[
  {
    "id": "8483",
    "description": "exclamation_mark",
    "pos": "WHITE",
    "explanation": "(punctuation mark - 1. used as punctuation in symbol sentences;  2. used to indicate that the symbol statement that follows it is in the imperative form)   - Character",
    "isCharacter": true
  },
  {
    "id": "8484",
    "description": "percent,percentage,%",
    "pos": "YELLOW",
    "explanation": "(international mathematical symbol)   - Character",
    "isCharacter": true
  },
  {
    "id": "8485",
    "description": "question_mark",
    "pos": "YELLOW",
    "explanation": "(punctuation mark - used as punctuation in symbol sentences)   - Character",
    "isCharacter": true
  },
  {
    "id": "8486",
    "description": "period,point,full_stop,decimal_point",
    "pos": "WHITE",
    "explanation": "(punctuation mark - 1. used as punctuation in symbol sentences; 2. international mathematical symbol)   - Character",
    "isCharacter": true
  },
  {
    "id": "8487",
    "description": "comma",
    "pos": "WHITE",
    "explanation": "(punctuation mark - 1. used as punctuation in symbol sentences; 2. used to divide component parts of compound and combined symbols, in order to clarify meaning)   - Character",
    "isCharacter": true
  },
  {
    "id": "8488",
    "description": "colon",
    "pos": "WHITE",
    "explanation": "(punctuation mark)   - Character",
    "isCharacter": true
  },
  {
    "id": "8489",
    "description": "apostrophe",
    "pos": "WHITE",
    "explanation": "(punctuation mark)   - Character",
    "isCharacter": true
  },
  {
    "id": "8490",
    "description": "degree",
    "pos": "WHITE",
    "explanation": "(punctuation mark)   - Character",
    "isCharacter": true
  },
  {
    "id": "8496",
    "description": "zero_(digit),0",
    "pos": "WHITE",
    "explanation": "(Arabic numeral 0)   - Character",
    "isCharacter": true
  },
  {
    "id": "8497",
    "description": "one_(digit),1,modifier_(first_person)",
    "pos": "WHITE",
    "explanation": "(Arabic numeral 1)   - Character",
    "isCharacter": true
  },
  {
    "id": "8498",
    "description": "two_(digit),2,modifier_(second_person)",
    "pos": "WHITE",
    "explanation": "(Arabic numeral 2)   - Character",
    "isCharacter": true
  },
  {
    "id": "8499",
    "description": "three_(digit),3,modifier_(third_person)",
    "pos": "WHITE",
    "explanation": "(Arabic numeral 3)   - Character",
    "isCharacter": true
  },
  {
    "id": "8500",
    "description": "four_(digit),4",
    "pos": "WHITE",
    "explanation": "(Arabic numeral 4)   - Character",
    "isCharacter": true
  },
  {
    "id": "8501",
    "description": "five_(digit),5",
    "pos": "WHITE",
    "explanation": "(Arabic numeral 5)   - Character",
    "isCharacter": true
  },
  {
    "id": "8502",
    "description": "six_(digit),6",
    "pos": "WHITE",
    "explanation": "(Arabic numeral 6)   - Character",
    "isCharacter": true
  },
  {
    "id": "8503",
    "description": "seven_(digit),7",
    "pos": "WHITE",
    "explanation": "(Arabic numeral 7)   - Character",
    "isCharacter": true
  },
  {
    "id": "8504",
    "description": "eight_(digit),8",
    "pos": "WHITE",
    "explanation": "(Arabic numeral 8)   - Character",
    "isCharacter": true
  },
  {
    "id": "8505",
    "description": "nine_(digit),9",
    "pos": "WHITE",
    "explanation": "(Arabic numeral 9)   - Character",
    "isCharacter": true
  },
  {
    "id": "8510",
    "description": "zero_(index_number)",
    "pos": "WHITE",
    "explanation": "(Arabic numeral 0 - small)   - Character",
    "isCharacter": true
  },
  {
    "id": "8511",
    "description": "one_(index_number)",
    "pos": "WHITE",
    "explanation": "(Arabic numeral 1 - small)   - Character",
    "isCharacter": true
  },
  {
    "id": "8512",
    "description": "two_(index_number)",
    "pos": "WHITE",
    "explanation": "(Arabic numeral 2 - small)   - Character",
    "isCharacter": true
  },
  {
    "id": "8513",
    "description": "three_(index_number)",
    "pos": "WHITE",
    "explanation": "(Arabic numeral 3 - small)   - Character",
    "isCharacter": true
  },
  {
    "id": "8514",
    "description": "four_(index_number)",
    "pos": "WHITE",
    "explanation": "(Arabic numeral 4 - small)   - Character",
    "isCharacter": true
  },
  {
    "id": "8515",
    "description": "five_(index_number)",
    "pos": "WHITE",
    "explanation": "(Arabic numeral 5 - small)   - Character",
    "isCharacter": true
  },
  {
    "id": "8516",
    "description": "six_(index_number)",
    "pos": "WHITE",
    "explanation": "(Arabic numeral 6 - small)   - Character",
    "isCharacter": true
  },
  {
    "id": "8517",
    "description": "seven_(index_number)",
    "pos": "WHITE",
    "explanation": "(Arabic numeral 7 - small)   - Character",
    "isCharacter": true
  },
  {
    "id": "8518",
    "description": "eight_(index_number)",
    "pos": "WHITE",
    "explanation": "(Arabic numeral 8 - small)   - Character",
    "isCharacter": true
  },
  {
    "id": "8519",
    "description": "nine_(index_number)",
    "pos": "WHITE",
    "explanation": "(Arabic numeral 9 - small)   - Character",
    "isCharacter": true
  },
  {
    "id": "8521",
    "description": "a_(lowercase)",
    "pos": "WHITE",
    "explanation": "(Latin English lowercase letter a)  - Character",
    "isCharacter": true
  },
  {
    "id": "8522",
    "description": "b_(lowercase)",
    "pos": "WHITE",
    "explanation": "(Latin English lowercase letter b)  - Character",
    "isCharacter": true
  },
  {
    "id": "8523",
    "description": "c_(lowercase)",
    "pos": "WHITE",
    "explanation": "(Latin English lowercase letter c)  - Character",
    "isCharacter": true
  },
  {
    "id": "8524",
    "description": "d_(lowercase)",
    "pos": "WHITE",
    "explanation": "(Latin English lowercase letter d)  - Character",
    "isCharacter": true
  },
  {
    "id": "8525",
    "description": "e_(lowercase)",
    "pos": "WHITE",
    "explanation": "(Latin English lowercase letter e)  - Character",
    "isCharacter": true
  },
  {
    "id": "8526",
    "description": "f_(lowercase)",
    "pos": "WHITE",
    "explanation": "(Latin English lowercase letter f)  - Character",
    "isCharacter": true
  },
  {
    "id": "8527",
    "description": "g_(lowercase)",
    "pos": "WHITE",
    "explanation": "(Latin English lowercase letter g)  - Character",
    "isCharacter": true
  },
  {
    "id": "8528",
    "description": "h_(lowercase)",
    "pos": "WHITE",
    "explanation": "(Latin English lowercase letter h)  - Character",
    "isCharacter": true
  },
  {
    "id": "8529",
    "description": "i_(lowercase)",
    "pos": "WHITE",
    "explanation": "(Latin English lowercase letter i)  - Character",
    "isCharacter": true
  },
  {
    "id": "8530",
    "description": "j_(lowercase)",
    "pos": "WHITE",
    "explanation": "(Latin English lowercase letter j)  - Character",
    "isCharacter": true
  },
  {
    "id": "8531",
    "description": "k_(lowercase)",
    "pos": "WHITE",
    "explanation": "(Latin English lowercase letter k)  - Character",
    "isCharacter": true
  },
  {
    "id": "8532",
    "description": "l_(lowercase)",
    "pos": "WHITE",
    "explanation": "(Latin English lowercase letter l)  - Character",
    "isCharacter": true
  },
  {
    "id": "8533",
    "description": "m_(lowercase)",
    "pos": "WHITE",
    "explanation": "(Latin English lowercase letter m)  - Character",
    "isCharacter": true
  },
  {
    "id": "8534",
    "description": "n_(lowercase)",
    "pos": "WHITE",
    "explanation": "(Latin English lowercase letter n)  - Character",
    "isCharacter": true
  },
  {
    "id": "8535",
    "description": "o_(lowercase)",
    "pos": "WHITE",
    "explanation": "(Latin English lowercase letter o)  - Character",
    "isCharacter": true
  },
  {
    "id": "8536",
    "description": "p_(lowercase)",
    "pos": "WHITE",
    "explanation": "(Latin English lowercase letter p)  - Character",
    "isCharacter": true
  },
  {
    "id": "8537",
    "description": "q_(lowercase)",
    "pos": "WHITE",
    "explanation": "(Latin English lowercase letter q)  - Character",
    "isCharacter": true
  },
  {
    "id": "8538",
    "description": "r_(lowercase)",
    "pos": "WHITE",
    "explanation": "(Latin English lowercase letter r)  - Character",
    "isCharacter": true
  },
  {
    "id": "8539",
    "description": "s_(lowercase)",
    "pos": "WHITE",
    "explanation": "(Latin English lowercase letter s)  - Character",
    "isCharacter": true
  },
  {
    "id": "8540",
    "description": "t_(lowercase)",
    "pos": "WHITE",
    "explanation": "(Latin English lowercase letter t)  - Character",
    "isCharacter": true
  },
  {
    "id": "8541",
    "description": "u_(lowercase)",
    "pos": "WHITE",
    "explanation": "(Latin English lowercase letter u)  - Character",
    "isCharacter": true
  },
  {
    "id": "8542",
    "description": "v_(lowercase)",
    "pos": "WHITE",
    "explanation": "(Latin English lowercase letter v)  - Character",
    "isCharacter": true
  },
  {
    "id": "8543",
    "description": "w_(lowercase)",
    "pos": "WHITE",
    "explanation": "(Latin English lowercase letter w)  - Character",
    "isCharacter": true
  },
  {
    "id": "8544",
    "description": "x_(lowercase)",
    "pos": "WHITE",
    "explanation": "(Latin English lowercase letter x)  - Character",
    "isCharacter": true
  },
  {
    "id": "8545",
    "description": "y_(lowercase)",
    "pos": "WHITE",
    "explanation": "(Latin English lowercase letter y)  - Character",
    "isCharacter": true
  },
  {
    "id": "8546",
    "description": "z_(lowercase)",
    "pos": "WHITE",
    "explanation": "(Latin English lowercase letter z)  - Character",
    "isCharacter": true
  },
  {
    "id": "8551",
    "description": "A_(uppercase)",
    "pos": "WHITE",
    "explanation": "(Latin English uppercase letter A)  - Character",
    "isCharacter": true
  },
  {
    "id": "8552",
    "description": "B_(uppercase)",
    "pos": "WHITE",
    "explanation": "(Latin English uppercase letter B)  - Character",
    "isCharacter": true
  },
  {
    "id": "8553",
    "description": "C_(uppercase)",
    "pos": "WHITE",
    "explanation": "(Latin English uppercase letter C)  - Character",
    "isCharacter": true
  },
  {
    "id": "8554",
    "description": "D_(uppercase)",
    "pos": "WHITE",
    "explanation": "(Latin English uppercase letter D)  - Character",
    "isCharacter": true
  },
  {
    "id": "8555",
    "description": "E_(uppercase)",
    "pos": "WHITE",
    "explanation": "(Latin English uppercase letter E)  - Character",
    "isCharacter": true
  },
  {
    "id": "8556",
    "description": "F_(uppercase)",
    "pos": "WHITE",
    "explanation": "(Latin English uppercase letter F)  - Character",
    "isCharacter": true
  },
  {
    "id": "8557",
    "description": "G_(uppercase)",
    "pos": "WHITE",
    "explanation": "(Latin English uppercase letter G)  - Character",
    "isCharacter": true
  },
  {
    "id": "8558",
    "description": "H_(uppercase)",
    "pos": "WHITE",
    "explanation": "(Latin English uppercase letter H)  - Character",
    "isCharacter": true
  },
  {
    "id": "8559",
    "description": "I_(uppercase)",
    "pos": "WHITE",
    "explanation": "(Latin English uppercase letter I)  - Character",
    "isCharacter": true
  },
  {
    "id": "8560",
    "description": "J_(uppercase)",
    "pos": "WHITE",
    "explanation": "(Latin English uppercase letter J)  - Character",
    "isCharacter": true
  },
  {
    "id": "8561",
    "description": "K_(uppercase)",
    "pos": "WHITE",
    "explanation": "(Latin English uppercase letter K)  - Character",
    "isCharacter": true
  },
  {
    "id": "8562",
    "description": "L_(uppercase)",
    "pos": "WHITE",
    "explanation": "(Latin English uppercase letter L)  - Character",
    "isCharacter": true
  },
  {
    "id": "8563",
    "description": "M_(uppercase)",
    "pos": "WHITE",
    "explanation": "(Latin English uppercase letter M)  - Character",
    "isCharacter": true
  },
  {
    "id": "8564",
    "description": "N_(uppercase)",
    "pos": "WHITE",
    "explanation": "(Latin English uppercase letter N)  - Character",
    "isCharacter": true
  },
  {
    "id": "8565",
    "description": "O_(uppercase)",
    "pos": "WHITE",
    "explanation": "(Latin English uppercase letter O)  - Character",
    "isCharacter": true
  },
  {
    "id": "8566",
    "description": "P_(uppercase)",
    "pos": "WHITE",
    "explanation": "(Latin English uppercase letter P)  - Character",
    "isCharacter": true
  },
  {
    "id": "8567",
    "description": "Q_(uppercase)",
    "pos": "WHITE",
    "explanation": "(Latin English uppercase letter Q)  - Character",
    "isCharacter": true
  },
  {
    "id": "8568",
    "description": "R_(uppercase)",
    "pos": "WHITE",
    "explanation": "(Latin English uppercase letter R)  - Character",
    "isCharacter": true
  },
  {
    "id": "8569",
    "description": "S_(uppercase)",
    "pos": "WHITE",
    "explanation": "(Latin English uppercase letter S)  - Character",
    "isCharacter": true
  },
  {
    "id": "8570",
    "description": "T_(uppercase)",
    "pos": "WHITE",
    "explanation": "(Latin English uppercase letter T)  - Character",
    "isCharacter": true
  },
  {
    "id": "8571",
    "description": "U_(uppercase)",
    "pos": "WHITE",
    "explanation": "(Latin English uppercase letter U)  - Character",
    "isCharacter": true
  },
  {
    "id": "8572",
    "description": "V_(uppercase)",
    "pos": "WHITE",
    "explanation": "(Latin English uppercase letter V)  - Character",
    "isCharacter": true
  },
  {
    "id": "8573",
    "description": "W_(uppercase)",
    "pos": "WHITE",
    "explanation": "(Latin English uppercase letter W)  - Character",
    "isCharacter": true
  },
  {
    "id": "8574",
    "description": "X_(uppercase)",
    "pos": "WHITE",
    "explanation": "(Latin English uppercase letter X)  - Character",
    "isCharacter": true
  },
  {
    "id": "8575",
    "description": "Y_(uppercase)",
    "pos": "WHITE",
    "explanation": "(Latin English uppercase letter Y)  - Character",
    "isCharacter": true
  },
  {
    "id": "8576",
    "description": "Z_(uppercase)",
    "pos": "WHITE",
    "explanation": "(Latin English uppercase letter Z)  - Character",
    "isCharacter": true
  },
  {
    "id": "8993",
    "description": "indicator_(action)",
    "pos": "GRAY",
    "explanation": "(action [quarter-sized]: placed above a symbol to create (1) the infinitive form of a verb, and (2) the present tense of a verb)  - Character (indicator)",
    "isCharacter": true
  },
  {
    "id": "8994",
    "description": "indicator_(active)",
    "pos": "GRAY",
    "explanation": "(action indicator [modification]: turned on its side and pointing forward: placed above a symbol to emphasize that something is acting on something else. The symbol is logically related to about.) - Character (indicator - modified)",
    "isCharacter": true
  },
  {
    "id": "8995",
    "description": "indicator_(conditional)",
    "pos": "GRAY",
    "explanation": "(question mark [quarter-sized]: placed above a symbol to indicate the equivalent of the English present conditional form)  - Character (indicator)",
    "isCharacter": true
  },
  {
    "id": "8996",
    "description": "indicator_(description_after_fact)",
    "pos": "GRAY",
    "explanation": "(description indicator + dot: placed above a symbol to indicate meanings equivalent to an English past participle, usually with an -ed or -en ending)  - Character (superimposed - indicator)",
    "isCharacter": true
  },
  {
    "id": "8997",
    "description": "indicator_(description_before_fact)",
    "pos": "GRAY",
    "explanation": "(dot + description indicator: the dot comes before the indicator: placed above a symbol to produce meanings equivalent to English words ending in -able)  - Character (superimposed - indicator)",
    "isCharacter": true
  },
  {
    "id": "8998",
    "description": "indicator_(description)",
    "pos": "GRAY",
    "explanation": "(evaluation [quarter-sized]: placed above a symbol to show that it is describing or evaluating something. This indicator produces meanings equivalent to English adjectives and adverbs.)  - Character (indicator)",
    "isCharacter": true
  },
  {
    "id": "8999",
    "description": "indicator_(future_action)",
    "pos": "GRAY",
    "explanation": "(future [quarter-sized]: placed above a symbol to indicate future action)  - Character (indicator)",
    "isCharacter": true
  },
  {
    "id": "9000",
    "description": "indicator_(future_conditional)",
    "pos": "GRAY",
    "explanation": "(conditional indicator + future action indicator: placed above a symbol to indicate the future conditional form)  - Character (superimposed - indicator)",
    "isCharacter": true
  },
  {
    "id": "9001",
    "description": "indicator_(future_passive)",
    "pos": "GRAY",
    "explanation": "(passive indicator + future action indicator)  - Character (superimposed - indicator)",
    "isCharacter": true
  },
  {
    "id": "9002",
    "description": "indicator_(future_passive_conditional)",
    "pos": "GRAY",
    "explanation": "(passive indicator + future conditional indicator)  - Character (superimposed - indicator)",
    "isCharacter": true
  },
  {
    "id": "9003",
    "description": "indicator_(passive)",
    "pos": "GRAY",
    "explanation": "(action indicator [modification]: turned on its side and pointing backward: placed above a symbol to emphasize that something is being acted upon. The symbol is logically related to by.) - Character (indicator - modified)",
    "isCharacter": true
  },
  {
    "id": "9004",
    "description": "indicator_(past_action)",
    "pos": "GRAY",
    "explanation": "(past [quarter-sized]: placed above a symbol to indicate past action)  - Character (indicator)",
    "isCharacter": true
  },
  {
    "id": "9005",
    "description": "indicator_(past_conditional)",
    "pos": "GRAY",
    "explanation": "(conditional indicator + past action indicator: placed above a symbol to indicate the past conditional form)  - Character (superimposed - indicator)",
    "isCharacter": true
  },
  {
    "id": "9006",
    "description": "indicator_(past_passive_conditional)",
    "pos": "GRAY",
    "explanation": "(passive indicator + past conditional indicator)  - Character (superimposed - indicator)",
    "isCharacter": true
  },
  {
    "id": "9007",
    "description": "indicator_(past_passive)",
    "pos": "GRAY",
    "explanation": "(passive indicator + past action indicator)  - Character (superimposed - indicator)",
    "isCharacter": true
  },
  {
    "id": "9008",
    "description": "indicator_(present_passive_conditional)",
    "pos": "GRAY",
    "explanation": "(passive indicator + conditional indicator)  - Character (superimposed - indicator)",
    "isCharacter": true
  },
  {
    "id": "9009",
    "description": "indicator_(thing)",
    "pos": "GRAY",
    "explanation": "(thing [quarter-sized]: placed above a symbol to represent a concrete object)  - Character (indicator)",
    "isCharacter": true
  },
  {
    "id": "9010",
    "description": "indicator_(thing,plural)",
    "pos": "GRAY",
    "explanation": "(thing indicator + plural indicator)  - Character (superimposed - indicator)",
    "isCharacter": true
  },
  {
    "id": "9011",
    "description": "indicator_(plural)",
    "pos": "GRAY",
    "explanation": "(multiplication [quarter-sized]: placed above a symbol to indicate a plural form)  - Character (indicator)",
    "isCharacter": true
  },
  {
    "id": "12321",
    "description": "a,an,any",
    "pos": "WHITE",
    "explanation": "(diagonal line suggests an index finger pointing at something unspecific. The diagonal line has the opposite orientation to the one used in the, this and that.)  - Character",
    "isCharacter": true
  },
  {
    "id": "12322",
    "description": "ability,capability,capacity,potential",
    "pos": "YELLOW",
    "explanation": "(dot + evaluation: evaluation beforehand of one’s potential to do something)  - Character (sequenced)",
    "isCharacter": true
  },
  {
    "id": "12323",
    "description": "abortion_(induced)",
    "pos": "YELLOW",
    "explanation": "(to cause + miscarriage,abortion_(spontaneous))",
    "isCharacter": false,
    "composition": [
      13134,
      "/",
      25547,
      "/",
      18269
    ]
  },
  {
    "id": "12324",
    "description": "about,concerning,regarding,in_relation_to,of,on",
    "pos": "WHITE",
    "explanation": "(relation [half-sized], pointing forward: used to mean on when the symbol refers to time, e.g. on Wednesday) - Character",
    "isCharacter": true
  },
  {
    "id": "12325",
    "description": "absorbent_material,sponge",
    "pos": "YELLOW",
    "explanation": "(material + into)",
    "isCharacter": false,
    "composition": [
      15431,
      "/",
      14952
    ]
  },
  {
    "id": "12326",
    "description": "celibacy,chastity,abstinence",
    "pos": "YELLOW",
    "explanation": "(to decide + without + sexual intercourse)",
    "isCharacter": false,
    "composition": [
      13649,
      "/",
      15474,
      "/",
      13380,
      "/",
      14431
    ]
  },
  {
    "id": "12327",
    "description": "abuse,assault,violence",
    "pos": "YELLOW",
    "explanation": "(force + intensity)",
    "isCharacter": false,
    "composition": [
      22914,
      "/",
      14947
    ]
  },
  {
    "id": "12328",
    "description": "accessory",
    "pos": "YELLOW",
    "explanation": "(thing + plus + clothing: something added to one's clothing)",
    "isCharacter": false,
    "composition": [
      17717,
      "/",
      12374,
      "/",
      13366
    ]
  },
  {
    "id": "12329",
    "description": "accident,chance_event",
    "pos": "YELLOW",
    "explanation": "(event + without + to expect: unexpected event)",
    "isCharacter": false,
    "composition": [
      14114,
      "/",
      15474,
      "/",
      14128
    ]
  },
  {
    "id": "12330",
    "description": "account",
    "pos": "YELLOW",
    "explanation": "(paper [modification] + container: written (financial) record of something held) - Character (superimposed - modified)",
    "isCharacter": true
  },
  {
    "id": "12331",
    "description": "ache",
    "pos": "YELLOW",
    "explanation": "(pain + to continue: pain that goes on and on)",
    "isCharacter": false,
    "composition": [
      14164,
      "/",
      "RK:-2",
      "/",
      16164,
      "/",
      24881
    ]
  },
  {
    "id": "12332",
    "description": "acne",
    "pos": "YELLOW",
    "explanation": "(many + pimple)",
    "isCharacter": false,
    "composition": [
      14647,
      "/",
      16180
    ]
  },
  {
    "id": "12333",
    "description": "across",
    "pos": "WHITE",
    "explanation": "(a vertical line with two horizontal lines [half sized] across it: CKB says this is a small road crossing a main road) - Character",
    "isCharacter": true
  },
  {
    "id": "12334",
    "description": "action,act,deed",
    "pos": "YELLOW",
    "explanation": "(symbol suggests the shape of a volcano cone, which CKB says represents \"one of the primeval actions of our earth\". The Action [full-sized], is used primarily as the source of activity - action [half-sized]) - Character",
    "isCharacter": true
  },
  {
    "id": "12335",
    "description": "activity,male_gender_(in_combinations)",
    "pos": "YELLOW",
    "explanation": "(action [half-sized]) (Also used as part of other characters to indicate male gender) - Character",
    "isCharacter": true
  },
  {
    "id": "12336",
    "description": "active,actively",
    "pos": "GREEN",
    "explanation": "(activity + description indicator)",
    "isCharacter": false,
    "composition": [
      12335,
      ";",
      8998
    ]
  },
  {
    "id": "12337",
    "description": "Adar",
    "pos": "YELLOW",
    "explanation": "(month + megillah: month of Purim (Hebrew))",
    "isCharacter": false,
    "composition": [
      15649,
      "/",
      15451
    ]
  },
  {
    "id": "12338",
    "description": "add,gain-(to)",
    "pos": "RED",
    "explanation": "(addition + action indicator)",
    "isCharacter": false,
    "composition": [
      12339,
      ";",
      8993
    ]
  },
  {
    "id": "12339",
    "description": "addition,gain",
    "pos": "YELLOW",
    "explanation": "(based upon the international mathematical symbol) - Character",
    "isCharacter": true
  },
  {
    "id": "12340",
    "description": "adolescence",
    "pos": "YELLOW",
    "explanation": "(limited time + adolescent)",
    "isCharacter": false,
    "composition": [
      15212,
      "/",
      17516
    ]
  },
  {
    "id": "12341",
    "description": "adult,grownup",
    "pos": "BLUE",
    "explanation": "(flower + big: CKB suggests that an adult is a person reaching \"full flower\") - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "12342",
    "description": "adult,mature",
    "pos": "GREEN",
    "explanation": "(adult + description indicator)",
    "isCharacter": false,
    "composition": [
      12341,
      ";",
      8998
    ]
  },
  {
    "id": "12343",
    "description": "advance,go-(to)",
    "pos": "RED",
    "explanation": "(forward + action indicator)  See also: go,depart,leave-(to) 14449, and walk,go-(to) 18031",
    "isCharacter": false,
    "composition": [
      14390,
      ";",
      8993
    ]
  },
  {
    "id": "12344",
    "description": "advertisement",
    "pos": "YELLOW",
    "explanation": "(page + attention: paper that attracts one's attention)",
    "isCharacter": false,
    "composition": [
      15962,
      "/",
      14133,
      "/",
      14947,
      "/",
      14947
    ]
  },
  {
    "id": "12345",
    "description": "advice,counsel,recommendation",
    "pos": "YELLOW",
    "explanation": "(suggestion + to help)",
    "isCharacter": false,
    "composition": [
      15925,
      "/",
      16437,
      "/",
      "RK:-2",
      "/",
      14704
    ]
  },
  {
    "id": "12346",
    "description": "advise,counsel,recommend-(to)",
    "pos": "RED",
    "explanation": "(advice + action indicator)",
    "isCharacter": false,
    "composition": [
      15925,
      ";",
      8993,
      "/",
      16437,
      "/",
      "RK:-2",
      "/",
      14704
    ]
  },
  {
    "id": "12347",
    "description": "afraid,frightened,scared",
    "pos": "GREEN",
    "explanation": "(fear,fright,concern + description indicator: sad about the future because of its uncertainties)",
    "isCharacter": false,
    "composition": [
      14164,
      ";",
      8998,
      "/",
      13869,
      "/",
      25568
    ]
  },
  {
    "id": "12348",
    "description": "after,behind",
    "pos": "WHITE",
    "explanation": "(reference line + dot: dot comes after the reference line. This symbol refers to both time and space.) - Character (sequenced)",
    "isCharacter": true
  },
  {
    "id": "12349",
    "description": "afternoon",
    "pos": "YELLOW",
    "explanation": "(day + after + 12: the part of the day after noon)",
    "isCharacter": false,
    "composition": [
      13639,
      "/",
      12348,
      "/",
      8497,
      "/",
      "RK:-1",
      "/",
      8498
    ]
  },
  {
    "id": "12350",
    "description": "again",
    "pos": "WHITE",
    "explanation": "(dot is repeated: it appears once and then again)  - Character (sequenced)",
    "isCharacter": true
  },
  {
    "id": "12351",
    "description": "against,opposed_to",
    "pos": "WHITE",
    "explanation": "(opposition [half-sized]) - Character",
    "isCharacter": true
  },
  {
    "id": "12352",
    "description": "ago,then_(past)",
    "pos": "WHITE",
    "explanation": "(past [half-sized]) - Character",
    "isCharacter": true
  },
  {
    "id": "12353",
    "description": "agree-(to)",
    "pos": "RED",
    "explanation": "(agreement + action indicator)",
    "isCharacter": false,
    "composition": [
      12354,
      ";",
      8993
    ]
  },
  {
    "id": "12354",
    "description": "agreement",
    "pos": "YELLOW",
    "explanation": "(two parallel arrows: to be in harmony) - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "12355",
    "description": "aid,device,support",
    "pos": "YELLOW",
    "explanation": "(help + thing indicator: concrete thing that aids or supports a person. The symbol is the concrete form of help.)  - (character with thing indicator)",
    "isCharacter": "false",
    "composition": [
      14704,
      ";",
      9009
    ]
  },
  {
    "id": "12356",
    "description": "air,atmosphere",
    "pos": "YELLOW",
    "explanation": "(sky + nose: one breathes air from the sky) - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "12357",
    "description": "airplane,aeroplane,plane",
    "pos": "YELLOW",
    "explanation": "(wings + wheel) - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "12358",
    "description": "airport",
    "pos": "YELLOW",
    "explanation": "(building + airplane)",
    "isCharacter": false,
    "composition": [
      14905,
      "/",
      12357
    ]
  },
  {
    "id": "12359",
    "description": "alcoholic_drink,alcoholic_beverage,liquor",
    "pos": "YELLOW",
    "explanation": "(pictograph: symbol suggests a wine glass) - Character",
    "isCharacter": true
  },
  {
    "id": "12360",
    "description": "all,every,everything,total,whole",
    "pos": "WHITE",
    "explanation": "(multitude + enclosure: symbol reminds us that “all” can only refer to some restricted multitude) - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "12361",
    "description": "all_gone",
    "pos": "WHITE",
    "explanation": "(all + to take away: all taken away)",
    "isCharacter": false,
    "composition": [
      12360,
      "/",
      17449
    ]
  },
  {
    "id": "12362",
    "description": "alligator,crocodile",
    "pos": "YELLOW",
    "explanation": "(animal_(water) + snake + teeth: combination of water animal and reptile + teeth)",
    "isCharacter": false,
    "composition": [
      12389,
      "/",
      17189,
      "/",
      17517
    ]
  },
  {
    "id": "12363",
    "description": "alone,just,only,solitary",
    "pos": "GREEN",
    "explanation": "(to be + 1 + description indicator: to be only one)",
    "isCharacter": false,
    "composition": [
      24443,
      ";",
      8998,
      "/",
      8497
    ]
  },
  {
    "id": "12364",
    "description": "along_with",
    "pos": "WHITE",
    "explanation": "(and + and: in addition to)",
    "isCharacter": false,
    "composition": [
      12374,
      "/",
      12374
    ]
  },
  {
    "id": "12365",
    "description": "alpana,rangoli_(decoration)",
    "pos": "YELLOW",
    "explanation": "(design + floor: decoration used on special occasions) (India)",
    "isCharacter": false,
    "composition": [
      16194,
      "/",
      14202
    ]
  },
  {
    "id": "12366",
    "description": "alphabet,letters_(lowercase)_(Latin_alphabet)",
    "pos": "YELLOW",
    "explanation": "(a_(lowercase) + b_(lowercase) + c_(lowercase): first three letters of the English alphabet, representing the entire alphabet) - Character (superimposed)",
    "isCharacter": "true",
    "composition": [
      "Xa",
      "/",
      "Xb",
      "/",
      "Xc"
    ]
  },
  {
    "id": "12367",
    "description": "although",
    "pos": "WHITE",
    "explanation": "(three arrowheads: one arrowhead moves forward between and beyond two opposing arrowheads)  - Character",
    "isCharacter": true
  },
  {
    "id": "12368",
    "description": "always,ever,forever",
    "pos": "GREEN",
    "explanation": "(time + all + description indicator: all the time)",
    "isCharacter": false,
    "composition": [
      17732,
      ";",
      8998,
      "/",
      12360
    ]
  },
  {
    "id": "12369",
    "description": "ambulance",
    "pos": "YELLOW",
    "explanation": "(car + medical)",
    "isCharacter": false,
    "composition": [
      13121,
      "/",
      24920
    ]
  },
  {
    "id": "12370",
    "description": "amenorrhea",
    "pos": "YELLOW",
    "explanation": "(without + menstruation)",
    "isCharacter": false,
    "composition": [
      15474,
      "/",
      18209,
      "/",
      17994,
      "/",
      15649
    ]
  },
  {
    "id": "12371",
    "description": "amphibian",
    "pos": "YELLOW",
    "explanation": "(animal + water + earth: animal adapted to life in water and on land)",
    "isCharacter": false,
    "composition": [
      12378,
      "/",
      25633
    ]
  },
  {
    "id": "12372",
    "description": "amuse,entertain,please-(to)",
    "pos": "RED",
    "explanation": "(to give + happiness + action indicator: to give happiness or pleasure)",
    "isCharacter": false,
    "composition": [
      24903,
      ";",
      8993,
      "/",
      14164,
      "/",
      17983
    ]
  },
  {
    "id": "12373",
    "description": "anal_intercourse",
    "pos": "YELLOW",
    "explanation": "(to combine + erect penis + anus [contraction])",
    "isCharacter": false,
    "composition": [
      13380,
      "/",
      13944,
      "/",
      13097
    ]
  },
  {
    "id": "12374",
    "description": "and,also,plus,too",
    "pos": "WHITE",
    "explanation": "(addition [half-sized] with the crossbar located in the midline)  - Character",
    "isCharacter": true
  },
  {
    "id": "12375",
    "description": "angel_(OLD)",
    "pos": "BLUE",
    "explanation": "(angel_(1) + God: winged person sent by God)  SUPERSEDED SYNONYM  See angel_(1) 20571 and angel_(2) 20570",
    "isCharacter": false,
    "composition": [
      20571,
      "/",
      "RK:-2",
      "/",
      14451
    ]
  },
  {
    "id": "12376",
    "description": "angle",
    "pos": "YELLOW",
    "explanation": "(international mathematical symbol)  - Character",
    "isCharacter": true
  },
  {
    "id": "12377",
    "description": "angry,angrily,mad",
    "pos": "GREEN",
    "explanation": "(much + feeling + opposition + description indicator: having strong feelings against someone or something)",
    "isCharacter": false,
    "composition": [
      14647,
      "/",
      14164,
      ";",
      8998,
      "/",
      15928
    ]
  },
  {
    "id": "12378",
    "description": "animal,beast",
    "pos": "YELLOW",
    "explanation": "(pictograph: symbol suggests a creature with four legs)  - Character",
    "isCharacter": true
  },
  {
    "id": "12379",
    "description": "animal_(bovine,ovine),bovid,bovine",
    "pos": "YELLOW",
    "explanation": "(animal + horn(s) pictograph)  - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "12380",
    "description": "dog,canine_(animal),canid",
    "pos": "YELLOW",
    "explanation": "(animal + curved line (representing a tail): the waving tail being characteristic of a dog)  - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "12381",
    "description": "deer,cervine_(animal),cervid",
    "pos": "YELLOW",
    "explanation": "(animal + horn(s) pictograph: horns are raised to signify that males shed their horns annually)  - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "12382",
    "description": "domestic_animal",
    "pos": "YELLOW",
    "explanation": "(animal + protection: animal that is cared for in a domestic setting)",
    "isCharacter": false,
    "composition": [
      12378,
      "/",
      16420
    ]
  },
  {
    "id": "12383",
    "description": "cat,feline_(animal),felid",
    "pos": "YELLOW",
    "explanation": "(animal + small curved lines (representing claws): the claws being characteristic of cats)  - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "12384",
    "description": "marsupial_(animal),pouched_mammal",
    "pos": "YELLOW",
    "explanation": "(animal + pouch)",
    "isCharacter": false,
    "composition": [
      12378,
      "/",
      13403
    ]
  },
  {
    "id": "12385",
    "description": "animal_(protected)",
    "pos": "YELLOW",
    "explanation": "(animal + protection + description after the fact indicator)",
    "isCharacter": false,
    "composition": [
      12378,
      "/",
      16420,
      ";",
      8996
    ]
  },
  {
    "id": "12386",
    "description": "rat,rodent,gnawer,gnawing_animal",
    "pos": "YELLOW",
    "explanation": "(animal + teeth: animal that gnaws to file its continuously growing teeth)",
    "isCharacter": false,
    "composition": [
      12378,
      "/",
      17517
    ]
  },
  {
    "id": "12387",
    "description": "animal_skin,hide,pelt",
    "pos": "YELLOW",
    "explanation": "(protection + animal: protective covering of an animal)",
    "isCharacter": false,
    "composition": [
      16420,
      "/",
      12378
    ]
  },
  {
    "id": "12388",
    "description": "lizard,reptile_(snake_like_animal)",
    "pos": "YELLOW",
    "explanation": "(animal + snake: snake-like animal)",
    "isCharacter": false,
    "composition": [
      12378,
      "/",
      17189
    ]
  },
  {
    "id": "12389",
    "description": "animal_(water)",
    "pos": "YELLOW",
    "explanation": "(animal + water [modification, under earthline])  - Character (superimposed - modified)",
    "isCharacter": true
  },
  {
    "id": "12390",
    "description": "animal_(wild)",
    "pos": "YELLOW",
    "explanation": "(animal + open: untamed animal that lives in the open)",
    "isCharacter": false,
    "composition": [
      12378,
      "/",
      15923
    ]
  },
  {
    "id": "12391",
    "description": "ankle",
    "pos": "YELLOW",
    "explanation": "(kneeling person + pointer, to ankle joint)  - Character (superimposed - pointer)",
    "isCharacter": true
  },
  {
    "id": "12392",
    "description": "anniversary",
    "pos": "YELLOW",
    "explanation": "(year + again: occasion that comes again every year)",
    "isCharacter": false,
    "composition": [
      18289,
      "/",
      12350
    ]
  },
  {
    "id": "12393",
    "description": "answer,reply",
    "pos": "YELLOW",
    "explanation": "(question + enclosure (combination): an answer \"closes\" a question)  - Character (superimposed - combined)",
    "isCharacter": true
  },
  {
    "id": "12394",
    "description": "answer,reply-(to)",
    "pos": "RED",
    "explanation": "(answer + action indicator)",
    "isCharacter": false,
    "composition": [
      12393,
      ";",
      8993
    ]
  },
  {
    "id": "12395",
    "description": "ant",
    "pos": "YELLOW",
    "explanation": "(insect + work + intensity: industrious insect)",
    "isCharacter": false,
    "composition": [
      14943,
      "/",
      18273,
      "/",
      14947
    ]
  },
  {
    "id": "12396",
    "description": "anus",
    "pos": "YELLOW",
    "explanation": "(opening + buttocks)",
    "isCharacter": false,
    "composition": [
      15923,
      "/",
      13097
    ]
  },
  {
    "id": "12397",
    "description": "anxiety",
    "pos": "YELLOW",
    "explanation": "(upset + future_(uncertain): upset about an uncertain future)",
    "isCharacter": false,
    "composition": [
      14164,
      "/",
      20524,
      "/",
      25568
    ]
  },
  {
    "id": "12398",
    "description": "anxious,anxiously",
    "pos": "GREEN",
    "explanation": "(anxiety + description indicator)",
    "isCharacter": false,
    "composition": [
      14164,
      ";",
      8998,
      "/",
      20524,
      "/",
      25568
    ]
  },
  {
    "id": "12399",
    "description": "anyone,anybody,somebody,someone",
    "pos": "BLUE",
    "explanation": "(any + person)",
    "isCharacter": false,
    "composition": [
      12321,
      "/",
      16161
    ]
  },
  {
    "id": "12400",
    "description": "anything,something",
    "pos": "WHITE",
    "explanation": "(any + thing)",
    "isCharacter": false,
    "composition": [
      12321,
      "/",
      17717
    ]
  },
  {
    "id": "12401",
    "description": "anytime,sometime",
    "pos": "WHITE",
    "explanation": "(any + time)",
    "isCharacter": false,
    "composition": [
      12321,
      "/",
      17732
    ]
  },
  {
    "id": "12402",
    "description": "anywhere,anyplace,someplace,somewhere",
    "pos": "WHITE",
    "explanation": "(any + earth,ground,land: can be interpreted as a combination of any and place)  - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "12403",
    "description": "apartment,flat,unit",
    "pos": "YELLOW",
    "explanation": "(house + inside + house: dwelling inside a larger building)",
    "isCharacter": false,
    "composition": [
      14905,
      "/",
      14932,
      "/",
      14905
    ]
  },
  {
    "id": "12404",
    "description": "apologize,apologise,regret_(express)-(to)",
    "pos": "RED",
    "explanation": "(to speak + comma + to regret + action indicator)",
    "isCharacter": false,
    "composition": [
      15666,
      ";",
      8993,
      "/",
      8487,
      "/",
      14164,
      "/",
      13869,
      "/",
      12324,
      "/",
      15975
    ]
  },
  {
    "id": "12405",
    "description": "apple",
    "pos": "YELLOW",
    "explanation": "(pictograph of apple with stem) - Character",
    "isCharacter": true
  },
  {
    "id": "12406",
    "description": "appointment",
    "pos": "YELLOW",
    "explanation": "(time + to meet: time agreed upon for a meeting)",
    "isCharacter": false,
    "composition": [
      17732,
      "/",
      25583
    ]
  },
  {
    "id": "12407",
    "description": "approach",
    "pos": "YELLOW",
    "explanation": "(forward + reference line: advancing arrow approaches the line but does not reach it) - Character",
    "isCharacter": true
  },
  {
    "id": "12408",
    "description": "approve-(to)",
    "pos": "RED",
    "explanation": "(evaluation + correct + action indicator: to evaluate as correct or good in a rational sense)",
    "isCharacter": false,
    "composition": [
      13949,
      ";",
      8993,
      "/",
      25538,
      "/",
      14947
    ]
  },
  {
    "id": "12409",
    "description": "apricot",
    "pos": "YELLOW",
    "explanation": "(peach + small)",
    "isCharacter": false,
    "composition": [
      15983,
      "/",
      24917
    ]
  },
  {
    "id": "12410",
    "description": "April",
    "pos": "YELLOW",
    "explanation": "(month + 4: fourth month of the year)",
    "isCharacter": false,
    "composition": [
      15649,
      "/",
      8500
    ]
  },
  {
    "id": "12411",
    "description": "apron,coverall,smock,overall",
    "pos": "YELLOW",
    "explanation": "(protection + clothing: protective covering worn over other clothing)",
    "isCharacter": false,
    "composition": [
      16420,
      "/",
      13366
    ]
  },
  {
    "id": "12412",
    "description": "architect",
    "pos": "BLUE",
    "explanation": "(person + to plan + building: person who designs buildings)",
    "isCharacter": false,
    "composition": [
      16161,
      "/",
      16194,
      "/",
      14905
    ]
  },
  {
    "id": "12413",
    "description": "argue,dispute,quarrel-(to)",
    "pos": "RED",
    "explanation": "(argument + action indicator)",
    "isCharacter": false,
    "composition": [
      15666,
      ";",
      8993,
      "/",
      12610,
      "/",
      14947
    ]
  },
  {
    "id": "12414",
    "description": "argument,dispute,quarrel",
    "pos": "YELLOW",
    "explanation": "(discussion + intensity)",
    "isCharacter": false,
    "composition": [
      15666,
      "/",
      12610,
      "/",
      14947
    ]
  },
  {
    "id": "12577",
    "description": "arm",
    "pos": "YELLOW",
    "explanation": "(pictograph: symbol suggests an arm bent upward)  - Character",
    "isCharacter": true
  },
  {
    "id": "12578",
    "description": "armchair",
    "pos": "YELLOW",
    "explanation": "(pictograph: symbol suggests a chair with support added for the arm)  - Character",
    "isCharacter": true
  },
  {
    "id": "12579",
    "description": "military,armed_forces,armed_services",
    "pos": "YELLOW",
    "explanation": "(group + war: group trained for war)",
    "isCharacter": false,
    "composition": [
      14647,
      "/",
      16161,
      "/",
      18036
    ]
  },
  {
    "id": "12580",
    "description": "around",
    "pos": "WHITE",
    "explanation": "(curved line + dot: half circle is around the dot)  - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "12581",
    "description": "art",
    "pos": "YELLOW",
    "explanation": "(man-made + feeling: process of making or producing something that inspires emotion in the beholder)",
    "isCharacter": false,
    "composition": [
      23583,
      "/",
      "RK:-2",
      "/",
      14164
    ]
  },
  {
    "id": "12582",
    "description": "art_gallery,gallery",
    "pos": "YELLOW",
    "explanation": "(building + work of art + thing indicator: building where works of art are displayed)",
    "isCharacter": false,
    "composition": [
      14905,
      "/",
      23583,
      ";",
      9009,
      "/",
      "RK:-2",
      "/",
      14164
    ]
  },
  {
    "id": "12583",
    "description": "artificial_insemination",
    "pos": "YELLOW",
    "explanation": "(aid + medical + conception)",
    "isCharacter": false,
    "composition": [
      14704,
      "/",
      24920,
      "/",
      13395
    ]
  },
  {
    "id": "12584",
    "description": "artificial_respiration",
    "pos": "YELLOW",
    "explanation": "(to cause + to breathe)",
    "isCharacter": false,
    "composition": [
      13134,
      "/",
      "RK:-2",
      "/",
      15732,
      "/",
      15666
    ]
  },
  {
    "id": "12585",
    "description": "give_artificial_respiration,resuscitate,revive-(to)",
    "pos": "RED",
    "explanation": "(artificial respiration + action indicator)",
    "isCharacter": false,
    "composition": [
      13134,
      ";",
      8993,
      "/",
      "RK:-2",
      "/",
      15732,
      "/",
      15666
    ]
  },
  {
    "id": "12586",
    "description": "ashes",
    "pos": "YELLOW",
    "explanation": "(waste + fire)",
    "isCharacter": false,
    "composition": [
      18043,
      "/",
      14183
    ]
  },
  {
    "id": "12587",
    "description": "ashtray",
    "pos": "YELLOW",
    "explanation": "(container + ashes)",
    "isCharacter": false,
    "composition": [
      14421,
      "/",
      14183
    ]
  },
  {
    "id": "12588",
    "description": "ask,inquire,question-(to)",
    "pos": "RED",
    "explanation": "(question + action indicator)",
    "isCharacter": false,
    "composition": [
      16445,
      ";",
      8993
    ]
  },
  {
    "id": "12589",
    "description": "asleep",
    "pos": "GREEN",
    "explanation": "(sleep + description indicator)",
    "isCharacter": false,
    "composition": [
      17008,
      ";",
      8998
    ]
  },
  {
    "id": "12590",
    "description": "astronaut,cosmonaut",
    "pos": "BLUE",
    "explanation": "(person + rocket: person who goes up in a rocket)",
    "isCharacter": false,
    "composition": [
      16161,
      "/",
      25614,
      "/",
      17983
    ]
  },
  {
    "id": "12591",
    "description": "at",
    "pos": "WHITE",
    "explanation": "(position [half-sized])  - Character (sequenced)",
    "isCharacter": true
  },
  {
    "id": "12592",
    "description": "atom",
    "pos": "YELLOW",
    "explanation": "(pictograph of an atom with inner nucleus + pointer showing the movement of a circling electron)  - Character",
    "isCharacter": true
  },
  {
    "id": "12593",
    "description": "attack_(of_illness)",
    "pos": "YELLOW",
    "explanation": "(of illness) (illness + limited time)",
    "isCharacter": false,
    "composition": [
      16164,
      "/",
      15212
    ]
  },
  {
    "id": "12594",
    "description": "attention",
    "pos": "YELLOW",
    "explanation": "(eye + intensity + intensity: using the eyes intently)",
    "isCharacter": false,
    "composition": [
      14133,
      "/",
      14947,
      "/",
      14947
    ]
  },
  {
    "id": "12595",
    "description": "August",
    "pos": "YELLOW",
    "explanation": "(month + 8: eighth month of the year)",
    "isCharacter": false,
    "composition": [
      15649,
      "/",
      8504
    ]
  },
  {
    "id": "12596",
    "description": "aunt",
    "pos": "BLUE",
    "explanation": "(sister + parent: the sister of one's father or mother)  - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "12597",
    "description": "autumn,fall_(ckb)",
    "pos": "YELLOW",
    "explanation": "(sun + 3: third season) (CKB) SYMBOL SYNONYM",
    "isCharacter": false,
    "composition": [
      17462,
      "/",
      8499
    ]
  },
  {
    "id": "12598",
    "description": "autumn,fall",
    "pos": "YELLOW",
    "explanation": "(sun + 3 + leaf + down: third season when the leaves fall) (BCI) SYMBOL SYNONYM",
    "isCharacter": false,
    "composition": [
      17462,
      "/",
      8499,
      "/",
      15183,
      "/",
      13869
    ]
  },
  {
    "id": "12599",
    "description": "Av_(Hebrew_month)",
    "pos": "YELLOW",
    "explanation": "(month + church_ruin,temple_ruin,wreck,wreckage_(church,temple,mosque)_(1): month of the Tisha B'Av, the destruction of the Holy Temple (Hebrew))",
    "isCharacter": false,
    "composition": [
      15649,
      "/",
      25605,
      "/",
      14451
    ]
  },
  {
    "id": "12600",
    "description": "avocado",
    "pos": "YELLOW",
    "explanation": "(pear + pit)  - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "12601",
    "description": "awake",
    "pos": "GREEN",
    "explanation": "(wakefulness,alertness + description indicator: state one is in when one's eyes are open)",
    "isCharacter": false,
    "composition": [
      24949,
      ";",
      8998
    ]
  },
  {
    "id": "12602",
    "description": "away,at_a_distance,off_(OLD)",
    "pos": "WHITE",
    "explanation": "(reference line [half-sized] + arrowhead: full square between reference line and arrowhead emphasizes distance. This symbol is a simplified form of departure.)  - Character (sequenced)  SUPERSEDED SYNONYM  See away,at_a_distance,off 25522",
    "isCharacter": true
  },
  {
    "id": "12603",
    "description": "baby,infant",
    "pos": "BLUE",
    "explanation": "(child, turned on its side: child too young to stand)  - Character",
    "isCharacter": true
  },
  {
    "id": "12604",
    "description": "baby_boy",
    "pos": "BLUE",
    "explanation": "(boy, turned on his side: boy too young to stand)  - Character",
    "isCharacter": true
  },
  {
    "id": "12605",
    "description": "baby_carriage,buggy,pram,pushchair,stroller",
    "pos": "YELLOW",
    "explanation": "(wagon + baby: carriage for a baby)",
    "isCharacter": false,
    "composition": [
      18028,
      "/",
      12603
    ]
  },
  {
    "id": "12606",
    "description": "baby_clinic",
    "pos": "YELLOW",
    "explanation": "(clinic + baby)",
    "isCharacter": false,
    "composition": [
      16430,
      "/",
      24920,
      "/",
      12603
    ]
  },
  {
    "id": "12607",
    "description": "baby_girl",
    "pos": "BLUE",
    "explanation": "(girl, turned on her side: girl too young to stand)  - Character",
    "isCharacter": true
  },
  {
    "id": "12608",
    "description": "babysitter",
    "pos": "BLUE",
    "explanation": "(person + to protect + child: person who cares for a child)",
    "isCharacter": false,
    "composition": [
      16161,
      "/",
      16420,
      "/",
      13166
    ]
  },
  {
    "id": "12609",
    "description": "back_(body)",
    "pos": "YELLOW",
    "explanation": "(standing person + pointer, to back)  - Character (superimposed - pointer)",
    "isCharacter": true
  },
  {
    "id": "12610",
    "description": "back_and_forth,backward_and_forward,to_and_fro",
    "pos": "WHITE",
    "explanation": "(backward [modification, on earthline] + forward)  - Character  (superimposed - modified)",
    "isCharacter": true
  },
  {
    "id": "12611",
    "description": "backpack,rucksack",
    "pos": "YELLOW",
    "explanation": "(sack + back)",
    "isCharacter": false,
    "composition": [
      16701,
      "/",
      12609
    ]
  },
  {
    "id": "12612",
    "description": "back_up-(to)",
    "pos": "RED",
    "explanation": "(backward + action indicator)",
    "isCharacter": false,
    "composition": [
      12613,
      ";",
      8993
    ]
  },
  {
    "id": "12613",
    "description": "backward,back",
    "pos": "WHITE",
    "explanation": "(arrow, pointing backward)  - Character",
    "isCharacter": true
  },
  {
    "id": "12614",
    "description": "bacon",
    "pos": "YELLOW",
    "explanation": "(pork + linear thing + thing indicator: pork in strips)",
    "isCharacter": false,
    "composition": [
      14377,
      "/",
      16175,
      "/",
      15214,
      ";",
      9009
    ]
  },
  {
    "id": "12615",
    "description": "bad,wrong",
    "pos": "GREEN",
    "explanation": "(feeling + negative + description indicator: felt to be negative or bad in an emotional sense)  See also: immoral,bad,wrong,morally_wrong 14929 and incorrect,bad,inaccurate,wrong 14935",
    "isCharacter": false,
    "composition": [
      14164,
      ";",
      8998,
      "/",
      15474,
      "/",
      14947
    ]
  },
  {
    "id": "12616",
    "description": "badge,shield",
    "pos": "YELLOW",
    "explanation": "(pictograph: symbol is shaped like a badge)  - Character",
    "isCharacter": true
  },
  {
    "id": "12617",
    "description": "badminton_(activity)",
    "pos": "YELLOW",
    "explanation": "(activity + shuttlecock: game played with a feathered shuttlecock)",
    "isCharacter": false,
    "composition": [
      12335,
      "/",
      "RK:-2",
      "/",
      25608
    ]
  },
  {
    "id": "12618",
    "description": "baggage,bag,luggage,suitcase",
    "pos": "YELLOW",
    "explanation": "(pictograph)  - Character",
    "isCharacter": true
  },
  {
    "id": "12619",
    "description": "bake,cook,roast-(to)",
    "pos": "RED",
    "explanation": "(to cook + enclosure + action indicator: to cook inside an enclosure e.g. oven)",
    "isCharacter": false,
    "composition": [
      14183,
      ";",
      8993,
      "/",
      14377,
      "/",
      13934
    ]
  },
  {
    "id": "12620",
    "description": "balcony,porch,veranda",
    "pos": "YELLOW",
    "explanation": "(room + outside)",
    "isCharacter": false,
    "composition": [
      16687,
      "/",
      15942
    ]
  },
  {
    "id": "12621",
    "description": "ball",
    "pos": "YELLOW",
    "explanation": "(pictograph: symbol suggests a small stitched ball)  - Character",
    "isCharacter": true
  },
  {
    "id": "12622",
    "description": "balloon",
    "pos": "YELLOW",
    "explanation": "(pictograph)  - Character",
    "isCharacter": true
  },
  {
    "id": "12623",
    "description": "banana",
    "pos": "YELLOW",
    "explanation": "(pictograph with stem: crescent-shaped fruit  suggesting a banana)  - Character",
    "isCharacter": true
  },
  {
    "id": "12624",
    "description": "band,orchestra_(OLD)",
    "pos": "BLUE",
    "explanation": "(group + musical instrument)  SUPERSEDED SYNONYM  See band,orchestra 24873",
    "isCharacter": false,
    "composition": [
      14647,
      "/",
      16161,
      "/",
      17755,
      "/",
      15682
    ]
  },
  {
    "id": "12625",
    "description": "bandage,dressing",
    "pos": "YELLOW",
    "explanation": "(cloth + protection + medical)",
    "isCharacter": false,
    "composition": [
      13365,
      "/",
      16420,
      "/",
      24920
    ]
  },
  {
    "id": "12626",
    "description": "bank",
    "pos": "YELLOW",
    "explanation": "(building + money)",
    "isCharacter": false,
    "composition": [
      14905,
      "/",
      15484
    ]
  },
  {
    "id": "12627",
    "description": "bar,pub",
    "pos": "YELLOW",
    "explanation": "(public room + alcoholic drink)",
    "isCharacter": false,
    "composition": [
      16430,
      "/",
      12359
    ]
  },
  {
    "id": "12628",
    "description": "barber,hairdresser",
    "pos": "BLUE",
    "explanation": "(person + hair)",
    "isCharacter": false,
    "composition": [
      16161,
      "/",
      14661
    ]
  },
  {
    "id": "12629",
    "description": "barbershop,beauty_shop",
    "pos": "YELLOW",
    "explanation": "(public room + hair)",
    "isCharacter": false,
    "composition": [
      16430,
      "/",
      14661
    ]
  },
  {
    "id": "12630",
    "description": "barn,stable,shed",
    "pos": "YELLOW",
    "explanation": "(building + animal: building for animals)",
    "isCharacter": false,
    "composition": [
      14905,
      "/",
      12378
    ]
  },
  {
    "id": "12631",
    "description": "barrier_(contraceptive)",
    "pos": "YELLOW",
    "explanation": "(sperm + vertical line: combination of sperm and stop (to))  - Character (superimposed - combined)",
    "isCharacter": true
  },
  {
    "id": "12632",
    "description": "baseball_(activity)",
    "pos": "YELLOW",
    "explanation": "(activity + ball + corner: the corner character here represents the baseball diamond with the pointer to a base in a corner: ball game played on a diamond)",
    "isCharacter": false,
    "composition": [
      12335,
      "/",
      12621,
      "/",
      25537
    ]
  },
  {
    "id": "12633",
    "description": "base_camp",
    "pos": "YELLOW",
    "explanation": "(place + to gather)",
    "isCharacter": false,
    "composition": [
      16193,
      "/",
      14427
    ]
  },
  {
    "id": "12634",
    "description": "basketball_(activity)",
    "pos": "YELLOW",
    "explanation": "(activity + ball + container,basket_(high): game in which a ball is tossed into a high basket)",
    "isCharacter": false,
    "composition": [
      12335,
      "/",
      12621,
      "/",
      25535
    ]
  },
  {
    "id": "12635",
    "description": "bat_(sport)",
    "pos": "YELLOW",
    "explanation": "(linear thing + ball + thing indicator: linear thing used to hit a ball)",
    "isCharacter": false,
    "composition": [
      15214,
      ";",
      9009,
      "/",
      12621
    ]
  },
  {
    "id": "12636",
    "description": "bat_(animal)",
    "pos": "YELLOW",
    "explanation": "(animal + wing(s): flying animal)  - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "12637",
    "description": "bathroom,washroom",
    "pos": "YELLOW",
    "explanation": "(room + bath)",
    "isCharacter": false,
    "composition": [
      16687,
      "/",
      16992
    ]
  },
  {
    "id": "12638",
    "description": "battery",
    "pos": "YELLOW",
    "explanation": "(container + electricity: receptacle that stores and generates electricity)",
    "isCharacter": false,
    "composition": [
      13403,
      "/",
      13918
    ]
  },
  {
    "id": "12639",
    "description": "be,am,are,is,exist-(to)",
    "pos": "RED",
    "explanation": "(to live [half-sized] + action indicator: the \"little meaning\" of to live) (See Note p. II-30 in BRG)",
    "isCharacter": false,
    "composition": [
      24443,
      ";",
      8993
    ]
  },
  {
    "id": "12640",
    "description": "beach,bank,coast,shore",
    "pos": "YELLOW",
    "explanation": "(earth + water_(ground_level): place where land touches water)  - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "12641",
    "description": "beach_tennis_(activity)_(OLD)",
    "pos": "YELLOW",
    "explanation": "(tennis_(activity)_(OLD) + beach)  SUPERSEDED SYNONYM  See beach_tennis_(activity) 25981",
    "isCharacter": false,
    "composition": [
      12335,
      "/",
      "RK:-2",
      "/",
      25542,
      "/",
      12640
    ]
  },
  {
    "id": "12642",
    "description": "bean",
    "pos": "YELLOW",
    "explanation": "(pictograph: cross section of bean in a pod)  - Character",
    "isCharacter": true
  },
  {
    "id": "12643",
    "description": "bear",
    "pos": "YELLOW",
    "explanation": "(animal + bear's_head: animal + pictograph of a bear's head)",
    "isCharacter": false,
    "composition": [
      12378,
      "/",
      24801
    ]
  },
  {
    "id": "12644",
    "description": "beard",
    "pos": "YELLOW",
    "explanation": "(face_with_beard + pointer, to beard)  - Character (superimposed - pointer)",
    "isCharacter": true
  },
  {
    "id": "12645",
    "description": "beautiful,attractive,good-looking,handsome,pretty",
    "pos": "GREEN",
    "explanation": "(beauty + description indicator: pleasing to the eye)",
    "isCharacter": false,
    "composition": [
      14133,
      ";",
      8998,
      "/",
      14164,
      "/",
      17983
    ]
  },
  {
    "id": "12646",
    "description": "beaver",
    "pos": "YELLOW",
    "explanation": "(water_animal_(big_tail) + teeth: can be interpreted as a combination of water animal (with a big tail) and rodent, a large, flat-tailed rodent that makes its home in water)",
    "isCharacter": false,
    "composition": [
      25632,
      "/",
      17517
    ]
  },
  {
    "id": "12647",
    "description": "because",
    "pos": "WHITE",
    "explanation": "(cause [half-sized] + what,question_mark. CKB points out that this symbol is the reverse of why, and reminds us that the question mark remains to show that not all answers beginning with \"because\" are complete or satisfactory.)",
    "isCharacter": false,
    "composition": [
      17708,
      "/",
      18229
    ]
  },
  {
    "id": "12648",
    "description": "become-(to)",
    "pos": "RED",
    "explanation": "(to advance + to be + action indicator: to come to be)",
    "isCharacter": false,
    "composition": [
      14390,
      ";",
      8993,
      "/",
      24443
    ]
  },
  {
    "id": "12649",
    "description": "bed",
    "pos": "YELLOW",
    "explanation": "(pictograph: symbol suggests a bed with a pillow at the head)  - Character",
    "isCharacter": true
  },
  {
    "id": "12650",
    "description": "bedroom",
    "pos": "YELLOW",
    "explanation": "(room + to sleep)",
    "isCharacter": false,
    "composition": [
      16687,
      "/",
      17008
    ]
  },
  {
    "id": "12651",
    "description": "bee,bumblebee,hoverfly",
    "pos": "YELLOW",
    "explanation": "(fly + flower: flying insect that obtains nectar and pollen from flowers)",
    "isCharacter": false,
    "composition": [
      14371,
      "/",
      14205
    ]
  },
  {
    "id": "12652",
    "description": "beef",
    "pos": "YELLOW",
    "explanation": "(food + bovine: food that comes from a steer or cow. The symbol also can be explained as: combination of meat and bovine)",
    "isCharacter": false,
    "composition": [
      14377,
      "/",
      12379
    ]
  },
  {
    "id": "12653",
    "description": "beer",
    "pos": "YELLOW",
    "explanation": "(alcoholic drink + gas: alcoholic drink that has bubbles or foam)",
    "isCharacter": false,
    "composition": [
      12359,
      "/",
      14424
    ]
  },
  {
    "id": "12654",
    "description": "beet,beetroot",
    "pos": "YELLOW",
    "explanation": "(vegetable (large-leafed) + red: vegetable with a red, edible root)",
    "isCharacter": false,
    "composition": [
      17958,
      "/",
      13377,
      "/",
      15666
    ]
  },
  {
    "id": "12655",
    "description": "beetle",
    "pos": "YELLOW",
    "explanation": "(insect + pictograph of wing cases [hard shell])  - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "12656",
    "description": "before,in_front_of,prior_to",
    "pos": "WHITE",
    "explanation": "(dot + reference line: the dot comes before the reference line. This symbol refers to both time and space.)  - Character (sequenced)",
    "isCharacter": true
  },
  {
    "id": "12657",
    "description": "begin,start-(to)",
    "pos": "RED",
    "explanation": "(beginning + action indicator)",
    "isCharacter": false,
    "composition": [
      12658,
      ";",
      8993
    ]
  },
  {
    "id": "12658",
    "description": "beginning,start",
    "pos": "YELLOW",
    "explanation": "(reference line + forward: advancing arrow begins at the reference line)  - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "12659",
    "description": "behaviour",
    "pos": "YELLOW",
    "explanation": "(action + creature + thing indicator: action of a living being)",
    "isCharacter": false,
    "composition": [
      12335,
      "/",
      15206,
      ";",
      9009
    ]
  },
  {
    "id": "12660",
    "description": "belief",
    "pos": "YELLOW",
    "explanation": "(feeling + hypothesis,theory: where hypothesis,theory represents truth [contraction], what one feels to be true, without needing proof)",
    "isCharacter": false,
    "composition": [
      14164,
      "/",
      "RK:-2",
      "/",
      25574
    ]
  },
  {
    "id": "12661",
    "description": "believe-(to)",
    "pos": "RED",
    "explanation": "(belief + action indicator)",
    "isCharacter": false,
    "composition": [
      14164,
      ";",
      8993,
      "/",
      "RK:-2",
      "/",
      25574
    ]
  },
  {
    "id": "12662",
    "description": "bell",
    "pos": "YELLOW",
    "explanation": "(thing + 1 + musical note: thing with one musical note)",
    "isCharacter": false,
    "composition": [
      17717,
      "/",
      8497,
      "/",
      15682
    ]
  },
  {
    "id": "12663",
    "description": "belongs_to,of_(possessive)",
    "pos": "GRAY",
    "explanation": "(addition [half-sized, modification, with the crossbar located on the earthline])  - Character - (modified)",
    "isCharacter": true
  },
  {
    "id": "12664",
    "description": "belt,sash",
    "pos": "YELLOW",
    "explanation": "(linear thing + waist + thing indicator: linear thing worn at the waist)",
    "isCharacter": false,
    "composition": [
      15214,
      ";",
      9009,
      "/",
      18029
    ]
  },
  {
    "id": "12665",
    "description": "bench,pew",
    "pos": "YELLOW",
    "explanation": "(seat + long)",
    "isCharacter": false,
    "composition": [
      13148,
      "/",
      15193
    ]
  },
  {
    "id": "12666",
    "description": "berry",
    "pos": "YELLOW",
    "explanation": "(pictograph: symbol suggests a berry with a curved stem, in the position it would have if protruding from a bush)  - Character",
    "isCharacter": true
  },
  {
    "id": "12667",
    "description": "best",
    "pos": "GREEN",
    "explanation": "(most + good + description indicator)",
    "isCharacter": false,
    "composition": [
      24944,
      "/",
      14164,
      ";",
      8998,
      "/",
      12374,
      "/",
      14947
    ]
  },
  {
    "id": "12668",
    "description": "better",
    "pos": "GREEN",
    "explanation": "(more + good + description indicator)",
    "isCharacter": false,
    "composition": [
      24879,
      "/",
      14164,
      ";",
      8998,
      "/",
      12374,
      "/",
      14947
    ]
  },
  {
    "id": "12669",
    "description": "between",
    "pos": "WHITE",
    "explanation": "(two reference lines + dot, between them)  - Character (sequenced)",
    "isCharacter": true
  },
  {
    "id": "12670",
    "description": "beyond,past_(OLD)",
    "pos": "GREEN",
    "explanation": "(outside + limit(s),limitation_(OLD) + description indicator)  SUPERSEDED SYNONYM  See beyond,past 25983",
    "isCharacter": false,
    "composition": [
      15942,
      "/",
      15213,
      ";",
      8998
    ]
  },
  {
    "id": "12833",
    "description": "bib",
    "pos": "YELLOW",
    "explanation": "(protection + chest: protective covering for the upper body)",
    "isCharacter": false,
    "composition": [
      16420,
      "/",
      13161
    ]
  },
  {
    "id": "12834",
    "description": "bicycle",
    "pos": "YELLOW",
    "explanation": "(2 + wheel: two wheeled cycle)",
    "isCharacter": false,
    "composition": [
      8498,
      "/",
      18232
    ]
  },
  {
    "id": "12835",
    "description": "big,large",
    "pos": "GREEN",
    "explanation": "(bigness,largeness + description indicator: the vertical line extends to the biggest possible size within the symbol square)  See also: little,small 15221.",
    "isCharacter": false,
    "composition": [
      24875,
      ";",
      8998
    ]
  },
  {
    "id": "12836",
    "description": "bindi,tika_(decoration)",
    "pos": "YELLOW",
    "explanation": "(dot + colour + forehead: spot worn on the forehead of Hindu women) (India)",
    "isCharacter": false,
    "composition": [
      13867,
      "/",
      13377,
      "/",
      14384
    ]
  },
  {
    "id": "12837",
    "description": "bird",
    "pos": "YELLOW",
    "explanation": "(pictograph: symbol suggests the wings and feet of a bird)  - Character",
    "isCharacter": true
  },
  {
    "id": "12838",
    "description": "bird_(domestic)",
    "pos": "YELLOW",
    "explanation": "(bird + protection: bird that is cared for in a domestic setting)",
    "isCharacter": false,
    "composition": [
      12837,
      "/",
      16420
    ]
  },
  {
    "id": "12839",
    "description": "bird_(protected)",
    "pos": "YELLOW",
    "explanation": "(bird + protection + description after the fact indicator)",
    "isCharacter": false,
    "composition": [
      12837,
      "/",
      16420,
      ";",
      8996
    ]
  },
  {
    "id": "12840",
    "description": "duck,bird_(water),waterbird,waterfowl,seabird,seafowl",
    "pos": "YELLOW",
    "explanation": "(bird + water [modification, under earthline]: aquatic bird)  - Character (superimposed - modified)",
    "isCharacter": true
  },
  {
    "id": "12841",
    "description": "bird_(wild)",
    "pos": "YELLOW",
    "explanation": "(bird + open: untamed bird that lives in the open)",
    "isCharacter": false,
    "composition": [
      12837,
      "/",
      15923
    ]
  },
  {
    "id": "12842",
    "description": "birth,giving_birth,parturition,delivery",
    "pos": "YELLOW",
    "explanation": "(fetus [modification, opening in body] + down,downward [modification]: combination illustrating the birth of a baby)  - Character (superimposed - modified - combined)",
    "isCharacter": true
  },
  {
    "id": "12843",
    "description": "birth",
    "pos": "YELLOW",
    "explanation": "(protection,shelter + star: someone new under the roof. CKB points out that newspapers often use a star to denote a birth.)  - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "12844",
    "description": "birth_control",
    "pos": "YELLOW",
    "explanation": "(to stop + conception)",
    "isCharacter": false,
    "composition": [
      13935,
      "/",
      13395
    ]
  },
  {
    "id": "12845",
    "description": "birth_control_pill,pill",
    "pos": "YELLOW",
    "explanation": "(pill + without + egg: pill that prevents the release of an egg)",
    "isCharacter": false,
    "composition": [
      13685,
      "/",
      24920,
      "/",
      15474,
      "/",
      13912
    ]
  },
  {
    "id": "12846",
    "description": "birthday",
    "pos": "YELLOW",
    "explanation": "(day + birth: day of one's birth)",
    "isCharacter": false,
    "composition": [
      13639,
      "/",
      12843
    ]
  },
  {
    "id": "12847",
    "description": "bite-(to)",
    "pos": "RED",
    "explanation": "(teeth + action indicator)",
    "isCharacter": false,
    "composition": [
      17517,
      ";",
      8993
    ]
  },
  {
    "id": "12848",
    "description": "bitter",
    "pos": "GREEN",
    "explanation": "(taste + down + description indicator: unpleasant taste)",
    "isCharacter": false,
    "composition": [
      17506,
      ";",
      8998,
      "/",
      13869
    ]
  },
  {
    "id": "12849",
    "description": "black_(bci)",
    "pos": "WHITE",
    "explanation": "(colour + night) (BCI) SYMBOL SYNONYM",
    "isCharacter": false,
    "composition": [
      13377,
      "/",
      15719
    ]
  },
  {
    "id": "12850",
    "description": "black_(ckb)",
    "pos": "WHITE",
    "explanation": "(colour + zero: the absence of colour) (CKB) SYMBOL SYNONYM",
    "isCharacter": false,
    "composition": [
      13377,
      "/",
      8496
    ]
  },
  {
    "id": "12851",
    "description": "blackbird,crow,raven",
    "pos": "YELLOW",
    "explanation": "(bird + black)",
    "isCharacter": false,
    "composition": [
      12837,
      "/",
      13377,
      "/",
      15719
    ]
  },
  {
    "id": "12852",
    "description": "blackboard,chalkboard,whiteboard,writing_board",
    "pos": "YELLOW",
    "explanation": "(enclosure + to write: panel on which one writes, usually with chalk)",
    "isCharacter": false,
    "composition": [
      13934,
      "/",
      15991
    ]
  },
  {
    "id": "12853",
    "description": "bladder",
    "pos": "YELLOW",
    "explanation": "(container + urine)",
    "isCharacter": false,
    "composition": [
      13403,
      "/",
      18043,
      "/",
      14431
    ]
  },
  {
    "id": "12854",
    "description": "blanket,duvet,quilt",
    "pos": "YELLOW",
    "explanation": "(cloth + protection + bed)",
    "isCharacter": false,
    "composition": [
      13365,
      "/",
      16420,
      "/",
      12649
    ]
  },
  {
    "id": "12855",
    "description": "bleed-(to)",
    "pos": "RED",
    "explanation": "(blood + action indicator)",
    "isCharacter": false,
    "composition": [
      18209,
      ";",
      8993,
      "/",
      15206
    ]
  },
  {
    "id": "12856",
    "description": "blind",
    "pos": "GREEN",
    "explanation": "(blindness + description indicator: unable to see) See also: visually_impaired 26033",
    "isCharacter": false,
    "composition": [
      25526,
      ";",
      8998
    ]
  },
  {
    "id": "12857",
    "description": "blissymbol,Bliss-word",
    "pos": "YELLOW",
    "explanation": "(world + pen: writing for the  world)  - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "12858",
    "description": "blissymbol_part",
    "pos": "GRAY",
    "explanation": "(part + blissymbol: used with a compound symbol to produce a new meaning, represented by one of the component parts of the compound symbol)",
    "isCharacter": false,
    "composition": [
      15972,
      "/",
      12857
    ]
  },
  {
    "id": "12859",
    "description": "blissymbolics_resource_centre",
    "pos": "YELLOW",
    "explanation": "(resource_centre + blissymbol)",
    "isCharacter": false,
    "composition": [
      14905,
      "/",
      14382,
      "/",
      25555,
      "/",
      15162,
      "/",
      12857
    ]
  },
  {
    "id": "12860",
    "description": "block,brick",
    "pos": "YELLOW",
    "explanation": "(pictograph: symbol suggests a three-dimensional block. It is half the size of box.)  - Character",
    "isCharacter": true
  },
  {
    "id": "12861",
    "description": "blood",
    "pos": "YELLOW",
    "explanation": "(liquid + life: body fluid that sustains life)",
    "isCharacter": false,
    "composition": [
      18209,
      "/",
      15206
    ]
  },
  {
    "id": "12862",
    "description": "blow_(wind)-(to)",
    "pos": "RED",
    "explanation": "(wind + action indicator)",
    "isCharacter": false,
    "composition": [
      18255,
      ";",
      8993
    ]
  },
  {
    "id": "12863",
    "description": "blow_(mouth)-(to)",
    "pos": "RED",
    "explanation": "(mouth + wind + action indicator: to use the mouth to make a wind)",
    "isCharacter": false,
    "composition": [
      15666,
      ";",
      8993,
      "/",
      18255
    ]
  },
  {
    "id": "12864",
    "description": "blue_(bci)",
    "pos": "WHITE",
    "explanation": "(colour + sky) (BCI) SYMBOL SYNONYM",
    "isCharacter": false,
    "composition": [
      13377,
      "/",
      17006
    ]
  },
  {
    "id": "12865",
    "description": "blue_(ckb)",
    "pos": "WHITE",
    "explanation": "(colour + 5) (CKB) SYMBOL SYNONYM",
    "isCharacter": false,
    "composition": [
      13377,
      "/",
      8501
    ]
  },
  {
    "id": "12866",
    "description": "blueberry",
    "pos": "YELLOW",
    "explanation": "(berry + blue)",
    "isCharacter": false,
    "composition": [
      12666,
      "/",
      13377,
      "/",
      17006
    ]
  },
  {
    "id": "12867",
    "description": "bluebird",
    "pos": "YELLOW",
    "explanation": "(bird + blue)",
    "isCharacter": false,
    "composition": [
      12837,
      "/",
      13377,
      "/",
      17006
    ]
  },
  {
    "id": "12868",
    "description": "board_(material)",
    "pos": "YELLOW",
    "explanation": "(table + pointer, to underside: the top of a table is frequently made of boards)  - Character (superimposed - pointer)",
    "isCharacter": true
  },
  {
    "id": "12869",
    "description": "boat,ship",
    "pos": "YELLOW",
    "explanation": "(pictograph: symbol suggests a boat with a mast and also incorporates container.)  - Character",
    "isCharacter": true
  },
  {
    "id": "12870",
    "description": "body,trunk",
    "pos": "YELLOW",
    "explanation": "(pictograph: symbol suggests the trunk of the body, without head and limbs. The symbol may be used for body in a general sense.)  - Character",
    "isCharacter": true
  },
  {
    "id": "12871",
    "description": "boil_(food)-(to)",
    "pos": "RED",
    "explanation": "(fire + water + intensity + action indicator: to bring water or a liquid to a boil)",
    "isCharacter": false,
    "composition": [
      14183,
      ";",
      8993,
      "/",
      14377,
      "/",
      18209,
      "/",
      14947
    ]
  },
  {
    "id": "12872",
    "description": "boil_(liquid)-(to)",
    "pos": "RED",
    "explanation": "(fire + water + intensity + action indicator: to cook in boiling water)",
    "isCharacter": false,
    "composition": [
      14183,
      ";",
      8993,
      "/",
      18209,
      "/",
      14947
    ]
  },
  {
    "id": "12873",
    "description": "bone",
    "pos": "YELLOW",
    "explanation": "(pictograph: symbol suggests a bone shaft with ends)  - Character",
    "isCharacter": true
  },
  {
    "id": "12874",
    "description": "bonfire,barbeque,campfire",
    "pos": "YELLOW",
    "explanation": "(fire + happiness: a fire to enjoy)",
    "isCharacter": false,
    "composition": [
      14183,
      "/",
      14164,
      "/",
      17983
    ]
  },
  {
    "id": "12875",
    "description": "book",
    "pos": "YELLOW",
    "explanation": "(pictograph: symbol suggests an open book. It can also be explained as: two page symbols.)  - Character",
    "isCharacter": true
  },
  {
    "id": "12876",
    "description": "boot",
    "pos": "YELLOW",
    "explanation": "(protection + leg_and_foot)",
    "isCharacter": false,
    "composition": [
      16420,
      "/",
      25578
    ]
  },
  {
    "id": "12877",
    "description": "borrow-(to)",
    "pos": "RED",
    "explanation": "(to receive + limited time + action indicator)",
    "isCharacter": false,
    "composition": [
      24727,
      ";",
      8993,
      "/",
      15212
    ]
  },
  {
    "id": "12878",
    "description": "boss,supervisor_(OLD)",
    "pos": "BLUE",
    "explanation": "(person + to guide + work: person who directs work)  SUPERSEDED SYNONYM  See boss,supervisor 24849",
    "isCharacter": false,
    "composition": [
      16161,
      "/",
      22913,
      "/",
      18273
    ]
  },
  {
    "id": "12879",
    "description": "both",
    "pos": "WHITE",
    "explanation": "(2 + all: two of all)",
    "isCharacter": false,
    "composition": [
      8498,
      "/",
      12360
    ]
  },
  {
    "id": "12880",
    "description": "bottle,flask",
    "pos": "YELLOW",
    "explanation": "(pictograph: suggests bottle with body and neck)  - Character",
    "isCharacter": true
  },
  {
    "id": "12881",
    "description": "bottom,base",
    "pos": "YELLOW",
    "explanation": "(enclosure + pointer, to bottom)  - Character (superimposed - pointer)",
    "isCharacter": true
  },
  {
    "id": "12882",
    "description": "bow_(knot)",
    "pos": "YELLOW",
    "explanation": "(pictograph)  - Character",
    "isCharacter": true
  },
  {
    "id": "12883",
    "description": "bowel,intestine_(OLD)",
    "pos": "YELLOW",
    "explanation": "(tube + bowel movement)  SUPERSEDED SYNONYM  See intestine(s),bowel(s),gut(s) 25460",
    "isCharacter": false,
    "composition": [
      23926,
      "/",
      18043,
      "/",
      13097
    ]
  },
  {
    "id": "12884",
    "description": "bowel_movement,defecation,shitting,feces,shit,poop",
    "pos": "YELLOW",
    "explanation": "(waste + buttocks)",
    "isCharacter": false,
    "composition": [
      18043,
      "/",
      13097
    ]
  },
  {
    "id": "12885",
    "description": "bowling_(activity)",
    "pos": "YELLOW",
    "explanation": "(activity + ball_field: sport in which a ball is rolled along the ground)",
    "isCharacter": false,
    "composition": [
      12335,
      "/",
      25524
    ]
  },
  {
    "id": "12886",
    "description": "box,cube",
    "pos": "YELLOW",
    "explanation": "(pictograph: symbol suggests a three-dimensional box)  - Character",
    "isCharacter": true
  },
  {
    "id": "12887",
    "description": "boxing_(activity)",
    "pos": "YELLOW",
    "explanation": "(activity + fight)",
    "isCharacter": false,
    "composition": [
      12335,
      "/",
      24855
    ]
  },
  {
    "id": "12888",
    "description": "boy,lad",
    "pos": "BLUE",
    "explanation": "(child + male (combination))  - Character (superimposed - combined)",
    "isCharacter": true
  },
  {
    "id": "12889",
    "description": "bra,brassiere",
    "pos": "YELLOW",
    "explanation": "(clothing + breasts)",
    "isCharacter": false,
    "composition": [
      13366,
      "/",
      12899
    ]
  },
  {
    "id": "12890",
    "description": "medical_aid",
    "pos": "YELLOW",
    "explanation": "(support + medical + thing indicator)",
    "isCharacter": false,
    "composition": [
      14704,
      ";",
      9009,
      "/",
      24920
    ]
  },
  {
    "id": "12891",
    "description": "bracha,berakah,prayer_(small)",
    "pos": "YELLOW",
    "explanation": "(prayer + comma + little (Hebrew))",
    "isCharacter": false,
    "composition": [
      15666,
      "/",
      17739,
      "/",
      14451,
      "/",
      8487,
      "/",
      24917
    ]
  },
  {
    "id": "12892",
    "description": "Brahma",
    "pos": "BLUE",
    "explanation": "(god + creation: Hindu god for the creator) (India)",
    "isCharacter": false,
    "composition": [
      14451,
      "/",
      13607
    ]
  },
  {
    "id": "12893",
    "description": "brain",
    "pos": "YELLOW",
    "explanation": "(mind + thing indicator: organ of the body. The symbol is the concrete form of mind.)  - (character with thing indicator)",
    "isCharacter": "false",
    "composition": [
      15471,
      ";",
      9009
    ]
  },
  {
    "id": "12894",
    "description": "branch",
    "pos": "YELLOW",
    "explanation": "(tree + pointer, to branch)  - Character (superimposed - pointer)",
    "isCharacter": true
  },
  {
    "id": "12895",
    "description": "bread,loaf_of_bread,loaf",
    "pos": "YELLOW",
    "explanation": "(pictograph: symbol suggests a loaf of bread)  - Character",
    "isCharacter": true
  },
  {
    "id": "12896",
    "description": "break,crack,fracture,tear,injure,damage-(to)",
    "pos": "RED",
    "explanation": "(break,fracture,injury,damage + action indicator)",
    "isCharacter": false,
    "composition": [
      24852,
      ";",
      8993
    ]
  },
  {
    "id": "12897",
    "description": "breakable,fragile,vulnerable",
    "pos": "GREEN",
    "explanation": "(break,fracture,injury,damage + description before the fact indicator)",
    "isCharacter": false,
    "composition": [
      24852,
      ";",
      8997
    ]
  },
  {
    "id": "12898",
    "description": "breakfast",
    "pos": "YELLOW",
    "explanation": "(meal + 1: first meal of the day)",
    "isCharacter": false,
    "composition": [
      14647,
      "/",
      14377,
      "/",
      8497
    ]
  },
  {
    "id": "12899",
    "description": "breast(s)",
    "pos": "YELLOW",
    "explanation": "(body + two pointers, to breasts)  - Character (superimposed - pointer)",
    "isCharacter": true
  },
  {
    "id": "12900",
    "description": "breath,breathing,respiration",
    "pos": "YELLOW",
    "explanation": "(nose + mouth: mouth and nose are both used in breathing)",
    "isCharacter": false,
    "composition": [
      15732,
      "/",
      15666
    ]
  },
  {
    "id": "12901",
    "description": "breathe-(to)",
    "pos": "RED",
    "explanation": "(breath + action indicator)",
    "isCharacter": false,
    "composition": [
      15732,
      ";",
      8993,
      "/",
      15666
    ]
  },
  {
    "id": "12902",
    "description": "bridge,overpass",
    "pos": "YELLOW",
    "explanation": "(earth [modification, half-sized] + bow,arc + earth [half-sized]: the symbol suggests a bridge between two banks of a river) - Character (superimposed – modified)",
    "isCharacter": true
  },
  {
    "id": "12903",
    "description": "bright",
    "pos": "GREEN",
    "explanation": "(light + intensity + description indicator)",
    "isCharacter": false,
    "composition": [
      15208,
      ";",
      8998,
      "/",
      14947
    ]
  },
  {
    "id": "12904",
    "description": "bring-(to)",
    "pos": "RED",
    "explanation": "(to carry + forward + reference line + action indicator: to carry toward a given location)",
    "isCharacter": false,
    "composition": [
      25625,
      ";",
      8993,
      "/",
      12407
    ]
  },
  {
    "id": "12905",
    "description": "broccoli",
    "pos": "YELLOW",
    "explanation": "(cabbage + flower + green: cabbage with green flowerets)",
    "isCharacter": false,
    "composition": [
      13101,
      "/",
      14205,
      "/",
      13377,
      "/",
      14636
    ]
  },
  {
    "id": "12906",
    "description": "broil,barbecue,grill-(to)",
    "pos": "RED",
    "explanation": "(to cook + intensity + action indicator: to cook with intense heat)",
    "isCharacter": false,
    "composition": [
      14183,
      ";",
      8993,
      "/",
      14377,
      "/",
      14947
    ]
  },
  {
    "id": "12907",
    "description": "broken,injured,damaged",
    "pos": "GREEN",
    "explanation": "(break,fracture,injury,damage  + description after the fact indicator)",
    "isCharacter": false,
    "composition": [
      24852,
      ";",
      8996
    ]
  },
  {
    "id": "12908",
    "description": "broom",
    "pos": "YELLOW",
    "explanation": "(pictograph: symbol suggests a broom)  - Character",
    "isCharacter": true
  },
  {
    "id": "12909",
    "description": "brother",
    "pos": "BLUE",
    "explanation": "(son + 2: a son considered in relation to another child of his parents)",
    "isCharacter": false,
    "composition": [
      17209,
      "/",
      8498
    ]
  },
  {
    "id": "12910",
    "description": "brown_(bci)",
    "pos": "WHITE",
    "explanation": "(colour + earth) (BCI) SYMBOL SYNONYM",
    "isCharacter": false,
    "composition": [
      13377,
      "/",
      13901
    ]
  },
  {
    "id": "12911",
    "description": "brown_(ckb)",
    "pos": "WHITE",
    "explanation": "(colour + 1 + comma + 0: combination of red and black) (CKB) SYMBOL SYNONYM",
    "isCharacter": false,
    "composition": [
      13377,
      "/",
      8497,
      "/",
      8487,
      "/",
      8496
    ]
  },
  {
    "id": "12912",
    "description": "brush",
    "pos": "YELLOW",
    "explanation": "(pictograph: symbol suggests a brush in an upright position)  - Character",
    "isCharacter": true
  },
  {
    "id": "12913",
    "description": "brush-(to)",
    "pos": "RED",
    "explanation": "(brush + action indicator)",
    "isCharacter": false,
    "composition": [
      12912,
      ";",
      8993
    ]
  },
  {
    "id": "12914",
    "description": "brush_teeth-(to)",
    "pos": "RED",
    "explanation": "(toothbrush + action indicator)",
    "isCharacter": false,
    "composition": [
      12912,
      ";",
      8993,
      "/",
      17517
    ]
  },
  {
    "id": "12915",
    "description": "brussels_sprout(s)",
    "pos": "YELLOW",
    "explanation": "(cabbage + little)",
    "isCharacter": false,
    "composition": [
      13101,
      "/",
      24917
    ]
  },
  {
    "id": "12916",
    "description": "bubble",
    "pos": "YELLOW",
    "explanation": "(gas + pointer, to bubble)  - Character (superimposed - pointer)",
    "isCharacter": true
  },
  {
    "id": "12917",
    "description": "buffalo,bison",
    "pos": "YELLOW",
    "explanation": "(bovine + hump)  - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "12919",
    "description": "bulb_(flower)",
    "pos": "YELLOW",
    "explanation": "(bulbous_plant + pointer, to bulb)  - Character (superimposed - pointer)",
    "isCharacter": true
  },
  {
    "id": "12920",
    "description": "bull",
    "pos": "YELLOW",
    "explanation": "(bovine + male)",
    "isCharacter": false,
    "composition": [
      12379,
      "/",
      12335
    ]
  },
  {
    "id": "12921",
    "description": "bull_(fighting)",
    "pos": "YELLOW",
    "explanation": "(bovine + to fight)",
    "isCharacter": false,
    "composition": [
      12379,
      "/",
      24855
    ]
  },
  {
    "id": "12922",
    "description": "burn-(to)",
    "pos": "RED",
    "explanation": "(fire + action indicator)",
    "isCharacter": false,
    "composition": [
      14183,
      ";",
      8993
    ]
  },
  {
    "id": "12923",
    "description": "burned,burnt",
    "pos": "GREEN",
    "explanation": "(fire + description after the fact indicator)",
    "isCharacter": false,
    "composition": [
      14183,
      ";",
      8996
    ]
  },
  {
    "id": "12924",
    "description": "burning",
    "pos": "GREEN",
    "explanation": "(fire + description indicator)",
    "isCharacter": false,
    "composition": [
      14183,
      ";",
      8998
    ]
  },
  {
    "id": "12925",
    "description": "burp,belch-(to)",
    "pos": "RED",
    "explanation": "(wind + out_of_body_(upward) + action indicator: to expel wind from the stomach)",
    "isCharacter": false,
    "composition": [
      18255,
      ";",
      8993,
      "/",
      25590
    ]
  },
  {
    "id": "12926",
    "description": "bury_(person)-(to)",
    "pos": "RED",
    "explanation": "(grave + action indicator: to lay to rest below the earth)",
    "isCharacter": false,
    "composition": [
      14638,
      ";",
      8993
    ]
  },
  {
    "id": "13089",
    "description": "bus,coach",
    "pos": "YELLOW",
    "explanation": "(vehicle_(long) + pictograph of a steering wheel: suggests a bus with many wheels and a steering wheel)  - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "13090",
    "description": "bus_stop,bus_bay_(OLD)",
    "pos": "YELLOW",
    "explanation": "(platform + earth [modification, extended] + bus)  - Character (superimposed - modified)  SUPERSEDED SYNONYM and SUPERSEDED CHARACTER  See bus_stop,bus_bay 24041",
    "isCharacter": true
  },
  {
    "id": "13091",
    "description": "bus_driver",
    "pos": "BLUE",
    "explanation": "(person + bus)",
    "isCharacter": false,
    "composition": [
      16161,
      "/",
      13089
    ]
  },
  {
    "id": "13092",
    "description": "bush,shrub",
    "pos": "YELLOW",
    "explanation": "(pictograph: small tree growing close to the ground)  - Character",
    "isCharacter": true
  },
  {
    "id": "13093",
    "description": "business,economy,commerce,trade",
    "pos": "YELLOW",
    "explanation": "(money + to hold: money is taken into the till)  - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "13094",
    "description": "but,except,except_for_(preposition)",
    "pos": "WHITE",
    "explanation": "(CKB likens the but that halts a free flow of speech to a vertical line that stops a horizontal flowing line)  - Character",
    "isCharacter": true
  },
  {
    "id": "13095",
    "description": "butter",
    "pos": "YELLOW",
    "explanation": "(spread + cream: spread made from cream)",
    "isCharacter": false,
    "composition": [
      17238,
      "/",
      13881,
      "/",
      15206,
      "/",
      14947
    ]
  },
  {
    "id": "13096",
    "description": "butterfly,moth",
    "pos": "YELLOW",
    "explanation": "(pictograph: symbol suggests a butterfly or a moth)  - Character",
    "isCharacter": true
  },
  {
    "id": "13097",
    "description": "buttocks,bottom,bum,rear,ass",
    "pos": "YELLOW",
    "explanation": "(standing person + pointer, to buttocks)  - Character (superimposed - pointer)",
    "isCharacter": true
  },
  {
    "id": "13098",
    "description": "button,gripper,snap",
    "pos": "YELLOW",
    "explanation": "(disc + clothing)",
    "isCharacter": false,
    "composition": [
      13685,
      "/",
      13366
    ]
  },
  {
    "id": "13099",
    "description": "buy,purchase-(to)",
    "pos": "RED",
    "explanation": "(money + thing + action indicator: first you must have money, which you can then spend to buy something)",
    "isCharacter": false,
    "composition": [
      15484,
      ";",
      8993,
      "/",
      17717
    ]
  },
  {
    "id": "13100",
    "description": "by,by_means_of,of",
    "pos": "WHITE",
    "explanation": "(relation [half-sized], pointing backwards)  - Character",
    "isCharacter": true
  },
  {
    "id": "13101",
    "description": "cabbage",
    "pos": "YELLOW",
    "explanation": "(pictograph incorporating leafy vegetable) - Character (superimposed - combined)",
    "isCharacter": true
  },
  {
    "id": "13102",
    "description": "cabin,cottage,hut",
    "pos": "YELLOW",
    "explanation": "(house + little)",
    "isCharacter": false,
    "composition": [
      14905,
      "/",
      24917
    ]
  },
  {
    "id": "13103",
    "description": "caesarean_section,C-section",
    "pos": "YELLOW",
    "explanation": "(to remove + medical + fetus)",
    "isCharacter": false,
    "composition": [
      17449,
      "/",
      24920,
      "/",
      14170
    ]
  },
  {
    "id": "13104",
    "description": "cafe,coffee_house,snack_bar",
    "pos": "YELLOW",
    "explanation": "(public room + snack)",
    "isCharacter": false,
    "composition": [
      16430,
      "/",
      14647,
      "/",
      14377,
      "/",
      24917
    ]
  },
  {
    "id": "13105",
    "description": "cage",
    "pos": "YELLOW",
    "explanation": "(enclosure + pictograph of a barred window: enclosed space with bars that prevent escape)",
    "isCharacter": false,
    "composition": [
      13934,
      "/",
      18257
    ]
  },
  {
    "id": "13106",
    "description": "cake,bread_with_sugar",
    "pos": "YELLOW",
    "explanation": "(bread + sweet)",
    "isCharacter": false,
    "composition": [
      12895,
      "/",
      17506,
      "/",
      17983
    ]
  },
  {
    "id": "13107",
    "description": "calculate-(to)",
    "pos": "RED",
    "explanation": "(digital_processing,artificial_intelligence,calculation + action indicator: to think using numbers)",
    "isCharacter": false,
    "composition": [
      23475,
      ";",
      8993
    ]
  },
  {
    "id": "13108",
    "description": "calculator",
    "pos": "YELLOW",
    "explanation": "(machine + to calculate)",
    "isCharacter": false,
    "composition": [
      15406,
      "/",
      23475
    ]
  },
  {
    "id": "13109",
    "description": "calendar",
    "pos": "YELLOW",
    "explanation": "(page + day + month)",
    "isCharacter": false,
    "composition": [
      15962,
      "/",
      13639,
      "/",
      15649
    ]
  },
  {
    "id": "13110",
    "description": "camel",
    "pos": "YELLOW",
    "explanation": "(animal + pictograph of head and neck and two humps)  - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "13111",
    "description": "camera",
    "pos": "YELLOW",
    "explanation": "(enclosure + light: box that uses the sunlight to record what the eye sees)  - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "13112",
    "description": "camp",
    "pos": "YELLOW",
    "explanation": "(gathering + countryside + limited time: temporary gathering in the country)",
    "isCharacter": false,
    "composition": [
      14427,
      "/",
      13424,
      "/",
      15212
    ]
  },
  {
    "id": "13113",
    "description": "camper,caravan,mobile_home",
    "pos": "YELLOW",
    "explanation": "(vehicle + house [modification, high position] (combination))  - Character (superimposed - modified - combined)",
    "isCharacter": true
  },
  {
    "id": "13114",
    "description": "can,be_able-(to)",
    "pos": "RED",
    "explanation": "(ability_(half_sized) + action indicator)",
    "isCharacter": false,
    "composition": [
      25520,
      ";",
      8993
    ]
  },
  {
    "id": "13115",
    "description": "cylinder,can",
    "pos": "YELLOW",
    "explanation": "(pictograph)  - Character",
    "isCharacter": true
  },
  {
    "id": "13116",
    "description": "Canada",
    "pos": "YELLOW",
    "explanation": "(country + maple leaf)",
    "isCharacter": false,
    "composition": [
      13423,
      "/",
      15422
    ]
  },
  {
    "id": "13117",
    "description": "candle",
    "pos": "YELLOW",
    "explanation": "(linear thing + fire + light + thing indicator)",
    "isCharacter": false,
    "composition": [
      15214,
      ";",
      9009,
      "/",
      14183,
      "/",
      15208
    ]
  },
  {
    "id": "13118",
    "description": "candy_(OLD)",
    "pos": "YELLOW",
    "explanation": "(food + sweet + intensity)  SUPERSEDED SYNONYM  See candy 22375",
    "isCharacter": false,
    "composition": [
      14377,
      "/",
      17506,
      "/",
      17983,
      "/",
      14947
    ]
  },
  {
    "id": "13119",
    "description": "cane,stick,walking_stick",
    "pos": "YELLOW",
    "explanation": "(linear thing + to walk + thing indicator: linear thing used to help a person walk)",
    "isCharacter": false,
    "composition": [
      15214,
      ";",
      9009,
      "/",
      15189
    ]
  },
  {
    "id": "13120",
    "description": "cannon,gun",
    "pos": "YELLOW",
    "explanation": "(pictograph incorporating wheel and to destroy)  - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "13121",
    "description": "car,automobile,motor_vehicle",
    "pos": "YELLOW",
    "explanation": "(vehicle + pictograph of a steering wheel: suggests a car with a steering wheel)  - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "13122",
    "description": "cards,playing_cards",
    "pos": "YELLOW",
    "explanation": "(paper + to play + plural indicator)",
    "isCharacter": false,
    "composition": [
      15962,
      ";",
      9011,
      "/",
      12335,
      "/",
      "RK:-2",
      "/",
      14164,
      "/",
      17983
    ]
  },
  {
    "id": "13123",
    "description": "careful",
    "pos": "GREEN",
    "explanation": "(observation + intensity + intensity + description indicator: also a combination of to observe and attention)",
    "isCharacter": false,
    "composition": [
      24846,
      ";",
      8998,
      "/",
      14947,
      "/",
      14947
    ]
  },
  {
    "id": "13124",
    "description": "carrot,vegetable_(wedge-shaped)",
    "pos": "YELLOW",
    "explanation": "(vegetable below ground + pictograph of  wedge shape (combination))  - Character (superimposed - combined)",
    "isCharacter": true
  },
  {
    "id": "13125",
    "description": "carry,move,transport-(to)",
    "pos": "RED",
    "explanation": "(transport,transportation + action indicator: to move something by vehicle). See also: take,bring,carry,move-(to) 17497",
    "isCharacter": false,
    "composition": [
      25625,
      ";",
      8993
    ]
  },
  {
    "id": "13126",
    "description": "carrycot,bassinet",
    "pos": "YELLOW",
    "explanation": "(container + baby: holder for a baby)",
    "isCharacter": false,
    "composition": [
      13403,
      "/",
      12603
    ]
  },
  {
    "id": "13127",
    "description": "cart,carriage",
    "pos": "YELLOW",
    "explanation": "(transport,transportation + forward [modification, short arrow, high position]: can also be interpreted as a combination of transport and to pull)  - Character (superimposed - modified - combined)",
    "isCharacter": true
  },
  {
    "id": "13128",
    "description": "cassette,audiocassette,videocassette",
    "pos": "YELLOW",
    "explanation": "(pictograph)  - Character",
    "isCharacter": true
  },
  {
    "id": "13129",
    "description": "plaster_cast,cast_(medical)",
    "pos": "YELLOW",
    "explanation": "(enclosure + medical + body: medical enclosure for the body)",
    "isCharacter": false,
    "composition": [
      13934,
      "/",
      24920,
      "/",
      12870
    ]
  },
  {
    "id": "13131",
    "description": "catch,grab-(to)",
    "pos": "RED",
    "explanation": "(hand + to receive + action indicator)",
    "isCharacter": false,
    "composition": [
      14667,
      ";",
      8993,
      "/",
      24727
    ]
  },
  {
    "id": "13132",
    "description": "caterpillar",
    "pos": "YELLOW",
    "explanation": "(worm + butterfly: larva of the butterfly)",
    "isCharacter": false,
    "composition": [
      18279,
      "/",
      13096
    ]
  },
  {
    "id": "13133",
    "description": "cauliflower",
    "pos": "YELLOW",
    "explanation": "(cabbage + flower: cabbage with flowerets)",
    "isCharacter": false,
    "composition": [
      13101,
      "/",
      14205
    ]
  },
  {
    "id": "13134",
    "description": "cause",
    "pos": "YELLOW",
    "explanation": "(wedge shape that incorporates relation: the wedge presses into the thing on which it has an effect). - Character   See also: effect,result 13910",
    "isCharacter": true
  },
  {
    "id": "13135",
    "description": "cause-(to)",
    "pos": "RED",
    "explanation": "(cause + action indicator)",
    "isCharacter": false,
    "composition": [
      13134,
      ";",
      8993
    ]
  },
  {
    "id": "13136",
    "description": "be_caused_by-(to)",
    "pos": "RED",
    "explanation": "(cause + passive indicator)",
    "isCharacter": false,
    "composition": [
      13134,
      ";",
      9003
    ]
  },
  {
    "id": "13137",
    "description": "cave",
    "pos": "YELLOW",
    "explanation": "(hole + mountain: hole in a mountainside)",
    "isCharacter": false,
    "composition": [
      14883,
      "/",
      15663
    ]
  },
  {
    "id": "13138",
    "description": "cavity,caries",
    "pos": "YELLOW",
    "explanation": "(teeth + dot)  - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "13139",
    "description": "ceiling",
    "pos": "YELLOW",
    "explanation": "(room + pointer, to ceiling)  - Character (superimposed - pointer)",
    "isCharacter": true
  },
  {
    "id": "13140",
    "description": "celery",
    "pos": "YELLOW",
    "explanation": "(vegetable above ground [modification] + pictograph of a cluster of stalks) - Character (superimposed - combined - modified)",
    "isCharacter": true
  },
  {
    "id": "13141",
    "description": "celibacy,chastity",
    "pos": "YELLOW",
    "explanation": "(without + sexual intercourse)",
    "isCharacter": false,
    "composition": [
      15474,
      "/",
      13380,
      "/",
      14431
    ]
  },
  {
    "id": "13142",
    "description": "cemetery",
    "pos": "YELLOW",
    "explanation": "(place + grave)",
    "isCharacter": false,
    "composition": [
      16193,
      "/",
      14638
    ]
  },
  {
    "id": "13143",
    "description": "cent",
    "pos": "YELLOW",
    "explanation": "(international symbol for cent)  - Character",
    "isCharacter": true
  },
  {
    "id": "13144",
    "description": "century",
    "pos": "YELLOW",
    "explanation": "(100 + year: period of one hundred years)",
    "isCharacter": false,
    "composition": [
      8497,
      "/",
      "RK:-1",
      "/",
      8496,
      "/",
      "RK:-1",
      "/",
      8496,
      "/",
      18289
    ]
  },
  {
    "id": "13145",
    "description": "cereal",
    "pos": "YELLOW",
    "explanation": "(dish + grain)  - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "13146",
    "description": "certain_(OLD)",
    "pos": "GREEN",
    "explanation": "(opposite meaning + to doubt + description indicator)  SUPERSEDED SYNONYM  See certain,sure 24049",
    "isCharacter": false,
    "composition": [
      15927,
      "/",
      22911,
      ";",
      8998
    ]
  },
  {
    "id": "13147",
    "description": "cervix",
    "pos": "YELLOW",
    "explanation": "(part of + uterus)",
    "isCharacter": false,
    "composition": [
      15972,
      "/",
      17994
    ]
  },
  {
    "id": "13148",
    "description": "chair,seat",
    "pos": "YELLOW",
    "explanation": "(pictograph)  - Character",
    "isCharacter": true
  },
  {
    "id": "13149",
    "description": "challah",
    "pos": "YELLOW",
    "explanation": "(bread + Sabbath: traditional bread eaten on the Sabbath (Hebrew))",
    "isCharacter": false,
    "composition": [
      12895,
      "/",
      13639,
      "/",
      16495
    ]
  },
  {
    "id": "13150",
    "description": "chameleon",
    "pos": "YELLOW",
    "explanation": "(lizard + to change: lizard that is able to change colour)",
    "isCharacter": false,
    "composition": [
      12378,
      "/",
      17189,
      "/",
      13151
    ]
  },
  {
    "id": "13151",
    "description": "change,alteration,conversion",
    "pos": "YELLOW",
    "explanation": "(weather [modification]: CKB says that weather is ever-changing. Can also be interpreted as; life + water, ever-changing in state. The symbol represents change in a general sense.)  - Character (superimposed - modified)",
    "isCharacter": true
  },
  {
    "id": "13152",
    "description": "change,alter,convert-(to)",
    "pos": "RED",
    "explanation": "(change + action indicator)",
    "isCharacter": false,
    "composition": [
      13151,
      ";",
      8993
    ]
  },
  {
    "id": "13153",
    "description": "Chanukah,Hanukkah",
    "pos": "YELLOW",
    "explanation": "(holiday + light: holiday of lights (Hebrew))",
    "isCharacter": false,
    "composition": [
      13639,
      "/",
      14164,
      "/",
      17983,
      "/",
      15208
    ]
  },
  {
    "id": "13154",
    "description": "charity",
    "pos": "YELLOW",
    "explanation": "(help + needy person + feeling)",
    "isCharacter": false,
    "composition": [
      14704,
      "/",
      15701,
      "/",
      14164
    ]
  },
  {
    "id": "13155",
    "description": "cheap_(OLD)",
    "pos": "GREEN",
    "explanation": "(opposite meaning + expensive + description indicator)    SUPERSEDED SYNONYM  See  cheap,inexpensive 23039",
    "isCharacter": false,
    "composition": [
      15927,
      "/",
      14647,
      "/",
      15484,
      ";",
      8998,
      "/",
      14381,
      "/",
      17717
    ]
  },
  {
    "id": "13156",
    "description": "cheek",
    "pos": "YELLOW",
    "explanation": "(face + pointer, to cheek)  - Character (superimposed - pointer)",
    "isCharacter": true
  },
  {
    "id": "13157",
    "description": "cheese",
    "pos": "YELLOW",
    "explanation": "(pictograph: symbol suggests a wedge of cheese) - Character",
    "isCharacter": true
  },
  {
    "id": "13158",
    "description": "chemical_product",
    "pos": "YELLOW",
    "explanation": "(pictograph symbol suggests the outline of a chemical retort + thing [modification, lower position] (combination)) - Character (superimposed - modified - combined)",
    "isCharacter": true
  },
  {
    "id": "13159",
    "description": "cherry,cherries",
    "pos": "YELLOW",
    "explanation": "(fruit + pit,stone [modification,lower position] + fruit [modification] + pit,stone [modification,lower position]: pictograph of cherries combined in a cluster)  - Character (superimposed - modified - combined)",
    "isCharacter": true
  },
  {
    "id": "13160",
    "description": "Cheshvan",
    "pos": "YELLOW",
    "explanation": "(month + beginning + rain: month when rainy season begins (Hebrew))",
    "isCharacter": false,
    "composition": [
      15649,
      "/",
      12658,
      "/",
      16455
    ]
  },
  {
    "id": "13161",
    "description": "chest",
    "pos": "YELLOW",
    "explanation": "chest (body + pointer, to chest) - Character (superimposed - pointer)",
    "isCharacter": true
  },
  {
    "id": "13162",
    "description": "chest_of_drawers,bureau,dresser",
    "pos": "YELLOW",
    "explanation": "(pictograph)  - Character",
    "isCharacter": true
  },
  {
    "id": "13163",
    "description": "chew-(to)",
    "pos": "RED",
    "explanation": "(many + to bite + action indicator: to bite many times)",
    "isCharacter": false,
    "composition": [
      14647,
      "/",
      17517,
      ";",
      8993
    ]
  },
  {
    "id": "13164",
    "description": "chicken_(bird)",
    "pos": "YELLOW",
    "explanation": "(bird + food: bird commonly used for food)",
    "isCharacter": false,
    "composition": [
      12837,
      "/",
      14377
    ]
  },
  {
    "id": "13165",
    "description": "chicken_(food),poultry",
    "pos": "YELLOW",
    "explanation": "(food + bird)",
    "isCharacter": false,
    "composition": [
      14377,
      "/",
      12837
    ]
  },
  {
    "id": "13166",
    "description": "child,kid,youngster",
    "pos": "BLUE",
    "explanation": "(flower + little (combination): CKB writes: A child is like a \"little flower\". The symbol also can be explained as a pictograph showing the head, arms, feet and body of a child.)  - Character (superimposed - combined)",
    "isCharacter": true
  },
  {
    "id": "13167",
    "description": "child_abuse",
    "pos": "YELLOW",
    "explanation": "(abuse + child)",
    "isCharacter": false,
    "composition": [
      22914,
      "/",
      14947,
      "/",
      13166
    ]
  },
  {
    "id": "13168",
    "description": "chimney",
    "pos": "YELLOW",
    "explanation": "(building_with_chimney + pointer, to chimney) - Character (superimposed - pointer)",
    "isCharacter": true
  },
  {
    "id": "13169",
    "description": "chin",
    "pos": "YELLOW",
    "explanation": "(face + pointer, to chin)  - Character (superimposed - pointer)",
    "isCharacter": true
  },
  {
    "id": "13170",
    "description": "chipmunk",
    "pos": "YELLOW",
    "explanation": "(rodent + stripe)",
    "isCharacter": false,
    "composition": [
      12378,
      "/",
      17517,
      "/",
      15214
    ]
  },
  {
    "id": "13171",
    "description": "chocolate_(OLD)",
    "pos": "YELLOW",
    "explanation": "(food + powder + brown)    SUPERSEDED SYNONYM  See chocolate 22905",
    "isCharacter": false,
    "composition": [
      14377,
      "/",
      16233,
      "/",
      13377,
      "/",
      13901
    ]
  },
  {
    "id": "13172",
    "description": "chocolate_drink_(OLD)",
    "pos": "YELLOW",
    "explanation": "(drink + chocolate [contraction])    SUPERSEDED SYNONYM  See chocolate_drink 20772",
    "isCharacter": false,
    "composition": [
      13881,
      "/",
      16233,
      "/",
      13377,
      "/",
      13901
    ]
  },
  {
    "id": "13173",
    "description": "chocolate_flavouring,cocoa,cacao_powder_(OLD)",
    "pos": "YELLOW",
    "explanation": "(adding,additive + chocolate [contraction])    SUPERSEDED SYNONYM  See chocolate_flavouring 20771",
    "isCharacter": false,
    "composition": [
      12339,
      ";",
      9009,
      "/",
      16233,
      "/",
      13377,
      "/",
      13901
    ]
  },
  {
    "id": "13174",
    "description": "chocolate_spread_(OLD)",
    "pos": "YELLOW",
    "explanation": "(spread + chocolate [contraction])    SUPERSEDED SYNONYM  See chocolate_spread 22906",
    "isCharacter": false,
    "composition": [
      17238,
      "/",
      16233,
      "/",
      13377,
      "/",
      13901
    ]
  },
  {
    "id": "13175",
    "description": "choice,selection,election",
    "pos": "YELLOW",
    "explanation": "(comparative_more + eye [modification, low position]: combination of eye and to divide [half-sized] and many: the eye makes a choice among many things)  - Character (superimposed - modified - combined)",
    "isCharacter": true
  },
  {
    "id": "13176",
    "description": "choir,chorus",
    "pos": "BLUE",
    "explanation": "(group + to sing)",
    "isCharacter": false,
    "composition": [
      14647,
      "/",
      16161,
      "/",
      15666,
      "/",
      15682
    ]
  },
  {
    "id": "13177",
    "description": "choke,gag-(to)",
    "pos": "RED",
    "explanation": "(to swallow + negative + action indicator: to swallow badly )",
    "isCharacter": false,
    "composition": [
      13869,
      ";",
      8993,
      "/",
      13881,
      "/",
      15474,
      "/",
      14947
    ]
  },
  {
    "id": "13178",
    "description": "choose,pick,select-(to)",
    "pos": "RED",
    "explanation": "(choice + action indicator)",
    "isCharacter": false,
    "composition": [
      13175,
      ";",
      8993
    ]
  },
  {
    "id": "13179",
    "description": "chop-(to)",
    "pos": "RED",
    "explanation": "(to cut + intensity + action indicator)",
    "isCharacter": false,
    "composition": [
      15159,
      ";",
      8993,
      "/",
      14947
    ]
  },
  {
    "id": "13180",
    "description": "christian",
    "pos": "GREEN",
    "explanation": "(cross + description indicator)",
    "isCharacter": false,
    "composition": [
      13613,
      ";",
      8998
    ]
  },
  {
    "id": "13181",
    "description": "Christmas",
    "pos": "YELLOW",
    "explanation": "(birthday + Christ [contraction]: day of Christ's birth)",
    "isCharacter": false,
    "composition": [
      13639,
      "/",
      12843,
      "/",
      13613
    ]
  },
  {
    "id": "13182",
    "description": "Chumash,Pentateuch",
    "pos": "YELLOW",
    "explanation": "(5 + book + Torah (Hebrew))",
    "isCharacter": false,
    "composition": [
      8501,
      "/",
      12875,
      "/",
      17760
    ]
  },
  {
    "id": "13345",
    "description": "church,mosque,temple",
    "pos": "YELLOW",
    "explanation": "(building + God: building devoted to the worship of God)",
    "isCharacter": false,
    "composition": [
      14905,
      "/",
      14451
    ]
  },
  {
    "id": "13346",
    "description": "cigarette",
    "pos": "YELLOW",
    "explanation": "(smoking_(cigarette) + pointer, to cigarette)  - Character (superimposed - pointer)",
    "isCharacter": true
  },
  {
    "id": "13347",
    "description": "circle_(shape)",
    "pos": "YELLOW",
    "explanation": "(shape + circular shape [as of sun]: circle, a geometric shape)",
    "isCharacter": false,
    "composition": [
      14133,
      "/",
      17717,
      "/",
      17462
    ]
  },
  {
    "id": "13348",
    "description": "circumcision",
    "pos": "YELLOW",
    "explanation": "(to remove + foreskin)",
    "isCharacter": false,
    "composition": [
      17449,
      "/",
      16420,
      "/",
      15417
    ]
  },
  {
    "id": "13349",
    "description": "citizen",
    "pos": "YELLOW",
    "explanation": "(earth + man + woman (combination): man or woman having a relationship to a country or territory)  - Character (superimposed - combined)",
    "isCharacter": true
  },
  {
    "id": "13351",
    "description": "town,city_(small)",
    "pos": "YELLOW",
    "explanation": "(many + many + building: a large group of buildings comprise a city)",
    "isCharacter": false,
    "composition": [
      14647,
      "/",
      14647,
      "/",
      14905
    ]
  },
  {
    "id": "13352",
    "description": "class",
    "pos": "YELLOW",
    "explanation": "(group + to learn: group of people who come together to learn)",
    "isCharacter": false,
    "composition": [
      14647,
      "/",
      16161,
      "/",
      24727,
      "/",
      15162
    ]
  },
  {
    "id": "13353",
    "description": "classroom",
    "pos": "YELLOW",
    "explanation": "(room + to teach)",
    "isCharacter": false,
    "composition": [
      16687,
      "/",
      24903,
      "/",
      15162
    ]
  },
  {
    "id": "13354",
    "description": "claw_(animal)",
    "pos": "YELLOW",
    "explanation": "(feline + pointer, to claw)  - Character (superimposed - pointer)",
    "isCharacter": true
  },
  {
    "id": "13355",
    "description": "claw_(bird)",
    "pos": "YELLOW",
    "explanation": "(bird + pictograph of claws + pointer, to claw)  - Character (superimposed - pointer)",
    "isCharacter": true
  },
  {
    "id": "13356",
    "description": "clean_(OLD)",
    "pos": "GREEN",
    "explanation": "(opposite meaning + dirty + description indicator)  SUPERSEDED SYNONYM  See clean 24062",
    "isCharacter": false,
    "composition": [
      15927,
      "/",
      14647,
      "/",
      14133,
      ";",
      8998,
      "/",
      13867
    ]
  },
  {
    "id": "13357",
    "description": "clean-(to)",
    "pos": "RED",
    "explanation": "(to remove + dirty + action indicator)",
    "isCharacter": false,
    "composition": [
      17449,
      ";",
      8993,
      "/",
      14647,
      "/",
      14133,
      "/",
      13867
    ]
  },
  {
    "id": "13358",
    "description": "clear,transparent",
    "pos": "GREEN",
    "explanation": "(clearness,clarity,transparency,transparence + description indicator)",
    "isCharacter": false,
    "composition": [
      14133,
      ";",
      8998,
      "/",
      17724
    ]
  },
  {
    "id": "13359",
    "description": "clerk",
    "pos": "BLUE",
    "explanation": "(helper + business: person who helps in a business)",
    "isCharacter": false,
    "composition": [
      16161,
      "/",
      14704,
      "/",
      13093
    ]
  },
  {
    "id": "13360",
    "description": "climb-(to)",
    "pos": "RED",
    "explanation": "(to walk + up + action indicator)",
    "isCharacter": false,
    "composition": [
      15189,
      ";",
      8993,
      "/",
      17983
    ]
  },
  {
    "id": "13361",
    "description": "clinic",
    "pos": "YELLOW",
    "explanation": "(public room + medical)",
    "isCharacter": false,
    "composition": [
      16430,
      "/",
      24920
    ]
  },
  {
    "id": "13362",
    "description": "clitoris",
    "pos": "YELLOW",
    "explanation": "(part of + female genitals + intensity: part of the body that produces intense sexual excitement)",
    "isCharacter": false,
    "composition": [
      15972,
      "/",
      14431,
      "/",
      14166,
      "/",
      14947
    ]
  },
  {
    "id": "13363",
    "description": "clock,timepiece",
    "pos": "YELLOW",
    "explanation": "(time + thing indicator: object for telling time.The symbol is the concrete form of time.)  - (character with thing indicator)",
    "isCharacter": "false",
    "composition": [
      17732,
      ";",
      9009
    ]
  },
  {
    "id": "13364",
    "description": "close,enclose,shut-(to)",
    "pos": "RED",
    "explanation": "(enclosure + action indicator)",
    "isCharacter": false,
    "composition": [
      13934,
      ";",
      8993
    ]
  },
  {
    "id": "13365",
    "description": "cloth,fabric,material,textile,net",
    "pos": "YELLOW",
    "explanation": "(pictograph: symbol looks like woven threads, suggesting cloth) - Character",
    "isCharacter": true
  },
  {
    "id": "13366",
    "description": "clothing,clothes,garment",
    "pos": "YELLOW",
    "explanation": "(cloth + protection) - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "13367",
    "description": "cloud",
    "pos": "YELLOW",
    "explanation": "(water + sky: formation of water droplets in the sky) - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "13368",
    "description": "cloudy",
    "pos": "GREEN",
    "explanation": "(cloud + description indicator)",
    "isCharacter": false,
    "composition": [
      13367,
      ";",
      8998
    ]
  },
  {
    "id": "13369",
    "description": "club",
    "pos": "YELLOW",
    "explanation": "(gathering + interest: gathering of people sharing the same interest)",
    "isCharacter": false,
    "composition": [
      14427,
      "/",
      24916
    ]
  },
  {
    "id": "13370",
    "description": "biomass,biofuel",
    "pos": "YELLOW",
    "explanation": "(fuel + plant: fuel derived from plants)",
    "isCharacter": false,
    "composition": [
      14412,
      "/",
      16196
    ]
  },
  {
    "id": "13371",
    "description": "coat,jacket",
    "pos": "YELLOW",
    "explanation": "(clothing + over: clothing worn over other clothing)",
    "isCharacter": false,
    "composition": [
      13366,
      "/",
      15948
    ]
  },
  {
    "id": "13372",
    "description": "coconut",
    "pos": "YELLOW",
    "explanation": "(fruit + palm tree)",
    "isCharacter": false,
    "composition": [
      14405,
      "/",
      15960
    ]
  },
  {
    "id": "13373",
    "description": "coffee",
    "pos": "YELLOW",
    "explanation": "(drink + bean: drink made from coffee beans)",
    "isCharacter": false,
    "composition": [
      13881,
      "/",
      12642
    ]
  },
  {
    "id": "13374",
    "description": "coin",
    "pos": "YELLOW",
    "explanation": "(disc + money: money in the form of a disc)",
    "isCharacter": false,
    "composition": [
      13685,
      "/",
      15484
    ]
  },
  {
    "id": "13375",
    "description": "cold",
    "pos": "GREEN",
    "explanation": "(coldness,cold + description indicator) SYMBOL SYNONYM",
    "isCharacter": false,
    "composition": [
      25533,
      ";",
      8998
    ]
  },
  {
    "id": "13376",
    "description": "cold_(opposite_hot)",
    "pos": "GREEN",
    "explanation": "(opposite meaning + hot + description indicator) SYMBOL SYNONYM",
    "isCharacter": false,
    "composition": [
      15927,
      "/",
      14696,
      ";",
      8998
    ]
  },
  {
    "id": "13377",
    "description": "colour",
    "pos": "YELLOW",
    "explanation": "(eye + earth [half-sized]: what the eye receives from things on earth)",
    "isCharacter": true
  },
  {
    "id": "13378",
    "description": "comb",
    "pos": "YELLOW",
    "explanation": "(pictograph: symbol suggests a side view of a comb) - Character",
    "isCharacter": true
  },
  {
    "id": "13379",
    "description": "comb-(to)",
    "pos": "RED",
    "explanation": "(comb + action indicator)",
    "isCharacter": false,
    "composition": [
      13378,
      ";",
      8993
    ]
  },
  {
    "id": "13380",
    "description": "combination,connection",
    "pos": "YELLOW",
    "explanation": "(circle [half-sized] + circle [half-sized]: two interlocking circles) - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "13381",
    "description": "combine,connect,link-(to)",
    "pos": "RED",
    "explanation": "(combination + action indicator)",
    "isCharacter": false,
    "composition": [
      13380,
      ";",
      8993
    ]
  },
  {
    "id": "13382",
    "description": "combine_marker",
    "pos": "GRAY",
    "explanation": "(circle [quarter-sized] + circle [quarter-sized]: two small interlocking circles ¼ space above skyline, used before and after a novel multi-character Bliss-word created by a user to represent a new meaning. This signals that a Bliss-word is not contained in the published Blissymbol Vocabulary.)  - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "13383",
    "description": "come,approach-(to)",
    "pos": "RED",
    "explanation": "(approach + action indicator)",
    "isCharacter": false,
    "composition": [
      14390,
      ";",
      8993,
      "/",
      15214
    ]
  },
  {
    "id": "13384",
    "description": "comet",
    "pos": "YELLOW",
    "explanation": "(star [modification, on earthline] + curve,curved_line: pictograph that suggests a star with a curved tail) - Character (superimposed - modified)",
    "isCharacter": true
  },
  {
    "id": "13385",
    "description": "comfort,console-(to)",
    "pos": "RED",
    "explanation": "(to give + peace + action indicator)",
    "isCharacter": false,
    "composition": [
      24903,
      ";",
      8993,
      "/",
      15981
    ]
  },
  {
    "id": "13386",
    "description": "comfortable,restful",
    "pos": "GREEN",
    "explanation": "(rest + description indicator: feeling at rest)",
    "isCharacter": false,
    "composition": [
      16495,
      ";",
      8998
    ]
  },
  {
    "id": "13388",
    "description": "commandments",
    "pos": "YELLOW",
    "explanation": "(pictograph of two tablets of the laws: two tablets on which the ten commandments were inscribed) - Character",
    "isCharacter": true
  },
  {
    "id": "13389",
    "description": "communicate-(to)",
    "pos": "RED",
    "explanation": "(communication + action indicator)",
    "isCharacter": false,
    "composition": [
      25555,
      ";",
      8993,
      "/",
      15441
    ]
  },
  {
    "id": "13390",
    "description": "communication",
    "pos": "YELLOW",
    "explanation": "(exchange,substitution + meaning)",
    "isCharacter": false,
    "composition": [
      25555,
      "/",
      15441
    ]
  },
  {
    "id": "13391",
    "description": "compare-(to)",
    "pos": "RED",
    "explanation": "(to observe + same + action indicator: to observe the similarities between two or more persons or things)",
    "isCharacter": false,
    "composition": [
      24846,
      ";",
      8993,
      "/",
      16713
    ]
  },
  {
    "id": "13392",
    "description": "compete,race-(to)",
    "pos": "RED",
    "explanation": "(race + action indicator)",
    "isCharacter": false,
    "composition": [
      16451,
      ";",
      8993
    ]
  },
  {
    "id": "13393",
    "description": "composer",
    "pos": "BLUE",
    "explanation": "(person + tune: person who creates tunes)",
    "isCharacter": false,
    "composition": [
      16161,
      "/",
      16194,
      "/",
      15682
    ]
  },
  {
    "id": "13394",
    "description": "computer_(OLD)",
    "pos": "YELLOW",
    "explanation": "(machine + mind: machine that works like a mind)  SUPERSEDED SYNONYM  See computer 23447",
    "isCharacter": false,
    "composition": [
      15406,
      "/",
      15471
    ]
  },
  {
    "id": "13395",
    "description": "conception,fertilization,fertilized_egg",
    "pos": "YELLOW",
    "explanation": "(sperm + egg (combination))  - Character (superimposed - combined)",
    "isCharacter": true
  },
  {
    "id": "13396",
    "description": "concert_hall",
    "pos": "YELLOW",
    "explanation": "(building + music: building where music is performed)",
    "isCharacter": false,
    "composition": [
      14905,
      "/",
      13894,
      "/",
      15682
    ]
  },
  {
    "id": "13397",
    "description": "concrete,cement",
    "pos": "YELLOW",
    "explanation": "(material + stone + man-made: man-made material that can be used like stone)",
    "isCharacter": false,
    "composition": [
      15431,
      "/",
      17267,
      "/",
      23583
    ]
  },
  {
    "id": "13398",
    "description": "condom",
    "pos": "YELLOW",
    "explanation": "(barrier contraceptive + male)",
    "isCharacter": false,
    "composition": [
      12631,
      "/",
      12335
    ]
  },
  {
    "id": "13399",
    "description": "conductor_(music)_(OLD)",
    "pos": "BLUE",
    "explanation": "(person + to lead + musical note: person who leads or directs musicians)  SUPERSEDED SYNONYM  See conductor_(music) 24811",
    "isCharacter": false,
    "composition": [
      16161,
      "/",
      22913,
      "/",
      15682
    ]
  },
  {
    "id": "13400",
    "description": "cone",
    "pos": "YELLOW",
    "explanation": "(pictograph: symbol suggests the outline of a cone) - Character",
    "isCharacter": true
  },
  {
    "id": "13401",
    "description": "conscience",
    "pos": "YELLOW",
    "explanation": "(mind + mind [modification, at a higher level]: another level of consciousness super-imposed on the rational mind) - Character (superimposed - modified)",
    "isCharacter": true
  },
  {
    "id": "13402",
    "description": "considerate,thoughtful",
    "pos": "GREEN",
    "explanation": "(consideration (mind + other) + description indicator: mindful of others)",
    "isCharacter": false,
    "composition": [
      24880,
      ";",
      8998
    ]
  },
  {
    "id": "13403",
    "description": "container,bowl,holder,pouch,basket",
    "pos": "YELLOW",
    "explanation": "(pictograph: symbol suggests the outline of a bowl) - Character",
    "isCharacter": true
  },
  {
    "id": "13404",
    "description": "continue,pass-(to)",
    "pos": "RED",
    "explanation": "(continuance,continuation (forward [extended] + reference line [half-sized]) + action indicator: the arrow passes a reference line and continues on)",
    "isCharacter": false,
    "composition": [
      24881,
      ";",
      8993
    ]
  },
  {
    "id": "13405",
    "description": "uterine_contraction",
    "pos": "YELLOW",
    "explanation": "(work + uterus)",
    "isCharacter": false,
    "composition": [
      18273,
      "/",
      17994
    ]
  },
  {
    "id": "13406",
    "description": "contrast-(to)",
    "pos": "RED",
    "explanation": "(to observe + different + action indicator: to observe the differences between two persons or things)",
    "isCharacter": false,
    "composition": [
      24846,
      ";",
      8993,
      "/",
      13675
    ]
  },
  {
    "id": "13407",
    "description": "control_oneself-(to)",
    "pos": "RED",
    "explanation": "(self-control + action indicator)",
    "isCharacter": false,
    "composition": [
      22913,
      ";",
      8993,
      "/",
      8497,
      "/",
      15214
    ]
  },
  {
    "id": "13408",
    "description": "cook-(to)",
    "pos": "RED",
    "explanation": "(fire + food + action indicator: to use fire (heat) to prepare food)",
    "isCharacter": false,
    "composition": [
      14183,
      ";",
      8993,
      "/",
      14377
    ]
  },
  {
    "id": "13409",
    "description": "cookie,biscuit",
    "pos": "YELLOW",
    "explanation": "(disc + sweet: sweet, disc-shaped food)",
    "isCharacter": false,
    "composition": [
      13685,
      "/",
      17506,
      "/",
      17983
    ]
  },
  {
    "id": "13410",
    "description": "cool,chilly",
    "pos": "GREEN",
    "explanation": "(cold + little + description indicator) SYMBOL SYNONYM",
    "isCharacter": false,
    "composition": [
      25533,
      ";",
      8998,
      "/",
      24917
    ]
  },
  {
    "id": "13411",
    "description": "cool,chilly_(opposite_warm)",
    "pos": "GREEN",
    "explanation": "(opposite meaning + warm + description indicator) SYMBOL SYNONYM",
    "isCharacter": false,
    "composition": [
      15927,
      "/",
      14696,
      ";",
      8998,
      "/",
      24917
    ]
  },
  {
    "id": "13412",
    "description": "copy,duplicate",
    "pos": "YELLOW",
    "explanation": "(to repeat + thing indicator)  - (character with thing indicator)",
    "isCharacter": "false",
    "composition": [
      24934,
      ";",
      9009
    ]
  },
  {
    "id": "13413",
    "description": "corn",
    "pos": "YELLOW",
    "explanation": "(vegetable (oval-shaped) + dot + dot [modification, higher] + dot [modification, lower]: dots suggesting kernels of corn) - Character (superimposed - modified)",
    "isCharacter": true
  },
  {
    "id": "13414",
    "description": "corner_(room)",
    "pos": "YELLOW",
    "explanation": "(room + pointer, to corner)  - Character (superimposed - pointer)",
    "isCharacter": true
  },
  {
    "id": "13415",
    "description": "cornmeal",
    "pos": "YELLOW",
    "explanation": "(powder + corn)",
    "isCharacter": false,
    "composition": [
      16233,
      "/",
      13413
    ]
  },
  {
    "id": "13416",
    "description": "correct,accurate,good,right",
    "pos": "GREEN",
    "explanation": "(correctness + description indicator: thought to be correct, good, or right in a rational sense) See also: good,well,fine,ok,okay,all_right 14463 and moral,good,right,morally_right 15653",
    "isCharacter": false,
    "composition": [
      25538,
      ";",
      8998,
      "/",
      14947
    ]
  },
  {
    "id": "13417",
    "description": "cost,price",
    "pos": "YELLOW",
    "explanation": "(money + for (in exchange for) + thing)",
    "isCharacter": false,
    "composition": [
      15484,
      "/",
      14381,
      "/",
      17717
    ]
  },
  {
    "id": "13418",
    "description": "costume,disguise",
    "pos": "YELLOW",
    "explanation": "(clothing + make believe)",
    "isCharacter": false,
    "composition": [
      13366,
      "/",
      24895
    ]
  },
  {
    "id": "13419",
    "description": "couch,chesterfield,sofa",
    "pos": "YELLOW",
    "explanation": "(pictograph: symbol suggests a couch with a reclining back) - Character",
    "isCharacter": true
  },
  {
    "id": "13420",
    "description": "cough-(to)",
    "pos": "RED",
    "explanation": "(to blow + intensity + action indicator: to blow air forcefully from one's mouth)",
    "isCharacter": false,
    "composition": [
      15666,
      ";",
      8993,
      "/",
      18255,
      "/",
      14947
    ]
  },
  {
    "id": "13421",
    "description": "counsellor,adviser",
    "pos": "BLUE",
    "explanation": "(person + suggestion + to help: person who makes suggestions in order to help)",
    "isCharacter": false,
    "composition": [
      16161,
      "/",
      15925,
      "/",
      16437,
      "/",
      "RK:-2",
      "/",
      14704
    ]
  },
  {
    "id": "13422",
    "description": "count-(to)",
    "pos": "RED",
    "explanation": "(number + action indicator)",
    "isCharacter": false,
    "composition": [
      15742,
      ";",
      8993
    ]
  },
  {
    "id": "13423",
    "description": "country,state",
    "pos": "YELLOW",
    "explanation": "(flag + earth: territory identified by a flag) See also: countryside,country,nature 13424. - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "13424",
    "description": "countryside,country,nature",
    "pos": "YELLOW",
    "explanation": "(tree + earth: place where trees dominate the landscape) See also: country,state 13423 - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "13425",
    "description": "couple_(heterosexual)",
    "pos": "BLUE",
    "explanation": "(man + woman)  - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "13426",
    "description": "couple_(two_persons)",
    "pos": "BLUE",
    "explanation": "(person + person)",
    "isCharacter": true
  },
  {
    "id": "13427",
    "description": "family,couple",
    "pos": "BLUE",
    "explanation": "(man + protection + woman: a man and a woman living under one roof) - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "13428",
    "description": "court,field_(OLD)",
    "pos": "YELLOW",
    "explanation": "(place + sport_(OLD): place where sports are played)  SUPERSEDED SYNONYM  See court,field 22840",
    "isCharacter": false,
    "composition": [
      16193,
      "/",
      12335,
      "/",
      14690
    ]
  },
  {
    "id": "13429",
    "description": "cousin",
    "pos": "BLUE",
    "explanation": "(offspring + sibling + parent: child of one's uncle or aunt)",
    "isCharacter": false,
    "composition": [
      15912,
      "/",
      15912,
      "/",
      8498,
      "/",
      15968
    ]
  },
  {
    "id": "13430",
    "description": "cow",
    "pos": "YELLOW",
    "explanation": "(bovine + female)",
    "isCharacter": false,
    "composition": [
      12379,
      "/",
      14166
    ]
  },
  {
    "id": "13431",
    "description": "craft",
    "pos": "YELLOW",
    "explanation": "(man-made + hand: production of things by hand, e.g. quilting or wood carving)",
    "isCharacter": false,
    "composition": [
      23583,
      "/",
      "RK:-2",
      "/",
      14667
    ]
  },
  {
    "id": "13432",
    "description": "cramp,spasm",
    "pos": "YELLOW",
    "explanation": "(pain + muscle: pain caused by muscle spasm or contraction)",
    "isCharacter": false,
    "composition": [
      14164,
      "/",
      "RK:-2",
      "/",
      16164,
      "/",
      20517
    ]
  },
  {
    "id": "13433",
    "description": "cranberry",
    "pos": "YELLOW",
    "explanation": "(berry + bog: berry that grows in marsh land)",
    "isCharacter": false,
    "composition": [
      12666,
      "/",
      17472
    ]
  },
  {
    "id": "13434",
    "description": "crane",
    "pos": "YELLOW",
    "explanation": "(machine + up and down: equipment to raise and lower)",
    "isCharacter": false,
    "composition": [
      15406,
      "/",
      20524
    ]
  },
  {
    "id": "13435",
    "description": "crash_(forward)",
    "pos": "YELLOW",
    "explanation": "(to stop + intensity) SYMBOL SYNONYM",
    "isCharacter": false,
    "composition": [
      13935,
      "/",
      14947
    ]
  },
  {
    "id": "13436",
    "description": "crash_(downward)-(to)",
    "pos": "RED",
    "explanation": "(crash (downward) + action indicator) SYMBOL SYNONYM",
    "isCharacter": false,
    "composition": [
      24422,
      ";",
      8993,
      "/",
      14947
    ]
  },
  {
    "id": "13437",
    "description": "crash_(air),plane_crash,air_crash_(OLD)",
    "pos": "YELLOW",
    "explanation": "(crash_(downward) + airplane)",
    "isCharacter": false,
    "composition": [
      24422,
      "/",
      14947,
      "/",
      12357
    ]
  },
  {
    "id": "13438",
    "description": "crash_(car),car_crash_(OLD)",
    "pos": "YELLOW",
    "explanation": "(crash_(forward) + car)",
    "isCharacter": false,
    "composition": [
      13935,
      "/",
      14947,
      "/",
      13121
    ]
  },
  {
    "id": "13439",
    "description": "crash_(forward)-(to)",
    "pos": "RED",
    "explanation": "(crash (forward) + action indicator)",
    "isCharacter": false,
    "composition": [
      13935,
      ";",
      8993,
      "/",
      14947
    ]
  },
  {
    "id": "13440",
    "description": "crash_(downward)",
    "pos": "YELLOW",
    "explanation": "(bump,press,pressing + intensity: an intense fall and hit onto the ground)",
    "isCharacter": false,
    "composition": [
      24422,
      "/",
      14947
    ]
  },
  {
    "id": "13603",
    "description": "crawl-(to)",
    "pos": "RED",
    "explanation": "(kneeling person + forward + action indicator: to go forward on one's knees)",
    "isCharacter": false,
    "composition": [
      16162,
      ";",
      8993,
      "/",
      14390
    ]
  },
  {
    "id": "13604",
    "description": "crayon,coloured_pencil,marker",
    "pos": "YELLOW",
    "explanation": "(pencil + colour)",
    "isCharacter": false,
    "composition": [
      15991,
      "/",
      13377
    ]
  },
  {
    "id": "13605",
    "description": "cream",
    "pos": "YELLOW",
    "explanation": "(milk + intensity: the intensity symbol suggests that cream is rich milk)",
    "isCharacter": false,
    "composition": [
      13881,
      "/",
      15206,
      "/",
      14947
    ]
  },
  {
    "id": "13606",
    "description": "create-(to)",
    "pos": "RED",
    "explanation": "(creation + action indicator)",
    "isCharacter": false,
    "composition": [
      13607,
      ";",
      8993
    ]
  },
  {
    "id": "13607",
    "description": "creation,nature",
    "pos": "YELLOW",
    "explanation": "(equal-sided triangle: CKB points out that the Greeks considered the equal-sided triangle to be the simplest and most harmonious geometrical creation, and proof that the world is not chaos, but organized according to harmonious lines) - Character",
    "isCharacter": true
  },
  {
    "id": "13608",
    "description": "creative",
    "pos": "GREEN",
    "explanation": "(creation + description indicator)",
    "isCharacter": false,
    "composition": [
      13607,
      ";",
      8998
    ]
  },
  {
    "id": "13609",
    "description": "creature,being",
    "pos": "YELLOW",
    "explanation": "(life + thing indicator: a living creature. The symbol is the concrete form of life.)  - (character with thing indicator)",
    "isCharacter": "false",
    "composition": [
      15206,
      ";",
      9009
    ]
  },
  {
    "id": "13610",
    "description": "crescent",
    "pos": "YELLOW",
    "explanation": "(shape + crescent shape)",
    "isCharacter": false,
    "composition": [
      14133,
      "/",
      17717,
      "/",
      15651
    ]
  },
  {
    "id": "13611",
    "description": "crochet-(to)",
    "pos": "RED",
    "explanation": "(to make + cloth + hook + action indicator: to make cloth with a hook)",
    "isCharacter": false,
    "composition": [
      23583,
      ";",
      8993,
      "/",
      13365,
      "/",
      14891
    ]
  },
  {
    "id": "13612",
    "description": "croquet_(activity)",
    "pos": "YELLOW",
    "explanation": "(activity + ball + hammer: game in which a mallet is used to move a ball)",
    "isCharacter": false,
    "composition": [
      12335,
      "/",
      12621,
      "/",
      14666
    ]
  },
  {
    "id": "13613",
    "description": "cross,Christianity_(in_combinations)",
    "pos": "YELLOW",
    "explanation": "(pictograph, of a cross: symbol for Christianity) - Character",
    "isCharacter": true
  },
  {
    "id": "13614",
    "description": "cross-(to)",
    "pos": "RED",
    "explanation": "(across + action indicator)",
    "isCharacter": false,
    "composition": [
      12333,
      ";",
      8993
    ]
  },
  {
    "id": "13615",
    "description": "crotch",
    "pos": "YELLOW",
    "explanation": "(body + pointer, to crotch)  - Character (superimposed - pointer)",
    "isCharacter": true
  },
  {
    "id": "13616",
    "description": "crush,squeeze-(to)",
    "pos": "RED",
    "explanation": "(compression,compressing,squeezing + action indicator: to crush a thing by pressure from two directions)",
    "isCharacter": false,
    "composition": [
      25534,
      ";",
      8993
    ]
  },
  {
    "id": "13617",
    "description": "crutches",
    "pos": "YELLOW",
    "explanation": "(tools + medical + to walk + plural indicator: medical devices for walking)",
    "isCharacter": false,
    "composition": [
      17755,
      ";",
      9011,
      "/",
      24920,
      "/",
      15189
    ]
  },
  {
    "id": "13618",
    "description": "cry,weep-(to)",
    "pos": "RED",
    "explanation": "(eye + rain + action indicator: to have water falling from one's eyes like raindrops)",
    "isCharacter": false,
    "composition": [
      14133,
      ";",
      8993,
      "/",
      16455
    ]
  },
  {
    "id": "13619",
    "description": "crystal",
    "pos": "YELLOW",
    "explanation": "(thing + pictograph, of the plane facet-like faces of a crystal)  - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "13620",
    "description": "cucumber",
    "pos": "YELLOW",
    "explanation": "(vegetable (cylinder-shaped) + long)",
    "isCharacter": false,
    "composition": [
      18007,
      "/",
      15193
    ]
  },
  {
    "id": "13621",
    "description": "mug,cup",
    "pos": "YELLOW",
    "explanation": "(pictograph: symbol suggests a cup or a glass with a handle) - Character",
    "isCharacter": true
  },
  {
    "id": "13622",
    "description": "cupboard,closet,wardrobe",
    "pos": "YELLOW",
    "explanation": "(pictograph: symbol suggests double doors of a cupboard/closet) - Character",
    "isCharacter": true
  },
  {
    "id": "13623",
    "description": "currant(s)",
    "pos": "YELLOW",
    "explanation": "(pictograph of cluster of currants) - Character",
    "isCharacter": true
  },
  {
    "id": "13624",
    "description": "current",
    "pos": "GREEN",
    "explanation": "(now + description indicator)",
    "isCharacter": false,
    "composition": [
      15736,
      ";",
      8998
    ]
  },
  {
    "id": "13625",
    "description": "current_events",
    "pos": "YELLOW",
    "explanation": "(event + now + plural indicator)",
    "isCharacter": false,
    "composition": [
      14114,
      ";",
      9011,
      "/",
      15736
    ]
  },
  {
    "id": "13626",
    "description": "curtain(s),drape(s)",
    "pos": "YELLOW",
    "explanation": "(pictograph: symbol suggests a curtained window) - Character",
    "isCharacter": true
  },
  {
    "id": "13627",
    "description": "curve,curved_line",
    "pos": "YELLOW",
    "explanation": "(pictograph) - Character",
    "isCharacter": true
  },
  {
    "id": "13628",
    "description": "cut_(scissors)-(to)",
    "pos": "RED",
    "explanation": "(scissors + action indicator) SYMBOL SYNONYM",
    "isCharacter": false,
    "composition": [
      16736,
      ";",
      8993
    ]
  },
  {
    "id": "13629",
    "description": "cut_(knife)-(to)",
    "pos": "RED",
    "explanation": "(knife + action indicator) SYMBOL SYNONYM",
    "isCharacter": false,
    "composition": [
      15159,
      ";",
      8993
    ]
  },
  {
    "id": "13630",
    "description": "cutlery",
    "pos": "YELLOW",
    "explanation": "(generalization + knife)",
    "isCharacter": false,
    "composition": [
      14430,
      "/",
      15159
    ]
  },
  {
    "id": "13631",
    "description": "dance-(to)",
    "pos": "RED",
    "explanation": "(dance,dancing + action indicator: to step to the rhythm of the music)",
    "isCharacter": false,
    "composition": [
      15189,
      ";",
      8993,
      "/",
      15682
    ]
  },
  {
    "id": "13632",
    "description": "danger",
    "pos": "YELLOW",
    "explanation": "(creation + intensity: CKB says that this symbol implies that we must take care that we do not harm ourselves or others, since we are all part of a divine Creation) - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "13633",
    "description": "dangerous",
    "pos": "GREEN",
    "explanation": "(danger + description indicator)",
    "isCharacter": false,
    "composition": [
      13632,
      ";",
      8998
    ]
  },
  {
    "id": "13634",
    "description": "dark_(OLD)",
    "pos": "GREEN",
    "explanation": "(opposite meaning + light + description indicator)  SUPERSEDED SYNONYM  See dark 23844",
    "isCharacter": false,
    "composition": [
      15927,
      "/",
      15208,
      ";",
      8998
    ]
  },
  {
    "id": "13635",
    "description": "date_(man_woman)",
    "pos": "YELLOW",
    "explanation": "(to meet + man + woman: a man and a woman meeting each other socially) SYMBOL SYNONYM",
    "isCharacter": false,
    "composition": [
      25583,
      "/",
      15416,
      "/",
      18269
    ]
  },
  {
    "id": "13636",
    "description": "date_(two_persons)",
    "pos": "YELLOW",
    "explanation": "(to meet + person + person) SYMBOL SYNONYM",
    "isCharacter": false,
    "composition": [
      25583,
      "/",
      16161,
      "/",
      16161
    ]
  },
  {
    "id": "13637",
    "description": "date_(fruit)",
    "pos": "YELLOW",
    "explanation": "(plum (fruit + pit) + palm tree: fruit that grows on a palm tree)",
    "isCharacter": false,
    "composition": [
      16208,
      "/",
      15960
    ]
  },
  {
    "id": "13638",
    "description": "daughter",
    "pos": "BLUE",
    "explanation": "(protection + female: female born under the family roof) - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "13639",
    "description": "day",
    "pos": "YELLOW",
    "explanation": "(sun + earth: sun appears above the horizon; it shines on the earth during the day) - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "13640",
    "description": "daycare",
    "pos": "YELLOW",
    "explanation": "(protection + day)",
    "isCharacter": false,
    "composition": [
      16420,
      "/",
      13639
    ]
  },
  {
    "id": "13641",
    "description": "day_care_centre",
    "pos": "YELLOW",
    "explanation": "(building + day care)",
    "isCharacter": false,
    "composition": [
      14905,
      "/",
      16420,
      "/",
      13639
    ]
  },
  {
    "id": "13642",
    "description": "dead,deceased",
    "pos": "GREEN",
    "explanation": "(death + description after the fact indicator)",
    "isCharacter": false,
    "composition": [
      13645,
      ";",
      8996
    ]
  },
  {
    "id": "13643",
    "description": "deaf",
    "pos": "GREEN",
    "explanation": "(deafness + description indicator: unable to hear)  See also: hearing-impaired 26009",
    "isCharacter": false,
    "composition": [
      25543,
      ";",
      8998
    ]
  },
  {
    "id": "13644",
    "description": "dear",
    "pos": "GRAY",
    "explanation": "(feeling + toward: symbol showing affectionate or friendly feelings toward someone. It is used as a salutation in letters.)",
    "isCharacter": false,
    "composition": [
      14164,
      "/",
      17739
    ]
  },
  {
    "id": "13645",
    "description": "death",
    "pos": "YELLOW",
    "explanation": "(life + to cross out: life destroyed) - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "13646",
    "description": "decade",
    "pos": "YELLOW",
    "explanation": "(10 + year: a period of ten years)",
    "isCharacter": false,
    "composition": [
      8497,
      "/",
      "RK:-1",
      "/",
      8496,
      "/",
      18289
    ]
  },
  {
    "id": "13647",
    "description": "December",
    "pos": "YELLOW",
    "explanation": "(month + 12: twelfth month of the year)",
    "isCharacter": false,
    "composition": [
      15649,
      "/",
      8497,
      "/",
      "RK:-1",
      "/",
      8498
    ]
  },
  {
    "id": "13648",
    "description": "decide-(to)",
    "pos": "RED",
    "explanation": "(decision + action indicator)",
    "isCharacter": false,
    "composition": [
      13649,
      ";",
      8993
    ]
  },
  {
    "id": "13649",
    "description": "decision",
    "pos": "YELLOW",
    "explanation": "(to think + to arrive: arrival at  a rational position) - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "13650",
    "description": "decoration_(OLD)",
    "pos": "YELLOW",
    "explanation": "(thing + plus + beautiful: thing added to beautify)  SUPERSEDED SYNONYM  See decoration,ornament 24079",
    "isCharacter": false,
    "composition": [
      17717,
      "/",
      12374,
      "/",
      14133,
      "/",
      14164,
      "/",
      17983
    ]
  },
  {
    "id": "13651",
    "description": "decrease,reduce-(to)",
    "pos": "RED",
    "explanation": "(little + action indicator: to become smaller)",
    "isCharacter": false,
    "composition": [
      24917,
      ";",
      8993
    ]
  },
  {
    "id": "13652",
    "description": "deep",
    "pos": "GREEN",
    "explanation": "(depth + description indicator: the pointer points downward to the bottom of a relatively deep space)",
    "isCharacter": false,
    "composition": [
      25546,
      ";",
      8998
    ]
  },
  {
    "id": "13653",
    "description": "deep-fry-(to)",
    "pos": "RED",
    "explanation": "(to fry + intensity + action indicator: to fry at a high temperature)",
    "isCharacter": false,
    "composition": [
      14183,
      ";",
      8993,
      "/",
      14377,
      "/",
      15914,
      "/",
      14947
    ]
  },
  {
    "id": "13654",
    "description": "Denmark_(OLD)",
    "pos": "YELLOW",
    "explanation": "(country + three_Danish_waters_(OLD): country divided by three channels of water)  SUPERSEDED SYNONYM  See Denmark 25991",
    "isCharacter": false,
    "composition": [
      13423,
      "/",
      25623
    ]
  },
  {
    "id": "13655",
    "description": "toothpick",
    "pos": "YELLOW",
    "explanation": "(linear thing + teeth + thing indicator)",
    "isCharacter": false,
    "composition": [
      15214,
      ";",
      9009,
      "/",
      17517
    ]
  },
  {
    "id": "13656",
    "description": "dentist",
    "pos": "BLUE",
    "explanation": "(doctor + teeth)",
    "isCharacter": false,
    "composition": [
      16161,
      "/",
      24920,
      "/",
      17517
    ]
  },
  {
    "id": "13657",
    "description": "deodorant",
    "pos": "YELLOW",
    "explanation": "(chemical product + against + odour)",
    "isCharacter": false,
    "composition": [
      13158,
      "/",
      12351,
      "/",
      17017
    ]
  },
  {
    "id": "13658",
    "description": "departure",
    "pos": "YELLOW",
    "explanation": "(reference line + forward: advancing arrow departs from the line) - Character",
    "isCharacter": true
  },
  {
    "id": "13659",
    "description": "depression",
    "pos": "YELLOW",
    "explanation": "(mood + fall-(to): also a combination of mood and sad + intensity)",
    "isCharacter": false,
    "composition": [
      25379,
      "/",
      14164,
      "/",
      13869,
      "/",
      14947
    ]
  },
  {
    "id": "13660",
    "description": "descend,go_down-(to)",
    "pos": "RED",
    "explanation": "(down + action indicator)",
    "isCharacter": false,
    "composition": [
      13869,
      ";",
      8993
    ]
  },
  {
    "id": "13661",
    "description": "describe-(to)",
    "pos": "RED",
    "explanation": "(to say + state_of_mind + action indicator: to say what you think exists)",
    "isCharacter": false,
    "composition": [
      15666,
      ";",
      8993,
      "/",
      25379
    ]
  },
  {
    "id": "13662",
    "description": "desirable",
    "pos": "GREEN",
    "explanation": "(to want + description before the fact indicator)",
    "isCharacter": false,
    "composition": [
      14164,
      ";",
      8997,
      "/",
      14183
    ]
  },
  {
    "id": "13663",
    "description": "desk,worktable,work_table",
    "pos": "YELLOW",
    "explanation": "(table + work)",
    "isCharacter": false,
    "composition": [
      17493,
      "/",
      18273
    ]
  },
  {
    "id": "13664",
    "description": "dessert",
    "pos": "YELLOW",
    "explanation": "(food + end: food that one eats at the end of a meal)",
    "isCharacter": false,
    "composition": [
      14377,
      "/",
      13935
    ]
  },
  {
    "id": "13665",
    "description": "destroy,annul,cancel,cross_out,delete-(to)",
    "pos": "RED",
    "explanation": "(deletion,cancellation,destruction + action indicator: diagonal line used to cross out something)",
    "isCharacter": false,
    "composition": [
      24883,
      ";",
      8993
    ]
  },
  {
    "id": "13666",
    "description": "develop-(to)",
    "pos": "RED",
    "explanation": "(development + action indicator)",
    "isCharacter": false,
    "composition": [
      28012,
      ";",
      8993
    ]
  },
  {
    "id": "13667",
    "description": "development_(OLD)",
    "pos": "YELLOW",
    "explanation": "(change + forward [modification, short arrow]: change through progression) - Character (superimposed - modified)",
    "isCharacter": true
  },
  {
    "id": "13668",
    "description": "dhoti,lungi",
    "pos": "YELLOW",
    "explanation": "(clothing + around + man) (India)",
    "isCharacter": false,
    "composition": [
      13366,
      "/",
      12580,
      "/",
      15416
    ]
  },
  {
    "id": "13669",
    "description": "diamond_(shape),rhombus,rhomb",
    "pos": "YELLOW",
    "explanation": "(shape + diamond_(character))",
    "isCharacter": false,
    "composition": [
      14133,
      "/",
      17717,
      "/",
      25549
    ]
  },
  {
    "id": "13670",
    "description": "diaper,nappy",
    "pos": "YELLOW",
    "explanation": "(absorbent material + buttocks_and_genitals)",
    "isCharacter": false,
    "composition": [
      15431,
      "/",
      14952,
      "/",
      25531
    ]
  },
  {
    "id": "13671",
    "description": "diaphragm_(contraceptive),pessary",
    "pos": "YELLOW",
    "explanation": "(barrier_(contraceptive) + female)",
    "isCharacter": false,
    "composition": [
      12631,
      "/",
      14166
    ]
  },
  {
    "id": "13672",
    "description": "die-(to)",
    "pos": "RED",
    "explanation": "(death + action indicator)",
    "isCharacter": false,
    "composition": [
      13645,
      ";",
      8993
    ]
  },
  {
    "id": "13673",
    "description": "diet",
    "pos": "YELLOW",
    "explanation": "(plan + to eat)",
    "isCharacter": false,
    "composition": [
      16194,
      "/",
      14377
    ]
  },
  {
    "id": "13674",
    "description": "diet-(to)",
    "pos": "RED",
    "explanation": "(to eat + plan + action indicator: to eat according to a plan)",
    "isCharacter": false,
    "composition": [
      14377,
      ";",
      8993,
      "/",
      16194
    ]
  },
  {
    "id": "13675",
    "description": "different,other,difference",
    "pos": "WHITE",
    "explanation": "(to cross out + same)  - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "13676",
    "description": "difficult,hard",
    "pos": "GREEN",
    "explanation": "(difficulty + description indicator)",
    "isCharacter": false,
    "composition": [
      24884,
      ";",
      8998
    ]
  },
  {
    "id": "13677",
    "description": "dig-(to)",
    "pos": "RED",
    "explanation": "(digging,excavation + action indicator)",
    "isCharacter": false,
    "composition": [
      25550,
      ";",
      8993
    ]
  },
  {
    "id": "13678",
    "description": "digest-(to)",
    "pos": "RED",
    "explanation": "(digestion + action indicator)",
    "isCharacter": false,
    "composition": [
      14377,
      ";",
      8993,
      "/",
      17724
    ]
  },
  {
    "id": "13679",
    "description": "digestion",
    "pos": "YELLOW",
    "explanation": "(food + through: food passing through the body)",
    "isCharacter": false,
    "composition": [
      14377,
      "/",
      17724
    ]
  },
  {
    "id": "13680",
    "description": "dining_room",
    "pos": "YELLOW",
    "explanation": "(room + to eat)",
    "isCharacter": false,
    "composition": [
      16687,
      "/",
      14377
    ]
  },
  {
    "id": "13681",
    "description": "dinosaur_(OLD)",
    "pos": "YELLOW",
    "explanation": "(reptile + past: extinct reptile)  SUPERSEDED SYNONYM  See dinosaur 23477",
    "isCharacter": false,
    "composition": [
      12378,
      "/",
      17189,
      "/",
      15975
    ]
  },
  {
    "id": "13682",
    "description": "direction,cardinal_point",
    "pos": "YELLOW",
    "explanation": "(generalization + forward)",
    "isCharacter": false,
    "composition": [
      14430,
      "/",
      14390
    ]
  },
  {
    "id": "13683",
    "description": "dirty,soiled",
    "pos": "GREEN",
    "explanation": "(many + spot + description indicator: having many spots)",
    "isCharacter": false,
    "composition": [
      14647,
      "/",
      14133,
      ";",
      8998,
      "/",
      13867
    ]
  },
  {
    "id": "13684",
    "description": "disability,handicap,impairment_(OLD)",
    "pos": "YELLOW",
    "explanation": "(ability + limits: limited ability)  SUPERSEDED SYNONYM  See disability,handicap,impairment 25992",
    "isCharacter": false,
    "composition": [
      12322,
      "/",
      15213
    ]
  },
  {
    "id": "13685",
    "description": "disc,disk",
    "pos": "YELLOW",
    "explanation": "(pictograph: simplified three-dimensional drawing of a disc) - Character",
    "isCharacter": true
  },
  {
    "id": "13686",
    "description": "disco",
    "pos": "YELLOW",
    "explanation": "(gathering + record: gathering to listen to recorded music)",
    "isCharacter": false,
    "composition": [
      14427,
      "/",
      25601,
      "/",
      13894
    ]
  },
  {
    "id": "13687",
    "description": "discomfort",
    "pos": "YELLOW",
    "explanation": "(comfort + to destroy) - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "13688",
    "description": "discuss,converse,debate-(to)",
    "pos": "RED",
    "explanation": "(discussion + action indicator)",
    "isCharacter": false,
    "composition": [
      15666,
      ";",
      8993,
      "/",
      12610
    ]
  },
  {
    "id": "13689",
    "description": "discussion,conversation,debate,chat",
    "pos": "YELLOW",
    "explanation": "(to speak + back and forth: talk that goes back and forth)",
    "isCharacter": false,
    "composition": [
      15666,
      "/",
      12610
    ]
  },
  {
    "id": "13690",
    "description": "dish,plate,platter",
    "pos": "YELLOW",
    "explanation": "(pictograph: symbol suggests a dish) - Character",
    "isCharacter": true
  },
  {
    "id": "13691",
    "description": "dislike",
    "pos": "YELLOW",
    "explanation": "(feeling + negative)",
    "isCharacter": false,
    "composition": [
      14164,
      "/",
      15474,
      "/",
      14947
    ]
  },
  {
    "id": "13692",
    "description": "dislike-(to)",
    "pos": "RED",
    "explanation": "(dislike + action indicator)",
    "isCharacter": false,
    "composition": [
      14164,
      ";",
      8993,
      "/",
      15474,
      "/",
      14947
    ]
  },
  {
    "id": "13694",
    "description": "divide-(to)",
    "pos": "RED",
    "explanation": "(division + action indicator)",
    "isCharacter": false,
    "composition": [
      13857,
      ";",
      8993
    ]
  },
  {
    "id": "13857",
    "description": "division",
    "pos": "YELLOW",
    "explanation": "(based upon the international mathematical symbol) - Character",
    "isCharacter": true
  },
  {
    "id": "13858",
    "description": "divorce",
    "pos": "YELLOW",
    "explanation": "(marriage + division: legal division of a marriage)",
    "isCharacter": false,
    "composition": [
      15425,
      "/",
      13857
    ]
  },
  {
    "id": "13859",
    "description": "divorce-(to)",
    "pos": "RED",
    "explanation": "(divorce + action indicator)",
    "isCharacter": false,
    "composition": [
      15425,
      ";",
      8993,
      "/",
      13857
    ]
  },
  {
    "id": "13860",
    "description": "do,act-(to)",
    "pos": "RED",
    "explanation": "(action + action indicator)",
    "isCharacter": false,
    "composition": [
      12335,
      ";",
      8993
    ]
  },
  {
    "id": "13861",
    "description": "doctor,physician",
    "pos": "BLUE",
    "explanation": "(person + medical)",
    "isCharacter": false,
    "composition": [
      16161,
      "/",
      24920
    ]
  },
  {
    "id": "13862",
    "description": "doll",
    "pos": "YELLOW",
    "explanation": "(child + man-made)",
    "isCharacter": false,
    "composition": [
      13166,
      "/",
      23583
    ]
  },
  {
    "id": "13863",
    "description": "dollar",
    "pos": "YELLOW",
    "explanation": "(international  symbol for dollar) - Character",
    "isCharacter": true
  },
  {
    "id": "13864",
    "description": "dolphin,porpoise,water_mammal_(with_tail)",
    "pos": "YELLOW",
    "explanation": "(pictograph: the shape contains water_creature + pictograph of a tail fin) - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "13865",
    "description": "donkey,mule",
    "pos": "YELLOW",
    "explanation": "(horse + work: animal that resembles a horse and is commonly used to assist with work)",
    "isCharacter": false,
    "composition": [
      14897,
      "/",
      18273
    ]
  },
  {
    "id": "13866",
    "description": "door",
    "pos": "YELLOW",
    "explanation": "(pictograph: symbol suggests a doorway) - Character",
    "isCharacter": true
  },
  {
    "id": "13867",
    "description": "dot",
    "pos": "YELLOW",
    "explanation": "(pictograph: often used to create a meaning based on the relationship between the dot and an associated symbol) - Character",
    "isCharacter": true
  },
  {
    "id": "13868",
    "description": "doubt-(to)",
    "pos": "RED",
    "explanation": "(doubt,uncertainty + action indicator)",
    "isCharacter": false,
    "composition": [
      22911,
      ";",
      8993
    ]
  },
  {
    "id": "13869",
    "description": "down,downward",
    "pos": "WHITE",
    "explanation": "(arrow, pointing downward) - Character",
    "isCharacter": true
  },
  {
    "id": "13870",
    "description": "downward_and_backward",
    "pos": "WHITE",
    "explanation": "(arrow, pointing downward and backward) - Character",
    "isCharacter": true
  },
  {
    "id": "13871",
    "description": "downward_and_forward",
    "pos": "WHITE",
    "explanation": "(arrow, pointing downward and forward) - Character",
    "isCharacter": true
  },
  {
    "id": "13872",
    "description": "drain,sift,strain-(to)",
    "pos": "RED",
    "explanation": "(sieve + action indicator)",
    "isCharacter": false,
    "composition": [
      16976,
      ";",
      8993
    ]
  },
  {
    "id": "13873",
    "description": "draw,sketch-(to)",
    "pos": "RED",
    "explanation": "(pencil + picture + action indicator: to use a pencil or pen to make a picture)",
    "isCharacter": false,
    "composition": [
      15991,
      ";",
      8993,
      "/",
      14133,
      "/",
      13934
    ]
  },
  {
    "id": "13874",
    "description": "drawer",
    "pos": "YELLOW",
    "explanation": "(chest of drawers + pointer, to drawer)  - Character (superimposed - pointer)",
    "isCharacter": true
  },
  {
    "id": "13875",
    "description": "dream-(to)",
    "pos": "RED",
    "explanation": "(to think + to sleep + action indicator: to think in one's sleep)",
    "isCharacter": false,
    "composition": [
      15471,
      ";",
      8993,
      "/",
      17008
    ]
  },
  {
    "id": "13876",
    "description": "dress",
    "pos": "YELLOW",
    "explanation": "(clothing + woman)",
    "isCharacter": false,
    "composition": [
      13366,
      "/",
      18269
    ]
  },
  {
    "id": "13877",
    "description": "dress,wear-(to)",
    "pos": "RED",
    "explanation": "(clothing + action indicator)",
    "isCharacter": false,
    "composition": [
      13366,
      ";",
      8993
    ]
  },
  {
    "id": "13878",
    "description": "dress_up,disguise-(to)",
    "pos": "RED",
    "explanation": "(costume + action indicator: people \"dress up\" to imagine themselves as someone or something else, e.g. at Halloween)",
    "isCharacter": false,
    "composition": [
      13366,
      ";",
      8993,
      "/",
      24895
    ]
  },
  {
    "id": "13879",
    "description": "dressing_gown,housecoat,robe",
    "pos": "YELLOW",
    "explanation": "(clothing + comfort)",
    "isCharacter": false,
    "composition": [
      13366,
      "/",
      16495
    ]
  },
  {
    "id": "13880",
    "description": "dried_bean_(OLD)",
    "pos": "YELLOW",
    "explanation": "(bean + dry)  SUPERSEDED SYNONYM  See bean_(dried),chick-pea,kidney_bean,pinto_bean 24021",
    "isCharacter": false,
    "composition": [
      12642,
      "/",
      15927,
      "/",
      18209
    ]
  },
  {
    "id": "13881",
    "description": "drink,beverage",
    "pos": "YELLOW",
    "explanation": "(liquid + food)  - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "13882",
    "description": "drink-(to)",
    "pos": "RED",
    "explanation": "(drink + action indicator)",
    "isCharacter": false,
    "composition": [
      13881,
      ";",
      8993
    ]
  },
  {
    "id": "13883",
    "description": "drive-(to)",
    "pos": "RED",
    "explanation": "(car + action indicator)",
    "isCharacter": false,
    "composition": [
      13121,
      ";",
      8993
    ]
  },
  {
    "id": "13884",
    "description": "driver,chauffeur",
    "pos": "BLUE",
    "explanation": "(person + car)",
    "isCharacter": false,
    "composition": [
      16161,
      "/",
      13121
    ]
  },
  {
    "id": "13885",
    "description": "dromedary",
    "pos": "YELLOW",
    "explanation": "(animal + pictograph of head and neck and one hump) - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "13886",
    "description": "drunk",
    "pos": "GREEN",
    "explanation": "(weak person + alcoholic drink + description indicator: when drunk a person’s knees may buckle)",
    "isCharacter": false,
    "composition": [
      16167,
      ";",
      8998,
      "/",
      12359
    ]
  },
  {
    "id": "13887",
    "description": "dry_(OLD)",
    "pos": "GREEN",
    "explanation": "(opposite meaning + wet + description after the fact indicator)  SUPERSEDED SYNONYM  See dry 23857",
    "isCharacter": false,
    "composition": [
      15927,
      "/",
      18209,
      ";",
      8996
    ]
  },
  {
    "id": "13888",
    "description": "dry-(to)_(OLD)",
    "pos": "RED",
    "explanation": "(to cause + dry + action indicator)  SUPERSEDED SYNONYM  See dry-(to) 23858",
    "isCharacter": false,
    "composition": [
      13134,
      ";",
      8993,
      "/",
      15927,
      "/",
      18209
    ]
  },
  {
    "id": "13889",
    "description": "duck_(food)",
    "pos": "YELLOW",
    "explanation": "(food + duck)",
    "isCharacter": false,
    "composition": [
      14377,
      "/",
      12840
    ]
  },
  {
    "id": "13890",
    "description": "dump_truck,dumper,tipper_lorry,tipper",
    "pos": "YELLOW",
    "explanation": "(truck + out of (downward))",
    "isCharacter": false,
    "composition": [
      17781,
      "/",
      15944
    ]
  },
  {
    "id": "13891",
    "description": "Durga",
    "pos": "BLUE",
    "explanation": "(goddess + 10 + hand: Hindu goddess) (India)",
    "isCharacter": false,
    "composition": [
      14451,
      "/",
      8497,
      "/",
      "RK:-1",
      "/",
      8496,
      "/",
      14667
    ]
  },
  {
    "id": "13892",
    "description": "during,while",
    "pos": "WHITE",
    "explanation": "(limited time + dot (in position above sky line): occurring at a time limited by reference to another event) - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "13893",
    "description": "each,every",
    "pos": "WHITE",
    "explanation": "(1 + all: one of all)",
    "isCharacter": false,
    "composition": [
      8497,
      "/",
      12360
    ]
  },
  {
    "id": "13894",
    "description": "ear",
    "pos": "YELLOW",
    "explanation": "(pictograph: symbol suggests a side view of an ear) - Character",
    "isCharacter": true
  },
  {
    "id": "13895",
    "description": "ear_mold",
    "pos": "YELLOW",
    "explanation": "(thing + ear: part of a hearing aid that fits into the ear) - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "13896",
    "description": "early",
    "pos": "GREEN",
    "explanation": "(before + time + description indicator: before the appointed time)",
    "isCharacter": false,
    "composition": [
      12656,
      "/",
      17732,
      ";",
      8998
    ]
  },
  {
    "id": "13897",
    "description": "earmuffs_(protection)",
    "pos": "YELLOW",
    "explanation": "(protection + ear)",
    "isCharacter": false,
    "composition": [
      16420,
      "/",
      13894
    ]
  },
  {
    "id": "13898",
    "description": "earn-(to)",
    "pos": "RED",
    "explanation": "(to work + for (in exchange for) + money: to work in exchange for money)",
    "isCharacter": false,
    "composition": [
      18273,
      ";",
      8993,
      "/",
      14381,
      "/",
      15484
    ]
  },
  {
    "id": "13899",
    "description": "earphones,headphones",
    "pos": "YELLOW",
    "explanation": "(earmuffs_(general) + electricity)",
    "isCharacter": false,
    "composition": [
      24889,
      "/",
      13918
    ]
  },
  {
    "id": "13900",
    "description": "earth,globe,world",
    "pos": "YELLOW",
    "explanation": "(pictograph: symbol suggests the planet rotating on its diagonal axis) - Character",
    "isCharacter": true
  },
  {
    "id": "13901",
    "description": "earth,ground,land",
    "pos": "YELLOW",
    "explanation": "(horizontal line, on the earthline of the symbol drawing area) - Character",
    "isCharacter": true
  },
  {
    "id": "13902",
    "description": "east",
    "pos": "YELLOW",
    "explanation": "(sun + pointer, to east)  - Character (superimposed - pointer)",
    "isCharacter": true
  },
  {
    "id": "13903",
    "description": "easter",
    "pos": "YELLOW",
    "explanation": "(day + to rise + Christ [contraction]: the day of Christ's rising from the dead)",
    "isCharacter": false,
    "composition": [
      13639,
      "/",
      17983,
      "/",
      13613
    ]
  },
  {
    "id": "13904",
    "description": "eastern",
    "pos": "GREEN",
    "explanation": "(east + description indicator)",
    "isCharacter": false,
    "composition": [
      13902,
      ";",
      8998
    ]
  },
  {
    "id": "13905",
    "description": "easy_(OLD)",
    "pos": "GREEN",
    "explanation": "(opposite meaning + difficult + description indicator)  SUPERSEDED SYNONYM  See easy,easily 23861",
    "isCharacter": false,
    "composition": [
      15927,
      "/",
      24884
    ]
  },
  {
    "id": "13906",
    "description": "eat-(to)",
    "pos": "RED",
    "explanation": "(food + action indicator)",
    "isCharacter": false,
    "composition": [
      14377,
      ";",
      8993
    ]
  },
  {
    "id": "13907",
    "description": "edge",
    "pos": "YELLOW",
    "explanation": "(table + pointer, to edge)  - Character (superimposed - pointer)",
    "isCharacter": true
  },
  {
    "id": "13908",
    "description": "education",
    "pos": "YELLOW",
    "explanation": "(to exchange + knowledge)",
    "isCharacter": false,
    "composition": [
      25555,
      "/",
      15162
    ]
  },
  {
    "id": "13909",
    "description": "eel",
    "pos": "YELLOW",
    "explanation": "(fish + snake: snake-like fish)",
    "isCharacter": false,
    "composition": [
      14188,
      "/",
      17189
    ]
  },
  {
    "id": "13910",
    "description": "effect,result",
    "pos": "YELLOW",
    "explanation": "(greater_than_(relation) + pictograph, of imprint: the effect is the imprint left by the wedge-shaped cause) See also: cause 13134. - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "13911",
    "description": "egg,ovum_(1)",
    "pos": "YELLOW",
    "explanation": "(seed + life) SYMBOL SYNONYM",
    "isCharacter": false,
    "composition": [
      16749,
      "/",
      15206
    ]
  },
  {
    "id": "13912",
    "description": "egg,ovum_(2)",
    "pos": "YELLOW",
    "explanation": "(pictograph) SYMBOL SYNONYM - Character",
    "isCharacter": true
  },
  {
    "id": "13913",
    "description": "eggplant,aubergine,brinjal",
    "pos": "YELLOW",
    "explanation": "(vegetable (cylinder-shaped) + purple)",
    "isCharacter": false,
    "composition": [
      18007,
      "/",
      13377,
      "/",
      15666,
      "/",
      17006
    ]
  },
  {
    "id": "13914",
    "description": "either",
    "pos": "WHITE",
    "explanation": "(relation [half-sized], pointing forward + dot: altered form of position in order to represent the meaning “the first alternative”. The dot is within the relation symbol because, as CKB writes, \"We have not decided where to place it.\") - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "13915",
    "description": "ejaculation",
    "pos": "YELLOW",
    "explanation": "ejaculation (erection + sperm + intensity)",
    "isCharacter": false,
    "composition": [
      13944,
      "/",
      17226,
      "/",
      14947
    ]
  },
  {
    "id": "13916",
    "description": "elbow",
    "pos": "YELLOW",
    "explanation": "(arm + pointer, to elbow)  - Character (superimposed - pointer)",
    "isCharacter": true
  },
  {
    "id": "13917",
    "description": "electric,electrical",
    "pos": "GREEN",
    "explanation": "(electricity + description indicator)",
    "isCharacter": false,
    "composition": [
      13918,
      ";",
      8998
    ]
  },
  {
    "id": "13918",
    "description": "electricity",
    "pos": "YELLOW",
    "explanation": "(pictograph: symbol suggests a lightning bolt) - Character",
    "isCharacter": true
  },
  {
    "id": "13919",
    "description": "electric_light,lamp",
    "pos": "YELLOW",
    "explanation": "(light + electricity + thing indicator: object that provides light by means of electricity)",
    "isCharacter": false,
    "composition": [
      15208,
      ";",
      9009,
      "/",
      13918
    ]
  },
  {
    "id": "13920",
    "description": "electric_wheelchair",
    "pos": "YELLOW",
    "explanation": "(wheelchair + electricity)",
    "isCharacter": false,
    "composition": [
      18233,
      "/",
      13918
    ]
  },
  {
    "id": "13921",
    "description": "electric_wire,electric_cord,cord,cable,lead_(OLD)",
    "pos": "YELLOW",
    "explanation": "(linear thing + electricity + thing indicator)",
    "isCharacter": false,
    "composition": [
      15214,
      ";",
      9009,
      "/",
      13918
    ]
  },
  {
    "id": "13922",
    "description": "electromagnetic_radiation",
    "pos": "YELLOW",
    "explanation": "electromagnetic radiation (derived from electricity) - Character",
    "isCharacter": true
  },
  {
    "id": "13923",
    "description": "elephant",
    "pos": "YELLOW",
    "explanation": "(animal + nose: animal distinguished by its nose, i.e., trunk)",
    "isCharacter": false,
    "composition": [
      12378,
      "/",
      15732
    ]
  },
  {
    "id": "13924",
    "description": "elevator,lift",
    "pos": "YELLOW",
    "explanation": "(room + up and down)",
    "isCharacter": false,
    "composition": [
      16687,
      "/",
      20524
    ]
  },
  {
    "id": "13925",
    "description": "Elul",
    "pos": "YELLOW",
    "explanation": "(month + before + shofar: month before Rosh Hashana (Hebrew))",
    "isCharacter": false,
    "composition": [
      15649,
      "/",
      12656,
      "/",
      14895,
      "/",
      17251
    ]
  },
  {
    "id": "13926",
    "description": "embarrassed",
    "pos": "GREEN",
    "explanation": "(embarrassment + description after the fact indicator)",
    "isCharacter": false,
    "composition": [
      13687,
      ";",
      8996,
      "/",
      20524
    ]
  },
  {
    "id": "13927",
    "description": "embarrassing",
    "pos": "GREEN",
    "explanation": "(embarrassment + description indicator)",
    "isCharacter": false,
    "composition": [
      13687,
      ";",
      8998,
      "/",
      20524
    ]
  },
  {
    "id": "13928",
    "description": "embarrassment",
    "pos": "YELLOW",
    "explanation": "(discomfort + up_and_down: also a combination of uncomfortable and upset)",
    "isCharacter": false,
    "composition": [
      13687,
      "/",
      20524
    ]
  },
  {
    "id": "13929",
    "description": "embryo",
    "pos": "YELLOW",
    "explanation": "(body + being_(state_of): an embryo is a potential living being, which cannot live outside the mother's body) - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "13930",
    "description": "emergency",
    "pos": "YELLOW",
    "explanation": "(danger + limited time)",
    "isCharacter": false,
    "composition": [
      13632,
      "/",
      15212
    ]
  },
  {
    "id": "13931",
    "description": "empathy",
    "pos": "YELLOW",
    "explanation": "(feeling + understanding,comprehension)",
    "isCharacter": false,
    "composition": [
      14164,
      "/",
      25629
    ]
  },
  {
    "id": "13932",
    "description": "empty_(OLD)",
    "pos": "GREEN",
    "explanation": "(opposite meaning + full + description indicator)  SUPERSEDED SYNONYM  See empty 23863",
    "isCharacter": false,
    "composition": [
      15927,
      "/",
      24897,
      ";",
      8998
    ]
  },
  {
    "id": "13933",
    "description": "empty-(to)_(OLD)",
    "pos": "RED",
    "explanation": "(empty + action indicator)  SUPERSEDED SYNONYM  See empty,evacuate,throw_away,void-(to) 23864",
    "isCharacter": false,
    "composition": [
      15927,
      "/",
      24897,
      ";",
      8993
    ]
  },
  {
    "id": "13934",
    "description": "enclosure",
    "pos": "YELLOW",
    "explanation": "(pictograph: an enclosed space) - Character",
    "isCharacter": true
  },
  {
    "id": "13935",
    "description": "end,arrival,stop",
    "pos": "YELLOW",
    "explanation": "(forward + reference line: the arrow arrives at the line and stops) - Character",
    "isCharacter": true
  },
  {
    "id": "13936",
    "description": "energy",
    "pos": "YELLOW",
    "explanation": "(sun + electromagnetic radiation: potential energy, as received from the sun) - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "13937",
    "description": "engaged",
    "pos": "GREEN",
    "explanation": "(before + marriage + description indicator)",
    "isCharacter": false,
    "composition": [
      12656,
      "/",
      15425,
      ";",
      8998
    ]
  },
  {
    "id": "13938",
    "description": "enjoy-(to)",
    "pos": "RED",
    "explanation": "(happiness + action indicator)",
    "isCharacter": false,
    "composition": [
      14164,
      ";",
      8993,
      "/",
      17983
    ]
  },
  {
    "id": "13939",
    "description": "enough",
    "pos": "GREEN",
    "explanation": "(minus + more + description indicator: no more needed, i.e.,the right amount or number)",
    "isCharacter": false,
    "composition": [
      15474,
      "/",
      24879,
      ";",
      8998
    ]
  },
  {
    "id": "13940",
    "description": "enter,absorb,insert,penetrate-(to)",
    "pos": "RED",
    "explanation": "(into + action indicator)",
    "isCharacter": false,
    "composition": [
      14952,
      ";",
      8993
    ]
  },
  {
    "id": "13941",
    "description": "envious",
    "pos": "GREEN",
    "explanation": "(to want + comma + other + to have + description indicator: wanting what another person has)",
    "isCharacter": false,
    "composition": [
      14164,
      ";",
      8998,
      "/",
      14183,
      "/",
      8487,
      "/",
      15214,
      "/",
      8498,
      "/",
      24912
    ]
  },
  {
    "id": "13942",
    "description": "environment",
    "pos": "YELLOW",
    "explanation": "(earth + water + sky: complete physical world that surrounds us) - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "13943",
    "description": "equal-(to)",
    "pos": "RED",
    "explanation": "(equal + action indicator)",
    "isCharacter": false,
    "composition": [
      16713,
      ";",
      8993
    ]
  },
  {
    "id": "13944",
    "description": "erection,erect_penis",
    "pos": "YELLOW",
    "explanation": "(standing_(standing_person) + pictograph, of erect penis) - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "13945",
    "description": "eternal_life,immortality_(after_death)",
    "pos": "YELLOW",
    "explanation": "(life + after + death)",
    "isCharacter": false,
    "composition": [
      15206,
      "/",
      12348,
      "/",
      13645
    ]
  },
  {
    "id": "13946",
    "description": "etrog",
    "pos": "YELLOW",
    "explanation": "(pictograph: citrus fruit used as a Jewish ceremonial object (Hebrew)) - Character",
    "isCharacter": true
  },
  {
    "id": "13947",
    "description": "evaluate-(to)",
    "pos": "RED",
    "explanation": "(evaluation + action indicator)",
    "isCharacter": false,
    "composition": [
      13949,
      ";",
      8993
    ]
  },
  {
    "id": "13948",
    "description": "appreciate,value,treasure-(to)",
    "pos": "RED",
    "explanation": "(to evaluate + good + action indicator)",
    "isCharacter": false,
    "composition": [
      13949,
      ";",
      8993,
      "/",
      14164,
      "/",
      12374,
      "/",
      14947
    ]
  },
  {
    "id": "13949",
    "description": "evaluation,value",
    "pos": "YELLOW",
    "explanation": "(symbol represents a cone balancing unsteadily on its point, reminding us that our evaluations are variable and unreliable) - Character",
    "isCharacter": true
  },
  {
    "id": "13950",
    "description": "evening",
    "pos": "YELLOW",
    "explanation": "(moon [modification, upper half] + earth: the moon begins to appear above the horizon) - Character (superimposed - modified)",
    "isCharacter": true
  },
  {
    "id": "14113",
    "description": "evening_before_holiday,evening_of_Sabbath",
    "pos": "YELLOW",
    "explanation": "(evening + before + Sabbath,day_of_rest)",
    "isCharacter": false,
    "composition": [
      13950,
      "/",
      12656,
      "/",
      13639,
      "/",
      16495
    ]
  },
  {
    "id": "14114",
    "description": "event,happening,occasion",
    "pos": "YELLOW",
    "explanation": "(to be + earth [half-sized]: occurrence on earth) - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "14115",
    "description": "ever,whenever",
    "pos": "GREEN",
    "explanation": "(anytime + description indicator)",
    "isCharacter": false,
    "composition": [
      12321,
      "/",
      17732,
      ";",
      8998
    ]
  },
  {
    "id": "14116",
    "description": "evergreen_tree,spruce,fir,fir_tree",
    "pos": "YELLOW",
    "explanation": "(tree + pictograph of spruce branches: pictograph symbol that suggests a spruce or pine tree. The symbol can be used for any tree that does not lose its leaves annually.) - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "14117",
    "description": "everybody,everyone",
    "pos": "WHITE",
    "explanation": "(all + person)",
    "isCharacter": false,
    "composition": [
      12360,
      "/",
      16161
    ]
  },
  {
    "id": "14118",
    "description": "exchange,substitute,trade-(to)",
    "pos": "RED",
    "explanation": "(exchange,substitution + action indicator)",
    "isCharacter": false,
    "composition": [
      25555,
      ";",
      8993
    ]
  },
  {
    "id": "14119",
    "description": "ecstatic",
    "pos": "GREEN",
    "explanation": "(ecstasy + description indicator)",
    "isCharacter": false,
    "composition": [
      14164,
      ";",
      8998,
      "/",
      14947,
      "/",
      14947,
      "/",
      14947
    ]
  },
  {
    "id": "14120",
    "description": "ecstasy",
    "pos": "YELLOW",
    "explanation": "(feeling + three intensity symbols: experiencing very intense feelings)",
    "isCharacter": false,
    "composition": [
      14164,
      "/",
      14947,
      "/",
      14947,
      "/",
      14947
    ]
  },
  {
    "id": "14121",
    "description": "exclude-(to)",
    "pos": "RED",
    "explanation": "(outside + action indicator)",
    "isCharacter": false,
    "composition": [
      15942,
      ";",
      8993
    ]
  },
  {
    "id": "14122",
    "description": "excuse",
    "pos": "YELLOW",
    "explanation": "(to allow + after: condoning of something after it has occurred)",
    "isCharacter": false,
    "composition": [
      24926,
      "/",
      12348
    ]
  },
  {
    "id": "14123",
    "description": "excuse-(to)",
    "pos": "RED",
    "explanation": "(excuse + action indicator)",
    "isCharacter": false,
    "composition": [
      24926,
      ";",
      8993,
      "/",
      12348
    ]
  },
  {
    "id": "14124",
    "description": "exercise,work_out-(to)",
    "pos": "RED",
    "explanation": "(exercise_(physical) + action indicator: to work in order to maintain health)",
    "isCharacter": false,
    "composition": [
      18273,
      ";",
      8993,
      "/",
      14690
    ]
  },
  {
    "id": "14125",
    "description": "exhibitionism,immodesty,indecent_exposure",
    "pos": "YELLOW",
    "explanation": "(to cause + to see + genitals)",
    "isCharacter": false,
    "composition": [
      13134,
      "/",
      14133,
      "/",
      14431
    ]
  },
  {
    "id": "14126",
    "description": "exit-(to)",
    "pos": "RED",
    "explanation": "(out of (forward) + action indicator)",
    "isCharacter": false,
    "composition": [
      15943,
      ";",
      8993
    ]
  },
  {
    "id": "14127",
    "description": "expect,anticipate-(to)",
    "pos": "RED",
    "explanation": "(expectation + action indicator)",
    "isCharacter": false,
    "composition": [
      14128,
      ";",
      8993
    ]
  },
  {
    "id": "14128",
    "description": "expectation,anticipation",
    "pos": "YELLOW",
    "explanation": "(mind + future_(uncertain): thinking about an unknown future) - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "14129",
    "description": "expensive_(OLD)",
    "pos": "GREEN",
    "explanation": "(much + cost + description indicator: costing a lot of money)  SUPERSEDED SYNONYM  See expensive 23080",
    "isCharacter": false,
    "composition": [
      14647,
      "/",
      15484,
      ";",
      8998,
      "/",
      14381,
      "/",
      17717
    ]
  },
  {
    "id": "14130",
    "description": "explain,give_a_reason-(to)",
    "pos": "RED",
    "explanation": "(to say + understanding,comprehension + action indicator: to say something in such a way that another person understands it)",
    "isCharacter": false,
    "composition": [
      15666,
      ";",
      8993,
      "/",
      25629
    ]
  },
  {
    "id": "14131",
    "description": "explode,blow_up,detonate,burst-(to)",
    "pos": "RED",
    "explanation": "(explosion + action indicator)",
    "isCharacter": false,
    "composition": [
      14132,
      ";",
      8993
    ]
  },
  {
    "id": "14132",
    "description": "explosion,detonation,blowup",
    "pos": "YELLOW",
    "explanation": "(thing + four arrows [modification, short arrows], moving outwards)  - Character (superimposed - modified)",
    "isCharacter": true
  },
  {
    "id": "14133",
    "description": "eye",
    "pos": "YELLOW",
    "explanation": "(pictograph: symbol suggests an eye with a pupil in the centre) - Character",
    "isCharacter": true
  },
  {
    "id": "14134",
    "description": "eyebrow",
    "pos": "YELLOW",
    "explanation": "(eye + line [half-sized] + pointer)  - Character (superimposed - pointer)",
    "isCharacter": true
  },
  {
    "id": "14135",
    "description": "eyebrow_pencil",
    "pos": "YELLOW",
    "explanation": "(pencil + eyebrow)",
    "isCharacter": false,
    "composition": [
      15991,
      "/",
      14134
    ]
  },
  {
    "id": "14136",
    "description": "eyelid_(upper)",
    "pos": "YELLOW",
    "explanation": "(eye + pointer, to upper eyelid)  - Character (superimposed - pointer)",
    "isCharacter": true
  },
  {
    "id": "14137",
    "description": "eye_makeup",
    "pos": "YELLOW",
    "explanation": "(colour + plus + eyelid(s): colour added to eyelids and eyelashes)",
    "isCharacter": false,
    "composition": [
      13377,
      "/",
      12374,
      "/",
      25557
    ]
  },
  {
    "id": "14138",
    "description": "face",
    "pos": "YELLOW",
    "explanation": "(head + dot [modification, higher position] + dot [modification, higher position]: pictograph, suggesting a face with mouth, nose and two eyes) - Character (superimposed - modified)",
    "isCharacter": true
  },
  {
    "id": "14139",
    "description": "fact",
    "pos": "YELLOW",
    "explanation": "(mind + real: something that one thinks is real) - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "14140",
    "description": "factory,plant",
    "pos": "YELLOW",
    "explanation": "(building + to make: building where things are manufactured)",
    "isCharacter": false,
    "composition": [
      14905,
      "/",
      23583
    ]
  },
  {
    "id": "14141",
    "description": "falafel",
    "pos": "YELLOW",
    "explanation": "(food + ball + bean: Middle Eastern food made from chick-pea meal and shaped into balls)",
    "isCharacter": false,
    "composition": [
      14377,
      "/",
      12621,
      "/",
      12642
    ]
  },
  {
    "id": "14142",
    "description": "fall-(to)",
    "pos": "RED",
    "explanation": "(fall,drop,spill,tumble + action indicator)",
    "isCharacter": false,
    "composition": [
      13869,
      ";",
      8993,
      "/",
      14947
    ]
  },
  {
    "id": "14143",
    "description": "fallopian_tube",
    "pos": "YELLOW",
    "explanation": "(tube + egg)",
    "isCharacter": false,
    "composition": [
      23926,
      "/",
      13912
    ]
  },
  {
    "id": "14144",
    "description": "family_(traditional)",
    "pos": "BLUE",
    "explanation": "(man + protection + protection + woman: a man and a woman join their roofs to create a family unit. The symbol also can be explained as husband + wife.) SYMBOL SYNONYM - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "14145",
    "description": "family_(cohabiting)",
    "pos": "BLUE",
    "explanation": "(person + protection + person: caring people, i.e., people joined together to protect those in their care) SYMBOL SYNONYM - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "14146",
    "description": "police_force,police",
    "pos": "BLUE",
    "explanation": "(group + protection: group of caring people)  (Note: The similarity between police and parent, and the lacking aspect of law enforcement, can be seen as problematic.)",
    "isCharacter": false,
    "composition": [
      14647,
      "/",
      16161,
      "/",
      16420
    ]
  },
  {
    "id": "14147",
    "description": "family_planning",
    "pos": "YELLOW",
    "explanation": "(plan + conception)",
    "isCharacter": false,
    "composition": [
      16194,
      "/",
      13395
    ]
  },
  {
    "id": "14148",
    "description": "family_planning_clinic",
    "pos": "YELLOW",
    "explanation": "(public room + family planning)",
    "isCharacter": false,
    "composition": [
      16430,
      "/",
      16194,
      "/",
      13395
    ]
  },
  {
    "id": "14149",
    "description": "fan",
    "pos": "YELLOW",
    "explanation": "(pictograph) - Character",
    "isCharacter": true
  },
  {
    "id": "14150",
    "description": "far,distant_(OLD)",
    "pos": "GREEN",
    "explanation": "(farness,remoteness,farawayness_(OLD) + description indicator: a full space between the two lines, the lines are relatively far apart)  SUPERSEDED SYNONYM  See far,distant 26002",
    "isCharacter": false,
    "composition": [
      24896,
      ";",
      8998
    ]
  },
  {
    "id": "14151",
    "description": "farm",
    "pos": "YELLOW",
    "explanation": "(protection + field: place where the fields are cared for) - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "14152",
    "description": "farmer",
    "pos": "BLUE",
    "explanation": "(person + farm: person who farms)",
    "isCharacter": false,
    "composition": [
      16161,
      "/",
      14151
    ]
  },
  {
    "id": "14153",
    "description": "fast_day",
    "pos": "YELLOW",
    "explanation": "(day + without + food)",
    "isCharacter": false,
    "composition": [
      13639,
      "/",
      15474,
      "/",
      14377
    ]
  },
  {
    "id": "14154",
    "description": "fasten,attach,join,append,connect-(to)",
    "pos": "RED",
    "explanation": "(together + action indicator)",
    "isCharacter": false,
    "composition": [
      23409,
      ";",
      8993
    ]
  },
  {
    "id": "14155",
    "description": "fastener,gripper,velcro,zipper",
    "pos": "YELLOW",
    "explanation": "(thing + to fasten + clothing)",
    "isCharacter": false,
    "composition": [
      17717,
      "/",
      23409,
      "/",
      13366
    ]
  },
  {
    "id": "14156",
    "description": "fat,thick_(OLD)",
    "pos": "GREEN",
    "explanation": "(fatness,thickness_(OLD) + description indicator: the pointers point inward to the widest space bounded by the reference lines)  SUPERSEDED SYNONYM  See fat,thick 26003",
    "isCharacter": false,
    "composition": [
      25561,
      ";",
      8998
    ]
  },
  {
    "id": "14157",
    "description": "father,dad,daddy,papa,pa,pop",
    "pos": "BLUE",
    "explanation": "(protection + man: man who gives protection to his family) - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "14158",
    "description": "favourite",
    "pos": "GREEN",
    "explanation": "(to choose + first + description after the fact indicator: one's first choice)",
    "isCharacter": false,
    "composition": [
      13175,
      ";",
      8998,
      "/",
      8497,
      "/",
      8486
    ]
  },
  {
    "id": "14159",
    "description": "fear,be_afraid,dread-(to)",
    "pos": "RED",
    "explanation": "(afraid + action indicator: to feel afraid of the future because of its uncertainties)",
    "isCharacter": false,
    "composition": [
      14164,
      ";",
      8993,
      "/",
      13869,
      "/",
      25568
    ]
  },
  {
    "id": "14160",
    "description": "feather",
    "pos": "YELLOW",
    "explanation": "(part of + wings)",
    "isCharacter": false,
    "composition": [
      15972,
      "/",
      18259
    ]
  },
  {
    "id": "14161",
    "description": "February",
    "pos": "YELLOW",
    "explanation": "(month + 2: second month of the year)",
    "isCharacter": false,
    "composition": [
      15649,
      "/",
      8498
    ]
  },
  {
    "id": "14162",
    "description": "feed-(to)",
    "pos": "RED",
    "explanation": "(to give + food + action indicator)",
    "isCharacter": false,
    "composition": [
      24903,
      ";",
      8993,
      "/",
      14377
    ]
  },
  {
    "id": "14163",
    "description": "feel-(to)",
    "pos": "RED",
    "explanation": "(feeling + action indicator)",
    "isCharacter": false,
    "composition": [
      14164,
      ";",
      8993
    ]
  },
  {
    "id": "14164",
    "description": "feeling,emotion,sensation",
    "pos": "YELLOW",
    "explanation": "(symbol is the familiar heart shape: traditionally one's feelings are supposed to come from the heart. In a few cases, this symbol is used to represent sensation.) - Character",
    "isCharacter": true
  },
  {
    "id": "14165",
    "description": "female,feminine_(person)",
    "pos": "GREEN",
    "explanation": "(woman + description indicator)",
    "isCharacter": false,
    "composition": [
      18269,
      ";",
      8998
    ]
  },
  {
    "id": "14166",
    "description": "female_(gender)",
    "pos": "YELLOW",
    "explanation": "(woman [modification], and also creation [half sized]: this form of woman is used only in compound symbols to specify gender or sex) - Character (modified)",
    "isCharacter": true
  },
  {
    "id": "14167",
    "description": "fence,wall",
    "pos": "YELLOW",
    "explanation": "(building_with_yard_and_fence + pointer, to fence)  - Character (superimposed - pointer)",
    "isCharacter": true
  },
  {
    "id": "14168",
    "description": "fertile",
    "pos": "GREEN",
    "explanation": "(conception + description before the fact indicator: capable of conception)",
    "isCharacter": false,
    "composition": [
      13395,
      ";",
      8997
    ]
  },
  {
    "id": "14169",
    "description": "fertility_counselling",
    "pos": "YELLOW",
    "explanation": "(help + conception)",
    "isCharacter": false,
    "composition": [
      14704,
      "/",
      13395
    ]
  },
  {
    "id": "14170",
    "description": "fetus",
    "pos": "YELLOW",
    "explanation": "(body + baby)  - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "14171",
    "description": "few,little_(OLD)",
    "pos": "GREEN",
    "explanation": "(opposite meaning + much/many + description indicator)  SUPERSEDED SYNONYM  See few,little 24111",
    "isCharacter": false,
    "composition": [
      15927,
      "/",
      14647,
      ";",
      8998
    ]
  },
  {
    "id": "14172",
    "description": "fidelity,loyalty,solidarity",
    "pos": "YELLOW",
    "explanation": "(feeling + attachment)",
    "isCharacter": false,
    "composition": [
      14164,
      "/",
      23409
    ]
  },
  {
    "id": "14173",
    "description": "field",
    "pos": "YELLOW",
    "explanation": "(grain + earth: ground covered with grain or crops)  - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "14174",
    "description": "field_hockey,hockey_(activity)",
    "pos": "YELLOW",
    "explanation": "(activity + sport stick and ball: game played with a stick and a ball)",
    "isCharacter": false,
    "composition": [
      12335,
      "/",
      "RK:-2",
      "/",
      25618
    ]
  },
  {
    "id": "14175",
    "description": "fight,combat-(to)",
    "pos": "RED",
    "explanation": "(fight + action indicator)",
    "isCharacter": false,
    "composition": [
      24855,
      ";",
      8993
    ]
  },
  {
    "id": "14176",
    "description": "fill-(to)",
    "pos": "RED",
    "explanation": "(filling,fill,fullness + action indicator)",
    "isCharacter": false,
    "composition": [
      24897,
      ";",
      8993
    ]
  },
  {
    "id": "14177",
    "description": "film",
    "pos": "YELLOW",
    "explanation": "(cylinder + camera)",
    "isCharacter": false,
    "composition": [
      13115,
      "/",
      13111
    ]
  },
  {
    "id": "14178",
    "description": "finally,at_last",
    "pos": "GREEN",
    "explanation": "(time + last + description indicator)",
    "isCharacter": false,
    "composition": [
      17732,
      ";",
      8998,
      "/",
      15927,
      "/",
      8497,
      "/",
      8486
    ]
  },
  {
    "id": "14179",
    "description": "find-(to)",
    "pos": "RED",
    "explanation": "(eye + hidden thing + action indicator: to see something that was hidden)",
    "isCharacter": false,
    "composition": [
      14133,
      ";",
      8993,
      "/",
      25570
    ]
  },
  {
    "id": "14180",
    "description": "finger",
    "pos": "YELLOW",
    "explanation": "(hand + pointer, to finger)  - Character (superimposed - pointer)",
    "isCharacter": true
  },
  {
    "id": "14181",
    "description": "finish,complete-(to)",
    "pos": "RED",
    "explanation": "(to do + all + action indicator)",
    "isCharacter": false,
    "composition": [
      12335,
      ";",
      8993,
      "/",
      12360
    ]
  },
  {
    "id": "14182",
    "description": "Finland",
    "pos": "YELLOW",
    "explanation": "(country + sauna)",
    "isCharacter": false,
    "composition": [
      13423,
      "/",
      17257,
      "/",
      17267
    ]
  },
  {
    "id": "14183",
    "description": "fire",
    "pos": "YELLOW",
    "explanation": "(symbol looks like a flame, suggesting fire) - Character",
    "isCharacter": true
  },
  {
    "id": "14184",
    "description": "firefighter,fireman",
    "pos": "BLUE",
    "explanation": "(person + extinction,extinguishing (fire): person who puts out fires)",
    "isCharacter": false,
    "composition": [
      16161,
      "/",
      25556
    ]
  },
  {
    "id": "14185",
    "description": "fireplace",
    "pos": "YELLOW",
    "explanation": "(fire + open: opening in which a fire can be built)  - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "14186",
    "description": "fire_truck,fire_engine",
    "pos": "YELLOW",
    "explanation": "(truck + extinction,extinguishing (fire): truck used to put out fires)",
    "isCharacter": false,
    "composition": [
      17781,
      "/",
      25556
    ]
  },
  {
    "id": "14187",
    "description": "first,primary",
    "pos": "GREEN",
    "explanation": "(1 + decimal point + description indicator: the dot indicates an ordinal numeral)",
    "isCharacter": false,
    "composition": [
      8497,
      ";",
      8998,
      "/",
      8486
    ]
  },
  {
    "id": "14188",
    "description": "fish_(animal)",
    "pos": "YELLOW",
    "explanation": "(pictograph: symbol suggests a fish)  - Character",
    "isCharacter": true
  },
  {
    "id": "14189",
    "description": "fish_(food)",
    "pos": "YELLOW",
    "explanation": "(food + fish: food obtained from a fish)",
    "isCharacter": false,
    "composition": [
      14377,
      "/",
      14188
    ]
  },
  {
    "id": "14190",
    "description": "fish-(to)",
    "pos": "RED",
    "explanation": "(fishing + action indicator)",
    "isCharacter": false,
    "composition": [
      24727,
      ";",
      8993,
      "/",
      14188
    ]
  },
  {
    "id": "14191",
    "description": "fishing",
    "pos": "YELLOW",
    "explanation": "(receiving + fish)",
    "isCharacter": false,
    "composition": [
      24727,
      "/",
      14188
    ]
  },
  {
    "id": "14192",
    "description": "fix,mend,repair-(to)",
    "pos": "RED",
    "explanation": "(fixing,fix,mending,mend,repair,reparation + work + action indicator: to make something work again)",
    "isCharacter": false,
    "composition": [
      23583,
      ";",
      8993,
      "/",
      18273
    ]
  },
  {
    "id": "14193",
    "description": "flag",
    "pos": "YELLOW",
    "explanation": "(pictograph: symbol suggests a flag)  - Character",
    "isCharacter": true
  },
  {
    "id": "14194",
    "description": "flame",
    "pos": "YELLOW",
    "explanation": "(part of + fire)",
    "isCharacter": false,
    "composition": [
      15972,
      "/",
      14183
    ]
  },
  {
    "id": "14195",
    "description": "burnable,combustible,ignitable",
    "pos": "GREEN",
    "explanation": "(fire + description before the fact indicator)",
    "isCharacter": false,
    "composition": [
      14183,
      ";",
      8997
    ]
  },
  {
    "id": "14196",
    "description": "flashlight,lantern",
    "pos": "YELLOW",
    "explanation": "(light + hand + thing indicator: portable lamp)",
    "isCharacter": false,
    "composition": [
      15208,
      ";",
      9009,
      "/",
      14667
    ]
  },
  {
    "id": "14197",
    "description": "flat",
    "pos": "GREEN",
    "explanation": "(without + mountain + description indicator)",
    "isCharacter": false,
    "composition": [
      15474,
      "/",
      15663,
      ";",
      8998
    ]
  },
  {
    "id": "14198",
    "description": "flavouring,condiment,seasoning",
    "pos": "YELLOW",
    "explanation": "(addition + taste + thing indicator)",
    "isCharacter": false,
    "composition": [
      12339,
      ";",
      9009,
      "/",
      17506
    ]
  },
  {
    "id": "14199",
    "description": "flea",
    "pos": "YELLOW",
    "explanation": "(louse,stinging_insect + to jump: stinging insect that jumps)",
    "isCharacter": false,
    "composition": [
      14943,
      "/",
      16212,
      "/",
      23550
    ]
  },
  {
    "id": "14200",
    "description": "float-(to)",
    "pos": "RED",
    "explanation": "(floating container + action indicator: container appears to float on water)",
    "isCharacter": false,
    "composition": [
      25562,
      ";",
      8993
    ]
  },
  {
    "id": "14201",
    "description": "flood",
    "pos": "YELLOW",
    "explanation": "(much + water on ground (flooding))",
    "isCharacter": false,
    "composition": [
      14647,
      "/",
      25633
    ]
  },
  {
    "id": "14202",
    "description": "floor",
    "pos": "YELLOW",
    "explanation": "(room + pointer, to floor from underneath)  - Character (superimposed - pointer)",
    "isCharacter": true
  },
  {
    "id": "14203",
    "description": "floor_covering,linoleum",
    "pos": "YELLOW",
    "explanation": "(room + pointer, to floor from above)  - Character (superimposed - pointer)",
    "isCharacter": true
  },
  {
    "id": "14204",
    "description": "flour",
    "pos": "YELLOW",
    "explanation": "(powder + grain: powder made from grain)",
    "isCharacter": false,
    "composition": [
      16233,
      "/",
      14625
    ]
  },
  {
    "id": "14205",
    "description": "flower",
    "pos": "YELLOW",
    "explanation": "(pictograph: symbol suggests a flower)  - Character",
    "isCharacter": true
  },
  {
    "id": "14206",
    "description": "flower_(from_bulb)",
    "pos": "YELLOW",
    "explanation": "(flower + bulb + pointer, to flower)  - Character (superimposed - pointer)",
    "isCharacter": true
  },
  {
    "id": "14369",
    "description": "flower_(protected)",
    "pos": "YELLOW",
    "explanation": "(flower + protection + description after the fact indicator)",
    "isCharacter": false,
    "composition": [
      14205,
      "/",
      16420,
      ";",
      8996
    ]
  },
  {
    "id": "14370",
    "description": "wildflower",
    "pos": "YELLOW",
    "explanation": "(flower + open: uncultivated flower that grows in the open)",
    "isCharacter": false,
    "composition": [
      14205,
      "/",
      15923
    ]
  },
  {
    "id": "14371",
    "description": "fly,flying_insect",
    "pos": "YELLOW",
    "explanation": "(insect + to fly)  - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "14372",
    "description": "fly-(to)",
    "pos": "RED",
    "explanation": "(wings + action indicator)",
    "isCharacter": false,
    "composition": [
      18259,
      ";",
      8993
    ]
  },
  {
    "id": "14373",
    "description": "flying",
    "pos": "GREEN",
    "explanation": "(wings + description indicator)",
    "isCharacter": false,
    "composition": [
      18259,
      ";",
      8998
    ]
  },
  {
    "id": "14374",
    "description": "fog",
    "pos": "YELLOW",
    "explanation": "(sky + water: formation of water droplets below the sky)  - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "14375",
    "description": "fold,pleat-(to)",
    "pos": "RED",
    "explanation": "(fold,folding,pleating + action indicator)",
    "isCharacter": false,
    "composition": [
      25564,
      ";",
      8993
    ]
  },
  {
    "id": "14376",
    "description": "follow-(to)_(OLD)",
    "pos": "RED",
    "explanation": "(opposite meaning + to lead + action indicator)  SUPERSEDED SYNONYM  See follow-(to) 21053",
    "isCharacter": false,
    "composition": [
      15927,
      "/",
      22913,
      ";",
      8993
    ]
  },
  {
    "id": "14377",
    "description": "food",
    "pos": "YELLOW",
    "explanation": "(mouth + earth [half-sized]: what the mouth gets from the earth)  - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "14378",
    "description": "food_ball",
    "pos": "YELLOW",
    "explanation": "(food + ball: food shaped into a ball)",
    "isCharacter": false,
    "composition": [
      14377,
      "/",
      12621
    ]
  },
  {
    "id": "14379",
    "description": "foot",
    "pos": "YELLOW",
    "explanation": "foot (legs and feet + pointer, to foot)  - Character (superimposed - pointer)",
    "isCharacter": true
  },
  {
    "id": "14380",
    "description": "football,soccer_(activity)",
    "pos": "YELLOW",
    "explanation": "(activity + ball + legs and feet: game in which legs and feet are used to move the ball)",
    "isCharacter": false,
    "composition": [
      12335,
      "/",
      12621,
      "/",
      15189
    ]
  },
  {
    "id": "14381",
    "description": "for_(in_exchange_for),instead",
    "pos": "WHITE",
    "explanation": "(to exchange [modification]) - Character (modified)",
    "isCharacter": true
  },
  {
    "id": "14382",
    "description": "for_(the_purpose_of),in_order_to",
    "pos": "WHITE",
    "explanation": "(purpose [half-sized])  - Character",
    "isCharacter": true
  },
  {
    "id": "14383",
    "description": "forced,compelled,obliged",
    "pos": "GREEN",
    "explanation": "(must (a) + description indicator)",
    "isCharacter": false,
    "composition": [
      22914,
      ";",
      8998
    ]
  },
  {
    "id": "14384",
    "description": "forehead",
    "pos": "YELLOW",
    "explanation": "(face + pointer, to forehead)  - Character (superimposed - pointer)",
    "isCharacter": true
  },
  {
    "id": "14385",
    "description": "foreskin",
    "pos": "YELLOW",
    "explanation": "(protection + penis [contraction])",
    "isCharacter": false,
    "composition": [
      16420,
      "/",
      15417
    ]
  },
  {
    "id": "14386",
    "description": "forest,bush,wood,woods",
    "pos": "YELLOW",
    "explanation": "(many + many + trees: large group of trees)",
    "isCharacter": false,
    "composition": [
      14647,
      "/",
      14647,
      "/",
      17775
    ]
  },
  {
    "id": "14387",
    "description": "forget-(to)",
    "pos": "RED",
    "explanation": "(forgetting,amnesia + action indicator)",
    "isCharacter": false,
    "composition": [
      24899,
      ";",
      8993
    ]
  },
  {
    "id": "14388",
    "description": "forgive,pardon-(to)",
    "pos": "RED",
    "explanation": "(permission,allowance_(moral) + after + action indicator: to give moral permission for a misdeed after it is done)",
    "isCharacter": false,
    "composition": [
      25593,
      ";",
      8993,
      "/",
      12348
    ]
  },
  {
    "id": "14389",
    "description": "fork",
    "pos": "YELLOW",
    "explanation": "(pictograph: symbol suggests a fork. The diagonal orientation of fork is the same as that of spoon and knife.)  - Character",
    "isCharacter": true
  },
  {
    "id": "14390",
    "description": "forward",
    "pos": "WHITE",
    "explanation": "(arrow, pointing forward)  - Character",
    "isCharacter": true
  },
  {
    "id": "14391",
    "description": "foster_mother",
    "pos": "BLUE",
    "explanation": "(woman + similar + mother: woman who acts as a mother)",
    "isCharacter": false,
    "composition": [
      18269,
      "/",
      25586,
      "/",
      16713,
      "/",
      15662
    ]
  },
  {
    "id": "14392",
    "description": "foster_parent",
    "pos": "BLUE",
    "explanation": "(similar + parent: unrelated person who cares for a child like a parent)",
    "isCharacter": false,
    "composition": [
      25586,
      "/",
      16713,
      "/",
      15968
    ]
  },
  {
    "id": "14393",
    "description": "four_o'clock_eating_break",
    "pos": "YELLOW",
    "explanation": "(food + time + 4: break for eating at four o’clock)",
    "isCharacter": false,
    "composition": [
      14377,
      "/",
      17732,
      "/",
      8500
    ]
  },
  {
    "id": "14394",
    "description": "fox,jackal,coyote",
    "pos": "YELLOW",
    "explanation": "(canine + little + open: small, wild animal similar to a dog)",
    "isCharacter": false,
    "composition": [
      12380,
      "/",
      24917,
      "/",
      15923
    ]
  },
  {
    "id": "14395",
    "description": "free,freely",
    "pos": "GREEN",
    "explanation": "(freedom + description indicator)",
    "isCharacter": false,
    "composition": [
      14396,
      ";",
      8998
    ]
  },
  {
    "id": "14396",
    "description": "freedom,liberty",
    "pos": "YELLOW",
    "explanation": "(feeling + open: feeling of being unconfined)  - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "14397",
    "description": "freeze,solidify-(to)",
    "pos": "RED",
    "explanation": "(freezing,hardening,solidifying + action indicator: to convert water to solid ice)",
    "isCharacter": false,
    "composition": [
      25565,
      ";",
      8993
    ]
  },
  {
    "id": "14398",
    "description": "French_fries,chips_(OLD)",
    "pos": "YELLOW",
    "explanation": "(potato + linear thing + plural indicator + thing indicator: potatoes cut in strips)  SUPERSEDED SYNONYM  See French_fries,chips 24657",
    "isCharacter": false,
    "composition": [
      18005,
      ";",
      9011,
      "/",
      13377,
      "/",
      17192,
      "/",
      15214,
      ";",
      9009
    ]
  },
  {
    "id": "14399",
    "description": "fresh",
    "pos": "GREEN",
    "explanation": "(taste + new + description indicator)",
    "isCharacter": false,
    "composition": [
      17506,
      ";",
      8998,
      "/",
      25587
    ]
  },
  {
    "id": "14400",
    "description": "Friday_(OLD)",
    "pos": "YELLOW",
    "explanation": "(day + 6: sixth day of the week - based on the convention of Sunday being the first)  SUPERSEDED SYNONYM  See Friday_(day5) 25064, Friday_(day6) 25065, Friday_(day7) 25066",
    "isCharacter": false,
    "composition": [
      13639,
      "/",
      8502
    ]
  },
  {
    "id": "14401",
    "description": "friend",
    "pos": "BLUE",
    "explanation": "(person + to like: person whom one likes)",
    "isCharacter": false,
    "composition": [
      16161,
      "/",
      14164,
      "/",
      12374,
      "/",
      14947
    ]
  },
  {
    "id": "14402",
    "description": "frog,toad",
    "pos": "YELLOW",
    "explanation": "(amphibian + to jump: amphibian that hops)",
    "isCharacter": false,
    "composition": [
      12378,
      "/",
      25633,
      "/",
      23550
    ]
  },
  {
    "id": "14403",
    "description": "from",
    "pos": "WHITE",
    "explanation": "(reference line [half-sized] + arrowhead: the arrowhead departs from the reference line. This symbol is a simplified form of departure.)  - Character (sequenced)",
    "isCharacter": true
  },
  {
    "id": "14404",
    "description": "food_(frozen)",
    "pos": "YELLOW",
    "explanation": "(food + ice)",
    "isCharacter": false,
    "composition": [
      14377,
      "/",
      14919
    ]
  },
  {
    "id": "14405",
    "description": "fruit",
    "pos": "YELLOW",
    "explanation": "(pictograph: symbol suggests a piece of fruit with a curved stem, in the position it would have if hanging from a tree)  - Character",
    "isCharacter": true
  },
  {
    "id": "14406",
    "description": "fruit_juice,juice",
    "pos": "YELLOW",
    "explanation": "(drink + fruit)",
    "isCharacter": false,
    "composition": [
      13881,
      "/",
      14405
    ]
  },
  {
    "id": "14407",
    "description": "fruit_yogurt,fruit_yoghurt",
    "pos": "YELLOW",
    "explanation": "(yogurt + fruit)",
    "isCharacter": false,
    "composition": [
      14377,
      "/",
      13881,
      "/",
      15206,
      "/",
      14405
    ]
  },
  {
    "id": "14408",
    "description": "frustrated",
    "pos": "GREEN",
    "explanation": "(frustration + description after the fact indicator)",
    "isCharacter": false,
    "composition": [
      14164,
      ";",
      8996,
      "/",
      25545
    ]
  },
  {
    "id": "14409",
    "description": "frustrating",
    "pos": "GREEN",
    "explanation": "(frustration + description indicator)",
    "isCharacter": false,
    "composition": [
      14164,
      ";",
      8998,
      "/",
      25545
    ]
  },
  {
    "id": "14410",
    "description": "frustration",
    "pos": "YELLOW",
    "explanation": "(feeling + adversity,hardship,setback)",
    "isCharacter": false,
    "composition": [
      14164,
      "/",
      25545
    ]
  },
  {
    "id": "14411",
    "description": "fry,saute-(to)",
    "pos": "RED",
    "explanation": "(to cook + oil + action indicator: to cook with oil or fat)",
    "isCharacter": false,
    "composition": [
      14183,
      ";",
      8993,
      "/",
      14377,
      "/",
      15914
    ]
  },
  {
    "id": "14412",
    "description": "fuel",
    "pos": "YELLOW",
    "explanation": "(energy + enclosure: energy that can be put into an enclosure and used to power something)  - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "14413",
    "description": "full",
    "pos": "GREEN",
    "explanation": "(filling,fill,fullness + description indicator)",
    "isCharacter": false,
    "composition": [
      24897,
      ";",
      8998
    ]
  },
  {
    "id": "14414",
    "description": "funny,humorous",
    "pos": "GREEN",
    "explanation": "(laugh,laughter + description indicator: causing laughter)",
    "isCharacter": false,
    "composition": [
      14164,
      ";",
      8998,
      "/",
      17983,
      "/",
      15666
    ]
  },
  {
    "id": "14415",
    "description": "fur,coat_(animal),hair_(animal)",
    "pos": "YELLOW",
    "explanation": "(furred_animal + pointer, to hair: hair protecting the skin of an animal)  - Character (superimposed - pointer)",
    "isCharacter": true
  },
  {
    "id": "14416",
    "description": "furniture",
    "pos": "YELLOW",
    "explanation": "(generalization + chair + table: two common pieces of furniture stand for furniture in general)",
    "isCharacter": false,
    "composition": [
      14430,
      "/",
      13148,
      "/",
      17493
    ]
  },
  {
    "id": "14417",
    "description": "future",
    "pos": "YELLOW",
    "explanation": "(outline of parabolic mirror focused on what lies ahead of it)  - Character",
    "isCharacter": true
  },
  {
    "id": "14418",
    "description": "game",
    "pos": "YELLOW",
    "explanation": "(competition + to enjoy)",
    "isCharacter": false,
    "composition": [
      16451,
      "/",
      14164,
      "/",
      17983
    ]
  },
  {
    "id": "14419",
    "description": "Ganesh",
    "pos": "BLUE",
    "explanation": "(god + elephant: Hindu god) (India)",
    "isCharacter": false,
    "composition": [
      14451,
      "/",
      12378,
      "/",
      15732
    ]
  },
  {
    "id": "14420",
    "description": "garage",
    "pos": "YELLOW",
    "explanation": "(building + vehicle [modification]: the two wheels representing a modified vehicle, building for vehicles) - Character (superimposed - modified)",
    "isCharacter": true
  },
  {
    "id": "14421",
    "description": "garbage_can,rubbish_bin,trash_can",
    "pos": "YELLOW",
    "explanation": "(container + waste)  - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "14422",
    "description": "garden",
    "pos": "YELLOW",
    "explanation": "(flower + earth: place with flowers)  - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "14423",
    "description": "garlic",
    "pos": "YELLOW",
    "explanation": "(onion,vegetable_(bulb) + smell + intensity: bulb vegetable having a strong odour)",
    "isCharacter": false,
    "composition": [
      18006,
      "/",
      17017,
      "/",
      14947
    ]
  },
  {
    "id": "14424",
    "description": "gas",
    "pos": "YELLOW",
    "explanation": "(up + pictograph of a bubble: symbol suggests a gas bubble rising upward)  - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "14425",
    "description": "gasoline,gas,petrol",
    "pos": "YELLOW",
    "explanation": "(liquid + wheel: liquid that powers machinery and vehicles)",
    "isCharacter": false,
    "composition": [
      18209,
      "/",
      18232
    ]
  },
  {
    "id": "14426",
    "description": "gather,assemble-(to)",
    "pos": "RED",
    "explanation": "(gathering + action indicator)",
    "isCharacter": false,
    "composition": [
      14427,
      ";",
      8993
    ]
  },
  {
    "id": "14427",
    "description": "gathering,assembly,meeting,conference",
    "pos": "YELLOW",
    "explanation": "(four arrows [modification], pointing inward towards each other, i.e., gathering together) - Character (modified)",
    "isCharacter": true
  },
  {
    "id": "14428",
    "description": "gender,sex",
    "pos": "YELLOW",
    "explanation": "(male + female: having either a male or female gender)  - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "14429",
    "description": "indefinite",
    "pos": "GREEN",
    "explanation": "(a + description indicator)",
    "isCharacter": false,
    "composition": [
      12321,
      ";",
      8998
    ]
  },
  {
    "id": "14430",
    "description": "generalization",
    "pos": "YELLOW",
    "explanation": "(mouth + many: what one says to characterize many things: CKB describes this symbol as \"a saying about a multitude\".)  - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "14431",
    "description": "genitals,sex_organs",
    "pos": "YELLOW",
    "explanation": "(standing person + pointer, to genital area)  - Character (superimposed - pointer)",
    "isCharacter": true
  },
  {
    "id": "14432",
    "description": "genitals,sex_organs_(female)",
    "pos": "YELLOW",
    "explanation": "(genitals + female)",
    "isCharacter": false,
    "composition": [
      14431,
      "/",
      14166
    ]
  },
  {
    "id": "14433",
    "description": "genitals,sex_organs_(male)",
    "pos": "YELLOW",
    "explanation": "(genitals + male)",
    "isCharacter": false,
    "composition": [
      14431,
      "/",
      12335
    ]
  },
  {
    "id": "14434",
    "description": "gerbil,guinea_pig,hamster",
    "pos": "YELLOW",
    "explanation": "(rodent + feeling: combination of rodent and pet, rodent often kept as a pet)",
    "isCharacter": false,
    "composition": [
      12378,
      "/",
      17517,
      "/",
      14164
    ]
  },
  {
    "id": "14435",
    "description": "get,acquire,receive-(to)",
    "pos": "RED",
    "explanation": "(receiving + action indicator: to draw into what one holds)",
    "isCharacter": false,
    "composition": [
      24727,
      ";",
      8993
    ]
  },
  {
    "id": "14436",
    "description": "ghost_(OLD)",
    "pos": "BLUE",
    "explanation": "(person + transparent: person that you can see through)  SUPERSEDED SYNONYM  See ghost,phantom 23520",
    "isCharacter": false,
    "composition": [
      16161,
      "/",
      14133,
      "/",
      17724
    ]
  },
  {
    "id": "14437",
    "description": "gift,offering,present",
    "pos": "YELLOW",
    "explanation": "(thing + giving: thing that is given)",
    "isCharacter": false,
    "composition": [
      17717,
      "/",
      24903
    ]
  },
  {
    "id": "14438",
    "description": "giraffe",
    "pos": "YELLOW",
    "explanation": "(animal + pictograph of head and long neck) - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "14439",
    "description": "girl",
    "pos": "BLUE",
    "explanation": "(child + female (combination)) - Character (superimposed - combined)",
    "isCharacter": true
  },
  {
    "id": "14440",
    "description": "give,offer,provide-(to)",
    "pos": "RED",
    "explanation": "(giving + action indicator: to draw from what one holds)",
    "isCharacter": false,
    "composition": [
      24903,
      ";",
      8993
    ]
  },
  {
    "id": "14441",
    "description": "glass_material",
    "pos": "YELLOW",
    "explanation": "(material + glass: material of which drinking glasses are made)",
    "isCharacter": false,
    "composition": [
      15431,
      "/",
      14442
    ]
  },
  {
    "id": "14442",
    "description": "glass,drinking_glass",
    "pos": "YELLOW",
    "explanation": "(pictograph: symbol suggests a drinking glass)  - Character",
    "isCharacter": true
  },
  {
    "id": "14443",
    "description": "glasses,eyeglasses",
    "pos": "YELLOW",
    "explanation": "(pictograph: symbol suggests a pair of glasses and incorporates two eye symbols)  - Character",
    "isCharacter": true
  },
  {
    "id": "14444",
    "description": "glassware",
    "pos": "YELLOW",
    "explanation": "(generalization + glass)",
    "isCharacter": false,
    "composition": [
      14430,
      "/",
      14442
    ]
  },
  {
    "id": "14445",
    "description": "sports_glove,glove,mitt",
    "pos": "YELLOW",
    "explanation": "(glove + receiving: combination of glove and to catch, glove for use when catching a ball)",
    "isCharacter": false,
    "composition": [
      16420,
      "/",
      14667,
      "/",
      24727
    ]
  },
  {
    "id": "14446",
    "description": "glove(s),mitt(s),mitten(s)",
    "pos": "YELLOW",
    "explanation": "(protection + hand: protective covering for the hand)",
    "isCharacter": false,
    "composition": [
      16420,
      "/",
      14667
    ]
  },
  {
    "id": "14447",
    "description": "glue,adhesive,paste",
    "pos": "YELLOW",
    "explanation": "(chemical product + attachment: chemical product to fasten)",
    "isCharacter": false,
    "composition": [
      13158,
      "/",
      23409
    ]
  },
  {
    "id": "14448",
    "description": "glue,paste,stick-(to)",
    "pos": "RED",
    "explanation": "(glue + action indicator)",
    "isCharacter": false,
    "composition": [
      13158,
      ";",
      8993,
      "/",
      23409
    ]
  },
  {
    "id": "14449",
    "description": "go,depart,leave-(to)",
    "pos": "RED",
    "explanation": "(departure + action indicator)",
    "isCharacter": false,
    "composition": [
      13658,
      ";",
      8993
    ]
  },
  {
    "id": "14450",
    "description": "goal",
    "pos": "YELLOW",
    "explanation": "(door + ball: also a pictograph where the symbol suggests a goal with a ball in it)  - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "14451",
    "description": "God",
    "pos": "BLUE",
    "explanation": "(creation + creation [modification, on a higher level]: above our created world is a higher Creator)  - Character (superimposed - modified)",
    "isCharacter": true
  },
  {
    "id": "14452",
    "description": "goldfish,guppy,pet_fish",
    "pos": "YELLOW",
    "explanation": "(fish + feeling: fish frequently kept as a pet)",
    "isCharacter": false,
    "composition": [
      14188,
      "/",
      14164
    ]
  },
  {
    "id": "14453",
    "description": "golf_(activity)",
    "pos": "YELLOW",
    "explanation": "(activity + sport stick and ball + container_(low): game in which a stick is used to propel the ball into a hole)",
    "isCharacter": false,
    "composition": [
      12335,
      "/",
      "RK:-2",
      "/",
      25618,
      "/",
      25536
    ]
  },
  {
    "id": "14454",
    "description": "goodbye,farewell",
    "pos": "GRAY",
    "explanation": "(mouth + parting: what you say when you part from someone)",
    "isCharacter": false,
    "composition": [
      15666,
      "/",
      25592
    ]
  },
  {
    "id": "14455",
    "description": "Good_Friday",
    "pos": "YELLOW",
    "explanation": "(day + death + Christ [contraction]: day Christ died on the cross)",
    "isCharacter": false,
    "composition": [
      13639,
      "/",
      13645,
      "/",
      13613
    ]
  },
  {
    "id": "14456",
    "description": "goodness",
    "pos": "YELLOW",
    "explanation": "(feeling + positive)",
    "isCharacter": false,
    "composition": [
      14164,
      "/",
      12374,
      "/",
      14947
    ]
  },
  {
    "id": "14457",
    "description": "goods,contents",
    "pos": "YELLOW",
    "explanation": "(container + thing)  - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "14458",
    "description": "goose_(bird)",
    "pos": "YELLOW",
    "explanation": "(water bird + big)",
    "isCharacter": false,
    "composition": [
      12840,
      "/",
      24875
    ]
  },
  {
    "id": "14459",
    "description": "goose_(food)",
    "pos": "YELLOW",
    "explanation": "(food + goose)",
    "isCharacter": false,
    "composition": [
      14377,
      "/",
      12840,
      "/",
      24875
    ]
  },
  {
    "id": "14460",
    "description": "gopher,ground_hog",
    "pos": "YELLOW",
    "explanation": "(rodent + hole: rodent that lives in a burrow underground)",
    "isCharacter": false,
    "composition": [
      12378,
      "/",
      17517,
      "/",
      14883
    ]
  },
  {
    "id": "14461",
    "description": "govern,rule-(to)",
    "pos": "RED",
    "explanation": "(to lead + country + action indicator: to lead a country)",
    "isCharacter": false,
    "composition": [
      22913,
      ";",
      8993,
      "/",
      13423
    ]
  },
  {
    "id": "14462",
    "description": "government_(OLD)",
    "pos": "YELLOW",
    "explanation": "(group + leadership + country)  SUPERSEDED SYNONYM  See government 24812",
    "isCharacter": false,
    "composition": [
      14647,
      "/",
      16161,
      "/",
      22913,
      "/",
      13423
    ]
  },
  {
    "id": "14463",
    "description": "good,well,fine,ok,okay,all_right",
    "pos": "GREEN",
    "explanation": "(goodness + description indicator: felt to be positive or good in an emotional sense)",
    "isCharacter": false,
    "composition": [
      14164,
      ";",
      8998,
      "/",
      12374,
      "/",
      14947
    ]
  },
  {
    "id": "14625",
    "description": "grain,cereal",
    "pos": "YELLOW",
    "explanation": "(grass + grass: pictograph where symbol suggests two stalks of grain.)  - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "14626",
    "description": "grandfather,granddad,grandpa",
    "pos": "BLUE",
    "explanation": "(father + parent: father of one's father or mother)  - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "14627",
    "description": "grandfather_(maternal)",
    "pos": "BLUE",
    "explanation": "(father + mother: father of one’s mother)  - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "14628",
    "description": "grandfather_(paternal)",
    "pos": "BLUE",
    "explanation": "(father + father: father of one’s father)  - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "14629",
    "description": "grandmother,grandma,granny",
    "pos": "BLUE",
    "explanation": "(mother + parent: mother of one's father or mother)  - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "14630",
    "description": "grandmother_(maternal)",
    "pos": "BLUE",
    "explanation": "(mother + mother: mother of one’s mother)  - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "14631",
    "description": "grandmother_(paternal)",
    "pos": "BLUE",
    "explanation": "(mother + father: mother of one’s  father)  - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "14632",
    "description": "grandparent",
    "pos": "BLUE",
    "explanation": "(parent + parent: the parent of one's father or mother)  - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "14633",
    "description": "grape_juice",
    "pos": "YELLOW",
    "explanation": "(drink + grape,grapes)",
    "isCharacter": false,
    "composition": [
      13881,
      "/",
      14635
    ]
  },
  {
    "id": "14634",
    "description": "grapefruit",
    "pos": "YELLOW",
    "explanation": "(citrus fruit + big)",
    "isCharacter": false,
    "composition": [
      15933,
      "/",
      24875
    ]
  },
  {
    "id": "14635",
    "description": "grape,grapes",
    "pos": "YELLOW",
    "explanation": "(pictograph: symbol suggests a cluster of grapes hanging from a stem)  - Character",
    "isCharacter": true
  },
  {
    "id": "14636",
    "description": "grass",
    "pos": "YELLOW",
    "explanation": "(pictograph: symbol suggests a blade of grass)  - Character",
    "isCharacter": true
  },
  {
    "id": "14637",
    "description": "grasshopper",
    "pos": "YELLOW",
    "explanation": "(insect + to jump)",
    "isCharacter": false,
    "composition": [
      14943,
      "/",
      23550
    ]
  },
  {
    "id": "14638",
    "description": "grave",
    "pos": "YELLOW",
    "explanation": "(earth + reclining,lying_(person_lying_down) [modification, under earthline]: place of rest below the earth)  - Character (superimposed - modified)",
    "isCharacter": true
  },
  {
    "id": "14639",
    "description": "gray,grey",
    "pos": "WHITE",
    "explanation": "(colour + night + snow: combination of black and white)",
    "isCharacter": false,
    "composition": [
      13377,
      "/",
      15719,
      "/",
      17192
    ]
  },
  {
    "id": "14640",
    "description": "great_experience",
    "pos": "YELLOW",
    "explanation": "(good + intensity: intensely good feeling)",
    "isCharacter": false,
    "composition": [
      14164,
      "/",
      12374,
      "/",
      14947,
      "/",
      14947
    ]
  },
  {
    "id": "14641",
    "description": "green_(bci)",
    "pos": "WHITE",
    "explanation": "(colour + grass) (BCI) SYMBOL SYNONYM",
    "isCharacter": false,
    "composition": [
      13377,
      "/",
      14636
    ]
  },
  {
    "id": "14642",
    "description": "green_(ckb)",
    "pos": "WHITE",
    "explanation": "(colour + 4) (CKB) SYMBOL SYNONYM",
    "isCharacter": false,
    "composition": [
      13377,
      "/",
      8500
    ]
  },
  {
    "id": "14643",
    "description": "greenhouse,glasshouse,hothouse",
    "pos": "YELLOW",
    "explanation": "(building + plant: building for cultivating plants)",
    "isCharacter": false,
    "composition": [
      14905,
      "/",
      16196
    ]
  },
  {
    "id": "14644",
    "description": "green_onion,scallion,spring_onion",
    "pos": "YELLOW",
    "explanation": "(onion + little)",
    "isCharacter": false,
    "composition": [
      18006,
      "/",
      24917
    ]
  },
  {
    "id": "14645",
    "description": "grocery_store,food_store,supermarket_(OLD)",
    "pos": "YELLOW",
    "explanation": "(store (OLD) + food)  SUPERSEDED SYNONYM  See grocery_store,food_store,supermarket 23102",
    "isCharacter": false,
    "composition": [
      16430,
      "/",
      13093,
      "/",
      14377
    ]
  },
  {
    "id": "14646",
    "description": "group_(people)",
    "pos": "BLUE",
    "explanation": "(group of + person: a number of people considered together)",
    "isCharacter": false,
    "composition": [
      14647,
      "/",
      16161
    ]
  },
  {
    "id": "14647",
    "description": "group_of,much_of,many_of,quantity_of",
    "pos": "YELLOW",
    "explanation": "(multiplication [half-sized]: used before another symbol to create a collective or quantitative meaning)  - Character",
    "isCharacter": true
  },
  {
    "id": "14648",
    "description": "grove",
    "pos": "YELLOW",
    "explanation": "(group of + tree)",
    "isCharacter": false,
    "composition": [
      14647,
      "/",
      17775
    ]
  },
  {
    "id": "14649",
    "description": "grow-(to)",
    "pos": "RED",
    "explanation": "(growth,growing + action indicator: to come up as flowers do. CKB says that this symbol applies primarily to agriculture and horticulture, but that it may be used in a general sense, such as \"children grow up\".)",
    "isCharacter": false,
    "composition": [
      14205,
      ";",
      8993,
      "/",
      17983
    ]
  },
  {
    "id": "14650",
    "description": "guard_duty",
    "pos": "YELLOW",
    "explanation": "(limited time + person + to watch)",
    "isCharacter": false,
    "composition": [
      15212,
      "/",
      16161,
      "/",
      24949,
      "/",
      14947
    ]
  },
  {
    "id": "14651",
    "description": "guess,estimate-(to)",
    "pos": "RED",
    "explanation": "(doubt + plus minus + action indicator: to reason on the basis of information of uncertain accuracy)",
    "isCharacter": false,
    "composition": [
      22911,
      ";",
      8993,
      "/",
      25595
    ]
  },
  {
    "id": "14652",
    "description": "guilt",
    "pos": "YELLOW",
    "explanation": "(judgement + negative: the mind weighs something and judges it to be negative)",
    "isCharacter": false,
    "composition": [
      23127,
      "/",
      15474,
      "/",
      14947
    ]
  },
  {
    "id": "14653",
    "description": "guilty",
    "pos": "GREEN",
    "explanation": "(guilt + description indicator)",
    "isCharacter": false,
    "composition": [
      23127,
      ";",
      8998,
      "/",
      15474,
      "/",
      14947
    ]
  },
  {
    "id": "14654",
    "description": "gull,seagull,sea_gull",
    "pos": "YELLOW",
    "explanation": "(water bird + waste: water bird that feeds on refuse, a scavenger)",
    "isCharacter": false,
    "composition": [
      12840,
      "/",
      18043
    ]
  },
  {
    "id": "14655",
    "description": "gun,firearm",
    "pos": "YELLOW",
    "explanation": "(pictograph: symbol suggests a gun with a trigger area)  - Character",
    "isCharacter": true
  },
  {
    "id": "14656",
    "description": "gym,gymnasium_(OLD)",
    "pos": "YELLOW",
    "explanation": "(room + activity + health: room for activity that keeps one healthy)  SUPERSEDED SYNONYM  See gym,gymnasium 26005",
    "isCharacter": false,
    "composition": [
      16687,
      "/",
      12335,
      "/",
      14690
    ]
  },
  {
    "id": "14657",
    "description": "gym_mat_(OLD)",
    "pos": "YELLOW",
    "explanation": "(floor covering + sport (OLD): floor covering used for sports)  SUPERSEDED SYNONYM  See gym_mat 26006",
    "isCharacter": false,
    "composition": [
      14203,
      "/",
      12335,
      "/",
      14690
    ]
  },
  {
    "id": "14658",
    "description": "Haggadah",
    "pos": "YELLOW",
    "explanation": "(book + Passover: book used at Passover ceremonial meal (Hebrew))",
    "isCharacter": false,
    "composition": [
      12875,
      "/",
      8503,
      "/",
      13639,
      "/",
      12895,
      "/",
      24918
    ]
  },
  {
    "id": "14659",
    "description": "hail",
    "pos": "YELLOW",
    "explanation": "(ice + down: ice particles that fall down from the sky)  - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "14660",
    "description": "hair",
    "pos": "YELLOW",
    "explanation": "(pictograph: used only in association with a body part or animal symbol)  - Character (sequenced)",
    "isCharacter": true
  },
  {
    "id": "14661",
    "description": "hair_(head)",
    "pos": "YELLOW",
    "explanation": "(head_with_hair + pointer, to hair)  - Character (superimposed - pointer)",
    "isCharacter": true
  },
  {
    "id": "14662",
    "description": "Halloween_(OLD)",
    "pos": "YELLOW",
    "explanation": "(day + ghost (OLD): day for ghosts)  SUPERSEDED SYNONYM  See Halloween 26007",
    "isCharacter": false,
    "composition": [
      13639,
      "/",
      16161,
      "/",
      14133,
      "/",
      17724
    ]
  },
  {
    "id": "14663",
    "description": "halva,halvah,halwa",
    "pos": "YELLOW",
    "explanation": "(food + sweet + grain: Middle Eastern sweet)",
    "isCharacter": false,
    "composition": [
      14377,
      "/",
      17506,
      "/",
      17983,
      "/",
      14625
    ]
  },
  {
    "id": "14664",
    "description": "hamburger_(OLD)",
    "pos": "YELLOW",
    "explanation": "(roll + meat)  SUPERSEDED SYNONYM  See hamburger 20770",
    "isCharacter": false,
    "composition": [
      16683,
      "/",
      14377,
      "/",
      12378
    ]
  },
  {
    "id": "14665",
    "description": "hamentasch",
    "pos": "YELLOW",
    "explanation": "(cookie + ear: cookie shaped like an ear, eaten on Purim (Hebrew))",
    "isCharacter": false,
    "composition": [
      13685,
      "/",
      17506,
      "/",
      17983,
      "/",
      13894
    ]
  },
  {
    "id": "14666",
    "description": "hammer,gavel,mallet",
    "pos": "YELLOW",
    "explanation": "(pictograph: symbol looks like a hammer ready to strike)  - Character",
    "isCharacter": true
  },
  {
    "id": "14667",
    "description": "hand",
    "pos": "YELLOW",
    "explanation": "(pictograph: symbol reproduces the shape formed by the thumb and the index finger)  - Character",
    "isCharacter": true
  },
  {
    "id": "14668",
    "description": "handbag,shopping_bag,carrier_bag",
    "pos": "YELLOW",
    "explanation": "(container + pictograph of top with a handle: pictograph that suggests a handbag with a handle)  - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "14669",
    "description": "handball_(activity)",
    "pos": "YELLOW",
    "explanation": "(activity + ball + hand)",
    "isCharacter": false,
    "composition": [
      12335,
      "/",
      12621,
      "/",
      14667
    ]
  },
  {
    "id": "14670",
    "description": "handgun,pistol",
    "pos": "YELLOW",
    "explanation": "(gun + small)",
    "isCharacter": false,
    "composition": [
      14655,
      "/",
      24938
    ]
  },
  {
    "id": "14671",
    "description": "handkerchief",
    "pos": "YELLOW",
    "explanation": "(cloth + nose)",
    "isCharacter": false,
    "composition": [
      13365,
      "/",
      15732
    ]
  },
  {
    "id": "14672",
    "description": "handmade_object,handicraft",
    "pos": "YELLOW",
    "explanation": "(craft + thing indicator: handmade object produced by a craftsman, e.g. a quilt or a plaque)",
    "isCharacter": false,
    "composition": [
      23583,
      ";",
      9009,
      "/",
      "RK:-2",
      "/",
      14667
    ]
  },
  {
    "id": "14673",
    "description": "hang,hook-(to)",
    "pos": "RED",
    "explanation": "(hook + action indicator)",
    "isCharacter": false,
    "composition": [
      14891,
      ";",
      8993
    ]
  },
  {
    "id": "14674",
    "description": "happen,occur-(to)",
    "pos": "RED",
    "explanation": "(event + action indicator)",
    "isCharacter": false,
    "composition": [
      14114,
      ";",
      8993
    ]
  },
  {
    "id": "14675",
    "description": "happiness,fun,joy,pleasure",
    "pos": "YELLOW",
    "explanation": "(feeling + up: uplifted feeling)",
    "isCharacter": false,
    "composition": [
      14164,
      "/",
      17983
    ]
  },
  {
    "id": "14676",
    "description": "happy,glad,gladly,happily",
    "pos": "GREEN",
    "explanation": "(happiness + description indicator)",
    "isCharacter": false,
    "composition": [
      14164,
      ";",
      8998,
      "/",
      17983
    ]
  },
  {
    "id": "14677",
    "description": "harassment",
    "pos": "YELLOW",
    "explanation": "(group_of,much_of,many_of,quantity_of + disturbance,unrest: harassment is destroying peace of mind)",
    "isCharacter": false,
    "composition": [
      14647,
      "/",
      25553
    ]
  },
  {
    "id": "14678",
    "description": "harbour",
    "pos": "YELLOW",
    "explanation": "(protected_water + boat)",
    "isCharacter": false,
    "composition": [
      25597,
      "/",
      12869
    ]
  },
  {
    "id": "14679",
    "description": "hard_(OLD)",
    "pos": "GREEN",
    "explanation": "(opposite meaning + soft + description indicator)  SUPERSEDED SYNONYM  See hard,firm 20530",
    "isCharacter": false,
    "composition": [
      15927,
      "/",
      14667,
      ";",
      8998,
      "/",
      25575
    ]
  },
  {
    "id": "14680",
    "description": "harmony,harmoniousness,concord,concordance",
    "pos": "YELLOW",
    "explanation": "(feeling + agreement: feeling of agreement)",
    "isCharacter": false,
    "composition": [
      14164,
      "/",
      12354
    ]
  },
  {
    "id": "14681",
    "description": "harvest",
    "pos": "YELLOW",
    "explanation": "(knife + grain: cutting of grain)",
    "isCharacter": false,
    "composition": [
      15159,
      "/",
      "RK:-2",
      "/",
      14625
    ]
  },
  {
    "id": "14682",
    "description": "hat,cap,hood",
    "pos": "YELLOW",
    "explanation": "(protection + head: protective covering for the head)",
    "isCharacter": false,
    "composition": [
      16420,
      "/",
      14689
    ]
  },
  {
    "id": "14683",
    "description": "hate-(to)_(OLD)",
    "pos": "RED",
    "explanation": "(opposite meaning + to love + action indicator)  SUPERSEDED SYNONYM  See hate-(to) 23883",
    "isCharacter": false,
    "composition": [
      15927,
      "/",
      15399,
      ";",
      8993
    ]
  },
  {
    "id": "14684",
    "description": "Havdalah",
    "pos": "YELLOW",
    "explanation": "(end + Sabbath: ceremony to mark the end of the Sabbath (Hebrew))",
    "isCharacter": false,
    "composition": [
      13935,
      "/",
      13639,
      "/",
      16495
    ]
  },
  {
    "id": "14685",
    "description": "have-(to)",
    "pos": "RED",
    "explanation": "(holding + action indicator: to have something in one's possession without necessarily owning it, thus the half-size of own,possess-(to) 15950)",
    "isCharacter": false,
    "composition": [
      24912,
      ";",
      8993
    ]
  },
  {
    "id": "14686",
    "description": "hawk,eagle_(OLD)",
    "pos": "YELLOW",
    "explanation": "(bird + up + intensity: bird that soars)",
    "isCharacter": false,
    "composition": [
      12837,
      "/",
      17983,
      "/",
      14947
    ]
  },
  {
    "id": "14687",
    "description": "he,him,himself",
    "pos": "BLUE",
    "explanation": "(male + 3: third person (m.sing.)",
    "isCharacter": false,
    "composition": [
      15416,
      "/",
      8499
    ]
  },
  {
    "id": "14688",
    "description": "he,she,him,her,one",
    "pos": "BLUE",
    "explanation": "(person + 3: third person (sing.), unmarked for gender)",
    "isCharacter": false,
    "composition": [
      16161,
      "/",
      8499
    ]
  },
  {
    "id": "14689",
    "description": "head",
    "pos": "YELLOW",
    "explanation": "(pictograph: symbol suggests a human head, with two lines indicating nose and mouth)  - Character",
    "isCharacter": true
  },
  {
    "id": "14690",
    "description": "health",
    "pos": "YELLOW",
    "explanation": "(person [modification] + arm: symbol suggests the outline of a person, arm bent, as if exercising to maintain health)  - Character (superimposed - modified)",
    "isCharacter": true
  },
  {
    "id": "14691",
    "description": "healthy,well",
    "pos": "GREEN",
    "explanation": "(health + description indicator)",
    "isCharacter": false,
    "composition": [
      14690,
      ";",
      8998
    ]
  },
  {
    "id": "14692",
    "description": "hear,listen-(to)",
    "pos": "RED",
    "explanation": "(ear + action indicator)",
    "isCharacter": false,
    "composition": [
      13894,
      ";",
      8993
    ]
  },
  {
    "id": "14693",
    "description": "hearing_aid",
    "pos": "YELLOW",
    "explanation": "(aid + ear + electricity + thing indicator: electrical aid for the ear)",
    "isCharacter": false,
    "composition": [
      14704,
      ";",
      9009,
      "/",
      13894,
      "/",
      13918
    ]
  },
  {
    "id": "14694",
    "description": "hearing-impaired_(OLD)",
    "pos": "GREEN",
    "explanation": "(limit(s), limitation (OLD) + to hear + description indicator)  SUPERSEDED SYNONYM  See hearing-impaired 26009",
    "isCharacter": false,
    "composition": [
      15213,
      ";",
      8998,
      "/",
      13894
    ]
  },
  {
    "id": "14695",
    "description": "heart",
    "pos": "YELLOW",
    "explanation": "(feeling + thing indicator: organ of the body. The symbol is the concrete form of feeling, emotion.)  - (character with thing indicator)",
    "isCharacter": "false",
    "composition": [
      14164,
      ";",
      9009
    ]
  },
  {
    "id": "14696",
    "description": "heat",
    "pos": "YELLOW",
    "explanation": "(pointer (left) + fire + pointer (right): suggesting radiation of heat)  - Character (superimposed - pointer)",
    "isCharacter": true
  },
  {
    "id": "14697",
    "description": "heat-(to)",
    "pos": "RED",
    "explanation": "(heat + action indicator)",
    "isCharacter": false,
    "composition": [
      14696,
      ";",
      8993
    ]
  },
  {
    "id": "14698",
    "description": "heavy",
    "pos": "GREEN",
    "explanation": "(weight + down + description indicator: causing the scales to go down)",
    "isCharacter": false,
    "composition": [
      18221,
      ";",
      8998,
      "/",
      13869
    ]
  },
  {
    "id": "14699",
    "description": "hedgehog_(OLD)",
    "pos": "YELLOW",
    "explanation": "(animal + obsolete old pictograph of spines)  - Character  SUPERSEDED SYNONYM and SUPERSEDED CHARACTER  See hedgehog 23527",
    "isCharacter": true
  },
  {
    "id": "14700",
    "description": "heel",
    "pos": "YELLOW",
    "explanation": "(legs and feet + pointer, to heel)  - Character (superimposed - pointer)",
    "isCharacter": true
  },
  {
    "id": "14701",
    "description": "helicopter",
    "pos": "YELLOW",
    "explanation": "(wheel + propeller,rotor_(blades): pictograph derived from airplane)  - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "14702",
    "description": "hello,greetings",
    "pos": "GRAY",
    "explanation": "(mouth + meeting,encounter: what you say when you meet someone)",
    "isCharacter": false,
    "composition": [
      15666,
      "/",
      25583
    ]
  },
  {
    "id": "14703",
    "description": "helmet_(OLD)",
    "pos": "YELLOW",
    "explanation": "(hat + intensity: reinforced hat)  SUPERSEDED SYNONYM  See helmet 21615",
    "isCharacter": false,
    "composition": [
      16420,
      "/",
      14689,
      "/",
      14947
    ]
  },
  {
    "id": "14704",
    "description": "help,aid,assistance,support",
    "pos": "YELLOW",
    "explanation": "(diagonal line + person: the person symbol appears to be helping the leaning line)  - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "14705",
    "description": "help,aid,assist,serve,support-(to)",
    "pos": "RED",
    "explanation": "(help + action indicator)",
    "isCharacter": false,
    "composition": [
      14704,
      ";",
      8993
    ]
  },
  {
    "id": "14706",
    "description": "helper,aide,assistant,personal_assistant",
    "pos": "BLUE",
    "explanation": "(person + help: person who gives aid)",
    "isCharacter": false,
    "composition": [
      16161,
      "/",
      14704
    ]
  },
  {
    "id": "14707",
    "description": "her,hers",
    "pos": "BLUE",
    "explanation": "(she + belongs to: third person (f.sing.) possessive)",
    "isCharacter": false,
    "composition": [
      18269,
      "/",
      8499,
      "/",
      12663
    ]
  },
  {
    "id": "14708",
    "description": "here",
    "pos": "WHITE",
    "explanation": "(about,concerning,in_relation_to,of,on + two dots: the \"of,on\" arrowhead pointing to the right to the first and closest one of two dots, indicating the \"here\" relationship to certain points in space)  - Character (sequenced)",
    "isCharacter": true
  },
  {
    "id": "14709",
    "description": "heterosexuality",
    "pos": "YELLOW",
    "explanation": "(feeling + couple_(heterosexual): intimate sexual relationship between a man and a woman)",
    "isCharacter": false,
    "composition": [
      14164,
      "/",
      "RK:-2",
      "/",
      13425
    ]
  },
  {
    "id": "14710",
    "description": "hide,conceal-(to)",
    "pos": "RED",
    "explanation": "(to make + minus + to see + action indicator: to make invisible)",
    "isCharacter": false,
    "composition": [
      23583,
      ";",
      8993,
      "/",
      15474,
      "/",
      14133
    ]
  },
  {
    "id": "14711",
    "description": "high,tall",
    "pos": "GREEN",
    "explanation": "(height,tallness + description indicator: the space between the reference lines is the highest possible within the symbol square)",
    "isCharacter": false,
    "composition": [
      24909,
      ";",
      8998
    ]
  },
  {
    "id": "14712",
    "description": "hill",
    "pos": "YELLOW",
    "explanation": "(mountain + little: small mountain)",
    "isCharacter": false,
    "composition": [
      15663,
      "/",
      24917
    ]
  },
  {
    "id": "14713",
    "description": "hip",
    "pos": "YELLOW",
    "explanation": "(legs and feet + pointer, to hip)  - Character (superimposed - pointer)",
    "isCharacter": true
  },
  {
    "id": "14714",
    "description": "hippopotamus",
    "pos": "YELLOW",
    "explanation": "(animal_(water) + horse (combination): taken from Greek, \"horse of the river\", an animal that spends much time in water) - Character (superimposed - combined)",
    "isCharacter": true
  },
  {
    "id": "14715",
    "description": "his",
    "pos": "BLUE",
    "explanation": "(he + belongs to: third person (m.sing.) possessive)",
    "isCharacter": false,
    "composition": [
      15416,
      "/",
      8499,
      "/",
      12663
    ]
  },
  {
    "id": "14716",
    "description": "his,her,hers,one's",
    "pos": "BLUE",
    "explanation": "(he,she,him,her,one + belongs to: third person (sing.) possessive, unmarked for gender)",
    "isCharacter": false,
    "composition": [
      16161,
      "/",
      8499,
      "/",
      12663
    ]
  },
  {
    "id": "14717",
    "description": "hit-(to)",
    "pos": "RED",
    "explanation": "(to touch + intensity + intensity + action indicator: to use the hand forcefully)",
    "isCharacter": false,
    "composition": [
      14667,
      ";",
      8993,
      "/",
      14947,
      "/",
      14947
    ]
  },
  {
    "id": "14718",
    "description": "hobby,pastime",
    "pos": "YELLOW",
    "explanation": "(activity + interesting)",
    "isCharacter": false,
    "composition": [
      12335,
      "/",
      24916
    ]
  },
  {
    "id": "14881",
    "description": "hoist,lift",
    "pos": "YELLOW",
    "explanation": "(aid + up and down + thing indicator)",
    "isCharacter": false,
    "composition": [
      14704,
      ";",
      9009,
      "/",
      20524
    ]
  },
  {
    "id": "14882",
    "description": "hold,contain_(1)-(to)",
    "pos": "RED",
    "explanation": "(container + action indicator)",
    "isCharacter": false,
    "composition": [
      13403,
      ";",
      8993
    ]
  },
  {
    "id": "14883",
    "description": "hole",
    "pos": "YELLOW",
    "explanation": "(earth [half-sized] + container_(low) + earth [half-sized]: symbol suggests a hole in the ground) - Character (superimposed - modified)",
    "isCharacter": true
  },
  {
    "id": "14884",
    "description": "holiday,festival",
    "pos": "YELLOW",
    "explanation": "(day + happy: day for happy activities)",
    "isCharacter": false,
    "composition": [
      13639,
      "/",
      14164,
      "/",
      17983
    ]
  },
  {
    "id": "14885",
    "description": "home",
    "pos": "YELLOW",
    "explanation": "(house + feeling: house to which one is emotionally tied)",
    "isCharacter": false,
    "composition": [
      14905,
      "/",
      14164
    ]
  },
  {
    "id": "14886",
    "description": "home_run",
    "pos": "YELLOW",
    "explanation": "(4 + corner: a run around all four bases in baseball)",
    "isCharacter": false,
    "composition": [
      8500,
      "/",
      25537
    ]
  },
  {
    "id": "14887",
    "description": "homosexuality_(female),lesbianism",
    "pos": "YELLOW",
    "explanation": "(feeling + couple_(female): intimate sexual relationship between two women)",
    "isCharacter": false,
    "composition": [
      14164,
      "/",
      "RK:-2",
      "/",
      25540
    ]
  },
  {
    "id": "14888",
    "description": "homosexuality_(male)",
    "pos": "YELLOW",
    "explanation": "(feeling + couple_(male): intimate sexual relationship between two men)",
    "isCharacter": false,
    "composition": [
      14164,
      "/",
      "RK:-2",
      "/",
      25541
    ]
  },
  {
    "id": "14889",
    "description": "honey_(spread)",
    "pos": "YELLOW",
    "explanation": "(spread + flower: spread obtained from the nectar of flowers)",
    "isCharacter": false,
    "composition": [
      17238,
      "/",
      14205
    ]
  },
  {
    "id": "14890",
    "description": "honey_(food)",
    "pos": "YELLOW",
    "explanation": "(food + flower: food obtained from the nectar of flowers)",
    "isCharacter": false,
    "composition": [
      14377,
      "/",
      14205
    ]
  },
  {
    "id": "14891",
    "description": "hook,hanger",
    "pos": "YELLOW",
    "explanation": "(pictograph)  - Character",
    "isCharacter": true
  },
  {
    "id": "14892",
    "description": "hop-(to)",
    "pos": "RED",
    "explanation": "(1 + foot + action indicator: to go on one foot)",
    "isCharacter": false,
    "composition": [
      8497,
      "/",
      14379,
      ";",
      8993
    ]
  },
  {
    "id": "14893",
    "description": "hope-(to)",
    "pos": "RED",
    "explanation": "(hope + action indicator: to have a happy feeling about the future despite its uncertainties)",
    "isCharacter": false,
    "composition": [
      14164,
      ";",
      8993,
      "/",
      17983,
      "/",
      25568
    ]
  },
  {
    "id": "14894",
    "description": "horizon",
    "pos": "YELLOW",
    "explanation": "(early morning + pointer, to horizon)  - Character (superimposed - pointer)",
    "isCharacter": true
  },
  {
    "id": "14895",
    "description": "trumpet,horn,cornet_(1)",
    "pos": "YELLOW",
    "explanation": "(pictograph) - Character  SYMBOL SYNONYM",
    "isCharacter": true
  },
  {
    "id": "14896",
    "description": "horn(s)",
    "pos": "YELLOW",
    "explanation": "(animal_(bovine,ovine),bovid,bovine + pointer, to horns)  - Character (superimposed - pointer)",
    "isCharacter": true
  },
  {
    "id": "14897",
    "description": "horse",
    "pos": "YELLOW",
    "explanation": "(animal + pictograph of horse's head and neck)  - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "14898",
    "description": "horseradish",
    "pos": "YELLOW",
    "explanation": "(vegetable (wedge-shaped) + hot,spicy,peppery: wedge-shaped vegetable with a hot-tasting edible root)",
    "isCharacter": false,
    "composition": [
      13124,
      "/",
      17506,
      "/",
      14183
    ]
  },
  {
    "id": "14899",
    "description": "hospital,clinic",
    "pos": "YELLOW",
    "explanation": "(building + medical: building where medical services are available)",
    "isCharacter": false,
    "composition": [
      14905,
      "/",
      24920
    ]
  },
  {
    "id": "14900",
    "description": "hot_(temperature)",
    "pos": "GREEN",
    "explanation": "(heat + description indicator)",
    "isCharacter": false,
    "composition": [
      14696,
      ";",
      8998
    ]
  },
  {
    "id": "14901",
    "description": "hot,spicy,peppery",
    "pos": "GREEN",
    "explanation": "(taste + fire + description indicator)",
    "isCharacter": false,
    "composition": [
      17506,
      ";",
      8998,
      "/",
      14183
    ]
  },
  {
    "id": "14902",
    "description": "hot_dog,frankfurter",
    "pos": "YELLOW",
    "explanation": "(roll + meat + long)",
    "isCharacter": false,
    "composition": [
      16683,
      "/",
      14377,
      "/",
      12378,
      "/",
      15193
    ]
  },
  {
    "id": "14903",
    "description": "hotel,motel",
    "pos": "YELLOW",
    "explanation": "(building + person + to travel: building where travellers stay)",
    "isCharacter": false,
    "composition": [
      14905,
      "/",
      16161,
      "/",
      17779
    ]
  },
  {
    "id": "14904",
    "description": "hour,o'clock",
    "pos": "YELLOW",
    "explanation": "(time + degree, to indicate an hour)",
    "isCharacter": false,
    "composition": [
      17732,
      "/",
      8490
    ]
  },
  {
    "id": "14905",
    "description": "house,building,dwelling,residence",
    "pos": "YELLOW",
    "explanation": "(foundation + protection: pictograph of the outline of a house.The symbol can also be explained as: combination of enclosure and protection.)  - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "14906",
    "description": "how",
    "pos": "WHITE",
    "explanation": "(who,that,which-(relative) + action)",
    "isCharacter": false,
    "composition": [
      16482,
      "/",
      12335
    ]
  },
  {
    "id": "14907",
    "description": "how-(question)",
    "pos": "WHITE",
    "explanation": "(what,question_mark + action: interrogative)",
    "isCharacter": false,
    "composition": [
      18229,
      "/",
      12335
    ]
  },
  {
    "id": "14908",
    "description": "how_much,how_many",
    "pos": "WHITE",
    "explanation": "(what,question_mark + quantity)",
    "isCharacter": false,
    "composition": [
      18229,
      "/",
      14647
    ]
  },
  {
    "id": "14909",
    "description": "hug,cuddle,embrace-(to)",
    "pos": "RED",
    "explanation": "(hug,squeeze,embrace + action indicator)",
    "isCharacter": false,
    "composition": [
      12577,
      ";",
      8993,
      "/",
      12580
    ]
  },
  {
    "id": "14910",
    "description": "humble,meek",
    "pos": "GREEN",
    "explanation": "(feeling + inferior + description indicator: lacking a feeling of pride)",
    "isCharacter": false,
    "composition": [
      14164,
      ";",
      8998,
      "/",
      17969
    ]
  },
  {
    "id": "14911",
    "description": "hummus",
    "pos": "YELLOW",
    "explanation": "(spread + bean: Middle Eastern spread made from chick-peas)",
    "isCharacter": false,
    "composition": [
      17238,
      "/",
      12642
    ]
  },
  {
    "id": "14912",
    "description": "hungry",
    "pos": "GREEN",
    "explanation": "(feeling + minus + food + description indicator: having a feeling caused by the lack of food)",
    "isCharacter": false,
    "composition": [
      14164,
      ";",
      8998,
      "/",
      15474,
      "/",
      14377
    ]
  },
  {
    "id": "14913",
    "description": "hurt,pain_(feel),suffer-(to)",
    "pos": "RED",
    "explanation": "(pain + action indicator)",
    "isCharacter": false,
    "composition": [
      14164,
      ";",
      8993,
      "/",
      "RK:-2",
      "/",
      16164
    ]
  },
  {
    "id": "14914",
    "description": "husband",
    "pos": "BLUE",
    "explanation": "(man + protection: this symbol, joined to the symbol for wife, produces family)  - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "14915",
    "description": "hysterectomy",
    "pos": "YELLOW",
    "explanation": "(to remove + medical + uterus)",
    "isCharacter": false,
    "composition": [
      17449,
      "/",
      24920,
      "/",
      17994
    ]
  },
  {
    "id": "14916",
    "description": "I,me,myself",
    "pos": "BLUE",
    "explanation": "(person + 1: the first person singular)",
    "isCharacter": false,
    "composition": [
      16161,
      "/",
      8497
    ]
  },
  {
    "id": "14917",
    "description": "I,me,myself-(feminine)",
    "pos": "BLUE",
    "explanation": "(female + l: first person singular (f.))",
    "isCharacter": false,
    "composition": [
      18269,
      "/",
      8497
    ]
  },
  {
    "id": "14918",
    "description": "I,me,myself-(masculine)",
    "pos": "BLUE",
    "explanation": "(male + 1: first person singular (m.))",
    "isCharacter": false,
    "composition": [
      15416,
      "/",
      8497
    ]
  },
  {
    "id": "14919",
    "description": "ice",
    "pos": "YELLOW",
    "explanation": "(water + thing: water transformed into a solid thing)  - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "14920",
    "description": "ice_cream_(OLD)",
    "pos": "YELLOW",
    "explanation": "(food + sweet + ice: sweet frozen food)  SUPERSEDED SYNONYM  See ice_cream,sherbet,sorbet 22369 (and ice_cream_(cone) 14921, ice_cream_(bar) 22370, and ice_cream_(lollipop) 22366)",
    "isCharacter": false,
    "composition": [
      14377,
      "/",
      17506,
      "/",
      17983,
      "/",
      14919
    ]
  },
  {
    "id": "14921",
    "description": "ice_cream_(cone)",
    "pos": "YELLOW",
    "explanation": "(pictograph)  - Character",
    "isCharacter": true
  },
  {
    "id": "14922",
    "description": "ice_hockey_(activity)",
    "pos": "YELLOW",
    "explanation": "(activity + sport_stick_and_puck,hockey_stick + ice: game played on ice with a stick and a rubber disc)",
    "isCharacter": false,
    "composition": [
      12335,
      "/",
      "RK:-2",
      "/",
      25619,
      "/",
      14919
    ]
  },
  {
    "id": "14923",
    "description": "Iceland",
    "pos": "YELLOW",
    "explanation": "(country + ice + fire: country characterized by ice and fiery volcanoes)",
    "isCharacter": false,
    "composition": [
      13423,
      "/",
      14919,
      "/",
      14183
    ]
  },
  {
    "id": "14924",
    "description": "ice_skates",
    "pos": "YELLOW",
    "explanation": "(legs and feet + pictograph of two curved lines, suggesting skates)  - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "14925",
    "description": "icy,frozen",
    "pos": "GREEN",
    "explanation": "(ice + description indicator)",
    "isCharacter": false,
    "composition": [
      14919,
      ";",
      8998
    ]
  },
  {
    "id": "14926",
    "description": "idea,thought",
    "pos": "YELLOW",
    "explanation": "(mind + down: a thought issuing from the mind)  - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "14927",
    "description": "if",
    "pos": "WHITE",
    "explanation": "(what,question_mark + either)",
    "isCharacter": false,
    "composition": [
      18229,
      "/",
      13914
    ]
  },
  {
    "id": "14929",
    "description": "immoral,bad,wrong,morally_wrong",
    "pos": "GREEN",
    "explanation": "(bad_conscience + intensity + description indicator: morally wrong or bad) See also: bad,wrong 12615 and incorrect,bad,inaccurate,wrong 14935.",
    "isCharacter": false,
    "composition": [
      25523,
      ";",
      8998,
      "/",
      14947
    ]
  },
  {
    "id": "14930",
    "description": "important,significant",
    "pos": "GREEN",
    "explanation": "(importance,significance + description indicator: of intense interest)",
    "isCharacter": false,
    "composition": [
      24913,
      ";",
      8998
    ]
  },
  {
    "id": "14931",
    "description": "improve-(to)_(OLD)",
    "pos": "RED",
    "explanation": "(to cause + more + correct + action indicator: to cause to be better, in a rational sense.)",
    "isCharacter": false,
    "composition": [
      13134,
      ";",
      8993,
      "/",
      24879,
      "/",
      25538,
      "/",
      14947
    ]
  },
  {
    "id": "14932",
    "description": "in,inside,interior,internal",
    "pos": "WHITE",
    "explanation": "(enclosure + dot, inside the enclosure)  - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "14933",
    "description": "incest",
    "pos": "YELLOW",
    "explanation": "(sexual intercourse + relative)",
    "isCharacter": false,
    "composition": [
      13380,
      "/",
      14431,
      "/",
      16481
    ]
  },
  {
    "id": "14934",
    "description": "include-(to)",
    "pos": "RED",
    "explanation": "(inside + action indicator)",
    "isCharacter": false,
    "composition": [
      14932,
      ";",
      8993
    ]
  },
  {
    "id": "14935",
    "description": "incorrect,bad,inaccurate,wrong",
    "pos": "GREEN",
    "explanation": "(incorrect_thinking + intensity + description indicator: thought to be wrong or bad in a rational sense) See also: bad,wrong 12615 and immoral,bad,wrong,morally_wrong 14929.",
    "isCharacter": false,
    "composition": [
      25539,
      ";",
      8998,
      "/",
      14947
    ]
  },
  {
    "id": "14936",
    "description": "increase,enlarge-(to)",
    "pos": "RED",
    "explanation": "(big + action indicator: to become bigger)",
    "isCharacter": false,
    "composition": [
      24875,
      ";",
      8993
    ]
  },
  {
    "id": "14937",
    "description": "Independence_Day_(Israel)",
    "pos": "YELLOW",
    "explanation": "(day + Israel) (Israel)",
    "isCharacter": false,
    "composition": [
      13639,
      "/",
      13423,
      "/",
      17251
    ]
  },
  {
    "id": "14938",
    "description": "indigo",
    "pos": "WHITE",
    "explanation": "(colour + 6) (CKB)",
    "isCharacter": false,
    "composition": [
      13377,
      "/",
      8502
    ]
  },
  {
    "id": "14939",
    "description": "infertile,sterile",
    "pos": "GREEN",
    "explanation": "(without + fertilization + description before the fact indicator: incapable of conception)",
    "isCharacter": false,
    "composition": [
      15474,
      "/",
      13395,
      ";",
      8997
    ]
  },
  {
    "id": "14940",
    "description": "infinite,limitless_(OLD)",
    "pos": "GREEN",
    "explanation": "(infiniteness,boundlessness,limitlessness_(OLD) + description indicator)  SUPERSEDED SYNONYM  See infinite,limitless 26010",
    "isCharacter": false,
    "composition": [
      15474,
      "/",
      15213,
      ";",
      8998
    ]
  },
  {
    "id": "14941",
    "description": "injection,inoculation,shot",
    "pos": "YELLOW",
    "explanation": "(pictograph of hypodermic syringe)  - Character",
    "isCharacter": true
  },
  {
    "id": "14942",
    "description": "injure,hurt-(to)",
    "pos": "RED",
    "explanation": "(to cause + pain + action indicator)",
    "isCharacter": false,
    "composition": [
      13134,
      ";",
      8993,
      "/",
      14164,
      "/",
      "RK:-2",
      "/",
      16164
    ]
  },
  {
    "id": "14943",
    "description": "insect,bug",
    "pos": "YELLOW",
    "explanation": "(pictograph: symbol suggests a creature with six legs)  - Character",
    "isCharacter": true
  },
  {
    "id": "14944",
    "description": "insect_(pest)",
    "pos": "YELLOW",
    "explanation": "(insect + negative: undesirable insect, a pest)",
    "isCharacter": false,
    "composition": [
      14943,
      "/",
      15474,
      "/",
      14947
    ]
  },
  {
    "id": "14945",
    "description": "instruction,teaching",
    "pos": "YELLOW",
    "explanation": "(to give + knowledge)",
    "isCharacter": false,
    "composition": [
      24903,
      "/",
      15162
    ]
  },
  {
    "id": "14946",
    "description": "instruction(s),direction(s)",
    "pos": "YELLOW",
    "explanation": "(page + to use: paper that tells one how to use something)",
    "isCharacter": false,
    "composition": [
      15962,
      "/",
      24847
    ]
  },
  {
    "id": "14947",
    "description": "intensity",
    "pos": "WHITE",
    "explanation": "(exclamation mark: used following another symbol to enhance meaning in a qualitative way)  - Character",
    "isCharacter": true
  },
  {
    "id": "14948",
    "description": "interesting,interested",
    "pos": "GREEN",
    "explanation": "(interest + description indicator: engaging the mind)",
    "isCharacter": false,
    "composition": [
      24916,
      ";",
      8998
    ]
  },
  {
    "id": "14949",
    "description": "international",
    "pos": "GREEN",
    "explanation": "(country + all + description indicator)",
    "isCharacter": false,
    "composition": [
      13423,
      ";",
      8998,
      "/",
      12360
    ]
  },
  {
    "id": "14950",
    "description": "intimacy,closeness",
    "pos": "YELLOW",
    "explanation": "(feeling + close)",
    "isCharacter": false,
    "composition": [
      14164,
      "/",
      25586
    ]
  },
  {
    "id": "14951",
    "description": "intimate,close",
    "pos": "GREEN",
    "explanation": "(intimacy + description indicator)",
    "isCharacter": false,
    "composition": [
      14164,
      ";",
      8998,
      "/",
      25586
    ]
  },
  {
    "id": "14952",
    "description": "into",
    "pos": "WHITE",
    "explanation": "(forward + enclosure: the arrow is entering the enclosure)  - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "14953",
    "description": "invent-(to)",
    "pos": "RED",
    "explanation": "(plan + first + action indicator: to plan for the first time)",
    "isCharacter": false,
    "composition": [
      16194,
      ";",
      8993,
      "/",
      8497,
      "/",
      8486
    ]
  },
  {
    "id": "14954",
    "description": "Ireland",
    "pos": "YELLOW",
    "explanation": "(country + shamrock)",
    "isCharacter": false,
    "composition": [
      13423,
      "/",
      16939
    ]
  },
  {
    "id": "14955",
    "description": "iron,smoothing_iron",
    "pos": "YELLOW",
    "explanation": "(pictograph)  - Character",
    "isCharacter": true
  },
  {
    "id": "14956",
    "description": "iron-(to)",
    "pos": "RED",
    "explanation": "(iron + action indicator)",
    "isCharacter": false,
    "composition": [
      14955,
      ";",
      8993
    ]
  },
  {
    "id": "14957",
    "description": "ironing_board",
    "pos": "YELLOW",
    "explanation": "(table + iron)",
    "isCharacter": false,
    "composition": [
      17493,
      "/",
      14955
    ]
  },
  {
    "id": "14958",
    "description": "island",
    "pos": "YELLOW",
    "explanation": "(water_(ground_level) + earth + water_(ground_level): land surrounded by water on ground level)  - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "14959",
    "description": "Israel",
    "pos": "YELLOW",
    "explanation": "(country + Star of David)",
    "isCharacter": false,
    "composition": [
      13423,
      "/",
      17251
    ]
  },
  {
    "id": "14960",
    "description": "it,itself",
    "pos": "WHITE",
    "explanation": "(CKB says that this symbol is derived from  small. The symbol also looks like the top part of the symbols for man and woman minus the specific gender parts. It refers to things rather than to people.)  - Character",
    "isCharacter": true
  },
  {
    "id": "14961",
    "description": "apparent(ly),clear(ly),evident(ly),obvious(ly),plain(ly)",
    "pos": "GREEN",
    "explanation": "(understanding,comprehension + through + description indicator)",
    "isCharacter": false,
    "composition": [
      25629,
      ";",
      8998,
      "/",
      17724
    ]
  },
  {
    "id": "14962",
    "description": "its",
    "pos": "WHITE",
    "explanation": "(it,itself + belongs to: refers to things rather than to people)",
    "isCharacter": false,
    "composition": [
      14960,
      "/",
      12663
    ]
  },
  {
    "id": "14963",
    "description": "intrauterine_device,IUD",
    "pos": "YELLOW",
    "explanation": "(birth control + uterus)",
    "isCharacter": false,
    "composition": [
      13935,
      "/",
      13395,
      "/",
      17994
    ]
  },
  {
    "id": "14964",
    "description": "Iyar",
    "pos": "YELLOW",
    "explanation": "(month + Israel: month of Independence Day)",
    "isCharacter": false,
    "composition": [
      15649,
      "/",
      13423,
      "/",
      17251
    ]
  },
  {
    "id": "14965",
    "description": "jam,jelly,marmalade,preserves",
    "pos": "YELLOW",
    "explanation": "(spread + fruit)",
    "isCharacter": false,
    "composition": [
      17238,
      "/",
      14405
    ]
  },
  {
    "id": "14966",
    "description": "January",
    "pos": "YELLOW",
    "explanation": "(month + 1: first month of the year)",
    "isCharacter": false,
    "composition": [
      15649,
      "/",
      8497
    ]
  },
  {
    "id": "14967",
    "description": "jealous",
    "pos": "GREEN",
    "explanation": "(to resent + other + to have + description indicator)",
    "isCharacter": false,
    "composition": [
      14164,
      ";",
      8998,
      "/",
      12351,
      "/",
      15214,
      "/",
      8498,
      "/",
      24912
    ]
  },
  {
    "id": "14968",
    "description": "Jerusalem_Day",
    "pos": "YELLOW",
    "explanation": "(day + city + first) (Israel)",
    "isCharacter": false,
    "composition": [
      13639,
      "/",
      14647,
      "/",
      14647,
      "/",
      14905,
      "/",
      8497,
      "/",
      8486
    ]
  },
  {
    "id": "14969",
    "description": "Jesus_(of_Nazareth),Jesus_Christ,Christ",
    "pos": "BLUE",
    "explanation": "(man + cross: a man regarded by Christians as being the Son of God, who died on the cross - biblical figure)",
    "isCharacter": false,
    "composition": [
      15416,
      "/",
      13613
    ]
  },
  {
    "id": "14970",
    "description": "jet,jet_plane",
    "pos": "YELLOW",
    "explanation": "(plane + out of: plane driven forward by expelling gas)",
    "isCharacter": false,
    "composition": [
      12357,
      "/",
      15943
    ]
  },
  {
    "id": "14971",
    "description": "jewel,gem,gemstone",
    "pos": "YELLOW",
    "explanation": "(stone + to shine)",
    "isCharacter": false,
    "composition": [
      17267,
      "/",
      17252
    ]
  },
  {
    "id": "14972",
    "description": "Jewish",
    "pos": "GREEN",
    "explanation": "(Star of David + description indicator: having to do with Judaism, for which the Star of David is a symbol)",
    "isCharacter": false,
    "composition": [
      17251,
      ";",
      8998
    ]
  },
  {
    "id": "14973",
    "description": "joint",
    "pos": "YELLOW",
    "explanation": "(bones with joint + pointer to the junction where they meet)  - Character (superimposed - sequenced - pointer)",
    "isCharacter": true
  },
  {
    "id": "14974",
    "description": "joke_(spoken)-(to)",
    "pos": "RED",
    "explanation": "(to say + comma + funny + action indicator: to say something in order to be funny)",
    "isCharacter": false,
    "composition": [
      15666,
      ";",
      8993,
      "/",
      8487,
      "/",
      14164,
      "/",
      17983,
      "/",
      15666
    ]
  },
  {
    "id": "15137",
    "description": "July",
    "pos": "YELLOW",
    "explanation": "(month + 7: seventh month of the year)",
    "isCharacter": false,
    "composition": [
      15649,
      "/",
      8503
    ]
  },
  {
    "id": "15138",
    "description": "jump_rope,skipping_rope",
    "pos": "YELLOW",
    "explanation": "(linear thing + to jump + thing indicator)",
    "isCharacter": false,
    "composition": [
      15214,
      ";",
      9009,
      "/",
      23550
    ]
  },
  {
    "id": "15139",
    "description": "jump-(to)",
    "pos": "RED",
    "explanation": "(jump + action indicator)",
    "isCharacter": false,
    "composition": [
      23550,
      ";",
      8993
    ]
  },
  {
    "id": "15140",
    "description": "June",
    "pos": "YELLOW",
    "explanation": "(month + 6: sixth month of the year)",
    "isCharacter": false,
    "composition": [
      15649,
      "/",
      8502
    ]
  },
  {
    "id": "15141",
    "description": "Kabbalat_Shabbat",
    "pos": "WHITE",
    "explanation": "(greeting + Sabbath: ceremony to welcome the Sabbath)",
    "isCharacter": false,
    "composition": [
      15666,
      "/",
      25583,
      "/",
      13639,
      "/",
      16495
    ]
  },
  {
    "id": "15142",
    "description": "Kali",
    "pos": "BLUE",
    "explanation": "(god + black: Hindu goddess) (India)",
    "isCharacter": false,
    "composition": [
      14451,
      "/",
      13377,
      "/",
      15719
    ]
  },
  {
    "id": "15143",
    "description": "keep,preserve,save-(to)",
    "pos": "RED",
    "explanation": "(to hold + future + action indicator: to hold for the future)",
    "isCharacter": false,
    "composition": [
      13403,
      ";",
      8993,
      "/",
      14417
    ]
  },
  {
    "id": "15144",
    "description": "key",
    "pos": "YELLOW",
    "explanation": "(pictograph: symbol suggests a key)  - Character",
    "isCharacter": true
  },
  {
    "id": "15145",
    "description": "kibbutz",
    "pos": "YELLOW",
    "explanation": "(village + to work + to live + together: collective settlement ) (Israel)",
    "isCharacter": false,
    "composition": [
      14647,
      "/",
      14905,
      "/",
      18273,
      "/",
      15206,
      "/",
      23409
    ]
  },
  {
    "id": "15146",
    "description": "kick-(to)",
    "pos": "RED",
    "explanation": "(leg_and_foot + intensity + action indicator: to move legs and feet forcefully)",
    "isCharacter": false,
    "composition": [
      25578,
      ";",
      8993,
      "/",
      14947
    ]
  },
  {
    "id": "15147",
    "description": "kiddush,blessing_over_wine",
    "pos": "YELLOW",
    "explanation": "(prayer + wine: blessing over wine)",
    "isCharacter": false,
    "composition": [
      15666,
      "/",
      17739,
      "/",
      14451,
      "/",
      12359,
      "/",
      14635
    ]
  },
  {
    "id": "15148",
    "description": "kill,murder-(to)",
    "pos": "RED",
    "explanation": "(to cause + to die + action indicator)",
    "isCharacter": false,
    "composition": [
      13134,
      ";",
      8993,
      "/",
      13645
    ]
  },
  {
    "id": "15149",
    "description": "kind,kindly",
    "pos": "GREEN",
    "explanation": "(feeling + help + description indicator: feeling of wanting to be helpful)",
    "isCharacter": false,
    "composition": [
      14164,
      ";",
      8998,
      "/",
      "RK:-2",
      "/",
      14704
    ]
  },
  {
    "id": "15151",
    "description": "Kislev",
    "pos": "YELLOW",
    "explanation": "(month + happy + light: month of Chanukah)",
    "isCharacter": false,
    "composition": [
      15649,
      "/",
      14164,
      "/",
      17983,
      "/",
      15208
    ]
  },
  {
    "id": "15152",
    "description": "kiss",
    "pos": "YELLOW",
    "explanation": "(mouth + mouth: two mouths touching)  - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "15153",
    "description": "kiss-(to)",
    "pos": "RED",
    "explanation": "(kiss + action indicator)",
    "isCharacter": false,
    "composition": [
      15152,
      ";",
      8993
    ]
  },
  {
    "id": "15154",
    "description": "kitchen",
    "pos": "YELLOW",
    "explanation": "(room + to prepare food)",
    "isCharacter": false,
    "composition": [
      16687,
      "/",
      23583,
      "/",
      14377
    ]
  },
  {
    "id": "15155",
    "description": "kite",
    "pos": "YELLOW",
    "explanation": "(pictograph)  - Character",
    "isCharacter": true
  },
  {
    "id": "15156",
    "description": "kitten_(OLD)",
    "pos": "YELLOW",
    "explanation": "(cat + baby)  SUPERSEDED SYNONYM  See kitten 24474",
    "isCharacter": false,
    "composition": [
      12383,
      "/",
      12603
    ]
  },
  {
    "id": "15157",
    "description": "knee",
    "pos": "YELLOW",
    "explanation": "(kneeling_(kneeling_person) + pointer, to knee joint) - Character (superimposed - pointer)",
    "isCharacter": true
  },
  {
    "id": "15158",
    "description": "kneel-(to)",
    "pos": "RED",
    "explanation": "(kneeling_(kneeling_person) + action indicator)",
    "isCharacter": false,
    "composition": [
      16162,
      ";",
      8993
    ]
  },
  {
    "id": "15159",
    "description": "knife,sword",
    "pos": "YELLOW",
    "explanation": "(pictograph: symbol suggests a knife or sword. The diagonal orientation of knife is the same as that of fork and spoon.) - Character",
    "isCharacter": true
  },
  {
    "id": "15160",
    "description": "knit-(to)",
    "pos": "RED",
    "explanation": "(to make + cloth + 2 + linear thing + thing indicator + action indicator: to make cloth using two linear things, i.e., knitting needles)",
    "isCharacter": false,
    "composition": [
      23583,
      ";",
      8993,
      "/",
      13365,
      "/",
      8498,
      "/",
      15214,
      ";",
      9009
    ]
  },
  {
    "id": "15161",
    "description": "know-(to)",
    "pos": "RED",
    "explanation": "(knowledge + action indicator)",
    "isCharacter": false,
    "composition": [
      15162,
      ";",
      8993
    ]
  },
  {
    "id": "15162",
    "description": "knowledge,class_(in_combinations)",
    "pos": "YELLOW",
    "explanation": "(combination of mind and enclosure: store house of the mind)  - Character",
    "isCharacter": true
  },
  {
    "id": "15163",
    "description": "koala",
    "pos": "YELLOW",
    "explanation": "(marsupial + tree: marsupial adapted to living in trees)",
    "isCharacter": false,
    "composition": [
      12378,
      "/",
      13403,
      "/",
      17775
    ]
  },
  {
    "id": "15164",
    "description": "eyeliner,kohl",
    "pos": "YELLOW",
    "explanation": "(colour + plus + eyelid_(lower): eye make-up,traditionally used by women in African, Middle East, and Eastern cultures)",
    "isCharacter": false,
    "composition": [
      13377,
      "/",
      12374,
      "/",
      25558
    ]
  },
  {
    "id": "15165",
    "description": "labour",
    "pos": "YELLOW",
    "explanation": "(work + birth)",
    "isCharacter": false,
    "composition": [
      18273,
      "/",
      12842
    ]
  },
  {
    "id": "15166",
    "description": "ladder",
    "pos": "YELLOW",
    "explanation": "(pictograph)  - Character",
    "isCharacter": true
  },
  {
    "id": "15167",
    "description": "Lag_B'Omer",
    "pos": "YELLOW",
    "explanation": "(night + comma + bonfire)",
    "isCharacter": false,
    "composition": [
      15719,
      "/",
      8487,
      "/",
      14183,
      "/",
      14164,
      "/",
      17983
    ]
  },
  {
    "id": "15168",
    "description": "lake,pond",
    "pos": "YELLOW",
    "explanation": "(much + water: body of water)",
    "isCharacter": false,
    "composition": [
      14647,
      "/",
      25777
    ]
  },
  {
    "id": "15169",
    "description": "Lakshmi",
    "pos": "BLUE",
    "explanation": "(God + money: Hindu goddess) (India)",
    "isCharacter": false,
    "composition": [
      14451,
      "/",
      15484
    ]
  },
  {
    "id": "15170",
    "description": "lamb,mutton",
    "pos": "YELLOW",
    "explanation": "(food + sheep: food that comes from a lamb or sheep. The symbol also can be explained as: combination of meat and sheep.)",
    "isCharacter": false,
    "composition": [
      14377,
      "/",
      12379,
      "/",
      13365
    ]
  },
  {
    "id": "15171",
    "description": "landing,airplane_landing",
    "pos": "YELLOW",
    "explanation": "(airplane + downward and forward)",
    "isCharacter": false,
    "composition": [
      12357,
      "/",
      13871
    ]
  },
  {
    "id": "15172",
    "description": "language",
    "pos": "YELLOW",
    "explanation": "(mouth + ear: what is spoken and heard)  - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "15173",
    "description": "last,final",
    "pos": "GREEN",
    "explanation": "(opposite meaning + first + description indicator)",
    "isCharacter": false,
    "composition": [
      15927,
      "/",
      8497,
      ";",
      8998,
      "/",
      8486
    ]
  },
  {
    "id": "15174",
    "description": "last_night",
    "pos": "YELLOW",
    "explanation": "(night + ago,then_(past))",
    "isCharacter": false,
    "composition": [
      15719,
      "/",
      12352
    ]
  },
  {
    "id": "15175",
    "description": "last_week",
    "pos": "YELLOW",
    "explanation": "(week + ago,then_(past))",
    "isCharacter": false,
    "composition": [
      8503,
      "/",
      13639,
      "/",
      12352
    ]
  },
  {
    "id": "15176",
    "description": "last_year",
    "pos": "YELLOW",
    "explanation": "(year + ago,then_(past))",
    "isCharacter": false,
    "composition": [
      18289,
      "/",
      12352
    ]
  },
  {
    "id": "15177",
    "description": "late",
    "pos": "GREEN",
    "explanation": "(after + time + description indicator: after the appointed time)",
    "isCharacter": false,
    "composition": [
      12348,
      "/",
      17732,
      ";",
      8998
    ]
  },
  {
    "id": "15178",
    "description": "laugh-(to)",
    "pos": "RED",
    "explanation": "(laugh,laughter + action indicator: to express happiness with the mouth by laughing)",
    "isCharacter": false,
    "composition": [
      14164,
      ";",
      8993,
      "/",
      17983,
      "/",
      15666
    ]
  },
  {
    "id": "15179",
    "description": "laundromat,launderette,laundry",
    "pos": "YELLOW",
    "explanation": "(public room + bath,washing + clothing)",
    "isCharacter": false,
    "composition": [
      16430,
      "/",
      16992,
      "/",
      13366
    ]
  },
  {
    "id": "15180",
    "description": "lawn,meadow",
    "pos": "YELLOW",
    "explanation": "(grass + earth: land covered with grass) - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "15181",
    "description": "lead,direct,guide-(to)",
    "pos": "RED",
    "explanation": "(leadership,guidance + action indicator: to use mental powers to carry events or persons forward)",
    "isCharacter": false,
    "composition": [
      22913,
      ";",
      8993
    ]
  },
  {
    "id": "15182",
    "description": "leader,director,guide_(2)",
    "pos": "BLUE",
    "explanation": "(person + leadership)",
    "isCharacter": false,
    "composition": [
      16161,
      "/",
      22913
    ]
  },
  {
    "id": "15183",
    "description": "leaf",
    "pos": "YELLOW",
    "explanation": "(pictograph)  - Character",
    "isCharacter": true
  },
  {
    "id": "15184",
    "description": "learn-(to)",
    "pos": "RED",
    "explanation": "(to receive + knowledge + action indicator)",
    "isCharacter": false,
    "composition": [
      24727,
      ";",
      8993,
      "/",
      15162
    ]
  },
  {
    "id": "15185",
    "description": "fewest,least,minimum",
    "pos": "GREEN",
    "explanation": "(opposite meaning + most + description indicator)",
    "isCharacter": false,
    "composition": [
      15927,
      "/",
      24944,
      ";",
      8998
    ]
  },
  {
    "id": "15186",
    "description": "leather",
    "pos": "YELLOW",
    "explanation": "(material + animal skin: material made from an animal skin)",
    "isCharacter": false,
    "composition": [
      15431,
      "/",
      16420,
      "/",
      12378
    ]
  },
  {
    "id": "15187",
    "description": "left",
    "pos": "GREEN",
    "explanation": "(left_turn,left_(position_or_direction) + description indicator)",
    "isCharacter": false,
    "composition": [
      25577,
      ";",
      8998
    ]
  },
  {
    "id": "15188",
    "description": "leg",
    "pos": "YELLOW",
    "explanation": "(legs and feet + pointer, to leg)  - Character (superimposed - pointer)",
    "isCharacter": true
  },
  {
    "id": "15189",
    "description": "legs_and_feet",
    "pos": "YELLOW",
    "explanation": "(pictograph: symbol suggests a side view of a pair of legs and feet)  - Character",
    "isCharacter": true
  },
  {
    "id": "15190",
    "description": "lemon",
    "pos": "YELLOW",
    "explanation": "(pictograph: suggests a lemon with stem)  - Character",
    "isCharacter": true
  },
  {
    "id": "15191",
    "description": "lemonade",
    "pos": "YELLOW",
    "explanation": "(drink + lemon)",
    "isCharacter": false,
    "composition": [
      13881,
      "/",
      15190
    ]
  },
  {
    "id": "15192",
    "description": "lend,loan-(to)",
    "pos": "RED",
    "explanation": "(to give + limited time + action indicator: to give for a limited time)",
    "isCharacter": false,
    "composition": [
      24903,
      ";",
      8993,
      "/",
      15212
    ]
  },
  {
    "id": "15193",
    "description": "length,longness",
    "pos": "YELLOW",
    "explanation": "(horizontal line bounded by two reference lines [half-sized]: the horizontal line extends full length within the symbol square)  - Character",
    "isCharacter": true
  },
  {
    "id": "15194",
    "description": "leopard",
    "pos": "YELLOW",
    "explanation": "(feline + spot: feline with spots)",
    "isCharacter": false,
    "composition": [
      12383,
      "/",
      14133,
      "/",
      13867
    ]
  },
  {
    "id": "15195",
    "description": "fewer,less",
    "pos": "GREEN",
    "explanation": "(opposite meaning + more + description indicator)",
    "isCharacter": false,
    "composition": [
      15927,
      "/",
      24879,
      ";",
      8998
    ]
  },
  {
    "id": "15196",
    "description": "let,allow,permit-(to)",
    "pos": "RED",
    "explanation": "(permission,allowance + action indicator: CKB says that the symbol represents a thought that is allowed to pass through a mental barrier)",
    "isCharacter": false,
    "composition": [
      24926,
      ";",
      8993
    ]
  },
  {
    "id": "15197",
    "description": "let_us,let's",
    "pos": "RED",
    "explanation": "(command + to let + us + action indicator + plural indicator: the first person plural imperative of \"to let\")",
    "isCharacter": false,
    "composition": [
      14947,
      "/",
      24926,
      ";",
      8993,
      "/",
      16161,
      ";",
      9011,
      "/",
      8497
    ]
  },
  {
    "id": "15198",
    "description": "letter,mail,post",
    "pos": "YELLOW",
    "explanation": "(pictograph: symbol suggests an envelope)  - Character",
    "isCharacter": true
  },
  {
    "id": "15199",
    "description": "letter_carrier,postman,mailman",
    "pos": "BLUE",
    "explanation": "(person + letter)",
    "isCharacter": false,
    "composition": [
      16161,
      "/",
      15198
    ]
  },
  {
    "id": "15200",
    "description": "lettuce,leafy_vegetable",
    "pos": "YELLOW",
    "explanation": "(earth + outline of leaves: symbol suggests a leafy vegetable with the grass-like edible portion above ground)  - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "15201",
    "description": "library_(building)",
    "pos": "YELLOW",
    "explanation": "(building + book: building that contains a collection of books)",
    "isCharacter": false,
    "composition": [
      14905,
      "/",
      12875
    ]
  },
  {
    "id": "15202",
    "description": "library_(room)",
    "pos": "YELLOW",
    "explanation": "(room + book: room that contains a collection of books)",
    "isCharacter": false,
    "composition": [
      16687,
      "/",
      12875
    ]
  },
  {
    "id": "15203",
    "description": "lie_(OLD)",
    "pos": "YELLOW",
    "explanation": "(opposite meaning + truth)  SUPERSEDED SYNONYM  See lie 23894",
    "isCharacter": false,
    "composition": [
      15927,
      "/",
      17786
    ]
  },
  {
    "id": "15204",
    "description": "lie-(to)_(OLD)",
    "pos": "RED",
    "explanation": "(lie + action indicator)  SUPERSEDED SYNONYM  See lie-(to) 23895",
    "isCharacter": false,
    "composition": [
      15927,
      "/",
      17786,
      ";",
      8993
    ]
  },
  {
    "id": "15205",
    "description": "lie_down,lie-(to)",
    "pos": "RED",
    "explanation": "(reclining,lying_(person_lying_down) + action indicator)",
    "isCharacter": false,
    "composition": [
      16163,
      ";",
      8993
    ]
  },
  {
    "id": "15206",
    "description": "life",
    "pos": "YELLOW",
    "explanation": "(sun + person, in combination: energy produced by the sun supports life on earth)  - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "15207",
    "description": "lift,raise-(to)",
    "pos": "RED",
    "explanation": "(up + weight + action indicator: to raise a weight)",
    "isCharacter": false,
    "composition": [
      17983,
      ";",
      8993,
      "/",
      18221
    ]
  },
  {
    "id": "15208",
    "description": "light",
    "pos": "YELLOW",
    "explanation": "(sun + eye: we see by the light of the sun)  - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "15209",
    "description": "lightning",
    "pos": "YELLOW",
    "explanation": "(sky + electricity: electricity that comes from the sky)  - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "15210",
    "description": "like-(to)",
    "pos": "RED",
    "explanation": "(goodness + action indicator: to have a positive or good feeling toward someone or something)",
    "isCharacter": false,
    "composition": [
      14164,
      ";",
      8993,
      "/",
      12374,
      "/",
      14947
    ]
  },
  {
    "id": "15211",
    "description": "lime",
    "pos": "YELLOW",
    "explanation": "(citrus fruit + green)",
    "isCharacter": false,
    "composition": [
      15933,
      "/",
      13377,
      "/",
      14636
    ]
  },
  {
    "id": "15212",
    "description": "limited_time,interval,period,awhile,for_a_while",
    "pos": "YELLOW",
    "explanation": "(time + limit(s))  - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "15213",
    "description": "limit(s),limitation_(OLD)",
    "pos": "YELLOW",
    "explanation": "(two reference lines on the vertical boundaries of the symbol for enclosure, limiting what lies between them)  - Character (sequenced)  SUPERSEDED SYNONYM and SUPERSEDED CHARACTER  See limit(s),limitation,restriction 25579",
    "isCharacter": true
  },
  {
    "id": "15214",
    "description": "line,stripe",
    "pos": "YELLOW",
    "explanation": "(symbol is a full-sized vertical line)  - Character",
    "isCharacter": true
  },
  {
    "id": "15215",
    "description": "linear,straight",
    "pos": "GREEN",
    "explanation": "(line + description indicator)",
    "isCharacter": false,
    "composition": [
      15214,
      ";",
      8998
    ]
  },
  {
    "id": "15216",
    "description": "linear_thing",
    "pos": "YELLOW",
    "explanation": "(line + thing indicator)",
    "isCharacter": false,
    "composition": [
      15214,
      ";",
      9009
    ]
  },
  {
    "id": "15217",
    "description": "lion",
    "pos": "YELLOW",
    "explanation": "(feline + mane_(lion_etc): male of the species has a mane)",
    "isCharacter": false,
    "composition": [
      12383,
      "/",
      25580
    ]
  },
  {
    "id": "15218",
    "description": "lip(s)",
    "pos": "YELLOW",
    "explanation": "(mouth + pointer, from above + pointer, from below: the pointers indicating the lips) - Character (superimposed - pointer)",
    "isCharacter": true
  },
  {
    "id": "15219",
    "description": "lipstick",
    "pos": "YELLOW",
    "explanation": "(colour + plus + lips: colour added to lips)",
    "isCharacter": false,
    "composition": [
      13377,
      "/",
      12374,
      "/",
      15218
    ]
  },
  {
    "id": "15220",
    "description": "list,inventory",
    "pos": "YELLOW",
    "explanation": "(paper + many + thing: written record of many things)",
    "isCharacter": false,
    "composition": [
      15962,
      "/",
      14647,
      "/",
      17717
    ]
  },
  {
    "id": "15221",
    "description": "little,small",
    "pos": "GREEN",
    "explanation": "(vertical line [half-sized] bounded by two horizontal reference lines [half-sized] + description indicator: the vertical line is relatively little) See also: big,large 12835.",
    "isCharacter": false,
    "composition": [
      24917,
      ";",
      8998
    ]
  },
  {
    "id": "15222",
    "description": "live_(life)-(to)",
    "pos": "RED",
    "explanation": "(life + action indicator)",
    "isCharacter": false,
    "composition": [
      15206,
      ";",
      8993
    ]
  },
  {
    "id": "15223",
    "description": "live,dwell,reside-(to)",
    "pos": "RED",
    "explanation": "(house + action indicator)",
    "isCharacter": false,
    "composition": [
      14905,
      ";",
      8993
    ]
  },
  {
    "id": "15224",
    "description": "living_room,lounge,sitting_room,front_room,parlor,parlour,waiting_room",
    "pos": "YELLOW",
    "explanation": "(room + chair: room where one can sit)",
    "isCharacter": false,
    "composition": [
      16687,
      "/",
      13148
    ]
  },
  {
    "id": "15226",
    "description": "crab,shellfish_(with_claws)",
    "pos": "YELLOW",
    "explanation": "(pictograph: symbol suggests a crustacean with pincers)  - Character",
    "isCharacter": true
  },
  {
    "id": "15227",
    "description": "lock-(to)",
    "pos": "RED",
    "explanation": "(key + action indicator)",
    "isCharacter": false,
    "composition": [
      15144,
      ";",
      8993
    ]
  },
  {
    "id": "15228",
    "description": "lonely,lonesome",
    "pos": "GREEN",
    "explanation": "(feeling + minus + person + description indicator: feeling of being without companionship)",
    "isCharacter": false,
    "composition": [
      14164,
      ";",
      8998,
      "/",
      15474,
      "/",
      16161
    ]
  },
  {
    "id": "15229",
    "description": "long",
    "pos": "GREEN",
    "explanation": "(length + description indicator)",
    "isCharacter": false,
    "composition": [
      15193,
      ";",
      8998
    ]
  },
  {
    "id": "15230",
    "description": "longer",
    "pos": "GREEN",
    "explanation": "(more + long + description indicator)",
    "isCharacter": false,
    "composition": [
      24879,
      "/",
      15193,
      ";",
      8998
    ]
  },
  {
    "id": "15393",
    "description": "longest",
    "pos": "GREEN",
    "explanation": "(most + long + description indicator)",
    "isCharacter": false,
    "composition": [
      24944,
      "/",
      15193,
      ";",
      8998
    ]
  },
  {
    "id": "15394",
    "description": "lose_(fail_to_keep)-(to)",
    "pos": "RED",
    "explanation": "(opposite meaning + to find + action indicator)",
    "isCharacter": false,
    "composition": [
      15927,
      "/",
      14133,
      ";",
      8993,
      "/",
      25570
    ]
  },
  {
    "id": "15395",
    "description": "lose_(fail_to_win)-(to)_(OLD)",
    "pos": "RED",
    "explanation": "(opposite meaning + to win + action indicator)  SUPERSEDED SYNONYM  See lose_(fail_to_win)-(to) 23897",
    "isCharacter": false,
    "composition": [
      15927,
      "/",
      16451,
      ";",
      8993,
      "/",
      12339
    ]
  },
  {
    "id": "15396",
    "description": "loss_(emotional)",
    "pos": "YELLOW",
    "explanation": "(feeling + to take away: emotional response to the loss of someone or something)",
    "isCharacter": false,
    "composition": [
      14164,
      "/",
      17449
    ]
  },
  {
    "id": "15397",
    "description": "loud,noisy",
    "pos": "GREEN",
    "explanation": "(noise_(loud) + description indicator)",
    "isCharacter": false,
    "composition": [
      17216,
      ";",
      8998,
      "/",
      14947
    ]
  },
  {
    "id": "15398",
    "description": "lovable",
    "pos": "GREEN",
    "explanation": "(love + description before the fact indicator)",
    "isCharacter": false,
    "composition": [
      15399,
      ";",
      8997
    ]
  },
  {
    "id": "15399",
    "description": "love,affection",
    "pos": "YELLOW",
    "explanation": "(feeling + arrow [modification, prolonged and as if partly hidden]: feeling as if an arrow is piercing one's heart) - Character (superimposed - modified)",
    "isCharacter": true
  },
  {
    "id": "15400",
    "description": "love-(to)",
    "pos": "RED",
    "explanation": "(love + action indicator)",
    "isCharacter": false,
    "composition": [
      15399,
      ";",
      8993
    ]
  },
  {
    "id": "15401",
    "description": "low,short",
    "pos": "GREEN",
    "explanation": "(lowness,shortness_(height) + description indicator: the space between the reference lines is relatively low) See also: high,tall 14711 and short 16962.",
    "isCharacter": false,
    "composition": [
      24918,
      ";",
      8998
    ]
  },
  {
    "id": "15402",
    "description": "luck,fortune",
    "pos": "YELLOW",
    "explanation": "(feeling + addition: having a \"big plus\" or advantage)",
    "isCharacter": false,
    "composition": [
      14164,
      "/",
      12339
    ]
  },
  {
    "id": "15403",
    "description": "lucky,fortunate",
    "pos": "GREEN",
    "explanation": "(luck + description after the fact indicator: feeling one has a \"big plus\" or advantage)",
    "isCharacter": false,
    "composition": [
      14164,
      ";",
      8996,
      "/",
      12339
    ]
  },
  {
    "id": "15404",
    "description": "lulav",
    "pos": "YELLOW",
    "explanation": "(3 + branch + Sukkot)",
    "isCharacter": false,
    "composition": [
      8499,
      "/",
      12894,
      "/",
      8503,
      "/",
      13639,
      "/",
      16420,
      ";",
      9009,
      "/",
      17775,
      ";",
      9011
    ]
  },
  {
    "id": "15405",
    "description": "lunch,dinner",
    "pos": "YELLOW",
    "explanation": "(meal + 2: second meal of the day)",
    "isCharacter": false,
    "composition": [
      14647,
      "/",
      14377,
      "/",
      8498
    ]
  },
  {
    "id": "15406",
    "description": "machine,appliance,engine,motor",
    "pos": "YELLOW",
    "explanation": "(sun + wheel: the sun provides the energy that drives the wheels of machinery)  - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "15407",
    "description": "magazine,journal",
    "pos": "YELLOW",
    "explanation": "(book + often: book that is published at frequent intervals)",
    "isCharacter": false,
    "composition": [
      12875,
      "/",
      14647,
      "/",
      17732
    ]
  },
  {
    "id": "15408",
    "description": "mail,post-(to)",
    "pos": "RED",
    "explanation": "(mail + action indicator)",
    "isCharacter": false,
    "composition": [
      15198,
      ";",
      8993
    ]
  },
  {
    "id": "15409",
    "description": "mailbox,letterbox,postbox",
    "pos": "YELLOW",
    "explanation": "(enclosure + letter)",
    "isCharacter": false,
    "composition": [
      13934,
      "/",
      15198
    ]
  },
  {
    "id": "15410",
    "description": "make,manufacture,produce-(to)",
    "pos": "RED",
    "explanation": "(making,production,fashioning + action indicator: imperfect version of creation, represents man-made)",
    "isCharacter": false,
    "composition": [
      23583,
      ";",
      8993
    ]
  },
  {
    "id": "15411",
    "description": "make-believe,pretend,imaginary",
    "pos": "GREEN",
    "explanation": "(fantasy,phantasy,imagination,illusion + description indicator: to let one's mind soar into the sky, or up into the clouds)",
    "isCharacter": false,
    "composition": [
      24895,
      ";",
      8998
    ]
  },
  {
    "id": "15412",
    "description": "maker,manufacturer,producer",
    "pos": "BLUE",
    "explanation": "(person + to make)",
    "isCharacter": false,
    "composition": [
      16161,
      "/",
      23583
    ]
  },
  {
    "id": "15413",
    "description": "makeup",
    "pos": "YELLOW",
    "explanation": "(colour + plus + face: colour added to the face)",
    "isCharacter": false,
    "composition": [
      13377,
      "/",
      12374,
      "/",
      14138
    ]
  },
  {
    "id": "15414",
    "description": "male,masculine_(person)",
    "pos": "GREEN",
    "explanation": "(man + description indicator)",
    "isCharacter": false,
    "composition": [
      15416,
      ";",
      8998
    ]
  },
  {
    "id": "15416",
    "description": "man,male",
    "pos": "BLUE",
    "explanation": "(person [modification] + action (combination): CKB says man embodies the action principle in society. The symbol  also looks like a stick figure of a man wearing trousers.) See also: activity,male_gender_(in_combinations) 12335, and  male,masculine_(person) 15414.  - Character (superimposed - modified - combined)",
    "isCharacter": true
  },
  {
    "id": "15417",
    "description": "male_genitals_(man_with_penis)",
    "pos": "BLUE",
    "explanation": "(standing_(standing_person) + pictograph of penis: used as the base character for penis)  - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "15418",
    "description": "manager,secretary",
    "pos": "BLUE",
    "explanation": "(person + to plan + work: person who organizes the work)",
    "isCharacter": false,
    "composition": [
      16161,
      "/",
      16194,
      "/",
      18273
    ]
  },
  {
    "id": "15419",
    "description": "mango",
    "pos": "YELLOW",
    "explanation": "(pictograph, mango with stem + pit)  - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "15420",
    "description": "man-made,produced",
    "pos": "GREEN",
    "explanation": "(making,production,fashioning + description indicator)",
    "isCharacter": false,
    "composition": [
      23583,
      ";",
      8998
    ]
  },
  {
    "id": "15421",
    "description": "map",
    "pos": "YELLOW",
    "explanation": "(paper + earth: graphic representation of the earth)",
    "isCharacter": false,
    "composition": [
      15962,
      "/",
      13901
    ]
  },
  {
    "id": "15422",
    "description": "maple-leaf",
    "pos": "YELLOW",
    "explanation": "(pictograph)  - Character",
    "isCharacter": true
  },
  {
    "id": "15423",
    "description": "March",
    "pos": "YELLOW",
    "explanation": "(month + 3: third month of the year)",
    "isCharacter": false,
    "composition": [
      15649,
      "/",
      8499
    ]
  },
  {
    "id": "15424",
    "description": "margarine",
    "pos": "YELLOW",
    "explanation": "(spread + oil)",
    "isCharacter": false,
    "composition": [
      17238,
      "/",
      15914
    ]
  },
  {
    "id": "15425",
    "description": "marriage",
    "pos": "YELLOW",
    "explanation": "(protection + combination,connection: joining together and living under one roof)  - Character (modified, superimposed)",
    "isCharacter": true
  },
  {
    "id": "15426",
    "description": "marry-(to)",
    "pos": "RED",
    "explanation": "(marriage + action indicator)",
    "isCharacter": false,
    "composition": [
      15425,
      ";",
      8993
    ]
  },
  {
    "id": "15427",
    "description": "mash,crush,squeeze,squash_(food)-(to)",
    "pos": "RED",
    "explanation": "(mash,mush,pulp_(food) + action indicator: to crush food)",
    "isCharacter": false,
    "composition": [
      25581,
      ";",
      8993
    ]
  },
  {
    "id": "15428",
    "description": "mask,false_face",
    "pos": "YELLOW",
    "explanation": "(face + fantasy,phantasy,imagination,illusion)",
    "isCharacter": false,
    "composition": [
      14138,
      "/",
      24895
    ]
  },
  {
    "id": "15429",
    "description": "masturbation",
    "pos": "YELLOW",
    "explanation": "(genitals + to touch + pleasure)",
    "isCharacter": false,
    "composition": [
      14431,
      "/",
      14667,
      "/",
      14164,
      "/",
      17983
    ]
  },
  {
    "id": "15430",
    "description": "match",
    "pos": "YELLOW",
    "explanation": "(linear thing + fire + thing indicator)",
    "isCharacter": false,
    "composition": [
      15214,
      ";",
      9009,
      "/",
      14183
    ]
  },
  {
    "id": "15431",
    "description": "material,raw_material,stuff",
    "pos": "YELLOW",
    "explanation": "(thing + earth [half-sized]: thing that you get from the earth, i.e., raw material. The symbol is also used for material in a general sense.)  - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "15432",
    "description": "mathematics,arithmetic,math_(2)",
    "pos": "YELLOW",
    "explanation": "(science + digits_(computer): science of numbers)  - Character (superimposed) SYMBOL SYNONYM",
    "isCharacter": true
  },
  {
    "id": "15433",
    "description": "maturation",
    "pos": "YELLOW",
    "explanation": "(to advance + adult: advancing toward adulthood)",
    "isCharacter": false,
    "composition": [
      14390,
      "/",
      12341
    ]
  },
  {
    "id": "15434",
    "description": "matzo",
    "pos": "YELLOW",
    "explanation": "(bread + low: unleavened bread eaten on Passover)",
    "isCharacter": false,
    "composition": [
      12895,
      "/",
      24918
    ]
  },
  {
    "id": "15435",
    "description": "May",
    "pos": "YELLOW",
    "explanation": "(month + 5: fifth month of the year)",
    "isCharacter": false,
    "composition": [
      15649,
      "/",
      8501
    ]
  },
  {
    "id": "15436",
    "description": "possibility",
    "pos": "YELLOW",
    "explanation": "(being_(state_of) + what,question_mark: expression that indicates doubt or uncertainty)",
    "isCharacter": false,
    "composition": [
      24443,
      "/",
      18229
    ]
  },
  {
    "id": "15437",
    "description": "congratulate-(to)",
    "pos": "RED",
    "explanation": "(congratulations + action indicator)",
    "isCharacter": false,
    "composition": [
      14947,
      "/",
      14164,
      ";",
      8993,
      "/",
      12339
    ]
  },
  {
    "id": "15438",
    "description": "meal",
    "pos": "YELLOW",
    "explanation": "(group of + food: group of foods served and eaten in a single sitting)",
    "isCharacter": false,
    "composition": [
      14647,
      "/",
      14377
    ]
  },
  {
    "id": "15439",
    "description": "mean,cruel",
    "pos": "GREEN",
    "explanation": "(feeling + sharp + description indicator: sharp or “cutting” in one’s manner)",
    "isCharacter": false,
    "composition": [
      14164,
      ";",
      8998,
      "/",
      15159
    ]
  },
  {
    "id": "15440",
    "description": "mean,signify-(to)",
    "pos": "RED",
    "explanation": "(meaning + action indicator)",
    "isCharacter": false,
    "composition": [
      15441,
      ";",
      8993
    ]
  },
  {
    "id": "15441",
    "description": "meaning,sense,significance",
    "pos": "YELLOW",
    "explanation": "(to think + to say + to write: significance the mind attaches to what is spoken or written)  - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "15442",
    "description": "measure-(to)",
    "pos": "RED",
    "explanation": "(measurement + action indicator)",
    "isCharacter": false,
    "composition": [
      15443,
      ";",
      8993
    ]
  },
  {
    "id": "15443",
    "description": "measurement,measure",
    "pos": "YELLOW",
    "explanation": "(length,longness + shortness_(distance,length): combination of long and short)  - Character (superimposed - combined)",
    "isCharacter": true
  },
  {
    "id": "15444",
    "description": "meat",
    "pos": "YELLOW",
    "explanation": "(food + animal: food that comes from an animal)",
    "isCharacter": false,
    "composition": [
      14377,
      "/",
      12378
    ]
  },
  {
    "id": "15445",
    "description": "meatball",
    "pos": "YELLOW",
    "explanation": "(meat + ball: meat shaped into a ball)",
    "isCharacter": false,
    "composition": [
      14377,
      "/",
      12378,
      "/",
      12621
    ]
  },
  {
    "id": "15446",
    "description": "medical,medically",
    "pos": "GREEN",
    "explanation": "(medicine,medical_practice + description indicator)",
    "isCharacter": false,
    "composition": [
      24920,
      ";",
      8998
    ]
  },
  {
    "id": "15447",
    "description": "medical_insurance",
    "pos": "YELLOW",
    "explanation": "(insurance + medical: protection against unpredictable future medical expense)",
    "isCharacter": false,
    "composition": [
      25576,
      "/",
      24920
    ]
  },
  {
    "id": "15448",
    "description": "medicine,medication",
    "pos": "YELLOW",
    "explanation": "(chemical product + medical)",
    "isCharacter": false,
    "composition": [
      13158,
      "/",
      24920
    ]
  },
  {
    "id": "15449",
    "description": "meet,encounter,see-(to)",
    "pos": "RED",
    "explanation": "(meeting,encounter + action indicator)",
    "isCharacter": false,
    "composition": [
      25583,
      ";",
      8993
    ]
  },
  {
    "id": "15450",
    "description": "meeting,assembly,conference",
    "pos": "YELLOW",
    "explanation": "(gathering + discussion)",
    "isCharacter": false,
    "composition": [
      14427,
      "/",
      15666,
      "/",
      12610
    ]
  },
  {
    "id": "15451",
    "description": "Megillah_(Book_of_Esther)",
    "pos": "YELLOW",
    "explanation": "(pictograph: symbol suggests a scroll on one post)  - Character",
    "isCharacter": true
  },
  {
    "id": "15452",
    "description": "melon",
    "pos": "YELLOW",
    "explanation": "fruit [modification]: pictograph showing a fruit with a thick rind and a stem) - Character (modified)",
    "isCharacter": true
  },
  {
    "id": "15453",
    "description": "menopause",
    "pos": "YELLOW",
    "explanation": "(end + menstruation)",
    "isCharacter": false,
    "composition": [
      13935,
      "/",
      18209,
      "/",
      17994,
      "/",
      15649
    ]
  },
  {
    "id": "15454",
    "description": "menorah",
    "pos": "YELLOW",
    "explanation": "(pictograph: symbol suggests the nine branched candelabra used on Chanukah)  - Character",
    "isCharacter": true
  },
  {
    "id": "15455",
    "description": "menstruation,menstrual_period,period",
    "pos": "YELLOW",
    "explanation": "(liquid + uterus + month)",
    "isCharacter": false,
    "composition": [
      18209,
      "/",
      17994,
      "/",
      15649
    ]
  },
  {
    "id": "15456",
    "description": "mental,intellectual,rational,thinking",
    "pos": "GREEN",
    "explanation": "(mind + description indicator)",
    "isCharacter": false,
    "composition": [
      15471,
      ";",
      8998
    ]
  },
  {
    "id": "15457",
    "description": "disabled,handicapped_(intellectually,mentally)_(OLD)",
    "pos": "GREEN",
    "explanation": "(limit(s),limitation_(OLD) + mind + description indicator: having limits to one's mental abilities)  SUPERSEDED SYNONYM  See disabled,impaired,handicapped_(intellectually,mentally) 25994",
    "isCharacter": false,
    "composition": [
      15213,
      ";",
      8998,
      "/",
      15471
    ]
  },
  {
    "id": "15458",
    "description": "merry-go-round,carousel",
    "pos": "YELLOW",
    "explanation": "(to circle + happy + thing indicator: thing to enjoy by going around and around)",
    "isCharacter": false,
    "composition": [
      24249,
      ";",
      9009,
      "/",
      14164,
      "/",
      17983
    ]
  },
  {
    "id": "15459",
    "description": "metal",
    "pos": "YELLOW",
    "explanation": "(material + metal_bar)",
    "isCharacter": false,
    "composition": [
      15431,
      "/",
      23150
    ]
  },
  {
    "id": "15460",
    "description": "metaphor",
    "pos": "YELLOW",
    "explanation": "(mouth [modification, up in the sky] + flower [modification, longer stem] + earth [half-sized] (combination): \"flowery speech\", a signal that what follows should not be taken literally)  - Character (superimposed - modified - combined)",
    "isCharacter": true
  },
  {
    "id": "15461",
    "description": "mezuzah",
    "pos": "YELLOW",
    "explanation": "(part of + Torah + door)",
    "isCharacter": false,
    "composition": [
      15972,
      "/",
      17760,
      "/",
      13866
    ]
  },
  {
    "id": "15462",
    "description": "microwave-(to)",
    "pos": "RED",
    "explanation": "(microwave oven + action indicator)",
    "isCharacter": false,
    "composition": [
      15463,
      ";",
      8993
    ]
  },
  {
    "id": "15463",
    "description": "microwave_oven",
    "pos": "YELLOW",
    "explanation": "(enclosure + electromagnetic radiation)  - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "15464",
    "description": "middle,centre",
    "pos": "YELLOW",
    "explanation": "(enclosure + pointer, to centre)  - Character (superimposed - pointer)",
    "isCharacter": true
  },
  {
    "id": "15465",
    "description": "midsummer",
    "pos": "YELLOW",
    "explanation": "(day + most + sun)",
    "isCharacter": false,
    "composition": [
      13639,
      "/",
      24944,
      "/",
      17462
    ]
  },
  {
    "id": "15466",
    "description": "military_plane",
    "pos": "YELLOW",
    "explanation": "(airplane + war)",
    "isCharacter": false,
    "composition": [
      12357,
      "/",
      18036
    ]
  },
  {
    "id": "15467",
    "description": "military_reserve_duty",
    "pos": "YELLOW",
    "explanation": "(limited time + soldier: service as a soldier for a limited time only)",
    "isCharacter": false,
    "composition": [
      15212,
      "/",
      16161,
      "/",
      18036
    ]
  },
  {
    "id": "15468",
    "description": "milk",
    "pos": "YELLOW",
    "explanation": "(drink + life: drink that sustains life)",
    "isCharacter": false,
    "composition": [
      13881,
      "/",
      15206
    ]
  },
  {
    "id": "15469",
    "description": "milkman",
    "pos": "BLUE",
    "explanation": "(person + milk)",
    "isCharacter": false,
    "composition": [
      16161,
      "/",
      13881,
      "/",
      15206
    ]
  },
  {
    "id": "15470",
    "description": "milkshake_(OLD)",
    "pos": "YELLOW",
    "explanation": "(milk + to shake)",
    "isCharacter": false,
    "composition": [
      13881,
      "/",
      15206,
      "/",
      20524
    ]
  },
  {
    "id": "15471",
    "description": "mind,intellect,reason",
    "pos": "YELLOW",
    "explanation": "(symbol suggests an outline of a skull)  - Character",
    "isCharacter": true
  },
  {
    "id": "15472",
    "description": "mine",
    "pos": "YELLOW",
    "explanation": "(mountain + dot: dot locates the position of a mine deep within the mountain)  - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "15473",
    "description": "minister,pastor,preacher,priest,rabbi",
    "pos": "BLUE",
    "explanation": "(person + to teach + God: person who gives us knowledge about God)",
    "isCharacter": false,
    "composition": [
      16161,
      "/",
      24903,
      "/",
      15162,
      "/",
      14451
    ]
  },
  {
    "id": "15474",
    "description": "minus,no,without",
    "pos": "WHITE",
    "explanation": "(subtraction [half-sized]: the small meaning of subtraction. The symbol is used before another symbol to create a  negative meaning, e.g. (minus + sound) to represent silence.)  - Character",
    "isCharacter": true
  },
  {
    "id": "15475",
    "description": "minute",
    "pos": "YELLOW",
    "explanation": "(time + apostrophe, used in astronomy to indicate a minute)",
    "isCharacter": false,
    "composition": [
      17732,
      "/",
      8489
    ]
  },
  {
    "id": "15476",
    "description": "arrow_(bent)",
    "pos": "YELLOW",
    "explanation": "(pictograph: arrow bent into another direction as if reflected)  - Character",
    "isCharacter": true
  },
  {
    "id": "15477",
    "description": "miscarriage,abortion_(spontaneous)",
    "pos": "YELLOW",
    "explanation": "(miscarriage,abortion_(general) + woman: cancelled human pregnancy due to the natural death of an embryo)",
    "isCharacter": false,
    "composition": [
      25547,
      "/",
      18269
    ]
  },
  {
    "id": "15478",
    "description": "miss,lose-(to)",
    "pos": "RED",
    "explanation": "(loss + action indicator)",
    "isCharacter": false,
    "composition": [
      14164,
      ";",
      8993,
      "/",
      17449
    ]
  },
  {
    "id": "15479",
    "description": "mistake,error,fault",
    "pos": "YELLOW",
    "explanation": "(action + incorrect)",
    "isCharacter": false,
    "composition": [
      12335,
      "/",
      25539,
      "/",
      14947
    ]
  },
  {
    "id": "15480",
    "description": "mite,tick",
    "pos": "YELLOW",
    "explanation": "(spider + little: tiny spider-like insect)",
    "isCharacter": false,
    "composition": [
      17229,
      "/",
      24917
    ]
  },
  {
    "id": "15481",
    "description": "mix,blend-(to)",
    "pos": "RED",
    "explanation": "(mixture + action indicator)",
    "isCharacter": false,
    "composition": [
      22377,
      ";",
      8993
    ]
  },
  {
    "id": "15482",
    "description": "recreation_room,moadan",
    "pos": "YELLOW",
    "explanation": "(room + happiness: room for social gatherings) (Israel)",
    "isCharacter": false,
    "composition": [
      16687,
      "/",
      14164,
      "/",
      17983
    ]
  },
  {
    "id": "15483",
    "description": "Monday_(OLD)",
    "pos": "YELLOW",
    "explanation": "(day + 2: second day of the week - based on the convention of Sunday being the first)  SUPERSEDED SYNONYM  See Monday_(day1) 25113, Monday_(day2) 25114, Monday_(day3) 25115",
    "isCharacter": false,
    "composition": [
      13639,
      "/",
      8498
    ]
  },
  {
    "id": "15484",
    "description": "money,cash",
    "pos": "YELLOW",
    "explanation": "(symbol suggests a modified rod of Mercury, the traditional symbol for trade and commerce)  - Character",
    "isCharacter": true
  },
  {
    "id": "15485",
    "description": "monkey,ape,gorilla,primate",
    "pos": "YELLOW",
    "explanation": "(animal + similar to + person: animal that resembles a person)",
    "isCharacter": false,
    "composition": [
      12378,
      "/",
      25586,
      "/",
      16713,
      "/",
      16161
    ]
  },
  {
    "id": "15486",
    "description": "monster",
    "pos": "YELLOW",
    "explanation": "(creature + strange + thing indicator: creature that is strange or unusual)",
    "isCharacter": false,
    "composition": [
      15206,
      ";",
      9009,
      "/",
      14164,
      "/",
      18229
    ]
  },
  {
    "id": "15487",
    "description": "congratulations,best_of_luck,mazel_tov",
    "pos": "GRAY",
    "explanation": "(command + luck)",
    "isCharacter": false,
    "composition": [
      14947,
      "/",
      14164,
      "/",
      12339
    ]
  },
  {
    "id": "15649",
    "description": "month",
    "pos": "YELLOW",
    "explanation": "(moon [modification, as of half-moon]) - Character (modified)",
    "isCharacter": true
  },
  {
    "id": "15650",
    "description": "mood",
    "pos": "YELLOW",
    "explanation": "(state_of_mind + feeling: state of one’s mind and emotions)",
    "isCharacter": false,
    "composition": [
      25379,
      "/",
      14164
    ]
  },
  {
    "id": "15651",
    "description": "moon",
    "pos": "YELLOW",
    "explanation": "(pictograph: crescent shape resembling the curved shape of the moon in its first quarters)  - Character",
    "isCharacter": true
  },
  {
    "id": "15652",
    "description": "moose,elk",
    "pos": "YELLOW",
    "explanation": "(cervine + big)",
    "isCharacter": false,
    "composition": [
      12381,
      "/",
      24875
    ]
  },
  {
    "id": "15653",
    "description": "moral,good,right,morally_right",
    "pos": "GREEN",
    "explanation": "(good_conscience + intensity + description indicator: can also be seen as a combination of conscience + positive) See also: correct,accurate,good,right 13416 and good,well,fine,ok,okay,all_right 14463.",
    "isCharacter": false,
    "composition": [
      25569,
      ";",
      8998,
      "/",
      14947
    ]
  },
  {
    "id": "15654",
    "description": "more",
    "pos": "GREEN",
    "explanation": "(comparative_more + description indicator: much/many on a higher level)",
    "isCharacter": false,
    "composition": [
      24879,
      ";",
      8998
    ]
  },
  {
    "id": "15655",
    "description": "morning_(before_noon)",
    "pos": "YELLOW",
    "explanation": "(day + before + 12: part of the day before noon)",
    "isCharacter": false,
    "composition": [
      13639,
      "/",
      12656,
      "/",
      8497,
      "/",
      "RK:-1",
      "/",
      8498
    ]
  },
  {
    "id": "15656",
    "description": "morning_(early)",
    "pos": "YELLOW",
    "explanation": "(combination of sun and earth: time when the sun appears above the horizon)  - Character",
    "isCharacter": true
  },
  {
    "id": "15657",
    "description": "mortal",
    "pos": "GREEN",
    "explanation": "(death + description before the fact indicator: pertaining to beings who must eventually die)",
    "isCharacter": false,
    "composition": [
      13645,
      ";",
      8997
    ]
  },
  {
    "id": "15658",
    "description": "moshav",
    "pos": "YELLOW",
    "explanation": "(village + to work + together) (Israel)",
    "isCharacter": false,
    "composition": [
      14647,
      "/",
      14905,
      "/",
      18273,
      "/",
      23409
    ]
  },
  {
    "id": "15659",
    "description": "Muslim,Moslem,Islamic",
    "pos": "GREEN",
    "explanation": "(star + crescent moon + description indicator: the star and crescent are traditional symbols for Islam)",
    "isCharacter": false,
    "composition": [
      17252,
      ";",
      8998,
      "/",
      15651
    ]
  },
  {
    "id": "15660",
    "description": "mosquito,gadfly,horsefly,cleg",
    "pos": "YELLOW",
    "explanation": "(insect + to fly + to puncture: flying insect that punctures the skin)",
    "isCharacter": false,
    "composition": [
      14371,
      "/",
      16212
    ]
  },
  {
    "id": "15661",
    "description": "most,maximum",
    "pos": "GREEN",
    "explanation": "(superlative_most + description indicator: much/many on the highest level)",
    "isCharacter": false,
    "composition": [
      24944,
      ";",
      8998
    ]
  },
  {
    "id": "15662",
    "description": "mother,mom,mommy,mum",
    "pos": "BLUE",
    "explanation": "(protection + woman: woman who gives protection to her family)  - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "15663",
    "description": "mountain",
    "pos": "YELLOW",
    "explanation": "(pictograph: symbol suggests the side view of a mountain slope)  - Character",
    "isCharacter": true
  },
  {
    "id": "15664",
    "description": "mountain_berry,cowberry,lingonberry",
    "pos": "YELLOW",
    "explanation": "(berry + mountain: berry that grows in uplands)",
    "isCharacter": false,
    "composition": [
      12666,
      "/",
      15663
    ]
  },
  {
    "id": "15665",
    "description": "mouse",
    "pos": "YELLOW",
    "explanation": "(rodent + little: rodent that is smaller than a rat)",
    "isCharacter": false,
    "composition": [
      12378,
      "/",
      17517,
      "/",
      24917
    ]
  },
  {
    "id": "15666",
    "description": "mouth",
    "pos": "YELLOW",
    "explanation": "(pictograph: symbol suggests a round open mouth)  - Character",
    "isCharacter": true
  },
  {
    "id": "15667",
    "description": "move-(to)",
    "pos": "RED",
    "explanation": "(move,movement + action indicator: the wheel moves by rolling over the ground)",
    "isCharacter": false,
    "composition": [
      25119,
      ";",
      8993
    ]
  },
  {
    "id": "15668",
    "description": "move_bowels,defecate,stool,shit,ca-ca-(to)",
    "pos": "RED",
    "explanation": "(bowel movement + action indicator)",
    "isCharacter": false,
    "composition": [
      18043,
      ";",
      8993,
      "/",
      13097
    ]
  },
  {
    "id": "15669",
    "description": "movie,film",
    "pos": "YELLOW",
    "explanation": "(cylinder + projector)",
    "isCharacter": false,
    "composition": [
      13115,
      "/",
      16254
    ]
  },
  {
    "id": "15670",
    "description": "movie_theatre,cinema",
    "pos": "YELLOW",
    "explanation": "(building + projector)",
    "isCharacter": false,
    "composition": [
      14905,
      "/",
      16254
    ]
  },
  {
    "id": "15671",
    "description": "much,many,very",
    "pos": "GREEN",
    "explanation": "(quantity + description indicator)",
    "isCharacter": false,
    "composition": [
      14647,
      ";",
      8998
    ]
  },
  {
    "id": "15672",
    "description": "mud,clay",
    "pos": "YELLOW",
    "explanation": "(earth [modification, extended line] + water_(ground_level): mixture composed of more earth than water)  - Character (superimposed - modified)",
    "isCharacter": true
  },
  {
    "id": "15673",
    "description": "multiplication",
    "pos": "YELLOW",
    "explanation": "(based upon the international mathematical symbol)  - Character",
    "isCharacter": true
  },
  {
    "id": "15674",
    "description": "multiply-(to)",
    "pos": "RED",
    "explanation": "(multiplication + action indicator)",
    "isCharacter": false,
    "composition": [
      15673,
      ";",
      8993
    ]
  },
  {
    "id": "15675",
    "description": "multitude",
    "pos": "YELLOW",
    "explanation": "(multiplication + thing indicator: large number of people or things. The symbol is the concrete form of multiplication.)  - (character with thing indicator)",
    "isCharacter": "false",
    "composition": [
      15673,
      ";",
      9009
    ]
  },
  {
    "id": "15676",
    "description": "muscle_(OLD)",
    "pos": "YELLOW",
    "explanation": "(arm + pictograph of bulging biceps + pointer)  - Character (superimposed - pointer)  SUPERSEDED SYNONYM and SUPERSEDED CHARACTER  See muscle 20517",
    "isCharacter": true
  },
  {
    "id": "15677",
    "description": "museum",
    "pos": "YELLOW",
    "explanation": "(building + thing + interesting + plural indicator: building where interesting things are displayed)",
    "isCharacter": false,
    "composition": [
      14905,
      "/",
      17717,
      ";",
      9011,
      "/",
      24916
    ]
  },
  {
    "id": "15678",
    "description": "mushroom",
    "pos": "YELLOW",
    "explanation": "(pictograph)  - Character",
    "isCharacter": true
  },
  {
    "id": "15679",
    "description": "music",
    "pos": "YELLOW",
    "explanation": "(ear + musical note)",
    "isCharacter": false,
    "composition": [
      13894,
      "/",
      15682
    ]
  },
  {
    "id": "15680",
    "description": "musical_group",
    "pos": "BLUE",
    "explanation": "(group + musical note)",
    "isCharacter": false,
    "composition": [
      14647,
      "/",
      16161,
      "/",
      15682
    ]
  },
  {
    "id": "15681",
    "description": "musical_instrument",
    "pos": "YELLOW",
    "explanation": "(instrument + musical note)",
    "isCharacter": false,
    "composition": [
      17755,
      "/",
      15682
    ]
  },
  {
    "id": "15682",
    "description": "musical_note,music_(in_combinations)",
    "pos": "YELLOW",
    "explanation": "(international symbol)  - Character",
    "isCharacter": true
  },
  {
    "id": "15683",
    "description": "musician",
    "pos": "BLUE",
    "explanation": "(person + musical note: person who makes music)",
    "isCharacter": false,
    "composition": [
      16161,
      "/",
      15682
    ]
  },
  {
    "id": "15684",
    "description": "muskrat",
    "pos": "YELLOW",
    "explanation": "(combination of water animal and rodent: rodent at home in water)",
    "isCharacter": false,
    "composition": [
      12389,
      "/",
      17517
    ]
  },
  {
    "id": "15685",
    "description": "must,have_to,be_forced_to-(to)",
    "pos": "RED",
    "explanation": "(must_(a) + action indicator)          -  Note, original derivation in BRG is: (to force + passive indicator: to be forced to do something)",
    "isCharacter": false,
    "composition": [
      22914,
      ";",
      8993
    ]
  },
  {
    "id": "15686",
    "description": "my,mine",
    "pos": "BLUE",
    "explanation": "(I + belongs to: first person singular, possessive)",
    "isCharacter": false,
    "composition": [
      16161,
      "/",
      8497,
      "/",
      12663
    ]
  },
  {
    "id": "15687",
    "description": "my,mine-(feminine)",
    "pos": "BLUE",
    "explanation": "(female + 1 + belongs to: first person singular (f.), possessive)",
    "isCharacter": false,
    "composition": [
      18269,
      "/",
      8497,
      "/",
      12663
    ]
  },
  {
    "id": "15688",
    "description": "my,mine-(masculine)",
    "pos": "BLUE",
    "explanation": "(male + 1 + belongs to: first person singular (m.), possessive)",
    "isCharacter": false,
    "composition": [
      15416,
      "/",
      8497,
      "/",
      12663
    ]
  },
  {
    "id": "15689",
    "description": "nail",
    "pos": "YELLOW",
    "explanation": "(pictograph: symbol suggests a nail. It is twice the height of the pin symbol)  - Character",
    "isCharacter": true
  },
  {
    "id": "15690",
    "description": "nail_polish,nail_varnish",
    "pos": "YELLOW",
    "explanation": "(colour + plus + finger: colour added to fingernails)",
    "isCharacter": false,
    "composition": [
      13377,
      "/",
      12374,
      "/",
      14180
    ]
  },
  {
    "id": "15691",
    "description": "name,label,term,title",
    "pos": "YELLOW",
    "explanation": "(pen + mouth: something that can be spoken or written)  - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "15692",
    "description": "napkin,serviette",
    "pos": "YELLOW",
    "explanation": "(cloth + to eat)",
    "isCharacter": false,
    "composition": [
      13365,
      "/",
      14377
    ]
  },
  {
    "id": "15693",
    "description": "narrow",
    "pos": "GREEN",
    "explanation": "(opposite meaning + wide + description indicator)",
    "isCharacter": false,
    "composition": [
      15927,
      "/",
      25634,
      ";",
      8998
    ]
  },
  {
    "id": "15694",
    "description": "naughty",
    "pos": "GREEN",
    "explanation": "(bad + comma + little + description indicator)",
    "isCharacter": false,
    "composition": [
      14164,
      ";",
      8998,
      "/",
      15474,
      "/",
      14947,
      "/",
      8487,
      "/",
      24917
    ]
  },
  {
    "id": "15695",
    "description": "naughty,not_nice",
    "pos": "GREEN",
    "explanation": "(feeling + incorrect + description indicator)",
    "isCharacter": false,
    "composition": [
      14164,
      ";",
      8998,
      "/",
      25539,
      "/",
      14947
    ]
  },
  {
    "id": "15696",
    "description": "navy",
    "pos": "YELLOW",
    "explanation": "(group + war + water: group trained for war at sea)",
    "isCharacter": false,
    "composition": [
      14647,
      "/",
      16161,
      "/",
      18036,
      "/",
      25777
    ]
  },
  {
    "id": "15697",
    "description": "near,almost,close,nearly",
    "pos": "GREEN",
    "explanation": "(nearness,closeness,proximity + description indicator)",
    "isCharacter": false,
    "composition": [
      25586,
      ";",
      8998
    ]
  },
  {
    "id": "15698",
    "description": "necessary,necessarily,needed",
    "pos": "GREEN",
    "explanation": "(need + description indicator)",
    "isCharacter": false,
    "composition": [
      15701,
      ";",
      8998
    ]
  },
  {
    "id": "15699",
    "description": "neck_(head)",
    "pos": "YELLOW",
    "explanation": "(head + pictograph of neck + pointer, to neck)  - Character (superimposed - pointer)",
    "isCharacter": true
  },
  {
    "id": "15700",
    "description": "neck_(body)",
    "pos": "YELLOW",
    "explanation": "(body + pointer, to neck)  - Character (superimposed - pointer)",
    "isCharacter": true
  },
  {
    "id": "15701",
    "description": "need_(needy_person)",
    "pos": "YELLOW",
    "explanation": "(person, leaning, as if in need of support)  - Character",
    "isCharacter": true
  },
  {
    "id": "15702",
    "description": "need-(to)",
    "pos": "RED",
    "explanation": "(need + action indicator: the leaning person needs support)",
    "isCharacter": false,
    "composition": [
      15701,
      ";",
      8993
    ]
  },
  {
    "id": "15703",
    "description": "needle",
    "pos": "YELLOW",
    "explanation": "(pictograph: symbol suggests a sewing needle with an eye)  - Character",
    "isCharacter": true
  },
  {
    "id": "15704",
    "description": "hypodermic_needle",
    "pos": "YELLOW",
    "explanation": "(hypodermic_needlepoint + thing indicator: or semantically more reasonable; syringe + pointer, to needlepoint)  - (character with thing indicator)",
    "isCharacter": "false",
    "composition": [
      25573,
      ";",
      9009
    ]
  },
  {
    "id": "15705",
    "description": "neighbour",
    "pos": "BLUE",
    "explanation": "(person + to live + near)",
    "isCharacter": false,
    "composition": [
      16161,
      "/",
      14905,
      "/",
      25586
    ]
  },
  {
    "id": "15706",
    "description": "neither",
    "pos": "WHITE",
    "explanation": "(minus + either)",
    "isCharacter": false,
    "composition": [
      15474,
      "/",
      13914
    ]
  },
  {
    "id": "15707",
    "description": "nephew",
    "pos": "BLUE",
    "explanation": "(son + sibling: son of one's brother or sister)",
    "isCharacter": false,
    "composition": [
      17209,
      "/",
      15912,
      "/",
      8498
    ]
  },
  {
    "id": "15708",
    "description": "Netherlands_(The),Holland",
    "pos": "YELLOW",
    "explanation": "(country + low)",
    "isCharacter": false,
    "composition": [
      13423,
      "/",
      24918
    ]
  },
  {
    "id": "15709",
    "description": "never_(OLD)",
    "pos": "GREEN",
    "explanation": "(opposite meaning + always + description indicator)  SUPERSEDED SYNONYM  See never 23906",
    "isCharacter": false,
    "composition": [
      15927,
      "/",
      17732,
      ";",
      8998,
      "/",
      12360
    ]
  },
  {
    "id": "15710",
    "description": "new",
    "pos": "GREEN",
    "explanation": "(newness,novelty + description indicator)",
    "isCharacter": false,
    "composition": [
      25587,
      ";",
      8998
    ]
  },
  {
    "id": "15711",
    "description": "New_Year's_Day",
    "pos": "YELLOW",
    "explanation": "(birthday + year: day that a new year is born)",
    "isCharacter": false,
    "composition": [
      13639,
      "/",
      12843,
      "/",
      18289
    ]
  },
  {
    "id": "15712",
    "description": "news",
    "pos": "YELLOW",
    "explanation": "(eye + ear: information received through the eye and the ear)  - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "15713",
    "description": "newspaper,bulletin,newsletter",
    "pos": "YELLOW",
    "explanation": "(page + news)",
    "isCharacter": false,
    "composition": [
      15962,
      "/",
      15712
    ]
  },
  {
    "id": "15714",
    "description": "next",
    "pos": "GREEN",
    "explanation": "(first + after + description indicator: coming directly after)",
    "isCharacter": false,
    "composition": [
      8497,
      ";",
      8998,
      "/",
      8486,
      "/",
      12348
    ]
  },
  {
    "id": "15715",
    "description": "next_week",
    "pos": "YELLOW",
    "explanation": "(week + then (future))",
    "isCharacter": false,
    "composition": [
      8503,
      "/",
      13639,
      "/",
      17705
    ]
  },
  {
    "id": "15716",
    "description": "next_year",
    "pos": "YELLOW",
    "explanation": "(year + then (future))",
    "isCharacter": false,
    "composition": [
      18289,
      "/",
      "RK:-2",
      "/",
      17705
    ]
  },
  {
    "id": "15717",
    "description": "nice,pleasant",
    "pos": "GREEN",
    "explanation": "(feeling + correct + description indicator: felt to be socially \"correct\")",
    "isCharacter": false,
    "composition": [
      14164,
      ";",
      8998,
      "/",
      25538,
      "/",
      14947
    ]
  },
  {
    "id": "15718",
    "description": "niece",
    "pos": "BLUE",
    "explanation": "(daughter + sibling: daughter of one's brother or sister)",
    "isCharacter": false,
    "composition": [
      13638,
      "/",
      15912,
      "/",
      8498
    ]
  },
  {
    "id": "15719",
    "description": "night",
    "pos": "YELLOW",
    "explanation": "(moon + earth: the moon appears above the horizon; it shines on the earth during the night)  - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "15720",
    "description": "nipple(s)",
    "pos": "YELLOW",
    "explanation": "(part of + breasts)",
    "isCharacter": false,
    "composition": [
      15972,
      "/",
      12899
    ]
  },
  {
    "id": "15721",
    "description": "Nisan,Nissan",
    "pos": "YELLOW",
    "explanation": "(month + unleavened bread: month of Passover, the first month of the year)",
    "isCharacter": false,
    "composition": [
      15649,
      "/",
      12895,
      "/",
      24918
    ]
  },
  {
    "id": "15722",
    "description": "no-(exclamatory)",
    "pos": "GRAY",
    "explanation": "(not + intensity: strong negative response)",
    "isCharacter": false,
    "composition": [
      15474,
      "/",
      14947,
      "/",
      14947
    ]
  },
  {
    "id": "15723",
    "description": "no_one,nobody",
    "pos": "BLUE",
    "explanation": "(minus + person)",
    "isCharacter": false,
    "composition": [
      15474,
      "/",
      16161
    ]
  },
  {
    "id": "15724",
    "description": "nocturnal_emission,wet_dream",
    "pos": "YELLOW",
    "explanation": "(ejaculation + to sleep)",
    "isCharacter": false,
    "composition": [
      13944,
      "/",
      17226,
      "/",
      14947,
      "/",
      17008
    ]
  },
  {
    "id": "15725",
    "description": "none,nothing_(OLD)",
    "pos": "WHITE",
    "explanation": "(opposite meaning + all)  SUPERSEDED SYNONYM  See nothing,none 23907",
    "isCharacter": false,
    "composition": [
      15927,
      "/",
      12360
    ]
  },
  {
    "id": "15726",
    "description": "nonsense",
    "pos": "YELLOW",
    "explanation": "(meaning + deletion,cancellation,destruction: something that has no meaning)  - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "15727",
    "description": "nonsense-(exclamatory)",
    "pos": "GRAY",
    "explanation": "(nonsense + intensity symbol: exclamation)",
    "isCharacter": false,
    "composition": [
      15726,
      "/",
      14947
    ]
  },
  {
    "id": "15728",
    "description": "nonspeaking",
    "pos": "GREEN",
    "explanation": "(no_speech,anarthria + description indicator: unable to speak). See also: speech_impaired 26025",
    "isCharacter": false,
    "composition": [
      25588,
      ";",
      8998
    ]
  },
  {
    "id": "15729",
    "description": "nor",
    "pos": "WHITE",
    "explanation": "(minus + or)",
    "isCharacter": false,
    "composition": [
      15474,
      "/",
      15929
    ]
  },
  {
    "id": "15730",
    "description": "north",
    "pos": "YELLOW",
    "explanation": "(sun + pointer, to north)  - Character (superimposed - pointer)",
    "isCharacter": true
  },
  {
    "id": "15731",
    "description": "northern",
    "pos": "GREEN",
    "explanation": "(north + description indicator)",
    "isCharacter": false,
    "composition": [
      15730,
      ";",
      8998
    ]
  },
  {
    "id": "15732",
    "description": "nose",
    "pos": "YELLOW",
    "explanation": "(pictograph: symbol suggests the side view of a nose)  - Character",
    "isCharacter": true
  },
  {
    "id": "15733",
    "description": "not,negative,no,don't,doesn't",
    "pos": "WHITE",
    "explanation": "(minus + intensity: also used before a verb to create a negative sentence)",
    "isCharacter": false,
    "composition": [
      15474,
      "/",
      14947
    ]
  },
  {
    "id": "15734",
    "description": "notebook,writing_book",
    "pos": "YELLOW",
    "explanation": "(book + to write)",
    "isCharacter": false,
    "composition": [
      12875,
      "/",
      15991
    ]
  },
  {
    "id": "15735",
    "description": "November",
    "pos": "YELLOW",
    "explanation": "(month + 11: eleventh month of the year)",
    "isCharacter": false,
    "composition": [
      15649,
      "/",
      8497,
      "/",
      "RK:-1",
      "/",
      8497
    ]
  },
  {
    "id": "15736",
    "description": "now",
    "pos": "WHITE",
    "explanation": "(ago,then_(past) + then,so,later: present [half-sized])  - Character (sequenced)",
    "isCharacter": true
  },
  {
    "id": "15737",
    "description": "nowhere,no_place",
    "pos": "WHITE",
    "explanation": "(minus + ground: a combination of minus and place)  - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "15738",
    "description": "nuclear_energy",
    "pos": "YELLOW",
    "explanation": "(energy + nucleus: energy released by a nuclear reaction)",
    "isCharacter": false,
    "composition": [
      13936,
      "/",
      15741
    ]
  },
  {
    "id": "15739",
    "description": "nuclear_fallout,radioactive_dust",
    "pos": "YELLOW",
    "explanation": "(dust + nucleus)",
    "isCharacter": false,
    "composition": [
      16233,
      "/",
      15741
    ]
  },
  {
    "id": "15740",
    "description": "nuclear_radiation,radioactivity",
    "pos": "YELLOW",
    "explanation": "(pointer (left) + nucleus + pointer (right): suggesting radiation of radioactive particles)  - Character (superimposed - pointer)",
    "isCharacter": true
  },
  {
    "id": "15741",
    "description": "nucleus_(atom)",
    "pos": "YELLOW",
    "explanation": "(atom + pointer (small), to inner nucleus)  - Character (superimposed - pointer (small))",
    "isCharacter": true
  },
  {
    "id": "15742",
    "description": "number",
    "pos": "YELLOW",
    "explanation": "(international symbol)  - Character",
    "isCharacter": true
  },
  {
    "id": "15905",
    "description": "nurse",
    "pos": "BLUE",
    "explanation": "(person + to care for + medical: person who gives medical care)",
    "isCharacter": false,
    "composition": [
      16161,
      "/",
      16420,
      "/",
      24920
    ]
  },
  {
    "id": "15906",
    "description": "nut",
    "pos": "YELLOW",
    "explanation": "(seed + tree: edible seed from a tree)",
    "isCharacter": false,
    "composition": [
      16749,
      "/",
      17775
    ]
  },
  {
    "id": "15907",
    "description": "obey,comply-(to)",
    "pos": "RED",
    "explanation": "(to do + by + to guide + action indicator: to do something by the rules)",
    "isCharacter": false,
    "composition": [
      12335,
      ";",
      8993,
      "/",
      13100,
      "/",
      22913
    ]
  },
  {
    "id": "15908",
    "description": "observe-(to)",
    "pos": "RED",
    "explanation": "(observation + action indicator: to look at something thoughtfully)",
    "isCharacter": false,
    "composition": [
      24846,
      ";",
      8993
    ]
  },
  {
    "id": "15909",
    "description": "ocean,sea",
    "pos": "YELLOW",
    "explanation": "(much + much + water: large body of water)",
    "isCharacter": false,
    "composition": [
      14647,
      "/",
      14647,
      "/",
      25777
    ]
  },
  {
    "id": "15910",
    "description": "October",
    "pos": "YELLOW",
    "explanation": "(month + 10: tenth month of the year)",
    "isCharacter": false,
    "composition": [
      15649,
      "/",
      8497,
      "/",
      "RK:-1",
      "/",
      8496
    ]
  },
  {
    "id": "15911",
    "description": "office",
    "pos": "YELLOW",
    "explanation": "(room + work + pencil: room where work is done)",
    "isCharacter": false,
    "composition": [
      16687,
      "/",
      18273,
      "/",
      15991
    ]
  },
  {
    "id": "15912",
    "description": "offspring,child",
    "pos": "BLUE",
    "explanation": "(protection + male + female: male or female born under the family roof)  - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "15913",
    "description": "often,frequent,frequently",
    "pos": "GREEN",
    "explanation": "(many + time + description indicator: on many occasions)",
    "isCharacter": false,
    "composition": [
      14647,
      "/",
      17732,
      ";",
      8998
    ]
  },
  {
    "id": "15914",
    "description": "oil,lubricant",
    "pos": "YELLOW",
    "explanation": "(water,fluid,liquid + water_(ground_level): two parallel liquid symbols, suggesting oil that floats on water) - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "15915",
    "description": "old_(opposite_new)",
    "pos": "GREEN",
    "explanation": "(opposite meaning + new + description indicator)  Also see old 23910",
    "isCharacter": false,
    "composition": [
      15927,
      "/",
      25587,
      ";",
      8998
    ]
  },
  {
    "id": "15916",
    "description": "old,elderly",
    "pos": "GREEN",
    "explanation": "(opposite meaning + young + description indicator)",
    "isCharacter": false,
    "composition": [
      15927,
      "/",
      13166,
      ";",
      8998
    ]
  },
  {
    "id": "15917",
    "description": "olive",
    "pos": "YELLOW",
    "explanation": "(pictograph: fruit [oval shaped] with stem)  - Character",
    "isCharacter": true
  },
  {
    "id": "15918",
    "description": "on",
    "pos": "WHITE",
    "explanation": "(earth [half-sized] + pointer: refers only to space, e.g. on the table)  - Character (superimposed - pointer)",
    "isCharacter": true
  },
  {
    "id": "15919",
    "description": "once",
    "pos": "GREEN",
    "explanation": "(1 + time + description indicator: on one occasion)",
    "isCharacter": false,
    "composition": [
      8497,
      "/",
      17732,
      ";",
      8998
    ]
  },
  {
    "id": "15920",
    "description": "bulb_(plant)",
    "pos": "YELLOW",
    "explanation": "(pictograph + earth)  - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "15921",
    "description": "open",
    "pos": "GREEN",
    "explanation": "(opening + description indicator)",
    "isCharacter": false,
    "composition": [
      15923,
      ";",
      8998
    ]
  },
  {
    "id": "15922",
    "description": "open-(to)",
    "pos": "RED",
    "explanation": "(opening + action indicator)",
    "isCharacter": false,
    "composition": [
      15923,
      ";",
      8993
    ]
  },
  {
    "id": "15923",
    "description": "opening",
    "pos": "YELLOW",
    "explanation": "(enclosure, open at the top)  - Character",
    "isCharacter": true
  },
  {
    "id": "15924",
    "description": "operation",
    "pos": "YELLOW",
    "explanation": "(to cut + medical)",
    "isCharacter": false,
    "composition": [
      15159,
      "/",
      24920
    ]
  },
  {
    "id": "15925",
    "description": "opinion",
    "pos": "YELLOW",
    "explanation": "(mind + mouth: expression of what one thinks)  - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "15926",
    "description": "opossum,possum",
    "pos": "YELLOW",
    "explanation": "(marsupial + night: marsupial that comes out at night)",
    "isCharacter": false,
    "composition": [
      12378,
      "/",
      13403,
      "/",
      15719
    ]
  },
  {
    "id": "15927",
    "description": "opposite_meaning,opposite_of,opposite",
    "pos": "GRAY",
    "explanation": "(combination of up and down: up is the opposite of down. The symbol is placed before a second symbol to create an antonym or meaning that is the opposite of that of the second symbol.)  - Character",
    "isCharacter": true
  },
  {
    "id": "15928",
    "description": "opposition,counter_purpose",
    "pos": "YELLOW",
    "explanation": "(less_than_(relation) + less_than_(relation), pointing in the opposite direction from the purpose symbol)  - Character (sequenced)",
    "isCharacter": true
  },
  {
    "id": "15929",
    "description": "or",
    "pos": "WHITE",
    "explanation": "(by,by_means_of,of (relation [half-sized], pointing backward) + dot: the second alternative, the reverse of either)  - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "15930",
    "description": "oral_sex",
    "pos": "YELLOW",
    "explanation": "(to combine + genitals + mouth)",
    "isCharacter": false,
    "composition": [
      13380,
      "/",
      14431,
      "/",
      15666
    ]
  },
  {
    "id": "15931",
    "description": "orange_(bci)",
    "pos": "WHITE",
    "explanation": "(colour + mouth + sun: combination of red and yellow) (BCI) SYMBOL SYNONYM",
    "isCharacter": false,
    "composition": [
      13377,
      "/",
      15666,
      "/",
      17462
    ]
  },
  {
    "id": "15932",
    "description": "orange_(ckb)",
    "pos": "WHITE",
    "explanation": "(colour + 2) (CKB) SYMBOL SYNONYM",
    "isCharacter": false,
    "composition": [
      13377,
      "/",
      8498
    ]
  },
  {
    "id": "15933",
    "description": "orange,citrus_fruit",
    "pos": "YELLOW",
    "explanation": "(fruit + pictograph of segments)  - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "15934",
    "description": "orchard",
    "pos": "YELLOW",
    "explanation": "(grove + fruit)",
    "isCharacter": false,
    "composition": [
      14647,
      "/",
      17775,
      "/",
      14405
    ]
  },
  {
    "id": "15935",
    "description": "organize,arrange-(to)",
    "pos": "RED",
    "explanation": "(to plan + many + thing + action indicator: to make a system from many things)",
    "isCharacter": false,
    "composition": [
      16194,
      ";",
      8993,
      "/",
      14647,
      "/",
      17717
    ]
  },
  {
    "id": "15936",
    "description": "orgasm",
    "pos": "YELLOW",
    "explanation": "(ecstasy + genitals)",
    "isCharacter": false,
    "composition": [
      14164,
      "/",
      14947,
      "/",
      14947,
      "/",
      14947,
      "/",
      14431
    ]
  },
  {
    "id": "15937",
    "description": "ostrich",
    "pos": "YELLOW",
    "explanation": "(bird + to walk: bird that walks or runs but does not fly)",
    "isCharacter": false,
    "composition": [
      12837,
      "/",
      15189
    ]
  },
  {
    "id": "15938",
    "description": "other,another_(person)",
    "pos": "BLUE",
    "explanation": "(person [modification] + 2: referring to a second person)",
    "isCharacter": true
  },
  {
    "id": "15939",
    "description": "our,ours-(feminine)",
    "pos": "BLUE",
    "explanation": "(female + 1 + belongs to + plural indicator: first person plural (f.), possessive)",
    "isCharacter": false,
    "composition": [
      18269,
      ";",
      9011,
      "/",
      8497,
      "/",
      12663
    ]
  },
  {
    "id": "15940",
    "description": "our,ours-(masculine)",
    "pos": "BLUE",
    "explanation": "(male + 1 + belongs to + plural indicator: first person plural (m.), possessive)",
    "isCharacter": false,
    "composition": [
      15416,
      ";",
      9011,
      "/",
      8497,
      "/",
      12663
    ]
  },
  {
    "id": "15941",
    "description": "our,ours",
    "pos": "BLUE",
    "explanation": "(we + belongs to + plural indicator: first person plural, possessive)",
    "isCharacter": false,
    "composition": [
      16161,
      ";",
      9011,
      "/",
      8497,
      "/",
      12663
    ]
  },
  {
    "id": "15942",
    "description": "out,exterior,external,outside",
    "pos": "WHITE",
    "explanation": "(enclosure + dot, outside the enclosure)  - Character (sequenced)",
    "isCharacter": true
  },
  {
    "id": "15943",
    "description": "out_of,exit_(forward)",
    "pos": "WHITE",
    "explanation": "(enclosure + forward: the arrow is moving out of the enclosure)  - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "15944",
    "description": "out_of,exit_(downward)",
    "pos": "WHITE",
    "explanation": "(enclosure + downward)  - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "15945",
    "description": "outing,excursion",
    "pos": "YELLOW",
    "explanation": "(legs and feet + out of)",
    "isCharacter": false,
    "composition": [
      15189,
      "/",
      15943
    ]
  },
  {
    "id": "15946",
    "description": "oval,ellipse_(shape)",
    "pos": "YELLOW",
    "explanation": "(shape + oval)",
    "isCharacter": false,
    "composition": [
      14133,
      "/",
      17717,
      "/",
      23599
    ]
  },
  {
    "id": "15947",
    "description": "ovary",
    "pos": "YELLOW",
    "explanation": "(container + egg)",
    "isCharacter": false,
    "composition": [
      13403,
      "/",
      13912
    ]
  },
  {
    "id": "15948",
    "description": "over,above,superior",
    "pos": "WHITE",
    "explanation": "(dot + horizontal reference line: the dot is over or above the line)  - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "15949",
    "description": "owl,night_bird",
    "pos": "YELLOW",
    "explanation": "(bird + night)",
    "isCharacter": false,
    "composition": [
      12837,
      "/",
      15719
    ]
  },
  {
    "id": "15950",
    "description": "own,possess-(to)",
    "pos": "RED",
    "explanation": "(ownership,possession + action indicator: CKB writes \"an addition, a gain, a plus of some very earthly (material) thing”)",
    "isCharacter": false,
    "composition": [
      24925,
      ";",
      8993
    ]
  },
  {
    "id": "15951",
    "description": "ox",
    "pos": "YELLOW",
    "explanation": "(bovine + work: horned animal commonly used to assist with heavy labour)",
    "isCharacter": false,
    "composition": [
      12379,
      "/",
      18273
    ]
  },
  {
    "id": "15952",
    "description": "oyster,clam,mussel",
    "pos": "YELLOW",
    "explanation": "(pictograph of shell + water)  - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "15953",
    "description": "pail,bucket",
    "pos": "YELLOW",
    "explanation": "(pictograph: symbol suggests a pail with a handle)  - Character",
    "isCharacter": true
  },
  {
    "id": "15954",
    "description": "pain,suffering",
    "pos": "YELLOW",
    "explanation": "(feeling + sick: discomfort that makes one \"draw up one's knees\". The symbol usually represents physical pain but also can be used to represent emotional distress and suffering.)",
    "isCharacter": false,
    "composition": [
      14164,
      "/",
      "RK:-2",
      "/",
      16164
    ]
  },
  {
    "id": "15955",
    "description": "painful,painfully,sore",
    "pos": "GREEN",
    "explanation": "(pain + description indicator)",
    "isCharacter": false,
    "composition": [
      14164,
      ";",
      8998,
      "/",
      "RK:-2",
      "/",
      16164
    ]
  },
  {
    "id": "15956",
    "description": "paint,dye",
    "pos": "YELLOW",
    "explanation": "(chemical product + colour + liquid)",
    "isCharacter": false,
    "composition": [
      13158,
      "/",
      13377,
      "/",
      18209
    ]
  },
  {
    "id": "15957",
    "description": "paint,dye-(to)",
    "pos": "RED",
    "explanation": "(paint + action indicator)",
    "isCharacter": false,
    "composition": [
      13158,
      ";",
      8993,
      "/",
      13377,
      "/",
      18209
    ]
  },
  {
    "id": "15958",
    "description": "painter",
    "pos": "BLUE",
    "explanation": "(person + paint [contraction])",
    "isCharacter": false,
    "composition": [
      16161,
      "/",
      13377,
      "/",
      18209
    ]
  },
  {
    "id": "15959",
    "description": "pair",
    "pos": "YELLOW",
    "explanation": "(2 + thing indicator: two items)  - (character with thing indicator)",
    "isCharacter": "false",
    "composition": [
      8498,
      ";",
      9009
    ]
  },
  {
    "id": "15960",
    "description": "palm",
    "pos": "YELLOW",
    "explanation": "(pictograph: the symbols suggests a tree with curved fronds)  - Character",
    "isCharacter": true
  },
  {
    "id": "15961",
    "description": "pants,jeans,slacks,trousers",
    "pos": "YELLOW",
    "explanation": "(clothing + leg: clothing that covers the legs)",
    "isCharacter": false,
    "composition": [
      13366,
      "/",
      15188
    ]
  },
  {
    "id": "15962",
    "description": "paper,card,page",
    "pos": "YELLOW",
    "explanation": "(pictograph: symbol suggests a sheet of paper or a page of a book) See also: book 12875  - Character",
    "isCharacter": true
  },
  {
    "id": "15963",
    "description": "parakeet,budgie",
    "pos": "YELLOW",
    "explanation": "(parrot + little: small bird that can be trained to talk)",
    "isCharacter": false,
    "composition": [
      12837,
      "/",
      "RK:-2",
      "/",
      15666,
      "/",
      8487,
      "/",
      24917
    ]
  },
  {
    "id": "15964",
    "description": "parallel",
    "pos": "YELLOW",
    "explanation": "(line + line: international mathematical symbol)  - Character",
    "isCharacter": true
  },
  {
    "id": "15965",
    "description": "paratrooper",
    "pos": "BLUE",
    "explanation": "(soldier + from_sky: soldier trained to jump down from the sky using a parachute)",
    "isCharacter": false,
    "composition": [
      16161,
      "/",
      18036,
      "/",
      25566
    ]
  },
  {
    "id": "15966",
    "description": "parcel,package",
    "pos": "YELLOW",
    "explanation": "(pictograph)  - Character",
    "isCharacter": true
  },
  {
    "id": "15967",
    "description": "pardon,what_did_you_say",
    "pos": "GRAY",
    "explanation": "(what,question_mark + to say + action indicator)",
    "isCharacter": false,
    "composition": [
      18229,
      "/",
      15666,
      ";",
      8993
    ]
  },
  {
    "id": "15968",
    "description": "parent",
    "pos": "BLUE",
    "explanation": "(protection + person: person who gives protection to his or her family)  - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "15969",
    "description": "park",
    "pos": "YELLOW",
    "explanation": "(flower + earth + tree: place with flowers and trees)  - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "15970",
    "description": "parrot,myna,talking_bird",
    "pos": "YELLOW",
    "explanation": "(bird + to talk: bird that can be trained to talk)",
    "isCharacter": false,
    "composition": [
      12837,
      "/",
      "RK:-2",
      "/",
      15666
    ]
  },
  {
    "id": "15971",
    "description": "parsnip",
    "pos": "YELLOW",
    "explanation": "(vegetable (wedge-shaped) + white: vegetable with a long, white, edible root)",
    "isCharacter": false,
    "composition": [
      13124,
      "/",
      13377,
      "/",
      17192
    ]
  },
  {
    "id": "15972",
    "description": "part,bit,piece,portion,part_of",
    "pos": "GRAY",
    "explanation": "(division [half-sized]: a part is created when something is divided)  With the gloss \"part of\", the symbol is used before another symbol to create a new meaning, which is part of the meaning of the original symbol, i.e., part of + language = word. See Note p. II-106 in BRG)  - Character",
    "isCharacter": true
  },
  {
    "id": "15973",
    "description": "party",
    "pos": "YELLOW",
    "explanation": "(gathering + happy)",
    "isCharacter": false,
    "composition": [
      14427,
      "/",
      14164,
      "/",
      17983
    ]
  },
  {
    "id": "15974",
    "description": "Passover",
    "pos": "YELLOW",
    "explanation": "(week + bread + low: the week when unleavened bread, matzo, is eaten)",
    "isCharacter": false,
    "composition": [
      8503,
      "/",
      13639,
      "/",
      12895,
      "/",
      24918
    ]
  },
  {
    "id": "15975",
    "description": "past",
    "pos": "YELLOW",
    "explanation": "(outline of parabolic mirror focused on what lies behind it)  - Character",
    "isCharacter": true
  },
  {
    "id": "15976",
    "description": "patience",
    "pos": "YELLOW",
    "explanation": "(ability + to wait)",
    "isCharacter": false,
    "composition": [
      12322,
      "/",
      13935,
      "/",
      15212
    ]
  },
  {
    "id": "15977",
    "description": "be_patient-(to)",
    "pos": "RED",
    "explanation": "(patience + action indicator)",
    "isCharacter": false,
    "composition": [
      12322,
      ";",
      8993,
      "/",
      13935,
      "/",
      15212
    ]
  },
  {
    "id": "15978",
    "description": "paw",
    "pos": "YELLOW",
    "explanation": "(animal + pointer, to paw or hoof)  - Character (superimposed - pointer)",
    "isCharacter": true
  },
  {
    "id": "15979",
    "description": "pay,spend-(to)",
    "pos": "RED",
    "explanation": "(to give + money + action indicator)",
    "isCharacter": false,
    "composition": [
      24903,
      ";",
      8993,
      "/",
      15484
    ]
  },
  {
    "id": "15980",
    "description": "peace_(opposite_war)",
    "pos": "YELLOW",
    "explanation": "(opposite meaning + war)",
    "isCharacter": false,
    "composition": [
      15927,
      "/",
      18036
    ]
  },
  {
    "id": "15981",
    "description": "peace,peace_of_mind,serenity",
    "pos": "YELLOW",
    "explanation": "(feeling + world: feeling of being at one with the world)  - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "15982",
    "description": "peaceful,serene,calm",
    "pos": "GREEN",
    "explanation": "(peace + description indicator)",
    "isCharacter": false,
    "composition": [
      15981,
      ";",
      8998
    ]
  },
  {
    "id": "15983",
    "description": "peach,nectarine",
    "pos": "YELLOW",
    "explanation": "(pictograph with stem + pit)  - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "15984",
    "description": "peacock",
    "pos": "YELLOW",
    "explanation": "(bird + fan: bird with a tail that opens like a fan)",
    "isCharacter": false,
    "composition": [
      12837,
      "/",
      14149
    ]
  },
  {
    "id": "15985",
    "description": "peanut_butter",
    "pos": "YELLOW",
    "explanation": "(spread + seed)",
    "isCharacter": false,
    "composition": [
      17238,
      "/",
      16749
    ]
  },
  {
    "id": "15986",
    "description": "pear",
    "pos": "YELLOW",
    "explanation": "(pictograph with stem)  - Character",
    "isCharacter": true
  },
  {
    "id": "15987",
    "description": "pea(s)",
    "pos": "YELLOW",
    "explanation": "(pictograph: symbol suggests a cross section of two peas in a pod)  - Character",
    "isCharacter": true
  },
  {
    "id": "15988",
    "description": "peel",
    "pos": "YELLOW",
    "explanation": "(protection + fruit)",
    "isCharacter": false,
    "composition": [
      16420,
      "/",
      14405
    ]
  },
  {
    "id": "15989",
    "description": "peel-(to)",
    "pos": "RED",
    "explanation": "(to remove + peel + action indicator)",
    "isCharacter": false,
    "composition": [
      17449,
      ";",
      8993,
      "/",
      16420,
      "/",
      14405
    ]
  },
  {
    "id": "15990",
    "description": "pelican",
    "pos": "YELLOW",
    "explanation": "(water bird + pouch: water bird with a pouch-shaped bill)",
    "isCharacter": false,
    "composition": [
      12840,
      "/",
      13403
    ]
  },
  {
    "id": "15991",
    "description": "pen,pencil",
    "pos": "YELLOW",
    "explanation": "(pictograph: symbol suggests a pen or pencil in writing position)  - Character",
    "isCharacter": true
  },
  {
    "id": "15992",
    "description": "penetrate,go_through-(to)",
    "pos": "RED",
    "explanation": "(through + action indicator)",
    "isCharacter": false,
    "composition": [
      17724,
      ";",
      8993
    ]
  },
  {
    "id": "15993",
    "description": "penguin",
    "pos": "YELLOW",
    "explanation": "(water bird + to walk: water bird that walks)",
    "isCharacter": false,
    "composition": [
      12840,
      "/",
      15189
    ]
  },
  {
    "id": "15994",
    "description": "penis",
    "pos": "YELLOW",
    "explanation": "(male_genitals_(man_with_penis) + pointer)  - Character (superimposed - pointer)",
    "isCharacter": true
  },
  {
    "id": "15995",
    "description": "pepper_(vegetable)",
    "pos": "YELLOW",
    "explanation": "(pictograph with stem)  - Character",
    "isCharacter": true
  },
  {
    "id": "15996",
    "description": "pepper_(seasoning)",
    "pos": "YELLOW",
    "explanation": "(adding,additive + taste + fire: combination of seasoning and hot + thing indicator)",
    "isCharacter": false,
    "composition": [
      12339,
      ";",
      9009,
      "/",
      17506,
      "/",
      14183
    ]
  },
  {
    "id": "15997",
    "description": "perfume,fragrance,aroma,scent",
    "pos": "YELLOW",
    "explanation": "(smell + happy: pleasant smell)",
    "isCharacter": false,
    "composition": [
      17017,
      "/",
      14164,
      "/",
      17983
    ]
  },
  {
    "id": "15998",
    "description": "perpendicular",
    "pos": "YELLOW",
    "explanation": "(line,stripe + ground: international mathematical symbol)  - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "16161",
    "description": "person,human_being,individual,human",
    "pos": "BLUE",
    "explanation": "(symbol suggests a human being standing, with feet turned out)  - Character",
    "isCharacter": true
  },
  {
    "id": "16162",
    "description": "kneeling_(kneeling_person)",
    "pos": "BLUE",
    "explanation": "(person [modification]: showing knees bent) - Character (modified)",
    "isCharacter": true
  },
  {
    "id": "16163",
    "description": "reclining,lying_(person_lying_down)",
    "pos": "BLUE",
    "explanation": "(person [modification]: lying on his back) - Character (modified)",
    "isCharacter": true
  },
  {
    "id": "16164",
    "description": "illness,disease,sickness_(sick_person)",
    "pos": "YELLOW",
    "explanation": "(person [modification]: lying on his back with knees drawn up as if sick or in pain) - Character (modified)",
    "isCharacter": true
  },
  {
    "id": "16165",
    "description": "seat,sitting_(sitting_person)",
    "pos": "YELLOW",
    "explanation": "(person [modification]: in sitting position) - Character (modified)",
    "isCharacter": true
  },
  {
    "id": "16166",
    "description": "standing_(standing_person)",
    "pos": "BLUE",
    "explanation": "(person [modification]: in standing position) - Character (modified)",
    "isCharacter": true
  },
  {
    "id": "16167",
    "description": "weakness_(weak_person)",
    "pos": "YELLOW",
    "explanation": "(person [modification]: buckling at the knees as though weak) - Character (modified)",
    "isCharacter": true
  },
  {
    "id": "16168",
    "description": "pet",
    "pos": "YELLOW",
    "explanation": "(animal + feeling: animal for which one has feeling)",
    "isCharacter": false,
    "composition": [
      12378,
      "/",
      14164
    ]
  },
  {
    "id": "16169",
    "description": "photograph,photo,pic",
    "pos": "YELLOW",
    "explanation": "(paper + camera)",
    "isCharacter": false,
    "composition": [
      15962,
      "/",
      13111
    ]
  },
  {
    "id": "16170",
    "description": "disabled,handicapped_(physically)_(OLD)",
    "pos": "GREEN",
    "explanation": "(limit(s),limitation_(OLD) + body + description indicator: having limits to one's physical abilities)  SUPERSEDED SYNONYM  See disabled,impaired,handicapped_(physically) 25995",
    "isCharacter": false,
    "composition": [
      15213,
      ";",
      8998,
      "/",
      12870
    ]
  },
  {
    "id": "16171",
    "description": "picnic",
    "pos": "YELLOW",
    "explanation": "(food + outside: food eaten outside)",
    "isCharacter": false,
    "composition": [
      14377,
      "/",
      15942
    ]
  },
  {
    "id": "16172",
    "description": "picture,image,icon,painting",
    "pos": "YELLOW",
    "explanation": "(eye + enclosure: what the eyes see in a frame)",
    "isCharacter": false,
    "composition": [
      14133,
      "/",
      13934
    ]
  },
  {
    "id": "16173",
    "description": "pie,tart",
    "pos": "YELLOW",
    "explanation": "(food + protection: food with a crust covering it)",
    "isCharacter": false,
    "composition": [
      14377,
      "/",
      16420
    ]
  },
  {
    "id": "16174",
    "description": "pier_(OLD)",
    "pos": "YELLOW",
    "explanation": "(platform + combination of boat and to float)  - Character (superimposed - combined)  SUPERSEDED SYNONYM  and SUPERSEDED CHARACTER  See pier 24857",
    "isCharacter": true
  },
  {
    "id": "16175",
    "description": "pig",
    "pos": "YELLOW",
    "explanation": "(animal + pictograph of curly tail)  - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "16176",
    "description": "pill,tablet",
    "pos": "YELLOW",
    "explanation": "(disc + medical: medicine in disc form)",
    "isCharacter": false,
    "composition": [
      13685,
      "/",
      24920
    ]
  },
  {
    "id": "16177",
    "description": "pillow,cushion",
    "pos": "YELLOW",
    "explanation": "(bed + pointer, to pillow)  - Character (superimposed - pointer)",
    "isCharacter": true
  },
  {
    "id": "16178",
    "description": "pillowcase",
    "pos": "YELLOW",
    "explanation": "(cloth + pillow)",
    "isCharacter": false,
    "composition": [
      13365,
      "/",
      16177
    ]
  },
  {
    "id": "16179",
    "description": "pilot",
    "pos": "BLUE",
    "explanation": "(person + airplane)",
    "isCharacter": false,
    "composition": [
      16161,
      "/",
      12357
    ]
  },
  {
    "id": "16180",
    "description": "pimple,blemish",
    "pos": "YELLOW",
    "explanation": "(face + dot + pointer, to dot)  - Character (superimposed - pointer)",
    "isCharacter": true
  },
  {
    "id": "16181",
    "description": "pin",
    "pos": "YELLOW",
    "explanation": "(pictograph: symbol suggests a pin. It is half the height of the nail symbol.)  - Character",
    "isCharacter": true
  },
  {
    "id": "16182",
    "description": "pineapple",
    "pos": "YELLOW",
    "explanation": "(pictograph with stem and leaves)  - Character",
    "isCharacter": true
  },
  {
    "id": "16183",
    "description": "table_tennis,ping-pong_(activity)_(OLD)",
    "pos": "YELLOW",
    "explanation": "(tennis_(activity)_(OLD) + table: game like tennis, played on a table)  SUPERSEDED SYNONYM  See table_tennis,ping-pong_(activity) 26028",
    "isCharacter": false,
    "composition": [
      12335,
      "/",
      "RK:-2",
      "/",
      25542,
      "/",
      17493
    ]
  },
  {
    "id": "16184",
    "description": "pink_(bci)",
    "pos": "WHITE",
    "explanation": "(colour + mouth + sun: combination of red and white) (BCI) SYMBOL SYNONYM",
    "isCharacter": false,
    "composition": [
      13377,
      "/",
      15666,
      "/",
      17192
    ]
  },
  {
    "id": "16185",
    "description": "pink_(ckb)",
    "pos": "WHITE",
    "explanation": "(colour + 1 + sun: combination of red and white) (CKB) SYMBOL SYNONYM",
    "isCharacter": false,
    "composition": [
      13377,
      "/",
      8497,
      "/",
      17462
    ]
  },
  {
    "id": "16186",
    "description": "pipe,smoking_pipe",
    "pos": "YELLOW",
    "explanation": "(smoking_(pipe) + pointer, to the pipe bowl)  - Character (superimposed - pointer)",
    "isCharacter": true
  },
  {
    "id": "16187",
    "description": "pipe,hose,tube_(1)",
    "pos": "YELLOW",
    "explanation": "(pictograph: horizontal orientation)  - Character    SYMBOL SYNONYM",
    "isCharacter": true
  },
  {
    "id": "16188",
    "description": "pit,stone",
    "pos": "YELLOW",
    "explanation": "(pictograph: symbol suggests a pit or stone)  - Character",
    "isCharacter": true
  },
  {
    "id": "16189",
    "description": "pit,stone-(to)",
    "pos": "RED",
    "explanation": "(to remove + pit + action indicator)",
    "isCharacter": false,
    "composition": [
      17449,
      ";",
      8993,
      "/",
      16188
    ]
  },
  {
    "id": "16190",
    "description": "pita",
    "pos": "YELLOW",
    "explanation": "(pictograph: Middle Eastern bread, the line in the middle suggests that the bread is hollow inside)  - Character",
    "isCharacter": true
  },
  {
    "id": "16191",
    "description": "pitcher,jug,kettle,pot",
    "pos": "YELLOW",
    "explanation": "(pictograph with handle and spout)  - Character",
    "isCharacter": true
  },
  {
    "id": "16192",
    "description": "pizza",
    "pos": "YELLOW",
    "explanation": "(food + pizza_slice(s),sector(s),circle_sector(s))",
    "isCharacter": false,
    "composition": [
      14377,
      "/",
      25594
    ]
  },
  {
    "id": "16193",
    "description": "place,area,location,space",
    "pos": "YELLOW",
    "explanation": "(earth + pointer: place on the earth)  - Character (superimposed - pointer)",
    "isCharacter": true
  },
  {
    "id": "16194",
    "description": "plan,design,method,system",
    "pos": "YELLOW",
    "explanation": "(mind + man-made: rational way for making something)  - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "16195",
    "description": "plan,design-(to)",
    "pos": "RED",
    "explanation": "(plan + action indicator)",
    "isCharacter": false,
    "composition": [
      16194,
      ";",
      8993
    ]
  },
  {
    "id": "16196",
    "description": "plant",
    "pos": "YELLOW",
    "explanation": "(pictograph: symbol suggests a flower with a leaf)  - Character",
    "isCharacter": true
  },
  {
    "id": "16197",
    "description": "plastic",
    "pos": "YELLOW",
    "explanation": "(chemical product + many + shape: chemical product that can be formed into many shapes)",
    "isCharacter": false,
    "composition": [
      13158,
      "/",
      14647,
      "/",
      14133,
      "/",
      17717
    ]
  },
  {
    "id": "16198",
    "description": "stop,platform_(vehicle)_(OLD)",
    "pos": "YELLOW",
    "explanation": "(platform + earth [modification, extended] + vehicle)  - Character (superimposed - modified)  SUPERSEDED SYNONYM and SUPERSEDED CHARACTER See stop,platform_(vehicle) 24290",
    "isCharacter": true
  },
  {
    "id": "16199",
    "description": "play,recreation",
    "pos": "YELLOW",
    "explanation": "(activity + happy)",
    "isCharacter": false,
    "composition": [
      12335,
      "/",
      "RK:-2",
      "/",
      14164,
      "/",
      17983
    ]
  },
  {
    "id": "16200",
    "description": "play-(to)",
    "pos": "RED",
    "explanation": "(play + action indicator)",
    "isCharacter": false,
    "composition": [
      12335,
      ";",
      8993,
      "/",
      "RK:-2",
      "/",
      14164,
      "/",
      17983
    ]
  },
  {
    "id": "16201",
    "description": "play_football-(to)",
    "pos": "RED",
    "explanation": "football,soccer_(activity) + action indicator)",
    "isCharacter": false,
    "composition": [
      12335,
      ";",
      8993,
      "/",
      12621,
      "/",
      15189
    ]
  },
  {
    "id": "16202",
    "description": "playground",
    "pos": "YELLOW",
    "explanation": "(place + to play)",
    "isCharacter": false,
    "composition": [
      16193,
      "/",
      12335,
      "/",
      "RK:-2",
      "/",
      14164,
      "/",
      17983
    ]
  },
  {
    "id": "16203",
    "description": "playroom,family_room,recreation_room",
    "pos": "YELLOW",
    "explanation": "(room + to play)",
    "isCharacter": false,
    "composition": [
      16687,
      "/",
      12335,
      "/",
      "RK:-2",
      "/",
      14164,
      "/",
      17983
    ]
  },
  {
    "id": "16204",
    "description": "please",
    "pos": "GRAY",
    "explanation": "(command + feeling: polite command)",
    "isCharacter": false,
    "composition": [
      14947,
      "/",
      14164
    ]
  },
  {
    "id": "16205",
    "description": "pliers,tongs,tweezer(s),pincer(s)_(pair_of)",
    "pos": "YELLOW",
    "explanation": "(pictograph: symbol suggests a pair of pliers in an open position)  - Character",
    "isCharacter": true
  },
  {
    "id": "16206",
    "description": "plough",
    "pos": "YELLOW",
    "explanation": "(knife + earth: heavy blade that cuts the soil in preparation for planting)  - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "16207",
    "description": "plug",
    "pos": "YELLOW",
    "explanation": "(into + electricity + thing indicator: fitting inserted into an electrical socket)",
    "isCharacter": false,
    "composition": [
      14952,
      ";",
      9009,
      "/",
      13918
    ]
  },
  {
    "id": "16208",
    "description": "plum,drupe",
    "pos": "YELLOW",
    "explanation": "(fruit + pit)  - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "16209",
    "description": "pocket",
    "pos": "YELLOW",
    "explanation": "(container + clothing: container sewn into an article of clothing)",
    "isCharacter": false,
    "composition": [
      13403,
      "/",
      13366
    ]
  },
  {
    "id": "16210",
    "description": "poem",
    "pos": "YELLOW",
    "explanation": "(page + poetry)",
    "isCharacter": false,
    "composition": [
      15962,
      "/",
      25585,
      "/",
      14164
    ]
  },
  {
    "id": "16211",
    "description": "poetry",
    "pos": "YELLOW",
    "explanation": "(metaphor_(winged) + feeling: \"winged speech\", which appeals to the emotions)",
    "isCharacter": false,
    "composition": [
      25585,
      "/",
      14164
    ]
  },
  {
    "id": "16212",
    "description": "point,tip,peak",
    "pos": "YELLOW",
    "explanation": "(knife + pointer, to tip)  - Character (superimposed - pointer)",
    "isCharacter": true
  },
  {
    "id": "16213",
    "description": "point,indicate-(to)",
    "pos": "RED",
    "explanation": "(pointer + action indicator)",
    "isCharacter": false,
    "composition": [
      23619,
      ";",
      8993
    ]
  },
  {
    "id": "16214",
    "description": "point_of_view",
    "pos": "YELLOW",
    "explanation": "(mind + position: rational position in regard to something)",
    "isCharacter": false,
    "composition": [
      15471,
      "/",
      16224
    ]
  },
  {
    "id": "16215",
    "description": "poison",
    "pos": "YELLOW",
    "explanation": "(chemical product + death: chemical product that kills)",
    "isCharacter": false,
    "composition": [
      13158,
      "/",
      13645
    ]
  },
  {
    "id": "16216",
    "description": "polenta",
    "pos": "YELLOW",
    "explanation": "(food + cornmeal: dish made with cornmeal)",
    "isCharacter": false,
    "composition": [
      14377,
      "/",
      16233,
      "/",
      13413
    ]
  },
  {
    "id": "16217",
    "description": "police_officer,policeman,policewoman",
    "pos": "BLUE",
    "explanation": "(person + protection)  Note: (The similarity between police and parent, and the lacking aspect of law enforcement, can be seen as problematic.)",
    "isCharacter": false,
    "composition": [
      16161,
      "/",
      16420
    ]
  },
  {
    "id": "16218",
    "description": "pollution",
    "pos": "YELLOW",
    "explanation": "(waste + environment: waste products that spoil the environment)",
    "isCharacter": false,
    "composition": [
      18043,
      "/",
      13942
    ]
  },
  {
    "id": "16219",
    "description": "pool",
    "pos": "YELLOW",
    "explanation": "(foundation,base,fundament + water: could also be interpreted as a combination of enclosure and water)  - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "16220",
    "description": "poor_(little_money)",
    "pos": "GREEN",
    "explanation": "(without + money + description indicator)",
    "isCharacter": false,
    "composition": [
      15474,
      "/",
      15484,
      ";",
      8998
    ]
  },
  {
    "id": "16221",
    "description": "popcorn",
    "pos": "YELLOW",
    "explanation": "(corn + to jump: corn that jumps as it cooks)",
    "isCharacter": false,
    "composition": [
      13413,
      "/",
      23550
    ]
  },
  {
    "id": "16222",
    "description": "porcupine_(OLD)",
    "pos": "YELLOW",
    "explanation": "(hedgehog_(OLD) + teeth: combination of rodent + pictograph of spines (OLD))  SUPERSEDED SYNONYM  See porcupine 23620",
    "isCharacter": false,
    "composition": [
      14699,
      "/",
      17517
    ]
  },
  {
    "id": "16223",
    "description": "pork,ham",
    "pos": "YELLOW",
    "explanation": "(food + pig: food that comes from a pig. The symbol also can be explained as a combination of meat and pig.)",
    "isCharacter": false,
    "composition": [
      14377,
      "/",
      16175
    ]
  },
  {
    "id": "16224",
    "description": "position",
    "pos": "YELLOW",
    "explanation": "(greater_than_(relation) + dot: forward pointing relation to a certain point in space)  - Character (sequenced)",
    "isCharacter": true
  },
  {
    "id": "16225",
    "description": "positive",
    "pos": "WHITE",
    "explanation": "(plus + intensity)",
    "isCharacter": false,
    "composition": [
      12374,
      "/",
      14947
    ]
  },
  {
    "id": "16226",
    "description": "maybe,perhaps,possibly",
    "pos": "GREEN",
    "explanation": "(possibility + description before the fact indicator)",
    "isCharacter": false,
    "composition": [
      24443,
      ";",
      8997,
      "/",
      18229
    ]
  },
  {
    "id": "16227",
    "description": "postcard",
    "pos": "YELLOW",
    "explanation": "(enclosure + stamp (combination): pictograph, which suggests a postcard with a stamp in the upper right corner)  - Character (superimposed - combined)",
    "isCharacter": true
  },
  {
    "id": "16228",
    "description": "post_office",
    "pos": "YELLOW",
    "explanation": "(building + letter: building where mail is processed)",
    "isCharacter": false,
    "composition": [
      14905,
      "/",
      15198
    ]
  },
  {
    "id": "16229",
    "description": "pot,pan",
    "pos": "YELLOW",
    "explanation": "(pictograph: symbol suggests a pan with a handle)  - Character",
    "isCharacter": true
  },
  {
    "id": "16230",
    "description": "potato",
    "pos": "YELLOW",
    "explanation": "(vegetable below ground + white: starchy, white tuber)",
    "isCharacter": false,
    "composition": [
      18005,
      "/",
      13377,
      "/",
      17192
    ]
  },
  {
    "id": "16231",
    "description": "potato_chips,crisps_(OLD)",
    "pos": "YELLOW",
    "explanation": "(potato + disc + plural indicator: potatoes cut in disc shapes)  SUPERSEDED SYNONYM  See potato_chip(s),chip(s),crisp(s) 24716",
    "isCharacter": false,
    "composition": [
      18005,
      ";",
      9011,
      "/",
      13377,
      "/",
      17192,
      "/",
      13685
    ]
  },
  {
    "id": "16232",
    "description": "pound_sterling",
    "pos": "YELLOW",
    "explanation": "(international symbol for British pound sterling)  - Character",
    "isCharacter": true
  },
  {
    "id": "16233",
    "description": "powder,dust",
    "pos": "YELLOW",
    "explanation": "(three powder-like dots: located at the corner points of the stone symbol) See stone,rock 17267  - Character (superimposed - sequenced)",
    "isCharacter": true
  },
  {
    "id": "16234",
    "description": "power_(physics)",
    "pos": "YELLOW",
    "explanation": "(action + electromagnetic radiation: energy in action)  - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "16235",
    "description": "practise,practice,drill,exercise,rehearse-(to)",
    "pos": "RED",
    "explanation": "(to work + repetition + action indicator: to work at something repeatedly)",
    "isCharacter": false,
    "composition": [
      18273,
      ";",
      8993,
      "/",
      24934
    ]
  },
  {
    "id": "16236",
    "description": "pray-(to)",
    "pos": "RED",
    "explanation": "(prayer + action indicator)",
    "isCharacter": false,
    "composition": [
      15666,
      ";",
      8993,
      "/",
      17739,
      "/",
      14451
    ]
  },
  {
    "id": "16237",
    "description": "prayer",
    "pos": "YELLOW",
    "explanation": "(to speak + to + God: talking to God)",
    "isCharacter": false,
    "composition": [
      15666,
      "/",
      17739,
      "/",
      14451
    ]
  },
  {
    "id": "16238",
    "description": "prayer_book,Siddur",
    "pos": "YELLOW",
    "explanation": "(book + prayer)",
    "isCharacter": false,
    "composition": [
      12875,
      "/",
      15666,
      "/",
      17739,
      "/",
      14451
    ]
  },
  {
    "id": "16239",
    "description": "preceding_(OLD)",
    "pos": "GREEN",
    "explanation": "(opposite meaning + next + description indicator)  SUPERSEDED SYNONYM  See preceding,previous,former,earlier 24218",
    "isCharacter": false,
    "composition": [
      15927,
      "/",
      8497,
      ";",
      8998,
      "/",
      8486,
      "/",
      12348
    ]
  },
  {
    "id": "16240",
    "description": "pregnancy",
    "pos": "YELLOW",
    "explanation": "(conception + woman)",
    "isCharacter": false,
    "composition": [
      13395,
      "/",
      18269
    ]
  },
  {
    "id": "16241",
    "description": "pregnant",
    "pos": "GREEN",
    "explanation": "(pregnancy + description indicator) SYMBOL SYNONYM",
    "isCharacter": false,
    "composition": [
      13395,
      ";",
      8998,
      "/",
      18269
    ]
  },
  {
    "id": "16242",
    "description": "pregnant_(ckb)",
    "pos": "GREEN",
    "explanation": "(before + birth + description indicator: woman's condition before she bears a child) SYMBOL SYNONYM",
    "isCharacter": false,
    "composition": [
      12656,
      "/",
      12843,
      ";",
      8998
    ]
  },
  {
    "id": "16243",
    "description": "premature_birth",
    "pos": "YELLOW",
    "explanation": "(birth + early)",
    "isCharacter": false,
    "composition": [
      12842,
      "/",
      12656,
      "/",
      17732
    ]
  },
  {
    "id": "16244",
    "description": "prepare,set,set_up,ready,gear_up,fix-(to)",
    "pos": "RED",
    "explanation": "(preparation,readying,readiness,preparedness + action indicator: to do something in order to be ready for the future)",
    "isCharacter": false,
    "composition": [
      12335,
      ";",
      8993,
      "/",
      14382,
      "/",
      14417
    ]
  },
  {
    "id": "16245",
    "description": "prepare_food,cook-(to)",
    "pos": "RED",
    "explanation": "(cooking,cookery,preparation_(general) + action indicator)",
    "isCharacter": false,
    "composition": [
      23583,
      ";",
      8993,
      "/",
      14377
    ]
  },
  {
    "id": "16246",
    "description": "present",
    "pos": "YELLOW",
    "explanation": "(past + future: time between past and future)  - Character (sequenced)",
    "isCharacter": true
  },
  {
    "id": "16247",
    "description": "pretend,make_believe-(to)",
    "pos": "RED",
    "explanation": "(fantasy + action indicator: to let one's mind soar into the sky, or up into the clouds)",
    "isCharacter": false,
    "composition": [
      24895,
      ";",
      8993
    ]
  },
  {
    "id": "16250",
    "description": "prison,jail",
    "pos": "YELLOW",
    "explanation": "(building + barred window: building where people are put behind bars)",
    "isCharacter": false,
    "composition": [
      14905,
      "/",
      18257
    ]
  },
  {
    "id": "16251",
    "description": "private",
    "pos": "GREEN",
    "explanation": "(to close + public + description indicator)",
    "isCharacter": false,
    "composition": [
      13934,
      ";",
      8998,
      "/",
      14647,
      "/",
      14647,
      "/",
      16161
    ]
  },
  {
    "id": "16252",
    "description": "probable,likely,probably",
    "pos": "GREEN",
    "explanation": "(to doubt + plus + description before the fact indicator: in doubt, but tending towards the positive)",
    "isCharacter": false,
    "composition": [
      22911,
      ";",
      8997,
      "/",
      12374
    ]
  },
  {
    "id": "16253",
    "description": "problem",
    "pos": "YELLOW",
    "explanation": "(question + difficult: difficult question to solve)",
    "isCharacter": false,
    "composition": [
      16445,
      "/",
      24884
    ]
  },
  {
    "id": "16254",
    "description": "projector",
    "pos": "YELLOW",
    "explanation": "(camera + forward [modification, short arrow]: device that projects the picture produced by a camera forward onto a screen)  - Character (superimposed - modified)",
    "isCharacter": true
  },
  {
    "id": "16417",
    "description": "promise,pledge-(to)",
    "pos": "RED",
    "explanation": "(promise + action indicator: to say that something will be done in the future)",
    "isCharacter": false,
    "composition": [
      15666,
      ";",
      8993,
      "/",
      12335,
      "/",
      14417
    ]
  },
  {
    "id": "16418",
    "description": "prostitution",
    "pos": "YELLOW",
    "explanation": "(sexual intercourse + money)",
    "isCharacter": false,
    "composition": [
      13380,
      "/",
      14431,
      "/",
      15484
    ]
  },
  {
    "id": "16419",
    "description": "protect,cover,shelter,take_care_of-(to)",
    "pos": "RED",
    "explanation": "(protection + action indicator)",
    "isCharacter": false,
    "composition": [
      16420,
      ";",
      8993
    ]
  },
  {
    "id": "16420",
    "description": "protection,shelter",
    "pos": "YELLOW",
    "explanation": "(symbol looks like a roof, suggesting the protection provided by a roof)  - Character",
    "isCharacter": true
  },
  {
    "id": "16421",
    "description": "protest,object,oppose-(to)",
    "pos": "RED",
    "explanation": "(to say + against + action indicator)",
    "isCharacter": false,
    "composition": [
      15666,
      ";",
      8993,
      "/",
      12351
    ]
  },
  {
    "id": "16422",
    "description": "proud",
    "pos": "GREEN",
    "explanation": "(feeling + above + description indicator)",
    "isCharacter": false,
    "composition": [
      14164,
      ";",
      8998,
      "/",
      15948
    ]
  },
  {
    "id": "16423",
    "description": "province,county,region,state",
    "pos": "YELLOW",
    "explanation": "(part of + country)",
    "isCharacter": false,
    "composition": [
      15972,
      "/",
      13423
    ]
  },
  {
    "id": "16424",
    "description": "prune_(OLD)",
    "pos": "YELLOW",
    "explanation": "(plum + dry_(OLD))  SUPERSEDED SYNONYM  See prune 24225",
    "isCharacter": false,
    "composition": [
      16208,
      "/",
      15927,
      "/",
      18209
    ]
  },
  {
    "id": "16425",
    "description": "puberty",
    "pos": "YELLOW",
    "explanation": "(awake + sexuality)",
    "isCharacter": false,
    "composition": [
      24949,
      "/",
      14164,
      "/",
      "RK:-2",
      "/",
      14428
    ]
  },
  {
    "id": "16426",
    "description": "pubic_hair",
    "pos": "YELLOW",
    "explanation": "(hair + body + pointer, to hair)  - Character (superimposed - pointer)",
    "isCharacter": true
  },
  {
    "id": "16427",
    "description": "public_(of_the_public)",
    "pos": "GREEN",
    "explanation": "(public + description indicator)",
    "isCharacter": false,
    "composition": [
      14647,
      "/",
      14647,
      "/",
      16161,
      ";",
      8998
    ]
  },
  {
    "id": "16428",
    "description": "public_(not_private)",
    "pos": "GREEN",
    "explanation": "(open + public + description indicator)",
    "isCharacter": false,
    "composition": [
      15923,
      ";",
      8998,
      "/",
      14647,
      "/",
      14647,
      "/",
      16161
    ]
  },
  {
    "id": "16429",
    "description": "public_(the_public)",
    "pos": "BLUE",
    "explanation": "(many + many + person: large group of people)",
    "isCharacter": false,
    "composition": [
      14647,
      "/",
      14647,
      "/",
      16161
    ]
  },
  {
    "id": "16430",
    "description": "public_room",
    "pos": "YELLOW",
    "explanation": "(ground + room, room with extended floor line [adaptation]: room opening out onto the street)  - Character (superimposed - adapted)",
    "isCharacter": true
  },
  {
    "id": "16431",
    "description": "pull,drag,tow,tug-(to)",
    "pos": "RED",
    "explanation": "(pull,pulling + action indicator: the forward moving arrow seems to be pulling the thing)",
    "isCharacter": false,
    "composition": [
      25599,
      ";",
      8993
    ]
  },
  {
    "id": "16432",
    "description": "puncture,prick-(to)",
    "pos": "RED",
    "explanation": "(point + action indicator)",
    "isCharacter": false,
    "composition": [
      16212,
      ";",
      8993
    ]
  },
  {
    "id": "16433",
    "description": "puppet",
    "pos": "YELLOW",
    "explanation": "(doll + hand: doll manipulated by the hand)",
    "isCharacter": false,
    "composition": [
      13166,
      "/",
      23583,
      "/",
      "RK:-2",
      "/",
      14667
    ]
  },
  {
    "id": "16434",
    "description": "puppy",
    "pos": "YELLOW",
    "explanation": "(dog + baby)",
    "isCharacter": false,
    "composition": [
      12380,
      "/",
      12603
    ]
  },
  {
    "id": "16435",
    "description": "Purim",
    "pos": "YELLOW",
    "explanation": "(holiday + megillah: the holiday on which megillah or story of Esther is read)",
    "isCharacter": false,
    "composition": [
      13639,
      "/",
      14164,
      "/",
      17983,
      "/",
      15451
    ]
  },
  {
    "id": "16436",
    "description": "purple,violet_(bci)",
    "pos": "WHITE",
    "explanation": "(colour + mouth + sky: combination of red and blue) (BCI) SYMBOL SYNONYM",
    "isCharacter": false,
    "composition": [
      13377,
      "/",
      15666,
      "/",
      17006
    ]
  },
  {
    "id": "16437",
    "description": "purpose",
    "pos": "YELLOW",
    "explanation": "(greater_than_(relation) + greater_than_(relation): the forward pointing doubled symbol stresses a purposeful relationship)  - Character (sequenced)",
    "isCharacter": true
  },
  {
    "id": "16438",
    "description": "purse,pocketbook,wallet",
    "pos": "YELLOW",
    "explanation": "(container + money + person: personal container for money)",
    "isCharacter": false,
    "composition": [
      13403,
      "/",
      15484,
      "/",
      16161
    ]
  },
  {
    "id": "16439",
    "description": "push,shove-(to)",
    "pos": "RED",
    "explanation": "(push,pushing + action indicator: the forward moving arrow seems to be pushing the thing)",
    "isCharacter": false,
    "composition": [
      24825,
      ";",
      8993
    ]
  },
  {
    "id": "16440",
    "description": "put,locate,place-(to)",
    "pos": "RED",
    "explanation": "(place + action indicator)",
    "isCharacter": false,
    "composition": [
      16193,
      ";",
      8993
    ]
  },
  {
    "id": "16441",
    "description": "jigsaw_puzzle",
    "pos": "YELLOW",
    "explanation": "(picture + piece: picture made from many pieces)",
    "isCharacter": false,
    "composition": [
      14133,
      "/",
      13934,
      "/",
      15972
    ]
  },
  {
    "id": "16442",
    "description": "pyjama(s),nightgown,nightie,pajama(s)",
    "pos": "YELLOW",
    "explanation": "(clothing + to sleep)",
    "isCharacter": false,
    "composition": [
      13366,
      "/",
      17008
    ]
  },
  {
    "id": "16443",
    "description": "pyramid",
    "pos": "YELLOW",
    "explanation": "(pictograph: symbol suggests a three-dimensional outline of a pyramid)  - Character",
    "isCharacter": true
  },
  {
    "id": "16445",
    "description": "question",
    "pos": "YELLOW",
    "explanation": "(what,question_mark + open: the question is open-ended. This symbol is also used to introduce a question.)  - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "16446",
    "description": "quick,fast,quickly,rapid,rapidly",
    "pos": "GREEN",
    "explanation": "(quickness,rapidity,speediness + description indicator)",
    "isCharacter": false,
    "composition": [
      14390,
      ";",
      8998,
      "/",
      14947
    ]
  },
  {
    "id": "16447",
    "description": "quiet,quietly",
    "pos": "GREEN",
    "explanation": "(minus + loud + description indicator: absence of noise)",
    "isCharacter": false,
    "composition": [
      15474,
      "/",
      17216,
      ";",
      8998,
      "/",
      14947
    ]
  },
  {
    "id": "16448",
    "description": "rabbit,hare",
    "pos": "YELLOW",
    "explanation": "(rodent + ear: animal known for its long ears)",
    "isCharacter": false,
    "composition": [
      12378,
      "/",
      17517,
      "/",
      13894
    ]
  },
  {
    "id": "16449",
    "description": "rabies",
    "pos": "YELLOW",
    "explanation": "(illness + animal + comma + to bite: viral nervous system illness of animals (including humans), usually spread by bite of infected animal)",
    "isCharacter": false,
    "composition": [
      16164,
      "/",
      12378,
      "/",
      8487,
      "/",
      17517
    ]
  },
  {
    "id": "16450",
    "description": "raccoon",
    "pos": "YELLOW",
    "explanation": "(animal + mask_(disguise): animal with a dark band across the eyes, which resembles a mask)",
    "isCharacter": false,
    "composition": [
      12378,
      "/",
      25582
    ]
  },
  {
    "id": "16451",
    "description": "race,competition,contest",
    "pos": "YELLOW",
    "explanation": "(forward + forward [modification, lower position]: two forward arrows, one overtaking another, appear to be competing)  - Character (superimposed - modified)",
    "isCharacter": true
  },
  {
    "id": "16452",
    "description": "racket,racquet",
    "pos": "YELLOW",
    "explanation": "(pictograph)  - Character",
    "isCharacter": true
  },
  {
    "id": "16453",
    "description": "radio_(1)",
    "pos": "YELLOW",
    "explanation": "(enclosure + ear + electricity: box for hearing by means of electricity) SYMBOL SYNONYM",
    "isCharacter": false,
    "composition": [
      13934,
      "/",
      13894,
      "/",
      13918
    ]
  },
  {
    "id": "16454",
    "description": "radish",
    "pos": "YELLOW",
    "explanation": "(vegetable (large-leafed) + hot: large-leafed vegetable with a hot-tasting, edible root)",
    "isCharacter": false,
    "composition": [
      17958,
      "/",
      17506,
      "/",
      14183
    ]
  },
  {
    "id": "16455",
    "description": "rain",
    "pos": "YELLOW",
    "explanation": "(water + down: water that falls down from the sky)  - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "16456",
    "description": "rain-(to)",
    "pos": "RED",
    "explanation": "(rain + action indicator)",
    "isCharacter": false,
    "composition": [
      16455,
      ";",
      8993
    ]
  },
  {
    "id": "16457",
    "description": "raincoat",
    "pos": "YELLOW",
    "explanation": "(clothing + rain)",
    "isCharacter": false,
    "composition": [
      13366,
      "/",
      16455
    ]
  },
  {
    "id": "16458",
    "description": "rainy",
    "pos": "GREEN",
    "explanation": "(rain + description indicator)",
    "isCharacter": false,
    "composition": [
      16455,
      ";",
      8998
    ]
  },
  {
    "id": "16459",
    "description": "raise,grow,bring_up,cultivate-(to)",
    "pos": "RED",
    "explanation": "(to cause + to grow + action indicator)",
    "isCharacter": false,
    "composition": [
      13134,
      ";",
      8993,
      "/",
      14205,
      "/",
      17983
    ]
  },
  {
    "id": "16460",
    "description": "raisins_(OLD)",
    "pos": "YELLOW",
    "explanation": "(grape,grapes + dry_(OLD))  SUPERSEDED SYNONYM  See raisin(s),currant(s) 24231",
    "isCharacter": false,
    "composition": [
      14635,
      "/",
      15927,
      "/",
      18209
    ]
  },
  {
    "id": "16461",
    "description": "rake",
    "pos": "YELLOW",
    "explanation": "(comb + garden)",
    "isCharacter": false,
    "composition": [
      13378,
      "/",
      14422
    ]
  },
  {
    "id": "16462",
    "description": "rape",
    "pos": "YELLOW",
    "explanation": "(assault + sexual intercourse)",
    "isCharacter": false,
    "composition": [
      22914,
      "/",
      14947,
      "/",
      13380,
      "/",
      14431
    ]
  },
  {
    "id": "16463",
    "description": "raspberry,blackberry,compound_berry",
    "pos": "YELLOW",
    "explanation": "(pictograph)  - Character",
    "isCharacter": true
  },
  {
    "id": "16464",
    "description": "raw,uncooked",
    "pos": "GREEN",
    "explanation": "(without + to cook + description indicator)",
    "isCharacter": false,
    "composition": [
      15474,
      "/",
      14183,
      ";",
      8998,
      "/",
      14377
    ]
  },
  {
    "id": "16465",
    "description": "read-(to)",
    "pos": "RED",
    "explanation": "(reading + action indicator: to see and perceive what is written on the printed page)",
    "isCharacter": false,
    "composition": [
      14133,
      ";",
      8993,
      "/",
      15962
    ]
  },
  {
    "id": "16466",
    "description": "ready,prepared",
    "pos": "GREEN",
    "explanation": "(to prepare + description after the fact indicator)",
    "isCharacter": false,
    "composition": [
      12335,
      ";",
      8996,
      "/",
      14382,
      "/",
      14417
    ]
  },
  {
    "id": "16467",
    "description": "real,really",
    "pos": "GREEN",
    "explanation": "(event,happening,occasion + description indicator: existing on earth)",
    "isCharacter": false,
    "composition": [
      14114,
      ";",
      8998
    ]
  },
  {
    "id": "16468",
    "description": "recent,recently",
    "pos": "GREEN",
    "explanation": "(past + near + description indicator: in the near past)",
    "isCharacter": false,
    "composition": [
      15975,
      ";",
      8998,
      "/",
      25586
    ]
  },
  {
    "id": "16469",
    "description": "recipe",
    "pos": "YELLOW",
    "explanation": "(page + to prepare food: written instructions for cooking)",
    "isCharacter": false,
    "composition": [
      15962,
      "/",
      23583,
      "/",
      14377
    ]
  },
  {
    "id": "16470",
    "description": "CD,record",
    "pos": "YELLOW",
    "explanation": "(recording_disk + ear: represents music or sound in general, recorded on any kind of disk medium)",
    "isCharacter": false,
    "composition": [
      25601,
      "/",
      13894
    ]
  },
  {
    "id": "16471",
    "description": "CD_player,record_player,stereo",
    "pos": "YELLOW",
    "explanation": "(machine + record)",
    "isCharacter": false,
    "composition": [
      15406,
      "/",
      25601,
      "/",
      13894
    ]
  },
  {
    "id": "16472",
    "description": "rectangle,oblong_(shape)",
    "pos": "YELLOW",
    "explanation": "(shape + rectangular shape [as of card]: rectangle, a geometric shape)",
    "isCharacter": false,
    "composition": [
      14133,
      "/",
      17717,
      "/",
      23431
    ]
  },
  {
    "id": "16473",
    "description": "rectangular,oblong",
    "pos": "GREEN",
    "explanation": "(rectangle + description indicator)",
    "isCharacter": false,
    "composition": [
      14133,
      ";",
      8998,
      "/",
      17717,
      "/",
      23431
    ]
  },
  {
    "id": "16474",
    "description": "red_(bci)",
    "pos": "WHITE",
    "explanation": "(colour + mouth) (BCI) SYMBOL SYNONYM",
    "isCharacter": false,
    "composition": [
      13377,
      "/",
      15666
    ]
  },
  {
    "id": "16475",
    "description": "red_(ckb)",
    "pos": "WHITE",
    "explanation": "(colour + 1) (CKB) SYMBOL SYNONYM",
    "isCharacter": false,
    "composition": [
      13377,
      "/",
      8497
    ]
  },
  {
    "id": "16476",
    "description": "refrigerator_(OLD)",
    "pos": "YELLOW",
    "explanation": "(cupboard + ice + electricity: electrically powered ice box)  SUPERSEDED SYNONYM  See refrigerator,fridge 23632",
    "isCharacter": false,
    "composition": [
      13622,
      "/",
      14919,
      "/",
      13918
    ]
  },
  {
    "id": "16477",
    "description": "regret-(to)",
    "pos": "RED",
    "explanation": "(sorry + action indicator: to feel sorry about something that occurred in the past)",
    "isCharacter": false,
    "composition": [
      14164,
      ";",
      8993,
      "/",
      13869,
      "/",
      12324,
      "/",
      15975
    ]
  },
  {
    "id": "16478",
    "description": "reindeer,caribou",
    "pos": "YELLOW",
    "explanation": "(cervine + north: animal common to Northern regions)",
    "isCharacter": false,
    "composition": [
      12381,
      "/",
      15730
    ]
  },
  {
    "id": "16479",
    "description": "less_than_(relation)",
    "pos": "WHITE",
    "explanation": "(symbol is derived from the mathematical symbol for “smaller than”. This symbol in half-size is the basis for against, by, and there.)  - Character",
    "isCharacter": true
  },
  {
    "id": "16480",
    "description": "greater_than_(relation)",
    "pos": "WHITE",
    "explanation": "(symbol is derived from the mathematical symbol for \"greater than\". This symbol in half-size is the basis for about, at, for, here and on.)  - Character",
    "isCharacter": true
  },
  {
    "id": "16481",
    "description": "relative,relation",
    "pos": "BLUE",
    "explanation": "(protection + person + protection: two adjoining roofs are used to mean person who is related)  - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "16482",
    "description": "who,that,which-(relative)",
    "pos": "WHITE",
    "explanation": "(double commas, apostrophes or ditto marks in a sentence [modification, on the midline]: This symbol is equivalent to a relative pronoun or a conjunction used to introduce a relative clause.  - Character (sequenced - modified)",
    "isCharacter": true
  },
  {
    "id": "16483",
    "description": "religion,naturalism_(OLD)",
    "pos": "YELLOW",
    "explanation": "(feeling + creation: feeling in relation to creation)  SUPERSEDED SYNONYM  See religion,naturalism 20563",
    "isCharacter": false,
    "composition": [
      14164,
      "/",
      "RK:-2",
      "/",
      13607
    ]
  },
  {
    "id": "16484",
    "description": "religious_(OLD)",
    "pos": "GREEN",
    "explanation": "(religion + description indicator)  SUPERSEDED SYNONYM  See religious 20562",
    "isCharacter": false,
    "composition": [
      14164,
      ";",
      8998,
      "/",
      "RK:-2",
      "/",
      13607
    ]
  },
  {
    "id": "16485",
    "description": "remember-(to)_(OLD)",
    "pos": "RED",
    "explanation": "(opposite meaning + to forget + action indicator)  SUPERSEDED SYNONYM  See remember,recall-(to) 23634",
    "isCharacter": false,
    "composition": [
      15927,
      "/",
      24899,
      ";",
      8993
    ]
  },
  {
    "id": "16486",
    "description": "remembrance_day",
    "pos": "YELLOW",
    "explanation": "(day + to remember)",
    "isCharacter": false,
    "composition": [
      13639,
      "/",
      15927,
      "/",
      24899
    ]
  },
  {
    "id": "16487",
    "description": "repeat,copy,duplicate,reproduce-(to)",
    "pos": "RED",
    "explanation": "(repetition,copying,duplication,replication + action indicator: the line is repeated)",
    "isCharacter": false,
    "composition": [
      24934,
      ";",
      8993
    ]
  },
  {
    "id": "16488",
    "description": "reproduction",
    "pos": "YELLOW",
    "explanation": "(conception + to cause + baby)",
    "isCharacter": false,
    "composition": [
      13395,
      "/",
      13134,
      "/",
      12603
    ]
  },
  {
    "id": "16489",
    "description": "request-(to)",
    "pos": "RED",
    "explanation": "(to ask + please + action indicator: to ask politely)",
    "isCharacter": false,
    "composition": [
      16445,
      ";",
      8993,
      "/",
      14947,
      "/",
      14164
    ]
  },
  {
    "id": "16490",
    "description": "resent-(to)",
    "pos": "RED",
    "explanation": "(feeling + against + action indicator: to harbour feelings against someone or something)",
    "isCharacter": false,
    "composition": [
      14164,
      ";",
      8993,
      "/",
      12351
    ]
  },
  {
    "id": "16491",
    "description": "resident",
    "pos": "BLUE",
    "explanation": "(person + house: person who lives in a house)",
    "isCharacter": false,
    "composition": [
      16161,
      "/",
      14905
    ]
  },
  {
    "id": "16492",
    "description": "residential_institution,group_home,hostel,residential_home",
    "pos": "YELLOW",
    "explanation": "(house + many + person: house in which a group of people live)",
    "isCharacter": false,
    "composition": [
      14905,
      "/",
      14647,
      "/",
      16161
    ]
  },
  {
    "id": "16493",
    "description": "resource_centre",
    "pos": "YELLOW",
    "explanation": "(building + for (the purpose of) + to exchange + knowledge: building where knowledge is given out and received)",
    "isCharacter": false,
    "composition": [
      14905,
      "/",
      14382,
      "/",
      25555,
      "/",
      15162
    ]
  },
  {
    "id": "16494",
    "description": "respect,admiration",
    "pos": "YELLOW",
    "explanation": "(feeling + about + person + superior: feeling one has about a person who is superior)",
    "isCharacter": false,
    "composition": [
      14164,
      "/",
      12324,
      "/",
      16161,
      "/",
      15948
    ]
  },
  {
    "id": "16495",
    "description": "rest,comfort",
    "pos": "YELLOW",
    "explanation": "(feeling + earth: feeling at rest on the earth. CKB points out that poets use the earth as a symbol for rest.)  - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "16496",
    "description": "rest-(to)",
    "pos": "RED",
    "explanation": "(rest + action indicator)",
    "isCharacter": false,
    "composition": [
      16495,
      ";",
      8993
    ]
  },
  {
    "id": "16497",
    "description": "rest_period,break",
    "pos": "YELLOW",
    "explanation": "(limited time + rest)",
    "isCharacter": false,
    "composition": [
      15212,
      "/",
      16495
    ]
  },
  {
    "id": "16498",
    "description": "restaurant,cafeteria",
    "pos": "YELLOW",
    "explanation": "(public room + to eat)",
    "isCharacter": false,
    "composition": [
      16430,
      "/",
      14377
    ]
  },
  {
    "id": "16499",
    "description": "return",
    "pos": "YELLOW",
    "explanation": "(reference line + backward: the arrow, moving backward, returns toward the reference line)  - Character (sequenced) ??",
    "isCharacter": true
  },
  {
    "id": "16500",
    "description": "return,come_back,reverse-(to)",
    "pos": "RED",
    "explanation": "(return + action indicator)",
    "isCharacter": false,
    "composition": [
      16499,
      ";",
      8993
    ]
  },
  {
    "id": "16501",
    "description": "rhinoceros",
    "pos": "YELLOW",
    "explanation": "(animal + pictograph of head and horn: animal with a distinctive horn protruding from its nose)  - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "16502",
    "description": "rhyme",
    "pos": "YELLOW",
    "explanation": "(similar sound + end: the effect produced when words have a similar sound. The symbol applies particularly to ends of lines of poetry.)",
    "isCharacter": false,
    "composition": [
      25586,
      "/",
      16713,
      "/",
      17216,
      "/",
      13935
    ]
  },
  {
    "id": "16503",
    "description": "rhythm_method",
    "pos": "YELLOW",
    "explanation": "(birth control + month: birth control based upon a woman’s monthly cycle)",
    "isCharacter": false,
    "composition": [
      13935,
      "/",
      13395,
      "/",
      15649
    ]
  },
  {
    "id": "16504",
    "description": "ribbon,tape",
    "pos": "YELLOW",
    "explanation": "(linear thing + cloth + thing indicator)",
    "isCharacter": false,
    "composition": [
      15214,
      ";",
      9009,
      "/",
      13365
    ]
  },
  {
    "id": "16505",
    "description": "rice",
    "pos": "YELLOW",
    "explanation": "(grain + water_(ground_level): grain that grows in water)  - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "16506",
    "description": "rich_(taste)",
    "pos": "GREEN",
    "explanation": "(taste + intensity + description indicator)",
    "isCharacter": false,
    "composition": [
      17506,
      ";",
      8998,
      "/",
      14947
    ]
  },
  {
    "id": "16507",
    "description": "rich,wealthy",
    "pos": "GREEN",
    "explanation": "(much + money + description indicator)",
    "isCharacter": false,
    "composition": [
      14647,
      "/",
      15484,
      ";",
      8998
    ]
  },
  {
    "id": "16508",
    "description": "rickshaw",
    "pos": "YELLOW",
    "explanation": "(cart + person: cart pulled by a person)",
    "isCharacter": false,
    "composition": [
      13127,
      "/",
      16161
    ]
  },
  {
    "id": "16509",
    "description": "ride-(to)",
    "pos": "RED",
    "explanation": "(ride,drive + action indicator: to go forward in a sitting position)",
    "isCharacter": false,
    "composition": [
      25603,
      ";",
      8993
    ]
  },
  {
    "id": "16510",
    "description": "rifle,shotgun",
    "pos": "YELLOW",
    "explanation": "(gun + long)",
    "isCharacter": false,
    "composition": [
      14655,
      "/",
      15193
    ]
  },
  {
    "id": "16673",
    "description": "right",
    "pos": "GREEN",
    "explanation": "(right_turn,right_(position_or_direction) + description indicator)",
    "isCharacter": false,
    "composition": [
      25604,
      ";",
      8998
    ]
  },
  {
    "id": "16674",
    "description": "angle_(right),right_angle",
    "pos": "YELLOW",
    "explanation": "(international mathematical symbol)  - Character",
    "isCharacter": true
  },
  {
    "id": "16675",
    "description": "ring",
    "pos": "YELLOW",
    "explanation": "(pictograph)  - Character",
    "isCharacter": true
  },
  {
    "id": "16676",
    "description": "rise,ascend,go_up-(to)",
    "pos": "RED",
    "explanation": "(up + action indicator)",
    "isCharacter": false,
    "composition": [
      17983,
      ";",
      8993
    ]
  },
  {
    "id": "16677",
    "description": "river,stream,current",
    "pos": "YELLOW",
    "explanation": "(water_(ground_level) + forward: water that flows forward)  - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "16678",
    "description": "road_(1)",
    "pos": "YELLOW",
    "explanation": "(road_and_car + pointer, to road: place where cars travel) SYMBOL SYNONYM  - Character (superimposed - pointer)",
    "isCharacter": true
  },
  {
    "id": "16679",
    "description": "roadrunner_(bird)",
    "pos": "YELLOW",
    "explanation": "(bird + to walk + little: small bird that walks or runs but does not fly)",
    "isCharacter": false,
    "composition": [
      12837,
      "/",
      15189,
      "/",
      24917
    ]
  },
  {
    "id": "16680",
    "description": "rocket,spaceship",
    "pos": "YELLOW",
    "explanation": "(projectile,rocket,spacecraft + upward)",
    "isCharacter": false,
    "composition": [
      25614,
      "/",
      17983
    ]
  },
  {
    "id": "16681",
    "description": "rocking_chair",
    "pos": "YELLOW",
    "explanation": "(chair + to rock: chair that rocks back and forth)",
    "isCharacter": false,
    "composition": [
      13148,
      "/",
      25406
    ]
  },
  {
    "id": "16682",
    "description": "rocking_horse_(OLD)",
    "pos": "YELLOW",
    "explanation": "(horse + to rock)  SUPERSEDED SYNONYM  See rocking_horse 21876",
    "isCharacter": false,
    "composition": [
      14897,
      "/",
      25406
    ]
  },
  {
    "id": "16683",
    "description": "roll,bun",
    "pos": "YELLOW",
    "explanation": "(bread [modification, reduced width]: pictograph of a bun) - Character (modified)",
    "isCharacter": true
  },
  {
    "id": "16684",
    "description": "roller_skate-(to)",
    "pos": "RED",
    "explanation": "(roller skates + action indicator)",
    "isCharacter": false,
    "composition": [
      16685,
      ";",
      8993
    ]
  },
  {
    "id": "16685",
    "description": "roller_skates",
    "pos": "YELLOW",
    "explanation": "(feet and legs + wheel [modification, low position] + wheel [modification, low position]: wheeled skates)  - Character (superimposed - modified)",
    "isCharacter": true
  },
  {
    "id": "16686",
    "description": "roof,cover",
    "pos": "YELLOW",
    "explanation": "(protection + thing indicator: thing that provides protective cover. The symbol is the concrete form of protection.)  - (character with thing indicator)",
    "isCharacter": "false",
    "composition": [
      16420,
      ";",
      9009
    ]
  },
  {
    "id": "16687",
    "description": "room",
    "pos": "YELLOW",
    "explanation": "(enclosure, open on the left side)  - Character",
    "isCharacter": true
  },
  {
    "id": "16688",
    "description": "root(s),rootage,root_system",
    "pos": "YELLOW",
    "explanation": "(earth + pictograph of roots: symbol suggests two roots below the ground.)  - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "16689",
    "description": "Rosh_Hashana",
    "pos": "YELLOW",
    "explanation": "(day + horn + Jewish: Jewish New Year, the day on which the shofar or ram's horn is blown)",
    "isCharacter": false,
    "composition": [
      13639,
      "/",
      14895,
      "/",
      17251
    ]
  },
  {
    "id": "16690",
    "description": "rotate,circle,circulate,wind_up,orbit-(to)",
    "pos": "RED",
    "explanation": "(rotation,circulation,orbit,lap,circle,round + action indicator)",
    "isCharacter": false,
    "composition": [
      24249,
      ";",
      8993
    ]
  },
  {
    "id": "16691",
    "description": "roti,chapati,flatbread",
    "pos": "YELLOW",
    "explanation": "(toast + disc: disc-shaped toasted bread)",
    "isCharacter": false,
    "composition": [
      25530,
      "/",
      14183,
      "/",
      13685
    ]
  },
  {
    "id": "16692",
    "description": "rouge,blusher",
    "pos": "YELLOW",
    "explanation": "(colour + plus + cheek: colour added to cheeks)",
    "isCharacter": false,
    "composition": [
      13377,
      "/",
      12374,
      "/",
      13156
    ]
  },
  {
    "id": "16693",
    "description": "round,circular",
    "pos": "GREEN",
    "explanation": "(circle + description indicator)",
    "isCharacter": false,
    "composition": [
      14133,
      ";",
      8998,
      "/",
      17717,
      "/",
      17462
    ]
  },
  {
    "id": "16695",
    "description": "rub,massage-(to)",
    "pos": "RED",
    "explanation": "(hand + back and forth + intensity + action indicator)",
    "isCharacter": false,
    "composition": [
      14667,
      ";",
      8993,
      "/",
      12610,
      "/",
      14947
    ]
  },
  {
    "id": "16696",
    "description": "rug,carpet,mat",
    "pos": "YELLOW",
    "explanation": "(cloth + floor covering)",
    "isCharacter": false,
    "composition": [
      13365,
      "/",
      14203
    ]
  },
  {
    "id": "16697",
    "description": "rule,regulation",
    "pos": "YELLOW",
    "explanation": "(page + to guide: written guidance)",
    "isCharacter": false,
    "composition": [
      15962,
      "/",
      22913
    ]
  },
  {
    "id": "16698",
    "description": "ruler,measuring_stick,tapeline,tape_measure",
    "pos": "YELLOW",
    "explanation": "(measurement + thing indicator)  - (character with thing indicator)",
    "isCharacter": "false",
    "composition": [
      15443,
      ";",
      9009
    ]
  },
  {
    "id": "16699",
    "description": "run,jog-(to)",
    "pos": "RED",
    "explanation": "(to walk + fast + action indicator)",
    "isCharacter": false,
    "composition": [
      15189,
      ";",
      8993,
      "/",
      14390,
      "/",
      14947
    ]
  },
  {
    "id": "16700",
    "description": "Sabbath,day_of_rest",
    "pos": "YELLOW",
    "explanation": "(day + rest: day for resting)",
    "isCharacter": false,
    "composition": [
      13639,
      "/",
      16495
    ]
  },
  {
    "id": "16701",
    "description": "sack,bag",
    "pos": "YELLOW",
    "explanation": "(pictograph: the sides of the symbol for container are extended)  - Character",
    "isCharacter": true
  },
  {
    "id": "16702",
    "description": "sad,sadly,unhappily,unhappy",
    "pos": "GREEN",
    "explanation": "(sadness + description indicator: having a downhearted feeling)",
    "isCharacter": false,
    "composition": [
      14164,
      ";",
      8998,
      "/",
      13869
    ]
  },
  {
    "id": "16703",
    "description": "sadness,sorrow,unhappiness",
    "pos": "YELLOW",
    "explanation": "(feeling + down)",
    "isCharacter": false,
    "composition": [
      14164,
      "/",
      13869
    ]
  },
  {
    "id": "16704",
    "description": "safe,safely,secure,securely",
    "pos": "GREEN",
    "explanation": "(safety + description indicator)",
    "isCharacter": false,
    "composition": [
      14164,
      ";",
      8998,
      "/",
      16420
    ]
  },
  {
    "id": "16705",
    "description": "safety,security",
    "pos": "YELLOW",
    "explanation": "(feeling + protection: feeling of being protected)",
    "isCharacter": false,
    "composition": [
      14164,
      "/",
      16420
    ]
  },
  {
    "id": "16706",
    "description": "sail_(OLD)",
    "pos": "YELLOW",
    "explanation": "(pictograph: symbol suggests a sail on a mast)  - Character  SUPERSEDED SYNONYM  See sail 20519",
    "isCharacter": true
  },
  {
    "id": "16707",
    "description": "sailboat_(OLD)",
    "pos": "YELLOW",
    "explanation": "(pictograph: symbol suggests the outline of a sailboat.The symbol also can be explained as: combination of boat and sail)  - Character  SUPERSEDED SYNONYM  See sailboat,sailing_boat,yacht 20520",
    "isCharacter": true
  },
  {
    "id": "16708",
    "description": "sailor",
    "pos": "BLUE",
    "explanation": "(person + boat)",
    "isCharacter": false,
    "composition": [
      16161,
      "/",
      12869
    ]
  },
  {
    "id": "16709",
    "description": "salad",
    "pos": "YELLOW",
    "explanation": "lettuce + dish (combination): used in a general sense for all salads)  - Character (superimposed - combined)",
    "isCharacter": true
  },
  {
    "id": "16710",
    "description": "saliva,spit",
    "pos": "YELLOW",
    "explanation": "(liquid + mouth: liquid contained in the mouth)",
    "isCharacter": false,
    "composition": [
      18209,
      "/",
      15666
    ]
  },
  {
    "id": "16711",
    "description": "salt_crystal",
    "pos": "YELLOW",
    "explanation": "(crystal + sea)",
    "isCharacter": false,
    "composition": [
      13619,
      "/",
      14647,
      "/",
      14647,
      "/",
      25777
    ]
  },
  {
    "id": "16712",
    "description": "salty_(OLD)",
    "pos": "GREEN",
    "explanation": "(taste + sea + description indicator)  SUPERSEDED SYNONYM See salty 26247",
    "isCharacter": false,
    "composition": [
      17506,
      ";",
      8998,
      "/",
      14647,
      "/",
      14647,
      "/",
      25777
    ]
  },
  {
    "id": "16713",
    "description": "same,equal,equality",
    "pos": "WHITE",
    "explanation": "(international mathematical symbol)  - Character",
    "isCharacter": true
  },
  {
    "id": "16714",
    "description": "same_sound",
    "pos": "GRAY",
    "explanation": "(same + sound: used before a second symbol to create a meaning that is a homonym of the second symbol)",
    "isCharacter": false,
    "composition": [
      16713,
      "/",
      17216
    ]
  },
  {
    "id": "16715",
    "description": "sand",
    "pos": "YELLOW",
    "explanation": "(powder + rock: powder made from a rock)",
    "isCharacter": false,
    "composition": [
      16233,
      "/",
      17267
    ]
  },
  {
    "id": "16716",
    "description": "sandal(s)",
    "pos": "YELLOW",
    "explanation": "(shoe + comma + open)",
    "isCharacter": false,
    "composition": [
      16420,
      "/",
      14379,
      "/",
      8487,
      "/",
      15923
    ]
  },
  {
    "id": "16717",
    "description": "sandbox,sandpit,sandtray",
    "pos": "YELLOW",
    "explanation": "foundation + sand: could also be interpreted as (enclosure [modification] + sand)",
    "isCharacter": false,
    "composition": [
      24120,
      "/",
      16233,
      "/",
      17267
    ]
  },
  {
    "id": "16718",
    "description": "sandwich",
    "pos": "YELLOW",
    "explanation": "(food + between + bread)",
    "isCharacter": false,
    "composition": [
      14377,
      "/",
      12669,
      "/",
      12895
    ]
  },
  {
    "id": "16719",
    "description": "sanitary_napkin,sanitary_towel,tampon",
    "pos": "YELLOW",
    "explanation": "(absorbent material + woman)",
    "isCharacter": false,
    "composition": [
      15431,
      "/",
      14952,
      "/",
      18269
    ]
  },
  {
    "id": "16720",
    "description": "sari",
    "pos": "YELLOW",
    "explanation": "(clothing + around + woman) (India)",
    "isCharacter": false,
    "composition": [
      13366,
      "/",
      12580,
      "/",
      18269
    ]
  },
  {
    "id": "16721",
    "description": "satisfaction,contentment",
    "pos": "YELLOW",
    "explanation": "(mind + full: CKB quotes the Chinese phrase to describe a contented man: “his rice bowl is full”)",
    "isCharacter": false,
    "composition": [
      15471,
      "/",
      24897
    ]
  },
  {
    "id": "16722",
    "description": "Saturday_(OLD)",
    "pos": "YELLOW",
    "explanation": "(day + 7: seventh day of the week - based on the convention of Sunday being the first)  SUPERSEDED SYNONYM  See Saturday_(day6) 25164, Saturday_(day7) 25165, Saturday_(day1) 25163",
    "isCharacter": false,
    "composition": [
      13639,
      "/",
      8503
    ]
  },
  {
    "id": "16723",
    "description": "sauce,gravy,relish,dressing_(OLD)",
    "pos": "YELLOW",
    "explanation": "(spread,paste + liquid: liquid served on or to accompany food)  SUPERSEDED SYNONYM  See sauce,gravy,relish,dressing 20522",
    "isCharacter": false,
    "composition": [
      17238,
      "/",
      18209
    ]
  },
  {
    "id": "16724",
    "description": "sauerkraut",
    "pos": "YELLOW",
    "explanation": "(cabbage + sour)",
    "isCharacter": false,
    "composition": [
      13101,
      "/",
      17506,
      "/",
      15159
    ]
  },
  {
    "id": "16725",
    "description": "sauna",
    "pos": "YELLOW",
    "explanation": "(steam bath + rock)",
    "isCharacter": false,
    "composition": [
      17257,
      "/",
      17267
    ]
  },
  {
    "id": "16726",
    "description": "sausage,frankfurter,hotdog,hot_dog",
    "pos": "YELLOW",
    "explanation": "(meat + long)",
    "isCharacter": false,
    "composition": [
      14377,
      "/",
      12378,
      "/",
      15193
    ]
  },
  {
    "id": "16727",
    "description": "saw",
    "pos": "YELLOW",
    "explanation": "(pictograph: symbol suggests a saw and  incorporates teeth)  - Character",
    "isCharacter": true
  },
  {
    "id": "16728",
    "description": "say,speak,talk,tell,express-(to)",
    "pos": "RED",
    "explanation": "(mouth + action indicator)",
    "isCharacter": false,
    "composition": [
      15666,
      ";",
      8993
    ]
  },
  {
    "id": "16729",
    "description": "scales",
    "pos": "YELLOW",
    "explanation": "(machine + to weigh)",
    "isCharacter": false,
    "composition": [
      15406,
      "/",
      18221
    ]
  },
  {
    "id": "16730",
    "description": "scarf",
    "pos": "YELLOW",
    "explanation": "(clothing + neck)",
    "isCharacter": false,
    "composition": [
      13366,
      "/",
      15699
    ]
  },
  {
    "id": "16731",
    "description": "scenery,landscape",
    "pos": "YELLOW",
    "explanation": "(generalization + countryside: general term for the countryside, which is characteristic of a particular area or region, e.g. a prairie landscape)",
    "isCharacter": false,
    "composition": [
      14430,
      "/",
      13424
    ]
  },
  {
    "id": "16732",
    "description": "schach",
    "pos": "YELLOW",
    "explanation": "(roof + tree + thing indicator + plural indicator: material used in making roof for Sukkot)",
    "isCharacter": false,
    "composition": [
      16420,
      ";",
      9009,
      "/",
      17775,
      ";",
      9011
    ]
  },
  {
    "id": "16733",
    "description": "schedule,timetable",
    "pos": "YELLOW",
    "explanation": "(paper + time: paper that gives the times of events)",
    "isCharacter": false,
    "composition": [
      15962,
      "/",
      17732
    ]
  },
  {
    "id": "16734",
    "description": "school",
    "pos": "YELLOW",
    "explanation": "(building + to teach: building used for teaching)",
    "isCharacter": false,
    "composition": [
      14905,
      "/",
      24903,
      "/",
      15162
    ]
  },
  {
    "id": "16735",
    "description": "science,body_of_learning",
    "pos": "YELLOW",
    "explanation": "(mind + nature: reasoned approach to nature)  - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "16736",
    "description": "scissors",
    "pos": "YELLOW",
    "explanation": "(pictograph: symbol suggests a pair of closed scissors)  - Character",
    "isCharacter": true
  },
  {
    "id": "16737",
    "description": "score",
    "pos": "YELLOW",
    "explanation": "(number + competition)",
    "isCharacter": false,
    "composition": [
      15742,
      "/",
      "RK:-2",
      "/",
      16451
    ]
  },
  {
    "id": "16738",
    "description": "scorpion",
    "pos": "YELLOW",
    "explanation": "(spider + to puncture: spider-like insect with a poisonous sting)",
    "isCharacter": false,
    "composition": [
      17229,
      "/",
      16212
    ]
  },
  {
    "id": "16739",
    "description": "screw",
    "pos": "YELLOW",
    "explanation": "(line + wavy line (as of fire) + line: pictograph that suggests the path made by the thread of a screw)  - Character (sequenced)",
    "isCharacter": true
  },
  {
    "id": "16740",
    "description": "screwdriver",
    "pos": "YELLOW",
    "explanation": "(tool + screw)",
    "isCharacter": false,
    "composition": [
      17755,
      "/",
      16739
    ]
  },
  {
    "id": "16741",
    "description": "scrotum",
    "pos": "YELLOW",
    "explanation": "(protection + testicle)",
    "isCharacter": false,
    "composition": [
      16420,
      "/",
      13403,
      "/",
      17226
    ]
  },
  {
    "id": "16742",
    "description": "search-(to)",
    "pos": "RED",
    "explanation": "(to watch + intensity + action indicator: to watch very intently)",
    "isCharacter": false,
    "composition": [
      24949,
      ";",
      8993,
      "/",
      14947,
      "/",
      14947
    ]
  },
  {
    "id": "16743",
    "description": "second_(time)",
    "pos": "YELLOW",
    "explanation": "(time + two apostrophes, used in astronomy to indicate a second)",
    "isCharacter": false,
    "composition": [
      17732,
      "/",
      8489,
      "/",
      8489
    ]
  },
  {
    "id": "16744",
    "description": "second_(ordinal)",
    "pos": "GREEN",
    "explanation": "(2 + decimal point + description indicator: the dot indicates an ordinal numeral)",
    "isCharacter": false,
    "composition": [
      8498,
      ";",
      8998,
      "/",
      8486
    ]
  },
  {
    "id": "16745",
    "description": "secret",
    "pos": "YELLOW",
    "explanation": "(enclosure + mouth: the mouth is closed)  - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "16746",
    "description": "secretary",
    "pos": "BLUE",
    "explanation": "(person + secret: historically, a person who keeps the boss's secrets)",
    "isCharacter": false,
    "composition": [
      16161,
      "/",
      16745
    ]
  },
  {
    "id": "16747",
    "description": "see,look,watch-(to)",
    "pos": "RED",
    "explanation": "(eye + action indicator)",
    "isCharacter": false,
    "composition": [
      14133,
      ";",
      8993
    ]
  },
  {
    "id": "16748",
    "description": "see_you_again",
    "pos": "GRAY",
    "explanation": "(to see + again + action indicator)",
    "isCharacter": false,
    "composition": [
      14133,
      ";",
      8993,
      "/",
      12350
    ]
  },
  {
    "id": "16749",
    "description": "seed",
    "pos": "YELLOW",
    "explanation": "(earth + two dots below, to represent seeds)  - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "16750",
    "description": "seem-(to)",
    "pos": "RED",
    "explanation": "(state_of_mind + what,question_mark + action indicator: can also be interpreted as mind + maybe + action indicator: to give the impression of being)",
    "isCharacter": false,
    "composition": [
      25379,
      ";",
      8993,
      "/",
      18229
    ]
  },
  {
    "id": "16751",
    "description": "seesaw,teeter-totter,teeter_board",
    "pos": "YELLOW",
    "explanation": "(slanted line (as of a diagonal of a horizontal rectangle – character of Unicode draft, missing here) + small triangle (as of female_(gender)): pictograph, slanted line on top of triangle, suggesting a seesaw)  - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "16752",
    "description": "self,oneself,ego_(person)",
    "pos": "BLUE",
    "explanation": "(1 + person [modification]: referring to oneself as person number one)",
    "isCharacter": true
  },
  {
    "id": "16753",
    "description": "self-harm",
    "pos": "YELLOW",
    "explanation": "(abuse,assault,violence + self)",
    "isCharacter": false,
    "composition": [
      22914,
      "/",
      14947,
      "/",
      8497,
      "/",
      15214
    ]
  },
  {
    "id": "16754",
    "description": "self-control",
    "pos": "YELLOW",
    "explanation": "(to lead + self: guidance of oneself)",
    "isCharacter": false,
    "composition": [
      22913,
      "/",
      8497,
      "/",
      15214
    ]
  },
  {
    "id": "16755",
    "description": "selfish,self-centred,self-centered,egoistic,egoistical,egocentric",
    "pos": "GREEN",
    "explanation": "(selfishness,egoism + description indicator: thinking only about oneself)",
    "isCharacter": false,
    "composition": [
      24937,
      ";",
      8998
    ]
  },
  {
    "id": "16756",
    "description": "sell-(to)",
    "pos": "RED",
    "explanation": "(thing + money + action indicator: first you must have something, which you can then sell for money)",
    "isCharacter": false,
    "composition": [
      17717,
      ";",
      8993,
      "/",
      15484
    ]
  },
  {
    "id": "16757",
    "description": "semen",
    "pos": "YELLOW",
    "explanation": "(liquid + sperm)",
    "isCharacter": false,
    "composition": [
      18209,
      "/",
      17226
    ]
  },
  {
    "id": "16758",
    "description": "seminal_vesicle",
    "pos": "YELLOW",
    "explanation": "(container + semen: pouch in which semen is produced)",
    "isCharacter": false,
    "composition": [
      13403,
      "/",
      18209,
      "/",
      17226
    ]
  },
  {
    "id": "16759",
    "description": "send-(to)",
    "pos": "RED",
    "explanation": "(to carry + departure + action indicator: to carry away from a given location)",
    "isCharacter": false,
    "composition": [
      25625,
      ";",
      8993,
      "/",
      13658
    ]
  },
  {
    "id": "16760",
    "description": "sentence,clause,phrase",
    "pos": "YELLOW",
    "explanation": "(group of + word: a group of words considered together)",
    "isCharacter": false,
    "composition": [
      14647,
      "/",
      15972,
      "/",
      15172
    ]
  },
  {
    "id": "16761",
    "description": "September",
    "pos": "YELLOW",
    "explanation": "(month + 9: ninth month of the year)",
    "isCharacter": false,
    "composition": [
      15649,
      "/",
      8505
    ]
  },
  {
    "id": "16762",
    "description": "several",
    "pos": "WHITE",
    "explanation": "(greater_than_(relation) + 2: greater than two)",
    "isCharacter": false,
    "composition": [
      16480,
      "/",
      8498
    ]
  },
  {
    "id": "16763",
    "description": "sew-(to)",
    "pos": "RED",
    "explanation": "(needle + action indicator)",
    "isCharacter": false,
    "composition": [
      15703,
      ";",
      8993
    ]
  },
  {
    "id": "16764",
    "description": "sewing_machine",
    "pos": "YELLOW",
    "explanation": "(machine + to sew)",
    "isCharacter": false,
    "composition": [
      15406,
      "/",
      15703
    ]
  },
  {
    "id": "16765",
    "description": "sex_drive,sexual_urge,libido",
    "pos": "YELLOW",
    "explanation": "(fire + gender,sex: sexual desire)",
    "isCharacter": false,
    "composition": [
      14183,
      "/",
      14428
    ]
  },
  {
    "id": "16766",
    "description": "sexual_abuse,sexual_assault,sexual_violence",
    "pos": "YELLOW",
    "explanation": "(abuse,assault,violence + sexual)",
    "isCharacter": false,
    "composition": [
      22914,
      "/",
      14947,
      "/",
      14428
    ]
  },
  {
    "id": "16929",
    "description": "sexual_arousal,sexual_excitement",
    "pos": "YELLOW",
    "explanation": "(excitement + gender,sex)",
    "isCharacter": false,
    "composition": [
      14164,
      "/",
      14947,
      "/",
      14947,
      "/",
      14428
    ]
  },
  {
    "id": "16930",
    "description": "sexual_harassment",
    "pos": "YELLOW",
    "explanation": "(harassment + gender,sex)",
    "isCharacter": false,
    "composition": [
      14647,
      "/",
      25553,
      "/",
      14428
    ]
  },
  {
    "id": "16931",
    "description": "sexual_intercourse,intercourse,copulation",
    "pos": "YELLOW",
    "explanation": "(to combine + gender,sex)",
    "isCharacter": false,
    "composition": [
      13380,
      "/",
      14431
    ]
  },
  {
    "id": "16932",
    "description": "sexual_pleasure",
    "pos": "YELLOW",
    "explanation": "(pleasure + gender,sex)",
    "isCharacter": false,
    "composition": [
      14164,
      "/",
      17983,
      "/",
      14428
    ]
  },
  {
    "id": "16933",
    "description": "sexuality",
    "pos": "YELLOW",
    "explanation": "(feeling + gender,sex)",
    "isCharacter": false,
    "composition": [
      14164,
      "/",
      "RK:-2",
      "/",
      14428
    ]
  },
  {
    "id": "16934",
    "description": "shake,jiggle-(to)",
    "pos": "RED",
    "explanation": "(up and down + action indicator)",
    "isCharacter": false,
    "composition": [
      20524,
      ";",
      8993
    ]
  },
  {
    "id": "16935",
    "description": "shallow",
    "pos": "GREEN",
    "explanation": "(shallowness + description indicator: pointer points downward into a relatively shallow space)",
    "isCharacter": false,
    "composition": [
      25606,
      ";",
      8998
    ]
  },
  {
    "id": "16936",
    "description": "greeting,shalom,salam_(etc)",
    "pos": "YELLOW",
    "explanation": "(mouth (to say) + meeting_and_parting: a combination of hello and goodbye, expression of greeting, either when meeting or parting)",
    "isCharacter": false,
    "composition": [
      15666,
      "/",
      25584
    ]
  },
  {
    "id": "16937",
    "description": "shame",
    "pos": "YELLOW",
    "explanation": "(sad + wrong: feeling of sadness about one's wrong behaviour)",
    "isCharacter": false,
    "composition": [
      14164,
      "/",
      13869,
      "/",
      25539,
      "/",
      14947
    ]
  },
  {
    "id": "16938",
    "description": "shampoo",
    "pos": "YELLOW",
    "explanation": "(soap + hair)",
    "isCharacter": false,
    "composition": [
      17717,
      "/",
      16992,
      "/",
      14661
    ]
  },
  {
    "id": "16939",
    "description": "shamrock,clover",
    "pos": "YELLOW",
    "explanation": "(pictograph)  - Character",
    "isCharacter": true
  },
  {
    "id": "16940",
    "description": "shape,form",
    "pos": "YELLOW",
    "explanation": "(eye + thing: how the eye perceives an object)",
    "isCharacter": false,
    "composition": [
      14133,
      "/",
      17717
    ]
  },
  {
    "id": "16941",
    "description": "share-(to)",
    "pos": "RED",
    "explanation": "(to have + together + action indicator)",
    "isCharacter": false,
    "composition": [
      24912,
      ";",
      8993,
      "/",
      23409
    ]
  },
  {
    "id": "16942",
    "description": "shark",
    "pos": "YELLOW",
    "explanation": "(fish + teeth)",
    "isCharacter": false,
    "composition": [
      14188,
      "/",
      17517
    ]
  },
  {
    "id": "16943",
    "description": "sharp_(knife)",
    "pos": "GREEN",
    "explanation": "(knife + description indicator)",
    "isCharacter": false,
    "composition": [
      15159,
      ";",
      8998
    ]
  },
  {
    "id": "16944",
    "description": "sharp_(taste),acid,sour",
    "pos": "GREEN",
    "explanation": "(taste + sharp + description indicator)",
    "isCharacter": false,
    "composition": [
      17506,
      ";",
      8998,
      "/",
      15159
    ]
  },
  {
    "id": "16945",
    "description": "shave_(beard)-(to)",
    "pos": "RED",
    "explanation": "(to cut + beard + action indicator)",
    "isCharacter": false,
    "composition": [
      15159,
      ";",
      8993,
      "/",
      12644
    ]
  },
  {
    "id": "16946",
    "description": "shaver,razor",
    "pos": "YELLOW",
    "explanation": "(knife + beard)",
    "isCharacter": false,
    "composition": [
      15159,
      "/",
      12644
    ]
  },
  {
    "id": "16947",
    "description": "shaving_soap,shaving_cream",
    "pos": "YELLOW",
    "explanation": "(soap + beard)",
    "isCharacter": false,
    "composition": [
      17717,
      "/",
      16992,
      "/",
      12644
    ]
  },
  {
    "id": "16948",
    "description": "Shavuot",
    "pos": "YELLOW",
    "explanation": "(day + commandments)",
    "isCharacter": false,
    "composition": [
      13639,
      "/",
      13388
    ]
  },
  {
    "id": "16949",
    "description": "she,her,herself",
    "pos": "BLUE",
    "explanation": "(female + 3: third person singular (f.))",
    "isCharacter": false,
    "composition": [
      18269,
      "/",
      8499
    ]
  },
  {
    "id": "16950",
    "description": "sheep",
    "pos": "YELLOW",
    "explanation": "(ovine + cloth: animal whose fleece is used to make cloth)",
    "isCharacter": false,
    "composition": [
      12379,
      "/",
      13365
    ]
  },
  {
    "id": "16951",
    "description": "sheet(s),bedclothes,bed_linen",
    "pos": "YELLOW",
    "explanation": "(cloth + bed)",
    "isCharacter": false,
    "composition": [
      13365,
      "/",
      12649
    ]
  },
  {
    "id": "16952",
    "description": "shekel",
    "pos": "YELLOW",
    "explanation": "(money + shekel_(character); the Israeli currency shekel)",
    "isCharacter": false,
    "composition": [
      15484,
      "/",
      25607
    ]
  },
  {
    "id": "16953",
    "description": "shelf",
    "pos": "YELLOW",
    "explanation": "(pictograph: symbol suggests a shelf)  - Character",
    "isCharacter": true
  },
  {
    "id": "16954",
    "description": "shell,crust",
    "pos": "YELLOW",
    "explanation": "(case,casing + pointer, to enclosure: a crust or shell surrounds the thing)  - Character (superimposed - pointer)",
    "isCharacter": true
  },
  {
    "id": "16955",
    "description": "shelter,refuge",
    "pos": "YELLOW",
    "explanation": "(room + protection)",
    "isCharacter": false,
    "composition": [
      16687,
      "/",
      16420
    ]
  },
  {
    "id": "16956",
    "description": "shine,beam-(to)",
    "pos": "RED",
    "explanation": "(sun + action indicator)",
    "isCharacter": false,
    "composition": [
      17462,
      ";",
      8993
    ]
  },
  {
    "id": "16957",
    "description": "shirt,blouse",
    "pos": "YELLOW",
    "explanation": "(clothing + chest: clothing that covers the upper part of the body)",
    "isCharacter": false,
    "composition": [
      13366,
      "/",
      13161
    ]
  },
  {
    "id": "16958",
    "description": "Shiva",
    "pos": "BLUE",
    "explanation": "(god + destruction: Hindu god) (India)",
    "isCharacter": false,
    "composition": [
      14451,
      "/",
      24883
    ]
  },
  {
    "id": "16959",
    "description": "shoe",
    "pos": "YELLOW",
    "explanation": "(protection + foot: protective covering for the feet)",
    "isCharacter": false,
    "composition": [
      16420,
      "/",
      14379
    ]
  },
  {
    "id": "16960",
    "description": "shofar",
    "pos": "YELLOW",
    "explanation": "(horn + Jewish)",
    "isCharacter": false,
    "composition": [
      14895,
      "/",
      17251
    ]
  },
  {
    "id": "16961",
    "description": "shopping_centre_(OLD)",
    "pos": "YELLOW",
    "explanation": "(many + public room: group of stores)  SUPERSEDED SYNONYM  See shopping_centre,mall,plaza 23207",
    "isCharacter": false,
    "composition": [
      14647,
      "/",
      16430
    ]
  },
  {
    "id": "16962",
    "description": "short",
    "pos": "GREEN",
    "explanation": "(shortness_(distance,length) + description indicator: horizontal line is relatively short) See also: low,short 15401 and long 15229.",
    "isCharacter": false,
    "composition": [
      24938,
      ";",
      8998
    ]
  },
  {
    "id": "16963",
    "description": "shorts",
    "pos": "YELLOW",
    "explanation": "(trousers + comma + short)",
    "isCharacter": false,
    "composition": [
      13366,
      "/",
      15188,
      "/",
      8487,
      "/",
      24938
    ]
  },
  {
    "id": "16964",
    "description": "shoulder",
    "pos": "YELLOW",
    "explanation": "(body + pointer, to shoulder)  - Character (superimposed - pointer)",
    "isCharacter": true
  },
  {
    "id": "16965",
    "description": "shout-(to)",
    "pos": "RED",
    "explanation": "(to say + two intensity symbols + action indicator: to say forcefully)",
    "isCharacter": false,
    "composition": [
      15666,
      ";",
      8993,
      "/",
      14947,
      "/",
      14947
    ]
  },
  {
    "id": "16966",
    "description": "shovel,spade",
    "pos": "YELLOW",
    "explanation": "(pictograph)  - Character",
    "isCharacter": true
  },
  {
    "id": "16967",
    "description": "show,demonstrate-(to)",
    "pos": "RED",
    "explanation": "(to cause + to observe + action indicator: to cause to be seen)",
    "isCharacter": false,
    "composition": [
      13134,
      ";",
      8993,
      "/",
      24846
    ]
  },
  {
    "id": "16968",
    "description": "shower",
    "pos": "YELLOW",
    "explanation": "(room + water + down: room where water pours down for bathing)  - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "16969",
    "description": "shower-(to)",
    "pos": "RED",
    "explanation": "(shower + action indicator)",
    "isCharacter": false,
    "composition": [
      16968,
      ";",
      8993
    ]
  },
  {
    "id": "16970",
    "description": "exhibition_hall,showplace",
    "pos": "YELLOW",
    "explanation": "(building + to see: building in which to see shows)",
    "isCharacter": false,
    "composition": [
      14905,
      "/",
      14133
    ]
  },
  {
    "id": "16971",
    "description": "Shevat,Shvat",
    "pos": "YELLOW",
    "explanation": "(month + birth + tree + plural indicator: month of Tu B’Shvat)",
    "isCharacter": false,
    "composition": [
      15649,
      "/",
      12843,
      "/",
      17775,
      ";",
      9011
    ]
  },
  {
    "id": "16972",
    "description": "sibling(s)",
    "pos": "BLUE",
    "explanation": "(offspring,child + 2: male or female family member considered in relation to another child of the same parents)",
    "isCharacter": false,
    "composition": [
      15912,
      "/",
      8498
    ]
  },
  {
    "id": "16973",
    "description": "sick,ill",
    "pos": "GREEN",
    "explanation": "(illness + description indicator)",
    "isCharacter": false,
    "composition": [
      16164,
      ";",
      8998
    ]
  },
  {
    "id": "16974",
    "description": "side_(body)",
    "pos": "YELLOW",
    "explanation": "(body + pointer, to side)  - Character (superimposed - pointer)",
    "isCharacter": true
  },
  {
    "id": "16975",
    "description": "side_(enclosure)",
    "pos": "YELLOW",
    "explanation": "(enclosure + pointer, to side)  - Character (superimposed - pointer)",
    "isCharacter": true
  },
  {
    "id": "16976",
    "description": "sieve,colander,strainer",
    "pos": "YELLOW",
    "explanation": "(container + downward [modification, low position]: container through which something can pass)  - Character (superimposed - modified)",
    "isCharacter": true
  },
  {
    "id": "16977",
    "description": "sign,advertisement",
    "pos": "YELLOW",
    "explanation": "(enclosure + attention: large square that attracts one's attention) SYMBOL SYNONYM",
    "isCharacter": false,
    "composition": [
      13934,
      "/",
      14133,
      "/",
      14947,
      "/",
      14947
    ]
  },
  {
    "id": "16978",
    "description": "sign_(OLD)",
    "pos": "YELLOW",
    "explanation": "(to point + thing: the hand points to the thing)  SUPERSEDED SYNONYM  See sign,signal 24749",
    "isCharacter": false,
    "composition": [
      23619,
      "/",
      17717
    ]
  },
  {
    "id": "16979",
    "description": "signature",
    "pos": "YELLOW",
    "explanation": "(to write + name: writing of one's name)",
    "isCharacter": false,
    "composition": [
      15991,
      "/",
      "RK:-2",
      "/",
      15691
    ]
  },
  {
    "id": "16980",
    "description": "signature_stamp",
    "pos": "YELLOW",
    "explanation": "(tool + signature)",
    "isCharacter": false,
    "composition": [
      17755,
      "/",
      15991,
      "/",
      "RK:-2",
      "/",
      15691
    ]
  },
  {
    "id": "16981",
    "description": "silence,quiet",
    "pos": "YELLOW",
    "explanation": "(minus + sound: absence of sound)",
    "isCharacter": false,
    "composition": [
      15474,
      "/",
      17216
    ]
  },
  {
    "id": "16982",
    "description": "silent",
    "pos": "GREEN",
    "explanation": "(silence + description indicator)",
    "isCharacter": false,
    "composition": [
      15474,
      "/",
      17216,
      ";",
      8998
    ]
  },
  {
    "id": "16983",
    "description": "Simchat_Torah",
    "pos": "YELLOW",
    "explanation": "(holiday + Torah)",
    "isCharacter": false,
    "composition": [
      13639,
      "/",
      14164,
      "/",
      17983,
      "/",
      17760
    ]
  },
  {
    "id": "16984",
    "description": "similar,like,alike",
    "pos": "GRAY",
    "explanation": "(near + same: nearly the same)",
    "isCharacter": false,
    "composition": [
      25586,
      "/",
      16713
    ]
  },
  {
    "id": "16985",
    "description": "similar_looking,looks_similar",
    "pos": "GRAY",
    "explanation": "(similar + eye)",
    "isCharacter": false,
    "composition": [
      25586,
      "/",
      16713,
      "/",
      14133
    ]
  },
  {
    "id": "16986",
    "description": "similar_sound,sounds_like",
    "pos": "GRAY",
    "explanation": "(similar + sound)",
    "isCharacter": false,
    "composition": [
      25586,
      "/",
      16713,
      "/",
      17216
    ]
  },
  {
    "id": "16987",
    "description": "simmer,poach-(to)",
    "pos": "RED",
    "explanation": "(to cook + water + action indicator)",
    "isCharacter": false,
    "composition": [
      14183,
      ";",
      8993,
      "/",
      14377,
      "/",
      18209
    ]
  },
  {
    "id": "16988",
    "description": "sin",
    "pos": "YELLOW",
    "explanation": "(wrong + God: something wrong in God's eyes)",
    "isCharacter": false,
    "composition": [
      25523,
      "/",
      14947,
      "/",
      14451
    ]
  },
  {
    "id": "16989",
    "description": "sin-(to)",
    "pos": "RED",
    "explanation": "(sin + action indicator)",
    "isCharacter": false,
    "composition": [
      25523,
      ";",
      8993,
      "/",
      14947,
      "/",
      14451
    ]
  },
  {
    "id": "16990",
    "description": "sing-(to)",
    "pos": "RED",
    "explanation": "(song + action indicator)",
    "isCharacter": false,
    "composition": [
      15666,
      ";",
      8993,
      "/",
      15682
    ]
  },
  {
    "id": "16991",
    "description": "singer",
    "pos": "BLUE",
    "explanation": "(person + to sing)",
    "isCharacter": false,
    "composition": [
      16161,
      "/",
      15666,
      "/",
      15682
    ]
  },
  {
    "id": "16992",
    "description": "bath,washing",
    "pos": "YELLOW",
    "explanation": "(container + water)  - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "16993",
    "description": "sinner",
    "pos": "BLUE",
    "explanation": "(person + sin: person who sins)",
    "isCharacter": false,
    "composition": [
      16161,
      "/",
      25523,
      "/",
      14947,
      "/",
      14451
    ]
  },
  {
    "id": "16994",
    "description": "sister",
    "pos": "BLUE",
    "explanation": "(daughter + 2: daughter considered in relation to another child of her parents)",
    "isCharacter": false,
    "composition": [
      13638,
      "/",
      8498
    ]
  },
  {
    "id": "16995",
    "description": "sit-(to)",
    "pos": "RED",
    "explanation": "(seat,sitting_(sitting_person) + action indicator)",
    "isCharacter": false,
    "composition": [
      16165,
      ";",
      8993
    ]
  },
  {
    "id": "16996",
    "description": "Sivan",
    "pos": "YELLOW",
    "explanation": "(month + commandments: month of the holiday of Shavout)",
    "isCharacter": false,
    "composition": [
      15649,
      "/",
      13388
    ]
  },
  {
    "id": "16997",
    "description": "skateboard",
    "pos": "YELLOW",
    "explanation": "(vehicle + ski,runner [modification, high position]: pictograph, combination of vehicle and ski)  - Character (superimposed - combined - modified)",
    "isCharacter": true
  },
  {
    "id": "16998",
    "description": "skeleton",
    "pos": "YELLOW",
    "explanation": "(structure + creature + thing indicator: supporting structure of a living creature)",
    "isCharacter": false,
    "composition": [
      17445,
      "/",
      15206,
      ";",
      9009
    ]
  },
  {
    "id": "16999",
    "description": "ski_boot(s)",
    "pos": "YELLOW",
    "explanation": "(boot(s) + ski)",
    "isCharacter": false,
    "composition": [
      16420,
      "/",
      25578,
      "/",
      25610
    ]
  },
  {
    "id": "17000",
    "description": "ski_pole(s)",
    "pos": "YELLOW",
    "explanation": "(2 + linear thing + ski + thing indicator)",
    "isCharacter": false,
    "composition": [
      8498,
      "/",
      15214,
      ";",
      9009,
      "/",
      25610
    ]
  },
  {
    "id": "17001",
    "description": "skin",
    "pos": "YELLOW",
    "explanation": "(protection + body: protective covering for the body)",
    "isCharacter": false,
    "composition": [
      16420,
      "/",
      12870
    ]
  },
  {
    "id": "17002",
    "description": "skirt",
    "pos": "YELLOW",
    "explanation": "(clothing,clothes,garment + woman_(below_waist): can also be explained as dress + pointer, to skirt)",
    "isCharacter": false,
    "composition": [
      13366,
      "/",
      25636
    ]
  },
  {
    "id": "17003",
    "description": "skis_(pair_of)",
    "pos": "YELLOW",
    "explanation": "(2 + ski)",
    "isCharacter": false,
    "composition": [
      8498,
      "/",
      25610
    ]
  },
  {
    "id": "17004",
    "description": "skullcap,kipa,yarmulke",
    "pos": "YELLOW",
    "explanation": "(hat + Jewish: head covering for religious purposes)",
    "isCharacter": false,
    "composition": [
      16420,
      "/",
      14689,
      "/",
      17251
    ]
  },
  {
    "id": "17005",
    "description": "skunk",
    "pos": "YELLOW",
    "explanation": "(animal + to smell bad: animal that gives off a disagreeable smell)",
    "isCharacter": false,
    "composition": [
      12378,
      "/",
      17017,
      "/",
      15474,
      "/",
      14947
    ]
  },
  {
    "id": "17006",
    "description": "sky",
    "pos": "YELLOW",
    "explanation": "(horizontal line, on the skyline of the symbol drawing area)  - Character",
    "isCharacter": true
  },
  {
    "id": "17007",
    "description": "sled,sledge,sleigh,toboggan",
    "pos": "YELLOW",
    "explanation": "(thing [modification, on earthline] + ski,runner_(sled_etc): pictograph, symbol suggests a sled, a snow vehicle to carry things)  - Character (superimposed - modified)",
    "isCharacter": true
  },
  {
    "id": "17008",
    "description": "sleep",
    "pos": "YELLOW",
    "explanation": "(eye + to close: one's eyes are closed in sleep)  - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "17009",
    "description": "sleep-(to)",
    "pos": "RED",
    "explanation": "(sleep + action indicator)",
    "isCharacter": false,
    "composition": [
      17008,
      ";",
      8993
    ]
  },
  {
    "id": "17010",
    "description": "sleeping_bag",
    "pos": "YELLOW",
    "explanation": "(sack + to sleep)",
    "isCharacter": false,
    "composition": [
      16701,
      "/",
      17008
    ]
  },
  {
    "id": "17011",
    "description": "slide",
    "pos": "YELLOW",
    "explanation": "(downward and forward + thing indicator: thing for sliding)  - (character with thing indicator)",
    "isCharacter": "false",
    "composition": [
      13871,
      ";",
      9009
    ]
  },
  {
    "id": "17012",
    "description": "slip,petticoat,half-slip,underskirt",
    "pos": "YELLOW",
    "explanation": "(dress + under)",
    "isCharacter": false,
    "composition": [
      13366,
      "/",
      18269,
      "/",
      17969
    ]
  },
  {
    "id": "17013",
    "description": "slipper(s)",
    "pos": "YELLOW",
    "explanation": "(shoe(s) + comma + house: shoe(s) worn mainly indoors)",
    "isCharacter": false,
    "composition": [
      16420,
      "/",
      14379,
      "/",
      14905
    ]
  },
  {
    "id": "17014",
    "description": "slow,slowly_(OLD)",
    "pos": "GREEN",
    "explanation": "(opposite meaning + fast + description indicator)  SUPERSEDED SYNONYM  See slow,slowly 24268",
    "isCharacter": false,
    "composition": [
      15927,
      "/",
      14390,
      ";",
      8998,
      "/",
      14947
    ]
  },
  {
    "id": "17015",
    "description": "smart,bright,clever,intelligent",
    "pos": "GREEN",
    "explanation": "(smartness,brightness,cleverness,intelligence + description indicator: having striking mental abilities)",
    "isCharacter": false,
    "composition": [
      15471,
      ";",
      8998,
      "/",
      14947
    ]
  },
  {
    "id": "17016",
    "description": "smash,grind,shatter,splinter-(to)",
    "pos": "RED",
    "explanation": "(to break + many + piece + action indicator)",
    "isCharacter": false,
    "composition": [
      24852,
      ";",
      8993,
      "/",
      14647,
      "/",
      15972
    ]
  },
  {
    "id": "17017",
    "description": "smell,odour",
    "pos": "YELLOW",
    "explanation": "(nose + earth [half-sized]: what the nose gets from the earth)  - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "17018",
    "description": "smell-(to)",
    "pos": "RED",
    "explanation": "(nose + action indicator)",
    "isCharacter": false,
    "composition": [
      15732,
      ";",
      8993
    ]
  },
  {
    "id": "17019",
    "description": "smell,give_off_odour-(to)",
    "pos": "RED",
    "explanation": "(smell + action indicator: to give off a smell or odour)",
    "isCharacter": false,
    "composition": [
      17017,
      ";",
      8993
    ]
  },
  {
    "id": "17020",
    "description": "smell_bad,stink-(to)",
    "pos": "RED",
    "explanation": "(to smell + negative + action indicator)",
    "isCharacter": false,
    "composition": [
      17017,
      ";",
      8993,
      "/",
      15474,
      "/",
      14947
    ]
  },
  {
    "id": "17021",
    "description": "smile,grin-(to)",
    "pos": "RED",
    "explanation": "(happy + face + action indicator: to make a happy face)",
    "isCharacter": false,
    "composition": [
      14164,
      ";",
      8993,
      "/",
      17983,
      "/",
      14138
    ]
  },
  {
    "id": "17022",
    "description": "smoke",
    "pos": "YELLOW",
    "explanation": "(cloud + fire)",
    "isCharacter": false,
    "composition": [
      13367,
      "/",
      14183
    ]
  },
  {
    "id": "17185",
    "description": "smoke-(to)",
    "pos": "RED",
    "explanation": "(smoking_(cigarette) + action indicator)",
    "isCharacter": false,
    "composition": [
      25611,
      ";",
      8993
    ]
  },
  {
    "id": "17186",
    "description": "smooth",
    "pos": "GREEN",
    "explanation": "(hand + glass + description indicator: feeling like glass)",
    "isCharacter": false,
    "composition": [
      14667,
      ";",
      8998,
      "/",
      14442
    ]
  },
  {
    "id": "17187",
    "description": "snack_(food)",
    "pos": "YELLOW",
    "explanation": "(meal + comma + little: small or light meal)",
    "isCharacter": false,
    "composition": [
      14647,
      "/",
      14377,
      "/",
      8487,
      "/",
      24917
    ]
  },
  {
    "id": "17188",
    "description": "snail",
    "pos": "YELLOW",
    "explanation": "(pictograph: symbol suggests a snail)  - Character",
    "isCharacter": true
  },
  {
    "id": "17189",
    "description": "snake",
    "pos": "YELLOW",
    "explanation": "(pictograph: symbol suggests a snake)  - Character",
    "isCharacter": true
  },
  {
    "id": "17190",
    "description": "water_snake",
    "pos": "YELLOW",
    "explanation": "(snake + water [modification, low position under the earthline]: snake that spends much time in the water)  - Character (superimposed - modified)",
    "isCharacter": true
  },
  {
    "id": "17191",
    "description": "sneeze-(to)",
    "pos": "RED",
    "explanation": "(nose + to blow + intensity + action indicator: to blow air forcefully from one's nose)",
    "isCharacter": false,
    "composition": [
      15732,
      ";",
      8993,
      "/",
      18255,
      "/",
      14947
    ]
  },
  {
    "id": "17192",
    "description": "snow",
    "pos": "YELLOW",
    "explanation": "(water + down [modification] + star [modification, on earthline] (combination): water that comes down from the sky in star-shaped flakes)  - Character (superimposed - modified - combined)",
    "isCharacter": true
  },
  {
    "id": "17193",
    "description": "snow-(to)",
    "pos": "RED",
    "explanation": "(snow + action indicator)",
    "isCharacter": false,
    "composition": [
      17192,
      ";",
      8993
    ]
  },
  {
    "id": "17194",
    "description": "snowball",
    "pos": "YELLOW",
    "explanation": "(snow + ball: snow shaped into a ball)",
    "isCharacter": false,
    "composition": [
      17192,
      "/",
      12621
    ]
  },
  {
    "id": "17195",
    "description": "snowflake",
    "pos": "YELLOW",
    "explanation": "(snow + pointer, to star-shaped flake)  - Character (superimposed - pointer)",
    "isCharacter": true
  },
  {
    "id": "17196",
    "description": "snowman",
    "pos": "YELLOW",
    "explanation": "(snow + man: snow shaped like a man)",
    "isCharacter": false,
    "composition": [
      17192,
      "/",
      15416
    ]
  },
  {
    "id": "17197",
    "description": "snowshoe_(OLD)",
    "pos": "YELLOW",
    "explanation": "(snowshoe + legs and feet + snow: special shoe for walking over snow)  SUPERSEDED SYNONYM  See snowshoe 25613",
    "isCharacter": false,
    "composition": [
      25613,
      "/",
      15189,
      "/",
      17192
    ]
  },
  {
    "id": "17198",
    "description": "snowstorm",
    "pos": "YELLOW",
    "explanation": "(storm + snow)",
    "isCharacter": false,
    "composition": [
      14647,
      "/",
      14647,
      "/",
      18255,
      "/",
      17192
    ]
  },
  {
    "id": "17199",
    "description": "snowsuit,winter_clothing",
    "pos": "YELLOW",
    "explanation": "(clothing + snow)",
    "isCharacter": false,
    "composition": [
      13366,
      "/",
      17192
    ]
  },
  {
    "id": "17200",
    "description": "soap,detergent",
    "pos": "YELLOW",
    "explanation": "(thing + to wash)",
    "isCharacter": false,
    "composition": [
      17717,
      "/",
      16992
    ]
  },
  {
    "id": "17201",
    "description": "social_worker",
    "pos": "BLUE",
    "explanation": "(worker + to help + person: person whose work consists of helping others)",
    "isCharacter": false,
    "composition": [
      16161,
      "/",
      18273,
      "/",
      14704,
      "/",
      16161
    ]
  },
  {
    "id": "17202",
    "description": "soda_pop,pop,soft_drink",
    "pos": "YELLOW",
    "explanation": "(drink + gas: carbonated drink)",
    "isCharacter": false,
    "composition": [
      13881,
      "/",
      14424
    ]
  },
  {
    "id": "17203",
    "description": "soft",
    "pos": "GREEN",
    "explanation": "(hand + imprint,depression + description indicator)",
    "isCharacter": false,
    "composition": [
      14667,
      ";",
      8998,
      "/",
      25575
    ]
  },
  {
    "id": "17204",
    "description": "soldier,warrior",
    "pos": "BLUE",
    "explanation": "(person + war)",
    "isCharacter": false,
    "composition": [
      16161,
      "/",
      18036
    ]
  },
  {
    "id": "17205",
    "description": "solid_thing",
    "pos": "YELLOW",
    "explanation": "(thing [modification, low position] + thing [modification, high position]: simplified three dimensional drawing of a solid object)  - Character (superimposed - modified)",
    "isCharacter": true
  },
  {
    "id": "17206",
    "description": "solve-(to)",
    "pos": "RED",
    "explanation": "(to answer + difficult + action indicator: to answer a difficult question)",
    "isCharacter": false,
    "composition": [
      12393,
      ";",
      8993,
      "/",
      24884
    ]
  },
  {
    "id": "17207",
    "description": "some,any",
    "pos": "GREEN",
    "explanation": "(part + description indicator)",
    "isCharacter": false,
    "composition": [
      15972,
      ";",
      8998
    ]
  },
  {
    "id": "17208",
    "description": "sometimes",
    "pos": "GREEN",
    "explanation": "(part of + time: part of the time, i.e., sometimes)",
    "isCharacter": false,
    "composition": [
      15972,
      "/",
      17732,
      ";",
      8998
    ]
  },
  {
    "id": "17209",
    "description": "son",
    "pos": "BLUE",
    "explanation": "(protection + male: male born under the family roof)  - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "17210",
    "description": "song",
    "pos": "YELLOW",
    "explanation": "(mouth + musical note: vocal music)",
    "isCharacter": false,
    "composition": [
      15666,
      "/",
      15682
    ]
  },
  {
    "id": "17211",
    "description": "songbird,finch,thrush",
    "pos": "YELLOW",
    "explanation": "(bird + song)",
    "isCharacter": false,
    "composition": [
      12837,
      "/",
      "RK:-2",
      "/",
      15666,
      "/",
      15682
    ]
  },
  {
    "id": "17212",
    "description": "soon",
    "pos": "GREEN",
    "explanation": "(future + near + description indicator: in the near future)",
    "isCharacter": false,
    "composition": [
      14417,
      ";",
      8998,
      "/",
      25586
    ]
  },
  {
    "id": "17213",
    "description": "wound,cut,sore",
    "pos": "YELLOW",
    "explanation": "(to break + skin)",
    "isCharacter": false,
    "composition": [
      24852,
      "/",
      16420,
      "/",
      12870
    ]
  },
  {
    "id": "17214",
    "description": "sorry",
    "pos": "GRAY",
    "explanation": "(sadness + about + past)",
    "isCharacter": false,
    "composition": [
      14164,
      "/",
      13869,
      "/",
      12324,
      "/",
      15975
    ]
  },
  {
    "id": "17215",
    "description": "sufganiya",
    "pos": "YELLOW",
    "explanation": "(disc + Chanukah: traditional sweet eaten at Chanukah)",
    "isCharacter": false,
    "composition": [
      13685,
      "/",
      13639,
      "/",
      14164,
      "/",
      17983,
      "/",
      15208
    ]
  },
  {
    "id": "17216",
    "description": "sound",
    "pos": "YELLOW",
    "explanation": "(ear + earth [half-sized]: what the ear receives from the earth)  - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "17217",
    "description": "sound-(to)",
    "pos": "RED",
    "explanation": "(sound + action indicator)",
    "isCharacter": false,
    "composition": [
      17216,
      ";",
      8993
    ]
  },
  {
    "id": "17218",
    "description": "soup,broth",
    "pos": "YELLOW",
    "explanation": "(dish + liquid)  - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "17219",
    "description": "south",
    "pos": "YELLOW",
    "explanation": "(sun + pointer, to south)  - Character (superimposed - pointer)",
    "isCharacter": true
  },
  {
    "id": "17220",
    "description": "southern",
    "pos": "GREEN",
    "explanation": "(south + description indicator)",
    "isCharacter": false,
    "composition": [
      17219,
      ";",
      8998
    ]
  },
  {
    "id": "17221",
    "description": "space,dimension",
    "pos": "YELLOW",
    "explanation": "(three coordinate axes drawn in perspective, illustrating the three dimensions of space)  - Character",
    "isCharacter": true
  },
  {
    "id": "17222",
    "description": "spaghetti_(OLD)",
    "pos": "YELLOW",
    "explanation": "(food + flour + linear thing + thing indicator: long, thin pasta)  SUPERSEDED SYNONYM  See spaghetti 20521",
    "isCharacter": false,
    "composition": [
      14377,
      "/",
      16233,
      "/",
      14625,
      "/",
      15214,
      ";",
      9009
    ]
  },
  {
    "id": "17223",
    "description": "special,particular",
    "pos": "GREEN",
    "explanation": "(feeling + interesting + description indicator)",
    "isCharacter": false,
    "composition": [
      14164,
      ";",
      8998,
      "/",
      24916
    ]
  },
  {
    "id": "17224",
    "description": "specific",
    "pos": "GREEN",
    "explanation": "(the + description indicator)",
    "isCharacter": false,
    "composition": [
      17700,
      ";",
      8998
    ]
  },
  {
    "id": "17225",
    "description": "speech_impaired_(OLD)",
    "pos": "GREEN",
    "explanation": "(limit(s),limitation_(OLD) + to speak + description indicator: having difficulties to speak intelligibly)  See also: nonspeaking  SUPERSEDED SYNONYM  See speech_impaired 26025",
    "isCharacter": false,
    "composition": [
      15213,
      ";",
      8998,
      "/",
      15666
    ]
  },
  {
    "id": "17226",
    "description": "sperm",
    "pos": "YELLOW",
    "explanation": "(pictograph)  - Character",
    "isCharacter": true
  },
  {
    "id": "17227",
    "description": "spermicide",
    "pos": "YELLOW",
    "explanation": "(chemical product + sperm_destruction)",
    "isCharacter": false,
    "composition": [
      13158,
      "/",
      25615
    ]
  },
  {
    "id": "17228",
    "description": "spice_box",
    "pos": "YELLOW",
    "explanation": "(container + seasoning)",
    "isCharacter": false,
    "composition": [
      13403,
      "/",
      12339,
      ";",
      9009,
      "/",
      17506
    ]
  },
  {
    "id": "17229",
    "description": "spider",
    "pos": "YELLOW",
    "explanation": "(pictograph: symbol suggests a spider)  - Character",
    "isCharacter": true
  },
  {
    "id": "17230",
    "description": "spiral,curl_(shape)",
    "pos": "YELLOW",
    "explanation": "(shape + spiral)",
    "isCharacter": false,
    "composition": [
      14133,
      "/",
      17717,
      "/",
      25616
    ]
  },
  {
    "id": "17231",
    "description": "spit-(to)",
    "pos": "RED",
    "explanation": "(spitting + action indicator: to expel from one's mouth)",
    "isCharacter": false,
    "composition": [
      25617,
      ";",
      8993
    ]
  },
  {
    "id": "17232",
    "description": "splash-(to)",
    "pos": "RED",
    "explanation": "(to hit + water + action indicator)",
    "isCharacter": false,
    "composition": [
      14667,
      ";",
      8993,
      "/",
      14947,
      "/",
      14947,
      "/",
      18209
    ]
  },
  {
    "id": "17233",
    "description": "spoon",
    "pos": "YELLOW",
    "explanation": "(pictograph: symbol suggests a spoon. The diagonal orientation of spoon is the same as that of fork and knife.)  - Character",
    "isCharacter": true
  },
  {
    "id": "17234",
    "description": "sport_(OLD)",
    "pos": "YELLOW",
    "explanation": "(activity + healthy)  SUPERSEDED SYNONYM  See sport 20518",
    "isCharacter": false,
    "composition": [
      12335,
      "/",
      14690
    ]
  },
  {
    "id": "17235",
    "description": "sport_stick",
    "pos": "YELLOW",
    "explanation": "(pictograph: symbol suggests a hockey stick)  - Character",
    "isCharacter": true
  },
  {
    "id": "17236",
    "description": "spot,mark",
    "pos": "YELLOW",
    "explanation": "(eye + dot: dot perceived by the eye)",
    "isCharacter": false,
    "composition": [
      14133,
      "/",
      13867
    ]
  },
  {
    "id": "17237",
    "description": "spouse,cohabitant,partner",
    "pos": "BLUE",
    "explanation": "(person + protection: person who shares one's roof)  - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "17238",
    "description": "spread,paste",
    "pos": "YELLOW",
    "explanation": "(food + on (combination): food that is put on something else)  - Character (superimposed - combined)",
    "isCharacter": true
  },
  {
    "id": "17239",
    "description": "spread_(cover_with_spread)-(to)",
    "pos": "RED",
    "explanation": "(spread + action indicator)",
    "isCharacter": false,
    "composition": [
      17238,
      ";",
      8993
    ]
  },
  {
    "id": "17240",
    "description": "spring_(ckb)",
    "pos": "YELLOW",
    "explanation": "(sun + 1: first season) (CKB) SYMBOL SYNONYM",
    "isCharacter": false,
    "composition": [
      17462,
      "/",
      8497
    ]
  },
  {
    "id": "17241",
    "description": "spring",
    "pos": "YELLOW",
    "explanation": "(sun + 1 + flower + up: first season when flowers begin to grow) (BCI) SYMBOL SYNONYM",
    "isCharacter": false,
    "composition": [
      17462,
      "/",
      8497,
      "/",
      14205,
      "/",
      17983
    ]
  },
  {
    "id": "17242",
    "description": "square_(shape)",
    "pos": "YELLOW",
    "explanation": "(shape + enclosure (with a square shape): square, a geometric shape)",
    "isCharacter": false,
    "composition": [
      14133,
      "/",
      17717,
      "/",
      13934
    ]
  },
  {
    "id": "17243",
    "description": "square_(description)",
    "pos": "GREEN",
    "explanation": "(square_(shape) + description indicator)",
    "isCharacter": false,
    "composition": [
      14133,
      ";",
      8998,
      "/",
      17717,
      "/",
      13934
    ]
  },
  {
    "id": "17244",
    "description": "squash,pumpkin",
    "pos": "YELLOW",
    "explanation": "(vegetable above ground [modification] + pictograph of thick rind)  - Character (superimposed - modified - combined)",
    "isCharacter": true
  },
  {
    "id": "17245",
    "description": "squirrel",
    "pos": "YELLOW",
    "explanation": "(animal_(bushy_tailed) + teeth: rodent with a bushy tail)",
    "isCharacter": false,
    "composition": [
      25521,
      "/",
      17517
    ]
  },
  {
    "id": "17246",
    "description": "staff",
    "pos": "BLUE",
    "explanation": "(group + to serve: group of people working to serve others)",
    "isCharacter": false,
    "composition": [
      14647,
      "/",
      16161,
      "/",
      14704
    ]
  },
  {
    "id": "17247",
    "description": "stairs,steps",
    "pos": "YELLOW",
    "explanation": "(pictograph: symbol suggests a side view of a flight of stairs)  - Character",
    "isCharacter": true
  },
  {
    "id": "17248",
    "description": "stamp",
    "pos": "YELLOW",
    "explanation": "(pictograph: symbol suggests a stamp in the upper corner of an envelope)  - Character",
    "isCharacter": true
  },
  {
    "id": "17249",
    "description": "stand-(to)",
    "pos": "RED",
    "explanation": "(standing_(standing_person) + action indicator)",
    "isCharacter": false,
    "composition": [
      16166,
      ";",
      8993
    ]
  },
  {
    "id": "17250",
    "description": "stander",
    "pos": "YELLOW",
    "explanation": "(support + medical + to stand + thing indicator: medical device for standing)",
    "isCharacter": false,
    "composition": [
      14704,
      ";",
      9009,
      "/",
      24920,
      "/",
      16166
    ]
  },
  {
    "id": "17251",
    "description": "star_of_David",
    "pos": "YELLOW",
    "explanation": "(symbol for Judaism)  - Character",
    "isCharacter": true
  },
  {
    "id": "17252",
    "description": "star",
    "pos": "YELLOW",
    "explanation": "(pictograph: symbol suggests a star giving off rays of light)  - Character",
    "isCharacter": true
  },
  {
    "id": "17253",
    "description": "starfish_(OLD)",
    "pos": "YELLOW",
    "explanation": "(fish + star)  SUPERSEDED SYNONYM  See starfish 23220",
    "isCharacter": false,
    "composition": [
      14188,
      "/",
      17252
    ]
  },
  {
    "id": "17254",
    "description": "stay,remain-(to)",
    "pos": "RED",
    "explanation": "(without + to advance + action indicator)",
    "isCharacter": false,
    "composition": [
      15474,
      "/",
      14390,
      ";",
      8993
    ]
  },
  {
    "id": "17255",
    "description": "steam",
    "pos": "YELLOW",
    "explanation": "(water + up: when water is converted into steam by boiling, it rises)  - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "17256",
    "description": "steam-(to)",
    "pos": "RED",
    "explanation": "(steam + action indicator)",
    "isCharacter": false,
    "composition": [
      17255,
      ";",
      8993
    ]
  },
  {
    "id": "17257",
    "description": "steam_bath",
    "pos": "YELLOW",
    "explanation": "(room + steam)  - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "17258",
    "description": "steel",
    "pos": "YELLOW",
    "explanation": "(material + knife: the material of which knives are made)",
    "isCharacter": false,
    "composition": [
      15431,
      "/",
      15159
    ]
  },
  {
    "id": "17259",
    "description": "stem,stalk",
    "pos": "YELLOW",
    "explanation": "(flower + pointer, to stem)  - Character (superimposed - pointer)",
    "isCharacter": true
  },
  {
    "id": "17260",
    "description": "stepfather",
    "pos": "BLUE",
    "explanation": "(husband + mother: husband of one's mother)  - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "17261",
    "description": "stepmother",
    "pos": "BLUE",
    "explanation": "(wife + father: wife of one's father)  - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "17262",
    "description": "sterilization",
    "pos": "YELLOW",
    "explanation": "(to cause + infertile)",
    "isCharacter": false,
    "composition": [
      13134,
      "/",
      15474,
      "/",
      13395
    ]
  },
  {
    "id": "17263",
    "description": "stick,log",
    "pos": "YELLOW",
    "explanation": "(linear thing + tree + thing indicator)",
    "isCharacter": false,
    "composition": [
      15214,
      ";",
      9009,
      "/",
      17775
    ]
  },
  {
    "id": "17264",
    "description": "stocking(s),sock(s),pantyhose,tights",
    "pos": "YELLOW",
    "explanation": "(clothing + leg_and_foot: clothing worn on legs and feet)",
    "isCharacter": false,
    "composition": [
      13366,
      "/",
      25578
    ]
  },
  {
    "id": "17265",
    "description": "stomach,abdomen,belly",
    "pos": "YELLOW",
    "explanation": "(body + pointer to stomach)  - Character (superimposed - pointer)",
    "isCharacter": true
  },
  {
    "id": "17266",
    "description": "stone_(material)",
    "pos": "YELLOW",
    "explanation": "(material + stone)",
    "isCharacter": false,
    "composition": [
      15431,
      "/",
      17267
    ]
  },
  {
    "id": "17267",
    "description": "stone,rock",
    "pos": "YELLOW",
    "explanation": "(mountain [half-sized])  - Character",
    "isCharacter": true
  },
  {
    "id": "17268",
    "description": "stop,arrive,end-(to)",
    "pos": "RED",
    "explanation": "(end + action indicator)",
    "isCharacter": false,
    "composition": [
      13935,
      ";",
      8993
    ]
  },
  {
    "id": "17269",
    "description": "store_(OLD)",
    "pos": "YELLOW",
    "explanation": "(public room + business: public room where money is exchanged for goods)    SUPERSEDED SYNONYM  See store,shop 23223",
    "isCharacter": false,
    "composition": [
      16430,
      "/",
      13093
    ]
  },
  {
    "id": "17270",
    "description": "storeroom",
    "pos": "YELLOW",
    "explanation": "(room + to hold)",
    "isCharacter": false,
    "composition": [
      16687,
      "/",
      13403
    ]
  },
  {
    "id": "17271",
    "description": "gale",
    "pos": "YELLOW",
    "explanation": "(much + wind)  See storm 23956 and hurricane 23887",
    "isCharacter": false,
    "composition": [
      14647,
      "/",
      18255
    ]
  },
  {
    "id": "17272",
    "description": "story,report,tale",
    "pos": "YELLOW",
    "explanation": "(page + mouth: spoken narrative. The symbol is used for story in a general sense, whether spoken, written, or printed.)",
    "isCharacter": false,
    "composition": [
      15962,
      "/",
      15666
    ]
  },
  {
    "id": "17273",
    "description": "stove,furnace,heater,oven",
    "pos": "YELLOW",
    "explanation": "(fire + enclosure: enclosed source of heat)  - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "17274",
    "description": "strange",
    "pos": "GREEN",
    "explanation": "(feeling + what,question_mark + description indicator: characteristic of someone or something about which one feels doubtful)",
    "isCharacter": false,
    "composition": [
      14164,
      ";",
      8998,
      "/",
      18229
    ]
  },
  {
    "id": "17275",
    "description": "stranger",
    "pos": "BLUE",
    "explanation": "(person + strange: person who is strange, unknown)",
    "isCharacter": false,
    "composition": [
      16161,
      "/",
      14164,
      "/",
      18229
    ]
  },
  {
    "id": "17276",
    "description": "strap,string,velcro,rope,cord",
    "pos": "YELLOW",
    "explanation": "(linear thing + to fasten + thing indicator: linear thing that fastens or joins)",
    "isCharacter": false,
    "composition": [
      15214,
      ";",
      9009,
      "/",
      23409
    ]
  },
  {
    "id": "17277",
    "description": "straw,drinking_straw",
    "pos": "YELLOW",
    "explanation": "(linear thing + drink + thing indicator)",
    "isCharacter": false,
    "composition": [
      15214,
      ";",
      9009,
      "/",
      13881
    ]
  },
  {
    "id": "17278",
    "description": "strawberry",
    "pos": "YELLOW",
    "explanation": "(berry + pictograph of seeds showing on the outside)  - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "17441",
    "description": "street",
    "pos": "YELLOW",
    "explanation": "(street_with_building + pointer, to street: ground, next to a building, used as a public thoroughfare) - Character (superimposed - pointer)",
    "isCharacter": true
  },
  {
    "id": "17442",
    "description": "string_bean,green_bean,runner_bean,wax_bean",
    "pos": "YELLOW",
    "explanation": "(bean + long)",
    "isCharacter": false,
    "composition": [
      12642,
      "/",
      15193
    ]
  },
  {
    "id": "17443",
    "description": "stroke-(to)",
    "pos": "RED",
    "explanation": "(hand + back and forth + action indicator)",
    "isCharacter": false,
    "composition": [
      14667,
      ";",
      8993,
      "/",
      12610
    ]
  },
  {
    "id": "17444",
    "description": "strong,powerful",
    "pos": "GREEN",
    "explanation": "(strength + description indicator: symbol suggests the outline of a person, arm bent, biceps flexed, showing strength)",
    "isCharacter": false,
    "composition": [
      24941,
      ";",
      8998
    ]
  },
  {
    "id": "17445",
    "description": "structure,construction",
    "pos": "YELLOW",
    "explanation": "(enclosure [modification, formed of lines and dots]) - Character (modified)",
    "isCharacter": true
  },
  {
    "id": "17446",
    "description": "student,pupil",
    "pos": "BLUE",
    "explanation": "(person + to learn)",
    "isCharacter": false,
    "composition": [
      16161,
      "/",
      24727,
      "/",
      15162
    ]
  },
  {
    "id": "17447",
    "description": "stupid,dumb_(OLD)",
    "pos": "GREEN",
    "explanation": "(opposite meaning + smart + description indicator)  SUPERSEDED SYNONYM  See stupid,dumb 24295",
    "isCharacter": false,
    "composition": [
      15927,
      "/",
      15471,
      ";",
      8998,
      "/",
      14947
    ]
  },
  {
    "id": "17448",
    "description": "subtract,remove,take_away-(to)",
    "pos": "RED",
    "explanation": "(subtraction + action indicator)",
    "isCharacter": false,
    "composition": [
      17449,
      ";",
      8993
    ]
  },
  {
    "id": "17449",
    "description": "subtraction,loss",
    "pos": "YELLOW",
    "explanation": "(based upon the international mathematical symbol)  - Character",
    "isCharacter": true
  },
  {
    "id": "17450",
    "description": "succeed-(to)",
    "pos": "RED",
    "explanation": "(success + action indicator)",
    "isCharacter": false,
    "composition": [
      17451,
      ";",
      8993
    ]
  },
  {
    "id": "17451",
    "description": "success",
    "pos": "YELLOW",
    "explanation": "(opposing_forces,counter-forces + forward: the forward arrow moves forward through the two arrows of opposing forces, i.e., it has success in overcoming the opposing forces) - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "17452",
    "description": "suddenly,abrupt,sudden",
    "pos": "GREEN",
    "explanation": "(time + lightning + description indicator: occurring as suddenly as a bolt of lightning)",
    "isCharacter": false,
    "composition": [
      17732,
      ";",
      8998,
      "/",
      15209
    ]
  },
  {
    "id": "17453",
    "description": "sugar,sweetener",
    "pos": "YELLOW",
    "explanation": "(adding,additive + sweetness + thing indicator: combination of flavouring and sweet)",
    "isCharacter": false,
    "composition": [
      12339,
      ";",
      9009,
      "/",
      17506,
      "/",
      17983
    ]
  },
  {
    "id": "17454",
    "description": "suggest,propose-(to)",
    "pos": "RED",
    "explanation": "(suggestion + action indicator)",
    "isCharacter": false,
    "composition": [
      15925,
      ";",
      8993,
      "/",
      16437
    ]
  },
  {
    "id": "17455",
    "description": "suggestion,proposal",
    "pos": "YELLOW",
    "explanation": "(opinion + purpose)",
    "isCharacter": false,
    "composition": [
      15925,
      "/",
      16437
    ]
  },
  {
    "id": "17456",
    "description": "suit",
    "pos": "YELLOW",
    "explanation": "(clothing + 2 + part: two piece clothing)",
    "isCharacter": false,
    "composition": [
      13366,
      "/",
      8498,
      "/",
      15972
    ]
  },
  {
    "id": "17457",
    "description": "sukkah",
    "pos": "YELLOW",
    "explanation": "(house + roof + tree + thing indicator + plural indicator: house for Sukkot)",
    "isCharacter": false,
    "composition": [
      14905,
      "/",
      16420,
      ";",
      9009,
      "/",
      17775,
      ";",
      9011
    ]
  },
  {
    "id": "17458",
    "description": "Sukkot",
    "pos": "YELLOW",
    "explanation": "(week + roof + tree + thing indicator + plural indicator: week-long holiday when a ceremonial hut is built from branches)",
    "isCharacter": false,
    "composition": [
      8503,
      "/",
      13639,
      "/",
      16420,
      ";",
      9009,
      "/",
      17775,
      ";",
      9011
    ]
  },
  {
    "id": "17459",
    "description": "summer_(ckb)",
    "pos": "YELLOW",
    "explanation": "(sun + 2: second season) (CKB) SYMBOL SYNONYM",
    "isCharacter": false,
    "composition": [
      17462,
      "/",
      8498
    ]
  },
  {
    "id": "17460",
    "description": "summer",
    "pos": "YELLOW",
    "explanation": "(sun + 2 + hot: second season when it is hot) (BCI) SYMBOL SYNONYM",
    "isCharacter": false,
    "composition": [
      17462,
      "/",
      8498,
      "/",
      14696
    ]
  },
  {
    "id": "17461",
    "description": "summer_day_camp",
    "pos": "YELLOW",
    "explanation": "(gathering + day + summer)",
    "isCharacter": false,
    "composition": [
      14427,
      "/",
      13639,
      "/",
      17462,
      "/",
      8498,
      "/",
      14696
    ]
  },
  {
    "id": "17462",
    "description": "sun",
    "pos": "YELLOW",
    "explanation": "(pictograph)  - Character",
    "isCharacter": true
  },
  {
    "id": "17463",
    "description": "sunscreen,sunblock,sun_lotion",
    "pos": "YELLOW",
    "explanation": "(chemical product + against + sun)",
    "isCharacter": false,
    "composition": [
      13158,
      "/",
      12351,
      "/",
      17462
    ]
  },
  {
    "id": "17464",
    "description": "Sunday_(OLD)",
    "pos": "YELLOW",
    "explanation": "(day + 1: first day of the week - based on the convention of Sunday being the first)  SUPERSEDED SYNONYM  See Sunday_(day7) 25182, Sunday_(day1) 25180, Sunday_(day2) 25181",
    "isCharacter": false,
    "composition": [
      13639,
      "/",
      8497
    ]
  },
  {
    "id": "17465",
    "description": "sunny",
    "pos": "GREEN",
    "explanation": "(sun + description indicator)",
    "isCharacter": false,
    "composition": [
      17462,
      ";",
      8998
    ]
  },
  {
    "id": "17466",
    "description": "sunrise",
    "pos": "YELLOW",
    "explanation": "(morning_(early) + up: half sun going up)",
    "isCharacter": false,
    "composition": [
      15656,
      "/",
      17983
    ]
  },
  {
    "id": "17467",
    "description": "sunset",
    "pos": "YELLOW",
    "explanation": "(morning_(early) + down: half sun going down)",
    "isCharacter": false,
    "composition": [
      15656,
      "/",
      13869
    ]
  },
  {
    "id": "17468",
    "description": "supper,dinner",
    "pos": "YELLOW",
    "explanation": "(meal + 3: third meal of the day)",
    "isCharacter": false,
    "composition": [
      14647,
      "/",
      14377,
      "/",
      8499
    ]
  },
  {
    "id": "17469",
    "description": "support-(to)",
    "pos": "RED",
    "explanation": "(to help + with (the help of) + money + action indicator: to provide financial support)",
    "isCharacter": false,
    "composition": [
      14704,
      ";",
      8993,
      "/",
      18267,
      "/",
      15484
    ]
  },
  {
    "id": "17470",
    "description": "surprise-(to)_(OLD)",
    "pos": "RED",
    "explanation": "(feeling + two intensity symbols + action indicator: to produce an intense emotional reaction)  SUPERSEDED SYNONYM  See surprise-(to) 23961",
    "isCharacter": false,
    "composition": [
      14164,
      ";",
      8993,
      "/",
      14947,
      "/",
      14947
    ]
  },
  {
    "id": "17471",
    "description": "swallow-(to)",
    "pos": "RED",
    "explanation": "(down + drink,beverage + action indicator: combination of food and liquid going down)",
    "isCharacter": false,
    "composition": [
      13869,
      ";",
      8993,
      "/",
      13881
    ]
  },
  {
    "id": "17472",
    "description": "swamp,bog,marsh",
    "pos": "YELLOW",
    "explanation": "(water_(ground_level) + earth [half-sized]: more water than earth)  - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "17473",
    "description": "swan",
    "pos": "YELLOW",
    "explanation": "(water_creature + pictograph of swan neck and head: symbol also incorporates water)  - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "17474",
    "description": "sweat,perspire-(to)",
    "pos": "RED",
    "explanation": "(sweat,perspiration + action indicator)",
    "isCharacter": false,
    "composition": [
      18209,
      ";",
      8993,
      "/",
      16420,
      "/",
      12870
    ]
  },
  {
    "id": "17475",
    "description": "sweat,perspiration",
    "pos": "YELLOW",
    "explanation": "(liquid + skin)",
    "isCharacter": false,
    "composition": [
      18209,
      "/",
      16420,
      "/",
      12870
    ]
  },
  {
    "id": "17477",
    "description": "sweet_(metaphor)",
    "pos": "GREEN",
    "explanation": "(metaphor + sweet + description indicator: \"sweet\" as in \"a sweet child\")",
    "isCharacter": false,
    "composition": [
      15460,
      "/",
      17506,
      ";",
      8998,
      "/",
      17983
    ]
  },
  {
    "id": "17478",
    "description": "sweet_(taste)",
    "pos": "GREEN",
    "explanation": "(sweetness,sweet + description indicator: pleasant taste)",
    "isCharacter": false,
    "composition": [
      17506,
      ";",
      8998,
      "/",
      17983
    ]
  },
  {
    "id": "17479",
    "description": "sweet,confection",
    "pos": "YELLOW",
    "explanation": "(food + sweet)",
    "isCharacter": false,
    "composition": [
      14377,
      "/",
      17506,
      "/",
      17983
    ]
  },
  {
    "id": "17480",
    "description": "sweet_potato,yam",
    "pos": "YELLOW",
    "explanation": "(vegetable below ground + sweet)",
    "isCharacter": false,
    "composition": [
      18005,
      "/",
      17506,
      "/",
      17983
    ]
  },
  {
    "id": "17481",
    "description": "sweetheart,lover",
    "pos": "BLUE",
    "explanation": "(person + to love)",
    "isCharacter": false,
    "composition": [
      16161,
      "/",
      15399
    ]
  },
  {
    "id": "17482",
    "description": "swim-(to)",
    "pos": "RED",
    "explanation": "(swimming,swim + action indicator: to move through water)",
    "isCharacter": false,
    "composition": [
      17724,
      ";",
      8993,
      "/",
      18209
    ]
  },
  {
    "id": "17483",
    "description": "swimming_pool",
    "pos": "YELLOW",
    "explanation": "(pool + swimming)",
    "isCharacter": false,
    "composition": [
      16219,
      "/",
      17724,
      "/",
      18209
    ]
  },
  {
    "id": "17484",
    "description": "swimsuit,swimwear,bathing_suit",
    "pos": "YELLOW",
    "explanation": "(clothing + comma + to swim)",
    "isCharacter": false,
    "composition": [
      13366,
      "/",
      17724,
      "/",
      18209
    ]
  },
  {
    "id": "17485",
    "description": "swing",
    "pos": "YELLOW",
    "explanation": "(swing,swinging + thing indicator: thing to swing upon)  - (character with thing indicator)",
    "isCharacter": "false",
    "composition": [
      25406,
      ";",
      9009
    ]
  },
  {
    "id": "17486",
    "description": "swing,sway,rock-(to)",
    "pos": "RED",
    "explanation": "(swing,swinging + action indicator)",
    "isCharacter": false,
    "composition": [
      25406,
      ";",
      8993
    ]
  },
  {
    "id": "17487",
    "description": "handle,switch",
    "pos": "YELLOW",
    "explanation": "(thing + hand: thing operated by the hand)",
    "isCharacter": false,
    "composition": [
      17717,
      "/",
      14667
    ]
  },
  {
    "id": "17488",
    "description": "switch-(to)",
    "pos": "RED",
    "explanation": "(handle + action indicator)",
    "isCharacter": false,
    "composition": [
      17717,
      ";",
      8993,
      "/",
      14667
    ]
  },
  {
    "id": "17489",
    "description": "symbol_display,symbol_board,symbol_chart",
    "pos": "YELLOW",
    "explanation": "(paper + plus + Blissymbol)",
    "isCharacter": false,
    "composition": [
      15962,
      "/",
      12374,
      "/",
      12857
    ]
  },
  {
    "id": "17490",
    "description": "synagogue",
    "pos": "YELLOW",
    "explanation": "(house + commandments: building for Jewish religious services and instruction)",
    "isCharacter": false,
    "composition": [
      14905,
      "/",
      13388
    ]
  },
  {
    "id": "17491",
    "description": "syringe",
    "pos": "YELLOW",
    "explanation": "(injection + thing indicator)  - (character with thing indicator)",
    "isCharacter": "false",
    "composition": [
      14941,
      ";",
      9009
    ]
  },
  {
    "id": "17492",
    "description": "table_game",
    "pos": "YELLOW",
    "explanation": "(to play + table: enjoyable activity that uses a table)",
    "isCharacter": false,
    "composition": [
      12335,
      "/",
      "RK:-2",
      "/",
      14164,
      "/",
      17983,
      "/",
      17493
    ]
  },
  {
    "id": "17493",
    "description": "table",
    "pos": "YELLOW",
    "explanation": "(pictograph: symbol suggests the side view of a table)  - Character",
    "isCharacter": true
  },
  {
    "id": "17494",
    "description": "tablecloth",
    "pos": "YELLOW",
    "explanation": "(cloth + table)",
    "isCharacter": false,
    "composition": [
      13365,
      "/",
      17493
    ]
  },
  {
    "id": "17495",
    "description": "tahini,sesame_seed_spread",
    "pos": "YELLOW",
    "explanation": "(spread + seed + white: Middle Eastern food, used rather like peanut butter)",
    "isCharacter": false,
    "composition": [
      17238,
      "/",
      16749,
      "/",
      13377,
      "/",
      17192
    ]
  },
  {
    "id": "17496",
    "description": "tail",
    "pos": "YELLOW",
    "explanation": "(canine + pointer, to tail)  - Character (superimposed - pointer)",
    "isCharacter": true
  },
  {
    "id": "17497",
    "description": "take,bring,carry,move-(to)",
    "pos": "RED",
    "explanation": "(portability + action indicator)",
    "isCharacter": false,
    "composition": [
      24714,
      ";",
      8993
    ]
  },
  {
    "id": "17498",
    "description": "take_away,remove-(to)",
    "pos": "RED",
    "explanation": "(hand + to take away + action indicator)",
    "isCharacter": false,
    "composition": [
      14667,
      ";",
      8993,
      "/",
      17449
    ]
  },
  {
    "id": "17499",
    "description": "takeoff,take-off,airplane_take-off",
    "pos": "YELLOW",
    "explanation": "(airplane + upward and forward)",
    "isCharacter": false,
    "composition": [
      12357,
      "/",
      "RK:-2",
      "/",
      17987
    ]
  },
  {
    "id": "17500",
    "description": "talcum_powder",
    "pos": "YELLOW",
    "explanation": "(powder + body)",
    "isCharacter": false,
    "composition": [
      16233,
      "/",
      12870
    ]
  },
  {
    "id": "17501",
    "description": "tallith",
    "pos": "YELLOW",
    "explanation": "(clothing + comma + to pray + Jewish)",
    "isCharacter": false,
    "composition": [
      13366,
      "/",
      8487,
      "/",
      15666,
      "/",
      17739,
      "/",
      14451,
      "/",
      17251
    ]
  },
  {
    "id": "17502",
    "description": "Tammuz",
    "pos": "YELLOW",
    "explanation": "(month + summer: month that is the heart of summer)",
    "isCharacter": false,
    "composition": [
      15649,
      "/",
      17462,
      "/",
      8498,
      "/",
      13100,
      "/",
      14183,
      "/",
      12324
    ]
  },
  {
    "id": "17503",
    "description": "tangerine,clementine,mandarin",
    "pos": "YELLOW",
    "explanation": "(citrus fruit + little)",
    "isCharacter": false,
    "composition": [
      15933,
      "/",
      24917
    ]
  },
  {
    "id": "17504",
    "description": "tank",
    "pos": "YELLOW",
    "explanation": "(bus,coach [modification, prolonged] + cannon [modification, higher position])  - Character (superimposed - modified)",
    "isCharacter": true
  },
  {
    "id": "17505",
    "description": "sound_recorder,tape_recorder",
    "pos": "YELLOW",
    "explanation": "(machine + to reproduce + ear: machine to reproduce material for listening)",
    "isCharacter": false,
    "composition": [
      15406,
      "/",
      24934,
      "/",
      13894
    ]
  },
  {
    "id": "17506",
    "description": "taste",
    "pos": "YELLOW",
    "explanation": "(nose + mouth: the nose and mouth are both used in tasting)  - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "17507",
    "description": "taste-(to)",
    "pos": "RED",
    "explanation": "(taste + action indicator)",
    "isCharacter": false,
    "composition": [
      17506,
      ";",
      8993
    ]
  },
  {
    "id": "17509",
    "description": "taxi,cab",
    "pos": "YELLOW",
    "explanation": "(car + limited time: car hired for a short time)",
    "isCharacter": false,
    "composition": [
      13121,
      "/",
      15212
    ]
  },
  {
    "id": "17510",
    "description": "taxi_driver,cab_driver",
    "pos": "BLUE",
    "explanation": "(person + taxi)",
    "isCharacter": false,
    "composition": [
      16161,
      "/",
      13121,
      "/",
      15212
    ]
  },
  {
    "id": "17511",
    "description": "tea",
    "pos": "YELLOW",
    "explanation": "(drink + leaf: drink made from tea leaves)",
    "isCharacter": false,
    "composition": [
      13881,
      "/",
      15183
    ]
  },
  {
    "id": "17512",
    "description": "teach,instruct-(to)",
    "pos": "RED",
    "explanation": "(to give + knowledge + action indicator)",
    "isCharacter": false,
    "composition": [
      24903,
      ";",
      8993,
      "/",
      15162
    ]
  },
  {
    "id": "17513",
    "description": "teacher,instructor",
    "pos": "BLUE",
    "explanation": "(person + to teach)",
    "isCharacter": false,
    "composition": [
      16161,
      "/",
      24903,
      "/",
      15162
    ]
  },
  {
    "id": "17514",
    "description": "team",
    "pos": "BLUE",
    "explanation": "(group + to work + together: group that works together)",
    "isCharacter": false,
    "composition": [
      14647,
      "/",
      16161,
      "/",
      18273,
      "/",
      23409
    ]
  },
  {
    "id": "17515",
    "description": "tease-(to)",
    "pos": "RED",
    "explanation": "(to act + upset + action indicator: to act in a way that upsets someone)",
    "isCharacter": false,
    "composition": [
      12335,
      ";",
      8993,
      "/",
      "RK:-2",
      "/",
      14164,
      "/",
      20524
    ]
  },
  {
    "id": "17516",
    "description": "teenager,adolescent,youth",
    "pos": "BLUE",
    "explanation": "(child + adult (combination): person between childhood and adulthood)  - Character (superimposed - combined)",
    "isCharacter": true
  },
  {
    "id": "17517",
    "description": "teeth",
    "pos": "YELLOW",
    "explanation": "(pictograph: symbol suggests two teeth)  - Character",
    "isCharacter": true
  },
  {
    "id": "17518",
    "description": "telephone,call",
    "pos": "YELLOW",
    "explanation": "(language + electricity: electrical device for speaking and listening)",
    "isCharacter": false,
    "composition": [
      15172,
      "/",
      13918
    ]
  },
  {
    "id": "17519",
    "description": "television",
    "pos": "YELLOW",
    "explanation": "(enclosure + eye + ear + electricity: box for seeing and hearing by a means of electricity)",
    "isCharacter": false,
    "composition": [
      13934,
      "/",
      14133,
      "/",
      13894,
      "/",
      13918
    ]
  },
  {
    "id": "17520",
    "description": "temperature",
    "pos": "YELLOW",
    "explanation": "(scale,measurement + point [low position under earthline]: symbol suggests a thermometer and incorporates measurement in a vertical position)  - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "17521",
    "description": "ten_o'clock_eating_break",
    "pos": "YELLOW",
    "explanation": "(food + time + 10) (Israel)",
    "isCharacter": false,
    "composition": [
      14377,
      "/",
      17732,
      "/",
      8497,
      "/",
      "RK:-1",
      "/",
      8496
    ]
  },
  {
    "id": "17522",
    "description": "tennis_(activity)_(OLD)",
    "pos": "YELLOW",
    "explanation": "(activity + crossed_racquets: game played with racquets)   SUPERSEDED SYNONYM  See tennis_(activity) 26031 and tennis,racket_sport,racquet_sport 26030",
    "isCharacter": false,
    "composition": [
      12335,
      "/",
      "RK:-2",
      "/",
      25542
    ]
  },
  {
    "id": "17523",
    "description": "tent",
    "pos": "YELLOW",
    "explanation": "(house + cloth: shelter made of cloth)",
    "isCharacter": false,
    "composition": [
      14905,
      "/",
      13365
    ]
  },
  {
    "id": "17524",
    "description": "termite,wood_destroying_insect",
    "pos": "YELLOW",
    "explanation": "(insect + tree_or_wood_destruction: insect that destroys trees or wood)",
    "isCharacter": false,
    "composition": [
      14943,
      "/",
      25626
    ]
  },
  {
    "id": "17525",
    "description": "terrified",
    "pos": "GREEN",
    "explanation": "(terror + description indicator)",
    "isCharacter": false,
    "composition": [
      14164,
      ";",
      8998,
      "/",
      13869,
      "/",
      25568,
      "/",
      14947
    ]
  },
  {
    "id": "17526",
    "description": "terrorist",
    "pos": "BLUE",
    "explanation": "(person + terrorism)",
    "isCharacter": false,
    "composition": [
      16161,
      "/",
      13134,
      "/",
      14164,
      "/",
      13869,
      "/",
      25568,
      "/",
      14947
    ]
  },
  {
    "id": "17527",
    "description": "terrorize-(to)",
    "pos": "RED",
    "explanation": "(terrorism + action indicator)",
    "isCharacter": false,
    "composition": [
      13134,
      ";",
      8993,
      "/",
      14164,
      "/",
      13869,
      "/",
      25568,
      "/",
      14947
    ]
  },
  {
    "id": "17528",
    "description": "test,assessment,exam",
    "pos": "YELLOW",
    "explanation": "(question + for (the purpose of) + evaluation)",
    "isCharacter": false,
    "composition": [
      16445,
      "/",
      14382,
      "/",
      "RK:-2",
      "/",
      13949
    ]
  },
  {
    "id": "17529",
    "description": "testicle",
    "pos": "YELLOW",
    "explanation": "(container + sperm)",
    "isCharacter": false,
    "composition": [
      13403,
      "/",
      17226
    ]
  },
  {
    "id": "17530",
    "description": "Tevet",
    "pos": "YELLOW",
    "explanation": "(month + winter: month of rain, typifying winter)",
    "isCharacter": false,
    "composition": [
      15649,
      "/",
      17462,
      "/",
      8500,
      "/",
      16455
    ]
  },
  {
    "id": "17531",
    "description": "tefillin",
    "pos": "YELLOW",
    "explanation": "(2 + box + part + Torah: two boxes with part of Torah)",
    "isCharacter": false,
    "composition": [
      8498,
      "/",
      12886,
      "/",
      15972,
      "/",
      17760
    ]
  },
  {
    "id": "17532",
    "description": "thank-(to)",
    "pos": "RED",
    "explanation": "(thanks + action indicator)",
    "isCharacter": false,
    "composition": [
      14164,
      ";",
      8993,
      "/",
      24903
    ]
  },
  {
    "id": "17533",
    "description": "thanks,thank_you",
    "pos": "GRAY",
    "explanation": "feeling + to give: polite phrase used to express gratitude to another)",
    "isCharacter": false,
    "composition": [
      14164,
      "/",
      24903
    ]
  },
  {
    "id": "17534",
    "description": "thanksgiving",
    "pos": "YELLOW",
    "explanation": "(day + thanks: day for giving thanks)",
    "isCharacter": false,
    "composition": [
      13639,
      "/",
      14164,
      "/",
      24903
    ]
  },
  {
    "id": "17697",
    "description": "that_(there)",
    "pos": "WHITE",
    "explanation": "(dot [low position] + the: the diagonal line has the same orientation as the one used in the and this)  - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "17698",
    "description": "too_bad,I'm_sorry,I'm_so_sorry",
    "pos": "GRAY",
    "explanation": "(sad + about )",
    "isCharacter": false,
    "composition": [
      14164,
      "/",
      13869,
      "/",
      12324
    ]
  },
  {
    "id": "17699",
    "description": "thaw,melt-(to)",
    "pos": "RED",
    "explanation": "(thawing,melting + action indicator: solid ice turns into water)",
    "isCharacter": false,
    "composition": [
      25621,
      ";",
      8993
    ]
  },
  {
    "id": "17700",
    "description": "the",
    "pos": "WHITE",
    "explanation": "(diagonal line suggests an index finger pointing at something specific. The diagonal line has the same orientation as the one used in this and that.)  - Character",
    "isCharacter": true
  },
  {
    "id": "17701",
    "description": "their,theirs-(persons)",
    "pos": "BLUE",
    "explanation": "(they + belongs to + plural indicator)",
    "isCharacter": false,
    "composition": [
      16161,
      ";",
      9011,
      "/",
      8499,
      "/",
      12663
    ]
  },
  {
    "id": "17702",
    "description": "their,theirs-(indefinite)",
    "pos": "WHITE",
    "explanation": "(its + plural indicator: refers to things rather than to people)",
    "isCharacter": false,
    "composition": [
      14960,
      ";",
      9011,
      "/",
      12663
    ]
  },
  {
    "id": "17703",
    "description": "their,theirs-(feminine_plural)",
    "pos": "BLUE",
    "explanation": "(female + 3 + belongs to + plural indicator: third person (f. pl.))",
    "isCharacter": false,
    "composition": [
      18269,
      ";",
      9011,
      "/",
      8499,
      "/",
      12663
    ]
  },
  {
    "id": "17704",
    "description": "their,theirs-(masculine_plural)",
    "pos": "BLUE",
    "explanation": "(male + 3 + belongs to + plural indicator: third person (m.pl.))",
    "isCharacter": false,
    "composition": [
      15416,
      ";",
      9011,
      "/",
      8499,
      "/",
      12663
    ]
  },
  {
    "id": "17705",
    "description": "then,so,later",
    "pos": "WHITE",
    "explanation": "(future [half-sized])  - Character",
    "isCharacter": true
  },
  {
    "id": "17706",
    "description": "therapist_(OLD)",
    "pos": "BLUE",
    "explanation": "(mutual aid + forward + person: person working cooperatively with another person to produce one free-standing person)  SUPERSEDED SYNONYM  See therapist 20516",
    "isCharacter": false,
    "composition": [
      21589,
      "/",
      "RK:-2",
      "/",
      14390,
      "/",
      16161
    ]
  },
  {
    "id": "17707",
    "description": "there",
    "pos": "WHITE",
    "explanation": "(two dots + by,by_means_of,of: the \"by\" arrowhead at the right hand end pointing to the left to the last one of two dots, indicating the furter away \"there\" relationship to certain points in space)  - Character (sequenced)",
    "isCharacter": true
  },
  {
    "id": "17708",
    "description": "therefore,so,so_that",
    "pos": "WHITE",
    "explanation": "(cause [half-sized])  - Character",
    "isCharacter": true
  },
  {
    "id": "17709",
    "description": "thermometer",
    "pos": "YELLOW",
    "explanation": "(temperature + thing indicator: The symbol is the concrete form of temperature)  - (character with thing indicator)",
    "isCharacter": "false",
    "composition": [
      17520,
      ";",
      9009
    ]
  },
  {
    "id": "17710",
    "description": "thermos,cooler,flask",
    "pos": "YELLOW",
    "explanation": "(container + same + temperature: container that keeps food or drink at a constant temperature for several hours)",
    "isCharacter": false,
    "composition": [
      13403,
      "/",
      16713,
      "/",
      17520
    ]
  },
  {
    "id": "17711",
    "description": "these",
    "pos": "WHITE",
    "explanation": "(this + plural indicator)",
    "isCharacter": false,
    "composition": [
      17720,
      ";",
      9011
    ]
  },
  {
    "id": "17712",
    "description": "they,them,themselves-(indefinite)",
    "pos": "WHITE",
    "explanation": "(it,itself + plural indicator: refers to things rather than to people)",
    "isCharacter": false,
    "composition": [
      14960,
      ";",
      9011
    ]
  },
  {
    "id": "17713",
    "description": "they,them,themselves-(persons)",
    "pos": "BLUE",
    "explanation": "(person + 3 + plural indicator: third person plural)",
    "isCharacter": false,
    "composition": [
      16161,
      ";",
      9011,
      "/",
      8499
    ]
  },
  {
    "id": "17714",
    "description": "they,them,themselves-(feminine_plural)",
    "pos": "BLUE",
    "explanation": "(female + 3 + plural indicator)",
    "isCharacter": false,
    "composition": [
      18269,
      ";",
      9011,
      "/",
      8499
    ]
  },
  {
    "id": "17715",
    "description": "they,them,themselves-(masculine_plural)",
    "pos": "BLUE",
    "explanation": "(male + 3 + plural indicator)",
    "isCharacter": false,
    "composition": [
      15416,
      ";",
      9011,
      "/",
      8499
    ]
  },
  {
    "id": "17716",
    "description": "thin,slim,narrow",
    "pos": "GREEN",
    "explanation": "(thinness,narrowness + description indicator: the pointers point inward toward the narrow space formed by the reference lines)",
    "isCharacter": false,
    "composition": [
      25622,
      ";",
      8998
    ]
  },
  {
    "id": "17717",
    "description": "thing,object",
    "pos": "YELLOW",
    "explanation": "(symbol suggests the two dimensional outline of a crystal)  - Character",
    "isCharacter": true
  },
  {
    "id": "17718",
    "description": "think,reason-(to)",
    "pos": "RED",
    "explanation": "(mind + action indicator)",
    "isCharacter": false,
    "composition": [
      15471,
      ";",
      8993
    ]
  },
  {
    "id": "17719",
    "description": "thirsty",
    "pos": "GREEN",
    "explanation": "(feeling + minus + drink + description indicator: having a feeling caused by the lack of drink)",
    "isCharacter": false,
    "composition": [
      14164,
      ";",
      8998,
      "/",
      15474,
      "/",
      13881
    ]
  },
  {
    "id": "17720",
    "description": "this",
    "pos": "WHITE",
    "explanation": "(the + dot [high position]: the diagonal line has the same orientation as the one used in the and that)  - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "17721",
    "description": "this_week",
    "pos": "YELLOW",
    "explanation": "(week + now)",
    "isCharacter": false,
    "composition": [
      8503,
      "/",
      13639,
      "/",
      15736
    ]
  },
  {
    "id": "17722",
    "description": "this_year",
    "pos": "YELLOW",
    "explanation": "(year + now)",
    "isCharacter": false,
    "composition": [
      18289,
      "/",
      15736
    ]
  },
  {
    "id": "17723",
    "description": "those",
    "pos": "WHITE",
    "explanation": "(that + plural indicator)",
    "isCharacter": false,
    "composition": [
      17697,
      ";",
      9011
    ]
  },
  {
    "id": "17724",
    "description": "through",
    "pos": "WHITE",
    "explanation": "(forward + reference line: arrow is passing through the reference line)  - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "17725",
    "description": "throw-(to)",
    "pos": "RED",
    "explanation": "(hand + to give + intensity + action indicator: to discharge into the air with a swift motion of the arm)",
    "isCharacter": false,
    "composition": [
      14667,
      ";",
      8993,
      "/",
      24903,
      "/",
      14947
    ]
  },
  {
    "id": "17726",
    "description": "thumb",
    "pos": "YELLOW",
    "explanation": "(hand + pointer, to thumb)  - Character (superimposed - pointer)",
    "isCharacter": true
  },
  {
    "id": "17727",
    "description": "thunder",
    "pos": "YELLOW",
    "explanation": "(ear + lightning: sound that accompanies lightning)",
    "isCharacter": false,
    "composition": [
      13894,
      "/",
      15209
    ]
  },
  {
    "id": "17728",
    "description": "Thursday_(OLD)",
    "pos": "YELLOW",
    "explanation": "(day + 5: fifth day of the week - based on the convention of Sunday being the first)  SUPERSEDED SYNONYM  See Thursday_(day4) 25193, Thursday_(day5) 25194, Thursday_(day6) 25195",
    "isCharacter": false,
    "composition": [
      13639,
      "/",
      8501
    ]
  },
  {
    "id": "17729",
    "description": "ticket,pass",
    "pos": "YELLOW",
    "explanation": "(paper + to enter: piece of paper that allows you to enter)",
    "isCharacter": false,
    "composition": [
      15962,
      "/",
      14952
    ]
  },
  {
    "id": "17730",
    "description": "tie,necktie",
    "pos": "YELLOW",
    "explanation": "(linear thing + neck + thing indicator)",
    "isCharacter": false,
    "composition": [
      15214,
      ";",
      9009,
      "/",
      15699
    ]
  },
  {
    "id": "17731",
    "description": "tiger",
    "pos": "YELLOW",
    "explanation": "(feline + stripe)",
    "isCharacter": false,
    "composition": [
      12383,
      "/",
      15214
    ]
  },
  {
    "id": "17732",
    "description": "time",
    "pos": "YELLOW",
    "explanation": "(symbol looks like a clock face, suggesting time)  - Character",
    "isCharacter": true
  },
  {
    "id": "17733",
    "description": "tiptoe-(to)",
    "pos": "RED",
    "explanation": "(toe + action indicator: to walk on one's toes)",
    "isCharacter": false,
    "composition": [
      17745,
      ";",
      8993
    ]
  },
  {
    "id": "17734",
    "description": "tire,tyre",
    "pos": "YELLOW",
    "explanation": "(wheel + pointer, to tire)  - Character (superimposed - pointer)",
    "isCharacter": true
  },
  {
    "id": "17735",
    "description": "tired,exhausted,weary_(OLD)",
    "pos": "GREEN",
    "explanation": "(rest + to need + description after the fact indicator: feeling in need of rest)",
    "isCharacter": false,
    "composition": [
      16495,
      ";",
      8996,
      "/",
      15701
    ]
  },
  {
    "id": "17736",
    "description": "Tisha_B'Av",
    "pos": "YELLOW",
    "explanation": "(day + temple_ruin: day of temple destruction)",
    "isCharacter": false,
    "composition": [
      13639,
      "/",
      25605,
      "/",
      14451
    ]
  },
  {
    "id": "17737",
    "description": "Tishri",
    "pos": "YELLOW",
    "explanation": "(month + shofar: month of Rosh Hashana)",
    "isCharacter": false,
    "composition": [
      15649,
      "/",
      14895,
      "/",
      17251
    ]
  },
  {
    "id": "17738",
    "description": "tissue",
    "pos": "YELLOW",
    "explanation": "(paper + nose)",
    "isCharacter": false,
    "composition": [
      15962,
      "/",
      15732
    ]
  },
  {
    "id": "17739",
    "description": "to,toward,towards",
    "pos": "WHITE",
    "explanation": "(arrowhead + reference line [half-sized]: the arrowhead approaches the reference line. This symbol is a simplified form of  approach.)  - Character (sequenced)",
    "isCharacter": true
  },
  {
    "id": "17740",
    "description": "toast",
    "pos": "YELLOW",
    "explanation": "(bread_surface + fire: bread browned on both sides)",
    "isCharacter": false,
    "composition": [
      25530,
      "/",
      14183
    ]
  },
  {
    "id": "17741",
    "description": "toast-(to)",
    "pos": "RED",
    "explanation": "(fire + bread_surface + action indicator)",
    "isCharacter": false,
    "composition": [
      14183,
      ";",
      8993,
      "/",
      25530
    ]
  },
  {
    "id": "17742",
    "description": "toaster",
    "pos": "YELLOW",
    "explanation": "(machine + to toast)",
    "isCharacter": false,
    "composition": [
      15406,
      "/",
      14183,
      "/",
      25530
    ]
  },
  {
    "id": "17743",
    "description": "tobacco",
    "pos": "YELLOW",
    "explanation": "(leaf + to smoke: leaf used for smoking)",
    "isCharacter": false,
    "composition": [
      15183,
      "/",
      25611
    ]
  },
  {
    "id": "17744",
    "description": "today",
    "pos": "YELLOW",
    "explanation": "(day + now)",
    "isCharacter": false,
    "composition": [
      13639,
      "/",
      15736
    ]
  },
  {
    "id": "17745",
    "description": "toe",
    "pos": "YELLOW",
    "explanation": "(legs and feet + pointer, to toe)  - Character (superimposed - pointer)",
    "isCharacter": true
  },
  {
    "id": "17746",
    "description": "together,attached,appended,fastened,joined",
    "pos": "GREEN",
    "explanation": "(attachment,appendix,annex + description indicator)",
    "isCharacter": false,
    "composition": [
      23409,
      ";",
      8998
    ]
  },
  {
    "id": "17747",
    "description": "toilet",
    "pos": "YELLOW",
    "explanation": "(seat + water_(ground_level): water closet)  - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "17748",
    "description": "toilet_paper",
    "pos": "YELLOW",
    "explanation": "(paper + toilet)",
    "isCharacter": false,
    "composition": [
      15962,
      "/",
      17747
    ]
  },
  {
    "id": "17749",
    "description": "tomato",
    "pos": "YELLOW",
    "explanation": "(vegetable above ground + red)",
    "isCharacter": false,
    "composition": [
      18004,
      "/",
      13377,
      "/",
      15666
    ]
  },
  {
    "id": "17750",
    "description": "tomorrow",
    "pos": "YELLOW",
    "explanation": "(day + then (future))",
    "isCharacter": false,
    "composition": [
      13639,
      "/",
      17705
    ]
  },
  {
    "id": "17751",
    "description": "tomorrow_night",
    "pos": "YELLOW",
    "explanation": "(night + then (future))",
    "isCharacter": false,
    "composition": [
      15719,
      "/",
      17705
    ]
  },
  {
    "id": "17752",
    "description": "tongue",
    "pos": "YELLOW",
    "explanation": "(part of + mouth + up and down: the part of the mouth that moves up and down)",
    "isCharacter": false,
    "composition": [
      15972,
      "/",
      15666,
      "/",
      20524
    ]
  },
  {
    "id": "17753",
    "description": "tonight",
    "pos": "YELLOW",
    "explanation": "(night + now)",
    "isCharacter": false,
    "composition": [
      15719,
      "/",
      15736
    ]
  },
  {
    "id": "17754",
    "description": "too_much,too_many",
    "pos": "GREEN",
    "explanation": "(over + much/many + description indicator: over the amount or number needed)",
    "isCharacter": false,
    "composition": [
      15948,
      "/",
      14647,
      ";",
      8998
    ]
  },
  {
    "id": "17755",
    "description": "tool,instrument",
    "pos": "YELLOW",
    "explanation": "(thing + hand: thing used by the hand to extend its capabilities)  - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "17756",
    "description": "toothbrush",
    "pos": "YELLOW",
    "explanation": "(brush + teeth)",
    "isCharacter": false,
    "composition": [
      12912,
      "/",
      17517
    ]
  },
  {
    "id": "17757",
    "description": "toothpaste",
    "pos": "YELLOW",
    "explanation": "(chemical product + brush + teeth: chemical product for brushing teeth)",
    "isCharacter": false,
    "composition": [
      13158,
      "/",
      12912,
      "/",
      17517
    ]
  },
  {
    "id": "17758",
    "description": "top",
    "pos": "YELLOW",
    "explanation": "(enclosure + pointer, to top)  - Character (superimposed - pointer)",
    "isCharacter": true
  },
  {
    "id": "17759",
    "description": "dreidel_top",
    "pos": "YELLOW",
    "explanation": "(pictograph)  - Character",
    "isCharacter": true
  },
  {
    "id": "17760",
    "description": "Torah",
    "pos": "YELLOW",
    "explanation": "(pictograph of a scroll on two posts: the Torah contains the Old Testament)  - Character",
    "isCharacter": true
  },
  {
    "id": "17761",
    "description": "touch,feel-(to)",
    "pos": "RED",
    "explanation": "(hand + action indicator)",
    "isCharacter": false,
    "composition": [
      14667,
      ";",
      8993
    ]
  },
  {
    "id": "17762",
    "description": "towel_(OLD)",
    "pos": "YELLOW",
    "explanation": "(cloth + dry_(OLD))    SUPERSEDED SYNONYM  See towel 24312",
    "isCharacter": false,
    "composition": [
      13365,
      "/",
      15927,
      "/",
      18209
    ]
  },
  {
    "id": "17763",
    "description": "toy",
    "pos": "YELLOW",
    "explanation": "(thing + play: a plaything)",
    "isCharacter": false,
    "composition": [
      17717,
      "/",
      12335,
      "/",
      "RK:-2",
      "/",
      14164,
      "/",
      17983
    ]
  },
  {
    "id": "17764",
    "description": "toy_animal,stuffed_animal",
    "pos": "YELLOW",
    "explanation": "(animal + man-made)",
    "isCharacter": false,
    "composition": [
      12378,
      "/",
      23583
    ]
  },
  {
    "id": "17765",
    "description": "tractor",
    "pos": "YELLOW",
    "explanation": "(car [modification, full sized back wheel]: pictograph of a tractor)  - Character (modified)",
    "isCharacter": true
  },
  {
    "id": "17766",
    "description": "traffic",
    "pos": "YELLOW",
    "explanation": "(many + car)",
    "isCharacter": false,
    "composition": [
      14647,
      "/",
      13121
    ]
  },
  {
    "id": "17767",
    "description": "train",
    "pos": "YELLOW",
    "explanation": "(many + railway car: many connected railway cars)",
    "isCharacter": false,
    "composition": [
      14647,
      "/",
      18010
    ]
  },
  {
    "id": "17768",
    "description": "trampoline",
    "pos": "YELLOW",
    "explanation": "(platform + to jump)",
    "isCharacter": false,
    "composition": [
      17493,
      "/",
      23550
    ]
  },
  {
    "id": "17769",
    "description": "translate-(to)",
    "pos": "RED",
    "explanation": "(bridge + language + action indicator: to form a bridge of understanding between languages)",
    "isCharacter": false,
    "composition": [
      12902,
      ";",
      8993,
      "/",
      15172
    ]
  },
  {
    "id": "17770",
    "description": "transvestite_(female)",
    "pos": "BLUE",
    "explanation": "(woman + to dress + man: woman who dresses like a man)",
    "isCharacter": false,
    "composition": [
      18269,
      "/",
      13366,
      "/",
      15416
    ]
  },
  {
    "id": "17771",
    "description": "transvestite_(male)",
    "pos": "BLUE",
    "explanation": "(man + to dress + woman: man who dresses like a woman)",
    "isCharacter": false,
    "composition": [
      15416,
      "/",
      13366,
      "/",
      18269
    ]
  },
  {
    "id": "17772",
    "description": "travel-(to)",
    "pos": "RED",
    "explanation": "(trip + action indicator)",
    "isCharacter": false,
    "composition": [
      17779,
      ";",
      8993
    ]
  },
  {
    "id": "17773",
    "description": "tray",
    "pos": "YELLOW",
    "explanation": "(pictograph)  - Character",
    "isCharacter": true
  },
  {
    "id": "17774",
    "description": "treat",
    "pos": "YELLOW",
    "explanation": "(thing + special: a thing or occurrence that causes special pleasure or delight)",
    "isCharacter": false,
    "composition": [
      17717,
      "/",
      14164,
      "/",
      24913
    ]
  },
  {
    "id": "17775",
    "description": "tree",
    "pos": "YELLOW",
    "explanation": "(pictograph, of tree with trunk and branches)  - Character",
    "isCharacter": true
  },
  {
    "id": "17776",
    "description": "triangle",
    "pos": "YELLOW",
    "explanation": "(shape + triangular shape: triangle, a geometric shape)",
    "isCharacter": false,
    "composition": [
      14133,
      "/",
      17717,
      "/",
      13607
    ]
  },
  {
    "id": "17777",
    "description": "triangular",
    "pos": "GREEN",
    "explanation": "(triangle + description indicator)",
    "isCharacter": false,
    "composition": [
      14133,
      ";",
      8998,
      "/",
      17717,
      "/",
      13607
    ]
  },
  {
    "id": "17778",
    "description": "tricycle",
    "pos": "YELLOW",
    "explanation": "(3 + wheel: three-wheeled cycle)",
    "isCharacter": false,
    "composition": [
      8499,
      "/",
      18232
    ]
  },
  {
    "id": "17779",
    "description": "trip,journey,travel,voyage",
    "pos": "YELLOW",
    "explanation": "(wheel + earth: movement along the earth)  - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "17780",
    "description": "trouble",
    "pos": "YELLOW",
    "explanation": "(feeling + opposing_forces,counter-forces: feeling of being beset by opposing forces) See also worry 18280.",
    "isCharacter": false,
    "composition": [
      14164,
      "/",
      25589
    ]
  },
  {
    "id": "17781",
    "description": "truck,lorry",
    "pos": "YELLOW",
    "explanation": "(transport,transportation + car: large motor vehicle for carrying things)  - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "17782",
    "description": "true,truly,truthful,truthfully",
    "pos": "GREEN",
    "explanation": "(truth + description indicator)",
    "isCharacter": false,
    "composition": [
      17786,
      ";",
      8998
    ]
  },
  {
    "id": "17783",
    "description": "trunk,tree_trunk,bole",
    "pos": "YELLOW",
    "explanation": "(tree + pointer, to trunk)  - Character (superimposed - pointer)",
    "isCharacter": true
  },
  {
    "id": "17784",
    "description": "trust-(to)",
    "pos": "RED",
    "explanation": "(trust + action indicator)",
    "isCharacter": false,
    "composition": [
      14164,
      ";",
      8993,
      "/",
      15927,
      "/",
      22911
    ]
  },
  {
    "id": "17785",
    "description": "trust,confidence",
    "pos": "YELLOW",
    "explanation": "(feeling + certain)",
    "isCharacter": false,
    "composition": [
      14164,
      "/",
      15927,
      "/",
      22911
    ]
  },
  {
    "id": "17786",
    "description": "truth",
    "pos": "YELLOW",
    "explanation": "(mind + hypothesis,theory: the mind believes itself to understand the nature of things, but it may be in error)  - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "17787",
    "description": "try,attempt-(to)",
    "pos": "RED",
    "explanation": "(attempt,effort,try + action indicator: to move forward with difficulty)",
    "isCharacter": false,
    "composition": [
      26126,
      ";",
      8993
    ]
  },
  {
    "id": "17788",
    "description": "Tu_Bishvat",
    "pos": "YELLOW",
    "explanation": "(day + birth + tree + plural indicator)",
    "isCharacter": false,
    "composition": [
      13639,
      "/",
      12843,
      "/",
      17775,
      ";",
      9011
    ]
  },
  {
    "id": "17789",
    "description": "tubal_ligation",
    "pos": "YELLOW",
    "explanation": "(operation + fallopian tube)",
    "isCharacter": false,
    "composition": [
      15159,
      "/",
      24920,
      "/",
      23926,
      "/",
      13912
    ]
  },
  {
    "id": "17790",
    "description": "Tuesday_(OLD)",
    "pos": "YELLOW",
    "explanation": "(day + 3: third day of the week - based on the convention of Sunday being the first)  SUPERSEDED SYNONYM  See Tuesday_(day2) 25203, Tuesday_(day3) 25204, Tuesday_(day4) 25205",
    "isCharacter": false,
    "composition": [
      13639,
      "/",
      8499
    ]
  },
  {
    "id": "17953",
    "description": "tune,melody",
    "pos": "YELLOW",
    "explanation": "(plan + musical note: planned sequence of notes)",
    "isCharacter": false,
    "composition": [
      16194,
      "/",
      15682
    ]
  },
  {
    "id": "17954",
    "description": "turkey_(bird)",
    "pos": "YELLOW",
    "explanation": "(bird + food + big: large bird used for food)",
    "isCharacter": false,
    "composition": [
      12837,
      "/",
      14377,
      "/",
      24875
    ]
  },
  {
    "id": "17955",
    "description": "turkey_(food)",
    "pos": "YELLOW",
    "explanation": "(food + bird + big: turkey as a dish)",
    "isCharacter": false,
    "composition": [
      14377,
      "/",
      12837,
      "/",
      24875
    ]
  },
  {
    "id": "17956",
    "description": "turn,play",
    "pos": "YELLOW",
    "explanation": "(time + activity: person's time to do something)",
    "isCharacter": false,
    "composition": [
      17732,
      "/",
      12335
    ]
  },
  {
    "id": "17957",
    "description": "turn-(to)",
    "pos": "RED",
    "explanation": "(turn,turning + action indicator) See turn,turning 25627",
    "isCharacter": false,
    "composition": [
      25627,
      ";",
      8993
    ]
  },
  {
    "id": "17958",
    "description": "turnip,rutabaga,vegetable_(large-leafed)",
    "pos": "YELLOW",
    "explanation": "(vegetable below ground [modification] + leaf (combination): large-leafed vegetable with an edible root)  - Character (superimposed - modified -combined)",
    "isCharacter": true
  },
  {
    "id": "17959",
    "description": "turtle,tortoise",
    "pos": "YELLOW",
    "explanation": "(animal + pictograph of head and protective shell)  - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "17960",
    "description": "twinkle,shine,sparkle-(to)",
    "pos": "RED",
    "explanation": "(star + action indicator)",
    "isCharacter": false,
    "composition": [
      17252,
      ";",
      8993
    ]
  },
  {
    "id": "17961",
    "description": "type,kind,sort,category",
    "pos": "YELLOW",
    "explanation": "(mind + division [half-sized]: the mind’s division of things into categories)  - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "17962",
    "description": "printer,typewriter",
    "pos": "YELLOW",
    "explanation": "(machine + to write)",
    "isCharacter": false,
    "composition": [
      15406,
      "/",
      15991
    ]
  },
  {
    "id": "17963",
    "description": "ugh,yuk-(exclamatory)",
    "pos": "GRAY",
    "explanation": "(to speak + bad + description indicator: expressing a bad or negative feeling about something.The symbol does not have a specific word equivalent: it can represent ugh!, yuk! or similar negative expressions.)",
    "isCharacter": false,
    "composition": [
      24961,
      ";",
      8998,
      "/",
      15474,
      "/",
      14947
    ]
  },
  {
    "id": "17964",
    "description": "ugly,unattractive",
    "pos": "GREEN",
    "explanation": "(eye + sad + description indicator: displeasing to the eye)",
    "isCharacter": false,
    "composition": [
      14133,
      ";",
      8998,
      "/",
      14164,
      "/",
      13869
    ]
  },
  {
    "id": "17965",
    "description": "umbilical_cord",
    "pos": "YELLOW",
    "explanation": "(tube + fetus)",
    "isCharacter": false,
    "composition": [
      23926,
      "/",
      14170
    ]
  },
  {
    "id": "17966",
    "description": "umbrella",
    "pos": "YELLOW",
    "explanation": "(protection + pictograph of an umbrella handle: symbol suggests an umbrella)  - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "17967",
    "description": "uncle",
    "pos": "BLUE",
    "explanation": "(brother + parent: brother of one's father or mother)  - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "17968",
    "description": "uncomfortable",
    "pos": "GREEN",
    "explanation": "(discomfort + description indicator) See discomfort 13687",
    "isCharacter": false,
    "composition": [
      13687,
      ";",
      8998
    ]
  },
  {
    "id": "17969",
    "description": "under,below,inferior",
    "pos": "WHITE",
    "explanation": "(horizontal reference line + dot [low position]: the dot is under or below the line)  - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "17970",
    "description": "bomb_shelter",
    "pos": "YELLOW",
    "explanation": "(shelter + under)",
    "isCharacter": false,
    "composition": [
      16687,
      "/",
      16420,
      "/",
      17969
    ]
  },
  {
    "id": "17971",
    "description": "underpants,briefs,panties",
    "pos": "YELLOW",
    "explanation": "(pants + under)",
    "isCharacter": false,
    "composition": [
      13366,
      "/",
      15188,
      "/",
      17969
    ]
  },
  {
    "id": "17972",
    "description": "undershirt",
    "pos": "YELLOW",
    "explanation": "(shirt + under)",
    "isCharacter": false,
    "composition": [
      13366,
      "/",
      13161,
      "/",
      17969
    ]
  },
  {
    "id": "17973",
    "description": "understand,see-(to)",
    "pos": "RED",
    "explanation": "(understanding,comprehension + action indicator: to enter into one's store of knowledge)  See understanding,comprehension 25629",
    "isCharacter": false,
    "composition": [
      25629,
      ";",
      8993
    ]
  },
  {
    "id": "17974",
    "description": "underwear,underclothes",
    "pos": "YELLOW",
    "explanation": "(clothing + under: clothing worn under other clothing)",
    "isCharacter": false,
    "composition": [
      13366,
      "/",
      17969
    ]
  },
  {
    "id": "17975",
    "description": "unemployment",
    "pos": "YELLOW",
    "explanation": "(without + work)",
    "isCharacter": false,
    "composition": [
      15474,
      "/",
      18273
    ]
  },
  {
    "id": "17976",
    "description": "unfold-(to)_(OLD)",
    "pos": "RED",
    "explanation": "(opposite meaning + to fold + action indicator)  SUPERSEDED SYNONYM  See unfold-(to) 23980",
    "isCharacter": false,
    "composition": [
      15927,
      "/",
      25564,
      ";",
      8993
    ]
  },
  {
    "id": "17977",
    "description": "unidentified_object_(suspected_explosive)",
    "pos": "YELLOW",
    "explanation": "(explosive + maybe)",
    "isCharacter": false,
    "composition": [
      14132,
      "/",
      24443,
      "/",
      18229
    ]
  },
  {
    "id": "17978",
    "description": "unit,example,sample,for_example,e.g.",
    "pos": "YELLOW",
    "explanation": "(1 + thing indicator: a single item)  - (character with thing indicator)",
    "isCharacter": "false",
    "composition": [
      8497,
      ";",
      9009
    ]
  },
  {
    "id": "17979",
    "description": "United_Kingdom",
    "pos": "YELLOW",
    "explanation": "(country + Union_Jack_pattern)",
    "isCharacter": false,
    "composition": [
      13423,
      "/",
      25631
    ]
  },
  {
    "id": "17980",
    "description": "university",
    "pos": "YELLOW",
    "explanation": "(building + to exchange + knowledge)",
    "isCharacter": false,
    "composition": [
      14905,
      "/",
      25555,
      "/",
      15162
    ]
  },
  {
    "id": "17981",
    "description": "unless,except_(conjunction)",
    "pos": "WHITE",
    "explanation": "(but + or)",
    "isCharacter": false,
    "composition": [
      13094,
      "/",
      15929
    ]
  },
  {
    "id": "17982",
    "description": "until,till,to",
    "pos": "WHITE",
    "explanation": "(arrowhead + reference line [half-sized]: the arrowhead has arrived at and touches the reference line. This symbol is a simplified form of arrival, end.)  - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "17983",
    "description": "up,upward",
    "pos": "WHITE",
    "explanation": "(arrow, pointing upward)  - Character",
    "isCharacter": true
  },
  {
    "id": "17984",
    "description": "up_and_down_(OLD)",
    "pos": "WHITE",
    "explanation": "(up + down)  SUPERSEDED SYNONYM  See up_and_down 20524",
    "isCharacter": true
  },
  {
    "id": "17985",
    "description": "upset",
    "pos": "GREEN",
    "explanation": "(upset,disturbance,agitation + description indicator: having unsettled feelings)",
    "isCharacter": false,
    "composition": [
      14164,
      ";",
      8998,
      "/",
      20524
    ]
  },
  {
    "id": "17986",
    "description": "upward_and_backward",
    "pos": "WHITE",
    "explanation": "(diagonal arrow, pointing upward and backward)  - Character",
    "isCharacter": true
  },
  {
    "id": "17987",
    "description": "upward_and_forward",
    "pos": "WHITE",
    "explanation": "(diagonal arrow, pointing upward and forward)  - Character",
    "isCharacter": true
  },
  {
    "id": "17988",
    "description": "urethra",
    "pos": "YELLOW",
    "explanation": "(tube + urine)",
    "isCharacter": false,
    "composition": [
      23926,
      "/",
      18043,
      "/",
      14431
    ]
  },
  {
    "id": "17989",
    "description": "urinate,make_water,pass_water,micturate,pee,piddle,piss,wee-(to)",
    "pos": "RED",
    "explanation": "(urine + action indicator)",
    "isCharacter": false,
    "composition": [
      18043,
      ";",
      8993,
      "/",
      14431
    ]
  },
  {
    "id": "17990",
    "description": "urine,piss,pee,piddle,weewee,water",
    "pos": "YELLOW",
    "explanation": "(waste + genitals)",
    "isCharacter": false,
    "composition": [
      18043,
      "/",
      14431
    ]
  },
  {
    "id": "17991",
    "description": "use-(to)",
    "pos": "RED",
    "explanation": "(usage,use + action indicator: to manipulate a tool rationally) See usage,use 24847",
    "isCharacter": false,
    "composition": [
      24847,
      ";",
      8993
    ]
  },
  {
    "id": "17992",
    "description": "usually,usual",
    "pos": "GREEN",
    "explanation": "(most + time + description indicator: on most occasions)",
    "isCharacter": false,
    "composition": [
      24944,
      "/",
      17732,
      ";",
      8998
    ]
  },
  {
    "id": "17993",
    "description": "utensil",
    "pos": "YELLOW",
    "explanation": "(tool + food)",
    "isCharacter": false,
    "composition": [
      17755,
      "/",
      14377
    ]
  },
  {
    "id": "17994",
    "description": "uterus,womb",
    "pos": "YELLOW",
    "explanation": "(body + female_(gender): part of a woman’s body where new life is nurtured) - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "17995",
    "description": "vacation,holiday",
    "pos": "YELLOW",
    "explanation": "(unemployment + happy: time of not working, which is happy)  See also: holiday,festival 14884",
    "isCharacter": false,
    "composition": [
      15474,
      "/",
      18273,
      "/",
      14164,
      "/",
      17983
    ]
  },
  {
    "id": "17996",
    "description": "vagina",
    "pos": "YELLOW",
    "explanation": "(uterus [modification, opening in body] + pointer, to passage)  - Character (superimposed - modified - pointer)",
    "isCharacter": true
  },
  {
    "id": "17997",
    "description": "Valentine_(card)",
    "pos": "YELLOW",
    "explanation": "(paper + love: message of love)",
    "isCharacter": false,
    "composition": [
      15962,
      "/",
      15399
    ]
  },
  {
    "id": "17998",
    "description": "Valentine's_Day",
    "pos": "YELLOW",
    "explanation": "(day + love: day to celebrate love)",
    "isCharacter": false,
    "composition": [
      13639,
      "/",
      15399
    ]
  },
  {
    "id": "17999",
    "description": "valley",
    "pos": "YELLOW",
    "explanation": "(mountains_with_valley + pointer: the low place between two mountains)  - Character (superimposed - pointer)",
    "isCharacter": true
  },
  {
    "id": "18000",
    "description": "van,minibus",
    "pos": "YELLOW",
    "explanation": "(bus + little)",
    "isCharacter": false,
    "composition": [
      13089,
      "/",
      24917
    ]
  },
  {
    "id": "18001",
    "description": "vas_deferens",
    "pos": "YELLOW",
    "explanation": "(tube + sperm)",
    "isCharacter": false,
    "composition": [
      23926,
      "/",
      17226
    ]
  },
  {
    "id": "18002",
    "description": "vasectomy",
    "pos": "YELLOW",
    "explanation": "(operation + vas deferens)",
    "isCharacter": false,
    "composition": [
      15159,
      "/",
      24920,
      "/",
      23926,
      "/",
      17226
    ]
  },
  {
    "id": "18003",
    "description": "veal",
    "pos": "YELLOW",
    "explanation": "(food + calf: food that comes from a calf) The symbol also can be explained as: combination of meat and calf.)",
    "isCharacter": false,
    "composition": [
      14377,
      "/",
      12379,
      "/",
      12603
    ]
  },
  {
    "id": "18004",
    "description": "vegetable_(above_ground)",
    "pos": "YELLOW",
    "explanation": "(earth + fruit [modification, upside down]: symbol suggests a vegetable with the edible portion above ground and the root below)  - Character (superimposed - modified)",
    "isCharacter": true
  },
  {
    "id": "18005",
    "description": "vegetable_(below_ground)",
    "pos": "YELLOW",
    "explanation": "(earth + fruit [modification, low position]: symbol looks like a vegetable with the edible portion below ground and the leafy portion above)  - Character (superimposed - modified)",
    "isCharacter": true
  },
  {
    "id": "18006",
    "description": "onion,vegetable_(bulb)",
    "pos": "YELLOW",
    "explanation": "(vegetable below ground + bulb (plant) (combination))  - Character (superimposed - combined)  See bulb_(plant) 15920",
    "isCharacter": true
  },
  {
    "id": "18007",
    "description": "vegetable_(oval-shaped)",
    "pos": "YELLOW",
    "explanation": "(vegetable above ground + oval (combination))  - Character (superimposed - combined)  See oval 23599",
    "isCharacter": true
  },
  {
    "id": "18010",
    "description": "vehicle,carriage,railway_car",
    "pos": "YELLOW",
    "explanation": "(wheel + wheel + horizontal line: pictograph, symbol suggests a vehicle such as a railroad car or a horse-drawn carriage that does not operate under its own power)  - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "18011",
    "description": "video_recorder",
    "pos": "YELLOW",
    "explanation": "(machine + to reproduce + eye + ear: machine to reproduce materials to see and to hear)",
    "isCharacter": false,
    "composition": [
      15406,
      "/",
      24934,
      "/",
      14133,
      "/",
      13894
    ]
  },
  {
    "id": "18012",
    "description": "village",
    "pos": "YELLOW",
    "explanation": "(group of + building)",
    "isCharacter": false,
    "composition": [
      14647,
      "/",
      14905
    ]
  },
  {
    "id": "18013",
    "description": "vinegar",
    "pos": "YELLOW",
    "explanation": "(combination of flavouring and sharp + thing indicator)",
    "isCharacter": false,
    "composition": [
      12339,
      ";",
      9009,
      "/",
      17506,
      "/",
      15159
    ]
  },
  {
    "id": "18014",
    "description": "purple,violet_(ckb)",
    "pos": "WHITE",
    "explanation": "(colour + 7) (CKB) SYMBOL SYNONYM",
    "isCharacter": false,
    "composition": [
      13377,
      "/",
      8503
    ]
  },
  {
    "id": "18015",
    "description": "virginity",
    "pos": "YELLOW",
    "explanation": "(without + sexual intercourse + past)",
    "isCharacter": false,
    "composition": [
      15474,
      "/",
      13380,
      "/",
      14431,
      "/",
      15975
    ]
  },
  {
    "id": "18016",
    "description": "Vishnu",
    "pos": "BLUE",
    "explanation": "(god + protection: Hindu god) (India)",
    "isCharacter": false,
    "composition": [
      14451,
      "/",
      16420
    ]
  },
  {
    "id": "18017",
    "description": "visit-(to)",
    "pos": "RED",
    "explanation": "(visit + action indicator)  See visit 24859",
    "isCharacter": false,
    "composition": [
      24859,
      ";",
      8993
    ]
  },
  {
    "id": "18018",
    "description": "visitor,guest",
    "pos": "BLUE",
    "explanation": "(person + visit: person who comes to visit)",
    "isCharacter": false,
    "composition": [
      16161,
      "/",
      24859
    ]
  },
  {
    "id": "18019",
    "description": "visually_impaired_(OLD)",
    "pos": "GREEN",
    "explanation": "(limit(s),limitation_(OLD) + to see + description indicator)    SUPERSEDED SYNONYM  See visually_impaired 26033",
    "isCharacter": false,
    "composition": [
      15213,
      ";",
      8998,
      "/",
      14133
    ]
  },
  {
    "id": "18020",
    "description": "volcano",
    "pos": "YELLOW",
    "explanation": "(mountain + fire)",
    "isCharacter": false,
    "composition": [
      15663,
      "/",
      14183
    ]
  },
  {
    "id": "18021",
    "description": "volunteer",
    "pos": "BLUE",
    "explanation": "(helper + free: person who gives assistance freely)",
    "isCharacter": false,
    "composition": [
      16161,
      "/",
      14704,
      "/",
      14396
    ]
  },
  {
    "id": "18022",
    "description": "vomit,throw_up,puke-(to)",
    "pos": "RED",
    "explanation": "(vomiting,vomit,puking + action indicator: to expel food)",
    "isCharacter": false,
    "composition": [
      15943,
      ";",
      8993,
      "/",
      14377
    ]
  },
  {
    "id": "18023",
    "description": "voyeurism",
    "pos": "YELLOW",
    "explanation": "(to watch + sex)",
    "isCharacter": false,
    "composition": [
      24949,
      "/",
      14947,
      "/",
      14428
    ]
  },
  {
    "id": "18024",
    "description": "vulture",
    "pos": "YELLOW",
    "explanation": "(bird + death: bird that feeds upon decaying flesh)",
    "isCharacter": false,
    "composition": [
      12837,
      "/",
      13645
    ]
  },
  {
    "id": "18025",
    "description": "vulva",
    "pos": "YELLOW",
    "explanation": "(protection + vagina)",
    "isCharacter": false,
    "composition": [
      16420,
      "/",
      17996
    ]
  },
  {
    "id": "18026",
    "description": "wading_pool,paddling_pool",
    "pos": "YELLOW",
    "explanation": "(pool + child: pool for a child to wade in)",
    "isCharacter": false,
    "composition": [
      16219,
      "/",
      13166
    ]
  },
  {
    "id": "18027",
    "description": "wage(s),pay,salary",
    "pos": "YELLOW",
    "explanation": "(money + for (in exchange for) + work)",
    "isCharacter": false,
    "composition": [
      15484,
      "/",
      14381,
      "/",
      18273
    ]
  },
  {
    "id": "18028",
    "description": "wagon,cart,truck",
    "pos": "YELLOW",
    "explanation": "(vehicle + diagonal line, representing a handle)  - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "18029",
    "description": "waist",
    "pos": "YELLOW",
    "explanation": "(body + pointer + pointer, to waist)  - Character (superimposed - pointer)",
    "isCharacter": true
  },
  {
    "id": "18030",
    "description": "wait-(to)",
    "pos": "RED",
    "explanation": "(wait,waiting + action indicator: to halt for a limited time)",
    "isCharacter": false,
    "composition": [
      13935,
      ";",
      8993,
      "/",
      15212
    ]
  },
  {
    "id": "18031",
    "description": "walk,go-(to)",
    "pos": "RED",
    "explanation": "(legs and feet + action indicator)",
    "isCharacter": false,
    "composition": [
      15189,
      ";",
      8993
    ]
  },
  {
    "id": "18032",
    "description": "walker,walking_aid_(2)",
    "pos": "YELLOW",
    "explanation": "(aid + medical + to walk + thing indicator: medical support that helps a person to walk) SYMBOL SYNONYM (See also 24298)",
    "isCharacter": false,
    "composition": [
      14704,
      ";",
      9009,
      "/",
      24920,
      "/",
      15189
    ]
  },
  {
    "id": "18033",
    "description": "wall",
    "pos": "YELLOW",
    "explanation": "(room + pointer, to wall)  - Character (superimposed - pointer)",
    "isCharacter": true
  },
  {
    "id": "18034",
    "description": "wand",
    "pos": "YELLOW",
    "explanation": "(vertical line + star [modification, position and shape at the top of the wand]: pictograph)  - Character (superimposed - modified)",
    "isCharacter": true
  },
  {
    "id": "18035",
    "description": "want,desire-(to)",
    "pos": "RED",
    "explanation": "(want,desire + action indicator: to have an emotional desire, a strong feeling shown by fire) See also: wish,desire 24833",
    "isCharacter": false,
    "composition": [
      14164,
      ";",
      8993,
      "/",
      14183
    ]
  },
  {
    "id": "18036",
    "description": "war",
    "pos": "YELLOW",
    "explanation": "(knife,sword + knife sword [modification, mirrored]: two crossed swords, suggesting armed conflict)  - Character (superimposed - modified)",
    "isCharacter": true
  },
  {
    "id": "18037",
    "description": "warm",
    "pos": "GREEN",
    "explanation": "(hot + little + description indicator)",
    "isCharacter": false,
    "composition": [
      14696,
      ";",
      8998,
      "/",
      24917
    ]
  },
  {
    "id": "18038",
    "description": "wash,bathe,bath-(to)",
    "pos": "RED",
    "explanation": "(bath,washing + action indicator)",
    "isCharacter": false,
    "composition": [
      16992,
      ";",
      8993
    ]
  },
  {
    "id": "18039",
    "description": "washable",
    "pos": "GREEN",
    "explanation": "(bath,washing + description before the fact indicator)",
    "isCharacter": false,
    "composition": [
      16992,
      ";",
      8997
    ]
  },
  {
    "id": "18040",
    "description": "washcloth,washrag,flannel",
    "pos": "YELLOW",
    "explanation": "(cloth + to wash)",
    "isCharacter": false,
    "composition": [
      13365,
      "/",
      16992
    ]
  },
  {
    "id": "18041",
    "description": "washer",
    "pos": "YELLOW",
    "explanation": "(machine + to wash)",
    "isCharacter": false,
    "composition": [
      15406,
      "/",
      16992
    ]
  },
  {
    "id": "18042",
    "description": "washing_machine,washer",
    "pos": "YELLOW",
    "explanation": "(machine + to wash + clothing)",
    "isCharacter": false,
    "composition": [
      15406,
      "/",
      16992,
      "/",
      13366
    ]
  },
  {
    "id": "18043",
    "description": "waste,garbage,rubbish,trash",
    "pos": "YELLOW",
    "explanation": "(thing + to destroy: something discarded or no longer of use)  - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "18044",
    "description": "watch,wristwatch",
    "pos": "YELLOW",
    "explanation": "(clock + hand + thing indicator: clock worn on the wrist or carried in a pocket)",
    "isCharacter": false,
    "composition": [
      17732,
      ";",
      9009,
      "/",
      14667
    ]
  },
  {
    "id": "18045",
    "description": "watch-(to)",
    "pos": "RED",
    "explanation": "(wakefulness,alertness + intensity + action indicator: to be wide awake and attentive)",
    "isCharacter": false,
    "composition": [
      24949,
      ";",
      8993,
      "/",
      14947
    ]
  },
  {
    "id": "18046",
    "description": "watchful,alert",
    "pos": "GREEN",
    "explanation": "(wakefulness,alertness + description indicator)",
    "isCharacter": false,
    "composition": [
      24949,
      ";",
      8998,
      "/",
      14947
    ]
  },
  {
    "id": "18209",
    "description": "water,fluid,liquid",
    "pos": "YELLOW",
    "explanation": "(symbol looks like a wave, suggesting water or liquid)  - Character",
    "isCharacter": true
  },
  {
    "id": "18210",
    "description": "we,us,ourselves-(feminine)",
    "pos": "BLUE",
    "explanation": "(female + 1 + plural indicator: first person plural, (f.))",
    "isCharacter": false,
    "composition": [
      18269,
      ";",
      9011,
      "/",
      8497
    ]
  },
  {
    "id": "18211",
    "description": "we,us,ourselves-(masculine)",
    "pos": "BLUE",
    "explanation": "(male + 1 + plural indicator: first person plural, (m.))",
    "isCharacter": false,
    "composition": [
      15416,
      ";",
      9011,
      "/",
      8497
    ]
  },
  {
    "id": "18212",
    "description": "we,us,ourselves",
    "pos": "BLUE",
    "explanation": "(person + 1 + plural indicator: first person plural)",
    "isCharacter": false,
    "composition": [
      16161,
      ";",
      9011,
      "/",
      8497
    ]
  },
  {
    "id": "18213",
    "description": "weak",
    "pos": "GREEN",
    "explanation": "(weakness_(weak_person) + description indicator: feeling experienced by a person whose knees are giving out)",
    "isCharacter": false,
    "composition": [
      16167,
      ";",
      8998
    ]
  },
  {
    "id": "18214",
    "description": "weather",
    "pos": "YELLOW",
    "explanation": "(sun + rain: these symbols represent the two major types of weather conditions)  - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "18215",
    "description": "weave-(to)",
    "pos": "RED",
    "explanation": "(to make + cloth + action indicator)",
    "isCharacter": false,
    "composition": [
      23583,
      ";",
      8993,
      "/",
      13365
    ]
  },
  {
    "id": "18216",
    "description": "Wednesday_(OLD)",
    "pos": "YELLOW",
    "explanation": "(day + 4: fourth day of the week - based on the convention of Sunday being the first)  SUPERSEDED SYNONYM  See Wednesday_(day3) 25214, Wednesday_(day4) 25215, Wednesday_(day5) 25216",
    "isCharacter": false,
    "composition": [
      13639,
      "/",
      8500
    ]
  },
  {
    "id": "18217",
    "description": "week",
    "pos": "YELLOW",
    "explanation": "(7 + day: period of seven days)",
    "isCharacter": false,
    "composition": [
      8503,
      "/",
      13639
    ]
  },
  {
    "id": "18218",
    "description": "weekend_(6-7)",
    "pos": "YELLOW",
    "explanation": "(day + 6 + plus_sign_(low) + 7: a combination of Saturday and Sunday in modern western week day numbering)  SYMBOL SYNONYM",
    "isCharacter": false,
    "composition": [
      13639,
      "/",
      8502,
      "/",
      25596,
      "/",
      8503
    ]
  },
  {
    "id": "18219",
    "description": "weekend_(7-1)",
    "pos": "YELLOW",
    "explanation": "(day + 7 + plus_sign_(low) + 1: a combination of Saturday and Sunday in traditional English or US week day numbering, and (possibly) Friday and Saturday in Israel)  SYMBOL SYNONYM",
    "isCharacter": false,
    "composition": [
      13639,
      "/",
      8503,
      "/",
      25596,
      "/",
      8497
    ]
  },
  {
    "id": "18220",
    "description": "weigh-(to)",
    "pos": "RED",
    "explanation": "(weight + action indicator)",
    "isCharacter": false,
    "composition": [
      18221,
      ";",
      8993
    ]
  },
  {
    "id": "18221",
    "description": "weight",
    "pos": "YELLOW",
    "explanation": "(pictograph: symbol suggests a scale on which weight is measured)  - Character",
    "isCharacter": true
  },
  {
    "id": "18222",
    "description": "weight_(a)",
    "pos": "YELLOW",
    "explanation": "(weight + thing indicator)  - (character with thing indicator)",
    "isCharacter": "false",
    "composition": [
      18221,
      ";",
      9009
    ]
  },
  {
    "id": "18223",
    "description": "welcome",
    "pos": "GRAY",
    "explanation": "(feeling + visitor [contraction]: feeling expressed to visitors)",
    "isCharacter": false,
    "composition": [
      14164,
      "/",
      24859
    ]
  },
  {
    "id": "18224",
    "description": "west",
    "pos": "YELLOW",
    "explanation": "(sun + pointer, to west)  - Character (superimposed - pointer)",
    "isCharacter": true
  },
  {
    "id": "18225",
    "description": "western",
    "pos": "GREEN",
    "explanation": "(west + description indicator)",
    "isCharacter": false,
    "composition": [
      18224,
      ";",
      8998
    ]
  },
  {
    "id": "18226",
    "description": "wet,damp,moist,watery",
    "pos": "GREEN",
    "explanation": "(water + description indicator)",
    "isCharacter": false,
    "composition": [
      18209,
      ";",
      8998
    ]
  },
  {
    "id": "18227",
    "description": "whale",
    "pos": "YELLOW",
    "explanation": "(water_mammal_(with_tail) + big: bigger whale, noted for its size)",
    "isCharacter": false,
    "composition": [
      13864,
      "/",
      24875
    ]
  },
  {
    "id": "18228",
    "description": "what",
    "pos": "WHITE",
    "explanation": "(who,that,which-(relative) + thing: relative pronoun)",
    "isCharacter": false,
    "composition": [
      16482,
      "/",
      17717
    ]
  },
  {
    "id": "18229",
    "description": "what,question_mark_(small)",
    "pos": "WHITE",
    "explanation": "(question mark [half-sized]: interrogative)  - Character",
    "isCharacter": true
  },
  {
    "id": "18230",
    "description": "what_kind-(question)",
    "pos": "WHITE",
    "explanation": "(what,question_mark + type)",
    "isCharacter": false,
    "composition": [
      18229,
      "/",
      17961
    ]
  },
  {
    "id": "18231",
    "description": "what_(thing)-(question)",
    "pos": "WHITE",
    "explanation": "(what,question_mark + thing: interrogative)",
    "isCharacter": false,
    "composition": [
      18229,
      "/",
      17717
    ]
  },
  {
    "id": "18232",
    "description": "wheel",
    "pos": "YELLOW",
    "explanation": "(pictograph: symbol suggests a  wheel with spokes)  - Character",
    "isCharacter": true
  },
  {
    "id": "18233",
    "description": "wheelchair",
    "pos": "YELLOW",
    "explanation": "(chair + wheel)  - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "18234",
    "description": "when",
    "pos": "WHITE",
    "explanation": "(who,that,which-(relative) + time: conjunction used to introduce a relative clause)",
    "isCharacter": false,
    "composition": [
      16482,
      "/",
      17732
    ]
  },
  {
    "id": "18235",
    "description": "when,what_time-(question)",
    "pos": "WHITE",
    "explanation": "(what,question_mark + time: interrogative)",
    "isCharacter": false,
    "composition": [
      18229,
      "/",
      17732
    ]
  },
  {
    "id": "18236",
    "description": "where",
    "pos": "WHITE",
    "explanation": "(who,that,which-(relative) + earth,ground,land: can be viewed as a combination of who,that,which-(relative) and place, conjunction used to introduce a relative clause)  - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "18237",
    "description": "where-(question)",
    "pos": "WHITE",
    "explanation": "(what,question_mark + earth,ground,land: can be viewed as a combination of what,question_mark and place: interrogative)  - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "18238",
    "description": "which,that-(relative)",
    "pos": "WHITE",
    "explanation": "(who,that,which-(relative) + part: relative pronoun)",
    "isCharacter": false,
    "composition": [
      16482,
      "/",
      15972
    ]
  },
  {
    "id": "18239",
    "description": "which-(question)",
    "pos": "WHITE",
    "explanation": "(what,question_mark + part: interrogative)",
    "isCharacter": false,
    "composition": [
      18229,
      "/",
      15972
    ]
  },
  {
    "id": "18240",
    "description": "whisper-(to)",
    "pos": "RED",
    "explanation": "(to say + quiet + action indicator)",
    "isCharacter": false,
    "composition": [
      15666,
      ";",
      8993,
      "/",
      15474,
      "/",
      17216,
      "/",
      14947
    ]
  },
  {
    "id": "18241",
    "description": "whistle-(to)",
    "pos": "RED",
    "explanation": "(to sing + teeth + action indicator: to make musical sounds through your teeth)",
    "isCharacter": false,
    "composition": [
      15666,
      ";",
      8993,
      "/",
      15682,
      "/",
      17517
    ]
  },
  {
    "id": "18242",
    "description": "white",
    "pos": "WHITE",
    "explanation": "(colour + snow) (BCI)",
    "isCharacter": false,
    "composition": [
      13377,
      "/",
      17192
    ]
  },
  {
    "id": "18244",
    "description": "who,whom-(question)",
    "pos": "WHITE",
    "explanation": "(what,question_mark + person: interrogative)",
    "isCharacter": false,
    "composition": [
      18229,
      "/",
      16161
    ]
  },
  {
    "id": "18245",
    "description": "who,whom,that-(relative)",
    "pos": "WHITE",
    "explanation": "(who,that,which-(relative) + person: relative pronoun)",
    "isCharacter": false,
    "composition": [
      16482,
      "/",
      16161
    ]
  },
  {
    "id": "18246",
    "description": "whose_(neutral)",
    "pos": "WHITE",
    "explanation": "(who,that,which-(relative) + belongs to: relative pronoun, possessive form)",
    "isCharacter": false,
    "composition": [
      16482,
      "/",
      12663
    ]
  },
  {
    "id": "18247",
    "description": "whose_(person)",
    "pos": "WHITE",
    "explanation": "(who,whom,that-(relative) + belongs to: relative pronoun, possessive form)",
    "isCharacter": false,
    "composition": [
      16482,
      "/",
      16161,
      "/",
      12663
    ]
  },
  {
    "id": "18248",
    "description": "whose-(question)",
    "pos": "WHITE",
    "explanation": "(who,whom-(question) + belongs to: interrogative)",
    "isCharacter": false,
    "composition": [
      18229,
      "/",
      16161,
      "/",
      12663
    ]
  },
  {
    "id": "18249",
    "description": "why-(question)",
    "pos": "WHITE",
    "explanation": "(what,question_mark + cause [half-sized])",
    "isCharacter": false,
    "composition": [
      18229,
      "/",
      17708
    ]
  },
  {
    "id": "18250",
    "description": "wide,broad",
    "pos": "GREEN",
    "explanation": "(wideness,broadness + description indicator: the pointers point outward to the widest space bounded by the reference lines)",
    "isCharacter": false,
    "composition": [
      25634,
      ";",
      8998
    ]
  },
  {
    "id": "18251",
    "description": "wife",
    "pos": "BLUE",
    "explanation": "(protection + woman: this symbol, joined to husband, produces family)  - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "18252",
    "description": "wiggle,squirm-(to)",
    "pos": "RED",
    "explanation": "(worm + action indicator: to wriggle like a worm)",
    "isCharacter": false,
    "composition": [
      18279,
      ";",
      8993
    ]
  },
  {
    "id": "18253",
    "description": "wiggly",
    "pos": "GREEN",
    "explanation": "(worm + description indicator: wriggling like a worm)",
    "isCharacter": false,
    "composition": [
      18279,
      ";",
      8998
    ]
  },
  {
    "id": "18254",
    "description": "win-(to)",
    "pos": "RED",
    "explanation": "(competition + gain + action indicator: to achieve a victory in a competition or contest)",
    "isCharacter": false,
    "composition": [
      16451,
      ";",
      8993,
      "/",
      12339
    ]
  },
  {
    "id": "18255",
    "description": "wind",
    "pos": "YELLOW",
    "explanation": "(air + forward: air that moves forward)  - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "18256",
    "description": "window",
    "pos": "YELLOW",
    "explanation": "(enclosure + pictograph of two traversing bars)  - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "18257",
    "description": "barred_window",
    "pos": "YELLOW",
    "explanation": "(enclosure + pictograph of bars of a lattice)  - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "18258",
    "description": "wine",
    "pos": "YELLOW",
    "explanation": "(alcoholic drink + grape,grapes)",
    "isCharacter": false,
    "composition": [
      12359,
      "/",
      14635
    ]
  },
  {
    "id": "18259",
    "description": "wing(s)",
    "pos": "YELLOW",
    "explanation": "(pictograph: symbol suggests a pair of wings in flight)  - Character",
    "isCharacter": true
  },
  {
    "id": "18260",
    "description": "wink,blink-(to)",
    "pos": "RED",
    "explanation": "(eyelid_(upper) + action indicator)",
    "isCharacter": false,
    "composition": [
      14136,
      ";",
      8993
    ]
  },
  {
    "id": "18261",
    "description": "winter_(ckb)",
    "pos": "YELLOW",
    "explanation": "(sun + 4: fourth season) (CKB)   SYMBOL SYNONYM",
    "isCharacter": false,
    "composition": [
      17462,
      "/",
      8500
    ]
  },
  {
    "id": "18262",
    "description": "winter_(snow)",
    "pos": "YELLOW",
    "explanation": "(sun + 4 + snow: fourth season when it snows) (BCI)  SYMBOL SYNONYM",
    "isCharacter": false,
    "composition": [
      17462,
      "/",
      8500,
      "/",
      17192
    ]
  },
  {
    "id": "18263",
    "description": "winter_(rain)",
    "pos": "YELLOW",
    "explanation": "(sun + 4 + rain: for use in parts of the world where it rains in winter)  SYMBOL SYNONYM",
    "isCharacter": false,
    "composition": [
      17462,
      "/",
      8500,
      "/",
      16455
    ]
  },
  {
    "id": "18264",
    "description": "wipe,dust,polish-(to)",
    "pos": "RED",
    "explanation": "(cloth + back and forth + action indicator)",
    "isCharacter": false,
    "composition": [
      13365,
      ";",
      8993,
      "/",
      12610
    ]
  },
  {
    "id": "18265",
    "description": "wire,cable_(OLD)",
    "pos": "YELLOW",
    "explanation": "(linear thing + metal + thing indicator)",
    "isCharacter": false,
    "composition": [
      15214,
      ";",
      9009,
      "/",
      23150
    ]
  },
  {
    "id": "18266",
    "description": "wish,desire-(to)",
    "pos": "RED",
    "explanation": "(wish,desire + action indicator: to have a rational desire, a strong feeling shown by fire) See also: want,desire 24834",
    "isCharacter": false,
    "composition": [
      24833,
      ";",
      8993
    ]
  },
  {
    "id": "18267",
    "description": "with",
    "pos": "WHITE",
    "explanation": "(addition [half-sized, modification with the crossbar located on the skyline])  - Character (modified)",
    "isCharacter": true
  },
  {
    "id": "18268",
    "description": "wolf,dingo,wild_dog",
    "pos": "YELLOW",
    "explanation": "(dog + open: untamed animal similar to a dog that lives in the open)",
    "isCharacter": false,
    "composition": [
      12380,
      "/",
      15923
    ]
  },
  {
    "id": "18269",
    "description": "woman,female",
    "pos": "BLUE",
    "explanation": "(person [modification] + creation [half-sized] (combination): CKB says woman embodies the creative principle in society. The symbol also looks like a stick figure of a woman wearing a skirt.)  - Character (superimposed - modified - combined)",
    "isCharacter": true
  },
  {
    "id": "18270",
    "description": "wood,lumber,timber",
    "pos": "YELLOW",
    "explanation": "(material + tree)",
    "isCharacter": false,
    "composition": [
      15431,
      "/",
      17775
    ]
  },
  {
    "id": "18271",
    "description": "wool",
    "pos": "YELLOW",
    "explanation": "(material + sheep: material obtained from the fleece of sheep)",
    "isCharacter": false,
    "composition": [
      15431,
      "/",
      12379,
      "/",
      13365
    ]
  },
  {
    "id": "18272",
    "description": "word",
    "pos": "YELLOW",
    "explanation": "(part of + language)",
    "isCharacter": false,
    "composition": [
      15972,
      "/",
      15172
    ]
  },
  {
    "id": "18273",
    "description": "work,employment,job",
    "pos": "YELLOW",
    "explanation": "(activity + activity [modification, high position]: two action symbols [half-sized], one above the other to \"heighten\" the meaning: actions done with a purpose)  - Character (superimposed - modified)",
    "isCharacter": true
  },
  {
    "id": "18274",
    "description": "work-(to)",
    "pos": "RED",
    "explanation": "(work + action indicator: to do with a purpose)",
    "isCharacter": false,
    "composition": [
      18273,
      ";",
      8993
    ]
  },
  {
    "id": "18275",
    "description": "work_of_art,art_object",
    "pos": "YELLOW",
    "explanation": "(man-made + feeling + thing indicator: man-made thing that inspires emotion in the beholder)",
    "isCharacter": false,
    "composition": [
      23583,
      ";",
      9009,
      "/",
      "RK:-2",
      "/",
      14164
    ]
  },
  {
    "id": "18276",
    "description": "workbook",
    "pos": "YELLOW",
    "explanation": "(book + to work)",
    "isCharacter": false,
    "composition": [
      12875,
      "/",
      18273
    ]
  },
  {
    "id": "18277",
    "description": "worker",
    "pos": "BLUE",
    "explanation": "(person + to work)",
    "isCharacter": false,
    "composition": [
      16161,
      "/",
      18273
    ]
  },
  {
    "id": "18278",
    "description": "world",
    "pos": "YELLOW",
    "explanation": "(sky + earth: what exists between sky and earth)  - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "18279",
    "description": "worm",
    "pos": "YELLOW",
    "explanation": "(earth [modification, extended] + snake [modification, under earthline]: snake-like creature that lives underground)  - Character (superimposed - modified)",
    "isCharacter": true
  },
  {
    "id": "18280",
    "description": "worry",
    "pos": "YELLOW",
    "explanation": "(mind + opposing_forces,counter-forces: thinking that one is beset by opposing forces)",
    "isCharacter": false,
    "composition": [
      15471,
      "/",
      25589
    ]
  },
  {
    "id": "18281",
    "description": "worry-(to)",
    "pos": "RED",
    "explanation": "(worry + action indicator)",
    "isCharacter": false,
    "composition": [
      15471,
      ";",
      8993,
      "/",
      25589
    ]
  },
  {
    "id": "18282",
    "description": "wow,super,great,neat,cool-(exclamatory)",
    "pos": "GRAY",
    "explanation": "(slang + positive + description indicator: expressing a positive feeling about something. It can represent wow!, great!, or similar positive expressions.)",
    "isCharacter": false,
    "composition": [
      24961,
      ";",
      8998,
      "/",
      12374,
      "/",
      14947
    ]
  },
  {
    "id": "18283",
    "description": "wrestling_(activity)",
    "pos": "YELLOW",
    "explanation": "(activity + 2 + person + to mix: informal activity in which two people grapple with each other)",
    "isCharacter": false,
    "composition": [
      12335,
      "/",
      8498,
      "/",
      16161,
      "/",
      22377
    ]
  },
  {
    "id": "18284",
    "description": "wrist",
    "pos": "YELLOW",
    "explanation": "(arm + pointer, to wrist)  - Character (superimposed - pointer)",
    "isCharacter": true
  },
  {
    "id": "18285",
    "description": "write-(to)",
    "pos": "RED",
    "explanation": "(pen + action indicator)",
    "isCharacter": false,
    "composition": [
      15991,
      ";",
      8993
    ]
  },
  {
    "id": "18286",
    "description": "Yahrzeit",
    "pos": "YELLOW",
    "explanation": "(anniversary + death)",
    "isCharacter": false,
    "composition": [
      18289,
      "/",
      12350,
      "/",
      13645
    ]
  },
  {
    "id": "18287",
    "description": "yard",
    "pos": "YELLOW",
    "explanation": "(building_with_yard_and_fence + pointer, to yard: area next to a building)  - Character (superimposed - pointer)",
    "isCharacter": true
  },
  {
    "id": "18288",
    "description": "yawn-(to)",
    "pos": "RED",
    "explanation": "(mouth + to sleep + action indicator: what one's mouth does when one is sleepy)",
    "isCharacter": false,
    "composition": [
      15666,
      ";",
      8993,
      "/",
      17008
    ]
  },
  {
    "id": "18289",
    "description": "year",
    "pos": "YELLOW",
    "explanation": "(sun with arrow head, indicating movement around: the earth completes one circuit around the sun in a year)  - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "18290",
    "description": "yell,scream-(to)",
    "pos": "RED",
    "explanation": "(to say + three intensity symbols + action indicator: to say very forcefully)",
    "isCharacter": false,
    "composition": [
      15666,
      ";",
      8993,
      "/",
      14947,
      "/",
      14947,
      "/",
      14947
    ]
  },
  {
    "id": "18291",
    "description": "yellow_(bci)",
    "pos": "WHITE",
    "explanation": "(colour + sun) (BCI) SYMBOL SYNONYM",
    "isCharacter": false,
    "composition": [
      13377,
      "/",
      17462
    ]
  },
  {
    "id": "18292",
    "description": "yellow_(ckb)",
    "pos": "WHITE",
    "explanation": "(colour + 3) (CKB) SYMBOL SYNONYM",
    "isCharacter": false,
    "composition": [
      13377,
      "/",
      8499
    ]
  },
  {
    "id": "18293",
    "description": "yen",
    "pos": "YELLOW",
    "explanation": "(international symbol for Japanese yen)  - Character",
    "isCharacter": true
  },
  {
    "id": "18294",
    "description": "yes-(exclamatory)",
    "pos": "GRAY",
    "explanation": "(positive + intensity: strong positive response)",
    "isCharacter": false,
    "composition": [
      12374,
      "/",
      14947,
      "/",
      14947
    ]
  },
  {
    "id": "18295",
    "description": "yesterday",
    "pos": "YELLOW",
    "explanation": "(day + then (past))",
    "isCharacter": false,
    "composition": [
      13639,
      "/",
      12352
    ]
  },
  {
    "id": "18296",
    "description": "yogurt,yoghurt",
    "pos": "YELLOW",
    "explanation": "(food + comma + milk: food made from fermented milk)",
    "isCharacter": false,
    "composition": [
      14377,
      "/",
      13881,
      "/",
      15206
    ]
  },
  {
    "id": "18297",
    "description": "Yom_Kippur",
    "pos": "YELLOW",
    "explanation": "(day + to forgive: the Day of Atonement, a holiday when one atones for sins and asks for forgiveness)",
    "isCharacter": false,
    "composition": [
      13639,
      "/",
      25593,
      "/",
      12348
    ]
  },
  {
    "id": "18298",
    "description": "you,yourselves-(feminine_plural)",
    "pos": "BLUE",
    "explanation": "(female + 2 + plural indicator: second person (f.pl.))",
    "isCharacter": false,
    "composition": [
      18269,
      ";",
      9011,
      "/",
      8498
    ]
  },
  {
    "id": "18299",
    "description": "you,yourself-(feminine_singular)",
    "pos": "BLUE",
    "explanation": "(female + 2: second person (f.sing.))",
    "isCharacter": false,
    "composition": [
      18269,
      "/",
      8498
    ]
  },
  {
    "id": "18300",
    "description": "you,yourselves-(masculine_plural)",
    "pos": "BLUE",
    "explanation": "(male + 2 + plural indicator: second person (m.pl.))",
    "isCharacter": false,
    "composition": [
      15416,
      ";",
      9011,
      "/",
      8498
    ]
  },
  {
    "id": "18301",
    "description": "you,yourself-(masculine_singular)",
    "pos": "BLUE",
    "explanation": "(male + 2: second person (m.sing.))",
    "isCharacter": false,
    "composition": [
      15416,
      "/",
      8498
    ]
  },
  {
    "id": "18302",
    "description": "you,yourselves-(plural)",
    "pos": "BLUE",
    "explanation": "(person + 2 + plural indicator: second person plural)",
    "isCharacter": false,
    "composition": [
      16161,
      ";",
      9011,
      "/",
      8498
    ]
  },
  {
    "id": "18465",
    "description": "you,yourself",
    "pos": "BLUE",
    "explanation": "(person + 2: second person singular)",
    "isCharacter": false,
    "composition": [
      16161,
      "/",
      8498
    ]
  },
  {
    "id": "18466",
    "description": "you_are_welcome,you're_welcome",
    "pos": "GRAY",
    "explanation": "(happy + to help + action indicator: polite phrase used in response to thank you)",
    "isCharacter": false,
    "composition": [
      14164,
      "/",
      17983,
      "/",
      14704
    ]
  },
  {
    "id": "18467",
    "description": "young",
    "pos": "GREEN",
    "explanation": "(child + description indicator)",
    "isCharacter": false,
    "composition": [
      13166,
      ";",
      8998
    ]
  },
  {
    "id": "18468",
    "description": "your,yours-(feminine_plural)",
    "pos": "BLUE",
    "explanation": "(female + 2 + belongs to + plural indicator: second person plural (f.), possessive)",
    "isCharacter": false,
    "composition": [
      18269,
      ";",
      9011,
      "/",
      8498,
      "/",
      12663
    ]
  },
  {
    "id": "18469",
    "description": "your,yours-(feminine_singular)",
    "pos": "BLUE",
    "explanation": "(female + 2 + belongs to: second person singular (f.), possessive)",
    "isCharacter": false,
    "composition": [
      18269,
      "/",
      8498,
      "/",
      12663
    ]
  },
  {
    "id": "18470",
    "description": "your,yours-(masculine_plural)",
    "pos": "BLUE",
    "explanation": "(male + 2 + belongs to + plural indicator: second person plural (m.), possessive)",
    "isCharacter": false,
    "composition": [
      15416,
      ";",
      9011,
      "/",
      8498,
      "/",
      12663
    ]
  },
  {
    "id": "18471",
    "description": "your,yours-(masculine_singular)",
    "pos": "BLUE",
    "explanation": "(male + 2 + belongs to: second person singular (m.), possessive)",
    "isCharacter": false,
    "composition": [
      15416,
      "/",
      8498,
      "/",
      12663
    ]
  },
  {
    "id": "18472",
    "description": "your,yours-(plural)",
    "pos": "BLUE",
    "explanation": "(you + belongs to + plural indicator)",
    "isCharacter": false,
    "composition": [
      16161,
      ";",
      9011,
      "/",
      8498,
      "/",
      12663
    ]
  },
  {
    "id": "18473",
    "description": "your,yours-(singular)",
    "pos": "BLUE",
    "explanation": "(you + belongs to: second person (sing.), possessive)",
    "isCharacter": false,
    "composition": [
      16161,
      "/",
      8498,
      "/",
      12663
    ]
  },
  {
    "id": "18474",
    "description": "zebra",
    "pos": "YELLOW",
    "explanation": "(horse + stripe: striped animal that resembles a horse)",
    "isCharacter": false,
    "composition": [
      14897,
      "/",
      15214
    ]
  },
  {
    "id": "18475",
    "description": "zoo",
    "pos": "YELLOW",
    "explanation": "(park + animal)",
    "isCharacter": false,
    "composition": [
      15969,
      "/",
      12378
    ]
  },
  {
    "id": "20513",
    "description": "cross_(a)",
    "pos": "YELLOW",
    "explanation": "(cross + thing indicator)  - (character with thing indicator)",
    "isCharacter": "false",
    "composition": [
      13613,
      ";",
      9009
    ]
  },
  {
    "id": "20514",
    "description": "eternal_life,immortality",
    "pos": "YELLOW",
    "explanation": "(life + without + end)",
    "isCharacter": false,
    "composition": [
      15206,
      "/",
      15474,
      "/",
      13935
    ]
  },
  {
    "id": "20515",
    "description": "star_of_David_(a)",
    "pos": "YELLOW",
    "explanation": "(star_of_David + thing indicator)  - (character with thing indicator)",
    "isCharacter": "false",
    "composition": [
      17251,
      ";",
      9009
    ]
  },
  {
    "id": "20516",
    "description": "therapist",
    "pos": "BLUE",
    "explanation": "(person + therapy)  Preferred NEW SYNONYM, replacing 17706",
    "isCharacter": false,
    "composition": [
      16161,
      "/",
      21589
    ]
  },
  {
    "id": "20517",
    "description": "muscle",
    "pos": "YELLOW",
    "explanation": "(arm + the pictograph of a protruding biceps)  - Character (superimposed)  Preferred NEW SYNONYM, replacing 15676",
    "isCharacter": true
  },
  {
    "id": "20518",
    "description": "sport",
    "pos": "YELLOW",
    "explanation": "(activity + health)  - Character (superimposed)  Preferred NEW SYNONYM, replacing 17234",
    "isCharacter": true
  },
  {
    "id": "20519",
    "description": "sail",
    "pos": "YELLOW",
    "explanation": "(pictograph: symbol suggests a sail on a mast)  - Character  Preferred NEW SYNONYM, replacing 16706",
    "isCharacter": true
  },
  {
    "id": "20520",
    "description": "sailboat,sailing_boat,yacht",
    "pos": "YELLOW",
    "explanation": "(boat + sail (combination): pictograph, suggests the outline of a sailboat. The symbol can be explained as: combination of boat and sail) - Character (superimposed - combined) Preferred NEW SYNONYM, replacing 16707",
    "isCharacter": true
  },
  {
    "id": "20521",
    "description": "spaghetti",
    "pos": "YELLOW",
    "explanation": "(pasta + line)",
    "isCharacter": false,
    "composition": [
      14377,
      "/",
      16233,
      "/",
      14625,
      "/",
      15214
    ]
  },
  {
    "id": "20522",
    "description": "sauce,gravy,relish,dressing",
    "pos": "YELLOW",
    "explanation": "(spread + liquid)  - Character (superimposed)  Preferred NEW SYNONYM, replacing 16723",
    "isCharacter": true
  },
  {
    "id": "20523",
    "description": "salt_(OLD)",
    "pos": "YELLOW",
    "explanation": "(flavouring + sea + thing indicator)  SUPERSEDED SYNONYM See salt 26245",
    "isCharacter": false,
    "composition": [
      12339,
      ";",
      9009,
      "/",
      17506,
      "/",
      14647,
      "/",
      14647,
      "/",
      25777
    ]
  },
  {
    "id": "20524",
    "description": "up_and_down",
    "pos": "WHITE",
    "explanation": "(up,upward + down,downward)  - Character (sequenced)  Preferred NEW SYNONYM, replacing 17984",
    "isCharacter": true
  },
  {
    "id": "20526",
    "description": "tasty,good,appetizing",
    "pos": "GREEN",
    "explanation": "(taste + description indicator)",
    "isCharacter": false,
    "composition": [
      17506,
      ";",
      8998,
      "/",
      12374,
      "/",
      14947
    ]
  },
  {
    "id": "20527",
    "description": "mirror",
    "pos": "YELLOW",
    "explanation": "(reflection + thing indicator: a ray of light is reflected by a mirror)  - (character with thing indicator)",
    "isCharacter": "false",
    "composition": [
      22384,
      ";",
      9009
    ]
  },
  {
    "id": "20528",
    "description": "can,tin,jar",
    "pos": "YELLOW",
    "explanation": "(pictograph)  - Character",
    "isCharacter": true
  },
  {
    "id": "20530",
    "description": "hard,firm",
    "pos": "GREEN",
    "explanation": "(hand + table + description indicator: a table top is hard to touch)  Preferred NEW SYNONYM, replacing 14679",
    "isCharacter": false,
    "composition": [
      14667,
      ";",
      8998,
      "/",
      17493
    ]
  },
  {
    "id": "20561",
    "description": "religion_(God_based)",
    "pos": "YELLOW",
    "explanation": "(feeling + God: God-based religion)  - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "20562",
    "description": "religious",
    "pos": "GREEN",
    "explanation": "(religion,naturalism + description indicator)  Preferred NEW SYNONYM, replacing 16484",
    "isCharacter": false,
    "composition": [
      20563,
      ";",
      8998
    ]
  },
  {
    "id": "20563",
    "description": "religion,naturalism",
    "pos": "YELLOW",
    "explanation": "(feeling + creation: doctrine that all religious truths are derived from nature)  - Character (superimposed)  Preferred NEW SYNONYM, replacing 16483",
    "isCharacter": true
  },
  {
    "id": "20564",
    "description": "belief_(supernatural)",
    "pos": "YELLOW",
    "explanation": "(feeling + supernatural)  - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "20565",
    "description": "believer_(in_God)",
    "pos": "BLUE",
    "explanation": "(person + religion_(God_based))",
    "isCharacter": false,
    "composition": [
      16161,
      "/",
      20561
    ]
  },
  {
    "id": "20566",
    "description": "believer",
    "pos": "BLUE",
    "explanation": "(person + religion,naturalism)",
    "isCharacter": false,
    "composition": [
      16161,
      "/",
      20563
    ]
  },
  {
    "id": "20567",
    "description": "Jesus_Christ",
    "pos": "BLUE",
    "explanation": "(man + Christianity)",
    "isCharacter": false,
    "composition": [
      15416,
      "/",
      20561,
      "/",
      13613
    ]
  },
  {
    "id": "20568",
    "description": "devil_(1)",
    "pos": "BLUE",
    "explanation": "(person + horns [modification, higher position]) - Character (superimposed - modified) SYMBOL SYNONYM",
    "isCharacter": true
  },
  {
    "id": "20569",
    "description": "devil_(2)",
    "pos": "BLUE",
    "explanation": "(spirit + supernatural + incorrect,bad,inaccurate,wrong + intensity: very bad supernatural spirit)  SYMBOL SYNONYM",
    "isCharacter": false,
    "composition": [
      21044,
      "/",
      21036,
      "/",
      25539,
      "/",
      14947,
      "/",
      14947
    ]
  },
  {
    "id": "20570",
    "description": "angel_(2)",
    "pos": "BLUE",
    "explanation": "(spirit + supernatural + peace)  SYMBOL SYNONYM",
    "isCharacter": false,
    "composition": [
      21044,
      "/",
      21036,
      "/",
      15981
    ]
  },
  {
    "id": "20571",
    "description": "angel_(1)",
    "pos": "BLUE",
    "explanation": "(person + wings)  - Character (superimposed)  SYMBOL SYNONYM",
    "isCharacter": true
  },
  {
    "id": "20572",
    "description": "family",
    "pos": "BLUE",
    "explanation": "(couple + star, representing a child or children)  - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "20573",
    "description": "religious_ceremony",
    "pos": "YELLOW",
    "explanation": "(ceremony + religion,naturalism)",
    "isCharacter": false,
    "composition": [
      14114,
      "/",
      16194,
      "/",
      20563
    ]
  },
  {
    "id": "20574",
    "description": "religious_ceremony_(God_based)",
    "pos": "YELLOW",
    "explanation": "(ceremony + religion_(God_based))",
    "isCharacter": false,
    "composition": [
      14114,
      "/",
      16194,
      "/",
      20561
    ]
  },
  {
    "id": "20575",
    "description": "marriage,wedding",
    "pos": "YELLOW",
    "explanation": "(ceremony + marriage)",
    "isCharacter": false,
    "composition": [
      14114,
      "/",
      16194,
      "/",
      15425
    ]
  },
  {
    "id": "20576",
    "description": "marriage_(religious)",
    "pos": "YELLOW",
    "explanation": "(religious ceremony + marriage)",
    "isCharacter": false,
    "composition": [
      14114,
      "/",
      16194,
      "/",
      20561,
      "/",
      15425
    ]
  },
  {
    "id": "20577",
    "description": "funeral_(religious)",
    "pos": "YELLOW",
    "explanation": "(religious ceremony + death)",
    "isCharacter": false,
    "composition": [
      14114,
      "/",
      16194,
      "/",
      20561,
      "/",
      13645
    ]
  },
  {
    "id": "20578",
    "description": "funeral",
    "pos": "YELLOW",
    "explanation": "(ceremony + death)",
    "isCharacter": false,
    "composition": [
      14114,
      "/",
      16194,
      "/",
      13645
    ]
  },
  {
    "id": "20579",
    "description": "burial",
    "pos": "YELLOW",
    "explanation": "(ceremony + grave)",
    "isCharacter": false,
    "composition": [
      14114,
      "/",
      16194,
      "/",
      14638
    ]
  },
  {
    "id": "20580",
    "description": "burial_(religious)",
    "pos": "YELLOW",
    "explanation": "(religious ceremony + grave)",
    "isCharacter": false,
    "composition": [
      14114,
      "/",
      16194,
      "/",
      20561,
      "/",
      14638
    ]
  },
  {
    "id": "20581",
    "description": "bury-(to)",
    "pos": "RED",
    "explanation": "(burial_site + action indicator)",
    "isCharacter": false,
    "composition": [
      16193,
      ";",
      8993,
      "/",
      25628
    ]
  },
  {
    "id": "20582",
    "description": "poor_(without_possessions)",
    "pos": "GREEN",
    "explanation": "(poverty + description indicator)",
    "isCharacter": false,
    "composition": [
      15474,
      "/",
      24925,
      ";",
      8998
    ]
  },
  {
    "id": "20583",
    "description": "football,soccer_(sport)",
    "pos": "YELLOW",
    "explanation": "(sport + ball + legs and feet)",
    "isCharacter": false,
    "composition": [
      20518,
      "/",
      12621,
      "/",
      15189
    ]
  },
  {
    "id": "20584",
    "description": "baseball_(sport)",
    "pos": "YELLOW",
    "explanation": "(sport + ball + corner: the corner character here representing the baseball diamond with the pointer to a base in the corner: ball game played on a diamond)",
    "isCharacter": false,
    "composition": [
      20518,
      "/",
      12621,
      "/",
      25537
    ]
  },
  {
    "id": "20585",
    "description": "basketball_(sport)",
    "pos": "YELLOW",
    "explanation": "(sport + ball + container,basket_(high))",
    "isCharacter": false,
    "composition": [
      20518,
      "/",
      12621,
      "/",
      25535
    ]
  },
  {
    "id": "20586",
    "description": "croquet_(sport)",
    "pos": "YELLOW",
    "explanation": "(sport + ball + hammer,gavel,mallet)",
    "isCharacter": false,
    "composition": [
      20518,
      "/",
      12621,
      "/",
      14666
    ]
  },
  {
    "id": "20587",
    "description": "bowling_(sport)",
    "pos": "YELLOW",
    "explanation": "(sport + ball_field)",
    "isCharacter": false,
    "composition": [
      20518,
      "/",
      25524
    ]
  },
  {
    "id": "20588",
    "description": "badminton_(sport)",
    "pos": "YELLOW",
    "explanation": "(sport + shuttlecock,birdie_(badminton))",
    "isCharacter": false,
    "composition": [
      20518,
      "/",
      25608
    ]
  },
  {
    "id": "20589",
    "description": "handball_(sport)",
    "pos": "YELLOW",
    "explanation": "(sport + ball + hand)",
    "isCharacter": false,
    "composition": [
      20518,
      "/",
      12621,
      "/",
      14667
    ]
  },
  {
    "id": "20590",
    "description": "ice_hockey_(sport)",
    "pos": "YELLOW",
    "explanation": "(sport + sport_stick_and_puck,hockey_stick + ice)",
    "isCharacter": false,
    "composition": [
      20518,
      "/",
      25619,
      "/",
      14919
    ]
  },
  {
    "id": "20591",
    "description": "field_hockey,hockey_(sport)",
    "pos": "YELLOW",
    "explanation": "(sport + sport_stick_and_ball,bandy_stick)",
    "isCharacter": false,
    "composition": [
      20518,
      "/",
      25618
    ]
  },
  {
    "id": "20592",
    "description": "golf_(sport)",
    "pos": "YELLOW",
    "explanation": "(sport + sport_stick_and_ball,bandy_stick + container_(low): the container below ground representing the golf hole)",
    "isCharacter": false,
    "composition": [
      20518,
      "/",
      25618,
      "/",
      25536
    ]
  },
  {
    "id": "20593",
    "description": "rugby,football_(N.A.)",
    "pos": "YELLOW",
    "explanation": "(sport + rugby_ball + legs and feet)",
    "isCharacter": false,
    "composition": [
      20518,
      "/",
      21807,
      "/",
      15189
    ]
  },
  {
    "id": "20594",
    "description": "wrestling_(sport)",
    "pos": "YELLOW",
    "explanation": "(sport + fight + mixture)",
    "isCharacter": false,
    "composition": [
      20518,
      "/",
      24855,
      "/",
      22377
    ]
  },
  {
    "id": "20595",
    "description": "judo",
    "pos": "YELLOW",
    "explanation": "(sport + fight + east + mixture)",
    "isCharacter": false,
    "composition": [
      20518,
      "/",
      24855,
      "/",
      13902,
      "/",
      22377
    ]
  },
  {
    "id": "20596",
    "description": "boxing_(sport)",
    "pos": "YELLOW",
    "explanation": "(sport + fight + hand)",
    "isCharacter": false,
    "composition": [
      20518,
      "/",
      24855,
      "/",
      14667
    ]
  },
  {
    "id": "20597",
    "description": "skiing_(sport)",
    "pos": "YELLOW",
    "explanation": "(sport + skis)",
    "isCharacter": false,
    "composition": [
      20518,
      "/",
      8498,
      "/",
      25610
    ]
  },
  {
    "id": "20598",
    "description": "skiing_(activity)",
    "pos": "YELLOW",
    "explanation": "(activity + skis)",
    "isCharacter": false,
    "composition": [
      12335,
      "/",
      8498,
      "/",
      25610
    ]
  },
  {
    "id": "20599",
    "description": "board",
    "pos": "YELLOW",
    "explanation": "(pictograph)  - Character",
    "isCharacter": true
  },
  {
    "id": "20600",
    "description": "stable",
    "pos": "YELLOW",
    "explanation": "(house + horse)",
    "isCharacter": false,
    "composition": [
      14905,
      "/",
      14897
    ]
  },
  {
    "id": "20601",
    "description": "carriage",
    "pos": "YELLOW",
    "explanation": "(cart,carriage + big + horse)",
    "isCharacter": false,
    "composition": [
      13127,
      "/",
      24875,
      "/",
      14897
    ]
  },
  {
    "id": "20602",
    "description": "tennis,racquet_sports_(OLD)",
    "pos": "YELLOW",
    "explanation": "(sport + crossed_racquets)    SUPERSEDED SYNONYM  See tennis,racket_sport,racquet_sport 26030",
    "isCharacter": false,
    "composition": [
      20518,
      "/",
      25542
    ]
  },
  {
    "id": "20603",
    "description": "table_tennis,ping-pong_(sport)_(OLD)",
    "pos": "YELLOW",
    "explanation": "(tennis,racquet_sports_(OLD) + table)    SUPERSEDED SYNONYM  See  table_tennis,ping-pong_(sport) 26029",
    "isCharacter": false,
    "composition": [
      20518,
      "/",
      25542,
      "/",
      17493
    ]
  },
  {
    "id": "20604",
    "description": "beach_tennis_(sport)_(OLD)",
    "pos": "YELLOW",
    "explanation": "(tennis,racquet_sports_(OLD) + beach)    SUPERSEDED SYNONYM  See beach_tennis_(sport) 25982",
    "isCharacter": false,
    "composition": [
      20518,
      "/",
      25542,
      "/",
      12640
    ]
  },
  {
    "id": "20605",
    "description": "team_(sport)",
    "pos": "YELLOW",
    "explanation": "(group + sport: group which comes together to play a sport)",
    "isCharacter": false,
    "composition": [
      14647,
      "/",
      16161,
      "/",
      20518
    ]
  },
  {
    "id": "20606",
    "description": "snack_(meal)",
    "pos": "YELLOW",
    "explanation": "(food + between)",
    "isCharacter": false,
    "composition": [
      14377,
      "/",
      12669
    ]
  },
  {
    "id": "20769",
    "description": "bun_(food)",
    "pos": "YELLOW",
    "explanation": "(roll,bun + horizontal line: pictograph, a bun cut horizontally for food to be placed in between)  - Character",
    "isCharacter": true
  },
  {
    "id": "20770",
    "description": "hamburger",
    "pos": "YELLOW",
    "explanation": "(bun_(food) + animal (meat [contraction]))  Preferred NEW SYNONYM, replacing 14664",
    "isCharacter": false,
    "composition": [
      20769,
      "/",
      12378
    ]
  },
  {
    "id": "20771",
    "description": "chocolate_flavouring",
    "pos": "YELLOW",
    "explanation": "(flavouring + chocolate [contraction] + thing indicator)  Preferred NEW SYNONYM, replacing 13173",
    "isCharacter": false,
    "composition": [
      12339,
      ";",
      9009,
      "/",
      17506,
      "/",
      12642,
      "/",
      17983
    ]
  },
  {
    "id": "20772",
    "description": "chocolate_drink",
    "pos": "YELLOW",
    "explanation": "(drink + chocolate [contraction])  Preferred NEW SYNONYM, replacing 13172",
    "isCharacter": false,
    "composition": [
      13881,
      "/",
      12642,
      "/",
      17983
    ]
  },
  {
    "id": "21025",
    "description": "monotheism",
    "pos": "YELLOW",
    "explanation": "(religion_(God_based) + 1 + God: belief that there is only one God)",
    "isCharacter": false,
    "composition": [
      20561,
      "/",
      8497,
      "/",
      14451
    ]
  },
  {
    "id": "21026",
    "description": "polytheism",
    "pos": "YELLOW",
    "explanation": "(religion_(God_based) + many + God: belief in more than one God)",
    "isCharacter": false,
    "composition": [
      20561,
      "/",
      14647,
      "/",
      14451
    ]
  },
  {
    "id": "21027",
    "description": "Christianity",
    "pos": "YELLOW",
    "explanation": "(religion_(God_based) + Christ [contraction]: religion founded on the teachings of Christ)",
    "isCharacter": false,
    "composition": [
      20561,
      "/",
      13613
    ]
  },
  {
    "id": "21028",
    "description": "Judaism",
    "pos": "YELLOW",
    "explanation": "(religion_(God_based) + Star of David: religion of the Jewish people)",
    "isCharacter": false,
    "composition": [
      20561,
      "/",
      17251
    ]
  },
  {
    "id": "21029",
    "description": "Islam",
    "pos": "YELLOW",
    "explanation": "(religion_(God_based) + Muslim: religion based on the teaching of the prophet Muhammed)",
    "isCharacter": false,
    "composition": [
      20561,
      "/",
      17252,
      "/",
      15651
    ]
  },
  {
    "id": "21030",
    "description": "Eastern_Orthodox_Church",
    "pos": "YELLOW",
    "explanation": "(Christianity + east: group of churches, including Greek and Russian Orthodox)",
    "isCharacter": false,
    "composition": [
      20561,
      "/",
      13613,
      "/",
      13902
    ]
  },
  {
    "id": "21031",
    "description": "Christian_(person)",
    "pos": "BLUE",
    "explanation": "(person + Christianity [contraction])",
    "isCharacter": false,
    "composition": [
      16161,
      "/",
      13613
    ]
  },
  {
    "id": "21032",
    "description": "Jew",
    "pos": "BLUE",
    "explanation": "(person + Star of David)",
    "isCharacter": false,
    "composition": [
      16161,
      "/",
      17251
    ]
  },
  {
    "id": "21033",
    "description": "Muslim,Moslem",
    "pos": "BLUE",
    "explanation": "(person + Muslim)",
    "isCharacter": false,
    "composition": [
      16161,
      "/",
      17252,
      "/",
      15651
    ]
  },
  {
    "id": "21034",
    "description": "Muhammad,Mohammed,Muhammed",
    "pos": "BLUE",
    "explanation": "(man + Islam: founder of Islam)",
    "isCharacter": false,
    "composition": [
      15416,
      "/",
      20561,
      "/",
      17252,
      "/",
      15651
    ]
  },
  {
    "id": "21035",
    "description": "Allah",
    "pos": "BLUE",
    "explanation": "(God + ALLAH)",
    "isCharacter": false,
    "composition": [
      14451,
      "/",
      "XA",
      "/",
      "XL",
      "/",
      "XL",
      "/",
      "XA",
      "/",
      "XH"
    ]
  },
  {
    "id": "21036",
    "description": "supernatural-(noun)",
    "pos": "YELLOW",
    "explanation": "(nature + mind [modification, at a higher position]: claimed to be experienced at a higher level of consciousness)  - Character (superimposed - modified)",
    "isCharacter": true
  },
  {
    "id": "21037",
    "description": "Vatican,Vatican_City",
    "pos": "YELLOW",
    "explanation": "(country + Christian: the Vatican is the seat of papal government)",
    "isCharacter": false,
    "composition": [
      13423,
      "/",
      13613
    ]
  },
  {
    "id": "21038",
    "description": "Roman_Catholicism,Roman_Catholic_Church",
    "pos": "YELLOW",
    "explanation": "(religion + Vatican: the doctrines, practices and organization of the Roman Catholic Church)",
    "isCharacter": false,
    "composition": [
      20561,
      "/",
      13423,
      "/",
      13613
    ]
  },
  {
    "id": "21039",
    "description": "protestantism",
    "pos": "YELLOW",
    "explanation": "(religion + Christ [contraction] + group: Christian religion, which emphasizes the importance of the congregation)",
    "isCharacter": false,
    "composition": [
      20561,
      "/",
      13613,
      "/",
      14647,
      "/",
      16161
    ]
  },
  {
    "id": "21040",
    "description": "grace,grace_of_God",
    "pos": "YELLOW",
    "explanation": "(pointer (left) + God + pointer (right): suggesting the grace radiating from God)  - Character (superimposed - pointer)",
    "isCharacter": true
  },
  {
    "id": "21041",
    "description": "divine,holy",
    "pos": "GREEN",
    "explanation": "(God + description indicator)",
    "isCharacter": false,
    "composition": [
      14451,
      ";",
      8998
    ]
  },
  {
    "id": "21042",
    "description": "bandy_(sport)",
    "pos": "YELLOW",
    "explanation": "(sport + sport_stick_and_ball,bandy_stick + ice)",
    "isCharacter": false,
    "composition": [
      20518,
      "/",
      25618,
      "/",
      14919
    ]
  },
  {
    "id": "21043",
    "description": "Messiah",
    "pos": "BLUE",
    "explanation": "(man + God + peace: Jesus Christ - biblical figure)",
    "isCharacter": false,
    "composition": [
      15416,
      "/",
      14451,
      "/",
      15981
    ]
  },
  {
    "id": "21044",
    "description": "spirit",
    "pos": "YELLOW",
    "explanation": "(feeling + to be: a feeling of being: a vital force, traditionally believed to be within living beings)  - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "21045",
    "description": "soul",
    "pos": "YELLOW",
    "explanation": "(spirit + person: the animating vital principal in man)",
    "isCharacter": false,
    "composition": [
      21044,
      "/",
      16161
    ]
  },
  {
    "id": "21046",
    "description": "Mary_(Mother_of_Christ)",
    "pos": "BLUE",
    "explanation": "(mother + Christ [contraction]: biblical figure)",
    "isCharacter": false,
    "composition": [
      15662,
      "/",
      15416,
      "/",
      13613
    ]
  },
  {
    "id": "21047",
    "description": "Joseph,Saint_Joseph",
    "pos": "BLUE",
    "explanation": "(father + Christ [contraction] + earth: the earthly father of Christ - biblical figure)",
    "isCharacter": false,
    "composition": [
      14157,
      "/",
      13613,
      "/",
      13901
    ]
  },
  {
    "id": "21048",
    "description": "prophecy",
    "pos": "YELLOW",
    "explanation": "(to speak + future: what is said about the future)",
    "isCharacter": false,
    "composition": [
      15666,
      "/",
      14417
    ]
  },
  {
    "id": "21049",
    "description": "prophesy-(to)",
    "pos": "RED",
    "explanation": "(prophecy + action indicator)",
    "isCharacter": false,
    "composition": [
      15666,
      ";",
      8993,
      "/",
      14417
    ]
  },
  {
    "id": "21050",
    "description": "prophet",
    "pos": "BLUE",
    "explanation": "(person + to prophesy)",
    "isCharacter": false,
    "composition": [
      16161,
      "/",
      15666,
      "/",
      14417
    ]
  },
  {
    "id": "21051",
    "description": "predict-(to)",
    "pos": "RED",
    "explanation": "(to prophesy + fact + action indicator)",
    "isCharacter": false,
    "composition": [
      15666,
      ";",
      8993,
      "/",
      14417,
      "/",
      14139
    ]
  },
  {
    "id": "21053",
    "description": "follow-(to)",
    "pos": "RED",
    "explanation": "(to go + leadership,guidance + action indicator: to go behind a leader)  Preferred NEW SYNONYM, replacing 14376",
    "isCharacter": false,
    "composition": [
      14390,
      ";",
      8993,
      "/",
      22913
    ]
  },
  {
    "id": "21054",
    "description": "leader,director,guide_(1)",
    "pos": "BLUE",
    "explanation": "(person + leadership,guidance)  - Character (superimposed)  SYMBOL SYNONYM",
    "isCharacter": true
  },
  {
    "id": "21055",
    "description": "religious_leader",
    "pos": "BLUE",
    "explanation": "(leader + religion)",
    "isCharacter": false,
    "composition": [
      21054,
      "/",
      20561
    ]
  },
  {
    "id": "21056",
    "description": "bishop",
    "pos": "BLUE",
    "explanation": "(leader + Christian)",
    "isCharacter": false,
    "composition": [
      21054,
      "/",
      13613
    ]
  },
  {
    "id": "21057",
    "description": "Pope",
    "pos": "BLUE",
    "explanation": "(leader + Vatican: bishop of Rome and leader of the Roman Catholic Church)",
    "isCharacter": false,
    "composition": [
      21054,
      "/",
      13423,
      "/",
      13613
    ]
  },
  {
    "id": "21058",
    "description": "disperse,disseminate,scatter,spread-(to)",
    "pos": "RED",
    "explanation": "(dispersion,dissemination,scattering,spread,spreading + action indicator)  See dispersion,dissemination,scattering,spread,spreading 24887",
    "isCharacter": false,
    "composition": [
      24887,
      ";",
      8993
    ]
  },
  {
    "id": "21059",
    "description": "apostle",
    "pos": "BLUE",
    "explanation": "(man + past + to disseminate + Christianity [contraction]: one of Christ's 12 disciples, whom he chose to preach the gospel)",
    "isCharacter": false,
    "composition": [
      15416,
      "/",
      15975,
      "/",
      24887,
      "/",
      13613
    ]
  },
  {
    "id": "21060",
    "description": "missionary",
    "pos": "BLUE",
    "explanation": "(person + to disseminate + religion)",
    "isCharacter": false,
    "composition": [
      16161,
      "/",
      24887,
      "/",
      20561
    ]
  },
  {
    "id": "21061",
    "description": "horn(s),antler(s)",
    "pos": "YELLOW",
    "explanation": "(pictograph)  - Character",
    "isCharacter": true
  },
  {
    "id": "21062",
    "description": "hell",
    "pos": "YELLOW",
    "explanation": "(place + devil)",
    "isCharacter": false,
    "composition": [
      16193,
      "/",
      20568
    ]
  },
  {
    "id": "21063",
    "description": "Adam",
    "pos": "BLUE",
    "explanation": "(man + first: the first man on earth - biblical figure)",
    "isCharacter": false,
    "composition": [
      15416,
      "/",
      8497,
      "/",
      8486
    ]
  },
  {
    "id": "21064",
    "description": "Eve",
    "pos": "BLUE",
    "explanation": "(woman + first: the first woman on earth - biblical figure)",
    "isCharacter": false,
    "composition": [
      18269,
      "/",
      8497,
      "/",
      8486
    ]
  },
  {
    "id": "21065",
    "description": "Noah",
    "pos": "BLUE",
    "explanation": "(man + boat + animal: biblical figure)",
    "isCharacter": false,
    "composition": [
      15416,
      "/",
      12869,
      "/",
      12378
    ]
  },
  {
    "id": "21066",
    "description": "Abraham",
    "pos": "BLUE",
    "explanation": "(man + multitude + offspring: biblical figure)",
    "isCharacter": false,
    "composition": [
      15416,
      "/",
      15673,
      "/",
      15912
    ]
  },
  {
    "id": "21067",
    "description": "Moses",
    "pos": "BLUE",
    "explanation": "(man + commandments: biblical figure)",
    "isCharacter": false,
    "composition": [
      15416,
      "/",
      13388
    ]
  },
  {
    "id": "21068",
    "description": "holy_book",
    "pos": "YELLOW",
    "explanation": "(book + God)",
    "isCharacter": false,
    "composition": [
      12875,
      "/",
      14451
    ]
  },
  {
    "id": "21069",
    "description": "Bible_(Christian)",
    "pos": "YELLOW",
    "explanation": "(holy book + Christian)",
    "isCharacter": false,
    "composition": [
      12875,
      "/",
      14451,
      "/",
      13613
    ]
  },
  {
    "id": "21070",
    "description": "Old_Testament",
    "pos": "YELLOW",
    "explanation": "(holy book + before + Christ [contraction])",
    "isCharacter": false,
    "composition": [
      12875,
      "/",
      14451,
      "/",
      12656,
      "/",
      13613
    ]
  },
  {
    "id": "21071",
    "description": "New_Testament",
    "pos": "YELLOW",
    "explanation": "(holy book + after + Christ [contraction])",
    "isCharacter": false,
    "composition": [
      12875,
      "/",
      14451,
      "/",
      12348,
      "/",
      13613
    ]
  },
  {
    "id": "21072",
    "description": "Koran",
    "pos": "YELLOW",
    "explanation": "(holy book + Muslim)",
    "isCharacter": false,
    "composition": [
      12875,
      "/",
      14451,
      "/",
      17252,
      "/",
      15651
    ]
  },
  {
    "id": "21073",
    "description": "hymnal,hymn_book",
    "pos": "YELLOW",
    "explanation": "(book + song + religion)",
    "isCharacter": false,
    "composition": [
      12875,
      "/",
      15666,
      "/",
      15682,
      "/",
      20561
    ]
  },
  {
    "id": "21074",
    "description": "hymn,psalm,gospel_song",
    "pos": "YELLOW",
    "explanation": "(song + religion)",
    "isCharacter": false,
    "composition": [
      15666,
      "/",
      15682,
      "/",
      20561
    ]
  },
  {
    "id": "21075",
    "description": "missal,liturgical_book",
    "pos": "YELLOW",
    "explanation": "(book + action + religion)",
    "isCharacter": false,
    "composition": [
      12875,
      "/",
      12335,
      "/",
      20561
    ]
  },
  {
    "id": "21076",
    "description": "gospel",
    "pos": "YELLOW",
    "explanation": "(story + Jesus Christ [contraction])",
    "isCharacter": false,
    "composition": [
      15962,
      "/",
      15666,
      "/",
      15416,
      "/",
      13613
    ]
  },
  {
    "id": "21078",
    "description": "appearance,manifestation",
    "pos": "YELLOW",
    "explanation": "(beginning + to see: coming into view for the first time)",
    "isCharacter": false,
    "composition": [
      12658,
      "/",
      14133
    ]
  },
  {
    "id": "21079",
    "description": "appear-(to)",
    "pos": "RED",
    "explanation": "(appearance + action indicator)",
    "isCharacter": false,
    "composition": [
      12658,
      ";",
      8993,
      "/",
      14133
    ]
  },
  {
    "id": "21080",
    "description": "disappearance",
    "pos": "YELLOW",
    "explanation": "(ending + to see)",
    "isCharacter": false,
    "composition": [
      13935,
      "/",
      14133
    ]
  },
  {
    "id": "21081",
    "description": "disappear-(to)",
    "pos": "RED",
    "explanation": "(disappearance + action indicator)",
    "isCharacter": false,
    "composition": [
      13935,
      ";",
      8993,
      "/",
      14133
    ]
  },
  {
    "id": "21082",
    "description": "holiness",
    "pos": "YELLOW",
    "explanation": "(pictograph: the symbol suggests a halo)  - Character",
    "isCharacter": true
  },
  {
    "id": "21083",
    "description": "holy",
    "pos": "GREEN",
    "explanation": "(holiness + description indicator)",
    "isCharacter": false,
    "composition": [
      21082,
      ";",
      8998
    ]
  },
  {
    "id": "21084",
    "description": "sanctify,consecrate-(to)",
    "pos": "RED",
    "explanation": "(holiness + action indicator)",
    "isCharacter": false,
    "composition": [
      21082,
      ";",
      8993
    ]
  },
  {
    "id": "21085",
    "description": "saint",
    "pos": "BLUE",
    "explanation": "(person + holy)",
    "isCharacter": false,
    "composition": [
      16161,
      "/",
      21082
    ]
  },
  {
    "id": "21086",
    "description": "Holy_Infant",
    "pos": "BLUE",
    "explanation": "(infant + holy)",
    "isCharacter": false,
    "composition": [
      12603,
      "/",
      21082
    ]
  },
  {
    "id": "21087",
    "description": "sanctity_of_life",
    "pos": "YELLOW",
    "explanation": "(holiness + life)",
    "isCharacter": false,
    "composition": [
      21082,
      "/",
      15206
    ]
  },
  {
    "id": "21088",
    "description": "Holy_City",
    "pos": "YELLOW",
    "explanation": "(city + holy)",
    "isCharacter": false,
    "composition": [
      14647,
      "/",
      14647,
      "/",
      14905,
      "/",
      21082
    ]
  },
  {
    "id": "21089",
    "description": "Holy_Family",
    "pos": "BLUE",
    "explanation": "(family + holy)",
    "isCharacter": false,
    "composition": [
      20572,
      "/",
      21082
    ]
  },
  {
    "id": "21090",
    "description": "single_parent",
    "pos": "BLUE",
    "explanation": "(parent + protection: one parent who offers protection to a child or children)  - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "21091",
    "description": "single_mother",
    "pos": "BLUE",
    "explanation": "(mother + protection)  - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "21092",
    "description": "single_father",
    "pos": "BLUE",
    "explanation": "(father + protection)  - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "21093",
    "description": "single_parent_family",
    "pos": "BLUE",
    "explanation": "(single parent + star: family consisting of a single parent and a child or children)  - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "21094",
    "description": "family_(group_home)",
    "pos": "BLUE",
    "explanation": "(group of + family: family consisting of members of a group home)",
    "isCharacter": false,
    "composition": [
      14647,
      "/",
      14145
    ]
  },
  {
    "id": "21095",
    "description": "religious_event",
    "pos": "YELLOW",
    "explanation": "(event + religion)",
    "isCharacter": false,
    "composition": [
      14114,
      "/",
      20561
    ]
  },
  {
    "id": "21096",
    "description": "ceremony",
    "pos": "YELLOW",
    "explanation": "(event + plan: event which consists of an act or a set of acts which follow a plan)",
    "isCharacter": false,
    "composition": [
      14114,
      "/",
      16194
    ]
  },
  {
    "id": "21097",
    "description": "meditate-(to)",
    "pos": "RED",
    "explanation": "(to reflect + spirit + action indicator:to think and reflect within the spirit)",
    "isCharacter": false,
    "composition": [
      25602,
      ";",
      8993,
      "/",
      21044
    ]
  },
  {
    "id": "21098",
    "description": "insight",
    "pos": "YELLOW",
    "explanation": "(to see + world: to be able to see the world as it is)  - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "21099",
    "description": "confess-(to)",
    "pos": "RED",
    "explanation": "(to speak + guilty)",
    "isCharacter": false,
    "composition": [
      15666,
      ";",
      8993,
      "/",
      23127,
      "/",
      15474,
      "/",
      14947
    ]
  },
  {
    "id": "21100",
    "description": "Christian_event",
    "pos": "YELLOW",
    "explanation": "(event + Christian [contraction])",
    "isCharacter": false,
    "composition": [
      14114,
      "/",
      13613
    ]
  },
  {
    "id": "21101",
    "description": "holy_event",
    "pos": "YELLOW",
    "explanation": "(event + holy)",
    "isCharacter": false,
    "composition": [
      14114,
      "/",
      21082
    ]
  },
  {
    "id": "21102",
    "description": "sacrament",
    "pos": "YELLOW",
    "explanation": "(Christian event + holy)",
    "isCharacter": false,
    "composition": [
      14114,
      "/",
      13613,
      "/",
      21082
    ]
  },
  {
    "id": "21103",
    "description": "sacrament_of_baptism",
    "pos": "YELLOW",
    "explanation": "(sacrament + water)",
    "isCharacter": false,
    "composition": [
      14114,
      "/",
      13613,
      "/",
      21082,
      "/",
      18209
    ]
  },
  {
    "id": "21104",
    "description": "sacrament_of_confirmation",
    "pos": "YELLOW",
    "explanation": "(sacrament + fire: Christian sacrament in commemoration of the flame of the Holy Spirit)",
    "isCharacter": false,
    "composition": [
      14114,
      "/",
      13613,
      "/",
      21082,
      "/",
      14183
    ]
  },
  {
    "id": "21105",
    "description": "sacrament_of_communion",
    "pos": "YELLOW",
    "explanation": "(sacrament + food: Christian sacrament in which consecrated bread and wine are partaken of)",
    "isCharacter": false,
    "composition": [
      14114,
      "/",
      13613,
      "/",
      21082,
      "/",
      14377
    ]
  },
  {
    "id": "21106",
    "description": "sacrament_of_absolution",
    "pos": "YELLOW",
    "explanation": "(sacrament + to forgive)",
    "isCharacter": false,
    "composition": [
      14114,
      "/",
      13613,
      "/",
      21082,
      "/",
      25593,
      "/",
      12348
    ]
  },
  {
    "id": "21107",
    "description": "sacrament_of_holy_orders",
    "pos": "YELLOW",
    "explanation": "(sacrament + person + belongs to + God)",
    "isCharacter": false,
    "composition": [
      14114,
      "/",
      13613,
      "/",
      21082,
      "/",
      16161,
      "/",
      12663,
      "/",
      14451
    ]
  },
  {
    "id": "21108",
    "description": "sacrament_of_marriage",
    "pos": "YELLOW",
    "explanation": "(sacrament + marriage)",
    "isCharacter": false,
    "composition": [
      14114,
      "/",
      13613,
      "/",
      21082,
      "/",
      15425
    ]
  },
  {
    "id": "21109",
    "description": "sacrament_of_anointment_of_sick",
    "pos": "YELLOW",
    "explanation": "(sacrament + oil + illness)",
    "isCharacter": false,
    "composition": [
      14114,
      "/",
      13613,
      "/",
      21082,
      "/",
      15914,
      "/",
      16164
    ]
  },
  {
    "id": "21110",
    "description": "confirmation",
    "pos": "YELLOW",
    "explanation": "(religious ceremony + knowledge)",
    "isCharacter": false,
    "composition": [
      14114,
      "/",
      16194,
      "/",
      20561,
      "/",
      15162
    ]
  },
  {
    "id": "21111",
    "description": "bat_mitzvah_(Hebrew)",
    "pos": "YELLOW",
    "explanation": "(religious ceremony + of + woman: religious ceremony that recognizes a Jewish girl as a woman)",
    "isCharacter": false,
    "composition": [
      14114,
      "/",
      16194,
      "/",
      20561,
      "/",
      12324,
      "/",
      "RK:-2",
      "/",
      18269
    ]
  },
  {
    "id": "21112",
    "description": "bar_mitzvah_(Hebrew)",
    "pos": "YELLOW",
    "explanation": "(religious ceremony + of + man: religious ceremony that recognizes a Jewish boy as a man)",
    "isCharacter": false,
    "composition": [
      14114,
      "/",
      16194,
      "/",
      20561,
      "/",
      12324,
      "/",
      "RK:-2",
      "/",
      15416
    ]
  },
  {
    "id": "21113",
    "description": "circumcision_ceremony",
    "pos": "YELLOW",
    "explanation": "(religious ceremony + circumcision: religious procedure performed on male babies)",
    "isCharacter": false,
    "composition": [
      14114,
      "/",
      16194,
      "/",
      20561,
      "/",
      17449,
      "/",
      16420,
      "/",
      15417
    ]
  },
  {
    "id": "21116",
    "description": "coffin",
    "pos": "YELLOW",
    "explanation": "(enclosure [modification, rectangular] + reclining,lying_(person_lying_down) [modification, higher position, shortened line for feet]) - Character (superimposed - modified)",
    "isCharacter": true
  },
  {
    "id": "21117",
    "description": "mausoleum",
    "pos": "YELLOW",
    "explanation": "(building + coffin: building in which coffins or tombs are placed)",
    "isCharacter": false,
    "composition": [
      14905,
      "/",
      21116
    ]
  },
  {
    "id": "21118",
    "description": "scatter_ashes-(to)",
    "pos": "RED",
    "explanation": "(to scatter + ashes + action indicator)",
    "isCharacter": false,
    "composition": [
      24887,
      ";",
      8993,
      "/",
      18043,
      "/",
      14183
    ]
  },
  {
    "id": "21281",
    "description": "urn",
    "pos": "YELLOW",
    "explanation": "(vase + ashes: burial urn)",
    "isCharacter": false,
    "composition": [
      21282,
      "/",
      18043,
      "/",
      14183
    ]
  },
  {
    "id": "21282",
    "description": "vase,urn,trophy_cup",
    "pos": "YELLOW",
    "explanation": "(pictograph)  - Character",
    "isCharacter": true
  },
  {
    "id": "21283",
    "description": "tomb",
    "pos": "YELLOW",
    "explanation": "(place + coffin)",
    "isCharacter": false,
    "composition": [
      16193,
      "/",
      21116
    ]
  },
  {
    "id": "21284",
    "description": "tombstone",
    "pos": "YELLOW",
    "explanation": "(stone + grave)",
    "isCharacter": false,
    "composition": [
      17267,
      "/",
      14638
    ]
  },
  {
    "id": "21285",
    "description": "cremation",
    "pos": "YELLOW",
    "explanation": "(fire + death: death representing a dead person [contraction])",
    "isCharacter": false,
    "composition": [
      14183,
      "/",
      13645
    ]
  },
  {
    "id": "21286",
    "description": "cremate-(to)",
    "pos": "RED",
    "explanation": "(cremation + action indicator)",
    "isCharacter": false,
    "composition": [
      14183,
      ";",
      8993,
      "/",
      13645
    ]
  },
  {
    "id": "21287",
    "description": "revelry,revel",
    "pos": "YELLOW",
    "explanation": "(party + intensity: lively or boisterous gathering)",
    "isCharacter": false,
    "composition": [
      14427,
      "/",
      14164,
      "/",
      17983,
      "/",
      14947
    ]
  },
  {
    "id": "21288",
    "description": "religious_gathering",
    "pos": "YELLOW",
    "explanation": "(gathering + religion)",
    "isCharacter": false,
    "composition": [
      14427,
      "/",
      20561
    ]
  },
  {
    "id": "21289",
    "description": "awful,dreadful,terrible",
    "pos": "GREEN",
    "explanation": "(bad + intensity + description indicator)",
    "isCharacter": false,
    "composition": [
      14164,
      ";",
      8998,
      "/",
      15474,
      "/",
      14947,
      "/",
      14947
    ]
  },
  {
    "id": "21290",
    "description": "celebration",
    "pos": "YELLOW",
    "explanation": "(event + happy + purpose: event to mark a special occasion)",
    "isCharacter": false,
    "composition": [
      14114,
      "/",
      14164,
      "/",
      17983,
      "/",
      16437
    ]
  },
  {
    "id": "21291",
    "description": "celebration_of_life",
    "pos": "YELLOW",
    "explanation": "(celebration + life)",
    "isCharacter": false,
    "composition": [
      14114,
      "/",
      14164,
      "/",
      17983,
      "/",
      16437,
      "/",
      15206
    ]
  },
  {
    "id": "21292",
    "description": "misericordia_(forgiveness_from_God)",
    "pos": "YELLOW",
    "explanation": "(to forgive + God)",
    "isCharacter": false,
    "composition": [
      25593,
      "/",
      12348,
      "/",
      14451
    ]
  },
  {
    "id": "21293",
    "description": "forgiveness,pardon",
    "pos": "YELLOW",
    "explanation": "(permission,allowance_(moral) + after: giving moral permission for a misdeed after it is done)",
    "isCharacter": false,
    "composition": [
      25593,
      "/",
      12348
    ]
  },
  {
    "id": "21294",
    "description": "unforgivable,inexcusable",
    "pos": "GREEN",
    "explanation": "(without + forgiveness + description indicator)",
    "isCharacter": false,
    "composition": [
      15474,
      "/",
      25593,
      ";",
      8998,
      "/",
      12348
    ]
  },
  {
    "id": "21295",
    "description": "shiva_(Judaism)",
    "pos": "YELLOW",
    "explanation": "(week + to mourn)",
    "isCharacter": false,
    "composition": [
      8503,
      "/",
      13639,
      "/",
      14164,
      "/",
      13869,
      "/",
      17449
    ]
  },
  {
    "id": "21296",
    "description": "mourn-(to)",
    "pos": "RED",
    "explanation": "(sadness + loss + action indicator: to feel sadness or grief after a loss)",
    "isCharacter": false,
    "composition": [
      14164,
      ";",
      8993,
      "/",
      13869,
      "/",
      17449
    ]
  },
  {
    "id": "21297",
    "description": "mystery,unknown",
    "pos": "YELLOW",
    "explanation": "(knowledge + what,question_mark: something known, but not fully understood)  - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "21298",
    "description": "mysterious,unknown",
    "pos": "GREEN",
    "explanation": "(mystery + description indicator)",
    "isCharacter": false,
    "composition": [
      21297,
      ";",
      8998
    ]
  },
  {
    "id": "21299",
    "description": "miracle",
    "pos": "YELLOW",
    "explanation": "(supernatural + positive: something positive which cannot be explained by laws of nature)",
    "isCharacter": false,
    "composition": [
      21036,
      "/",
      12374,
      "/",
      14947
    ]
  },
  {
    "id": "21300",
    "description": "vision,apparition",
    "pos": "YELLOW",
    "explanation": "(event + supernatural + to see)",
    "isCharacter": false,
    "composition": [
      14114,
      "/",
      21036,
      "/",
      14133
    ]
  },
  {
    "id": "21301",
    "description": "atheism",
    "pos": "YELLOW",
    "explanation": "(without + belief + God: disbelief or denial of existence of God)",
    "isCharacter": false,
    "composition": [
      15474,
      "/",
      14164,
      "/",
      "RK:-2",
      "/",
      25574,
      "/",
      14451
    ]
  },
  {
    "id": "21302",
    "description": "Christian_faith",
    "pos": "YELLOW",
    "explanation": "(belief + Christian)",
    "isCharacter": false,
    "composition": [
      14164,
      "/",
      "RK:-2",
      "/",
      25574,
      "/",
      13613
    ]
  },
  {
    "id": "21303",
    "description": "Christian_hope",
    "pos": "YELLOW",
    "explanation": "(hope + Christian)",
    "isCharacter": false,
    "composition": [
      14164,
      "/",
      17983,
      "/",
      25568,
      "/",
      13613
    ]
  },
  {
    "id": "21304",
    "description": "Christian_love",
    "pos": "YELLOW",
    "explanation": "(love + Christian)",
    "isCharacter": false,
    "composition": [
      15399,
      "/",
      13613
    ]
  },
  {
    "id": "21305",
    "description": "Christian_charity",
    "pos": "YELLOW",
    "explanation": "(charity + Christian)",
    "isCharacter": false,
    "composition": [
      14704,
      "/",
      15701,
      "/",
      14164,
      "/",
      13613
    ]
  },
  {
    "id": "21306",
    "description": "poverty",
    "pos": "YELLOW",
    "explanation": "(without + ownership,possession: state of being without possessions)",
    "isCharacter": false,
    "composition": [
      15474,
      "/",
      24925
    ]
  },
  {
    "id": "21307",
    "description": "impoverish-(to)",
    "pos": "RED",
    "explanation": "(to cause + poverty + action indicator)",
    "isCharacter": false,
    "composition": [
      13134,
      ";",
      8993,
      "/",
      15474,
      "/",
      24925
    ]
  },
  {
    "id": "21308",
    "description": "abstention",
    "pos": "YELLOW",
    "explanation": "(decision + without + action: decision to not do something)",
    "isCharacter": false,
    "composition": [
      13649,
      "/",
      15474,
      "/",
      12335
    ]
  },
  {
    "id": "21309",
    "description": "obedience",
    "pos": "YELLOW",
    "explanation": "(action + by + rule [contraction]: act of doing something according to the rules)",
    "isCharacter": false,
    "composition": [
      12335,
      "/",
      13100,
      "/",
      22913
    ]
  },
  {
    "id": "21310",
    "description": "preach-(to)",
    "pos": "RED",
    "explanation": "(to speak + to persuade + action indicator)",
    "isCharacter": false,
    "composition": [
      15666,
      ";",
      8993,
      "/",
      24927
    ]
  },
  {
    "id": "21311",
    "description": "persuade,convince-(to)",
    "pos": "RED",
    "explanation": "(persuasion + action indicator: to lead to agreement)",
    "isCharacter": false,
    "composition": [
      24927,
      ";",
      8993
    ]
  },
  {
    "id": "21312",
    "description": "amen",
    "pos": "GRAY",
    "explanation": "(yes + religion)",
    "isCharacter": false,
    "composition": [
      12374,
      "/",
      14947,
      "/",
      14947,
      "/",
      20563
    ]
  },
  {
    "id": "21313",
    "description": "dead_person",
    "pos": "BLUE",
    "explanation": "(person + dead)",
    "isCharacter": false,
    "composition": [
      16161,
      "/",
      13645
    ]
  },
  {
    "id": "21314",
    "description": "dead_(the_dead)",
    "pos": "BLUE",
    "explanation": "(dead person + plural indicator)",
    "isCharacter": false,
    "composition": [
      16161,
      ";",
      9011,
      "/",
      13645
    ]
  },
  {
    "id": "21315",
    "description": "corpse,cadaver,carrion",
    "pos": "YELLOW",
    "explanation": "(body + dead)",
    "isCharacter": false,
    "composition": [
      12870,
      "/",
      13645
    ]
  },
  {
    "id": "21316",
    "description": "resurrection",
    "pos": "YELLOW",
    "explanation": "(up + dead: rising from the dead)",
    "isCharacter": false,
    "composition": [
      17983,
      "/",
      13645
    ]
  },
  {
    "id": "21317",
    "description": "ritual",
    "pos": "YELLOW",
    "explanation": "(action + plan + to repeat: plan or procedures repeated over and over)",
    "isCharacter": false,
    "composition": [
      12335,
      "/",
      16194,
      "/",
      24934
    ]
  },
  {
    "id": "21318",
    "description": "perseverance",
    "pos": "YELLOW",
    "explanation": "(action + to repeat + intensity: repeated performance of actions)",
    "isCharacter": false,
    "composition": [
      12335,
      "/",
      24934,
      "/",
      14947
    ]
  },
  {
    "id": "21319",
    "description": "persevere-(to)",
    "pos": "RED",
    "explanation": "(perseverance + action indicator)",
    "isCharacter": false,
    "composition": [
      12335,
      ";",
      8993,
      "/",
      24934,
      "/",
      14947
    ]
  },
  {
    "id": "21320",
    "description": "convert_(belief)-(to)",
    "pos": "RED",
    "explanation": "(conversion + action indicator)",
    "isCharacter": false,
    "composition": [
      13151,
      ";",
      8993,
      "/",
      14164,
      "/",
      "RK:-2",
      "/",
      25574
    ]
  },
  {
    "id": "21321",
    "description": "conversion_(belief)",
    "pos": "YELLOW",
    "explanation": "(change + belief)",
    "isCharacter": false,
    "composition": [
      13151,
      "/",
      14164,
      "/",
      "RK:-2",
      "/",
      25574
    ]
  },
  {
    "id": "21322",
    "description": "fast,go_without_food",
    "pos": "YELLOW",
    "explanation": "(decision + without + food: decision to go without food)",
    "isCharacter": false,
    "composition": [
      13649,
      "/",
      15474,
      "/",
      14377
    ]
  },
  {
    "id": "21323",
    "description": "fast-(to)",
    "pos": "RED",
    "explanation": "(fast + action indicator)",
    "isCharacter": false,
    "composition": [
      13649,
      ";",
      8993,
      "/",
      15474,
      "/",
      14377
    ]
  },
  {
    "id": "21324",
    "description": "Ramadan",
    "pos": "YELLOW",
    "explanation": "(fast + month + Muslim: month of fasting observed by Muslims)",
    "isCharacter": false,
    "composition": [
      13649,
      "/",
      15474,
      "/",
      14377,
      "/",
      15649,
      "/",
      17252,
      "/",
      15651
    ]
  },
  {
    "id": "21325",
    "description": "forefather",
    "pos": "BLUE",
    "explanation": "(father + past)",
    "isCharacter": false,
    "composition": [
      14157,
      "/",
      15975
    ]
  },
  {
    "id": "21326",
    "description": "foremother",
    "pos": "BLUE",
    "explanation": "(mother + past)",
    "isCharacter": false,
    "composition": [
      15662,
      "/",
      15975
    ]
  },
  {
    "id": "21327",
    "description": "ancestor",
    "pos": "BLUE",
    "explanation": "(parent + past)",
    "isCharacter": false,
    "composition": [
      15968,
      "/",
      15975
    ]
  },
  {
    "id": "21328",
    "description": "all_knowing",
    "pos": "GREEN",
    "explanation": "(knowledge + all + description indicator)",
    "isCharacter": false,
    "composition": [
      15162,
      ";",
      8998,
      "/",
      12360
    ]
  },
  {
    "id": "21329",
    "description": "all_powerful",
    "pos": "GREEN",
    "explanation": "(ability + all + description indicator)",
    "isCharacter": false,
    "composition": [
      12322,
      ";",
      8998,
      "/",
      12360
    ]
  },
  {
    "id": "21331",
    "description": "unending,endless",
    "pos": "GREEN",
    "explanation": "(without + end + description indicator)",
    "isCharacter": false,
    "composition": [
      15474,
      "/",
      13935,
      ";",
      8998
    ]
  },
  {
    "id": "21332",
    "description": "eternal_(OLD)",
    "pos": "GREEN",
    "explanation": "(eternity,infinity_(OLD) + description indicator)    SUPERSEDED SYNONYM  See eternal 26000",
    "isCharacter": false,
    "composition": [
      17732,
      ";",
      8998,
      "/",
      15474,
      "/",
      15213
    ]
  },
  {
    "id": "21333",
    "description": "interrogate-(to)",
    "pos": "RED",
    "explanation": "(to ask + intensity + action indicator)",
    "isCharacter": false,
    "composition": [
      16445,
      ";",
      8993,
      "/",
      14947
    ]
  },
  {
    "id": "21334",
    "description": "beg,plead-(to)",
    "pos": "RED",
    "explanation": "(to ask + comma + please + action indicator)",
    "isCharacter": false,
    "composition": [
      16445,
      ";",
      8993,
      "/",
      8487,
      "/",
      14947,
      "/",
      14164
    ]
  },
  {
    "id": "21335",
    "description": "command,order-(to)",
    "pos": "RED",
    "explanation": "(to say + for the purpose of + action + action indicator: to speak with authority)",
    "isCharacter": false,
    "composition": [
      15666,
      ";",
      8993,
      "/",
      14382,
      "/",
      12335
    ]
  },
  {
    "id": "21336",
    "description": "demand-(to)",
    "pos": "RED",
    "explanation": "(to say + to want + intensity + action indicator: to speak or ask with urgency)",
    "isCharacter": false,
    "composition": [
      15666,
      ";",
      8993,
      "/",
      14164,
      "/",
      14183,
      "/",
      14947
    ]
  },
  {
    "id": "21337",
    "description": "proclaim,announce-(to)",
    "pos": "RED",
    "explanation": "(proclamation + action indicator: to make a public announcement)",
    "isCharacter": false,
    "composition": [
      15666,
      ";",
      8993,
      "/",
      24887
    ]
  },
  {
    "id": "21338",
    "description": "proclamation,announcement",
    "pos": "YELLOW",
    "explanation": "(to say + to disseminate: a public announcement)",
    "isCharacter": false,
    "composition": [
      15666,
      "/",
      24887
    ]
  },
  {
    "id": "21339",
    "description": "proclamation_(written)",
    "pos": "YELLOW",
    "explanation": "(paper + proclamation)",
    "isCharacter": false,
    "composition": [
      15962,
      "/",
      15666,
      "/",
      24887
    ]
  },
  {
    "id": "21340",
    "description": "flyer",
    "pos": "YELLOW",
    "explanation": "(paper + to disseminate)",
    "isCharacter": false,
    "composition": [
      15962,
      "/",
      24887
    ]
  },
  {
    "id": "21341",
    "description": "correctness,rightness",
    "pos": "YELLOW",
    "explanation": "(correct_thinking + intensity: a combination of mind and positive)",
    "isCharacter": false,
    "composition": [
      25538,
      "/",
      14947
    ]
  },
  {
    "id": "21342",
    "description": "excellence",
    "pos": "YELLOW",
    "explanation": "(correctness + intensity)",
    "isCharacter": false,
    "composition": [
      25538,
      "/",
      14947,
      "/",
      14947
    ]
  },
  {
    "id": "21343",
    "description": "excellent",
    "pos": "GREEN",
    "explanation": "(excellence + description indicator)",
    "isCharacter": false,
    "composition": [
      25538,
      ";",
      8998,
      "/",
      14947,
      "/",
      14947
    ]
  },
  {
    "id": "21344",
    "description": "perfection",
    "pos": "YELLOW",
    "explanation": "(excellence + intensity)",
    "isCharacter": false,
    "composition": [
      25538,
      "/",
      14947,
      "/",
      14947,
      "/",
      14947
    ]
  },
  {
    "id": "21345",
    "description": "perfect",
    "pos": "GREEN",
    "explanation": "(perfection + description indicator)",
    "isCharacter": false,
    "composition": [
      25538,
      ";",
      8998,
      "/",
      14947,
      "/",
      14947,
      "/",
      14947
    ]
  },
  {
    "id": "21346",
    "description": "evangelise-(to)",
    "pos": "RED",
    "explanation": "(to disseminate + news + positive + action indicator)",
    "isCharacter": false,
    "composition": [
      24887,
      ";",
      8993,
      "/",
      15712,
      "/",
      12374,
      "/",
      14947
    ]
  },
  {
    "id": "21347",
    "description": "evangelise_(christian)-(to)",
    "pos": "RED",
    "explanation": "(to disseminate + news + positive + Christianity [contraction] + action indicator)",
    "isCharacter": false,
    "composition": [
      24887,
      ";",
      8993,
      "/",
      15712,
      "/",
      12374,
      "/",
      14947,
      "/",
      13613
    ]
  },
  {
    "id": "21348",
    "description": "drown-(to)",
    "pos": "RED",
    "explanation": "(drowning + action indicator)",
    "isCharacter": false,
    "composition": [
      13645,
      ";",
      8993,
      "/",
      18209
    ]
  },
  {
    "id": "21349",
    "description": "drown_(cause_to)-(to)",
    "pos": "RED",
    "explanation": "(to cause + drowning + action indicator)",
    "isCharacter": false,
    "composition": [
      13134,
      ";",
      8993,
      "/",
      13645,
      "/",
      18209
    ]
  },
  {
    "id": "21350",
    "description": "desert",
    "pos": "YELLOW",
    "explanation": "(earth + without + water)",
    "isCharacter": false,
    "composition": [
      13901,
      "/",
      15474,
      "/",
      18209
    ]
  },
  {
    "id": "21351",
    "description": "wilderness",
    "pos": "YELLOW",
    "explanation": "(countryside + open/wild)",
    "isCharacter": false,
    "composition": [
      13424,
      "/",
      15923
    ]
  },
  {
    "id": "21352",
    "description": "huge",
    "pos": "GREEN",
    "explanation": "(big + intensity + description indicator)",
    "isCharacter": false,
    "composition": [
      24875,
      ";",
      8998,
      "/",
      14947
    ]
  },
  {
    "id": "21353",
    "description": "enormous",
    "pos": "GREEN",
    "explanation": "(huge + intensity + description indicator)",
    "isCharacter": false,
    "composition": [
      24875,
      ";",
      8998,
      "/",
      14947,
      "/",
      14947
    ]
  },
  {
    "id": "21354",
    "description": "gigantic",
    "pos": "GREEN",
    "explanation": "(enormous + intensity + description indicator)",
    "isCharacter": false,
    "composition": [
      24875,
      ";",
      8998,
      "/",
      14947,
      "/",
      14947,
      "/",
      14947
    ]
  },
  {
    "id": "21355",
    "description": "manna",
    "pos": "YELLOW",
    "explanation": "(food + from_sky: food, or something, provided unexpectedly, as though it had dropped from heaven)",
    "isCharacter": false,
    "composition": [
      14377,
      "/",
      25566
    ]
  },
  {
    "id": "21356",
    "description": "uninhabited",
    "pos": "GREEN",
    "explanation": "(place + without + human being + description indicator)",
    "isCharacter": false,
    "composition": [
      16193,
      ";",
      8998,
      "/",
      15474,
      "/",
      16161
    ]
  },
  {
    "id": "21357",
    "description": "fishnet",
    "pos": "YELLOW",
    "explanation": "(cloth + fish)",
    "isCharacter": false,
    "composition": [
      13365,
      "/",
      14188
    ]
  },
  {
    "id": "21358",
    "description": "incense",
    "pos": "YELLOW",
    "explanation": "(smoke + smell)",
    "isCharacter": false,
    "composition": [
      13367,
      "/",
      14183,
      "/",
      17017
    ]
  },
  {
    "id": "21359",
    "description": "calling,vocation",
    "pos": "YELLOW",
    "explanation": "(life + choice: chosen way of life)",
    "isCharacter": false,
    "composition": [
      15206,
      "/",
      13175
    ]
  },
  {
    "id": "21360",
    "description": "calling,profession,career",
    "pos": "YELLOW",
    "explanation": "(work + choice: chosen work)",
    "isCharacter": false,
    "composition": [
      18273,
      "/",
      13175
    ]
  },
  {
    "id": "21361",
    "description": "nag-(to)",
    "pos": "RED",
    "explanation": "(to say + to repeat + action indicator: to say repeatedly or over and over again)",
    "isCharacter": false,
    "composition": [
      15666,
      ";",
      8993,
      "/",
      24934
    ]
  },
  {
    "id": "21362",
    "description": "oil_lamp",
    "pos": "YELLOW",
    "explanation": "(lamp + oil + thing indicator)",
    "isCharacter": false,
    "composition": [
      15208,
      ";",
      9009,
      "/",
      15914
    ]
  },
  {
    "id": "21363",
    "description": "goblet,wineglass",
    "pos": "YELLOW",
    "explanation": "(pictograph)  - Character",
    "isCharacter": true
  },
  {
    "id": "21364",
    "description": "chalice",
    "pos": "YELLOW",
    "explanation": "(goblet + holy)",
    "isCharacter": false,
    "composition": [
      21363,
      "/",
      21082
    ]
  },
  {
    "id": "21365",
    "description": "ampullae",
    "pos": "YELLOW",
    "explanation": "(two + bottle + holy)",
    "isCharacter": false,
    "composition": [
      8498,
      "/",
      12880,
      "/",
      21082
    ]
  },
  {
    "id": "21366",
    "description": "paten,holy_tray",
    "pos": "YELLOW",
    "explanation": "(plate + holy)",
    "isCharacter": false,
    "composition": [
      13690,
      "/",
      21082
    ]
  },
  {
    "id": "21367",
    "description": "Host,wafer_(in_religious_ceremony)",
    "pos": "YELLOW",
    "explanation": "(bread + holy)",
    "isCharacter": false,
    "composition": [
      12895,
      "/",
      21082
    ]
  },
  {
    "id": "21368",
    "description": "altar",
    "pos": "YELLOW",
    "explanation": "(table + holy)",
    "isCharacter": false,
    "composition": [
      17493,
      "/",
      21082
    ]
  },
  {
    "id": "21369",
    "description": "altar_cloth",
    "pos": "YELLOW",
    "explanation": "(cloth + altar)",
    "isCharacter": false,
    "composition": [
      13365,
      "/",
      17493,
      "/",
      21082
    ]
  },
  {
    "id": "21370",
    "description": "vestment",
    "pos": "YELLOW",
    "explanation": "(clothing + holy)",
    "isCharacter": false,
    "composition": [
      13366,
      "/",
      21082
    ]
  },
  {
    "id": "21371",
    "description": "Christmas_tree",
    "pos": "YELLOW",
    "explanation": "(tree + Christmas [contraction])",
    "isCharacter": false,
    "composition": [
      17775,
      "/",
      12843,
      "/",
      13613
    ]
  },
  {
    "id": "21372",
    "description": "interview",
    "pos": "YELLOW",
    "explanation": "(question + person)",
    "isCharacter": false,
    "composition": [
      16445,
      "/",
      16161
    ]
  },
  {
    "id": "21373",
    "description": "interview-(to)",
    "pos": "RED",
    "explanation": "(interview + action indicator)",
    "isCharacter": false,
    "composition": [
      16445,
      ";",
      8993,
      "/",
      16161
    ]
  },
  {
    "id": "21374",
    "description": "interviewer",
    "pos": "BLUE",
    "explanation": "(person + interview)",
    "isCharacter": false,
    "composition": [
      16161,
      "/",
      16445,
      "/",
      16161
    ]
  },
  {
    "id": "21380",
    "description": "universal,world-wide",
    "pos": "GREEN",
    "explanation": "(world + all + description indicator)",
    "isCharacter": false,
    "composition": [
      18278,
      ";",
      8998,
      "/",
      12360
    ]
  },
  {
    "id": "21381",
    "description": "forgiven",
    "pos": "GREEN",
    "explanation": "(forgiveness + description after the fact indicator)",
    "isCharacter": false,
    "composition": [
      25593,
      ";",
      8996,
      "/",
      12348
    ]
  },
  {
    "id": "21537",
    "description": "sign-(to)",
    "pos": "RED",
    "explanation": "(sign language + action indicator)",
    "isCharacter": false,
    "composition": [
      15172,
      ";",
      8993,
      "/",
      14667
    ]
  },
  {
    "id": "21538",
    "description": "sign_language",
    "pos": "YELLOW",
    "explanation": "(language + hand: language expressed with the hands)",
    "isCharacter": false,
    "composition": [
      15172,
      "/",
      14667
    ]
  },
  {
    "id": "21539",
    "description": "polder_(Dutch)",
    "pos": "YELLOW",
    "explanation": "(earth + dryness: land protected by dykes which has been reclaimed from a body of water)",
    "isCharacter": false,
    "composition": [
      13901,
      "/",
      23859
    ]
  },
  {
    "id": "21540",
    "description": "cell",
    "pos": "YELLOW",
    "explanation": "(pictograph, of circular cell + being_(state_of): the symbol suggests a cell, with the symbol for to live [half-sized] as a cell nucleus in it)  - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "21541",
    "description": "Euro",
    "pos": "YELLOW",
    "explanation": "(international symbol for Euro)  - Character",
    "isCharacter": true
  },
  {
    "id": "21542",
    "description": "astronomy",
    "pos": "YELLOW",
    "explanation": "(science + star: scientific study of the universe beyond the earth)",
    "isCharacter": false,
    "composition": [
      16735,
      "/",
      17252
    ]
  },
  {
    "id": "21543",
    "description": "economics",
    "pos": "YELLOW",
    "explanation": "(science + business: science that deals with the production, distribution and consumption of commodities)",
    "isCharacter": false,
    "composition": [
      16735,
      "/",
      13093
    ]
  },
  {
    "id": "21544",
    "description": "chemistry",
    "pos": "YELLOW",
    "explanation": "(science + chemical product: science of the composition, structure, properties and reactions of matter)",
    "isCharacter": false,
    "composition": [
      16735,
      "/",
      13158
    ]
  },
  {
    "id": "21545",
    "description": "biochemistry",
    "pos": "YELLOW",
    "explanation": "(science + biochemical_product: chemistry of biological substances and processes)",
    "isCharacter": false,
    "composition": [
      16735,
      "/",
      25525
    ]
  },
  {
    "id": "21546",
    "description": "biology",
    "pos": "YELLOW",
    "explanation": "(science + combination of chemical product and life: science of living organisms and life processes)",
    "isCharacter": false,
    "composition": [
      16735,
      "/",
      15206
    ]
  },
  {
    "id": "21547",
    "description": "botany",
    "pos": "YELLOW",
    "explanation": "(science + plant: biological science of plants)",
    "isCharacter": false,
    "composition": [
      16735,
      "/",
      16196
    ]
  },
  {
    "id": "21548",
    "description": "anthropology",
    "pos": "YELLOW",
    "explanation": "(science + human being: scientific study of human beings)",
    "isCharacter": false,
    "composition": [
      16735,
      "/",
      16161
    ]
  },
  {
    "id": "21549",
    "description": "zoology",
    "pos": "YELLOW",
    "explanation": "(science + animal: biological science of animals)",
    "isCharacter": false,
    "composition": [
      16735,
      "/",
      12378
    ]
  },
  {
    "id": "21550",
    "description": "geology",
    "pos": "YELLOW",
    "explanation": "(science + earth: scientific study of the origins, history and structure of the earth)",
    "isCharacter": false,
    "composition": [
      16735,
      "/",
      13901
    ]
  },
  {
    "id": "21551",
    "description": "sociology",
    "pos": "YELLOW",
    "explanation": "(science + life + group: study of human social behaviour)",
    "isCharacter": false,
    "composition": [
      16735,
      "/",
      15206,
      "/",
      14647,
      "/",
      16161
    ]
  },
  {
    "id": "21552",
    "description": "psychology_(OLD)",
    "pos": "YELLOW",
    "explanation": "(science + mind: science of mental processes and behaviour)    SUPERSEDED SYNONYM  See psychology 23183",
    "isCharacter": false,
    "composition": [
      16735,
      "/",
      15471
    ]
  },
  {
    "id": "21553",
    "description": "history",
    "pos": "YELLOW",
    "explanation": "(science + past: study of the past, especially as revealed in recorded materials)",
    "isCharacter": false,
    "composition": [
      16735,
      "/",
      15975
    ]
  },
  {
    "id": "21554",
    "description": "archeology,archaeology",
    "pos": "YELLOW",
    "explanation": "(history + thing: study of physical objects and material evidence from the past)",
    "isCharacter": false,
    "composition": [
      16735,
      "/",
      15975,
      "/",
      17717
    ]
  },
  {
    "id": "21555",
    "description": "meteorology",
    "pos": "YELLOW",
    "explanation": "(science + weather: science dealing with the phenomena of the atmosphere, especially of weather)",
    "isCharacter": false,
    "composition": [
      16735,
      "/",
      18214
    ]
  },
  {
    "id": "21556",
    "description": "physics",
    "pos": "YELLOW",
    "explanation": "(science + energy: science of matter and energy and of interactions between them)",
    "isCharacter": false,
    "composition": [
      16735,
      "/",
      13936
    ]
  },
  {
    "id": "21557",
    "description": "linguistics",
    "pos": "YELLOW",
    "explanation": "(science + language: study of the nature and structure of language)",
    "isCharacter": false,
    "composition": [
      16735,
      "/",
      15172
    ]
  },
  {
    "id": "21558",
    "description": "mathematics,arithmetic,math_(1)",
    "pos": "YELLOW",
    "explanation": "(science + number: study of numbers, their form, arrangement and associated relationships)  SYMBOL SYNONYM",
    "isCharacter": false,
    "composition": [
      16735,
      "/",
      15742
    ]
  },
  {
    "id": "21559",
    "description": "scientist,academic",
    "pos": "BLUE",
    "explanation": "(person + science)",
    "isCharacter": false,
    "composition": [
      16161,
      "/",
      16735
    ]
  },
  {
    "id": "21560",
    "description": "astronomer",
    "pos": "BLUE",
    "explanation": "(person + astronomy)",
    "isCharacter": false,
    "composition": [
      16161,
      "/",
      16735,
      "/",
      17252
    ]
  },
  {
    "id": "21561",
    "description": "economist",
    "pos": "BLUE",
    "explanation": "(person + economics)",
    "isCharacter": false,
    "composition": [
      16161,
      "/",
      16735,
      "/",
      13093
    ]
  },
  {
    "id": "21562",
    "description": "chemist",
    "pos": "BLUE",
    "explanation": "(person + chemistry)",
    "isCharacter": false,
    "composition": [
      16161,
      "/",
      16735,
      "/",
      13158
    ]
  },
  {
    "id": "21563",
    "description": "biochemist",
    "pos": "BLUE",
    "explanation": "(person + biochemistry)",
    "isCharacter": false,
    "composition": [
      16161,
      "/",
      16735,
      "/",
      25525
    ]
  },
  {
    "id": "21564",
    "description": "biologist",
    "pos": "BLUE",
    "explanation": "(person + biology)",
    "isCharacter": false,
    "composition": [
      16161,
      "/",
      16735,
      "/",
      15206
    ]
  },
  {
    "id": "21565",
    "description": "botanist",
    "pos": "BLUE",
    "explanation": "(person + botany)",
    "isCharacter": false,
    "composition": [
      16161,
      "/",
      16735,
      "/",
      16196
    ]
  },
  {
    "id": "21566",
    "description": "zoologist",
    "pos": "BLUE",
    "explanation": "(person + zoology)",
    "isCharacter": false,
    "composition": [
      16161,
      "/",
      16735,
      "/",
      12378
    ]
  },
  {
    "id": "21567",
    "description": "geologist",
    "pos": "BLUE",
    "explanation": "(person + geology)",
    "isCharacter": false,
    "composition": [
      16161,
      "/",
      16735,
      "/",
      13901
    ]
  },
  {
    "id": "21568",
    "description": "sociologist",
    "pos": "BLUE",
    "explanation": "(person + sociology)",
    "isCharacter": false,
    "composition": [
      16161,
      "/",
      16735,
      "/",
      15206,
      "/",
      14647,
      "/",
      16161
    ]
  },
  {
    "id": "21569",
    "description": "historian",
    "pos": "BLUE",
    "explanation": "(person + history)",
    "isCharacter": false,
    "composition": [
      16161,
      "/",
      16735,
      "/",
      15975
    ]
  },
  {
    "id": "21570",
    "description": "archeologist,archaeologist",
    "pos": "BLUE",
    "explanation": "(person + archeology)",
    "isCharacter": false,
    "composition": [
      16161,
      "/",
      16735,
      "/",
      15975,
      "/",
      17717
    ]
  },
  {
    "id": "21571",
    "description": "meteorologist",
    "pos": "BLUE",
    "explanation": "(person + meteorology)",
    "isCharacter": false,
    "composition": [
      16161,
      "/",
      16735,
      "/",
      18214
    ]
  },
  {
    "id": "21572",
    "description": "linguist",
    "pos": "BLUE",
    "explanation": "(person + linguistics)",
    "isCharacter": false,
    "composition": [
      16161,
      "/",
      16735,
      "/",
      15172
    ]
  },
  {
    "id": "21573",
    "description": "mathematician_(academic)",
    "pos": "BLUE",
    "explanation": "(person + mathematics,arithmetic,math_(1))",
    "isCharacter": false,
    "composition": [
      16161,
      "/",
      16735,
      "/",
      15742
    ]
  },
  {
    "id": "21574",
    "description": "pediatrician,paediatrician",
    "pos": "BLUE",
    "explanation": "(doctor + child)",
    "isCharacter": false,
    "composition": [
      16161,
      "/",
      24920,
      "/",
      13166
    ]
  },
  {
    "id": "21575",
    "description": "surgeon",
    "pos": "BLUE",
    "explanation": "(doctor + knife)",
    "isCharacter": false,
    "composition": [
      16161,
      "/",
      24920,
      "/",
      15159
    ]
  },
  {
    "id": "21576",
    "description": "otolaryngologist",
    "pos": "BLUE",
    "explanation": "(doctor + ear + nose + neck_(head): specialist doctor of ear, nose and throat)",
    "isCharacter": false,
    "composition": [
      16161,
      "/",
      24920,
      "/",
      13894,
      "/",
      "RK:-2",
      "/",
      15732,
      "/",
      15699
    ]
  },
  {
    "id": "21577",
    "description": "orthopedist,orthopaedist",
    "pos": "BLUE",
    "explanation": "(doctor + bone)",
    "isCharacter": false,
    "composition": [
      16161,
      "/",
      24920,
      "/",
      12873
    ]
  },
  {
    "id": "21578",
    "description": "ophthalmologist,oculist",
    "pos": "BLUE",
    "explanation": "(doctor + eye)",
    "isCharacter": false,
    "composition": [
      16161,
      "/",
      24920,
      "/",
      14133
    ]
  },
  {
    "id": "21579",
    "description": "doctor_(rehab,hab)",
    "pos": "BLUE",
    "explanation": "(doctor + to advance + ability: physician who works to improve or restore physical abilities)",
    "isCharacter": false,
    "composition": [
      16161,
      "/",
      24920,
      "/",
      14390,
      "/",
      12322
    ]
  },
  {
    "id": "21580",
    "description": "gynecologist,gynaecologist",
    "pos": "BLUE",
    "explanation": "(doctor + woman: physician who diagnoses and treats female reproduction organs)",
    "isCharacter": false,
    "composition": [
      16161,
      "/",
      24920,
      "/",
      18269
    ]
  },
  {
    "id": "21581",
    "description": "general_practitioner",
    "pos": "BLUE",
    "explanation": "(doctor + generalization: physician who treats a variety of medical problems)",
    "isCharacter": false,
    "composition": [
      16161,
      "/",
      24920,
      "/",
      14430
    ]
  },
  {
    "id": "21582",
    "description": "cardiologist",
    "pos": "BLUE",
    "explanation": "(doctor + heart + thing indicator: physician who diagnoses and treats disorders of the heart)",
    "isCharacter": false,
    "composition": [
      16161,
      "/",
      24920,
      "/",
      14164,
      ";",
      9009
    ]
  },
  {
    "id": "21583",
    "description": "neurologist",
    "pos": "BLUE",
    "explanation": "(doctor + central nervous system + thing indicator: physician who diagnoses and treats disorders of the nervous system)",
    "isCharacter": false,
    "composition": [
      16161,
      "/",
      24920,
      "/",
      25434,
      ";",
      9009
    ]
  },
  {
    "id": "21584",
    "description": "psychiatrist",
    "pos": "BLUE",
    "explanation": "(doctor + mind: physician who diagnoses and treats mental illness)",
    "isCharacter": false,
    "composition": [
      16161,
      "/",
      24920,
      "/",
      15471
    ]
  },
  {
    "id": "21585",
    "description": "central_nervous_system,CNS",
    "pos": "YELLOW",
    "explanation": "(brain_signal + thing indicator: system consisting of brain and spinal cord which is activated by electrical impulses)  - (character with thing indicator)",
    "isCharacter": "false",
    "composition": [
      25434,
      ";",
      9009
    ]
  },
  {
    "id": "21586",
    "description": "psychologist_(researcher)_(OLD)",
    "pos": "BLUE",
    "explanation": "(person + psychology_(OLD))  SUPERSEDED SYNONYM  See psychologist_(researcher) 23182",
    "isCharacter": false,
    "composition": [
      16161,
      "/",
      16735,
      "/",
      15471
    ]
  },
  {
    "id": "21587",
    "description": "psychologist_(OLD)",
    "pos": "BLUE",
    "explanation": "(person + knowledge + mind)  SUPERSEDED SYNONYM  See psychologist 23181",
    "isCharacter": false,
    "composition": [
      16161,
      "/",
      15162,
      "/",
      15471
    ]
  },
  {
    "id": "21588",
    "description": "psychology_teacher_(OLD)",
    "pos": "BLUE",
    "explanation": "(teacher + mind)  SUPERSEDED SYNONYM  See psychology_teacher 23184",
    "isCharacter": false,
    "composition": [
      16161,
      "/",
      24903,
      "/",
      15162,
      "/",
      15471
    ]
  },
  {
    "id": "21589",
    "description": "therapy",
    "pos": "YELLOW",
    "explanation": "(need_(needy_person) + need [modification, mirrored]: mutual aid) - Character (superimposed - modified)",
    "isCharacter": true
  },
  {
    "id": "21590",
    "description": "speech_therapist",
    "pos": "BLUE",
    "explanation": "(therapist + language)",
    "isCharacter": false,
    "composition": [
      16161,
      "/",
      21589,
      "/",
      15172
    ]
  },
  {
    "id": "21591",
    "description": "occupational_therapist",
    "pos": "BLUE",
    "explanation": "(therapist + activity)",
    "isCharacter": false,
    "composition": [
      16161,
      "/",
      21589,
      "/",
      12335
    ]
  },
  {
    "id": "21592",
    "description": "physiotherapist",
    "pos": "BLUE",
    "explanation": "(therapist + muscle)",
    "isCharacter": false,
    "composition": [
      16161,
      "/",
      21589,
      "/",
      20517
    ]
  },
  {
    "id": "21593",
    "description": "audiologist",
    "pos": "BLUE",
    "explanation": "(therapist + ear [hearing])",
    "isCharacter": false,
    "composition": [
      16161,
      "/",
      21589,
      "/",
      13894
    ]
  },
  {
    "id": "21594",
    "description": "orthoptist",
    "pos": "BLUE",
    "explanation": "(therapist + eye [vision])",
    "isCharacter": false,
    "composition": [
      16161,
      "/",
      21589,
      "/",
      14133
    ]
  },
  {
    "id": "21595",
    "description": "communication_therapist",
    "pos": "BLUE",
    "explanation": "(therapist + communication)",
    "isCharacter": false,
    "composition": [
      16161,
      "/",
      21589,
      "/",
      25555,
      "/",
      15441
    ]
  },
  {
    "id": "21596",
    "description": "podiatrist,chiropodist",
    "pos": "BLUE",
    "explanation": "(therapist + foot)",
    "isCharacter": false,
    "composition": [
      16161,
      "/",
      21589,
      "/",
      14379
    ]
  },
  {
    "id": "21597",
    "description": "hydrotherapist",
    "pos": "BLUE",
    "explanation": "(therapist + water)",
    "isCharacter": false,
    "composition": [
      16161,
      "/",
      21589,
      "/",
      18209
    ]
  },
  {
    "id": "21598",
    "description": "music_therapist",
    "pos": "BLUE",
    "explanation": "(therapist + music)",
    "isCharacter": false,
    "composition": [
      16161,
      "/",
      21589,
      "/",
      13894,
      "/",
      15682
    ]
  },
  {
    "id": "21599",
    "description": "dance_therapist",
    "pos": "BLUE",
    "explanation": "(therapist + dance)",
    "isCharacter": false,
    "composition": [
      16161,
      "/",
      21589,
      "/",
      15189,
      "/",
      15682
    ]
  },
  {
    "id": "21600",
    "description": "osteopath",
    "pos": "BLUE",
    "explanation": "(person + hand + bone: person who treats medical disorders by manipulation techniques)",
    "isCharacter": false,
    "composition": [
      16161,
      "/",
      14667,
      "/",
      12873
    ]
  },
  {
    "id": "21601",
    "description": "chiropractor",
    "pos": "BLUE",
    "explanation": "(person + hand + joint: person who treats medical disorders by manipulation of the spinal column and other structures)",
    "isCharacter": false,
    "composition": [
      16161,
      "/",
      14667,
      "/",
      14973
    ]
  },
  {
    "id": "21602",
    "description": "masseur",
    "pos": "BLUE",
    "explanation": "(person + hand + muscle: person who manipulates the body to relax muscles)",
    "isCharacter": false,
    "composition": [
      16161,
      "/",
      14667,
      "/",
      20517
    ]
  },
  {
    "id": "21603",
    "description": "aroma_therapist",
    "pos": "BLUE",
    "explanation": "(person + hand + smell: person who gives therapy, based of different scents)",
    "isCharacter": false,
    "composition": [
      16161,
      "/",
      14667,
      "/",
      17017
    ]
  },
  {
    "id": "21604",
    "description": "reflexologist",
    "pos": "BLUE",
    "explanation": "(person + hand + foot: person who gives therapy, based on manipulation of different zones of the foot)",
    "isCharacter": false,
    "composition": [
      16161,
      "/",
      14667,
      "/",
      14379
    ]
  },
  {
    "id": "21605",
    "description": "acupuncturist",
    "pos": "BLUE",
    "explanation": "(person + hand + linear thing + thing indicator: person who treats illness by puncturing the body with needles)",
    "isCharacter": false,
    "composition": [
      16161,
      "/",
      14667,
      "/",
      15214,
      ";",
      9009
    ]
  },
  {
    "id": "21606",
    "description": "massage",
    "pos": "YELLOW",
    "explanation": "(action + hand + muscle: manipulation of the body to relax muscles)",
    "isCharacter": false,
    "composition": [
      12335,
      "/",
      "RK:-2",
      "/",
      14667,
      "/",
      20517
    ]
  },
  {
    "id": "21607",
    "description": "view_of_life",
    "pos": "YELLOW",
    "explanation": "(mind + activity: how people think or act)  - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "21608",
    "description": "culture",
    "pos": "YELLOW",
    "explanation": "(view of life + group: view of life shared by a group of people)",
    "isCharacter": false,
    "composition": [
      21607,
      "/",
      14647,
      "/",
      16161
    ]
  },
  {
    "id": "21609",
    "description": "people,tribe,clan,folk",
    "pos": "YELLOW",
    "explanation": "(group + view of life: group of people who share a common culture)",
    "isCharacter": false,
    "composition": [
      14647,
      "/",
      16161,
      "/",
      21607
    ]
  },
  {
    "id": "21610",
    "description": "nation",
    "pos": "YELLOW",
    "explanation": "(group + country: group of people organized under a single government)",
    "isCharacter": false,
    "composition": [
      14647,
      "/",
      16161,
      "/",
      13423
    ]
  },
  {
    "id": "21611",
    "description": "folk_music",
    "pos": "YELLOW",
    "explanation": "(music + culture)",
    "isCharacter": false,
    "composition": [
      13894,
      "/",
      15682,
      "/",
      21607,
      "/",
      14647,
      "/",
      16161
    ]
  },
  {
    "id": "21612",
    "description": "genocide,holocaust",
    "pos": "YELLOW",
    "explanation": "(destruction + people: systematic annihilation of a racial, political or cultural group)",
    "isCharacter": false,
    "composition": [
      24883,
      "/",
      14647,
      "/",
      16161,
      "/",
      21607
    ]
  },
  {
    "id": "21613",
    "description": "headscarf",
    "pos": "YELLOW",
    "explanation": "(clothing + head)",
    "isCharacter": false,
    "composition": [
      13366,
      "/",
      14689
    ]
  },
  {
    "id": "21614",
    "description": "veil",
    "pos": "YELLOW",
    "explanation": "(clothing + face)",
    "isCharacter": false,
    "composition": [
      13366,
      "/",
      14138
    ]
  },
  {
    "id": "21615",
    "description": "helmet",
    "pos": "YELLOW",
    "explanation": "(protection + intensity + head: strong protection for the head)  Preferred NEW SYNONYM, replacing 14703",
    "isCharacter": false,
    "composition": [
      16420,
      "/",
      14947,
      "/",
      14689
    ]
  },
  {
    "id": "21616",
    "description": "riding_helmet",
    "pos": "YELLOW",
    "explanation": "(helmet + horse: helmet worn when riding a horse)",
    "isCharacter": false,
    "composition": [
      16420,
      "/",
      14947,
      "/",
      14689,
      "/",
      14897
    ]
  },
  {
    "id": "21617",
    "description": "hockey_helmet",
    "pos": "YELLOW",
    "explanation": "(helmet + sport_stick_and_puck,hockey_stick (ice hockey [contraction]))",
    "isCharacter": false,
    "composition": [
      16420,
      "/",
      14947,
      "/",
      14689,
      "/",
      25619
    ]
  },
  {
    "id": "21618",
    "description": "bicycle_helmet,crash_helmet",
    "pos": "YELLOW",
    "explanation": "(helmet + bicycle)",
    "isCharacter": false,
    "composition": [
      16420,
      "/",
      14947,
      "/",
      14689,
      "/",
      8498,
      "/",
      18232
    ]
  },
  {
    "id": "21619",
    "description": "knee_pad",
    "pos": "YELLOW",
    "explanation": "(protection + intensity + knee)",
    "isCharacter": false,
    "composition": [
      16420,
      "/",
      14947,
      "/",
      15157
    ]
  },
  {
    "id": "21620",
    "description": "elbow_pad",
    "pos": "YELLOW",
    "explanation": "(protection + intensity + elbow)",
    "isCharacter": false,
    "composition": [
      16420,
      "/",
      14947,
      "/",
      13916
    ]
  },
  {
    "id": "21621",
    "description": "protective_mask",
    "pos": "YELLOW",
    "explanation": "(protection + intensity + face)",
    "isCharacter": false,
    "composition": [
      16420,
      "/",
      14947,
      "/",
      14138
    ]
  },
  {
    "id": "21622",
    "description": "suit_of_armour",
    "pos": "YELLOW",
    "explanation": "(protection + intensity + body)",
    "isCharacter": false,
    "composition": [
      16420,
      "/",
      14947,
      "/",
      12870
    ]
  },
  {
    "id": "21623",
    "description": "cap",
    "pos": "YELLOW",
    "explanation": "(pictograph)  - Character",
    "isCharacter": true
  },
  {
    "id": "21624",
    "description": "bliss-name",
    "pos": "YELLOW",
    "explanation": "(name + Blissymbol: combination of name and Blissymbol)  - Character (superimposed - combined)",
    "isCharacter": true
  },
  {
    "id": "21625",
    "description": "ball_sports",
    "pos": "YELLOW",
    "explanation": "(sport + ball)",
    "isCharacter": false,
    "composition": [
      20518,
      "/",
      12621
    ]
  },
  {
    "id": "21626",
    "description": "water_sports",
    "pos": "YELLOW",
    "explanation": "(sport + water)",
    "isCharacter": false,
    "composition": [
      20518,
      "/",
      18209
    ]
  },
  {
    "id": "21627",
    "description": "contact_sports",
    "pos": "YELLOW",
    "explanation": "(sport + fight)",
    "isCharacter": false,
    "composition": [
      20518,
      "/",
      24855
    ]
  },
  {
    "id": "21628",
    "description": "athletics",
    "pos": "YELLOW",
    "explanation": "(sport + beginning: the original sports/contests)",
    "isCharacter": false,
    "composition": [
      20518,
      "/",
      12658
    ]
  },
  {
    "id": "21629",
    "description": "equestrian_sports",
    "pos": "YELLOW",
    "explanation": "(sport + horse)",
    "isCharacter": false,
    "composition": [
      20518,
      "/",
      14897
    ]
  },
  {
    "id": "21630",
    "description": "winter_sports",
    "pos": "YELLOW",
    "explanation": "(sport + snow)",
    "isCharacter": false,
    "composition": [
      20518,
      "/",
      17192
    ]
  },
  {
    "id": "21794",
    "description": "motor_sports",
    "pos": "YELLOW",
    "explanation": "(sport + motor)",
    "isCharacter": false,
    "composition": [
      20518,
      "/",
      15406
    ]
  },
  {
    "id": "21795",
    "description": "mountain_sports",
    "pos": "YELLOW",
    "explanation": "(sport + mountain)",
    "isCharacter": false,
    "composition": [
      20518,
      "/",
      15663
    ]
  },
  {
    "id": "21796",
    "description": "sky_sports",
    "pos": "YELLOW",
    "explanation": "(sport + sky)",
    "isCharacter": false,
    "composition": [
      20518,
      "/",
      17006
    ]
  },
  {
    "id": "21797",
    "description": "shooting_sports",
    "pos": "YELLOW",
    "explanation": "(sport + gun)",
    "isCharacter": false,
    "composition": [
      20518,
      "/",
      14655
    ]
  },
  {
    "id": "21798",
    "description": "gymnastics",
    "pos": "YELLOW",
    "explanation": "(sport + muscle + design: sport in which movements are carefully planned)",
    "isCharacter": false,
    "composition": [
      20518,
      "/",
      20517,
      "/",
      16194
    ]
  },
  {
    "id": "21799",
    "description": "mind_sports",
    "pos": "YELLOW",
    "explanation": "(sport + mind)",
    "isCharacter": false,
    "composition": [
      20518,
      "/",
      15471
    ]
  },
  {
    "id": "21800",
    "description": "table_sports",
    "pos": "YELLOW",
    "explanation": "(sport + table)",
    "isCharacter": false,
    "composition": [
      20518,
      "/",
      17493
    ]
  },
  {
    "id": "21801",
    "description": "boating",
    "pos": "YELLOW",
    "explanation": "(sport + boat)",
    "isCharacter": false,
    "composition": [
      20518,
      "/",
      12869
    ]
  },
  {
    "id": "21803",
    "description": "stickball",
    "pos": "YELLOW",
    "explanation": "(sport + ball + linear thing (bat [contraction]) + thing indicator)",
    "isCharacter": false,
    "composition": [
      20518,
      "/",
      12621,
      "/",
      15214,
      ";",
      9009
    ]
  },
  {
    "id": "21804",
    "description": "volleyball",
    "pos": "YELLOW",
    "explanation": "(sport + ball + to hit)",
    "isCharacter": false,
    "composition": [
      20518,
      "/",
      12621,
      "/",
      14667,
      "/",
      14947,
      "/",
      14947
    ]
  },
  {
    "id": "21805",
    "description": "water_polo",
    "pos": "YELLOW",
    "explanation": "(sport + ball + water)",
    "isCharacter": false,
    "composition": [
      20518,
      "/",
      12621,
      "/",
      18209
    ]
  },
  {
    "id": "21806",
    "description": "boules,boccia_(sport)",
    "pos": "YELLOW",
    "explanation": "(sport + ball_field + measurement)",
    "isCharacter": false,
    "composition": [
      20518,
      "/",
      25524,
      "/",
      15443
    ]
  },
  {
    "id": "21807",
    "description": "rugby_ball,football_(N.A.)",
    "pos": "YELLOW",
    "explanation": "(pictograph)  - Character",
    "isCharacter": true
  },
  {
    "id": "21808",
    "description": "cricket",
    "pos": "YELLOW",
    "explanation": "(sport + ball + wicket)",
    "isCharacter": false,
    "composition": [
      20518,
      "/",
      12621,
      "/",
      21809
    ]
  },
  {
    "id": "21809",
    "description": "wicket",
    "pos": "YELLOW",
    "explanation": "(pictograph)  - Character",
    "isCharacter": true
  },
  {
    "id": "21810",
    "description": "motorcycle,scooter",
    "pos": "YELLOW",
    "explanation": "(bicycle + motor)",
    "isCharacter": false,
    "composition": [
      8498,
      "/",
      18232,
      "/",
      15406
    ]
  },
  {
    "id": "21811",
    "description": "scooter",
    "pos": "YELLOW",
    "explanation": "(bicycle + legs and feet: bicycle operated with legs and feet)  Vehicles have different names in different countries.",
    "isCharacter": false,
    "composition": [
      8498,
      "/",
      18232,
      "/",
      15189
    ]
  },
  {
    "id": "21812",
    "description": "scooter_(3_wheeled_electric)",
    "pos": "YELLOW",
    "explanation": "(tricycle + electricity) Vehicles have different names in different countries.",
    "isCharacter": false,
    "composition": [
      8499,
      "/",
      18232,
      "/",
      13918
    ]
  },
  {
    "id": "21813",
    "description": "prone_board,scooter-board",
    "pos": "YELLOW",
    "explanation": "(vehicle [modification, horizontal line replaced by board] + board [modification, higer position] (combination)) Vehicles have different names in different countries.  - Character (superimposed - modified - combined)",
    "isCharacter": true
  },
  {
    "id": "21814",
    "description": "handcycle",
    "pos": "YELLOW",
    "explanation": "(bicycle + hand: bicycle operated with the hands)",
    "isCharacter": false,
    "composition": [
      8498,
      "/",
      18232,
      "/",
      14667
    ]
  },
  {
    "id": "21815",
    "description": "recumbent_bicycle",
    "pos": "YELLOW",
    "explanation": "(bicycle + reclining,lying_(person_lying_down))",
    "isCharacter": false,
    "composition": [
      8498,
      "/",
      18232,
      "/",
      16163
    ]
  },
  {
    "id": "21816",
    "description": "tandem_bicycle",
    "pos": "YELLOW",
    "explanation": "(bicycle + two + person)",
    "isCharacter": false,
    "composition": [
      8498,
      "/",
      18232,
      "/",
      8498,
      "/",
      16161
    ]
  },
  {
    "id": "21817",
    "description": "mountain_bike",
    "pos": "YELLOW",
    "explanation": "(bicycle + mountain)",
    "isCharacter": false,
    "composition": [
      8498,
      "/",
      18232,
      "/",
      15663
    ]
  },
  {
    "id": "21818",
    "description": "ATB,all-terrain_bike",
    "pos": "YELLOW",
    "explanation": "(bicycle + countryside)",
    "isCharacter": false,
    "composition": [
      8498,
      "/",
      18232,
      "/",
      13424
    ]
  },
  {
    "id": "21819",
    "description": "wheelchair_bike",
    "pos": "YELLOW",
    "explanation": "(bicycle + wheelchair)",
    "isCharacter": false,
    "composition": [
      8498,
      "/",
      18232,
      "/",
      18233
    ]
  },
  {
    "id": "21820",
    "description": "stander_(wheeled)",
    "pos": "YELLOW",
    "explanation": "(wheel + standing_(standing_person))  - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "21821",
    "description": "sidecar_(motorcycle)",
    "pos": "YELLOW",
    "explanation": "(plus + transport,transportation (cart [modification]): a car added to another vehicle)",
    "isCharacter": false,
    "composition": [
      12374,
      "/",
      25625
    ]
  },
  {
    "id": "21822",
    "description": "go-kart,kart",
    "pos": "YELLOW",
    "explanation": "(car + small)",
    "isCharacter": false,
    "composition": [
      13121,
      "/",
      24917
    ]
  },
  {
    "id": "21823",
    "description": "cycling",
    "pos": "YELLOW",
    "explanation": "(sport + bicycle)",
    "isCharacter": false,
    "composition": [
      20518,
      "/",
      8498,
      "/",
      18232
    ]
  },
  {
    "id": "21824",
    "description": "speed_cycling",
    "pos": "YELLOW",
    "explanation": "(sport + bicycle + fast)",
    "isCharacter": false,
    "composition": [
      20518,
      "/",
      8498,
      "/",
      18232,
      "/",
      14390,
      "/",
      14947
    ]
  },
  {
    "id": "21825",
    "description": "mountain_biking",
    "pos": "YELLOW",
    "explanation": "(sport + mountain bike)",
    "isCharacter": false,
    "composition": [
      20518,
      "/",
      8498,
      "/",
      18232,
      "/",
      15663
    ]
  },
  {
    "id": "21826",
    "description": "motorcycling,motocross",
    "pos": "YELLOW",
    "explanation": "(sport + motorcycle)",
    "isCharacter": false,
    "composition": [
      20518,
      "/",
      8498,
      "/",
      18232,
      "/",
      15406
    ]
  },
  {
    "id": "21827",
    "description": "motorcycle_racing",
    "pos": "YELLOW",
    "explanation": "(sport + motorcycle + fast)",
    "isCharacter": false,
    "composition": [
      20518,
      "/",
      8498,
      "/",
      18232,
      "/",
      15406,
      "/",
      14390,
      "/",
      14947
    ]
  },
  {
    "id": "21828",
    "description": "sidecar_(motorcycle_sport)",
    "pos": "YELLOW",
    "explanation": "(sport + motorcycle + side car)",
    "isCharacter": false,
    "composition": [
      20518,
      "/",
      8498,
      "/",
      18232,
      "/",
      15406,
      "/",
      12374,
      "/",
      25625
    ]
  },
  {
    "id": "21829",
    "description": "car_racing,auto_racing",
    "pos": "YELLOW",
    "explanation": "(sport + car)",
    "isCharacter": false,
    "composition": [
      20518,
      "/",
      13121
    ]
  },
  {
    "id": "21830",
    "description": "Formula_One,NASCAR_Kart",
    "pos": "YELLOW",
    "explanation": "(sport + car + fast)",
    "isCharacter": false,
    "composition": [
      20518,
      "/",
      13121,
      "/",
      14390,
      "/",
      14947
    ]
  },
  {
    "id": "21831",
    "description": "kart_racing,karting,go-karting",
    "pos": "YELLOW",
    "explanation": "(sport + car + small)",
    "isCharacter": false,
    "composition": [
      20518,
      "/",
      13121,
      "/",
      24917
    ]
  },
  {
    "id": "21832",
    "description": "cycle,ride_a_bike-(to)",
    "pos": "RED",
    "explanation": "(bicycle + action indicator)",
    "isCharacter": false,
    "composition": [
      8498,
      "/",
      18232,
      ";",
      8993
    ]
  },
  {
    "id": "21833",
    "description": "go_by_car-(to)",
    "pos": "RED",
    "explanation": "(ride + car + action indicator)",
    "isCharacter": false,
    "composition": [
      25603,
      ";",
      8993,
      "/",
      13121
    ]
  },
  {
    "id": "21834",
    "description": "go_by_airplane,fly-(to)",
    "pos": "RED",
    "explanation": "(ride + airplane + action indicator)",
    "isCharacter": false,
    "composition": [
      25603,
      ";",
      8993,
      "/",
      12357
    ]
  },
  {
    "id": "21835",
    "description": "go_by_horse-(to)",
    "pos": "RED",
    "explanation": "(ride + horse + action indicator)",
    "isCharacter": false,
    "composition": [
      25603,
      ";",
      8993,
      "/",
      14897
    ]
  },
  {
    "id": "21836",
    "description": "ride_(horse)-(to)",
    "pos": "RED",
    "explanation": "(riding,horseback_riding + action indicator)",
    "isCharacter": false,
    "composition": [
      12335,
      ";",
      8993,
      "/",
      14897
    ]
  },
  {
    "id": "21837",
    "description": "fencing",
    "pos": "YELLOW",
    "explanation": "(sport + fight + sword)",
    "isCharacter": false,
    "composition": [
      20518,
      "/",
      24855,
      "/",
      15159
    ]
  },
  {
    "id": "21838",
    "description": "martial_arts",
    "pos": "YELLOW",
    "explanation": "(sport + fight + east)",
    "isCharacter": false,
    "composition": [
      20518,
      "/",
      24855,
      "/",
      13902
    ]
  },
  {
    "id": "21839",
    "description": "running",
    "pos": "YELLOW",
    "explanation": "(sport + legs and feet + fast)",
    "isCharacter": false,
    "composition": [
      20518,
      "/",
      15189,
      "/",
      14390,
      "/",
      14947
    ]
  },
  {
    "id": "21840",
    "description": "hurdles",
    "pos": "YELLOW",
    "explanation": "(running + jump)",
    "isCharacter": false,
    "composition": [
      20518,
      "/",
      15189,
      "/",
      14390,
      "/",
      14947,
      "/",
      23550
    ]
  },
  {
    "id": "21841",
    "description": "relay",
    "pos": "YELLOW",
    "explanation": "(to stop + to start)  - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "21842",
    "description": "relay_(sport)",
    "pos": "YELLOW",
    "explanation": "(sport + relay)",
    "isCharacter": false,
    "composition": [
      20518,
      "/",
      21841
    ]
  },
  {
    "id": "21843",
    "description": "high_jump",
    "pos": "YELLOW",
    "explanation": "(sport + to jump + high)",
    "isCharacter": false,
    "composition": [
      20518,
      "/",
      23550,
      "/",
      24909
    ]
  },
  {
    "id": "21844",
    "description": "pole_vaulting",
    "pos": "YELLOW",
    "explanation": "(sport + to jump + high + linear thing + thing indicator)",
    "isCharacter": false,
    "composition": [
      20518,
      "/",
      23550,
      "/",
      24909,
      "/",
      15214,
      ";",
      9009
    ]
  },
  {
    "id": "21845",
    "description": "long_jump_(OLD)",
    "pos": "YELLOW",
    "explanation": "(sport + jump + far,distant_(OLD))  SUPERSEDED SYNONYM  See long_jump_(sport) 26017",
    "isCharacter": false,
    "composition": [
      20518,
      "/",
      23550,
      "/",
      24896
    ]
  },
  {
    "id": "21846",
    "description": "shot_put",
    "pos": "YELLOW",
    "explanation": "(sport + ball + metal [contraction])",
    "isCharacter": false,
    "composition": [
      20518,
      "/",
      12621,
      "/",
      23150
    ]
  },
  {
    "id": "21847",
    "description": "discus",
    "pos": "YELLOW",
    "explanation": "(sport + disc)",
    "isCharacter": false,
    "composition": [
      20518,
      "/",
      13685
    ]
  },
  {
    "id": "21848",
    "description": "hammer_throw",
    "pos": "YELLOW",
    "explanation": "(sport + ball + chain)",
    "isCharacter": false,
    "composition": [
      20518,
      "/",
      12621,
      "/",
      21849
    ]
  },
  {
    "id": "21849",
    "description": "chain",
    "pos": "YELLOW",
    "explanation": "(pictograph)  - Character",
    "isCharacter": true
  },
  {
    "id": "21850",
    "description": "dart",
    "pos": "YELLOW",
    "explanation": "(arrow + small + thing indicator)",
    "isCharacter": false,
    "composition": [
      14390,
      ";",
      9009,
      "/",
      24917
    ]
  },
  {
    "id": "21851",
    "description": "javelin_throw",
    "pos": "YELLOW",
    "explanation": "(sport + javelin + thing indicator)",
    "isCharacter": false,
    "composition": [
      20518,
      "/",
      14390,
      ";",
      9009,
      "/",
      24875
    ]
  },
  {
    "id": "21852",
    "description": "arrow",
    "pos": "YELLOW",
    "explanation": "(forward + thing indicator)  - (character with thing indicator)",
    "isCharacter": "false",
    "composition": [
      14390,
      ";",
      9009
    ]
  },
  {
    "id": "21853",
    "description": "darts",
    "pos": "YELLOW",
    "explanation": "(sport + dart + thing indicator)",
    "isCharacter": false,
    "composition": [
      20518,
      "/",
      14390,
      ";",
      9009,
      "/",
      24917
    ]
  },
  {
    "id": "21854",
    "description": "javelin,spear",
    "pos": "YELLOW",
    "explanation": "(arrow + big + thing indicator)",
    "isCharacter": false,
    "composition": [
      14390,
      ";",
      9009,
      "/",
      24875
    ]
  },
  {
    "id": "21855",
    "description": "bow_and_arrow",
    "pos": "YELLOW",
    "explanation": "(curve,curved_line + forward: pictograph, suggesting a bow and arrow)  - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "21856",
    "description": "archery",
    "pos": "YELLOW",
    "explanation": "(sport + bow and arrow)",
    "isCharacter": false,
    "composition": [
      20518,
      "/",
      21855
    ]
  },
  {
    "id": "21857",
    "description": "multi-sport_event",
    "pos": "YELLOW",
    "explanation": "(sport + many + activity)  Many can be replaced by an appropriate number.",
    "isCharacter": false,
    "composition": [
      20518,
      "/",
      14647,
      "/",
      12335
    ]
  },
  {
    "id": "21858",
    "description": "triathlon",
    "pos": "YELLOW",
    "explanation": "(sport + three + activity)",
    "isCharacter": false,
    "composition": [
      20518,
      "/",
      8499,
      "/",
      12335
    ]
  },
  {
    "id": "21859",
    "description": "weight_lifting",
    "pos": "YELLOW",
    "explanation": "(sport + weight + thing indicator)",
    "isCharacter": false,
    "composition": [
      20518,
      "/",
      18221,
      ";",
      9009
    ]
  },
  {
    "id": "21860",
    "description": "skating",
    "pos": "YELLOW",
    "explanation": "(sport + ice skates)",
    "isCharacter": false,
    "composition": [
      20518,
      "/",
      14924
    ]
  },
  {
    "id": "21861",
    "description": "speed_skating",
    "pos": "YELLOW",
    "explanation": "(sport + ice skates + fast)",
    "isCharacter": false,
    "composition": [
      20518,
      "/",
      14924,
      "/",
      14390,
      "/",
      14947
    ]
  },
  {
    "id": "21862",
    "description": "figure_skating",
    "pos": "YELLOW",
    "explanation": "(sport + ice skates + design)",
    "isCharacter": false,
    "composition": [
      20518,
      "/",
      14924,
      "/",
      16194
    ]
  },
  {
    "id": "21863",
    "description": "slalom",
    "pos": "YELLOW",
    "explanation": "(sport + skis + to turn)",
    "isCharacter": false,
    "composition": [
      20518,
      "/",
      8498,
      "/",
      25610,
      "/",
      25627
    ]
  },
  {
    "id": "21864",
    "description": "downhill_skiing",
    "pos": "YELLOW",
    "explanation": "(sport + skis + downward/forward)",
    "isCharacter": false,
    "composition": [
      20518,
      "/",
      8498,
      "/",
      25610,
      "/",
      13871
    ]
  },
  {
    "id": "21865",
    "description": "cross_country_skiing",
    "pos": "YELLOW",
    "explanation": "(sport + skis + forward)",
    "isCharacter": false,
    "composition": [
      20518,
      "/",
      8498,
      "/",
      25610,
      "/",
      14390
    ]
  },
  {
    "id": "21866",
    "description": "ski_jumping",
    "pos": "YELLOW",
    "explanation": "(sport + skis + to jump)",
    "isCharacter": false,
    "composition": [
      20518,
      "/",
      8498,
      "/",
      25610,
      "/",
      23550
    ]
  },
  {
    "id": "21867",
    "description": "freestyle_skiing",
    "pos": "YELLOW",
    "explanation": "(sport + skis + design)",
    "isCharacter": false,
    "composition": [
      20518,
      "/",
      8498,
      "/",
      25610,
      "/",
      16194
    ]
  },
  {
    "id": "21868",
    "description": "snowboarding",
    "pos": "YELLOW",
    "explanation": "(sport + snowboard)",
    "isCharacter": false,
    "composition": [
      20518,
      "/",
      20599,
      "/",
      17192
    ]
  },
  {
    "id": "21869",
    "description": "snowboard",
    "pos": "YELLOW",
    "explanation": "(board + snow)",
    "isCharacter": false,
    "composition": [
      20599,
      "/",
      17192
    ]
  },
  {
    "id": "21870",
    "description": "sled_sport",
    "pos": "YELLOW",
    "explanation": "(sport + sled)",
    "isCharacter": false,
    "composition": [
      20518,
      "/",
      17007
    ]
  },
  {
    "id": "21871",
    "description": "toboggan",
    "pos": "YELLOW",
    "explanation": "(sled + small)",
    "isCharacter": false,
    "composition": [
      17007,
      "/",
      24917
    ]
  },
  {
    "id": "21872",
    "description": "bobsleigh",
    "pos": "YELLOW",
    "explanation": "(sled + big)",
    "isCharacter": false,
    "composition": [
      17007,
      "/",
      24875
    ]
  },
  {
    "id": "21873",
    "description": "horse_sled,horse-drawn_sleigh",
    "pos": "YELLOW",
    "explanation": "(sled + horse)",
    "isCharacter": false,
    "composition": [
      17007,
      "/",
      14897
    ]
  },
  {
    "id": "21874",
    "description": "dog_sled",
    "pos": "YELLOW",
    "explanation": "(sled + dog)",
    "isCharacter": false,
    "composition": [
      17007,
      "/",
      12380
    ]
  },
  {
    "id": "21875",
    "description": "horse_sled_sport",
    "pos": "YELLOW",
    "explanation": "(sport + horse sled)",
    "isCharacter": false,
    "composition": [
      20518,
      "/",
      17007,
      "/",
      14897
    ]
  },
  {
    "id": "21876",
    "description": "rocking_horse",
    "pos": "YELLOW",
    "explanation": "(horse + man-made + to rock)  Preferred NEW SYNONYM, replacing 16682",
    "isCharacter": false,
    "composition": [
      14897,
      "/",
      23583,
      "/",
      25406
    ]
  },
  {
    "id": "21877",
    "description": "dogsled_sport,dogsled_racing",
    "pos": "YELLOW",
    "explanation": "(sport + dog sled)",
    "isCharacter": false,
    "composition": [
      20518,
      "/",
      17007,
      "/",
      12380
    ]
  },
  {
    "id": "21878",
    "description": "sled_dog",
    "pos": "YELLOW",
    "explanation": "(dog + sled)",
    "isCharacter": false,
    "composition": [
      12380,
      "/",
      17007
    ]
  },
  {
    "id": "21879",
    "description": "curling",
    "pos": "YELLOW",
    "explanation": "(sport + disc + broom + ice)",
    "isCharacter": false,
    "composition": [
      20518,
      "/",
      13685,
      "/",
      12908,
      "/",
      14919
    ]
  },
  {
    "id": "21880",
    "description": "wave",
    "pos": "YELLOW",
    "explanation": "(water + pointer, to wave)  - Character (superimposed - pointer)",
    "isCharacter": true
  },
  {
    "id": "21881",
    "description": "surfboard",
    "pos": "YELLOW",
    "explanation": "(board + wave)",
    "isCharacter": false,
    "composition": [
      20599,
      "/",
      21880
    ]
  },
  {
    "id": "21882",
    "description": "sailboard,windsurf_board,windsurfing_board",
    "pos": "YELLOW",
    "explanation": "(board + sail)",
    "isCharacter": false,
    "composition": [
      20599,
      "/",
      20519
    ]
  },
  {
    "id": "21883",
    "description": "water_ski",
    "pos": "YELLOW",
    "explanation": "(ski + water)",
    "isCharacter": false,
    "composition": [
      25610,
      "/",
      25777
    ]
  },
  {
    "id": "21884",
    "description": "jet_ski,water_scooter",
    "pos": "YELLOW",
    "explanation": "(ski + water + motor)",
    "isCharacter": false,
    "composition": [
      25610,
      "/",
      25777,
      "/",
      15406
    ]
  },
  {
    "id": "21885",
    "description": "wind_surfing",
    "pos": "YELLOW",
    "explanation": "(sport + sailboard)",
    "isCharacter": false,
    "composition": [
      20518,
      "/",
      20599,
      "/",
      20519
    ]
  },
  {
    "id": "21886",
    "description": "water_skiing",
    "pos": "YELLOW",
    "explanation": "(sport + water ski)",
    "isCharacter": false,
    "composition": [
      20518,
      "/",
      25610,
      "/",
      25777
    ]
  },
  {
    "id": "22049",
    "description": "sailing",
    "pos": "YELLOW",
    "explanation": "(sport + sailboat)",
    "isCharacter": false,
    "composition": [
      20518,
      "/",
      20520
    ]
  },
  {
    "id": "22050",
    "description": "canoeing",
    "pos": "YELLOW",
    "explanation": "(sport + boat + one + paddle)",
    "isCharacter": false,
    "composition": [
      20518,
      "/",
      12869,
      "/",
      8497,
      "/",
      22067
    ]
  },
  {
    "id": "22051",
    "description": "rowing",
    "pos": "YELLOW",
    "explanation": "(sport + boat + two + oar)",
    "isCharacter": false,
    "composition": [
      20518,
      "/",
      12869,
      "/",
      8498,
      "/",
      22067
    ]
  },
  {
    "id": "22052",
    "description": "motorboat_sport",
    "pos": "YELLOW",
    "explanation": "(sport + boat + motor)",
    "isCharacter": false,
    "composition": [
      20518,
      "/",
      12869,
      "/",
      15406
    ]
  },
  {
    "id": "22053",
    "description": "swimming_(sport)",
    "pos": "YELLOW",
    "explanation": "(sport + swimming)",
    "isCharacter": false,
    "composition": [
      20518,
      "/",
      17724,
      "/",
      18209
    ]
  },
  {
    "id": "22054",
    "description": "synchronized_diving,synchro_diving_(sport)",
    "pos": "YELLOW",
    "explanation": "(sport + diving + design)",
    "isCharacter": false,
    "composition": [
      20518,
      "/",
      23550,
      "/",
      25777,
      "/",
      16194
    ]
  },
  {
    "id": "22055",
    "description": "diving_(sport)",
    "pos": "YELLOW",
    "explanation": "(sport + to jump + water)",
    "isCharacter": false,
    "composition": [
      20518,
      "/",
      23550,
      "/",
      25777
    ]
  },
  {
    "id": "22056",
    "description": "synchronized_swimming_(sport)",
    "pos": "YELLOW",
    "explanation": "(sport + swimming + plan)",
    "isCharacter": false,
    "composition": [
      20518,
      "/",
      17724,
      "/",
      18209,
      "/",
      16194
    ]
  },
  {
    "id": "22057",
    "description": "snorkeling,scuba_diving,deep_sea_diving_(sport)",
    "pos": "YELLOW",
    "explanation": "(sport + under + water)",
    "isCharacter": false,
    "composition": [
      20518,
      "/",
      17969,
      "/",
      18209
    ]
  },
  {
    "id": "22058",
    "description": "fishing_(sport)",
    "pos": "YELLOW",
    "explanation": "(sport + fishing)",
    "isCharacter": false,
    "composition": [
      20518,
      "/",
      24727,
      "/",
      14188
    ]
  },
  {
    "id": "22059",
    "description": "mast",
    "pos": "YELLOW",
    "explanation": "(sail + pointer, to the mast)  - Character (superimposed - pointer)",
    "isCharacter": true
  },
  {
    "id": "22060",
    "description": "boom",
    "pos": "YELLOW",
    "explanation": "(sail + pointer, to the boom)  - Character (superimposed - pointer)",
    "isCharacter": true
  },
  {
    "id": "22061",
    "description": "deck",
    "pos": "YELLOW",
    "explanation": "(boat + pointer, to the deck)  - Character (superimposed - pointer)",
    "isCharacter": true
  },
  {
    "id": "22062",
    "description": "bow,fore",
    "pos": "YELLOW",
    "explanation": "(boat + pointer, to the bow)  - Character (superimposed - pointer)",
    "isCharacter": true
  },
  {
    "id": "22063",
    "description": "stern",
    "pos": "YELLOW",
    "explanation": "(boat + pointer, to the stern)  - Character (superimposed - pointer)",
    "isCharacter": true
  },
  {
    "id": "22064",
    "description": "keel",
    "pos": "YELLOW",
    "explanation": "(boat + pointer, to the keel)  - Character (superimposed - pointer)",
    "isCharacter": true
  },
  {
    "id": "22065",
    "description": "hull,body",
    "pos": "YELLOW",
    "explanation": "(boat + pointer, to the hull)  - Character (superimposed - pointer)",
    "isCharacter": true
  },
  {
    "id": "22066",
    "description": "rudder",
    "pos": "YELLOW",
    "explanation": "(boat + pictograph, of rudder)  - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "22067",
    "description": "paddle,oar",
    "pos": "YELLOW",
    "explanation": "(water_(ground_level) + pictograph, of paddle in water)  - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "22068",
    "description": "paddle_(two_blades)",
    "pos": "YELLOW",
    "explanation": "(water_(ground_level) + pictograph, of paddle with two blades in water)  - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "22069",
    "description": "freighter",
    "pos": "YELLOW",
    "explanation": "(boat + thing [modification, higher position]: boat carrying goods) - Character (superimposed - modified)",
    "isCharacter": true
  },
  {
    "id": "22070",
    "description": "tanker",
    "pos": "YELLOW",
    "explanation": "(freighter + liquid)",
    "isCharacter": false,
    "composition": [
      22069,
      "/",
      18209
    ]
  },
  {
    "id": "22071",
    "description": "oil_tanker",
    "pos": "YELLOW",
    "explanation": "(freighter + oil)",
    "isCharacter": false,
    "composition": [
      22069,
      "/",
      15914
    ]
  },
  {
    "id": "22072",
    "description": "barge,river_boat",
    "pos": "YELLOW",
    "explanation": "(freighter + river)",
    "isCharacter": false,
    "composition": [
      22069,
      "/",
      16677
    ]
  },
  {
    "id": "22073",
    "description": "schooner",
    "pos": "YELLOW",
    "explanation": "(sailing boat + many + mast)  Many can be replaced by an appropriate number.",
    "isCharacter": false,
    "composition": [
      20520,
      "/",
      14647,
      "/",
      22059
    ]
  },
  {
    "id": "22074",
    "description": "motorboat",
    "pos": "YELLOW",
    "explanation": "(boat + motor)",
    "isCharacter": false,
    "composition": [
      12869,
      "/",
      15406
    ]
  },
  {
    "id": "22075",
    "description": "canoe",
    "pos": "YELLOW",
    "explanation": "(boat + one + paddle)",
    "isCharacter": false,
    "composition": [
      12869,
      "/",
      8497,
      "/",
      22067
    ]
  },
  {
    "id": "22076",
    "description": "rowing_boat",
    "pos": "YELLOW",
    "explanation": "(boat + two + oar)",
    "isCharacter": false,
    "composition": [
      12869,
      "/",
      8498,
      "/",
      22067
    ]
  },
  {
    "id": "22077",
    "description": "kayak",
    "pos": "YELLOW",
    "explanation": "(boat + paddle [two blades])",
    "isCharacter": false,
    "composition": [
      12869,
      "/",
      22068
    ]
  },
  {
    "id": "22078",
    "description": "lifeboat",
    "pos": "YELLOW",
    "explanation": "(boat + to aid)",
    "isCharacter": false,
    "composition": [
      12869,
      "/",
      14704
    ]
  },
  {
    "id": "22079",
    "description": "pilot_boat",
    "pos": "YELLOW",
    "explanation": "(boat + to guide)",
    "isCharacter": false,
    "composition": [
      12869,
      "/",
      22913
    ]
  },
  {
    "id": "22080",
    "description": "towboat,tugboat",
    "pos": "YELLOW",
    "explanation": "(boat + pull,pulling: a boat that pulls other boats)",
    "isCharacter": false,
    "composition": [
      12869,
      "/",
      25599
    ]
  },
  {
    "id": "22081",
    "description": "pushboat",
    "pos": "YELLOW",
    "explanation": "(boat + to push)",
    "isCharacter": false,
    "composition": [
      12869,
      "/",
      24825
    ]
  },
  {
    "id": "22082",
    "description": "cruise_ship",
    "pos": "YELLOW",
    "explanation": "(boat + person + to travel)",
    "isCharacter": false,
    "composition": [
      12869,
      "/",
      16161,
      "/",
      17779
    ]
  },
  {
    "id": "22083",
    "description": "ferry",
    "pos": "YELLOW",
    "explanation": "(boat + back and forth: vessel that makes regular return trips between two ports)",
    "isCharacter": false,
    "composition": [
      12869,
      "/",
      12610
    ]
  },
  {
    "id": "22084",
    "description": "steamship",
    "pos": "YELLOW",
    "explanation": "(boat + steam)",
    "isCharacter": false,
    "composition": [
      12869,
      "/",
      17255
    ]
  },
  {
    "id": "22085",
    "description": "hovercraft",
    "pos": "YELLOW",
    "explanation": "(boat + up + air: boat is pressed upward by air)",
    "isCharacter": false,
    "composition": [
      12869,
      "/",
      17983,
      "/",
      12356
    ]
  },
  {
    "id": "22086",
    "description": "rubber_boat,dinghy",
    "pos": "YELLOW",
    "explanation": "(boat + air: rubber boat inflated with air)",
    "isCharacter": false,
    "composition": [
      12869,
      "/",
      12356
    ]
  },
  {
    "id": "22087",
    "description": "catamaran,pontoon_boat",
    "pos": "YELLOW",
    "explanation": "(two + hull)",
    "isCharacter": false,
    "composition": [
      8498,
      "/",
      22065
    ]
  },
  {
    "id": "22088",
    "description": "paddle_boat,pedal_boat,water_bike,pedalo",
    "pos": "YELLOW",
    "explanation": "(boat + legs and feet: boat propelled by the legs and feet)",
    "isCharacter": false,
    "composition": [
      12869,
      "/",
      15189
    ]
  },
  {
    "id": "22089",
    "description": "houseboat",
    "pos": "YELLOW",
    "explanation": "(boat + house)",
    "isCharacter": false,
    "composition": [
      12869,
      "/",
      14905
    ]
  },
  {
    "id": "22090",
    "description": "boathouse",
    "pos": "YELLOW",
    "explanation": "(house + boat)",
    "isCharacter": false,
    "composition": [
      14905,
      "/",
      12869
    ]
  },
  {
    "id": "22091",
    "description": "horse_rider,equestrian",
    "pos": "BLUE",
    "explanation": "(person + horse)",
    "isCharacter": false,
    "composition": [
      16161,
      "/",
      14897
    ]
  },
  {
    "id": "22092",
    "description": "jockey",
    "pos": "BLUE",
    "explanation": "(horse rider + fast)",
    "isCharacter": false,
    "composition": [
      16161,
      "/",
      14897,
      "/",
      14390,
      "/",
      14947
    ]
  },
  {
    "id": "22093",
    "description": "sulky",
    "pos": "YELLOW",
    "explanation": "(cart + small + horse)",
    "isCharacter": false,
    "composition": [
      13127,
      "/",
      24917,
      "/",
      14897
    ]
  },
  {
    "id": "22094",
    "description": "horse_racing",
    "pos": "YELLOW",
    "explanation": "(sport + horse + fast)",
    "isCharacter": false,
    "composition": [
      20518,
      "/",
      14897,
      "/",
      14390,
      "/",
      14947
    ]
  },
  {
    "id": "22095",
    "description": "carriage_racing",
    "pos": "YELLOW",
    "explanation": "(sport + horse + carriage)",
    "isCharacter": false,
    "composition": [
      20518,
      "/",
      14897,
      "/",
      13127
    ]
  },
  {
    "id": "22096",
    "description": "showjumping_(horse)",
    "pos": "YELLOW",
    "explanation": "(sport + horse + to jump)",
    "isCharacter": false,
    "composition": [
      20518,
      "/",
      14897,
      "/",
      23550
    ]
  },
  {
    "id": "22097",
    "description": "dressage",
    "pos": "YELLOW",
    "explanation": "(sport + horse + plan)",
    "isCharacter": false,
    "composition": [
      20518,
      "/",
      14897,
      "/",
      16194
    ]
  },
  {
    "id": "22098",
    "description": "polo",
    "pos": "YELLOW",
    "explanation": "(sport + horse + sport_stick_and_ball,bandy_stick)",
    "isCharacter": false,
    "composition": [
      20518,
      "/",
      14897,
      "/",
      25618
    ]
  },
  {
    "id": "22099",
    "description": "billiards",
    "pos": "YELLOW",
    "explanation": "(sport + table + three + ball)",
    "isCharacter": false,
    "composition": [
      20518,
      "/",
      17493,
      "/",
      8499,
      "/",
      12621
    ]
  },
  {
    "id": "22100",
    "description": "pool,snooker",
    "pos": "YELLOW",
    "explanation": "(sport + table + many + ball)  Many can be replaced by an appropriate number.",
    "isCharacter": false,
    "composition": [
      20518,
      "/",
      17493,
      "/",
      14647,
      "/",
      12621
    ]
  },
  {
    "id": "22101",
    "description": "squash_(sport)_(OLD)",
    "pos": "YELLOW",
    "explanation": "(tennis,racquet_sports_(OLD) + room)  SUPERSEDED SYNONYM  See squash_(sport) 26027",
    "isCharacter": false,
    "composition": [
      20518,
      "/",
      25542,
      "/",
      16687
    ]
  },
  {
    "id": "22102",
    "description": "lacrosse_(sport)_(OLD)",
    "pos": "YELLOW",
    "explanation": "(tennis,racquet_sports_(OLD) + group: group representing team_(sport) [contraction])  SUPERSEDED SYNONYM  See lacrosse_(sport) 26013",
    "isCharacter": false,
    "composition": [
      20518,
      "/",
      25542,
      "/",
      14647,
      "/",
      16161
    ]
  },
  {
    "id": "22103",
    "description": "glider",
    "pos": "YELLOW",
    "explanation": "(airplane + air: plane propelled by air currents)",
    "isCharacter": false,
    "composition": [
      12357,
      "/",
      12356
    ]
  },
  {
    "id": "22104",
    "description": "seaplane",
    "pos": "YELLOW",
    "explanation": "(airplane + water: plane that can land on water)",
    "isCharacter": false,
    "composition": [
      12357,
      "/",
      25777
    ]
  },
  {
    "id": "22105",
    "description": "parachute",
    "pos": "YELLOW",
    "explanation": "(from_sky + pictograph, of the parachute canopy)  - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "22106",
    "description": "parachuting",
    "pos": "YELLOW",
    "explanation": "(sport + parachute)",
    "isCharacter": false,
    "composition": [
      20518,
      "/",
      22105
    ]
  },
  {
    "id": "22107",
    "description": "balloon_(hot_air)",
    "pos": "YELLOW",
    "explanation": "(pictograph)  - Character",
    "isCharacter": true
  },
  {
    "id": "22108",
    "description": "ballooning",
    "pos": "YELLOW",
    "explanation": "(sport + balloon_(hot_air))",
    "isCharacter": false,
    "composition": [
      20518,
      "/",
      22107
    ]
  },
  {
    "id": "22109",
    "description": "mountain_climbing",
    "pos": "YELLOW",
    "explanation": "(sport + mountain + to go up)",
    "isCharacter": false,
    "composition": [
      20518,
      "/",
      15663,
      "/",
      17983
    ]
  },
  {
    "id": "22110",
    "description": "abseiling,rappelling",
    "pos": "YELLOW",
    "explanation": "(sport + mountain + to go down)",
    "isCharacter": false,
    "composition": [
      20518,
      "/",
      15663,
      "/",
      13869
    ]
  },
  {
    "id": "22111",
    "description": "wall_climbing",
    "pos": "YELLOW",
    "explanation": "(sport + wall + to go up)",
    "isCharacter": false,
    "composition": [
      20518,
      "/",
      18033,
      "/",
      17983
    ]
  },
  {
    "id": "22112",
    "description": "parasailing",
    "pos": "YELLOW",
    "explanation": "(sport + parachute + boat)",
    "isCharacter": false,
    "composition": [
      20518,
      "/",
      22105,
      "/",
      12869
    ]
  },
  {
    "id": "22113",
    "description": "paraskiing",
    "pos": "YELLOW",
    "explanation": "(sport + parachute + skis)",
    "isCharacter": false,
    "composition": [
      20518,
      "/",
      22105,
      "/",
      8498,
      "/",
      25610
    ]
  },
  {
    "id": "22114",
    "description": "hang_gliding",
    "pos": "YELLOW",
    "explanation": "(sport + wings + person: sport in which a person flies by hanging from wings propelled by air currents)",
    "isCharacter": false,
    "composition": [
      20518,
      "/",
      18259,
      "/",
      16161
    ]
  },
  {
    "id": "22115",
    "description": "kite_flying",
    "pos": "YELLOW",
    "explanation": "(sport + kite)",
    "isCharacter": false,
    "composition": [
      20518,
      "/",
      15155
    ]
  },
  {
    "id": "22116",
    "description": "indoor_(character)",
    "pos": "YELLOW",
    "explanation": "(house + dot (inside the house): can also be seen as a combination of house and inside) - Character (superimposed - combined)",
    "isCharacter": true
  },
  {
    "id": "22117",
    "description": "outdoor,outdoors",
    "pos": "GREEN",
    "explanation": "(outdoor_(character) + description indicator: the dot is outside the house)",
    "isCharacter": false,
    "composition": [
      25591,
      ";",
      8998
    ]
  },
  {
    "id": "22118",
    "description": "appetizer,starter,entree",
    "pos": "YELLOW",
    "explanation": "(food + to start)",
    "isCharacter": false,
    "composition": [
      14377,
      "/",
      12658
    ]
  },
  {
    "id": "22119",
    "description": "main_dish,main_course",
    "pos": "YELLOW",
    "explanation": "(food + middle)",
    "isCharacter": false,
    "composition": [
      14377,
      "/",
      15464
    ]
  },
  {
    "id": "22120",
    "description": "fishburger",
    "pos": "YELLOW",
    "explanation": "(bun + fish [contraction])",
    "isCharacter": false,
    "composition": [
      20769,
      "/",
      14188
    ]
  },
  {
    "id": "22121",
    "description": "decorated_cake",
    "pos": "YELLOW",
    "explanation": "(cake + intensity)",
    "isCharacter": false,
    "composition": [
      12895,
      "/",
      17506,
      "/",
      17983,
      "/",
      14947
    ]
  },
  {
    "id": "22122",
    "description": "muffin,bun_(sweet)",
    "pos": "YELLOW",
    "explanation": "(bun + sweet)",
    "isCharacter": false,
    "composition": [
      16683,
      "/",
      17506,
      "/",
      17983
    ]
  },
  {
    "id": "22123",
    "description": "cupcake,fancy_cake,pastry",
    "pos": "YELLOW",
    "explanation": "(muffin + intensity)",
    "isCharacter": false,
    "composition": [
      16683,
      "/",
      17506,
      "/",
      17983,
      "/",
      14947
    ]
  },
  {
    "id": "22124",
    "description": "doughnut",
    "pos": "YELLOW",
    "explanation": "(muffin + ring: muffin in the shape of a ring)",
    "isCharacter": false,
    "composition": [
      16683,
      "/",
      17506,
      "/",
      17983,
      "/",
      16675
    ]
  },
  {
    "id": "22125",
    "description": "bagel",
    "pos": "YELLOW",
    "explanation": "(bun_(food) + ring: bun in the shape of a ring)",
    "isCharacter": false,
    "composition": [
      20769,
      "/",
      16675
    ]
  },
  {
    "id": "22126",
    "description": "waffle",
    "pos": "YELLOW",
    "explanation": "(food + grid,matrix: the waffle iron creates a grid pattern)",
    "isCharacter": false,
    "composition": [
      14377,
      "/",
      24904
    ]
  },
  {
    "id": "22127",
    "description": "fishball",
    "pos": "YELLOW",
    "explanation": "(fish_(food) + ball: fish shaped into a ball)",
    "isCharacter": false,
    "composition": [
      14377,
      "/",
      14188,
      "/",
      12621
    ]
  },
  {
    "id": "22128",
    "description": "dumpling",
    "pos": "YELLOW",
    "explanation": "(food + bun + ball: bun-like food shaped into a ball)",
    "isCharacter": false,
    "composition": [
      14377,
      "/",
      16683,
      "/",
      12621
    ]
  },
  {
    "id": "22129",
    "description": "pasta",
    "pos": "YELLOW",
    "explanation": "(food + flour: food made from [wheat] flour)",
    "isCharacter": false,
    "composition": [
      14377,
      "/",
      16233,
      "/",
      14625
    ]
  },
  {
    "id": "22130",
    "description": "macaroni",
    "pos": "YELLOW",
    "explanation": "(pasta + tube)",
    "isCharacter": false,
    "composition": [
      14377,
      "/",
      16233,
      "/",
      14625,
      "/",
      23926
    ]
  },
  {
    "id": "22131",
    "description": "farfalle",
    "pos": "YELLOW",
    "explanation": "(pasta + butterfly)",
    "isCharacter": false,
    "composition": [
      14377,
      "/",
      16233,
      "/",
      14625,
      "/",
      13096
    ]
  },
  {
    "id": "22132",
    "description": "pasta_wheel",
    "pos": "YELLOW",
    "explanation": "(pasta + wheel)",
    "isCharacter": false,
    "composition": [
      14377,
      "/",
      16233,
      "/",
      14625,
      "/",
      18232
    ]
  },
  {
    "id": "22133",
    "description": "lasagne,lasagna",
    "pos": "YELLOW",
    "explanation": "(pasta + page)",
    "isCharacter": false,
    "composition": [
      14377,
      "/",
      16233,
      "/",
      14625,
      "/",
      15962
    ]
  },
  {
    "id": "22134",
    "description": "ravioli",
    "pos": "YELLOW",
    "explanation": "(pasta + filled)",
    "isCharacter": false,
    "composition": [
      14377,
      "/",
      16233,
      "/",
      14625,
      "/",
      24897
    ]
  },
  {
    "id": "22135",
    "description": "rice_flour",
    "pos": "YELLOW",
    "explanation": "(powder + rice)",
    "isCharacter": false,
    "composition": [
      16233,
      "/",
      16505
    ]
  },
  {
    "id": "22136",
    "description": "rice_noodle",
    "pos": "YELLOW",
    "explanation": "(food + rice flour + line)",
    "isCharacter": false,
    "composition": [
      14377,
      "/",
      16233,
      "/",
      16505,
      "/",
      15214
    ]
  },
  {
    "id": "22137",
    "description": "egg_(boiled),boiled_egg",
    "pos": "YELLOW",
    "explanation": "(egg + to boil [contraction])",
    "isCharacter": false,
    "composition": [
      13912,
      "/",
      14183,
      "/",
      18209,
      "/",
      14947
    ]
  },
  {
    "id": "22138",
    "description": "egg_(fried),fried_egg",
    "pos": "YELLOW",
    "explanation": "(egg + to fry [contraction])",
    "isCharacter": false,
    "composition": [
      13912,
      "/",
      14183,
      "/",
      15914
    ]
  },
  {
    "id": "22139",
    "description": "omelette,omelet",
    "pos": "YELLOW",
    "explanation": "(egg + mixture + to heat [modification])",
    "isCharacter": false,
    "composition": [
      13912,
      "/",
      22377,
      "/",
      14183
    ]
  },
  {
    "id": "22140",
    "description": "scrambled_eggs",
    "pos": "YELLOW",
    "explanation": "(egg + to heat [modification] + mixture)",
    "isCharacter": false,
    "composition": [
      13912,
      "/",
      14183,
      "/",
      22377
    ]
  },
  {
    "id": "22141",
    "description": "egg_(poached),poached_egg",
    "pos": "YELLOW",
    "explanation": "(egg + heat [modification] + water: egg cooked in water)",
    "isCharacter": false,
    "composition": [
      13912,
      "/",
      14183,
      "/",
      18209
    ]
  },
  {
    "id": "22142",
    "description": "fruit_salad",
    "pos": "YELLOW",
    "explanation": "(salad + fruit)  The specifier fruit can be replaced with another appropriate one.",
    "isCharacter": false,
    "composition": [
      16709,
      "/",
      14405
    ]
  },
  {
    "id": "22305",
    "description": "shellfish_salad",
    "pos": "YELLOW",
    "explanation": "(salad + crab)",
    "isCharacter": false,
    "composition": [
      16709,
      "/",
      15226
    ]
  },
  {
    "id": "22306",
    "description": "pasta_salad",
    "pos": "YELLOW",
    "explanation": "(salad + pasta [contraction]))",
    "isCharacter": false,
    "composition": [
      16709,
      "/",
      16233,
      "/",
      14625
    ]
  },
  {
    "id": "22307",
    "description": "pudding,cream",
    "pos": "YELLOW",
    "explanation": "(plate + pictograph of pudding)  - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "22308",
    "description": "Christmas_pudding",
    "pos": "YELLOW",
    "explanation": "(pudding + Christmas [contraction])",
    "isCharacter": false,
    "composition": [
      22307,
      "/",
      12843,
      "/",
      13613
    ]
  },
  {
    "id": "22309",
    "description": "flavouring,seasoning_(liquid)",
    "pos": "YELLOW",
    "explanation": "(flavouring [contraction] + liquid + thing indicator)",
    "isCharacter": false,
    "composition": [
      12339,
      ";",
      9009,
      "/",
      18209
    ]
  },
  {
    "id": "22310",
    "description": "flavouring,seasoning_(powder)",
    "pos": "YELLOW",
    "explanation": "(flavouring [contraction] + powder + thing indicator)",
    "isCharacter": false,
    "composition": [
      12339,
      ";",
      9009,
      "/",
      16233
    ]
  },
  {
    "id": "22311",
    "description": "bark",
    "pos": "YELLOW",
    "explanation": "(protection + tree trunk)",
    "isCharacter": false,
    "composition": [
      16420,
      "/",
      17783
    ]
  },
  {
    "id": "22312",
    "description": "cinnamon",
    "pos": "YELLOW",
    "explanation": "(flavouring + bark + thing indicator)",
    "isCharacter": false,
    "composition": [
      12339,
      ";",
      9009,
      "/",
      17506,
      "/",
      16420,
      "/",
      17783
    ]
  },
  {
    "id": "22313",
    "description": "cinnamon_(powder)",
    "pos": "YELLOW",
    "explanation": "(flavouring (powder) + cinnamon [contraction] + thing indicator)",
    "isCharacter": false,
    "composition": [
      12339,
      ";",
      9009,
      "/",
      16233,
      "/",
      16420,
      "/",
      17783
    ]
  },
  {
    "id": "22314",
    "description": "vanilla",
    "pos": "YELLOW",
    "explanation": "(flavouring + pod + thing indicator)",
    "isCharacter": false,
    "composition": [
      12339,
      ";",
      9009,
      "/",
      17506,
      "/",
      22837
    ]
  },
  {
    "id": "22315",
    "description": "vanilla_(powder)",
    "pos": "YELLOW",
    "explanation": "(flavouring (powder) + vanilla [contraction] + thing indicator)",
    "isCharacter": false,
    "composition": [
      12339,
      ";",
      9009,
      "/",
      16233,
      "/",
      22837
    ]
  },
  {
    "id": "22316",
    "description": "vanilla_(liquid)",
    "pos": "YELLOW",
    "explanation": "(flavouring (liquid) + vanilla [contraction] + thing indicator)",
    "isCharacter": false,
    "composition": [
      12339,
      ";",
      9009,
      "/",
      18209,
      "/",
      22837
    ]
  },
  {
    "id": "22317",
    "description": "vanilla_sauce",
    "pos": "YELLOW",
    "explanation": "(sauce + vanilla [contraction])",
    "isCharacter": false,
    "composition": [
      20522,
      "/",
      22837
    ]
  },
  {
    "id": "22318",
    "description": "ginger",
    "pos": "YELLOW",
    "explanation": "(flavouring + roots + thing indicator)",
    "isCharacter": false,
    "composition": [
      12339,
      ";",
      9009,
      "/",
      17506,
      "/",
      16688
    ]
  },
  {
    "id": "22319",
    "description": "ginger_(powder)",
    "pos": "YELLOW",
    "explanation": "(flavouring (powder) + ginger [contraction] + thing indicator)",
    "isCharacter": false,
    "composition": [
      12339,
      ";",
      9009,
      "/",
      16233,
      "/",
      16688
    ]
  },
  {
    "id": "22320",
    "description": "ginger_sauce",
    "pos": "YELLOW",
    "explanation": "(sauce + ginger [contraction])",
    "isCharacter": false,
    "composition": [
      20522,
      "/",
      16688
    ]
  },
  {
    "id": "22321",
    "description": "herb_flavouring_(powder)",
    "pos": "YELLOW",
    "explanation": "(flavouring (powder) + herb flavouring [contraction] + thing indicator)",
    "isCharacter": false,
    "composition": [
      12339,
      ";",
      9009,
      "/",
      16233,
      "/",
      15183
    ]
  },
  {
    "id": "22322",
    "description": "herb_flavouring",
    "pos": "YELLOW",
    "explanation": "(flavouring + leaf + thing indicator)",
    "isCharacter": false,
    "composition": [
      12339,
      ";",
      9009,
      "/",
      17506,
      "/",
      15183
    ]
  },
  {
    "id": "22323",
    "description": "herb_sauce",
    "pos": "YELLOW",
    "explanation": "(sauce + herb flavouring [contraction])",
    "isCharacter": false,
    "composition": [
      20522,
      "/",
      15183
    ]
  },
  {
    "id": "22324",
    "description": "salad_dressing",
    "pos": "YELLOW",
    "explanation": "(sauce + salad)",
    "isCharacter": false,
    "composition": [
      20522,
      "/",
      16709
    ]
  },
  {
    "id": "22325",
    "description": "pepper_(powder)",
    "pos": "YELLOW",
    "explanation": "(flavouring (powder) + pepper [contraction] + thing indicator)",
    "isCharacter": false,
    "composition": [
      12339,
      ";",
      9009,
      "/",
      16233,
      "/",
      14183
    ]
  },
  {
    "id": "22326",
    "description": "pepper_sauce",
    "pos": "YELLOW",
    "explanation": "(sauce + pepper [contraction])",
    "isCharacter": false,
    "composition": [
      20522,
      "/",
      14183
    ]
  },
  {
    "id": "22327",
    "description": "curry",
    "pos": "YELLOW",
    "explanation": "(flavouring + mixture + hot [modification] + thing indicator)",
    "isCharacter": false,
    "composition": [
      12339,
      ";",
      9009,
      "/",
      17506,
      "/",
      22377,
      "/",
      14183
    ]
  },
  {
    "id": "22328",
    "description": "curry_(powder)",
    "pos": "YELLOW",
    "explanation": "(flavouring [contraction] + powder + mixture + hot [modification] + thing indicator)",
    "isCharacter": false,
    "composition": [
      12339,
      ";",
      9009,
      "/",
      16233,
      "/",
      22377,
      "/",
      14183
    ]
  },
  {
    "id": "22329",
    "description": "curry_sauce",
    "pos": "YELLOW",
    "explanation": "(sauce + mixture + hot [modification])",
    "isCharacter": false,
    "composition": [
      20522,
      "/",
      22377,
      "/",
      14183
    ]
  },
  {
    "id": "22330",
    "description": "mustard",
    "pos": "YELLOW",
    "explanation": "(flavouring + seeds + intensity + thing indicator)",
    "isCharacter": false,
    "composition": [
      12339,
      ";",
      9009,
      "/",
      17506,
      "/",
      16749,
      "/",
      14947
    ]
  },
  {
    "id": "22331",
    "description": "mustard_(powder)",
    "pos": "YELLOW",
    "explanation": "(flavouring [contraction] + powder + mustard [contraction] + thing indicator)",
    "isCharacter": false,
    "composition": [
      12339,
      ";",
      9009,
      "/",
      16233,
      "/",
      16749,
      "/",
      14947
    ]
  },
  {
    "id": "22332",
    "description": "mustard_sauce",
    "pos": "YELLOW",
    "explanation": "(sauce + mustard [contraction])",
    "isCharacter": false,
    "composition": [
      20522,
      "/",
      16749,
      "/",
      14947
    ]
  },
  {
    "id": "22333",
    "description": "sap_(flavouring)",
    "pos": "YELLOW",
    "explanation": "(flavouring + trunk + thing indicator)",
    "isCharacter": false,
    "composition": [
      12339,
      ";",
      9009,
      "/",
      17506,
      "/",
      17783
    ]
  },
  {
    "id": "22334",
    "description": "maple_syrup_flavouring",
    "pos": "YELLOW",
    "explanation": "(sap flavouring + maple leaf + thing indicator)",
    "isCharacter": false,
    "composition": [
      12339,
      ";",
      9009,
      "/",
      17506,
      "/",
      17783,
      "/",
      15422
    ]
  },
  {
    "id": "22335",
    "description": "syrup",
    "pos": "YELLOW",
    "explanation": "(flavouring [contraction] + liquid + sweet + thing indicator)",
    "isCharacter": false,
    "composition": [
      12339,
      ";",
      9009,
      "/",
      18209,
      "/",
      17506,
      "/",
      17983
    ]
  },
  {
    "id": "22336",
    "description": "sap",
    "pos": "YELLOW",
    "explanation": "(liquid + trunk)",
    "isCharacter": false,
    "composition": [
      18209,
      "/",
      17783
    ]
  },
  {
    "id": "22337",
    "description": "syrup_(from_tree)",
    "pos": "YELLOW",
    "explanation": "(flavouring [contraction] + sap + thing indicator)",
    "isCharacter": false,
    "composition": [
      12339,
      ";",
      9009,
      "/",
      18209,
      "/",
      17783
    ]
  },
  {
    "id": "22338",
    "description": "maple_syrup",
    "pos": "YELLOW",
    "explanation": "(flavouring [contraction] + sap + maple leaf + thing indicator)",
    "isCharacter": false,
    "composition": [
      12339,
      ";",
      9009,
      "/",
      18209,
      "/",
      17783,
      "/",
      15422
    ]
  },
  {
    "id": "22339",
    "description": "corn_syrup",
    "pos": "YELLOW",
    "explanation": "(flavouring [contraction] + liquid + corn + thing indicator)",
    "isCharacter": false,
    "composition": [
      12339,
      ";",
      9009,
      "/",
      18209,
      "/",
      13413
    ]
  },
  {
    "id": "22340",
    "description": "chocolate,cocoa,cacao_(sweet_powder)",
    "pos": "YELLOW",
    "explanation": "(flavouring [contraction] + powder + bean + sweet [contraction] + thing indicator)",
    "isCharacter": false,
    "composition": [
      12339,
      ";",
      9009,
      "/",
      16233,
      "/",
      12642,
      "/",
      17983
    ]
  },
  {
    "id": "22341",
    "description": "chocolate,cocoa,cacao_(bitter_powder)",
    "pos": "YELLOW",
    "explanation": "(flavouring [contraction] + powder + bean + bitter [contraction] + thing indicator)",
    "isCharacter": false,
    "composition": [
      12339,
      ";",
      9009,
      "/",
      16233,
      "/",
      12642,
      "/",
      13869
    ]
  },
  {
    "id": "22342",
    "description": "chocolate_sauce",
    "pos": "YELLOW",
    "explanation": "(sauce + chocolate [contraction])",
    "isCharacter": false,
    "composition": [
      20522,
      "/",
      12642,
      "/",
      17983
    ]
  },
  {
    "id": "22343",
    "description": "chocolate_(hagel)",
    "pos": "YELLOW",
    "explanation": "(spread + piece + chocolate [contraction])",
    "isCharacter": false,
    "composition": [
      17238,
      "/",
      15972,
      "/",
      12642,
      "/",
      17983
    ]
  },
  {
    "id": "22344",
    "description": "sweet_drink",
    "pos": "YELLOW",
    "explanation": "(drink + sweet)",
    "isCharacter": false,
    "composition": [
      13881,
      "/",
      17506,
      "/",
      17983
    ]
  },
  {
    "id": "22345",
    "description": "sparkling_wine",
    "pos": "YELLOW",
    "explanation": "(wine + gas)",
    "isCharacter": false,
    "composition": [
      12359,
      "/",
      14635,
      "/",
      14424
    ]
  },
  {
    "id": "22346",
    "description": "champagne",
    "pos": "YELLOW",
    "explanation": "(sparkling wine + intensity)",
    "isCharacter": false,
    "composition": [
      12359,
      "/",
      14635,
      "/",
      14424,
      "/",
      14947
    ]
  },
  {
    "id": "22347",
    "description": "cider",
    "pos": "YELLOW",
    "explanation": "(alcoholic drink + apple)",
    "isCharacter": false,
    "composition": [
      12359,
      "/",
      12405
    ]
  },
  {
    "id": "22349",
    "description": "juicy",
    "pos": "GREEN",
    "explanation": "(liquid + intensity + description indicator)",
    "isCharacter": false,
    "composition": [
      18209,
      ";",
      8998,
      "/",
      14947
    ]
  },
  {
    "id": "22350",
    "description": "pickled",
    "pos": "GREEN",
    "explanation": "(taste + sharp + description after the fact indicator)",
    "isCharacter": false,
    "composition": [
      17506,
      ";",
      8996,
      "/",
      15159
    ]
  },
  {
    "id": "22351",
    "description": "fried",
    "pos": "GREEN",
    "explanation": "(to fry [contraction] + description indicator)",
    "isCharacter": false,
    "composition": [
      14183,
      ";",
      8998,
      "/",
      15914
    ]
  },
  {
    "id": "22352",
    "description": "delicious,scrumptious,yummy",
    "pos": "GREEN",
    "explanation": "(tasty + one intensity character + description indicator)",
    "isCharacter": false,
    "composition": [
      17506,
      ";",
      8998,
      "/",
      12374,
      "/",
      14947,
      "/",
      14947
    ]
  },
  {
    "id": "22353",
    "description": "tasteless,not_tasty,not_good",
    "pos": "GREEN",
    "explanation": "(tasty + negative + description indicator)",
    "isCharacter": false,
    "composition": [
      17506,
      ";",
      8998,
      "/",
      15474,
      "/",
      14947
    ]
  },
  {
    "id": "22354",
    "description": "disgusting_(taste)",
    "pos": "GREEN",
    "explanation": "(not tasty + one intensity character + description indicator)",
    "isCharacter": false,
    "composition": [
      17506,
      ";",
      8998,
      "/",
      15474,
      "/",
      14947,
      "/",
      14947
    ]
  },
  {
    "id": "22355",
    "description": "meat_(frozen),frozen_meat",
    "pos": "YELLOW",
    "explanation": "(meat + frozen)",
    "isCharacter": false,
    "composition": [
      14377,
      "/",
      12378,
      "/",
      14919
    ]
  },
  {
    "id": "22356",
    "description": "fish_(frozen)",
    "pos": "YELLOW",
    "explanation": "(fish + frozen)",
    "isCharacter": false,
    "composition": [
      14377,
      "/",
      14188,
      "/",
      14919
    ]
  },
  {
    "id": "22357",
    "description": "yogurt,yoghurt_(frozen)",
    "pos": "YELLOW",
    "explanation": "(yoghurt + frozen)",
    "isCharacter": false,
    "composition": [
      14377,
      "/",
      13881,
      "/",
      15206,
      "/",
      14919
    ]
  },
  {
    "id": "22358",
    "description": "hard_cheese",
    "pos": "YELLOW",
    "explanation": "(cheese + hard)",
    "isCharacter": false,
    "composition": [
      13157,
      "/",
      14667,
      "/",
      17493
    ]
  },
  {
    "id": "22359",
    "description": "soft_cheese",
    "pos": "YELLOW",
    "explanation": "(cheese + soft)",
    "isCharacter": false,
    "composition": [
      13157,
      "/",
      14667,
      "/",
      25575
    ]
  },
  {
    "id": "22360",
    "description": "spreadable_cheese",
    "pos": "YELLOW",
    "explanation": "(cheese + spread: cheese used as a spread)",
    "isCharacter": false,
    "composition": [
      13157,
      "/",
      17238
    ]
  },
  {
    "id": "22361",
    "description": "fresh_cheese",
    "pos": "YELLOW",
    "explanation": "(cheese + new)",
    "isCharacter": false,
    "composition": [
      13157,
      "/",
      25587
    ]
  },
  {
    "id": "22362",
    "description": "lump(s)",
    "pos": "YELLOW",
    "explanation": "(four dots (two in high and two in low positions): indicating bits from thing)  - Character (superimposed - sequenced)",
    "isCharacter": true
  },
  {
    "id": "22363",
    "description": "lumpy",
    "pos": "GREEN",
    "explanation": "(lump(s) + description indicator)",
    "isCharacter": false,
    "composition": [
      22362,
      ";",
      8998
    ]
  },
  {
    "id": "22364",
    "description": "cottage_cheese",
    "pos": "YELLOW",
    "explanation": "(cheese + lump(s))",
    "isCharacter": false,
    "composition": [
      13157,
      "/",
      22362
    ]
  },
  {
    "id": "22365",
    "description": "lollipop,sucker",
    "pos": "YELLOW",
    "explanation": "(pictograph)  - Character",
    "isCharacter": true
  },
  {
    "id": "22366",
    "description": "ice_cream_(lollipop)",
    "pos": "YELLOW",
    "explanation": "(pictograph)  - Character",
    "isCharacter": true
  },
  {
    "id": "22367",
    "description": "water_ice_lollipop",
    "pos": "YELLOW",
    "explanation": "(ice_cream_(lollipop) + frozen)",
    "isCharacter": false,
    "composition": [
      22366,
      "/",
      14919
    ]
  },
  {
    "id": "22368",
    "description": "popsicle",
    "pos": "YELLOW",
    "explanation": "(cylinder + frozen)",
    "isCharacter": false,
    "composition": [
      13115,
      "/",
      14919
    ]
  },
  {
    "id": "22369",
    "description": "ice_cream,sherbet,sorbet",
    "pos": "YELLOW",
    "explanation": "(ice cream cone + pointer, to the ice cream)  - Character (superimposed - pointer)  Preferred NEW SYNONYM, replacing 14920 (See also: ice_cream_(cone) 14921, ice_cream_(bar) 22370, and ice_cream_(lollipop) 22366)",
    "isCharacter": true
  },
  {
    "id": "22370",
    "description": "ice_cream_(bar)",
    "pos": "YELLOW",
    "explanation": "(ice cream + bar)",
    "isCharacter": false,
    "composition": [
      22369,
      "/",
      22371
    ]
  },
  {
    "id": "22371",
    "description": "bar,cake",
    "pos": "YELLOW",
    "explanation": "(pictograph)  - Character",
    "isCharacter": true
  },
  {
    "id": "22372",
    "description": "candy_bar",
    "pos": "YELLOW",
    "explanation": "(bar + sweet)",
    "isCharacter": false,
    "composition": [
      22371,
      "/",
      17506,
      "/",
      17983
    ]
  },
  {
    "id": "22373",
    "description": "chocolate_bar",
    "pos": "YELLOW",
    "explanation": "(bar + chocolate [contraction])",
    "isCharacter": false,
    "composition": [
      22371,
      "/",
      12642,
      "/",
      17983
    ]
  },
  {
    "id": "22374",
    "description": "reflect,consider,regard-(to)",
    "pos": "RED",
    "explanation": "(reflection_(mental),consideration + action indicator)",
    "isCharacter": false,
    "composition": [
      25602,
      ";",
      8993
    ]
  },
  {
    "id": "22375",
    "description": "candy",
    "pos": "YELLOW",
    "explanation": "(pictograph)  - Character  Preferred NEW SYNONYM, replacing 13118",
    "isCharacter": true
  },
  {
    "id": "22376",
    "description": "candy,sweets",
    "pos": "YELLOW",
    "explanation": "(generalization + candy)",
    "isCharacter": false,
    "composition": [
      14430,
      "/",
      22375
    ]
  },
  {
    "id": "22377",
    "description": "mixture",
    "pos": "YELLOW",
    "explanation": "(two curved arrows mingling)  - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "22378",
    "description": "dough",
    "pos": "YELLOW",
    "explanation": "(mixture + flour [contraction] + liquid)",
    "isCharacter": false,
    "composition": [
      22377,
      "/",
      16233,
      "/",
      18209
    ]
  },
  {
    "id": "22379",
    "description": "batter",
    "pos": "YELLOW",
    "explanation": "(mixture + flour [contraction] + much + liquid)",
    "isCharacter": false,
    "composition": [
      22377,
      "/",
      16233,
      "/",
      14647,
      "/",
      18209
    ]
  },
  {
    "id": "22380",
    "description": "ingredient",
    "pos": "YELLOW",
    "explanation": "(part of + mixture)",
    "isCharacter": false,
    "composition": [
      15972,
      "/",
      22377
    ]
  },
  {
    "id": "22381",
    "description": "slice",
    "pos": "YELLOW",
    "explanation": "(thin + knife + thing indicator: a piece of food cut thin)",
    "isCharacter": false,
    "composition": [
      25622,
      ";",
      9009,
      "/",
      15159
    ]
  },
  {
    "id": "22382",
    "description": "slice-(to)",
    "pos": "RED",
    "explanation": "(slice + action indicator)",
    "isCharacter": false,
    "composition": [
      25622,
      ";",
      8993,
      "/",
      15159
    ]
  },
  {
    "id": "22383",
    "description": "sliced",
    "pos": "GREEN",
    "explanation": "(slice + description indicator)",
    "isCharacter": false,
    "composition": [
      25622,
      ";",
      8998,
      "/",
      15159
    ]
  },
  {
    "id": "22384",
    "description": "reflection",
    "pos": "YELLOW",
    "explanation": "(arrow_(bent) + vertical line: a ray of light strikes a mirror and is reflected back from it)  - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "22385",
    "description": "reflector",
    "pos": "YELLOW",
    "explanation": "(thing + reflection)",
    "isCharacter": false,
    "composition": [
      17717,
      "/",
      22384
    ]
  },
  {
    "id": "22386",
    "description": "shine",
    "pos": "YELLOW",
    "explanation": "(reflection + arrow_(bent) [modification, flipped vertically]) - Character (superimposed - modified)",
    "isCharacter": true
  },
  {
    "id": "22387",
    "description": "shine-(to)",
    "pos": "RED",
    "explanation": "(shine + action indicator)",
    "isCharacter": false,
    "composition": [
      22386,
      ";",
      8993
    ]
  },
  {
    "id": "22388",
    "description": "shiny,glossy",
    "pos": "GREEN",
    "explanation": "(shine + description indicator)",
    "isCharacter": false,
    "composition": [
      22386,
      ";",
      8998
    ]
  },
  {
    "id": "22389",
    "description": "polish-(to)",
    "pos": "RED",
    "explanation": "(to rub [contraction] + shine + action indicator)",
    "isCharacter": false,
    "composition": [
      14667,
      ";",
      8993,
      "/",
      12610,
      "/",
      22386
    ]
  },
  {
    "id": "22390",
    "description": "polisher",
    "pos": "YELLOW",
    "explanation": "(machine + to polish [contraction])",
    "isCharacter": false,
    "composition": [
      15406,
      "/",
      12610,
      "/",
      22386
    ]
  },
  {
    "id": "22391",
    "description": "vacuum_cleaner",
    "pos": "YELLOW",
    "explanation": "(machine + to clean)",
    "isCharacter": false,
    "composition": [
      15406,
      "/",
      17449,
      "/",
      14647,
      "/",
      14133,
      "/",
      13867
    ]
  },
  {
    "id": "22392",
    "description": "mixer,blender",
    "pos": "YELLOW",
    "explanation": "(machine + mixture)",
    "isCharacter": false,
    "composition": [
      15406,
      "/",
      22377
    ]
  },
  {
    "id": "22393",
    "description": "food_processor,kitchen_machine",
    "pos": "YELLOW",
    "explanation": "(machine + cooking,cookery,preparation_(general))",
    "isCharacter": false,
    "composition": [
      15406,
      "/",
      23583,
      "/",
      14377
    ]
  },
  {
    "id": "22394",
    "description": "opener",
    "pos": "YELLOW",
    "explanation": "(tool + to open)",
    "isCharacter": false,
    "composition": [
      17755,
      "/",
      15923
    ]
  },
  {
    "id": "22395",
    "description": "bottle_opener",
    "pos": "YELLOW",
    "explanation": "(opener + bottle)",
    "isCharacter": false,
    "composition": [
      17755,
      "/",
      15923,
      "/",
      12880
    ]
  },
  {
    "id": "22396",
    "description": "can_opener",
    "pos": "YELLOW",
    "explanation": "(opener + can)",
    "isCharacter": false,
    "composition": [
      17755,
      "/",
      15923,
      "/",
      20528
    ]
  },
  {
    "id": "22397",
    "description": "cleaning_tool",
    "pos": "YELLOW",
    "explanation": "(tool + to clean)",
    "isCharacter": false,
    "composition": [
      17755,
      "/",
      17449,
      "/",
      14647,
      "/",
      14133,
      "/",
      13867
    ]
  },
  {
    "id": "22398",
    "description": "cleaning_cloth",
    "pos": "YELLOW",
    "explanation": "(cloth + to clean)",
    "isCharacter": false,
    "composition": [
      13365,
      "/",
      17449,
      "/",
      14647,
      "/",
      14133,
      "/",
      13867
    ]
  },
  {
    "id": "22561",
    "description": "kitchen_tool,utensil",
    "pos": "YELLOW",
    "explanation": "(hand + food [modification]: tool for food]) - Character (superimposed - modified)",
    "isCharacter": true
  },
  {
    "id": "22562",
    "description": "grater,grinder",
    "pos": "YELLOW",
    "explanation": "(kitchen tool + to cut + piece)",
    "isCharacter": false,
    "composition": [
      22561,
      "/",
      15159,
      "/",
      15972
    ]
  },
  {
    "id": "22563",
    "description": "whisk,beater",
    "pos": "YELLOW",
    "explanation": "(kitchen tool + to mix)",
    "isCharacter": false,
    "composition": [
      22561,
      "/",
      22377
    ]
  },
  {
    "id": "22564",
    "description": "corkscrew",
    "pos": "YELLOW",
    "explanation": "(kitchen tool + screw)",
    "isCharacter": false,
    "composition": [
      22561,
      "/",
      16739
    ]
  },
  {
    "id": "22565",
    "description": "kitchen_tongs",
    "pos": "YELLOW",
    "explanation": "(kitchen tool + tongs)",
    "isCharacter": false,
    "composition": [
      22561,
      "/",
      16205
    ]
  },
  {
    "id": "22566",
    "description": "nutcracker",
    "pos": "YELLOW",
    "explanation": "(kitchen tool + nut)",
    "isCharacter": false,
    "composition": [
      22561,
      "/",
      16749,
      "/",
      17775
    ]
  },
  {
    "id": "22567",
    "description": "reaching_aid,grabber",
    "pos": "YELLOW",
    "explanation": "(aid + to bring + thing indicator)",
    "isCharacter": false,
    "composition": [
      14704,
      ";",
      9009,
      "/",
      24714
    ]
  },
  {
    "id": "22568",
    "description": "measuring_spoon",
    "pos": "YELLOW",
    "explanation": "(spoon + to measure)",
    "isCharacter": false,
    "composition": [
      17233,
      "/",
      15443
    ]
  },
  {
    "id": "22569",
    "description": "teaspoon",
    "pos": "YELLOW",
    "explanation": "(spoon + small)",
    "isCharacter": false,
    "composition": [
      17233,
      "/",
      24917
    ]
  },
  {
    "id": "22570",
    "description": "tablespoon",
    "pos": "YELLOW",
    "explanation": "(spoon + big)",
    "isCharacter": false,
    "composition": [
      17233,
      "/",
      24875
    ]
  },
  {
    "id": "22571",
    "description": "serving_spoon",
    "pos": "YELLOW",
    "explanation": "(spoon + to give)",
    "isCharacter": false,
    "composition": [
      17233,
      "/",
      24903
    ]
  },
  {
    "id": "22572",
    "description": "mixing_spoon",
    "pos": "YELLOW",
    "explanation": "(spoon + to mix)",
    "isCharacter": false,
    "composition": [
      17233,
      "/",
      22377
    ]
  },
  {
    "id": "22573",
    "description": "ladle",
    "pos": "YELLOW",
    "explanation": "(spoon + container: spoon with deep bowl for serving liquids)",
    "isCharacter": false,
    "composition": [
      17233,
      "/",
      13403
    ]
  },
  {
    "id": "22574",
    "description": "funnel",
    "pos": "YELLOW",
    "explanation": "(pictograph)  - Character",
    "isCharacter": true
  },
  {
    "id": "22575",
    "description": "oven_tray",
    "pos": "YELLOW",
    "explanation": "(tray + oven)",
    "isCharacter": false,
    "composition": [
      17773,
      "/",
      17273
    ]
  },
  {
    "id": "22576",
    "description": "baking_tin,baking_pan,ovenware",
    "pos": "YELLOW",
    "explanation": "(container + oven)",
    "isCharacter": false,
    "composition": [
      13403,
      "/",
      17273
    ]
  },
  {
    "id": "22577",
    "description": "stovetop",
    "pos": "YELLOW",
    "explanation": "(stove + pointer, to the top)  - Character (superimposed - pointer)",
    "isCharacter": true
  },
  {
    "id": "22578",
    "description": "cup",
    "pos": "YELLOW",
    "explanation": "(pictograph)  - Character",
    "isCharacter": true
  },
  {
    "id": "22579",
    "description": "saucepan",
    "pos": "YELLOW",
    "explanation": "(pictograph)  - Character",
    "isCharacter": true
  },
  {
    "id": "22580",
    "description": "electric_pan",
    "pos": "YELLOW",
    "explanation": "(pan + electricity)",
    "isCharacter": false,
    "composition": [
      16229,
      "/",
      "RK:-2",
      "/",
      13918
    ]
  },
  {
    "id": "22581",
    "description": "frying_pan",
    "pos": "YELLOW",
    "explanation": "(pan + oil)",
    "isCharacter": false,
    "composition": [
      16229,
      "/",
      15914
    ]
  },
  {
    "id": "22582",
    "description": "woking",
    "pos": "YELLOW",
    "explanation": "(wok,wok_pan + oil)",
    "isCharacter": false,
    "composition": [
      25635,
      "/",
      15914
    ]
  },
  {
    "id": "22583",
    "description": "lid",
    "pos": "YELLOW",
    "explanation": "(pictograph)  - Character",
    "isCharacter": true
  },
  {
    "id": "22584",
    "description": "pot,kettle,boiler",
    "pos": "YELLOW",
    "explanation": "(pictograph)  - Character",
    "isCharacter": true
  },
  {
    "id": "22585",
    "description": "deep_fryer",
    "pos": "YELLOW",
    "explanation": "(pot + oil + electricity)",
    "isCharacter": false,
    "composition": [
      22584,
      "/",
      15914,
      "/",
      13918
    ]
  },
  {
    "id": "22586",
    "description": "steamer",
    "pos": "YELLOW",
    "explanation": "(pot + steam)",
    "isCharacter": false,
    "composition": [
      22584,
      "/",
      17255
    ]
  },
  {
    "id": "22587",
    "description": "electric_kettle",
    "pos": "YELLOW",
    "explanation": "(pitcher,jug,kettle,pot + electricity)",
    "isCharacter": false,
    "composition": [
      16191,
      "/",
      13918
    ]
  },
  {
    "id": "22588",
    "description": "storage_jar,preserving_jar",
    "pos": "YELLOW",
    "explanation": "(can + future)",
    "isCharacter": false,
    "composition": [
      20528,
      "/",
      14417
    ]
  },
  {
    "id": "22589",
    "description": "glass_jar",
    "pos": "YELLOW",
    "explanation": "(can + glass)",
    "isCharacter": false,
    "composition": [
      20528,
      "/",
      14442
    ]
  },
  {
    "id": "22590",
    "description": "tin,can",
    "pos": "YELLOW",
    "explanation": "(can + metal [contraction])",
    "isCharacter": false,
    "composition": [
      20528,
      "/",
      23150
    ]
  },
  {
    "id": "22591",
    "description": "cookie_jar,biscuit_tin",
    "pos": "YELLOW",
    "explanation": "(can + cookie/biscuit)",
    "isCharacter": false,
    "composition": [
      20528,
      "/",
      13685,
      "/",
      17506,
      "/",
      17983
    ]
  },
  {
    "id": "22592",
    "description": "rolling_pin",
    "pos": "YELLOW",
    "explanation": "(pictograph)  - Character",
    "isCharacter": true
  },
  {
    "id": "22593",
    "description": "hot_tray,chafing_dish",
    "pos": "YELLOW",
    "explanation": "(tray + hot)",
    "isCharacter": false,
    "composition": [
      17773,
      "/",
      14696
    ]
  },
  {
    "id": "22594",
    "description": "table_mat,placemat",
    "pos": "YELLOW",
    "explanation": "(protection + table)",
    "isCharacter": false,
    "composition": [
      16420,
      "/",
      17493
    ]
  },
  {
    "id": "22595",
    "description": "pot_stand,trivet",
    "pos": "YELLOW",
    "explanation": "(protection + table + hot)",
    "isCharacter": false,
    "composition": [
      16420,
      "/",
      17493,
      "/",
      14696
    ]
  },
  {
    "id": "22596",
    "description": "potholder,oven_mitt",
    "pos": "YELLOW",
    "explanation": "(protection + hand + hot)",
    "isCharacter": false,
    "composition": [
      16420,
      "/",
      14667,
      "/",
      14696
    ]
  },
  {
    "id": "22597",
    "description": "dish_gloves,rubber_gloves",
    "pos": "YELLOW",
    "explanation": "(protection + hand + water)",
    "isCharacter": false,
    "composition": [
      16420,
      "/",
      14667,
      "/",
      18209
    ]
  },
  {
    "id": "22598",
    "description": "equator",
    "pos": "YELLOW",
    "explanation": "(earth + pointer, to the equator)  - Character (superimposed - pointer)",
    "isCharacter": true
  },
  {
    "id": "22599",
    "description": "South_Pole",
    "pos": "YELLOW",
    "explanation": "(earth + pointer, to the south pole)  - Character (superimposed - pointer)",
    "isCharacter": true
  },
  {
    "id": "22600",
    "description": "North_Pole",
    "pos": "YELLOW",
    "explanation": "(earth + pointer, to the north pole)  - Character (superimposed - pointer)",
    "isCharacter": true
  },
  {
    "id": "22601",
    "description": "continent",
    "pos": "YELLOW",
    "explanation": "(part of + earth)",
    "isCharacter": false,
    "composition": [
      15972,
      "/",
      13900
    ]
  },
  {
    "id": "22602",
    "description": "Africa",
    "pos": "YELLOW",
    "explanation": "(part of + equator: should be understood as a combination of continent and equator)",
    "isCharacter": false,
    "composition": [
      15972,
      "/",
      22598
    ]
  },
  {
    "id": "22603",
    "description": "Antarctic",
    "pos": "YELLOW",
    "explanation": "(part of + South Pole: should be understood as a combination of continent and South Pole)",
    "isCharacter": false,
    "composition": [
      15972,
      "/",
      22599
    ]
  },
  {
    "id": "22604",
    "description": "Asia",
    "pos": "YELLOW",
    "explanation": "(continent + east)",
    "isCharacter": false,
    "composition": [
      15972,
      "/",
      13900,
      "/",
      13902
    ]
  },
  {
    "id": "22605",
    "description": "Australia",
    "pos": "YELLOW",
    "explanation": "(continent + south + east)",
    "isCharacter": false,
    "composition": [
      15972,
      "/",
      13900,
      "/",
      17219,
      "/",
      13902
    ]
  },
  {
    "id": "22606",
    "description": "Europe",
    "pos": "YELLOW",
    "explanation": "(continent + north)",
    "isCharacter": false,
    "composition": [
      15972,
      "/",
      13900,
      "/",
      15730
    ]
  },
  {
    "id": "22607",
    "description": "North_America",
    "pos": "YELLOW",
    "explanation": "(continent + north + west)",
    "isCharacter": false,
    "composition": [
      15972,
      "/",
      13900,
      "/",
      15730,
      "/",
      18224
    ]
  },
  {
    "id": "22608",
    "description": "South_America",
    "pos": "YELLOW",
    "explanation": "(continent + south + west)",
    "isCharacter": false,
    "composition": [
      15972,
      "/",
      13900,
      "/",
      17219,
      "/",
      18224
    ]
  },
  {
    "id": "22609",
    "description": "Belgium",
    "pos": "YELLOW",
    "explanation": "(country + strong + intensity: acc. to Caesar, Belgians were the bravest of all people in the Roman empire)",
    "isCharacter": false,
    "composition": [
      13423,
      "/",
      24941,
      "/",
      14947
    ]
  },
  {
    "id": "22610",
    "description": "England",
    "pos": "YELLOW",
    "explanation": "(country + rose)",
    "isCharacter": false,
    "composition": [
      13423,
      "/",
      14205,
      "/",
      15399
    ]
  },
  {
    "id": "22611",
    "description": "rose",
    "pos": "YELLOW",
    "explanation": "(flower + love)",
    "isCharacter": false,
    "composition": [
      14205,
      "/",
      15399
    ]
  },
  {
    "id": "22612",
    "description": "Norway",
    "pos": "YELLOW",
    "explanation": "(country + fjord)",
    "isCharacter": false,
    "composition": [
      13423,
      "/",
      22613
    ]
  },
  {
    "id": "22613",
    "description": "fjord",
    "pos": "YELLOW",
    "explanation": "(water_(ground_level) + mountain: a long and narrow inlet of the sea in between steep mountains)  - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "22614",
    "description": "Scotland",
    "pos": "YELLOW",
    "explanation": "(country + cloth: cloth representing tartan)",
    "isCharacter": false,
    "composition": [
      13423,
      "/",
      13365
    ]
  },
  {
    "id": "22615",
    "description": "South_Africa",
    "pos": "YELLOW",
    "explanation": "(country + springbok)",
    "isCharacter": false,
    "composition": [
      13423,
      "/",
      12379,
      "/",
      23550
    ]
  },
  {
    "id": "22616",
    "description": "springbok",
    "pos": "YELLOW",
    "explanation": "(animal_(bovine,ovine),bovid,bovine + to jump)",
    "isCharacter": false,
    "composition": [
      12379,
      "/",
      23550
    ]
  },
  {
    "id": "22617",
    "description": "Sweden",
    "pos": "YELLOW",
    "explanation": "(country + three + crown: three crowns have been the symbol for Sweden since The Middle-Ages)",
    "isCharacter": false,
    "composition": [
      13423,
      "/",
      8499,
      "/",
      22618
    ]
  },
  {
    "id": "22618",
    "description": "crown",
    "pos": "YELLOW",
    "explanation": "(pictograph)  - Character",
    "isCharacter": true
  },
  {
    "id": "22619",
    "description": "The_Nordic_countries",
    "pos": "YELLOW",
    "explanation": "(five + country + north)",
    "isCharacter": false,
    "composition": [
      8501,
      "/",
      13423,
      "/",
      15730
    ]
  },
  {
    "id": "22620",
    "description": "earthquake",
    "pos": "YELLOW",
    "explanation": "(earth + to shake + intensity)",
    "isCharacter": false,
    "composition": [
      13901,
      "/",
      20524,
      "/",
      14947
    ]
  },
  {
    "id": "22621",
    "description": "continental_drift",
    "pos": "YELLOW",
    "explanation": "(continent + back and forth)",
    "isCharacter": false,
    "composition": [
      15972,
      "/",
      13900,
      "/",
      12610
    ]
  },
  {
    "id": "22622",
    "description": "waterfall",
    "pos": "YELLOW",
    "explanation": "(water + to fall)",
    "isCharacter": false,
    "composition": [
      18209,
      "/",
      13869,
      "/",
      14947
    ]
  },
  {
    "id": "22623",
    "description": "rapid(s)",
    "pos": "YELLOW",
    "explanation": "(river + intensity + stone: part of a river moving fast over rocks in the river bed)",
    "isCharacter": false,
    "composition": [
      16677,
      "/",
      14947,
      "/",
      17267
    ]
  },
  {
    "id": "22624",
    "description": "tidal_wave",
    "pos": "YELLOW",
    "explanation": "(wave + enormous)",
    "isCharacter": false,
    "composition": [
      21880,
      "/",
      24875,
      "/",
      14947,
      "/",
      14947
    ]
  },
  {
    "id": "22625",
    "description": "inlet",
    "pos": "YELLOW",
    "explanation": "(earth + water_(ground_level) + earth: an arm of water reaching into land)  - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "22626",
    "description": "tide",
    "pos": "YELLOW",
    "explanation": "(sea + back and forth: daily variations in surface levels of oceans)",
    "isCharacter": false,
    "composition": [
      14647,
      "/",
      14647,
      "/",
      25777,
      "/",
      12610
    ]
  },
  {
    "id": "22627",
    "description": "low_tide,ebb",
    "pos": "YELLOW",
    "explanation": "(tide + low)",
    "isCharacter": false,
    "composition": [
      14647,
      "/",
      14647,
      "/",
      25777,
      "/",
      12610,
      "/",
      24918
    ]
  },
  {
    "id": "22628",
    "description": "high_tide",
    "pos": "YELLOW",
    "explanation": "(tide + high)",
    "isCharacter": false,
    "composition": [
      14647,
      "/",
      14647,
      "/",
      25777,
      "/",
      12610,
      "/",
      24909
    ]
  },
  {
    "id": "22629",
    "description": "low_water",
    "pos": "YELLOW",
    "explanation": "(sea + low)",
    "isCharacter": false,
    "composition": [
      14647,
      "/",
      14647,
      "/",
      25777,
      "/",
      24918
    ]
  },
  {
    "id": "22630",
    "description": "high_water",
    "pos": "YELLOW",
    "explanation": "(sea + high)",
    "isCharacter": false,
    "composition": [
      14647,
      "/",
      14647,
      "/",
      25777,
      "/",
      24909
    ]
  },
  {
    "id": "22631",
    "description": "spring_(water)",
    "pos": "YELLOW",
    "explanation": "(water (ground level) + up)",
    "isCharacter": false,
    "composition": [
      25777,
      "/",
      17983
    ]
  },
  {
    "id": "22632",
    "description": "hot_spring",
    "pos": "YELLOW",
    "explanation": "(spring water + hot)",
    "isCharacter": false,
    "composition": [
      25777,
      "/",
      17983,
      "/",
      14696
    ]
  },
  {
    "id": "22633",
    "description": "constellation_of_stars",
    "pos": "YELLOW",
    "explanation": "(group of + star)",
    "isCharacter": false,
    "composition": [
      14647,
      "/",
      17252
    ]
  },
  {
    "id": "22634",
    "description": "light_year",
    "pos": "YELLOW",
    "explanation": "(distance [contraction] + light + year)",
    "isCharacter": false,
    "composition": [
      15443,
      "/",
      15208,
      "/",
      18289
    ]
  },
  {
    "id": "22635",
    "description": "telescope",
    "pos": "YELLOW",
    "explanation": "(tool + to see + star)",
    "isCharacter": false,
    "composition": [
      17755,
      "/",
      14133,
      "/",
      17252
    ]
  },
  {
    "id": "22636",
    "description": "astrology",
    "pos": "YELLOW",
    "explanation": "(knowledge + star + person: knowledge of stars as they relate to human beings)",
    "isCharacter": false,
    "composition": [
      15162,
      "/",
      17252,
      "/",
      16161
    ]
  },
  {
    "id": "22637",
    "description": "weather_forecast",
    "pos": "YELLOW",
    "explanation": "(prediction + weather)",
    "isCharacter": false,
    "composition": [
      15666,
      "/",
      14417,
      "/",
      18214
    ]
  },
  {
    "id": "22638",
    "description": "Aries_(in_zodiac)",
    "pos": "YELLOW",
    "explanation": "(constellation_of_stars + ram)",
    "isCharacter": false,
    "composition": [
      14647,
      "/",
      17252,
      "/",
      12379,
      "/",
      13365,
      "/",
      12335
    ]
  },
  {
    "id": "22639",
    "description": "Taurus_(in_zodiac)",
    "pos": "YELLOW",
    "explanation": "(constellation_of_stars + bull)",
    "isCharacter": false,
    "composition": [
      14647,
      "/",
      17252,
      "/",
      12379,
      "/",
      12335
    ]
  },
  {
    "id": "22640",
    "description": "Cancer_(in_zodiac)",
    "pos": "YELLOW",
    "explanation": "(constellation_of_stars + crab,shellfish_(with_claws))",
    "isCharacter": false,
    "composition": [
      14647,
      "/",
      17252,
      "/",
      15226
    ]
  },
  {
    "id": "22641",
    "description": "Leo_(in_zodiac)",
    "pos": "YELLOW",
    "explanation": "(constellation_of_stars + lion)",
    "isCharacter": false,
    "composition": [
      14647,
      "/",
      17252,
      "/",
      12383,
      "/",
      25580
    ]
  },
  {
    "id": "22642",
    "description": "Virgo_(in_zodiac)",
    "pos": "YELLOW",
    "explanation": "(constellation_of_stars + woman,female)",
    "isCharacter": false,
    "composition": [
      14647,
      "/",
      17252,
      "/",
      18269
    ]
  },
  {
    "id": "22643",
    "description": "Libra_(in_zodiac)",
    "pos": "YELLOW",
    "explanation": "(constellation_of_stars + weight_(a))",
    "isCharacter": false,
    "composition": [
      14647,
      "/",
      17252,
      "/",
      18221,
      ";",
      9009
    ]
  },
  {
    "id": "22644",
    "description": "Scorpio_(in_zodiac)",
    "pos": "YELLOW",
    "explanation": "(constellation_of_stars + scorpion)",
    "isCharacter": false,
    "composition": [
      14647,
      "/",
      17252,
      "/",
      17229,
      "/",
      16212
    ]
  },
  {
    "id": "22645",
    "description": "Sagittarius_(in_zodiac)",
    "pos": "YELLOW",
    "explanation": "(constellation_of_stars + man + bow_and_arrow)",
    "isCharacter": false,
    "composition": [
      14647,
      "/",
      17252,
      "/",
      15416,
      "/",
      21855
    ]
  },
  {
    "id": "22646",
    "description": "Capricorn_(in_zodiac)",
    "pos": "YELLOW",
    "explanation": "(constellation_of_stars + animal_(bovine,ovine),bovid,bovine + stone,rock)",
    "isCharacter": false,
    "composition": [
      14647,
      "/",
      17252,
      "/",
      12379,
      "/",
      17267
    ]
  },
  {
    "id": "22647",
    "description": "Aquarius_(in_zodiac)",
    "pos": "YELLOW",
    "explanation": "(constellation_of_stars + man + water)",
    "isCharacter": false,
    "composition": [
      14647,
      "/",
      17252,
      "/",
      15416,
      "/",
      18209
    ]
  },
  {
    "id": "22648",
    "description": "Pisces_(in_zodiac)",
    "pos": "YELLOW",
    "explanation": "(constellation_of_stars + fish_(animal))",
    "isCharacter": false,
    "composition": [
      14647,
      "/",
      17252,
      "/",
      14188
    ]
  },
  {
    "id": "22649",
    "description": "Nordic_God,Nordic_Goddess",
    "pos": "BLUE",
    "explanation": "(God + north)",
    "isCharacter": false,
    "composition": [
      14451,
      "/",
      15730
    ]
  },
  {
    "id": "22650",
    "description": "Woden",
    "pos": "BLUE",
    "explanation": "(Nordic God + eye: Woden gave away one eye in exchange for wisdom)",
    "isCharacter": false,
    "composition": [
      14451,
      "/",
      15730,
      "/",
      14133
    ]
  },
  {
    "id": "22651",
    "description": "Frigg",
    "pos": "BLUE",
    "explanation": "(wife + Woden)",
    "isCharacter": false,
    "composition": [
      18251,
      "/",
      14451,
      "/",
      15730,
      "/",
      14133
    ]
  },
  {
    "id": "22652",
    "description": "Thor",
    "pos": "BLUE",
    "explanation": "(Nordic God + hammer: the God of thunder; his hammer made the lightning)",
    "isCharacter": false,
    "composition": [
      14451,
      "/",
      15730,
      "/",
      14666
    ]
  },
  {
    "id": "22653",
    "description": "Sif",
    "pos": "BLUE",
    "explanation": "(wife + Thor)",
    "isCharacter": false,
    "composition": [
      18251,
      "/",
      14451,
      "/",
      15730,
      "/",
      14666
    ]
  },
  {
    "id": "22654",
    "description": "Mjolnir",
    "pos": "BLUE",
    "explanation": "(hammer + Nordic God: Thor's hammer)",
    "isCharacter": false,
    "composition": [
      14666,
      "/",
      14451,
      "/",
      15730
    ]
  },
  {
    "id": "22655",
    "description": "Gemini_(in_zodiac)",
    "pos": "YELLOW",
    "explanation": "(constellation_of_stars + twins)",
    "isCharacter": false,
    "composition": [
      14647,
      "/",
      17252,
      "/",
      8498,
      "/",
      16161,
      "/",
      16713,
      "/",
      12843
    ]
  },
  {
    "id": "22817",
    "description": "Balder",
    "pos": "BLUE",
    "explanation": "(Nordic God + light: the God of light and goodness)",
    "isCharacter": false,
    "composition": [
      14451,
      "/",
      15730,
      "/",
      15208
    ]
  },
  {
    "id": "22818",
    "description": "Frey",
    "pos": "BLUE",
    "explanation": "(Nordic God + plant: the God of growing power)",
    "isCharacter": false,
    "composition": [
      14451,
      "/",
      15730,
      "/",
      16196
    ]
  },
  {
    "id": "22819",
    "description": "Freya",
    "pos": "BLUE",
    "explanation": "(Nordic_God,Nordic_Goddess + love: the Goddess of love)",
    "isCharacter": false,
    "composition": [
      14451,
      "/",
      15730,
      "/",
      15399
    ]
  },
  {
    "id": "22820",
    "description": "Tyr",
    "pos": "BLUE",
    "explanation": "(Nordic God + war: the God of war)",
    "isCharacter": false,
    "composition": [
      14451,
      "/",
      15730,
      "/",
      18036
    ]
  },
  {
    "id": "22821",
    "description": "Aegir",
    "pos": "BLUE",
    "explanation": "(Nordic God + sea: the God of the sea)",
    "isCharacter": false,
    "composition": [
      14451,
      "/",
      15730,
      "/",
      14647,
      "/",
      14647,
      "/",
      25777
    ]
  },
  {
    "id": "22822",
    "description": "Loki_(OLD)",
    "pos": "BLUE",
    "explanation": "(Nordic God + lie_(OLD): the God of falseness)  SUPERSEDED SYNONYM  See Loki 26016",
    "isCharacter": false,
    "composition": [
      14451,
      "/",
      15730,
      "/",
      15927,
      "/",
      17786
    ]
  },
  {
    "id": "22823",
    "description": "Hugin_and_Munin",
    "pos": "YELLOW",
    "explanation": "(2 + bird + Nordic God: two ravens belonging to Woden)",
    "isCharacter": false,
    "composition": [
      8498,
      "/",
      12837,
      "/",
      14451,
      "/",
      15730
    ]
  },
  {
    "id": "22824",
    "description": "Sleipnir",
    "pos": "YELLOW",
    "explanation": "(horse + Nordic God: Woden's horse)",
    "isCharacter": false,
    "composition": [
      14897,
      "/",
      14451,
      "/",
      15730
    ]
  },
  {
    "id": "22825",
    "description": "Saehrimnir",
    "pos": "YELLOW",
    "explanation": "(pig/boar + Nordic God: a boar which was slaughtered every evening and healthy again every morning)",
    "isCharacter": false,
    "composition": [
      16175,
      "/",
      14451,
      "/",
      15730
    ]
  },
  {
    "id": "22826",
    "description": "Midgard's_serpent",
    "pos": "YELLOW",
    "explanation": "(snake + past time + north: a big snake curled around the world to keep it together)",
    "isCharacter": false,
    "composition": [
      17189,
      "/",
      15975,
      "/",
      15730
    ]
  },
  {
    "id": "22827",
    "description": "Valhalla",
    "pos": "YELLOW",
    "explanation": "(house + Nordic God: home of the Gods)",
    "isCharacter": false,
    "composition": [
      14905,
      "/",
      14451,
      "/",
      15730
    ]
  },
  {
    "id": "22828",
    "description": "Viking",
    "pos": "BLUE",
    "explanation": "(man + horns + sword)",
    "isCharacter": false,
    "composition": [
      15416,
      "/",
      21061,
      "/",
      15159
    ]
  },
  {
    "id": "22829",
    "description": "Viking_ship",
    "pos": "YELLOW",
    "explanation": "(boat + viking [contraction])",
    "isCharacter": false,
    "composition": [
      12869,
      "/",
      21061,
      "/",
      15159
    ]
  },
  {
    "id": "22830",
    "description": "runes",
    "pos": "YELLOW",
    "explanation": "(alphabet + past + north)",
    "isCharacter": false,
    "composition": [
      "Xa",
      "/",
      "Xb",
      "/",
      "Xc",
      "/",
      15975,
      "/",
      15730
    ]
  },
  {
    "id": "22831",
    "description": "offer,sacrifice-(to)",
    "pos": "RED",
    "explanation": "(to give + Nordic God + action indicator: to make a sacrifice the Gods)",
    "isCharacter": false,
    "composition": [
      24903,
      ";",
      8993,
      "/",
      14451,
      "/",
      15730
    ]
  },
  {
    "id": "22832",
    "description": "sacrifice",
    "pos": "YELLOW",
    "explanation": "(gift + Nordic God)",
    "isCharacter": false,
    "composition": [
      17717,
      "/",
      24903,
      "/",
      14451,
      "/",
      15730
    ]
  },
  {
    "id": "22833",
    "description": "blot",
    "pos": "YELLOW",
    "explanation": "(gathering + to sacrifice: ancient Scandinavian gathering to sacrifice to the Nordic Gods)",
    "isCharacter": false,
    "composition": [
      14427,
      "/",
      24903,
      "/",
      14451,
      "/",
      15730
    ]
  },
  {
    "id": "22834",
    "description": "planet",
    "pos": "YELLOW",
    "explanation": "(pictograph: symbol suggests the planet rotating on its horizontal axis) - Character",
    "isCharacter": true
  },
  {
    "id": "22835",
    "description": "lawn_bowling,bowls_(sport)",
    "pos": "YELLOW",
    "explanation": "(bowling_(sport) + lawn)",
    "isCharacter": false,
    "composition": [
      20518,
      "/",
      25524,
      "/",
      15180
    ]
  },
  {
    "id": "22836",
    "description": "solar_system",
    "pos": "YELLOW",
    "explanation": "(all + planet)",
    "isCharacter": false,
    "composition": [
      12360,
      "/",
      22834
    ]
  },
  {
    "id": "22837",
    "description": "pod,seedcase,seedpod",
    "pos": "YELLOW",
    "explanation": "(pictograph) - Character",
    "isCharacter": true
  },
  {
    "id": "22839",
    "description": "saddle",
    "pos": "YELLOW",
    "explanation": "(seat + horse)",
    "isCharacter": false,
    "composition": [
      16165,
      "/",
      14897
    ]
  },
  {
    "id": "22840",
    "description": "court,field,sport_field",
    "pos": "YELLOW",
    "explanation": "(place + sport)  Preferred NEW SYNONYM, replacing 13428",
    "isCharacter": false,
    "composition": [
      16193,
      "/",
      20518
    ]
  },
  {
    "id": "22841",
    "description": "burial_site",
    "pos": "YELLOW",
    "explanation": "(place + under_(ground_level))",
    "isCharacter": false,
    "composition": [
      16193,
      "/",
      25628
    ]
  },
  {
    "id": "22901",
    "description": "astrologer,astrologist",
    "pos": "BLUE",
    "explanation": "(person + astrology)",
    "isCharacter": false,
    "composition": [
      16161,
      "/",
      15162,
      "/",
      17252,
      "/",
      16161
    ]
  },
  {
    "id": "22903",
    "description": "beauty",
    "pos": "YELLOW",
    "explanation": "(eye + happiness,fun,joy,pleasure: pleasing to the eye)",
    "isCharacter": false,
    "composition": [
      14133,
      "/",
      14164,
      "/",
      17983
    ]
  },
  {
    "id": "22904",
    "description": "call,telephone,ring-(to)",
    "pos": "RED",
    "explanation": "(telephone + action indicator)",
    "isCharacter": false,
    "composition": [
      15172,
      ";",
      8993,
      "/",
      13918
    ]
  },
  {
    "id": "22905",
    "description": "chocolate",
    "pos": "YELLOW",
    "explanation": "(food + bean + up (sweet [contraction]))  Preferred NEW SYNONYM, replacing 13171",
    "isCharacter": false,
    "composition": [
      14377,
      "/",
      12642,
      "/",
      17983
    ]
  },
  {
    "id": "22906",
    "description": "chocolate_spread",
    "pos": "YELLOW",
    "explanation": "(spread + chocolate [contraction])  Preferred NEW SYNONYM, replacing 13174",
    "isCharacter": false,
    "composition": [
      17238,
      "/",
      12642,
      "/",
      17983
    ]
  },
  {
    "id": "22907",
    "description": "cook,chef",
    "pos": "BLUE",
    "explanation": "(person + cooking,cookery,preparation_(general))",
    "isCharacter": false,
    "composition": [
      16161,
      "/",
      23583,
      "/",
      14377
    ]
  },
  {
    "id": "22908",
    "description": "cooking,cookery,preparation_(hot_food)",
    "pos": "YELLOW",
    "explanation": "(fire + food: to use fire (heat) to prepare food)",
    "isCharacter": false,
    "composition": [
      14183,
      "/",
      14377
    ]
  },
  {
    "id": "22909",
    "description": "cooking,cookery,preparation_(general)",
    "pos": "YELLOW",
    "explanation": "(to make + food)",
    "isCharacter": false,
    "composition": [
      23583,
      "/",
      14377
    ]
  },
  {
    "id": "22910",
    "description": "dirt,soil",
    "pos": "YELLOW",
    "explanation": "(many + spot: many spots of dirt)",
    "isCharacter": false,
    "composition": [
      14647,
      "/",
      14133,
      "/",
      13867
    ]
  },
  {
    "id": "22911",
    "description": "doubt,uncertainty",
    "pos": "YELLOW",
    "explanation": "(to think + what,question_mark)  - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "22912",
    "description": "fear,fright,concern",
    "pos": "YELLOW",
    "explanation": "(sadness + future_(uncertain): concern about the future because of its uncertainties)",
    "isCharacter": false,
    "composition": [
      14164,
      "/",
      13869,
      "/",
      25568
    ]
  },
  {
    "id": "22913",
    "description": "leadership,guidance",
    "pos": "YELLOW",
    "explanation": "(mind + forward [modification, short arrow]: the use of mental powers to carry events or persons forward)  - Character (superimposed - modified)",
    "isCharacter": true
  },
  {
    "id": "22914",
    "description": "must_(a)",
    "pos": "YELLOW",
    "explanation": "(mind + strong [modification]: the use of the power of the mind, and/or physical strength, to make something happen)  - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "22915",
    "description": "religious_(God_based)",
    "pos": "GREEN",
    "explanation": "(religion_(God_based) + description indicator)  SYNONYM",
    "isCharacter": false,
    "composition": [
      20561,
      ";",
      8998
    ]
  },
  {
    "id": "22916",
    "description": "self-harming",
    "pos": "GREEN",
    "explanation": "(self-harm + description indicator)",
    "isCharacter": false,
    "composition": [
      22914,
      ";",
      8998,
      "/",
      14947,
      "/",
      8497,
      "/",
      15214
    ]
  },
  {
    "id": "22917",
    "description": "smartness,brightness,cleverness,intelligence",
    "pos": "YELLOW",
    "explanation": "(mind + intensity: striking mental abilities)",
    "isCharacter": false,
    "composition": [
      15471,
      "/",
      14947
    ]
  },
  {
    "id": "22918",
    "description": "uncertain,unsure",
    "pos": "GREEN",
    "explanation": "(doubt,uncertainty + description indicator)",
    "isCharacter": false,
    "composition": [
      22911,
      ";",
      8998
    ]
  },
  {
    "id": "23001",
    "description": "accusation",
    "pos": "YELLOW",
    "explanation": "(to speak + opposition)",
    "isCharacter": false,
    "composition": [
      15666,
      "/",
      15928
    ]
  },
  {
    "id": "23002",
    "description": "accusation_(legal),charge,prosecution",
    "pos": "YELLOW",
    "explanation": "(accusation + judgement,law_(in_combinations))",
    "isCharacter": false,
    "composition": [
      15666,
      "/",
      15928,
      "/",
      23127
    ]
  },
  {
    "id": "23003",
    "description": "accuse-(to)",
    "pos": "RED",
    "explanation": "(accusation + action indicator)",
    "isCharacter": false,
    "composition": [
      15666,
      ";",
      8993,
      "/",
      15928
    ]
  },
  {
    "id": "23004",
    "description": "accuse_(legal),charge,prosecute-(to)",
    "pos": "RED",
    "explanation": "(accusation + judgement,law_(in_combinations) + action indicator)",
    "isCharacter": false,
    "composition": [
      15666,
      ";",
      8993,
      "/",
      15928,
      "/",
      23127
    ]
  },
  {
    "id": "23005",
    "description": "act,demonstrate_(in_favour_of)-(to)",
    "pos": "RED",
    "explanation": "(action,demonstration_(in_favour_of) + action indicator)",
    "isCharacter": false,
    "composition": [
      12335,
      ";",
      8993,
      "/",
      16437
    ]
  },
  {
    "id": "23006",
    "description": "act_in_favour_of_(legal)-(to)",
    "pos": "RED",
    "explanation": "(action,demonstration_(in_favour_of) + judgement,law_(in_combinations) + action indicator)",
    "isCharacter": false,
    "composition": [
      12335,
      ";",
      8993,
      "/",
      16437,
      "/",
      23127
    ]
  },
  {
    "id": "23007",
    "description": "action,demonstration_(in_favour_of)",
    "pos": "YELLOW",
    "explanation": "(activity + purpose)",
    "isCharacter": false,
    "composition": [
      12335,
      "/",
      16437
    ]
  },
  {
    "id": "23008",
    "description": "activity_centre",
    "pos": "YELLOW",
    "explanation": "(building + activity)",
    "isCharacter": false,
    "composition": [
      14905,
      "/",
      12335
    ]
  },
  {
    "id": "23009",
    "description": "activity_centre_(children)",
    "pos": "YELLOW",
    "explanation": "(activity centre + child)",
    "isCharacter": false,
    "composition": [
      14905,
      "/",
      12335,
      "/",
      13166
    ]
  },
  {
    "id": "23010",
    "description": "activity_centre_(leisure_time),after_school_club,youth_club",
    "pos": "YELLOW",
    "explanation": "(activity centre + freedom)",
    "isCharacter": false,
    "composition": [
      14905,
      "/",
      12335,
      "/",
      14396
    ]
  },
  {
    "id": "23011",
    "description": "activity_centre_(teenagers)",
    "pos": "YELLOW",
    "explanation": "(activity centre + teenager)",
    "isCharacter": false,
    "composition": [
      14905,
      "/",
      12335,
      "/",
      17516
    ]
  },
  {
    "id": "23012",
    "description": "advocate",
    "pos": "BLUE",
    "explanation": "(person + action in favour of)",
    "isCharacter": false,
    "composition": [
      16161,
      "/",
      12335,
      "/",
      16437
    ]
  },
  {
    "id": "23013",
    "description": "advocate-(to)",
    "pos": "RED",
    "explanation": "(advocacy + action indicator: to speak for a purpose)",
    "isCharacter": false,
    "composition": [
      15666,
      ";",
      8993,
      "/",
      16437
    ]
  },
  {
    "id": "23014",
    "description": "advocate_(legal)",
    "pos": "BLUE",
    "explanation": "(legal person + action in favour of)",
    "isCharacter": false,
    "composition": [
      16161,
      "/",
      23127,
      "/",
      12335,
      "/",
      16437
    ]
  },
  {
    "id": "23015",
    "description": "advocate_(legal)-(to)",
    "pos": "RED",
    "explanation": "(advocate-(to) + judgement,law_(in_combinations) + action indicator)",
    "isCharacter": false,
    "composition": [
      15666,
      ";",
      8993,
      "/",
      16437,
      "/",
      23127
    ]
  },
  {
    "id": "23016",
    "description": "advocate_(legal,speaking)",
    "pos": "BLUE",
    "explanation": "(legal person + advocate-(to))",
    "isCharacter": false,
    "composition": [
      16161,
      "/",
      23127,
      "/",
      15666,
      "/",
      16437
    ]
  },
  {
    "id": "23017",
    "description": "advocate_(speaking),spokesperson",
    "pos": "BLUE",
    "explanation": "(person + advocate-(to))",
    "isCharacter": false,
    "composition": [
      16161,
      "/",
      15666,
      "/",
      16437
    ]
  },
  {
    "id": "23018",
    "description": "altimeter",
    "pos": "YELLOW",
    "explanation": "(gauge + high + thing indicator)",
    "isCharacter": false,
    "composition": [
      24806,
      ";",
      9009,
      "/",
      24909
    ]
  },
  {
    "id": "23019",
    "description": "anemometer",
    "pos": "YELLOW",
    "explanation": "(gauge + wind + thing indicator)",
    "isCharacter": false,
    "composition": [
      24806,
      ";",
      9009,
      "/",
      18255
    ]
  },
  {
    "id": "23020",
    "description": "angle_(measurement)",
    "pos": "YELLOW",
    "explanation": "(measurement + angle)",
    "isCharacter": false,
    "composition": [
      15443,
      "/",
      12376
    ]
  },
  {
    "id": "23021",
    "description": "any_day,someday",
    "pos": "YELLOW",
    "explanation": "(a + day)",
    "isCharacter": false,
    "composition": [
      12321,
      "/",
      13639
    ]
  },
  {
    "id": "23022",
    "description": "apartment_block",
    "pos": "YELLOW",
    "explanation": "(many + many + floor,storey,level,etage)",
    "isCharacter": false,
    "composition": [
      14647,
      "/",
      14647,
      "/",
      23085
    ]
  },
  {
    "id": "23023",
    "description": "archipelago",
    "pos": "YELLOW",
    "explanation": "(group of + island)",
    "isCharacter": false,
    "composition": [
      14647,
      "/",
      14958
    ]
  },
  {
    "id": "23024",
    "description": "area_(measurement)",
    "pos": "YELLOW",
    "explanation": "(measurement + enclosure)",
    "isCharacter": false,
    "composition": [
      15443,
      "/",
      13934
    ]
  },
  {
    "id": "23025",
    "description": "arrest-(to)",
    "pos": "RED",
    "explanation": "(capture,catch,seize-(to) + judgement,law_(in_combinations) + action indicator)",
    "isCharacter": false,
    "composition": [
      24727,
      ";",
      8993,
      "/",
      14947,
      "/",
      23127
    ]
  },
  {
    "id": "23026",
    "description": "attic",
    "pos": "YELLOW",
    "explanation": "(building_with_attic + pointer, to the attic)  - Character (superimposed - pointer)",
    "isCharacter": true
  },
  {
    "id": "23027",
    "description": "bakery",
    "pos": "YELLOW",
    "explanation": "(store + bread)",
    "isCharacter": false,
    "composition": [
      23223,
      "/",
      12895
    ]
  },
  {
    "id": "23028",
    "description": "barometer,manometer",
    "pos": "YELLOW",
    "explanation": "(gauge + pressure + air + thing indicator)",
    "isCharacter": false,
    "composition": [
      24806,
      ";",
      9009,
      "/",
      23169,
      "/",
      12356
    ]
  },
  {
    "id": "23029",
    "description": "basement,cellar",
    "pos": "YELLOW",
    "explanation": "(building_with_cellar + pointer, to cellar)  - Character (superimposed - pointer)",
    "isCharacter": true
  },
  {
    "id": "23030",
    "description": "biology_(class)",
    "pos": "YELLOW",
    "explanation": "(class [contraction] + biology [contraction])",
    "isCharacter": false,
    "composition": [
      15162,
      "/",
      15206
    ]
  },
  {
    "id": "23031",
    "description": "Bliss,Bliss_language,Blissymbolics",
    "pos": "YELLOW",
    "explanation": "(language + Blissymbol)",
    "isCharacter": false,
    "composition": [
      15172,
      "/",
      12857
    ]
  },
  {
    "id": "23032",
    "description": "Bliss_(class)",
    "pos": "YELLOW",
    "explanation": "(class [contraction] + Bliss language)",
    "isCharacter": false,
    "composition": [
      15162,
      "/",
      15172,
      "/",
      12857
    ]
  },
  {
    "id": "23033",
    "description": "board-(to)",
    "pos": "RED",
    "explanation": "(board_and_lodging,room_and_board + action indicator)",
    "isCharacter": false,
    "composition": [
      14905,
      ";",
      8993,
      "/",
      12374,
      "/",
      14377
    ]
  },
  {
    "id": "23034",
    "description": "bookshop",
    "pos": "YELLOW",
    "explanation": "(store + book)",
    "isCharacter": false,
    "composition": [
      23223,
      "/",
      12875
    ]
  },
  {
    "id": "23035",
    "description": "bronze",
    "pos": "YELLOW",
    "explanation": "(metal [contraction] + tin [contraction] + copper [contraction])",
    "isCharacter": false,
    "composition": [
      23150,
      "/",
      13621,
      "/",
      16229
    ]
  },
  {
    "id": "23036",
    "description": "bronze_age",
    "pos": "YELLOW",
    "explanation": "(past time + bronze [contraction])",
    "isCharacter": false,
    "composition": [
      15975,
      "/",
      13621,
      "/",
      16229
    ]
  },
  {
    "id": "23037",
    "description": "butcher_shop",
    "pos": "YELLOW",
    "explanation": "(store + meat)",
    "isCharacter": false,
    "composition": [
      23223,
      "/",
      14377,
      "/",
      12378
    ]
  },
  {
    "id": "23038",
    "description": "care_centre",
    "pos": "YELLOW",
    "explanation": "(house + protection)",
    "isCharacter": false,
    "composition": [
      14905,
      "/",
      16420
    ]
  },
  {
    "id": "23039",
    "description": "cheap,inexpensive",
    "pos": "GREEN",
    "explanation": "(price + small + description indicator)  Preferred NEW SYNONYM, replacing 13155",
    "isCharacter": false,
    "composition": [
      15484,
      ";",
      8998,
      "/",
      14381,
      "/",
      17717,
      "/",
      24917
    ]
  },
  {
    "id": "23040",
    "description": "chemistry_(class)",
    "pos": "YELLOW",
    "explanation": "(class [contraction] + chemistry [contraction])",
    "isCharacter": false,
    "composition": [
      15162,
      "/",
      13158
    ]
  },
  {
    "id": "23041",
    "description": "clerk,legal_aid",
    "pos": "BLUE",
    "explanation": "(helper + judgement,law_(in_combinations))",
    "isCharacter": false,
    "composition": [
      16161,
      "/",
      14704,
      "/",
      23127
    ]
  },
  {
    "id": "23042",
    "description": "clothing_shop",
    "pos": "YELLOW",
    "explanation": "(store + clothing)",
    "isCharacter": false,
    "composition": [
      23223,
      "/",
      13366
    ]
  },
  {
    "id": "23043",
    "description": "cockerel,rooster",
    "pos": "YELLOW",
    "explanation": "(chicken + male)",
    "isCharacter": false,
    "composition": [
      12837,
      "/",
      14377,
      "/",
      12335
    ]
  },
  {
    "id": "23044",
    "description": "cod,codfish",
    "pos": "YELLOW",
    "explanation": "(fish + pictograph of beard)  - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "23045",
    "description": "control_tower",
    "pos": "YELLOW",
    "explanation": "(tower + airplane)",
    "isCharacter": false,
    "composition": [
      23240,
      "/",
      12357
    ]
  },
  {
    "id": "23046",
    "description": "copper",
    "pos": "YELLOW",
    "explanation": "(metal [contraction] + pot + past time)",
    "isCharacter": false,
    "composition": [
      23150,
      "/",
      16229,
      "/",
      15975
    ]
  },
  {
    "id": "23047",
    "description": "corridor,hall",
    "pos": "YELLOW",
    "explanation": "(room + long)",
    "isCharacter": false,
    "composition": [
      16687,
      "/",
      15193
    ]
  },
  {
    "id": "23048",
    "description": "cotton",
    "pos": "YELLOW",
    "explanation": "(material + flower,bloom,blossom + cloth: textile fibre made from the boll of the cotton plant)",
    "isCharacter": false,
    "composition": [
      15431,
      "/",
      25563,
      "/",
      13365
    ]
  },
  {
    "id": "23049",
    "description": "cotton_fabric",
    "pos": "YELLOW",
    "explanation": "(cloth + flower,bloom,blossom: fabric woven from cotton fibre [contraction] )",
    "isCharacter": false,
    "composition": [
      13365,
      "/",
      25563
    ]
  },
  {
    "id": "23050",
    "description": "count",
    "pos": "YELLOW",
    "explanation": "(measurement + number)",
    "isCharacter": false,
    "composition": [
      15443,
      "/",
      15742
    ]
  },
  {
    "id": "23051",
    "description": "court,courthouse",
    "pos": "YELLOW",
    "explanation": "(building + judgement,law_(in_combinations))",
    "isCharacter": false,
    "composition": [
      14905,
      "/",
      23127
    ]
  },
  {
    "id": "23052",
    "description": "court,courtroom",
    "pos": "YELLOW",
    "explanation": "(public room + judgement,law_(in_combinations))",
    "isCharacter": false,
    "composition": [
      16430,
      "/",
      23127
    ]
  },
  {
    "id": "23053",
    "description": "crayfish",
    "pos": "YELLOW",
    "explanation": "(crab, shellfish with claws + small)",
    "isCharacter": false,
    "composition": [
      15226,
      "/",
      24917
    ]
  },
  {
    "id": "23054",
    "description": "day_and_night",
    "pos": "YELLOW",
    "explanation": "(24 + hour)",
    "isCharacter": false,
    "composition": [
      8498,
      "/",
      "RK:-1",
      "/",
      8500,
      "/",
      17732,
      "/",
      8490
    ]
  },
  {
    "id": "23055",
    "description": "day_centre",
    "pos": "YELLOW",
    "explanation": "(activity centre + day)",
    "isCharacter": false,
    "composition": [
      14905,
      "/",
      12335,
      "/",
      13639
    ]
  },
  {
    "id": "23056",
    "description": "care,protection,defence",
    "pos": "YELLOW",
    "explanation": "(activity + protection)",
    "isCharacter": false,
    "composition": [
      12335,
      "/",
      16420
    ]
  },
  {
    "id": "23057",
    "description": "defence_(legal)",
    "pos": "YELLOW",
    "explanation": "(to speak + to defend + judgement,law_(in_combinations))",
    "isCharacter": false,
    "composition": [
      15666,
      "/",
      12335,
      "/",
      16420,
      "/",
      23127
    ]
  },
  {
    "id": "23058",
    "description": "defence_(spoken)",
    "pos": "YELLOW",
    "explanation": "(to speak + to protect)",
    "isCharacter": false,
    "composition": [
      15666,
      "/",
      16420
    ]
  },
  {
    "id": "23059",
    "description": "care,protect,defend-(to)",
    "pos": "RED",
    "explanation": "(defence + action indicator)",
    "isCharacter": false,
    "composition": [
      12335,
      ";",
      8993,
      "/",
      16420
    ]
  },
  {
    "id": "23060",
    "description": "defend_(legal)-(to)",
    "pos": "RED",
    "explanation": "(defence_(legal) + action indicator)",
    "isCharacter": false,
    "composition": [
      15666,
      ";",
      8993,
      "/",
      12335,
      "/",
      16420,
      "/",
      23127
    ]
  },
  {
    "id": "23061",
    "description": "defend_(speak)-(to)",
    "pos": "RED",
    "explanation": "(defence_(spoken) + action indicator)",
    "isCharacter": false,
    "composition": [
      15666,
      ";",
      8993,
      "/",
      16420
    ]
  },
  {
    "id": "23062",
    "description": "defend_(speak,legal)-(to)",
    "pos": "RED",
    "explanation": "(defence_(spoken) + judgement,law_(in_combinations) + action indicator)",
    "isCharacter": false,
    "composition": [
      15666,
      ";",
      8993,
      "/",
      16420,
      "/",
      23127
    ]
  },
  {
    "id": "23063",
    "description": "caregiver,protector,defender",
    "pos": "BLUE",
    "explanation": "(person + care,protection,defence)",
    "isCharacter": false,
    "composition": [
      16161,
      "/",
      12335,
      "/",
      16420
    ]
  },
  {
    "id": "23064",
    "description": "deflation",
    "pos": "YELLOW",
    "explanation": "(value + money + plus: money will be worth more)",
    "isCharacter": false,
    "composition": [
      13949,
      "/",
      15484,
      "/",
      12374
    ]
  },
  {
    "id": "23065",
    "description": "act,demonstrate_(against)-(to)",
    "pos": "RED",
    "explanation": "(action,demonstration_(against) + action indicator)",
    "isCharacter": false,
    "composition": [
      12335,
      ";",
      8993,
      "/",
      15928
    ]
  },
  {
    "id": "23066",
    "description": "action,demonstration_(against)",
    "pos": "YELLOW",
    "explanation": "(action + opposition,counter_purpose)",
    "isCharacter": false,
    "composition": [
      12335,
      "/",
      15928
    ]
  },
  {
    "id": "23067",
    "description": "department_store",
    "pos": "YELLOW",
    "explanation": "(store + many + part)",
    "isCharacter": false,
    "composition": [
      23223,
      "/",
      14647,
      "/",
      15972
    ]
  },
  {
    "id": "23068",
    "description": "discount",
    "pos": "YELLOW",
    "explanation": "(price + minus)",
    "isCharacter": false,
    "composition": [
      15484,
      "/",
      14381,
      "/",
      17717,
      "/",
      15474
    ]
  },
  {
    "id": "23069",
    "description": "discount_sale",
    "pos": "YELLOW",
    "explanation": "(event + discount)",
    "isCharacter": false,
    "composition": [
      14114,
      "/",
      15484,
      "/",
      14381,
      "/",
      17717,
      "/",
      15474
    ]
  },
  {
    "id": "23070",
    "description": "discount_store",
    "pos": "YELLOW",
    "explanation": "(store + discount [contraction])",
    "isCharacter": false,
    "composition": [
      23223,
      "/",
      14381,
      "/",
      17717,
      "/",
      15474
    ]
  },
  {
    "id": "23071",
    "description": "distance_(OLD)",
    "pos": "YELLOW",
    "explanation": "(measurement + farness,remoteness,farawayness_(OLD))    SUPERSEDED SYNONYM  See distance 25996",
    "isCharacter": false,
    "composition": [
      15443,
      "/",
      24896
    ]
  },
  {
    "id": "23072",
    "description": "drugstore,pharmacy",
    "pos": "YELLOW",
    "explanation": "(store + medical)",
    "isCharacter": false,
    "composition": [
      23223,
      "/",
      24920
    ]
  },
  {
    "id": "23073",
    "description": "eaves",
    "pos": "YELLOW",
    "explanation": "(protection_with_pointer + thing indicator: roof with a pointer to the eaves)  - (character with thing indicator)",
    "isCharacter": "false",
    "composition": [
      25598,
      ";",
      9009
    ]
  },
  {
    "id": "23074",
    "description": "economics_(class)",
    "pos": "YELLOW",
    "explanation": "(class [contraction] + business)",
    "isCharacter": false,
    "composition": [
      15162,
      "/",
      13093
    ]
  },
  {
    "id": "23075",
    "description": "electricity_meter",
    "pos": "YELLOW",
    "explanation": "(gauge + electricity + thing indicator)",
    "isCharacter": false,
    "composition": [
      24806,
      ";",
      9009,
      "/",
      13918
    ]
  },
  {
    "id": "23076",
    "description": "elementary_school,primary_school",
    "pos": "YELLOW",
    "explanation": "(school [contraction] + child)  Use appropriate specifier for other stages of schools",
    "isCharacter": false,
    "composition": [
      14905,
      "/",
      15162,
      "/",
      13166
    ]
  },
  {
    "id": "23077",
    "description": "English_(class)",
    "pos": "YELLOW",
    "explanation": "(class [contraction] + English)",
    "isCharacter": false,
    "composition": [
      15162,
      "/",
      15172,
      "/",
      14205,
      "/",
      15399
    ]
  },
  {
    "id": "23078",
    "description": "English_(language)",
    "pos": "YELLOW",
    "explanation": "(language + England [contraction])",
    "isCharacter": false,
    "composition": [
      15172,
      "/",
      14205,
      "/",
      15399
    ]
  },
  {
    "id": "23079",
    "description": "evidence",
    "pos": "YELLOW",
    "explanation": "(fact + judgement,law_(in_combinations))",
    "isCharacter": false,
    "composition": [
      14139,
      "/",
      23127
    ]
  },
  {
    "id": "23080",
    "description": "expensive",
    "pos": "GREEN",
    "explanation": "(price + big + description indicator)  Preferred NEW SYNONYM, replacing 14129",
    "isCharacter": false,
    "composition": [
      15484,
      ";",
      8998,
      "/",
      14381,
      "/",
      17717,
      "/",
      24875
    ]
  },
  {
    "id": "23081",
    "description": "just,fair",
    "pos": "GREEN",
    "explanation": "(judgement + same/equal + description indicator)",
    "isCharacter": false,
    "composition": [
      23127,
      ";",
      8998,
      "/",
      16713
    ]
  },
  {
    "id": "23082",
    "description": "fine_(penalty)",
    "pos": "YELLOW",
    "explanation": "(money + after + guilt)",
    "isCharacter": false,
    "composition": [
      15484,
      "/",
      12348,
      "/",
      23127,
      "/",
      15474,
      "/",
      14947
    ]
  },
  {
    "id": "23083",
    "description": "flatfish",
    "pos": "YELLOW",
    "explanation": "(fish + low)",
    "isCharacter": false,
    "composition": [
      14188,
      "/",
      24918
    ]
  },
  {
    "id": "23084",
    "description": "flax",
    "pos": "YELLOW",
    "explanation": "(material + stalk + cloth: textile fibre made from the stalk of the flax plant)",
    "isCharacter": false,
    "composition": [
      15431,
      "/",
      17259,
      "/",
      13365
    ]
  },
  {
    "id": "23085",
    "description": "floor,storey,level,etage",
    "pos": "YELLOW",
    "explanation": "(building_with_storey + pointer)  - Character (superimposed - pointer)",
    "isCharacter": true
  },
  {
    "id": "23086",
    "description": "floor_(42nd)",
    "pos": "YELLOW",
    "explanation": "(storey + 42)  Use appropriate number for other floors.",
    "isCharacter": false,
    "composition": [
      23085,
      "/",
      8500,
      "/",
      "RK:-1",
      "/",
      8498
    ]
  },
  {
    "id": "23087",
    "description": "floor_(first)",
    "pos": "YELLOW",
    "explanation": "(storey + one)   Use appropriate number for other floors.",
    "isCharacter": false,
    "composition": [
      23085,
      "/",
      8497
    ]
  },
  {
    "id": "23088",
    "description": "florist",
    "pos": "YELLOW",
    "explanation": "(store + flower)",
    "isCharacter": false,
    "composition": [
      23223,
      "/",
      14205
    ]
  },
  {
    "id": "23089",
    "description": "foundation_(building)",
    "pos": "YELLOW",
    "explanation": "(building_with_foundation + pointer (to foundation))  - Character (superimposed - pointer)",
    "isCharacter": true
  },
  {
    "id": "23090",
    "description": "fuel_gauge",
    "pos": "YELLOW",
    "explanation": "(gauge + gasoline + thing indicator)",
    "isCharacter": false,
    "composition": [
      24806,
      ";",
      9009,
      "/",
      18209,
      "/",
      18232
    ]
  },
  {
    "id": "23091",
    "description": "garden_centre",
    "pos": "YELLOW",
    "explanation": "(store + garden)",
    "isCharacter": false,
    "composition": [
      23223,
      "/",
      14422
    ]
  },
  {
    "id": "23092",
    "description": "gauge,gage,meter",
    "pos": "YELLOW",
    "explanation": "(scale,measurement + thing indicator)  - (character with thing indicator)",
    "isCharacter": "false",
    "composition": [
      24806,
      ";",
      9009
    ]
  },
  {
    "id": "23093",
    "description": "geography",
    "pos": "YELLOW",
    "explanation": "(body of learning + earth)",
    "isCharacter": false,
    "composition": [
      16735,
      "/",
      13900
    ]
  },
  {
    "id": "23094",
    "description": "geography_(class)",
    "pos": "YELLOW",
    "explanation": "(class [contraction] + geography [contraction])",
    "isCharacter": false,
    "composition": [
      15162,
      "/",
      13900
    ]
  },
  {
    "id": "23095",
    "description": "geology_(class)",
    "pos": "YELLOW",
    "explanation": "(science + earth: scientific study of the origins, history and structure of the earth)",
    "isCharacter": false,
    "composition": [
      15162,
      "/",
      13901
    ]
  },
  {
    "id": "23096",
    "description": "gift_shop",
    "pos": "YELLOW",
    "explanation": "(store + gift)",
    "isCharacter": false,
    "composition": [
      23223,
      "/",
      17717,
      "/",
      24903
    ]
  },
  {
    "id": "23097",
    "description": "goat",
    "pos": "YELLOW",
    "explanation": "(ovine + pictograph of beard)  - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "23098",
    "description": "God_the_father",
    "pos": "BLUE",
    "explanation": "(God + father)",
    "isCharacter": false,
    "composition": [
      14451,
      "/",
      14157
    ]
  },
  {
    "id": "23099",
    "description": "God_the_son",
    "pos": "BLUE",
    "explanation": "(God + son)",
    "isCharacter": false,
    "composition": [
      14451,
      "/",
      17209
    ]
  },
  {
    "id": "23100",
    "description": "gold",
    "pos": "YELLOW",
    "explanation": "(metal [contraction] + ring)",
    "isCharacter": false,
    "composition": [
      23150,
      "/",
      16675
    ]
  },
  {
    "id": "23101",
    "description": "greengrocer",
    "pos": "YELLOW",
    "explanation": "(store + vegetable)",
    "isCharacter": false,
    "composition": [
      23223,
      "/",
      18004
    ]
  },
  {
    "id": "23102",
    "description": "grocery_store,food_store,supermarket",
    "pos": "YELLOW",
    "explanation": "(store + food)  Preferred NEW SYNONYM, replacing 14645",
    "isCharacter": false,
    "composition": [
      23223,
      "/",
      14377
    ]
  },
  {
    "id": "23103",
    "description": "gutter,eaves_trough",
    "pos": "YELLOW",
    "explanation": "(container + eaves + thing indicator)",
    "isCharacter": false,
    "composition": [
      13403,
      "/",
      25598,
      ";",
      9009
    ]
  },
  {
    "id": "23104",
    "description": "half_an_hour",
    "pos": "YELLOW",
    "explanation": "(30 + minute)",
    "isCharacter": false,
    "composition": [
      8499,
      "/",
      "RK:-1",
      "/",
      8496,
      "/",
      17732,
      "/",
      8489
    ]
  },
  {
    "id": "23105",
    "description": "hall",
    "pos": "YELLOW",
    "explanation": "(place + between + room: space between rooms)",
    "isCharacter": false,
    "composition": [
      16193,
      "/",
      12669,
      "/",
      16687
    ]
  },
  {
    "id": "23106",
    "description": "handicraft_shop",
    "pos": "YELLOW",
    "explanation": "(store + craft)",
    "isCharacter": false,
    "composition": [
      23223,
      "/",
      23583,
      "/",
      "RK:-2",
      "/",
      14667
    ]
  },
  {
    "id": "23107",
    "description": "handwriting,penmanship_(class)",
    "pos": "YELLOW",
    "explanation": "(knowledge (class [contraction]) + write + hand)",
    "isCharacter": false,
    "composition": [
      15162,
      "/",
      15991,
      "/",
      "RK:-2",
      "/",
      14667
    ]
  },
  {
    "id": "23108",
    "description": "health_goods_shop",
    "pos": "YELLOW",
    "explanation": "(store + health)",
    "isCharacter": false,
    "composition": [
      23223,
      "/",
      14690
    ]
  },
  {
    "id": "23109",
    "description": "Hebrew_(class)",
    "pos": "YELLOW",
    "explanation": "(knowledge (class [contraction]) + Hebrew)",
    "isCharacter": false,
    "composition": [
      15162,
      "/",
      15172,
      "/",
      17251
    ]
  },
  {
    "id": "23110",
    "description": "Hebrew_(language)",
    "pos": "YELLOW",
    "explanation": "(language + Jewish (Israel [contraction]))",
    "isCharacter": false,
    "composition": [
      15172,
      "/",
      17251
    ]
  },
  {
    "id": "23111",
    "description": "herb,spice_plant",
    "pos": "YELLOW",
    "explanation": "(plant + taste)",
    "isCharacter": false,
    "composition": [
      16196,
      "/",
      17506
    ]
  },
  {
    "id": "23112",
    "description": "history_(class)",
    "pos": "YELLOW",
    "explanation": "(knowledge + past: (class [contraction] + history [contraction])",
    "isCharacter": false,
    "composition": [
      15162,
      "/",
      15975
    ]
  },
  {
    "id": "23113",
    "description": "history_teacher",
    "pos": "BLUE",
    "explanation": "(person + history (class): teacher [contraction] + history [contraction])",
    "isCharacter": false,
    "composition": [
      16161,
      "/",
      15162,
      "/",
      15975
    ]
  },
  {
    "id": "23114",
    "description": "Holy_Spirit",
    "pos": "BLUE",
    "explanation": "(God + fire)",
    "isCharacter": false,
    "composition": [
      14451,
      "/",
      14183
    ]
  },
  {
    "id": "23115",
    "description": "Holy_Trinity",
    "pos": "YELLOW",
    "explanation": "(God + three + life)",
    "isCharacter": false,
    "composition": [
      14451,
      "/",
      8499,
      "/",
      15206
    ]
  },
  {
    "id": "23116",
    "description": "horizontal",
    "pos": "GREEN",
    "explanation": "(horizontal-(a) + description indicator)",
    "isCharacter": false,
    "composition": [
      23117,
      ";",
      8998
    ]
  },
  {
    "id": "23117",
    "description": "horizontal-(a)",
    "pos": "YELLOW",
    "explanation": "(right angle + pointer to horizontal arm of angle)  - Character (superimposed - pointer)",
    "isCharacter": true
  },
  {
    "id": "23118",
    "description": "illegal,criminal",
    "pos": "GREEN",
    "explanation": "(without + law + description indicator)",
    "isCharacter": false,
    "composition": [
      15474,
      "/",
      23127,
      ";",
      8998,
      "/",
      15962
    ]
  },
  {
    "id": "23119",
    "description": "inflation",
    "pos": "YELLOW",
    "explanation": "(value + money + minus: money will be worth less)",
    "isCharacter": false,
    "composition": [
      13949,
      "/",
      15484,
      "/",
      15474
    ]
  },
  {
    "id": "23120",
    "description": "innocence",
    "pos": "YELLOW",
    "explanation": "(judgement + positive: in a trial a person who is judged positively is judged not guilty)",
    "isCharacter": false,
    "composition": [
      23127,
      "/",
      12374,
      "/",
      14947
    ]
  },
  {
    "id": "23121",
    "description": "innocent,not_guilty",
    "pos": "GREEN",
    "explanation": "(innocence + description indicator)",
    "isCharacter": false,
    "composition": [
      23127,
      ";",
      8998,
      "/",
      12374,
      "/",
      14947
    ]
  },
  {
    "id": "23122",
    "description": "iron",
    "pos": "YELLOW",
    "explanation": "(metal [contraction] + nail)",
    "isCharacter": false,
    "composition": [
      23150,
      "/",
      15689
    ]
  },
  {
    "id": "23123",
    "description": "iron_age",
    "pos": "YELLOW",
    "explanation": "(past time + nail (iron [contraction]))",
    "isCharacter": false,
    "composition": [
      15975,
      "/",
      15689
    ]
  },
  {
    "id": "23124",
    "description": "jellyfish",
    "pos": "YELLOW",
    "explanation": "(water creature + pictograph of jellyfish tentacles) - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "23125",
    "description": "judge",
    "pos": "BLUE",
    "explanation": "(legal person + above/superior: a person who presides over legal proceedings and hands down a judgement)",
    "isCharacter": false,
    "composition": [
      16161,
      "/",
      23127,
      "/",
      15948
    ]
  },
  {
    "id": "23126",
    "description": "judge-(to)",
    "pos": "RED",
    "explanation": "(judgement + action indicator)",
    "isCharacter": false,
    "composition": [
      23127,
      ";",
      8993
    ]
  },
  {
    "id": "23127",
    "description": "judgement,law_(in_combinations)",
    "pos": "YELLOW",
    "explanation": "(mind + weight [modification, shorter horizontal line]: the mind weighs something to reach a judgement)  - Character (superimposed - modified)",
    "isCharacter": true
  },
  {
    "id": "23128",
    "description": "juridical",
    "pos": "GREEN",
    "explanation": "(judgement + description indicator)",
    "isCharacter": false,
    "composition": [
      23127,
      ";",
      8998
    ]
  },
  {
    "id": "23129",
    "description": "jury",
    "pos": "YELLOW",
    "explanation": "(group of + peer + legal [contraction]: a group of persons equal in standing before the law to the person being tried)",
    "isCharacter": false,
    "composition": [
      14647,
      "/",
      16161,
      "/",
      16713,
      "/",
      23127
    ]
  },
  {
    "id": "23130",
    "description": "justice",
    "pos": "YELLOW",
    "explanation": "(judgement + same/equal)",
    "isCharacter": false,
    "composition": [
      23127,
      "/",
      16713
    ]
  },
  {
    "id": "23131",
    "description": "language_(class)",
    "pos": "YELLOW",
    "explanation": "(class [contraction] + language)",
    "isCharacter": false,
    "composition": [
      15162,
      "/",
      15172
    ]
  },
  {
    "id": "23132",
    "description": "law",
    "pos": "YELLOW",
    "explanation": "(science,body_of_learning + judgement,law_(in_combinations)",
    "isCharacter": false,
    "composition": [
      16735,
      "/",
      23127
    ]
  },
  {
    "id": "23133",
    "description": "law-(a)",
    "pos": "YELLOW",
    "explanation": "(legal [contraction] + paper: judgement put into writing or recorded)",
    "isCharacter": false,
    "composition": [
      23127,
      "/",
      15962
    ]
  },
  {
    "id": "23134",
    "description": "law,The_Law",
    "pos": "YELLOW",
    "explanation": "(judgement + book)",
    "isCharacter": false,
    "composition": [
      23127,
      "/",
      12875
    ]
  },
  {
    "id": "23135",
    "description": "lawyer",
    "pos": "BLUE",
    "explanation": "(person + law )",
    "isCharacter": false,
    "composition": [
      16161,
      "/",
      23127,
      "/",
      12875
    ]
  },
  {
    "id": "23136",
    "description": "lawyer_(for_the_defence)",
    "pos": "BLUE",
    "explanation": "(legal person + to speak + to protect)",
    "isCharacter": false,
    "composition": [
      16161,
      "/",
      23127,
      "/",
      15666,
      "/",
      16420
    ]
  },
  {
    "id": "23137",
    "description": "lead",
    "pos": "YELLOW",
    "explanation": "(metal [contraction] + a weight)",
    "isCharacter": false,
    "composition": [
      23150,
      "/",
      18221,
      ";",
      9009
    ]
  },
  {
    "id": "23138",
    "description": "legal",
    "pos": "GREEN",
    "explanation": "(law + description indicator)",
    "isCharacter": false,
    "composition": [
      23127,
      ";",
      8998,
      "/",
      15962
    ]
  },
  {
    "id": "23139",
    "description": "legal_aid",
    "pos": "BLUE",
    "explanation": "(help + legal [contraction])",
    "isCharacter": false,
    "composition": [
      14704,
      "/",
      23127
    ]
  },
  {
    "id": "23140",
    "description": "legal_person_(in_combinations)",
    "pos": "BLUE",
    "explanation": "(person + legal {contr.])  Used in conjunction with a specifier",
    "isCharacter": false,
    "composition": [
      16161,
      "/",
      23127
    ]
  },
  {
    "id": "23141",
    "description": "leisure_time",
    "pos": "YELLOW",
    "explanation": "(time + free)",
    "isCharacter": false,
    "composition": [
      17732,
      "/",
      14396
    ]
  },
  {
    "id": "23142",
    "description": "light_meter",
    "pos": "YELLOW",
    "explanation": "(gauge + light + thing indicator)",
    "isCharacter": false,
    "composition": [
      24806,
      ";",
      9009,
      "/",
      15208
    ]
  },
  {
    "id": "23143",
    "description": "lighthouse",
    "pos": "YELLOW",
    "explanation": "(tower + lamp + thing indicator)",
    "isCharacter": false,
    "composition": [
      23240,
      "/",
      15208,
      ";",
      9009
    ]
  },
  {
    "id": "23144",
    "description": "linen,flax_fabric",
    "pos": "YELLOW",
    "explanation": "(cloth + stalk: fabric woven from flax [contraction] )",
    "isCharacter": false,
    "composition": [
      13365,
      "/",
      17259
    ]
  },
  {
    "id": "23145",
    "description": "liquor_shop,liquor_store",
    "pos": "YELLOW",
    "explanation": "(store + liquor)",
    "isCharacter": false,
    "composition": [
      23223,
      "/",
      12359
    ]
  },
  {
    "id": "23146",
    "description": "lobster",
    "pos": "YELLOW",
    "explanation": "(shellfish with claws + big)",
    "isCharacter": false,
    "composition": [
      15226,
      "/",
      24875
    ]
  },
  {
    "id": "23147",
    "description": "market",
    "pos": "YELLOW",
    "explanation": "(group of + store + limited time)",
    "isCharacter": false,
    "composition": [
      14647,
      "/",
      23223,
      "/",
      15212
    ]
  },
  {
    "id": "23148",
    "description": "math,mathematics_(class)_(1)",
    "pos": "YELLOW",
    "explanation": "(class [contraction] + mathematics [contraction])",
    "isCharacter": false,
    "composition": [
      15162,
      "/",
      15742
    ]
  },
  {
    "id": "23149",
    "description": "mercury",
    "pos": "YELLOW",
    "explanation": "(metal [contraction] + thermometer + thing indicator)",
    "isCharacter": false,
    "composition": [
      23150,
      "/",
      17520,
      ";",
      9009
    ]
  },
  {
    "id": "23150",
    "description": "metal_bar",
    "pos": "YELLOW",
    "explanation": "(thing + thing: a combination of rectangular shape + thing)  - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "23151",
    "description": "city,metropolis",
    "pos": "YELLOW",
    "explanation": "(may + many + many + building)",
    "isCharacter": false,
    "composition": [
      14647,
      "/",
      14647,
      "/",
      14647,
      "/",
      14905
    ]
  },
  {
    "id": "23152",
    "description": "midnight",
    "pos": "YELLOW",
    "explanation": "(hour + 24)",
    "isCharacter": false,
    "composition": [
      17732,
      "/",
      8490,
      "/",
      8498,
      "/",
      "RK:-1",
      "/",
      8500
    ]
  },
  {
    "id": "23153",
    "description": "multi_storey_building",
    "pos": "YELLOW",
    "explanation": "(group of + storey)",
    "isCharacter": false,
    "composition": [
      14647,
      "/",
      23085
    ]
  },
  {
    "id": "23154",
    "description": "multi_storey_home",
    "pos": "YELLOW",
    "explanation": "(group of + combination of storey and home)",
    "isCharacter": false,
    "composition": [
      14647,
      "/",
      23085,
      "/",
      14164
    ]
  },
  {
    "id": "23155",
    "description": "naming_ceremony",
    "pos": "YELLOW",
    "explanation": "(ceremony + name)",
    "isCharacter": false,
    "composition": [
      14114,
      "/",
      16194,
      "/",
      15691
    ]
  },
  {
    "id": "23156",
    "description": "naming_ceremony_(religious)",
    "pos": "YELLOW",
    "explanation": "(religious ceremony + name)",
    "isCharacter": false,
    "composition": [
      14114,
      "/",
      16194,
      "/",
      20563,
      "/",
      15691
    ]
  },
  {
    "id": "23157",
    "description": "noon",
    "pos": "YELLOW",
    "explanation": "(hour + 12)",
    "isCharacter": false,
    "composition": [
      17732,
      "/",
      8490,
      "/",
      8497,
      "/",
      "RK:-1",
      "/",
      8498
    ]
  },
  {
    "id": "23158",
    "description": "notary",
    "pos": "BLUE",
    "explanation": "(person + paper + legal [contraction]: person working with legal issues)",
    "isCharacter": false,
    "composition": [
      16161,
      "/",
      15962,
      "/",
      23127
    ]
  },
  {
    "id": "23159",
    "description": "notary_(lawyer)",
    "pos": "BLUE",
    "explanation": "(legal person + paper: combination of legal person and law)",
    "isCharacter": false,
    "composition": [
      16161,
      "/",
      23127,
      "/",
      15962
    ]
  },
  {
    "id": "23160",
    "description": "octopus",
    "pos": "YELLOW",
    "explanation": "(water creature + eight + arm)",
    "isCharacter": false,
    "composition": [
      23706,
      "/",
      8504,
      "/",
      12577
    ]
  },
  {
    "id": "23161",
    "description": "odometer_(OLD)",
    "pos": "YELLOW",
    "explanation": "(gauge + farness,remoteness,farawayness_(OLD) + thing indicator)    SUPERSEDED SYNONYM  See odometer 26019",
    "isCharacter": false,
    "composition": [
      24806,
      ";",
      9009,
      "/",
      24896
    ]
  },
  {
    "id": "23162",
    "description": "oil_gauge",
    "pos": "YELLOW",
    "explanation": "(gauge + oil + thing indicator)",
    "isCharacter": false,
    "composition": [
      24806,
      ";",
      9009,
      "/",
      15914
    ]
  },
  {
    "id": "23163",
    "description": "one_storey_building,bungalow",
    "pos": "YELLOW",
    "explanation": "(one + storey)",
    "isCharacter": false,
    "composition": [
      8497,
      "/",
      23085
    ]
  },
  {
    "id": "23164",
    "description": "one_storey_home",
    "pos": "YELLOW",
    "explanation": "(one + storey + feeling: 1 + combination of storey and home)",
    "isCharacter": false,
    "composition": [
      8497,
      "/",
      23085,
      "/",
      14164
    ]
  },
  {
    "id": "23165",
    "description": "peer",
    "pos": "BLUE",
    "explanation": "(person + same,equal,equality)",
    "isCharacter": false,
    "composition": [
      16161,
      "/",
      16713
    ]
  },
  {
    "id": "23166",
    "description": "pencil_case,pencil_box",
    "pos": "YELLOW",
    "explanation": "(container + pen,pencil)",
    "isCharacter": false,
    "composition": [
      13403,
      "/",
      15991
    ]
  },
  {
    "id": "23167",
    "description": "physics_(class)",
    "pos": "YELLOW",
    "explanation": "(knowledge + energy: class [contraction] + physics [contraction])",
    "isCharacter": false,
    "composition": [
      15162,
      "/",
      13936
    ]
  },
  {
    "id": "23168",
    "description": "prawn",
    "pos": "YELLOW",
    "explanation": "(shellfish without claws + big)",
    "isCharacter": false,
    "composition": [
      23204,
      "/",
      24875
    ]
  },
  {
    "id": "23169",
    "description": "pressure",
    "pos": "YELLOW",
    "explanation": "(enclosure + up and down: the arrows press against the top and bottom of the enclosure)  - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "23170",
    "description": "pressure_gauge",
    "pos": "YELLOW",
    "explanation": "(gauge + pressure + thing indicator)",
    "isCharacter": false,
    "composition": [
      24806,
      ";",
      9009,
      "/",
      23169
    ]
  },
  {
    "id": "23171",
    "description": "price_rise",
    "pos": "YELLOW",
    "explanation": "(price + plus)",
    "isCharacter": false,
    "composition": [
      15484,
      "/",
      14381,
      "/",
      17717,
      "/",
      12374
    ]
  },
  {
    "id": "23172",
    "description": "promote-(to)",
    "pos": "RED",
    "explanation": "(promotion + action indicator)",
    "isCharacter": false,
    "composition": [
      12335,
      ";",
      8993,
      "/",
      14382
    ]
  },
  {
    "id": "23173",
    "description": "promotion",
    "pos": "YELLOW",
    "explanation": "(activity + in order to)",
    "isCharacter": false,
    "composition": [
      12335,
      "/",
      14382
    ]
  },
  {
    "id": "23176",
    "description": "prosecutor",
    "pos": "BLUE",
    "explanation": "(legal person + to accuse)",
    "isCharacter": false,
    "composition": [
      16161,
      "/",
      23127,
      "/",
      15666,
      "/",
      15928
    ]
  },
  {
    "id": "23177",
    "description": "protest,objection,opposition",
    "pos": "YELLOW",
    "explanation": "(to speak + against)",
    "isCharacter": false,
    "composition": [
      15666,
      "/",
      12351
    ]
  },
  {
    "id": "23178",
    "description": "protest,resist-(to)",
    "pos": "RED",
    "explanation": "(protest + action indicator)",
    "isCharacter": false,
    "composition": [
      12335,
      ";",
      8993,
      "/",
      "RK:-2",
      "/",
      12351
    ]
  },
  {
    "id": "23179",
    "description": "protest,resistance",
    "pos": "YELLOW",
    "explanation": "(activity + against)",
    "isCharacter": false,
    "composition": [
      12335,
      "/",
      "RK:-2",
      "/",
      12351
    ]
  },
  {
    "id": "23180",
    "description": "protractor",
    "pos": "YELLOW",
    "explanation": "(gauge + angle + thing indicator)",
    "isCharacter": false,
    "composition": [
      24806,
      ";",
      9009,
      "/",
      12376
    ]
  },
  {
    "id": "23181",
    "description": "psychologist",
    "pos": "BLUE",
    "explanation": "(person + mind + feeling: person + psychology [contraction])  Preferred NEW SYNONYM, replacing 21587",
    "isCharacter": false,
    "composition": [
      16161,
      "/",
      15471,
      "/",
      14164
    ]
  },
  {
    "id": "23182",
    "description": "psychologist_(researcher)",
    "pos": "BLUE",
    "explanation": "(person + psychology: researcher + psychology [contraction])  Preferred NEW SYNONYM, replacing 21586",
    "isCharacter": false,
    "composition": [
      16161,
      "/",
      16735,
      "/",
      15471,
      "/",
      14164
    ]
  },
  {
    "id": "23183",
    "description": "psychology",
    "pos": "YELLOW",
    "explanation": "(body of knowledge + mind + feeling)  Preferred NEW SYNONYM, replacing 21552",
    "isCharacter": false,
    "composition": [
      16735,
      "/",
      15471,
      "/",
      14164
    ]
  },
  {
    "id": "23184",
    "description": "psychology_teacher",
    "pos": "BLUE",
    "explanation": "(teacher,pedagogue,educator_(in_combinations) + mind + feeling: teacher + psychology [contraction])  Preferred NEW SYNONYM, replacing 21588",
    "isCharacter": false,
    "composition": [
      16161,
      "/",
      15162,
      "/",
      15471,
      "/",
      14164
    ]
  },
  {
    "id": "23185",
    "description": "quarter_of_an_hour",
    "pos": "YELLOW",
    "explanation": "(15 + minute)",
    "isCharacter": false,
    "composition": [
      8497,
      "/",
      "RK:-1",
      "/",
      8501,
      "/",
      17732,
      "/",
      8489
    ]
  },
  {
    "id": "23186",
    "description": "rain_gauge",
    "pos": "YELLOW",
    "explanation": "(gauge + rain + thing indicator)",
    "isCharacter": false,
    "composition": [
      24806,
      ";",
      9009,
      "/",
      16455
    ]
  },
  {
    "id": "23187",
    "description": "reading_(class)",
    "pos": "YELLOW",
    "explanation": "(class [contraction] + reading)",
    "isCharacter": false,
    "composition": [
      15162,
      "/",
      14133,
      "/",
      15962
    ]
  },
  {
    "id": "23188",
    "description": "reading_lesson",
    "pos": "YELLOW",
    "explanation": "(lesson + reading)",
    "isCharacter": false,
    "composition": [
      15212,
      "/",
      15162,
      "/",
      14133,
      "/",
      15962
    ]
  },
  {
    "id": "23189",
    "description": "religion_(class)",
    "pos": "YELLOW",
    "explanation": "(class [contraction] + religion)",
    "isCharacter": false,
    "composition": [
      15162,
      "/",
      20563
    ]
  },
  {
    "id": "23190",
    "description": "religion_(science_of),theology",
    "pos": "YELLOW",
    "explanation": "(body of learning + religion)",
    "isCharacter": false,
    "composition": [
      16735,
      "/",
      20563
    ]
  },
  {
    "id": "23191",
    "description": "religion_teacher",
    "pos": "BLUE",
    "explanation": "(teacher [contraction] + religion)",
    "isCharacter": false,
    "composition": [
      16161,
      "/",
      15162,
      "/",
      20563
    ]
  },
  {
    "id": "23192",
    "description": "religious_service",
    "pos": "YELLOW",
    "explanation": "(service + religion)",
    "isCharacter": false,
    "composition": [
      12335,
      "/",
      16194,
      "/",
      20563
    ]
  },
  {
    "id": "23193",
    "description": "row_house,attached_houses",
    "pos": "YELLOW",
    "explanation": "(semi-detached_house + semi-detached_house: pictograph of attached houses)  - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "23194",
    "description": "sale",
    "pos": "YELLOW",
    "explanation": "(activity + to sell)",
    "isCharacter": false,
    "composition": [
      12335,
      "/",
      17717,
      "/",
      15484
    ]
  },
  {
    "id": "23195",
    "description": "salmon",
    "pos": "YELLOW",
    "explanation": "(fish + jump + river)",
    "isCharacter": false,
    "composition": [
      14188,
      "/",
      23550,
      "/",
      16677
    ]
  },
  {
    "id": "23196",
    "description": "sandwich_(open_face)",
    "pos": "YELLOW",
    "explanation": "(bread + spread)",
    "isCharacter": false,
    "composition": [
      12895,
      "/",
      17238
    ]
  },
  {
    "id": "23197",
    "description": "scale_(weighing)",
    "pos": "YELLOW",
    "explanation": "(gauge + weight + thing indicator)",
    "isCharacter": false,
    "composition": [
      24806,
      ";",
      9009,
      "/",
      18221
    ]
  },
  {
    "id": "23198",
    "description": "school_(in_combinations)",
    "pos": "YELLOW",
    "explanation": "(house + knowledge: house + to teach [contraction])  Used in conjunction with a specifier.",
    "isCharacter": false,
    "composition": [
      14905,
      "/",
      15162
    ]
  },
  {
    "id": "23199",
    "description": "season",
    "pos": "YELLOW",
    "explanation": "(part of + year)",
    "isCharacter": false,
    "composition": [
      15972,
      "/",
      18289
    ]
  },
  {
    "id": "23200",
    "description": "capture,catch,seize-(to)",
    "pos": "RED",
    "explanation": "(to get + intensity + action indicator)",
    "isCharacter": false,
    "composition": [
      24727,
      ";",
      8993,
      "/",
      14947
    ]
  },
  {
    "id": "23201",
    "description": "semi-detached_house",
    "pos": "YELLOW",
    "explanation": "(house + line: the line separating the building into two parts, creating a pictograph of a semi-detached house)  - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "23202",
    "description": "sentence,condemn-(to)",
    "pos": "RED",
    "explanation": "(to say + other + guilty)",
    "isCharacter": false,
    "composition": [
      15666,
      ";",
      8993,
      "/",
      15214,
      "/",
      8498,
      "/",
      23127,
      "/",
      15474,
      "/",
      14947
    ]
  },
  {
    "id": "23203",
    "description": "service_(work)",
    "pos": "YELLOW",
    "explanation": "(activity + plan)",
    "isCharacter": false,
    "composition": [
      12335,
      "/",
      16194
    ]
  },
  {
    "id": "23204",
    "description": "shellfish_(without_claws)",
    "pos": "YELLOW",
    "explanation": "(pictograph) - Character",
    "isCharacter": true
  },
  {
    "id": "23205",
    "description": "sheltered_workshop",
    "pos": "YELLOW",
    "explanation": "(house + protection + work)",
    "isCharacter": false,
    "composition": [
      14905,
      "/",
      16420,
      "/",
      18273
    ]
  },
  {
    "id": "23206",
    "description": "shoal,school_(of_fish)",
    "pos": "YELLOW",
    "explanation": "(group of + fish)",
    "isCharacter": false,
    "composition": [
      14647,
      "/",
      14188
    ]
  },
  {
    "id": "23207",
    "description": "shopping_centre,mall,plaza",
    "pos": "YELLOW",
    "explanation": "(group of + store)  Preferred NEW SYNONYM, replacing 16961",
    "isCharacter": false,
    "composition": [
      14647,
      "/",
      23223
    ]
  },
  {
    "id": "23208",
    "description": "shopping_mall",
    "pos": "YELLOW",
    "explanation": "(building + shopping centre)",
    "isCharacter": false,
    "composition": [
      14905,
      "/",
      14647,
      "/",
      23223
    ]
  },
  {
    "id": "23209",
    "description": "short_time_home",
    "pos": "YELLOW",
    "explanation": "(house + limited time: home [contraction] + limited time)",
    "isCharacter": false,
    "composition": [
      14905,
      "/",
      15212
    ]
  },
  {
    "id": "23210",
    "description": "shrimp",
    "pos": "YELLOW",
    "explanation": "(shellfish without claws + small)",
    "isCharacter": false,
    "composition": [
      23204,
      "/",
      24917
    ]
  },
  {
    "id": "23211",
    "description": "silk",
    "pos": "YELLOW",
    "explanation": "(material + worm + cloth: textile fibre produced by silk worms)",
    "isCharacter": false,
    "composition": [
      15431,
      "/",
      18279,
      "/",
      13365
    ]
  },
  {
    "id": "23212",
    "description": "silk_fabric",
    "pos": "YELLOW",
    "explanation": "(cloth + worm: fabric woven from silk fibre [contraction])",
    "isCharacter": false,
    "composition": [
      13365,
      "/",
      18279
    ]
  },
  {
    "id": "23213",
    "description": "silver",
    "pos": "YELLOW",
    "explanation": "(metal [contraction] + spoon)",
    "isCharacter": false,
    "composition": [
      23150,
      "/",
      17233
    ]
  },
  {
    "id": "23214",
    "description": "size",
    "pos": "YELLOW",
    "explanation": "(measurement + big)",
    "isCharacter": false,
    "composition": [
      15443,
      "/",
      24875
    ]
  },
  {
    "id": "23215",
    "description": "skyscraper",
    "pos": "YELLOW",
    "explanation": "(many + many + many + storey: building with many storeys)",
    "isCharacter": false,
    "composition": [
      14647,
      "/",
      14647,
      "/",
      14647,
      "/",
      23085
    ]
  },
  {
    "id": "23216",
    "description": "speed",
    "pos": "YELLOW",
    "explanation": "(measurement + fast)",
    "isCharacter": false,
    "composition": [
      15443,
      "/",
      14390,
      "/",
      14947
    ]
  },
  {
    "id": "23217",
    "description": "speedometer",
    "pos": "YELLOW",
    "explanation": "(gauge + fast + thing indicator)",
    "isCharacter": false,
    "composition": [
      24806,
      ";",
      9009,
      "/",
      14390,
      "/",
      14947
    ]
  },
  {
    "id": "23218",
    "description": "sport_lesson",
    "pos": "YELLOW",
    "explanation": "(lesson + sport)",
    "isCharacter": false,
    "composition": [
      15212,
      "/",
      15162,
      "/",
      20518
    ]
  },
  {
    "id": "23219",
    "description": "sport_shop",
    "pos": "YELLOW",
    "explanation": "(store + sport)",
    "isCharacter": false,
    "composition": [
      23223,
      "/",
      20518
    ]
  },
  {
    "id": "23220",
    "description": "starfish",
    "pos": "YELLOW",
    "explanation": "(water creature + star)  Preferred NEW SYNONYM, replacing 17253",
    "isCharacter": false,
    "composition": [
      23706,
      "/",
      17252
    ]
  },
  {
    "id": "23221",
    "description": "statement",
    "pos": "YELLOW",
    "explanation": "(to write + to say + legal [contraction]: testimony written down or recorded)",
    "isCharacter": false,
    "composition": [
      15991,
      "/",
      15666,
      "/",
      23127
    ]
  },
  {
    "id": "23222",
    "description": "stone_age",
    "pos": "YELLOW",
    "explanation": "(past + stone)",
    "isCharacter": false,
    "composition": [
      15975,
      "/",
      "RK:-2",
      "/",
      17267
    ]
  },
  {
    "id": "23223",
    "description": "store,shop",
    "pos": "YELLOW",
    "explanation": "(public room + business: public room where money is exchanged for goods)  - Character (superimposed)  Preferred NEW SYNONYM, replacing 17269",
    "isCharacter": true
  },
  {
    "id": "23224",
    "description": "support_(oral)",
    "pos": "YELLOW",
    "explanation": "(to speak + in order to)",
    "isCharacter": false,
    "composition": [
      15666,
      "/",
      14382
    ]
  },
  {
    "id": "23225",
    "description": "support_(orally)-(to)",
    "pos": "RED",
    "explanation": "(support (oral) + action indicator)",
    "isCharacter": false,
    "composition": [
      15666,
      ";",
      8993,
      "/",
      14382
    ]
  },
  {
    "id": "23226",
    "description": "Swedish_(class)",
    "pos": "YELLOW",
    "explanation": "(class [contraction] + Swedish)",
    "isCharacter": false,
    "composition": [
      15162,
      "/",
      15172,
      "/",
      8499,
      "/",
      22618
    ]
  },
  {
    "id": "23227",
    "description": "Swedish_(language)",
    "pos": "YELLOW",
    "explanation": "(language + 3 + crown: language + Sweden [contraction])",
    "isCharacter": false,
    "composition": [
      15172,
      "/",
      8499,
      "/",
      22618
    ]
  },
  {
    "id": "23228",
    "description": "sweet_shop,candy_store",
    "pos": "YELLOW",
    "explanation": "(store + candy)",
    "isCharacter": false,
    "composition": [
      23223,
      "/",
      14430,
      "/",
      22375
    ]
  },
  {
    "id": "23229",
    "description": "synthetic_fabric",
    "pos": "YELLOW",
    "explanation": "(material + chemical product + cloth: textile fibre produced by a chemical process)",
    "isCharacter": false,
    "composition": [
      15431,
      "/",
      13158,
      "/",
      13365
    ]
  },
  {
    "id": "23230",
    "description": "tax",
    "pos": "YELLOW",
    "explanation": "(money + leadership: money + to govern [contraction] )  - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "23231",
    "description": "tax_(national,federal)",
    "pos": "YELLOW",
    "explanation": "(tax + country: tax + government [contraction])",
    "isCharacter": false,
    "composition": [
      23230,
      "/",
      13423
    ]
  },
  {
    "id": "23232",
    "description": "tax_(real_estate)",
    "pos": "YELLOW",
    "explanation": "(tax + building)",
    "isCharacter": false,
    "composition": [
      23230,
      "/",
      14905
    ]
  },
  {
    "id": "23233",
    "description": "tax_(sales)",
    "pos": "YELLOW",
    "explanation": "(tax + to sell)",
    "isCharacter": false,
    "composition": [
      23230,
      "/",
      17717,
      "/",
      15484
    ]
  },
  {
    "id": "23234",
    "description": "tax_(state,regional)",
    "pos": "YELLOW",
    "explanation": "(tax + province)",
    "isCharacter": false,
    "composition": [
      23230,
      "/",
      15972,
      "/",
      13423
    ]
  },
  {
    "id": "23235",
    "description": "testify-(to)",
    "pos": "RED",
    "explanation": "(testimony + action indicator)",
    "isCharacter": false,
    "composition": [
      15666,
      ";",
      8993,
      "/",
      24846,
      "/",
      23127
    ]
  },
  {
    "id": "23236",
    "description": "testimony",
    "pos": "YELLOW",
    "explanation": "(to say + observation + legal [contraction]: to state under oath what one has observed)",
    "isCharacter": false,
    "composition": [
      15666,
      "/",
      24846,
      "/",
      23127
    ]
  },
  {
    "id": "23237",
    "description": "theatre",
    "pos": "YELLOW",
    "explanation": "(building + to see + to hear)",
    "isCharacter": false,
    "composition": [
      14905,
      "/",
      14133,
      "/",
      13894
    ]
  },
  {
    "id": "23238",
    "description": "timer",
    "pos": "YELLOW",
    "explanation": "(gauge + time + thing indicator)",
    "isCharacter": false,
    "composition": [
      24806,
      ";",
      9009,
      "/",
      17732
    ]
  },
  {
    "id": "23239",
    "description": "tin",
    "pos": "YELLOW",
    "explanation": "(metal [contraction] + cup + past time)",
    "isCharacter": false,
    "composition": [
      23150,
      "/",
      13621,
      "/",
      15975
    ]
  },
  {
    "id": "23240",
    "description": "tower",
    "pos": "YELLOW",
    "explanation": "(pictograph) - Character",
    "isCharacter": true
  },
  {
    "id": "23241",
    "description": "toy_shop",
    "pos": "YELLOW",
    "explanation": "(store + toy)",
    "isCharacter": false,
    "composition": [
      23223,
      "/",
      17717,
      "/",
      12335,
      "/",
      "RK:-2",
      "/",
      14164,
      "/",
      17983
    ]
  },
  {
    "id": "23242",
    "description": "trial",
    "pos": "YELLOW",
    "explanation": "(gathering + legal [contraction])",
    "isCharacter": false,
    "composition": [
      14427,
      "/",
      23127
    ]
  },
  {
    "id": "23243",
    "description": "two_storey_building",
    "pos": "YELLOW",
    "explanation": "(two + storey)",
    "isCharacter": false,
    "composition": [
      8498,
      "/",
      23085
    ]
  },
  {
    "id": "23244",
    "description": "unfair,unjust",
    "pos": "GREEN",
    "explanation": "(without + fair + description indicator)",
    "isCharacter": false,
    "composition": [
      15474,
      "/",
      23127,
      ";",
      8998,
      "/",
      16713
    ]
  },
  {
    "id": "23245",
    "description": "watch_tower,observation_tower",
    "pos": "YELLOW",
    "explanation": "(tower + observation)",
    "isCharacter": false,
    "composition": [
      23240,
      "/",
      24846
    ]
  },
  {
    "id": "23246",
    "description": "water_meter",
    "pos": "YELLOW",
    "explanation": "(gauge + water + thing indicator)",
    "isCharacter": false,
    "composition": [
      24806,
      ";",
      9009,
      "/",
      18209
    ]
  },
  {
    "id": "23247",
    "description": "water_tower",
    "pos": "YELLOW",
    "explanation": "(tower + water)",
    "isCharacter": false,
    "composition": [
      23240,
      "/",
      18209
    ]
  },
  {
    "id": "23248",
    "description": "weight_(measurement)",
    "pos": "YELLOW",
    "explanation": "(measurement + weight)",
    "isCharacter": false,
    "composition": [
      15443,
      "/",
      18221
    ]
  },
  {
    "id": "23249",
    "description": "vertical",
    "pos": "GREEN",
    "explanation": "(vertical-(a) + description indicator)",
    "isCharacter": false,
    "composition": [
      23250,
      ";",
      8998
    ]
  },
  {
    "id": "23250",
    "description": "vertical-(a)",
    "pos": "YELLOW",
    "explanation": "(right angle + pointer, to vertical arm of angle)  - Character (superimposed - pointer)",
    "isCharacter": true
  },
  {
    "id": "23251",
    "description": "witness",
    "pos": "BLUE",
    "explanation": "(person + observation + legal [contraction]: person + to testify [contraction])",
    "isCharacter": false,
    "composition": [
      16161,
      "/",
      24846,
      "/",
      23127
    ]
  },
  {
    "id": "23252",
    "description": "workplace",
    "pos": "YELLOW",
    "explanation": "(house + work)",
    "isCharacter": false,
    "composition": [
      14905,
      "/",
      18273
    ]
  },
  {
    "id": "23253",
    "description": "writing_(class)",
    "pos": "YELLOW",
    "explanation": "(class [contraction] + to write)",
    "isCharacter": false,
    "composition": [
      15162,
      "/",
      15991
    ]
  },
  {
    "id": "23401",
    "description": "aboard,on_board",
    "pos": "GREEN",
    "explanation": "(inside + vehicle + description indicator)  Use appropriate specifier.",
    "isCharacter": false,
    "composition": [
      14932,
      ";",
      8998,
      "/",
      18010
    ]
  },
  {
    "id": "23402",
    "description": "address",
    "pos": "YELLOW",
    "explanation": "(name + place + house)  Use appropriate specifier.",
    "isCharacter": false,
    "composition": [
      15691,
      "/",
      16193,
      "/",
      14905
    ]
  },
  {
    "id": "23403",
    "description": "anti-virus_program",
    "pos": "YELLOW",
    "explanation": "(computer program + protection)",
    "isCharacter": false,
    "composition": [
      16194,
      "/",
      23476,
      "/",
      16420
    ]
  },
  {
    "id": "23404",
    "description": "ashore",
    "pos": "GREEN",
    "explanation": "(debarkation,disembarkation_(ashore) + description indicator)",
    "isCharacter": false,
    "composition": [
      25544,
      ";",
      8998
    ]
  },
  {
    "id": "23405",
    "description": "ATM,cash_machine",
    "pos": "YELLOW",
    "explanation": "(machine + bank card)",
    "isCharacter": false,
    "composition": [
      15406,
      "/",
      23431,
      "/",
      15484
    ]
  },
  {
    "id": "23407",
    "description": "attach_(computer)-(to)",
    "pos": "RED",
    "explanation": "(attachment_(computer) + action indicator)",
    "isCharacter": false,
    "composition": [
      23409,
      ";",
      8993,
      "/",
      23500
    ]
  },
  {
    "id": "23408",
    "description": "attached_(computer)",
    "pos": "GREEN",
    "explanation": "(attachment_(computer) + description indicator)",
    "isCharacter": false,
    "composition": [
      23409,
      ";",
      8998,
      "/",
      23500
    ]
  },
  {
    "id": "23409",
    "description": "attachment,fastening,joint,seam,appendix,annex",
    "pos": "YELLOW",
    "explanation": "(vertical line + plus + vertical line: representing something attached to something else)  - Character (sequenced)",
    "isCharacter": true
  },
  {
    "id": "23410",
    "description": "attachment_(computer)",
    "pos": "YELLOW",
    "explanation": "(attachment + file)",
    "isCharacter": false,
    "composition": [
      23409,
      "/",
      23500
    ]
  },
  {
    "id": "23411",
    "description": "backspace_(computer)-(to)",
    "pos": "RED",
    "explanation": "(to delete + backwards)",
    "isCharacter": false,
    "composition": [
      24883,
      ";",
      8993,
      "/",
      "RK:-2",
      "/",
      12613
    ]
  },
  {
    "id": "23412",
    "description": "baker",
    "pos": "BLUE",
    "explanation": "(person + bread)",
    "isCharacter": false,
    "composition": [
      16161,
      "/",
      12895
    ]
  },
  {
    "id": "23413",
    "description": "ball_pool",
    "pos": "YELLOW",
    "explanation": "(foundation + many + ball: a partial enclosure containing many balls)",
    "isCharacter": false,
    "composition": [
      24120,
      "/",
      14647,
      "/",
      12621
    ]
  },
  {
    "id": "23414",
    "description": "ballet",
    "pos": "YELLOW",
    "explanation": "(action + toe + music)",
    "isCharacter": false,
    "composition": [
      12335,
      "/",
      17745,
      "/",
      13894,
      "/",
      15682
    ]
  },
  {
    "id": "23415",
    "description": "bank_card,money_card",
    "pos": "YELLOW",
    "explanation": "(card + money)",
    "isCharacter": false,
    "composition": [
      23431,
      "/",
      15484
    ]
  },
  {
    "id": "23416",
    "description": "barrow,garden_cart,wheelbarrow",
    "pos": "YELLOW",
    "explanation": "(wagon + garden)",
    "isCharacter": false,
    "composition": [
      18028,
      "/",
      14422
    ]
  },
  {
    "id": "23417",
    "description": "blackberry",
    "pos": "YELLOW",
    "explanation": "(compound berry + black)",
    "isCharacter": false,
    "composition": [
      16463,
      "/",
      13377,
      "/",
      15719
    ]
  },
  {
    "id": "23418",
    "description": "brave,courageous",
    "pos": "GREEN",
    "explanation": "(courage + description indicator)",
    "isCharacter": false,
    "composition": [
      14164,
      ";",
      8998,
      "/",
      24941
    ]
  },
  {
    "id": "23419",
    "description": "bricklayer",
    "pos": "BLUE",
    "explanation": "(person + brick)",
    "isCharacter": false,
    "composition": [
      16161,
      "/",
      12860
    ]
  },
  {
    "id": "23420",
    "description": "briefcase",
    "pos": "YELLOW",
    "explanation": "(bag + paper)",
    "isCharacter": false,
    "composition": [
      12618,
      "/",
      15962
    ]
  },
  {
    "id": "23421",
    "description": "Brontosaurus",
    "pos": "YELLOW",
    "explanation": "(dinosaur + big)",
    "isCharacter": false,
    "composition": [
      23477,
      "/",
      24875
    ]
  },
  {
    "id": "23422",
    "description": "brownie,house_elf",
    "pos": "BLUE",
    "explanation": "(little_person + house)",
    "isCharacter": false,
    "composition": [
      23577,
      "/",
      24917,
      "/",
      14905
    ]
  },
  {
    "id": "23423",
    "description": "Buddha",
    "pos": "BLUE",
    "explanation": "(man + Buddhism)",
    "isCharacter": false,
    "composition": [
      15416,
      "/",
      20563,
      "/",
      23472
    ]
  },
  {
    "id": "23424",
    "description": "Buddhism",
    "pos": "YELLOW",
    "explanation": "(religion + dharma wheel)",
    "isCharacter": false,
    "composition": [
      20563,
      "/",
      23472
    ]
  },
  {
    "id": "23425",
    "description": "buddhist",
    "pos": "GREEN",
    "explanation": "(dharma wheel + description indicator)",
    "isCharacter": false,
    "composition": [
      23472,
      ";",
      8998
    ]
  },
  {
    "id": "23426",
    "description": "buddhist_(person)",
    "pos": "BLUE",
    "explanation": "(person + dharma wheel: person + buddhist)",
    "isCharacter": false,
    "composition": [
      16161,
      "/",
      23472
    ]
  },
  {
    "id": "23427",
    "description": "budget,business_plan",
    "pos": "YELLOW",
    "explanation": "(plan + business)",
    "isCharacter": false,
    "composition": [
      16194,
      "/",
      13093
    ]
  },
  {
    "id": "23428",
    "description": "butcher",
    "pos": "BLUE",
    "explanation": "(person + meat)",
    "isCharacter": false,
    "composition": [
      16161,
      "/",
      14377,
      "/",
      12378
    ]
  },
  {
    "id": "23429",
    "description": "car_mechanic",
    "pos": "BLUE",
    "explanation": "(mechanic + car)",
    "isCharacter": false,
    "composition": [
      16161,
      "/",
      15406,
      "/",
      13121
    ]
  },
  {
    "id": "23430",
    "description": "car_track",
    "pos": "YELLOW",
    "explanation": "(track + car)",
    "isCharacter": false,
    "composition": [
      23690,
      "/",
      13121
    ]
  },
  {
    "id": "23431",
    "description": "card",
    "pos": "YELLOW",
    "explanation": "(pictograph: horizontally oriented rectangle representing a lying card) - Character",
    "isCharacter": true
  },
  {
    "id": "23432",
    "description": "card_game",
    "pos": "YELLOW",
    "explanation": "(play [contraction] + card)",
    "isCharacter": false,
    "composition": [
      12335,
      "/",
      "RK:-2",
      "/",
      14164,
      "/",
      23431
    ]
  },
  {
    "id": "23433",
    "description": "cartographer",
    "pos": "BLUE",
    "explanation": "(person + cartography)",
    "isCharacter": false,
    "composition": [
      16161,
      "/",
      16735,
      "/",
      15962,
      "/",
      13901
    ]
  },
  {
    "id": "23434",
    "description": "cartography",
    "pos": "YELLOW",
    "explanation": "(body of learning + map)",
    "isCharacter": false,
    "composition": [
      16735,
      "/",
      15962,
      "/",
      13901
    ]
  },
  {
    "id": "23435",
    "description": "cartoon,animated_picture",
    "pos": "YELLOW",
    "explanation": "(film + pencil: film on which images are drawn)",
    "isCharacter": false,
    "composition": [
      13115,
      "/",
      16254,
      "/",
      "RK:-2",
      "/",
      15991
    ]
  },
  {
    "id": "23436",
    "description": "casserole",
    "pos": "YELLOW",
    "explanation": "(food + container + oven: a food baked and served in the container in which it was cooked)",
    "isCharacter": false,
    "composition": [
      14377,
      "/",
      13403,
      "/",
      17273
    ]
  },
  {
    "id": "23437",
    "description": "castle,palace",
    "pos": "YELLOW",
    "explanation": "(tower [modification] + house [modification] + tower [modification]: pictograph suggests a castle as a combination of house and towers) - Character (superimposed - modified - combined)",
    "isCharacter": true
  },
  {
    "id": "23438",
    "description": "castle,palace_(royal)",
    "pos": "YELLOW",
    "explanation": "(castle + crown)",
    "isCharacter": false,
    "composition": [
      23437,
      "/",
      22618
    ]
  },
  {
    "id": "23439",
    "description": "causality",
    "pos": "YELLOW",
    "explanation": "(mind + cause: mental reflection on cause and effect)  - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "23440",
    "description": "chilly",
    "pos": "GREEN",
    "explanation": "(feeling + coldness,cold + description indicator)",
    "isCharacter": false,
    "composition": [
      14164,
      ";",
      8998,
      "/",
      25533
    ]
  },
  {
    "id": "23441",
    "description": "civil_engineer",
    "pos": "BLUE",
    "explanation": "(designer + bridge)",
    "isCharacter": false,
    "composition": [
      16161,
      "/",
      16194,
      "/",
      12902
    ]
  },
  {
    "id": "23443",
    "description": "clown",
    "pos": "BLUE",
    "explanation": "(person + face + colour)",
    "isCharacter": false,
    "composition": [
      16161,
      "/",
      14138,
      "/",
      13377
    ]
  },
  {
    "id": "23444",
    "description": "be_cold-(to)",
    "pos": "RED",
    "explanation": "(to feel + coldness,cold + action indicator)",
    "isCharacter": false,
    "composition": [
      14164,
      ";",
      8993,
      "/",
      25533
    ]
  },
  {
    "id": "23445",
    "description": "comedy",
    "pos": "YELLOW",
    "explanation": "(play + up: play + happy [contraction])",
    "isCharacter": false,
    "composition": [
      12335,
      "/",
      15962,
      "/",
      15666,
      "/",
      17983
    ]
  },
  {
    "id": "23446",
    "description": "community_centre,town_hall,village_hall",
    "pos": "YELLOW",
    "explanation": "(house + gathering)",
    "isCharacter": false,
    "composition": [
      14905,
      "/",
      14427
    ]
  },
  {
    "id": "23447",
    "description": "computer",
    "pos": "YELLOW",
    "explanation": "(machine + digits_(computer))  Preferred NEW SYNONYM, replacing 13394",
    "isCharacter": false,
    "composition": [
      15406,
      "/",
      23476
    ]
  },
  {
    "id": "23448",
    "description": "computer_case",
    "pos": "YELLOW",
    "explanation": "(enclosure + computer)",
    "isCharacter": false,
    "composition": [
      13934,
      "/",
      15406,
      "/",
      23476
    ]
  },
  {
    "id": "23449",
    "description": "computer_game_(OLD)",
    "pos": "YELLOW",
    "explanation": "(computer program + to play [contraction])  SUPERSEDED SYNONYM  See digital_game,video_game,computer_game 26159",
    "isCharacter": false,
    "composition": [
      16194,
      "/",
      23476,
      "/",
      12335,
      "/",
      "RK:-2",
      "/",
      14164
    ]
  },
  {
    "id": "23450",
    "description": "computer_peripheral",
    "pos": "YELLOW",
    "explanation": "(tool + computer)",
    "isCharacter": false,
    "composition": [
      17755,
      "/",
      15406,
      "/",
      23476
    ]
  },
  {
    "id": "23451",
    "description": "computer_screen,monitor",
    "pos": "YELLOW",
    "explanation": "(enclosure + eye + digits_(computer))",
    "isCharacter": false,
    "composition": [
      13934,
      "/",
      14133,
      "/",
      23476
    ]
  },
  {
    "id": "23452",
    "description": "concert",
    "pos": "YELLOW",
    "explanation": "(action + music)",
    "isCharacter": false,
    "composition": [
      12335,
      "/",
      13894,
      "/",
      15682
    ]
  },
  {
    "id": "23453",
    "description": "conjure,turn_to,transform-(to)",
    "pos": "RED",
    "explanation": "(wand + action indicator)",
    "isCharacter": false,
    "composition": [
      18034,
      ";",
      8993
    ]
  },
  {
    "id": "23454",
    "description": "constructional_blocks,lego_(etc)",
    "pos": "YELLOW",
    "explanation": "(block + together)",
    "isCharacter": false,
    "composition": [
      12860,
      "/",
      23409
    ]
  },
  {
    "id": "23455",
    "description": "constructional_toy",
    "pos": "YELLOW",
    "explanation": "(toy [contraction] + structure)",
    "isCharacter": false,
    "composition": [
      17717,
      "/",
      14164,
      "/",
      17445
    ]
  },
  {
    "id": "23456",
    "description": "copier,photocopier",
    "pos": "YELLOW",
    "explanation": "(machine + copy + paper)",
    "isCharacter": false,
    "composition": [
      15406,
      "/",
      24934,
      "/",
      15962
    ]
  },
  {
    "id": "23457",
    "description": "coral",
    "pos": "YELLOW",
    "explanation": "(water creature + plant: water animals forming structures that may appear similar to plants and flowers)",
    "isCharacter": false,
    "composition": [
      23706,
      "/",
      16196
    ]
  },
  {
    "id": "23458",
    "description": "coral_reef",
    "pos": "YELLOW",
    "explanation": "(many + many + coral)",
    "isCharacter": false,
    "composition": [
      14647,
      "/",
      14647,
      "/",
      23706,
      "/",
      16196
    ]
  },
  {
    "id": "23459",
    "description": "cordless_phone",
    "pos": "YELLOW",
    "explanation": "(telephone + back and forth: telephone that can be carried around)",
    "isCharacter": false,
    "composition": [
      15172,
      "/",
      13918,
      "/",
      12610
    ]
  },
  {
    "id": "23460",
    "description": "courage",
    "pos": "YELLOW",
    "explanation": "(feeling + strong)",
    "isCharacter": false,
    "composition": [
      14164,
      "/",
      24941
    ]
  },
  {
    "id": "23461",
    "description": "coward",
    "pos": "BLUE",
    "explanation": "(person + cowardice)",
    "isCharacter": false,
    "composition": [
      16161,
      "/",
      15474,
      "/",
      14164,
      "/",
      24941
    ]
  },
  {
    "id": "23462",
    "description": "cowardice",
    "pos": "YELLOW",
    "explanation": "(minus + courage)",
    "isCharacter": false,
    "composition": [
      15474,
      "/",
      14164,
      "/",
      24941
    ]
  },
  {
    "id": "23463",
    "description": "cowardly",
    "pos": "GREEN",
    "explanation": "(cowardice + description indicator)",
    "isCharacter": false,
    "composition": [
      15474,
      "/",
      14164,
      ";",
      8998,
      "/",
      24941
    ]
  },
  {
    "id": "23464",
    "description": "currency",
    "pos": "YELLOW",
    "explanation": "(money + country)",
    "isCharacter": false,
    "composition": [
      15484,
      "/",
      13423
    ]
  },
  {
    "id": "23465",
    "description": "cut_and_paste_(computer)-(to)",
    "pos": "RED",
    "explanation": "(take,bring,carry,move-(to) + digits_(computer): to move digitally)",
    "isCharacter": false,
    "composition": [
      24714,
      ";",
      8993,
      "/",
      23476
    ]
  },
  {
    "id": "23466",
    "description": "dare-(to)",
    "pos": "RED",
    "explanation": "(brave + activity + action indicator)",
    "isCharacter": false,
    "composition": [
      14164,
      ";",
      8993,
      "/",
      24941,
      "/",
      12335
    ]
  },
  {
    "id": "23467",
    "description": "data_(digital_information)",
    "pos": "YELLOW",
    "explanation": "(information + digits_(computer): digital information)",
    "isCharacter": false,
    "composition": [
      23542,
      "/",
      23476
    ]
  },
  {
    "id": "23468",
    "description": "delete_(computer)-(to)",
    "pos": "RED",
    "explanation": "(to delete + forward + action indicator)",
    "isCharacter": false,
    "composition": [
      24883,
      ";",
      8993,
      "/",
      14390
    ]
  },
  {
    "id": "23469",
    "description": "designer,planner",
    "pos": "BLUE",
    "explanation": "(person + design)",
    "isCharacter": false,
    "composition": [
      16161,
      "/",
      16194
    ]
  },
  {
    "id": "23470",
    "description": "desktop_computer",
    "pos": "YELLOW",
    "explanation": "(computer + tabletop)",
    "isCharacter": false,
    "composition": [
      15406,
      "/",
      23476,
      "/",
      23673
    ]
  },
  {
    "id": "23471",
    "description": "detach,take_apart-(to)",
    "pos": "RED",
    "explanation": "(detachment,separation,breakup + action indicator)",
    "isCharacter": false,
    "composition": [
      25548,
      ";",
      8993
    ]
  },
  {
    "id": "23472",
    "description": "Dharma_wheel",
    "pos": "YELLOW",
    "explanation": "(wheel [modification, to full size]: forms a pictograph of a big wheel with spokes, used as a symbol in Buddhism)  - Character (modified)",
    "isCharacter": true
  },
  {
    "id": "23473",
    "description": "meat_(diced),diced_meat,chunks_of_meat",
    "pos": "YELLOW",
    "explanation": "(meat + piece: meat cut into small pieces)",
    "isCharacter": false,
    "composition": [
      14377,
      "/",
      12378,
      "/",
      15972
    ]
  },
  {
    "id": "23474",
    "description": "digital",
    "pos": "GREEN",
    "explanation": "(digits_(computer) + description indicator)",
    "isCharacter": false,
    "composition": [
      23476,
      ";",
      8998
    ]
  },
  {
    "id": "23475",
    "description": "digital_processing,artificial_intelligence,calculation",
    "pos": "YELLOW",
    "explanation": "(mind + digits_(computer))  - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "23476",
    "description": "digits_(computer)",
    "pos": "WHITE",
    "explanation": "(quarter-sized vertical line + quarter-sized circle: representing the two digits 1 and 0)  - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "23477",
    "description": "dinosaur",
    "pos": "YELLOW",
    "explanation": "(animal + pictograph of dinosaur head and tail)  - Character (superimposed)  Preferred NEW SYNONYM, replacing 13681",
    "isCharacter": true
  },
  {
    "id": "23478",
    "description": "disembark-(to)",
    "pos": "RED",
    "explanation": "(to exit + vehicle + action indicator)",
    "isCharacter": false,
    "composition": [
      15943,
      ";",
      8993,
      "/",
      18010
    ]
  },
  {
    "id": "23479",
    "description": "document,written_record",
    "pos": "YELLOW",
    "explanation": "(paper + pen)",
    "isCharacter": false,
    "composition": [
      15962,
      "/",
      15991
    ]
  },
  {
    "id": "23480",
    "description": "drama",
    "pos": "YELLOW",
    "explanation": "(play + up and down: play portraying conflicting emotions and upsetting events)",
    "isCharacter": false,
    "composition": [
      12335,
      "/",
      15962,
      "/",
      15666,
      "/",
      20524
    ]
  },
  {
    "id": "23481",
    "description": "dwarf,gnome",
    "pos": "BLUE",
    "explanation": "(little person + beard: imaginary small person with beard)",
    "isCharacter": false,
    "composition": [
      23577,
      "/",
      24917,
      "/",
      12644
    ]
  },
  {
    "id": "23482",
    "description": "electrical_engineer",
    "pos": "BLUE",
    "explanation": "(designer + electricity)",
    "isCharacter": false,
    "composition": [
      16161,
      "/",
      16194,
      "/",
      13918
    ]
  },
  {
    "id": "23483",
    "description": "elf_(fog)",
    "pos": "BLUE",
    "explanation": "(little person + fog)",
    "isCharacter": false,
    "composition": [
      23577,
      "/",
      24917,
      "/",
      14374
    ]
  },
  {
    "id": "23484",
    "description": "elf_(star)",
    "pos": "BLUE",
    "explanation": "(little person + star)",
    "isCharacter": false,
    "composition": [
      23577,
      "/",
      24917,
      "/",
      17252
    ]
  },
  {
    "id": "23485",
    "description": "e-mail,email",
    "pos": "YELLOW",
    "explanation": "(letter + digits_(computer))",
    "isCharacter": false,
    "composition": [
      15198,
      "/",
      23476
    ]
  },
  {
    "id": "23486",
    "description": "e-mail_address,email_address",
    "pos": "YELLOW",
    "explanation": "(name + place + e-mail)",
    "isCharacter": false,
    "composition": [
      15691,
      "/",
      16193,
      "/",
      15198,
      "/",
      23476
    ]
  },
  {
    "id": "23487",
    "description": "embark,board-(to)",
    "pos": "RED",
    "explanation": "(to enter + vehicle + action indicator)",
    "isCharacter": false,
    "composition": [
      14952,
      ";",
      8993,
      "/",
      18010
    ]
  },
  {
    "id": "23488",
    "description": "enter_(computer)",
    "pos": "YELLOW",
    "explanation": "(backwards + short vertical line: pictograph, looks like the enter symbol on a computer keyboard)  - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "23489",
    "description": "export",
    "pos": "YELLOW",
    "explanation": "(out_of,exit_(forward) + contents)",
    "isCharacter": false,
    "composition": [
      15943,
      "/",
      14457
    ]
  },
  {
    "id": "23490",
    "description": "export-(to)",
    "pos": "RED",
    "explanation": "(export + action indicator)",
    "isCharacter": false,
    "composition": [
      15943,
      ";",
      8993,
      "/",
      14457
    ]
  },
  {
    "id": "23491",
    "description": "export_(computer)-(to)",
    "pos": "RED",
    "explanation": "(out_of,exit_(forward) + digits_(computer) + action indicator)",
    "isCharacter": false,
    "composition": [
      15943,
      ";",
      8993,
      "/",
      23542,
      "/",
      23476
    ]
  },
  {
    "id": "23492",
    "description": "exported",
    "pos": "GREEN",
    "explanation": "(export + description indicator)",
    "isCharacter": false,
    "composition": [
      15943,
      ";",
      8998,
      "/",
      14457
    ]
  },
  {
    "id": "23493",
    "description": "eye_controller,eye_gaze_controller",
    "pos": "YELLOW",
    "explanation": "(pointing device + eye)",
    "isCharacter": false,
    "composition": [
      17755,
      "/",
      23619,
      "/",
      14133
    ]
  },
  {
    "id": "23494",
    "description": "fairy,fairy_godmother",
    "pos": "BLUE",
    "explanation": "(make-believe woman + wand)",
    "isCharacter": false,
    "composition": [
      23581,
      "/",
      18034
    ]
  },
  {
    "id": "23495",
    "description": "fall_asleep-(to)",
    "pos": "RED",
    "explanation": "(to go + asleep + action indicator)",
    "isCharacter": false,
    "composition": [
      14390,
      ";",
      8993,
      "/",
      17008
    ]
  },
  {
    "id": "23496",
    "description": "fashion_designer",
    "pos": "BLUE",
    "explanation": "(designer + clothes)",
    "isCharacter": false,
    "composition": [
      16161,
      "/",
      16194,
      "/",
      13366
    ]
  },
  {
    "id": "23497",
    "description": "fax",
    "pos": "YELLOW",
    "explanation": "(paper + telephone)",
    "isCharacter": false,
    "composition": [
      15962,
      "/",
      15172,
      "/",
      13918
    ]
  },
  {
    "id": "23498",
    "description": "fax-(to)",
    "pos": "RED",
    "explanation": "(fax + action indicator)",
    "isCharacter": false,
    "composition": [
      15962,
      ";",
      8993,
      "/",
      15172,
      "/",
      13918
    ]
  },
  {
    "id": "23499",
    "description": "fax_(machine)",
    "pos": "YELLOW",
    "explanation": "(machine + fax)",
    "isCharacter": false,
    "composition": [
      15406,
      "/",
      15962,
      "/",
      15172,
      "/",
      13918
    ]
  },
  {
    "id": "23500",
    "description": "file,data_file_(digital)",
    "pos": "YELLOW",
    "explanation": "(container + digits_(computer))  - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "23501",
    "description": "filled,stuffed",
    "pos": "GREEN",
    "explanation": "(filling,fill,fullness + description after the fact indicator)",
    "isCharacter": false,
    "composition": [
      24897,
      ";",
      8996
    ]
  },
  {
    "id": "23502",
    "description": "filled_cabbage,stuffed_cabbage",
    "pos": "YELLOW",
    "explanation": "(cabbage + filled)",
    "isCharacter": false,
    "composition": [
      13101,
      "/",
      24897
    ]
  },
  {
    "id": "23503",
    "description": "filled_food,stuffed_food",
    "pos": "YELLOW",
    "explanation": "(food + filled)",
    "isCharacter": false,
    "composition": [
      14377,
      "/",
      24897
    ]
  },
  {
    "id": "23504",
    "description": "filled_leaf,dolma",
    "pos": "YELLOW",
    "explanation": "(leaf + filled)",
    "isCharacter": false,
    "composition": [
      15183,
      "/",
      24897
    ]
  },
  {
    "id": "23505",
    "description": "filled_vegetable,stuffed_vegetable",
    "pos": "YELLOW",
    "explanation": "(vegetable + filled)",
    "isCharacter": false,
    "composition": [
      18004,
      "/",
      24897
    ]
  },
  {
    "id": "23506",
    "description": "finger_spelling,finger_alphabet",
    "pos": "YELLOW",
    "explanation": "(alphabet + hand)",
    "isCharacter": false,
    "composition": [
      "Xa",
      "/",
      "Xb",
      "/",
      "Xc",
      "/",
      14667
    ]
  },
  {
    "id": "23507",
    "description": "fingerspell-(to)",
    "pos": "RED",
    "explanation": "(finger_spelling + action indicator)",
    "isCharacter": false,
    "composition": [
      "Xa",
      "/",
      "Xb",
      "/",
      "Xc",
      "/",
      "RK:-7",
      "/",
      8993,
      "/",
      "RK:3",
      "/",
      14667
    ]
  },
  {
    "id": "23508",
    "description": "fish_finger",
    "pos": "YELLOW",
    "explanation": "(fish + linear thing + thing indicator: fish food shaped into sticks)",
    "isCharacter": false,
    "composition": [
      14377,
      "/",
      14188,
      "/",
      15214,
      ";",
      9009
    ]
  },
  {
    "id": "23509",
    "description": "fisherman",
    "pos": "BLUE",
    "explanation": "(person + fish)",
    "isCharacter": false,
    "composition": [
      16161,
      "/",
      14188
    ]
  },
  {
    "id": "23510",
    "description": "flower_fairy",
    "pos": "BLUE",
    "explanation": "(little person + flower)",
    "isCharacter": false,
    "composition": [
      23577,
      "/",
      24917,
      "/",
      14205
    ]
  },
  {
    "id": "23511",
    "description": "folder",
    "pos": "YELLOW",
    "explanation": "(pictograph: looks like a paper folder, or a folder icon on a computer)  - Character",
    "isCharacter": true
  },
  {
    "id": "23512",
    "description": "folder_(digital)",
    "pos": "YELLOW",
    "explanation": "(container + file)",
    "isCharacter": false,
    "composition": [
      13403,
      "/",
      23500
    ]
  },
  {
    "id": "23513",
    "description": "foster_home",
    "pos": "YELLOW",
    "explanation": "(similar + home)",
    "isCharacter": false,
    "composition": [
      25586,
      "/",
      16713,
      "/",
      14905,
      "/",
      14164
    ]
  },
  {
    "id": "23514",
    "description": "freezer",
    "pos": "YELLOW",
    "explanation": "(cupboard + ice)",
    "isCharacter": false,
    "composition": [
      13622,
      "/",
      14919
    ]
  },
  {
    "id": "23515",
    "description": "fruit_cream,compote",
    "pos": "YELLOW",
    "explanation": "(pudding,cream + fruit)",
    "isCharacter": false,
    "composition": [
      22307,
      "/",
      14405
    ]
  },
  {
    "id": "23516",
    "description": "function",
    "pos": "YELLOW",
    "explanation": "(ability_(half_sized) + work)",
    "isCharacter": false,
    "composition": [
      25520,
      "/",
      18273
    ]
  },
  {
    "id": "23517",
    "description": "function-(to)",
    "pos": "RED",
    "explanation": "(function + action indicator)",
    "isCharacter": false,
    "composition": [
      25520,
      ";",
      8993,
      "/",
      18273
    ]
  },
  {
    "id": "23518",
    "description": "functional",
    "pos": "GREEN",
    "explanation": "(function + description indicator)",
    "isCharacter": false,
    "composition": [
      25520,
      ";",
      8998,
      "/",
      18273
    ]
  },
  {
    "id": "23519",
    "description": "gardener",
    "pos": "BLUE",
    "explanation": "(person + garden)",
    "isCharacter": false,
    "composition": [
      16161,
      "/",
      14422
    ]
  },
  {
    "id": "23520",
    "description": "ghost,phantom",
    "pos": "BLUE",
    "explanation": "(make-believe person + transparent)  Preferred NEW SYNONYM, replacing 14436",
    "isCharacter": false,
    "composition": [
      23577,
      "/",
      14133,
      "/",
      17724
    ]
  },
  {
    "id": "23521",
    "description": "giant",
    "pos": "BLUE",
    "explanation": "(make-believe person + gigantic)",
    "isCharacter": false,
    "composition": [
      23577,
      "/",
      24875,
      "/",
      14947,
      "/",
      14947,
      "/",
      14947
    ]
  },
  {
    "id": "23522",
    "description": "giant_(human)",
    "pos": "BLUE",
    "explanation": "(person + gigantic)",
    "isCharacter": false,
    "composition": [
      16161,
      "/",
      24875,
      "/",
      14947,
      "/",
      14947,
      "/",
      14947
    ]
  },
  {
    "id": "23523",
    "description": "go_ashore-(to)",
    "pos": "RED",
    "explanation": "(debarkation,disembarkation_(ashore) + action indicator)",
    "isCharacter": false,
    "composition": [
      25544,
      ";",
      8993
    ]
  },
  {
    "id": "23524",
    "description": "go_to_sea-(to)",
    "pos": "RED",
    "explanation": "(boarding,embarkation_(to_sea) + action indicator)",
    "isCharacter": false,
    "composition": [
      25527,
      ";",
      8993
    ]
  },
  {
    "id": "23525",
    "description": "goblin",
    "pos": "BLUE",
    "explanation": "(make-believe person + night)",
    "isCharacter": false,
    "composition": [
      23577,
      "/",
      15719
    ]
  },
  {
    "id": "23526",
    "description": "headmouse",
    "pos": "YELLOW",
    "explanation": "(pointing device + head)",
    "isCharacter": false,
    "composition": [
      17755,
      "/",
      23619,
      "/",
      14689
    ]
  },
  {
    "id": "23527",
    "description": "hedgehog",
    "pos": "YELLOW",
    "explanation": "(animal + quill(s),spine(s): pictograph of animal with spines) - Character (superimposed)  Preferred NEW SYNONYM, replacing 14699",
    "isCharacter": true
  },
  {
    "id": "23528",
    "description": "hero",
    "pos": "YELLOW",
    "explanation": "(person + heroic)",
    "isCharacter": false,
    "composition": [
      16161,
      "/",
      14164,
      "/",
      24941,
      "/",
      14947
    ]
  },
  {
    "id": "23529",
    "description": "heroic",
    "pos": "GREEN",
    "explanation": "(brave + intensity + description indicator)",
    "isCharacter": false,
    "composition": [
      14164,
      ";",
      8998,
      "/",
      24941,
      "/",
      14947
    ]
  },
  {
    "id": "23530",
    "description": "herring,sardine",
    "pos": "YELLOW",
    "explanation": "(fish + colour + silver [contraction]: often called “silver of the sea”)",
    "isCharacter": false,
    "composition": [
      14188,
      "/",
      13377,
      "/",
      17233
    ]
  },
  {
    "id": "23531",
    "description": "hobbit",
    "pos": "BLUE",
    "explanation": "(little person + foot)",
    "isCharacter": false,
    "composition": [
      23577,
      "/",
      24917,
      "/",
      14379
    ]
  },
  {
    "id": "23532",
    "description": "hold_(with_hand)-(to)",
    "pos": "RED",
    "explanation": "(hand + goods + action indicator)",
    "isCharacter": false,
    "composition": [
      14667,
      ";",
      8993,
      "/",
      14457
    ]
  },
  {
    "id": "23533",
    "description": "homework,home_studying",
    "pos": "YELLOW",
    "explanation": "(work + knowledge + house: study work done at home [contraction])",
    "isCharacter": false,
    "composition": [
      18273,
      "/",
      15162,
      "/",
      14905
    ]
  },
  {
    "id": "23534",
    "description": "hope",
    "pos": "YELLOW",
    "explanation": "(happy + future_(uncertain))",
    "isCharacter": false,
    "composition": [
      14164,
      "/",
      17983,
      "/",
      25568
    ]
  },
  {
    "id": "23535",
    "description": "hopeful",
    "pos": "GREEN",
    "explanation": "(hope + description indicator)",
    "isCharacter": false,
    "composition": [
      14164,
      ";",
      8998,
      "/",
      17983,
      "/",
      25568
    ]
  },
  {
    "id": "23536",
    "description": "house_work,housekeeping,housework",
    "pos": "YELLOW",
    "explanation": "(work + house: work to maintain a house)",
    "isCharacter": false,
    "composition": [
      18273,
      "/",
      14905
    ]
  },
  {
    "id": "23537",
    "description": "hunt-(to)",
    "pos": "RED",
    "explanation": "(hunt,hunting + action indicator)",
    "isCharacter": false,
    "composition": [
      14655,
      ";",
      8993,
      "/",
      12378
    ]
  },
  {
    "id": "23538",
    "description": "import",
    "pos": "YELLOW",
    "explanation": "(into + contents)",
    "isCharacter": false,
    "composition": [
      14952,
      "/",
      14457
    ]
  },
  {
    "id": "23539",
    "description": "import-(to)",
    "pos": "RED",
    "explanation": "(import + action indicator)",
    "isCharacter": false,
    "composition": [
      14952,
      ";",
      8993,
      "/",
      14457
    ]
  },
  {
    "id": "23540",
    "description": "import_(computer)-(to)",
    "pos": "RED",
    "explanation": "(into + data_(digital_information) + action indicator)",
    "isCharacter": false,
    "composition": [
      14952,
      ";",
      8993,
      "/",
      23542,
      "/",
      23476
    ]
  },
  {
    "id": "23541",
    "description": "imported",
    "pos": "GREEN",
    "explanation": "(import + description indicator)",
    "isCharacter": false,
    "composition": [
      14952,
      ";",
      8998,
      "/",
      14457
    ]
  },
  {
    "id": "23542",
    "description": "information",
    "pos": "YELLOW",
    "explanation": "(mind + up,upward: upward arrow, bringing information into the mind)  - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "23543",
    "description": "internet_(1)",
    "pos": "YELLOW",
    "explanation": "(net + digital_world)  SYMBOL SYNONYM",
    "isCharacter": false,
    "composition": [
      13365,
      "/",
      25552
    ]
  },
  {
    "id": "23544",
    "description": "internet_(2)",
    "pos": "YELLOW",
    "explanation": "(exchange + digital_world)  SYMBOL SYNONYM",
    "isCharacter": false,
    "composition": [
      25555,
      "/",
      25552
    ]
  },
  {
    "id": "23545",
    "description": "intranet_(1)",
    "pos": "YELLOW",
    "explanation": "(net + digital_space_(limited))  SYMBOL SYNONYM",
    "isCharacter": false,
    "composition": [
      13365,
      "/",
      25551
    ]
  },
  {
    "id": "23546",
    "description": "intranet_(2)",
    "pos": "YELLOW",
    "explanation": "(exchange + digital_space_(limited))  SYMBOL SYNONYM",
    "isCharacter": false,
    "composition": [
      25555,
      "/",
      25551
    ]
  },
  {
    "id": "23547",
    "description": "introduce,present-(to)",
    "pos": "RED",
    "explanation": "(to say + name + action indicator)",
    "isCharacter": false,
    "composition": [
      15666,
      ";",
      8993,
      "/",
      15691
    ]
  },
  {
    "id": "23548",
    "description": "journalist",
    "pos": "BLUE",
    "explanation": "(writer + news)",
    "isCharacter": false,
    "composition": [
      16161,
      "/",
      15991,
      "/",
      15712
    ]
  },
  {
    "id": "23549",
    "description": "joystick",
    "pos": "YELLOW",
    "explanation": "(pointing device + linear thing + thing indicator)",
    "isCharacter": false,
    "composition": [
      17755,
      "/",
      23619,
      "/",
      15214,
      ";",
      9009
    ]
  },
  {
    "id": "23550",
    "description": "jump",
    "pos": "YELLOW",
    "explanation": "(curved arrow, forward, indicating the path of a jump)  - Character",
    "isCharacter": true
  },
  {
    "id": "23551",
    "description": "Kazakhstan",
    "pos": "YELLOW",
    "explanation": "(country + horse)",
    "isCharacter": false,
    "composition": [
      13423,
      "/",
      14897
    ]
  },
  {
    "id": "23552",
    "description": "ketchup",
    "pos": "YELLOW",
    "explanation": "(tomato_sauce + intensity)",
    "isCharacter": false,
    "composition": [
      20522,
      "/",
      18004,
      "/",
      13377,
      "/",
      15666,
      "/",
      14947
    ]
  },
  {
    "id": "23553",
    "description": "key_(computer)",
    "pos": "YELLOW",
    "explanation": "(part + keyboard)",
    "isCharacter": false,
    "composition": [
      15972,
      "/",
      17755,
      "/",
      "Xa",
      "/",
      "Xb",
      "/",
      "Xc"
    ]
  },
  {
    "id": "23554",
    "description": "key_guard",
    "pos": "YELLOW",
    "explanation": "(help + keyboard + thing indicator)",
    "isCharacter": false,
    "composition": [
      14704,
      ";",
      9009,
      "/",
      17755,
      "/",
      "Xa",
      "/",
      "Xb",
      "/",
      "Xc"
    ]
  },
  {
    "id": "23555",
    "description": "keyboard_(computer)",
    "pos": "YELLOW",
    "explanation": "(tool + alphabet)",
    "isCharacter": false,
    "composition": [
      17755,
      "/",
      "Xa",
      "/",
      "Xb",
      "/",
      "Xc"
    ]
  },
  {
    "id": "23556",
    "description": "keyboard_(expanded)",
    "pos": "YELLOW",
    "explanation": "(keyboard + big)",
    "isCharacter": false,
    "composition": [
      17755,
      "/",
      "Xa",
      "/",
      "Xb",
      "/",
      "Xc",
      "/",
      24875
    ]
  },
  {
    "id": "23557",
    "description": "keyboard_(mini)",
    "pos": "YELLOW",
    "explanation": "(keyboard + small)",
    "isCharacter": false,
    "composition": [
      17755,
      "/",
      "Xa",
      "/",
      "Xb",
      "/",
      "Xc",
      "/",
      24917
    ]
  },
  {
    "id": "23558",
    "description": "kindergarten,preschool,nursery,play_group",
    "pos": "YELLOW",
    "explanation": "(house + child)",
    "isCharacter": false,
    "composition": [
      14905,
      "/",
      13166
    ]
  },
  {
    "id": "23559",
    "description": "king",
    "pos": "BLUE",
    "explanation": "(man + crown)",
    "isCharacter": false,
    "composition": [
      15416,
      "/",
      22618
    ]
  },
  {
    "id": "23560",
    "description": "landscape_design",
    "pos": "YELLOW",
    "explanation": "(design + garden)",
    "isCharacter": false,
    "composition": [
      16194,
      "/",
      14422
    ]
  },
  {
    "id": "23561",
    "description": "landscape_designer",
    "pos": "BLUE",
    "explanation": "(designer + garden)",
    "isCharacter": false,
    "composition": [
      16161,
      "/",
      16194,
      "/",
      14422
    ]
  },
  {
    "id": "23562",
    "description": "laptop",
    "pos": "YELLOW",
    "explanation": "(computer + to carry)",
    "isCharacter": false,
    "composition": [
      15406,
      "/",
      23476,
      "/",
      24714
    ]
  },
  {
    "id": "23563",
    "description": "lay_the_table-(to)",
    "pos": "RED",
    "explanation": "(tabletop + glassware + action indicator)",
    "isCharacter": false,
    "composition": [
      23673,
      ";",
      8993,
      "/",
      14430,
      "/",
      14442
    ]
  },
  {
    "id": "23564",
    "description": "lecture",
    "pos": "YELLOW",
    "explanation": "(to speak + knowledge + limited time)",
    "isCharacter": false,
    "composition": [
      15666,
      "/",
      15162,
      "/",
      15212
    ]
  },
  {
    "id": "23565",
    "description": "lecture-(to)",
    "pos": "RED",
    "explanation": "(lecture + action indicator)",
    "isCharacter": false,
    "composition": [
      15666,
      ";",
      8993,
      "/",
      15162,
      "/",
      15212
    ]
  },
  {
    "id": "23566",
    "description": "leprechaun",
    "pos": "BLUE",
    "explanation": "(little person + shamrock)",
    "isCharacter": false,
    "composition": [
      23577,
      "/",
      24917,
      "/",
      16939
    ]
  },
  {
    "id": "23567",
    "description": "lesson,lecture,class",
    "pos": "YELLOW",
    "explanation": "(limited time + to learn [contraction])",
    "isCharacter": false,
    "composition": [
      15212,
      "/",
      15162
    ]
  },
  {
    "id": "23568",
    "description": "librarian",
    "pos": "BLUE",
    "explanation": "(person + library)",
    "isCharacter": false,
    "composition": [
      16161,
      "/",
      14905,
      "/",
      12875
    ]
  },
  {
    "id": "23569",
    "description": "light_switch",
    "pos": "YELLOW",
    "explanation": "(tool + cause + light)",
    "isCharacter": false,
    "composition": [
      17755,
      "/",
      13134,
      "/",
      15208
    ]
  },
  {
    "id": "23570",
    "description": "little_person",
    "pos": "BLUE",
    "explanation": "(make-believe person + little)",
    "isCharacter": false,
    "composition": [
      23577,
      "/",
      24917
    ]
  },
  {
    "id": "23571",
    "description": "lotto,bingo_(etc)",
    "pos": "YELLOW",
    "explanation": "(play [contraction] + card + number)",
    "isCharacter": false,
    "composition": [
      12335,
      "/",
      "RK:-2",
      "/",
      14164,
      "/",
      23431,
      "/",
      15742
    ]
  },
  {
    "id": "23572",
    "description": "lumberjack",
    "pos": "BLUE",
    "explanation": "(person + to cut + tree)",
    "isCharacter": false,
    "composition": [
      16161,
      "/",
      15159,
      "/",
      17775
    ]
  },
  {
    "id": "23573",
    "description": "lunch_box",
    "pos": "YELLOW",
    "explanation": "(bag + food)  Use appropriate classifier.",
    "isCharacter": false,
    "composition": [
      12618,
      "/",
      14377
    ]
  },
  {
    "id": "23574",
    "description": "magician",
    "pos": "BLUE",
    "explanation": "(person + to cause + mystery)",
    "isCharacter": false,
    "composition": [
      16161,
      "/",
      13134,
      "/",
      21297
    ]
  },
  {
    "id": "23575",
    "description": "make_the_bed-(to)",
    "pos": "RED",
    "explanation": "(to cover + bed + action indicator)",
    "isCharacter": false,
    "composition": [
      16420,
      ";",
      8993,
      "/",
      12649
    ]
  },
  {
    "id": "23576",
    "description": "make-believe_man",
    "pos": "BLUE",
    "explanation": "(man + fantasy,phantasy,imagination,illusion)  - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "23577",
    "description": "make-believe_person,imaginary_person",
    "pos": "BLUE",
    "explanation": "(person + fantasy,phantasy,imagination,illusion)  - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "23578",
    "description": "make-believe_person_(in_forest)",
    "pos": "BLUE",
    "explanation": "(make-believe person + tree)",
    "isCharacter": false,
    "composition": [
      23577,
      "/",
      17775
    ]
  },
  {
    "id": "23579",
    "description": "make-believe_person_(in_water),water_nymph",
    "pos": "BLUE",
    "explanation": "(make-believe person + water)",
    "isCharacter": false,
    "composition": [
      23577,
      "/",
      18209
    ]
  },
  {
    "id": "23580",
    "description": "make-believe_person_(under_ground)",
    "pos": "BLUE",
    "explanation": "(make-believe person + under_(ground_level))",
    "isCharacter": false,
    "composition": [
      23577,
      "/",
      25628
    ]
  },
  {
    "id": "23581",
    "description": "make-believe_woman",
    "pos": "BLUE",
    "explanation": "(woman + fantasy,phantasy,imagination,illusion)  - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "23582",
    "description": "man_doll_(e.g._Ken)",
    "pos": "YELLOW",
    "explanation": "(man + man-made)",
    "isCharacter": false,
    "composition": [
      15416,
      "/",
      23583
    ]
  },
  {
    "id": "23583",
    "description": "making,production,fashioning",
    "pos": "YELLOW",
    "explanation": "(creation [modification, half height]: imperfect version of creation, represents man-made) - Character (modified)",
    "isCharacter": true
  },
  {
    "id": "23584",
    "description": "matching_game",
    "pos": "YELLOW",
    "explanation": "(play [contraction] + same)",
    "isCharacter": false,
    "composition": [
      12335,
      "/",
      "RK:-2",
      "/",
      14164,
      "/",
      16713
    ]
  },
  {
    "id": "23585",
    "description": "math,mathematics_(class)_(2)",
    "pos": "YELLOW",
    "explanation": "(subject [contraction] + mathematics)  SYMBOL SYNONYM",
    "isCharacter": false,
    "composition": [
      15162,
      "/",
      15432
    ]
  },
  {
    "id": "23586",
    "description": "meat_sauce",
    "pos": "YELLOW",
    "explanation": "(sauce + animal + lump(s): combination of sauce and minced meat)",
    "isCharacter": false,
    "composition": [
      20522,
      "/",
      12378,
      "/",
      22362
    ]
  },
  {
    "id": "23587",
    "description": "mechanic,technician",
    "pos": "BLUE",
    "explanation": "(person + machine)",
    "isCharacter": false,
    "composition": [
      16161,
      "/",
      15406
    ]
  },
  {
    "id": "23588",
    "description": "mechanical_engineer",
    "pos": "BLUE",
    "explanation": "(designer + machine)",
    "isCharacter": false,
    "composition": [
      16161,
      "/",
      16194,
      "/",
      15406
    ]
  },
  {
    "id": "23589",
    "description": "memory",
    "pos": "YELLOW",
    "explanation": "(knowledge + dot (inside the knowledge): can also be seen as a combination of knowledge and inside) - Character (superimposed - combined)",
    "isCharacter": true
  },
  {
    "id": "23590",
    "description": "mermaid",
    "pos": "BLUE",
    "explanation": "(make-believe woman + fish: imaginary woman having a tail of a fish)",
    "isCharacter": false,
    "composition": [
      23581,
      "/",
      14188
    ]
  },
  {
    "id": "23591",
    "description": "meat_(minced),minced_meat,ground_meat",
    "pos": "YELLOW",
    "explanation": "(meat + bits)",
    "isCharacter": false,
    "composition": [
      14377,
      "/",
      12378,
      "/",
      22362
    ]
  },
  {
    "id": "23592",
    "description": "mobile_phone,cellphone",
    "pos": "YELLOW",
    "explanation": "(telephone + to carry)",
    "isCharacter": false,
    "composition": [
      15172,
      "/",
      13918,
      "/",
      24714
    ]
  },
  {
    "id": "23593",
    "description": "mouse,pointing_device",
    "pos": "YELLOW",
    "explanation": "(tool + pointer)",
    "isCharacter": false,
    "composition": [
      17755,
      "/",
      23619
    ]
  },
  {
    "id": "23594",
    "description": "musical",
    "pos": "YELLOW",
    "explanation": "(play + music [contraction])",
    "isCharacter": false,
    "composition": [
      12335,
      "/",
      15962,
      "/",
      15666,
      "/",
      15682
    ]
  },
  {
    "id": "23595",
    "description": "net",
    "pos": "YELLOW",
    "explanation": "(net + to catch)",
    "isCharacter": false,
    "composition": [
      13365,
      "/",
      14667,
      "/",
      24727
    ]
  },
  {
    "id": "23596",
    "description": "noisemaker,musical_toy",
    "pos": "YELLOW",
    "explanation": "(toy [contraction] + sound)",
    "isCharacter": false,
    "composition": [
      17717,
      "/",
      14164,
      "/",
      17216
    ]
  },
  {
    "id": "23597",
    "description": "opera",
    "pos": "YELLOW",
    "explanation": "(play + music [contraction] + up and down: play and music portraying conflicting emotions and upsetting events)",
    "isCharacter": false,
    "composition": [
      12335,
      "/",
      15962,
      "/",
      15666,
      "/",
      15682,
      "/",
      20524
    ]
  },
  {
    "id": "23598",
    "description": "optician",
    "pos": "BLUE",
    "explanation": "(person + glasses)",
    "isCharacter": false,
    "composition": [
      16161,
      "/",
      14443
    ]
  },
  {
    "id": "23599",
    "description": "oval",
    "pos": "YELLOW",
    "explanation": "(pictograph)  - Character",
    "isCharacter": true
  },
  {
    "id": "23600",
    "description": "overlay",
    "pos": "YELLOW",
    "explanation": "(paper + on)",
    "isCharacter": false,
    "composition": [
      15962,
      "/",
      15918
    ]
  },
  {
    "id": "23601",
    "description": "overlay_keyboard,membrane_keyboard",
    "pos": "YELLOW",
    "explanation": "(keyboard + plan)",
    "isCharacter": false,
    "composition": [
      17755,
      "/",
      "Xa",
      "/",
      "Xb",
      "/",
      "Xc",
      "/",
      16194
    ]
  },
  {
    "id": "23602",
    "description": "palmtop,PDA",
    "pos": "YELLOW",
    "explanation": "(tablet + little)",
    "isCharacter": false,
    "composition": [
      15406,
      "/",
      23476,
      "/",
      14667,
      "/",
      24917
    ]
  },
  {
    "id": "23603",
    "description": "pancake,crepe,tortilla",
    "pos": "YELLOW",
    "explanation": "(dish + horizontal line [low, in the dish])  - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "23604",
    "description": "paper_money,bill",
    "pos": "YELLOW",
    "explanation": "(money + paper)",
    "isCharacter": false,
    "composition": [
      15962,
      "/",
      15484
    ]
  },
  {
    "id": "23605",
    "description": "passenger",
    "pos": "YELLOW",
    "explanation": "(person + to ride)",
    "isCharacter": false,
    "composition": [
      16161,
      "/",
      25603
    ]
  },
  {
    "id": "23606",
    "description": "educationalist,educationist_(academic)",
    "pos": "BLUE",
    "explanation": "(person + education,didactics,pedagogy)",
    "isCharacter": false,
    "composition": [
      16161,
      "/",
      16735,
      "/",
      25555,
      "/",
      15162
    ]
  },
  {
    "id": "23607",
    "description": "education,didactics,pedagogy",
    "pos": "YELLOW",
    "explanation": "(body of learning + to exchange + knowledge)",
    "isCharacter": false,
    "composition": [
      16735,
      "/",
      25555,
      "/",
      15162
    ]
  },
  {
    "id": "23608",
    "description": "Pegasus",
    "pos": "YELLOW",
    "explanation": "(horse + wings)",
    "isCharacter": false,
    "composition": [
      14897,
      "/",
      18259
    ]
  },
  {
    "id": "23609",
    "description": "perform-(to)",
    "pos": "RED",
    "explanation": "(performance + action indicator)",
    "isCharacter": false,
    "composition": [
      12335,
      ";",
      8993,
      "/",
      14905,
      "/",
      14133
    ]
  },
  {
    "id": "23610",
    "description": "performance,show",
    "pos": "YELLOW",
    "explanation": "(action + showplace)",
    "isCharacter": false,
    "composition": [
      12335,
      "/",
      14905,
      "/",
      14133
    ]
  },
  {
    "id": "23611",
    "description": "pharmacist",
    "pos": "BLUE",
    "explanation": "(person + medicine)",
    "isCharacter": false,
    "composition": [
      16161,
      "/",
      13158,
      "/",
      24920
    ]
  },
  {
    "id": "23612",
    "description": "philosopher",
    "pos": "BLUE",
    "explanation": "(person + causality)",
    "isCharacter": false,
    "composition": [
      16161,
      "/",
      23439
    ]
  },
  {
    "id": "23613",
    "description": "philosopher_(academic)",
    "pos": "BLUE",
    "explanation": "(person + philosophy)",
    "isCharacter": false,
    "composition": [
      16161,
      "/",
      16735,
      "/",
      23439
    ]
  },
  {
    "id": "23614",
    "description": "philosophy",
    "pos": "YELLOW",
    "explanation": "(body of learning + causality)",
    "isCharacter": false,
    "composition": [
      16735,
      "/",
      23439
    ]
  },
  {
    "id": "23615",
    "description": "philosophy_(class)",
    "pos": "YELLOW",
    "explanation": "(class [contraction] + causality)",
    "isCharacter": false,
    "composition": [
      15162,
      "/",
      23439
    ]
  },
  {
    "id": "23616",
    "description": "pirate",
    "pos": "BLUE",
    "explanation": "(sailor + receiving + negative + intensity: sailor + to rob [contraction] )",
    "isCharacter": false,
    "composition": [
      16161,
      "/",
      12869,
      "/",
      24727,
      "/",
      15474,
      "/",
      14947,
      "/",
      14947
    ]
  },
  {
    "id": "23617",
    "description": "play_(theater)",
    "pos": "YELLOW",
    "explanation": "(action + story)",
    "isCharacter": false,
    "composition": [
      12335,
      "/",
      15962,
      "/",
      15666
    ]
  },
  {
    "id": "23618",
    "description": "play,game_(in_combinations)",
    "pos": "YELLOW",
    "explanation": "(activity + feeling: contraction of play,recreation)  Used in conjunction with a specifier.",
    "isCharacter": false,
    "composition": [
      12335,
      "/",
      "RK:-2",
      "/",
      14164
    ]
  },
  {
    "id": "23619",
    "description": "pointing",
    "pos": "YELLOW",
    "explanation": "(hand [modification, on its side, as if pointing]) - Character (modified)",
    "isCharacter": true
  },
  {
    "id": "23620",
    "description": "porcupine",
    "pos": "YELLOW",
    "explanation": "(hedgehog + teeth: combination of hedgehog and rodent)  Preferred NEW SYNONYM, replacing 16222",
    "isCharacter": false,
    "composition": [
      23527,
      "/",
      17517
    ]
  },
  {
    "id": "23621",
    "description": "porridge",
    "pos": "YELLOW",
    "explanation": "(pudding,cream + grain,cereal)",
    "isCharacter": false,
    "composition": [
      22307,
      "/",
      14625
    ]
  },
  {
    "id": "23622",
    "description": "prince",
    "pos": "BLUE",
    "explanation": "(boy + crown)",
    "isCharacter": false,
    "composition": [
      12888,
      "/",
      22618
    ]
  },
  {
    "id": "23623",
    "description": "princess",
    "pos": "BLUE",
    "explanation": "(girl + crown)",
    "isCharacter": false,
    "composition": [
      14439,
      "/",
      22618
    ]
  },
  {
    "id": "23624",
    "description": "print-(to)",
    "pos": "RED",
    "explanation": "(machine + to write + action indicator)",
    "isCharacter": false,
    "composition": [
      15406,
      ";",
      8993,
      "/",
      15991
    ]
  },
  {
    "id": "23625",
    "description": "Pterosaur,Pterodactyl",
    "pos": "YELLOW",
    "explanation": "(dinosaur + wings)",
    "isCharacter": false,
    "composition": [
      23477,
      "/",
      18259
    ]
  },
  {
    "id": "23626",
    "description": "queen",
    "pos": "BLUE",
    "explanation": "(woman + crown)",
    "isCharacter": false,
    "composition": [
      18269,
      "/",
      22618
    ]
  },
  {
    "id": "23627",
    "description": "quill(s),spine(s)",
    "pos": "YELLOW",
    "explanation": "(pictograph)  - Character",
    "isCharacter": true
  },
  {
    "id": "23628",
    "description": "railway_track",
    "pos": "YELLOW",
    "explanation": "(track + train)",
    "isCharacter": false,
    "composition": [
      23690,
      "/",
      14647,
      "/",
      18010
    ]
  },
  {
    "id": "23629",
    "description": "ramp",
    "pos": "YELLOW",
    "explanation": "(pictograph)  - Character",
    "isCharacter": true
  },
  {
    "id": "23630",
    "description": "redo-(to)",
    "pos": "RED",
    "explanation": "(to add + action + before,in_front_of,prior_to + action indicator)",
    "isCharacter": false,
    "composition": [
      12339,
      ";",
      8993,
      "/",
      12335,
      "/",
      12656
    ]
  },
  {
    "id": "23631",
    "description": "redo_(computer)-(to)",
    "pos": "RED",
    "explanation": "(jump + digits_(computer) + action indicator)",
    "isCharacter": false,
    "composition": [
      23550,
      ";",
      8993,
      "/",
      23476
    ]
  },
  {
    "id": "23632",
    "description": "refrigerator,fridge",
    "pos": "YELLOW",
    "explanation": "(cupboard + cold)  Preferred NEW SYNONYM, replacing 16476",
    "isCharacter": false,
    "composition": [
      13622,
      "/",
      25533
    ]
  },
  {
    "id": "23634",
    "description": "remember,recall-(to)",
    "pos": "RED",
    "explanation": "(memory + action indicator)  Preferred NEW SYNONYM, replacing 16485",
    "isCharacter": false,
    "composition": [
      23589,
      ";",
      8993
    ]
  },
  {
    "id": "23635",
    "description": "research",
    "pos": "YELLOW",
    "explanation": "(activity + science)",
    "isCharacter": false,
    "composition": [
      12335,
      "/",
      23439,
      "/",
      14114
    ]
  },
  {
    "id": "23636",
    "description": "rice_pudding,rice_porridge",
    "pos": "YELLOW",
    "explanation": "(pudding + rice)",
    "isCharacter": false,
    "composition": [
      22307,
      "/",
      "RK:-2",
      "/",
      16505
    ]
  },
  {
    "id": "23637",
    "description": "rob-(to)",
    "pos": "RED",
    "explanation": "(to steal + intensity + action indicator)",
    "isCharacter": false,
    "composition": [
      14667,
      ";",
      8993,
      "/",
      24727,
      "/",
      15474,
      "/",
      14947,
      "/",
      14947
    ]
  },
  {
    "id": "23638",
    "description": "robber",
    "pos": "BLUE",
    "explanation": "(person + to rob [contraction])",
    "isCharacter": false,
    "composition": [
      16161,
      "/",
      24727,
      "/",
      15474,
      "/",
      14947,
      "/",
      14947
    ]
  },
  {
    "id": "23639",
    "description": "robot_doll",
    "pos": "YELLOW",
    "explanation": "(machine + person + man-made)",
    "isCharacter": false,
    "composition": [
      15406,
      "/",
      16161,
      "/",
      23583
    ]
  },
  {
    "id": "23640",
    "description": "roll-(to)",
    "pos": "RED",
    "explanation": "(rotation + ground + action indicator)",
    "isCharacter": false,
    "composition": [
      24249,
      ";",
      8993,
      "/",
      13901
    ]
  },
  {
    "id": "23641",
    "description": "ruin,wreck,wreckage_(building)_(2)",
    "pos": "YELLOW",
    "explanation": "(building + destroyed)  SYMBOL SYNONYM",
    "isCharacter": false,
    "composition": [
      14905,
      "/",
      24883
    ]
  },
  {
    "id": "23642",
    "description": "Russia",
    "pos": "YELLOW",
    "explanation": "(country + bear's_head: the country of the bear)",
    "isCharacter": false,
    "composition": [
      13423,
      "/",
      24801
    ]
  },
  {
    "id": "23643",
    "description": "samosa,pirogue",
    "pos": "YELLOW",
    "explanation": "(bread + filled)",
    "isCharacter": false,
    "composition": [
      12895,
      "/",
      24897
    ]
  },
  {
    "id": "23644",
    "description": "sand_play",
    "pos": "YELLOW",
    "explanation": "(play [contraction] + sand)",
    "isCharacter": false,
    "composition": [
      12335,
      "/",
      "RK:-2",
      "/",
      14164,
      "/",
      "RK:-2",
      "/",
      16233,
      "/",
      17267
    ]
  },
  {
    "id": "23645",
    "description": "sand_toy",
    "pos": "YELLOW",
    "explanation": "(toy [contraction] + sand)",
    "isCharacter": false,
    "composition": [
      17717,
      "/",
      14164,
      "/",
      "RK:-2",
      "/",
      16233,
      "/",
      17267
    ]
  },
  {
    "id": "23646",
    "description": "Sandman",
    "pos": "BLUE",
    "explanation": "(make-believe man + to sleep: make-believe man who puts one to sleep)",
    "isCharacter": false,
    "composition": [
      23576,
      "/",
      17008
    ]
  },
  {
    "id": "23647",
    "description": "Santa_Claus,Father_Christmas",
    "pos": "BLUE",
    "explanation": "(man + beard + evergreen tree)",
    "isCharacter": false,
    "composition": [
      15416,
      "/",
      12644,
      "/",
      14116
    ]
  },
  {
    "id": "23648",
    "description": "save_(computer)-(to)",
    "pos": "RED",
    "explanation": "(file,data_file_(digital) + future: combination of to keep and file + action indicator)",
    "isCharacter": false,
    "composition": [
      23500,
      ";",
      8993,
      "/",
      14417
    ]
  },
  {
    "id": "23649",
    "description": "save_as_(computer)-(to)",
    "pos": "RED",
    "explanation": "(save_(computer)-(to) + name + action indicator)",
    "isCharacter": false,
    "composition": [
      23500,
      ";",
      8993,
      "/",
      14417,
      "/",
      15691
    ]
  },
  {
    "id": "23650",
    "description": "schoolbag",
    "pos": "YELLOW",
    "explanation": "(bag + book)  Use appropriate classifier.",
    "isCharacter": false,
    "composition": [
      12618,
      "/",
      12875
    ]
  },
  {
    "id": "23651",
    "description": "science",
    "pos": "YELLOW",
    "explanation": "(causality + event: to research the cause of events)",
    "isCharacter": false,
    "composition": [
      23439,
      "/",
      14114
    ]
  },
  {
    "id": "23652",
    "description": "scientist,researcher",
    "pos": "BLUE",
    "explanation": "(person + science)",
    "isCharacter": false,
    "composition": [
      16161,
      "/",
      23439,
      "/",
      14114
    ]
  },
  {
    "id": "23653",
    "description": "sea_anemone",
    "pos": "YELLOW",
    "explanation": "(water creature + flower: water creature looking similar to a flower)",
    "isCharacter": false,
    "composition": [
      23706,
      "/",
      14205
    ]
  },
  {
    "id": "23654",
    "description": "sea_cucumber",
    "pos": "YELLOW",
    "explanation": "(water creature + oval shape)",
    "isCharacter": false,
    "composition": [
      23706,
      "/",
      23599
    ]
  },
  {
    "id": "23655",
    "description": "sea_lion",
    "pos": "YELLOW",
    "explanation": "(water_mammal_(with_tail) + to shout)",
    "isCharacter": false,
    "composition": [
      13864,
      "/",
      15666,
      "/",
      14947
    ]
  },
  {
    "id": "23656",
    "description": "sea_urchin",
    "pos": "YELLOW",
    "explanation": "(water creature + quills)",
    "isCharacter": false,
    "composition": [
      23706,
      "/",
      "RK:-2",
      "/",
      23627
    ]
  },
  {
    "id": "23657",
    "description": "seal",
    "pos": "YELLOW",
    "explanation": "(water_mammal_(with_tail) + fur)",
    "isCharacter": false,
    "composition": [
      13864,
      "/",
      "RK:-2",
      "/",
      14660
    ]
  },
  {
    "id": "23658",
    "description": "seaweed",
    "pos": "YELLOW",
    "explanation": "(water_(ground_level) + grass: representing plants growing in water)  - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "23659",
    "description": "select_all,mark_all-(to)",
    "pos": "RED",
    "explanation": "(to select + all + action indicator)",
    "isCharacter": false,
    "composition": [
      13175,
      ";",
      8993,
      "/",
      12360
    ]
  },
  {
    "id": "23660",
    "description": "shellfish",
    "pos": "YELLOW",
    "explanation": "(generalization + clam)",
    "isCharacter": false,
    "composition": [
      14430,
      "/",
      15952
    ]
  },
  {
    "id": "23661",
    "description": "shepherd",
    "pos": "BLUE",
    "explanation": "(person + sheep)",
    "isCharacter": false,
    "composition": [
      16161,
      "/",
      12379,
      "/",
      13365
    ]
  },
  {
    "id": "23662",
    "description": "shoot-(to)",
    "pos": "RED",
    "explanation": "(gun + action indicator)",
    "isCharacter": false,
    "composition": [
      14655,
      ";",
      8993
    ]
  },
  {
    "id": "23663",
    "description": "siren_of_the_woods",
    "pos": "BLUE",
    "explanation": "(make-believe woman + tree)",
    "isCharacter": false,
    "composition": [
      23581,
      "/",
      17775
    ]
  },
  {
    "id": "23664",
    "description": "software,computer_program,application,app",
    "pos": "YELLOW",
    "explanation": "(plan + digits_(computer))",
    "isCharacter": false,
    "composition": [
      16194,
      "/",
      23476
    ]
  },
  {
    "id": "23665",
    "description": "spell-(to)",
    "pos": "RED",
    "explanation": "(alphabet + action indicator)",
    "isCharacter": false,
    "composition": [
      "Xa",
      "/",
      "Xb",
      "/",
      "Xc",
      "/",
      "RK:-7",
      "/",
      8993,
      "/",
      "RK:3"
    ]
  },
  {
    "id": "23666",
    "description": "sport_elf",
    "pos": "BLUE",
    "explanation": "(little person + sport)",
    "isCharacter": false,
    "composition": [
      23577,
      "/",
      24917,
      "/",
      20518
    ]
  },
  {
    "id": "23667",
    "description": "steal-(to)",
    "pos": "RED",
    "explanation": "(to take + negative + action indicator)",
    "isCharacter": false,
    "composition": [
      14667,
      ";",
      8993,
      "/",
      24727,
      "/",
      15474,
      "/",
      14947
    ]
  },
  {
    "id": "23668",
    "description": "stew",
    "pos": "YELLOW",
    "explanation": "(sauce + animal + part: combination of sauce and diced meat)",
    "isCharacter": false,
    "composition": [
      20522,
      "/",
      12378,
      "/",
      15972
    ]
  },
  {
    "id": "23669",
    "description": "subject_(of_study)",
    "pos": "YELLOW",
    "explanation": "(part of + knowledge)",
    "isCharacter": false,
    "composition": [
      15972,
      "/",
      15162
    ]
  },
  {
    "id": "23670",
    "description": "switch",
    "pos": "YELLOW",
    "explanation": "(tool + cause + action)",
    "isCharacter": false,
    "composition": [
      17755,
      "/",
      13134,
      "/",
      "RK:-2",
      "/",
      12335
    ]
  },
  {
    "id": "23671",
    "description": "swordfish",
    "pos": "YELLOW",
    "explanation": "(fish + sword)",
    "isCharacter": false,
    "composition": [
      14188,
      "/",
      15159
    ]
  },
  {
    "id": "23672",
    "description": "tablet_computer,tablet,tablet_PC_(2)",
    "pos": "YELLOW",
    "explanation": "(computer + hand)  SYMBOL SYNONYM",
    "isCharacter": false,
    "composition": [
      15406,
      "/",
      23476,
      "/",
      14667
    ]
  },
  {
    "id": "23673",
    "description": "tabletop",
    "pos": "YELLOW",
    "explanation": "(table + pointer to the top)  - Character (superimposed - pointer)",
    "isCharacter": true
  },
  {
    "id": "23674",
    "description": "tailor,dressmaker,seamstress",
    "pos": "BLUE",
    "explanation": "(person + to make + clothes)",
    "isCharacter": false,
    "composition": [
      16161,
      "/",
      23583,
      "/",
      13366
    ]
  },
  {
    "id": "23675",
    "description": "teacher,pedagogue,educator",
    "pos": "BLUE",
    "explanation": "(person + to exchange + knowledge)",
    "isCharacter": false,
    "composition": [
      16161,
      "/",
      25555,
      "/",
      15162
    ]
  },
  {
    "id": "23676",
    "description": "teacher,pedagogue,educator_(in_combinations)",
    "pos": "BLUE",
    "explanation": "(person + knowledge: person + to teach [contraction])  Used in conjunction with a specifier.",
    "isCharacter": false,
    "composition": [
      16161,
      "/",
      15162
    ]
  },
  {
    "id": "23677",
    "description": "telephone_card",
    "pos": "YELLOW",
    "explanation": "(card + telephone)",
    "isCharacter": false,
    "composition": [
      23431,
      "/",
      15172,
      "/",
      13918
    ]
  },
  {
    "id": "23678",
    "description": "temporary_home",
    "pos": "YELLOW",
    "explanation": "(home + limited time)",
    "isCharacter": false,
    "composition": [
      14905,
      "/",
      14164,
      "/",
      15212
    ]
  },
  {
    "id": "23679",
    "description": "text_phone",
    "pos": "YELLOW",
    "explanation": "(telephone + alphabet)",
    "isCharacter": false,
    "composition": [
      15172,
      "/",
      13918,
      "/",
      "Xa",
      "/",
      "Xb",
      "/",
      "Xc"
    ]
  },
  {
    "id": "23680",
    "description": "theologian,theologist",
    "pos": "BLUE",
    "explanation": "(person + theology",
    "isCharacter": false,
    "composition": [
      16161,
      "/",
      16735,
      "/",
      20561
    ]
  },
  {
    "id": "23681",
    "description": "theology,philosophy_of_religion",
    "pos": "YELLOW",
    "explanation": "(body of learning + God-based religion: system of religious beliefs and theories)",
    "isCharacter": false,
    "composition": [
      16735,
      "/",
      20561
    ]
  },
  {
    "id": "23682",
    "description": "therapy_centre,rehabilitation_centre",
    "pos": "YELLOW",
    "explanation": "(building + therapy)",
    "isCharacter": false,
    "composition": [
      14905,
      "/",
      21589
    ]
  },
  {
    "id": "23683",
    "description": "thief",
    "pos": "BLUE",
    "explanation": "(person + receiving + negative: person + to steal [contraction])",
    "isCharacter": false,
    "composition": [
      16161,
      "/",
      24727,
      "/",
      15474,
      "/",
      14947
    ]
  },
  {
    "id": "23684",
    "description": "Tibet",
    "pos": "YELLOW",
    "explanation": "(country + dharma wheel)",
    "isCharacter": false,
    "composition": [
      13423,
      "/",
      23472
    ]
  },
  {
    "id": "23685",
    "description": "tomato_sauce",
    "pos": "YELLOW",
    "explanation": "(sauce + tomato)",
    "isCharacter": false,
    "composition": [
      20522,
      "/",
      18004,
      "/",
      13377,
      "/",
      15666
    ]
  },
  {
    "id": "23686",
    "description": "tooth_fairy",
    "pos": "BLUE",
    "explanation": "(fairy + teeth)",
    "isCharacter": false,
    "composition": [
      23581,
      "/",
      18034,
      "/",
      17517
    ]
  },
  {
    "id": "23687",
    "description": "touch_screen",
    "pos": "YELLOW",
    "explanation": "(computer_screen,monitor + hand)",
    "isCharacter": false,
    "composition": [
      13934,
      "/",
      14133,
      "/",
      23476,
      "/",
      14667
    ]
  },
  {
    "id": "23688",
    "description": "touchpad,trackpad",
    "pos": "YELLOW",
    "explanation": "(pointing device + finger)",
    "isCharacter": false,
    "composition": [
      17755,
      "/",
      23619,
      "/",
      14180
    ]
  },
  {
    "id": "23689",
    "description": "toy_(in_combinations)",
    "pos": "YELLOW",
    "explanation": "(thing + feeling: thing + play [contraction]) Used in conjunction with a specifier.",
    "isCharacter": false,
    "composition": [
      17717,
      "/",
      14164
    ]
  },
  {
    "id": "23690",
    "description": "track",
    "pos": "YELLOW",
    "explanation": "(pictograph)  - Character",
    "isCharacter": true
  },
  {
    "id": "23691",
    "description": "trackball",
    "pos": "YELLOW",
    "explanation": "(pointing device + ball)",
    "isCharacter": false,
    "composition": [
      17755,
      "/",
      23619,
      "/",
      12621
    ]
  },
  {
    "id": "23692",
    "description": "tragedy",
    "pos": "YELLOW",
    "explanation": "(play_(theater) + down: play_(theater) + sad [contraction])",
    "isCharacter": false,
    "composition": [
      12335,
      "/",
      15962,
      "/",
      15666,
      "/",
      13869
    ]
  },
  {
    "id": "23693",
    "description": "traveller",
    "pos": "BLUE",
    "explanation": "(person + travel)",
    "isCharacter": false,
    "composition": [
      16161,
      "/",
      17779
    ]
  },
  {
    "id": "23694",
    "description": "Triceratops",
    "pos": "YELLOW",
    "explanation": "(dinosaur + three + horn)",
    "isCharacter": false,
    "composition": [
      23477,
      "/",
      8499,
      "/",
      21061
    ]
  },
  {
    "id": "23695",
    "description": "troll",
    "pos": "BLUE",
    "explanation": "(make-believe person + stone: trolls turn into stones when the sun rises)",
    "isCharacter": false,
    "composition": [
      23577,
      "/",
      17267
    ]
  },
  {
    "id": "23696",
    "description": "troll_(tailed)",
    "pos": "BLUE",
    "explanation": "(make-believe person + linear thing + buttocks + thing indicator: trolls that have tails)",
    "isCharacter": false,
    "composition": [
      23577,
      "/",
      15214,
      ";",
      9009,
      "/",
      13097
    ]
  },
  {
    "id": "23697",
    "description": "tuna_fish",
    "pos": "YELLOW",
    "explanation": "(fish + huge)",
    "isCharacter": false,
    "composition": [
      14188,
      "/",
      24875,
      "/",
      14947
    ]
  },
  {
    "id": "23698",
    "description": "type-(to)",
    "pos": "RED",
    "explanation": "(to write + machine + action indicator)",
    "isCharacter": false,
    "composition": [
      15991,
      ";",
      8993,
      "/",
      15406
    ]
  },
  {
    "id": "23699",
    "description": "Tyrannosaurus_Rex",
    "pos": "YELLOW",
    "explanation": "(dinosaur + crown: the “King” of dinosaurs)",
    "isCharacter": false,
    "composition": [
      23477,
      "/",
      22618
    ]
  },
  {
    "id": "23700",
    "description": "undo-(to)",
    "pos": "RED",
    "explanation": "(to take away + action + in front of + action indicator)",
    "isCharacter": false,
    "composition": [
      17449,
      ";",
      8993,
      "/",
      12335,
      "/",
      12656
    ]
  },
  {
    "id": "23701",
    "description": "undo_(computer)-(to)",
    "pos": "RED",
    "explanation": "(jump_(backward) + digits_(computer) + action indicator)",
    "isCharacter": false,
    "composition": [
      24805,
      ";",
      8993,
      "/",
      23476
    ]
  },
  {
    "id": "23702",
    "description": "unicorn",
    "pos": "YELLOW",
    "explanation": "(horse + pictograph of a single horn)  - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "23703",
    "description": "wake_up-(to)",
    "pos": "RED",
    "explanation": "(to go + awake + action indicator)",
    "isCharacter": false,
    "composition": [
      14390,
      ";",
      8993,
      "/",
      24949
    ]
  },
  {
    "id": "23704",
    "description": "walrus",
    "pos": "YELLOW",
    "explanation": "(water creature with tail + teeth)",
    "isCharacter": false,
    "composition": [
      13864,
      "/",
      17517
    ]
  },
  {
    "id": "23705",
    "description": "wash_up,do_the_dishes-(to)",
    "pos": "YELLOW",
    "explanation": "(to wash + glassware + action indicator)",
    "isCharacter": false,
    "composition": [
      16992,
      ";",
      8993,
      "/",
      14430,
      "/",
      14442
    ]
  },
  {
    "id": "23706",
    "description": "water_creature",
    "pos": "YELLOW",
    "explanation": "(water_(ground_level) + arc: pictograph that could be associated with smooth water creatures)  Used in conjunction with a specifier.  - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "23707",
    "description": "water_play",
    "pos": "YELLOW",
    "explanation": "(play [contraction] + water)",
    "isCharacter": false,
    "composition": [
      12335,
      "/",
      "RK:-2",
      "/",
      14164,
      "/",
      18209
    ]
  },
  {
    "id": "23708",
    "description": "water_toy",
    "pos": "YELLOW",
    "explanation": "(toy [contraction] + water)",
    "isCharacter": false,
    "composition": [
      17717,
      "/",
      14164,
      "/",
      18209
    ]
  },
  {
    "id": "23709",
    "description": "website,domain_name,homepage,internet_domain",
    "pos": "YELLOW",
    "explanation": "(name + place + digital_world)",
    "isCharacter": false,
    "composition": [
      15691,
      "/",
      16193,
      "/",
      25552
    ]
  },
  {
    "id": "23710",
    "description": "vegetable(s)",
    "pos": "YELLOW",
    "explanation": "(generalization + vegetable_(above_ground))",
    "isCharacter": false,
    "composition": [
      14430,
      "/",
      18004
    ]
  },
  {
    "id": "23711",
    "description": "virus_(computer)",
    "pos": "YELLOW",
    "explanation": "(program + to destroy)",
    "isCharacter": false,
    "composition": [
      16194,
      "/",
      23476,
      "/",
      24883
    ]
  },
  {
    "id": "23712",
    "description": "witch",
    "pos": "BLUE",
    "explanation": "(make-believe woman + broom)",
    "isCharacter": false,
    "composition": [
      23581,
      "/",
      12908
    ]
  },
  {
    "id": "23713",
    "description": "wizard",
    "pos": "BLUE",
    "explanation": "(make-believe man + wand)",
    "isCharacter": false,
    "composition": [
      23576,
      "/",
      18034
    ]
  },
  {
    "id": "23714",
    "description": "woman_doll_(e.g._Barbie)",
    "pos": "YELLOW",
    "explanation": "(woman + man-made)",
    "isCharacter": false,
    "composition": [
      18269,
      "/",
      23583
    ]
  },
  {
    "id": "23715",
    "description": "worksheet",
    "pos": "YELLOW",
    "explanation": "(paper + to work)",
    "isCharacter": false,
    "composition": [
      15962,
      "/",
      18273
    ]
  },
  {
    "id": "23716",
    "description": "writer,author",
    "pos": "BLUE",
    "explanation": "(person + to write)",
    "isCharacter": false,
    "composition": [
      16161,
      "/",
      15991
    ]
  },
  {
    "id": "23801",
    "description": "accident",
    "pos": "YELLOW",
    "explanation": "(event + negative + intensity)",
    "isCharacter": false,
    "composition": [
      14114,
      "/",
      15474,
      "/",
      14947,
      "/",
      14947
    ]
  },
  {
    "id": "23802",
    "description": "accordion",
    "pos": "YELLOW",
    "explanation": "(wind instrument + back and forth)",
    "isCharacter": false,
    "composition": [
      23904,
      "/",
      18255,
      "/",
      12610
    ]
  },
  {
    "id": "23803",
    "description": "alto",
    "pos": "YELLOW",
    "explanation": "(stave + pointer, to alto position in stave)  - Character (superimposed - pointer)",
    "isCharacter": true
  },
  {
    "id": "23804",
    "description": "amplifier_(1)",
    "pos": "YELLOW",
    "explanation": "(machine + more + sound + intensity) SYMBOL SYNONYM",
    "isCharacter": false,
    "composition": [
      15406,
      "/",
      24879,
      "/",
      17216,
      "/",
      14947
    ]
  },
  {
    "id": "23805",
    "description": "amplifier_(2)",
    "pos": "YELLOW",
    "explanation": "(thing + more + sound + intensity)  SYMBOL SYNONYM",
    "isCharacter": false,
    "composition": [
      17717,
      "/",
      24879,
      "/",
      17216,
      "/",
      14947
    ]
  },
  {
    "id": "23806",
    "description": "autoharp,zither,kantele",
    "pos": "YELLOW",
    "explanation": "(musical instrument + group of + string + table)",
    "isCharacter": false,
    "composition": [
      23904,
      "/",
      14647,
      "/",
      23958,
      "/",
      17493
    ]
  },
  {
    "id": "23807",
    "description": "bagpipe",
    "pos": "YELLOW",
    "explanation": "(wind instrument + bag)",
    "isCharacter": false,
    "composition": [
      23904,
      "/",
      18255,
      "/",
      16701
    ]
  },
  {
    "id": "23808",
    "description": "banjo",
    "pos": "YELLOW",
    "explanation": "(string instrument + metal [contraction])",
    "isCharacter": false,
    "composition": [
      23904,
      "/",
      23958,
      "/",
      23150
    ]
  },
  {
    "id": "23809",
    "description": "bass",
    "pos": "YELLOW",
    "explanation": "(stave + pointer, to bass position in stave)  - Character (superimposed - pointer)",
    "isCharacter": true
  },
  {
    "id": "23810",
    "description": "bass_clarinet",
    "pos": "YELLOW",
    "explanation": "(clarinet + big)",
    "isCharacter": false,
    "composition": [
      23871,
      "/",
      23942,
      "/",
      24875
    ]
  },
  {
    "id": "23811",
    "description": "bass_guitar",
    "pos": "YELLOW",
    "explanation": "(string instrument + bass)",
    "isCharacter": false,
    "composition": [
      23904,
      "/",
      23958,
      "/",
      23809
    ]
  },
  {
    "id": "23812",
    "description": "bassoon_(1)",
    "pos": "YELLOW",
    "explanation": "(oboe (1) + big)  SYMBOL SYNONYM",
    "isCharacter": false,
    "composition": [
      23871,
      "/",
      8498,
      "/",
      23942,
      "/",
      24875
    ]
  },
  {
    "id": "23813",
    "description": "bassoon_(2)",
    "pos": "YELLOW",
    "explanation": "(oboe (2) + tenor)  SYMBOL SYNONYM",
    "isCharacter": false,
    "composition": [
      23904,
      "/",
      8498,
      "/",
      23942,
      "/",
      23966
    ]
  },
  {
    "id": "23814",
    "description": "bells,chime_bars,tubular_bells",
    "pos": "YELLOW",
    "explanation": "(group of + bell,chime_bar)",
    "isCharacter": false,
    "composition": [
      14647,
      "/",
      23904,
      "/",
      8497,
      "/",
      15682
    ]
  },
  {
    "id": "23815",
    "description": "block,city_block",
    "pos": "YELLOW",
    "explanation": "(place + between + street)",
    "isCharacter": false,
    "composition": [
      16193,
      "/",
      12669,
      "/",
      17441
    ]
  },
  {
    "id": "23816",
    "description": "bongo_drum,hand_drum",
    "pos": "YELLOW",
    "explanation": "(musical instrument + hand + to repeat)",
    "isCharacter": false,
    "composition": [
      23904,
      "/",
      14667,
      "/",
      24934
    ]
  },
  {
    "id": "23817",
    "description": "bow,arc",
    "pos": "YELLOW",
    "explanation": "(pictograph)  - Character",
    "isCharacter": true
  },
  {
    "id": "23818",
    "description": "bow_(musical_instrument)",
    "pos": "YELLOW",
    "explanation": "(bow_and_string_(musical) + pointer, to bow)  - Character (superimposed - pointer)",
    "isCharacter": true
  },
  {
    "id": "23819",
    "description": "bow_and_string_(musical)",
    "pos": "YELLOW",
    "explanation": "(pictograph)  - Character",
    "isCharacter": true
  },
  {
    "id": "23820",
    "description": "bow_and_string_instrument",
    "pos": "YELLOW",
    "explanation": "(musical instrument + bow and string)",
    "isCharacter": false,
    "composition": [
      23904,
      "/",
      23819
    ]
  },
  {
    "id": "23821",
    "description": "brake_(general)",
    "pos": "YELLOW",
    "explanation": "(tool + stop)",
    "isCharacter": false,
    "composition": [
      17755,
      "/",
      13935
    ]
  },
  {
    "id": "23822",
    "description": "brake_(vehicle)",
    "pos": "YELLOW",
    "explanation": "(tool + stop + to move)",
    "isCharacter": false,
    "composition": [
      17755,
      "/",
      13935,
      "/",
      25119
    ]
  },
  {
    "id": "23823",
    "description": "brass_instrument",
    "pos": "YELLOW",
    "explanation": "(musical instrument + metal [contraction])",
    "isCharacter": false,
    "composition": [
      23904,
      "/",
      23150
    ]
  },
  {
    "id": "23824",
    "description": "breeze",
    "pos": "YELLOW",
    "explanation": "(wind + little)",
    "isCharacter": false,
    "composition": [
      18255,
      "/",
      24917
    ]
  },
  {
    "id": "23825",
    "description": "bugle_(1)",
    "pos": "YELLOW",
    "explanation": "(horn + combat)  SYMBOL SYNONYM",
    "isCharacter": false,
    "composition": [
      14895,
      "/",
      18036
    ]
  },
  {
    "id": "23826",
    "description": "bugle_(2)",
    "pos": "YELLOW",
    "explanation": "(brass instrument + 0 + disc: horn with no valves)  SYMBOL SYNONYM",
    "isCharacter": false,
    "composition": [
      23904,
      "/",
      23150,
      "/",
      8496,
      "/",
      13685
    ]
  },
  {
    "id": "23827",
    "description": "burned_out,burnt_out_(OLD)",
    "pos": "GREEN",
    "explanation": "(sickness + without + energy_(mental) + description indicator)",
    "isCharacter": false,
    "composition": [
      16164,
      ";",
      8998,
      "/",
      15474,
      "/",
      13918,
      "/",
      15471
    ]
  },
  {
    "id": "23828",
    "description": "calm,lull",
    "pos": "YELLOW",
    "explanation": "(without + wind)",
    "isCharacter": false,
    "composition": [
      15474,
      "/",
      18255
    ]
  },
  {
    "id": "23829",
    "description": "calm_(weather)",
    "pos": "GREEN",
    "explanation": "(calm + description indicator)",
    "isCharacter": false,
    "composition": [
      15474,
      "/",
      18255,
      ";",
      8998
    ]
  },
  {
    "id": "23830",
    "description": "castanets_(1)",
    "pos": "YELLOW",
    "explanation": "(disc + finger)  SYMBOL SYNONYM",
    "isCharacter": false,
    "composition": [
      13685,
      "/",
      14180
    ]
  },
  {
    "id": "23831",
    "description": "castanets_(2)",
    "pos": "YELLOW",
    "explanation": "(musical instrument + up and down + disc + finger)  SYMBOL SYNONYM",
    "isCharacter": false,
    "composition": [
      23904,
      "/",
      20524,
      "/",
      13685,
      "/",
      14180
    ]
  },
  {
    "id": "23832",
    "description": "CD_cover",
    "pos": "YELLOW",
    "explanation": "(protection + CD,record)",
    "isCharacter": false,
    "composition": [
      16420,
      "/",
      25601,
      "/",
      13894
    ]
  },
  {
    "id": "23833",
    "description": "celeriac,celery",
    "pos": "YELLOW",
    "explanation": "(celery [modification, upper part] + vegetable_(below_ground) [modification, lower part] (combination): pictograph)  - Character (superimposed - modified - combined)",
    "isCharacter": true
  },
  {
    "id": "23834",
    "description": "cello",
    "pos": "YELLOW",
    "explanation": "(bow and string instrument + tenor)",
    "isCharacter": false,
    "composition": [
      23904,
      "/",
      23819,
      "/",
      23966
    ]
  },
  {
    "id": "23835",
    "description": "children's_song,nursery_rhyme",
    "pos": "YELLOW",
    "explanation": "(song + child)",
    "isCharacter": false,
    "composition": [
      15666,
      "/",
      15682,
      "/",
      13166
    ]
  },
  {
    "id": "23836",
    "description": "chronic_fatigue_syndrome_(OLD)",
    "pos": "YELLOW",
    "explanation": "(sickness + tired + intensity + intensity + intensity)",
    "isCharacter": false,
    "composition": [
      16164,
      "/",
      16495,
      "/",
      15701,
      "/",
      14947,
      "/",
      14947,
      "/",
      14947
    ]
  },
  {
    "id": "23837",
    "description": "clarinet,reed_instrument_(1)",
    "pos": "YELLOW",
    "explanation": "(flute,recorder + reed)  SYMBOL SYNONYM",
    "isCharacter": false,
    "composition": [
      23871,
      "/",
      23942
    ]
  },
  {
    "id": "23838",
    "description": "clarinet,reed_instrument_(2)",
    "pos": "YELLOW",
    "explanation": "(musical instrument + reed)  SYMBOL SYNONYM",
    "isCharacter": false,
    "composition": [
      23904,
      "/",
      23942
    ]
  },
  {
    "id": "23839",
    "description": "condensation",
    "pos": "YELLOW",
    "explanation": "(seven dots + liquid: the symbol suggests droplets converting into liquid)  - Character (superimposed - sequenced)",
    "isCharacter": true
  },
  {
    "id": "23840",
    "description": "condense-(to)",
    "pos": "RED",
    "explanation": "(condensation + action indicator)",
    "isCharacter": false,
    "composition": [
      23839,
      ";",
      8993
    ]
  },
  {
    "id": "23841",
    "description": "country_music",
    "pos": "YELLOW",
    "explanation": "(music + countryside)",
    "isCharacter": false,
    "composition": [
      13894,
      "/",
      15682,
      "/",
      13424
    ]
  },
  {
    "id": "23842",
    "description": "cymbal",
    "pos": "YELLOW",
    "explanation": "(musical instrument + disc + together)",
    "isCharacter": false,
    "composition": [
      23904,
      "/",
      13685,
      "/",
      23409
    ]
  },
  {
    "id": "23843",
    "description": "dance_music",
    "pos": "YELLOW",
    "explanation": "(music + legs_and_feet: music + dance [contraction])",
    "isCharacter": false,
    "composition": [
      13894,
      "/",
      15682,
      "/",
      15189
    ]
  },
  {
    "id": "23844",
    "description": "dark",
    "pos": "GREEN",
    "explanation": "(without + light + description indicator)  Preferred NEW SYNONYM, replacing 13634",
    "isCharacter": false,
    "composition": [
      15474,
      "/",
      15208,
      ";",
      8998
    ]
  },
  {
    "id": "23845",
    "description": "detest,despise-(to)",
    "pos": "RED",
    "explanation": "(feeling + negative + intensity + intensity + action indicator)",
    "isCharacter": false,
    "composition": [
      14164,
      ";",
      8993,
      "/",
      15474,
      "/",
      14947,
      "/",
      14947,
      "/",
      14947
    ]
  },
  {
    "id": "23846",
    "description": "disaster,catastrophe",
    "pos": "YELLOW",
    "explanation": "(event + negative + intensity + intensity)",
    "isCharacter": false,
    "composition": [
      14114,
      "/",
      15474,
      "/",
      14947,
      "/",
      14947,
      "/",
      14947
    ]
  },
  {
    "id": "23847",
    "description": "district,area,neighbourhood_(country)",
    "pos": "YELLOW",
    "explanation": "(part of + countryside)",
    "isCharacter": false,
    "composition": [
      15972,
      "/",
      13424
    ]
  },
  {
    "id": "23848",
    "description": "district,city_district,neighbourhood_(town)",
    "pos": "YELLOW",
    "explanation": "(part of + city)",
    "isCharacter": false,
    "composition": [
      15972,
      "/",
      14647,
      "/",
      14647,
      "/",
      14905
    ]
  },
  {
    "id": "23849",
    "description": "double_bass,bass_fiddle,contrabass",
    "pos": "YELLOW",
    "explanation": "(string and bow instrument + bass)",
    "isCharacter": false,
    "composition": [
      23904,
      "/",
      23819,
      "/",
      23809
    ]
  },
  {
    "id": "23850",
    "description": "contrabassoon,double_bassoon_(1)",
    "pos": "YELLOW",
    "explanation": "(bassoon (1) + bass)  SYMBOL SYNONYM",
    "isCharacter": false,
    "composition": [
      23871,
      "/",
      8498,
      "/",
      23942,
      "/",
      24875,
      "/",
      23809
    ]
  },
  {
    "id": "23851",
    "description": "contrabassoon,double_bassoon_(2)",
    "pos": "YELLOW",
    "explanation": "(oboe (2) + bass)  SYMBOL SYNONYM",
    "isCharacter": false,
    "composition": [
      23904,
      "/",
      8498,
      "/",
      23942,
      "/",
      23809
    ]
  },
  {
    "id": "23852",
    "description": "dried",
    "pos": "GREEN",
    "explanation": "(dryness + description after the fact indicator)",
    "isCharacter": false,
    "composition": [
      23859,
      ";",
      8996
    ]
  },
  {
    "id": "23853",
    "description": "driving_license",
    "pos": "YELLOW",
    "explanation": "(card + activity + vehicle)",
    "isCharacter": false,
    "composition": [
      23431,
      "/",
      12335,
      "/",
      18010
    ]
  },
  {
    "id": "23854",
    "description": "drum_(1)",
    "pos": "YELLOW",
    "explanation": "(pictograph)  - Character  SYMBOL SYNONYM",
    "isCharacter": true
  },
  {
    "id": "23855",
    "description": "drum_(2)",
    "pos": "YELLOW",
    "explanation": "(percussion instrument + to repeat)  SYMBOL SYNONYM",
    "isCharacter": false,
    "composition": [
      23904,
      "/",
      14666,
      "/",
      24934
    ]
  },
  {
    "id": "23856",
    "description": "drumstick",
    "pos": "YELLOW",
    "explanation": "(linear thing + drum)",
    "isCharacter": false,
    "composition": [
      15214,
      ";",
      9009,
      "/",
      23854
    ]
  },
  {
    "id": "23857",
    "description": "dry",
    "pos": "GREEN",
    "explanation": "(dryness + description indicator)  Preferred NEW SYNONYM, replacing 13887",
    "isCharacter": false,
    "composition": [
      23859,
      ";",
      8998
    ]
  },
  {
    "id": "23858",
    "description": "dry-(to)",
    "pos": "RED",
    "explanation": "(dryness + action indicator)  Preferred NEW SYNONYM, replacing 13888",
    "isCharacter": false,
    "composition": [
      23859,
      ";",
      8993
    ]
  },
  {
    "id": "23859",
    "description": "dryness,drought",
    "pos": "YELLOW",
    "explanation": "(water + to delete)  - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "23860",
    "description": "eager,keen,willing",
    "pos": "GREEN",
    "explanation": "(feeling + intensity + description indicator)",
    "isCharacter": false,
    "composition": [
      14164,
      ";",
      8998,
      "/",
      14947
    ]
  },
  {
    "id": "23861",
    "description": "easy,easily",
    "pos": "GREEN",
    "explanation": "(ease,easiness,simplicity + description indicator)  Preferred NEW SYNONYM, replacing 13905",
    "isCharacter": false,
    "composition": [
      24890,
      ";",
      8998
    ]
  },
  {
    "id": "23862",
    "description": "electric_piano",
    "pos": "YELLOW",
    "explanation": "(musical instrument + keyboard + electricity)",
    "isCharacter": false,
    "composition": [
      23904,
      "/",
      23892,
      "/",
      13918
    ]
  },
  {
    "id": "23863",
    "description": "empty",
    "pos": "GREEN",
    "explanation": "(emptying,voidance,evacuation + description indicator)  Preferred NEW SYNONYM, replacing 13932",
    "isCharacter": false,
    "composition": [
      24891,
      ";",
      8998
    ]
  },
  {
    "id": "23864",
    "description": "empty,evacuate,throw_away,void-(to)",
    "pos": "RED",
    "explanation": "(emptying,voidance,evacuation + description indicator)  Preferred NEW SYNONYM, replacing 13933",
    "isCharacter": false,
    "composition": [
      24891,
      ";",
      8993
    ]
  },
  {
    "id": "23865",
    "description": "energy_(mental)",
    "pos": "YELLOW",
    "explanation": "(electricity + mind)",
    "isCharacter": false,
    "composition": [
      13918,
      "/",
      15471
    ]
  },
  {
    "id": "23866",
    "description": "energy_(physical)",
    "pos": "YELLOW",
    "explanation": "(electricity + body)",
    "isCharacter": false,
    "composition": [
      13918,
      "/",
      12870
    ]
  },
  {
    "id": "23867",
    "description": "error,mishap",
    "pos": "YELLOW",
    "explanation": "(event + negative)",
    "isCharacter": false,
    "composition": [
      14114,
      "/",
      15474,
      "/",
      14947
    ]
  },
  {
    "id": "23868",
    "description": "exciting,excitingly,excited,excitedly",
    "pos": "GREEN",
    "explanation": "(excitement + description indicator)",
    "isCharacter": false,
    "composition": [
      14164,
      ";",
      8998,
      "/",
      14947,
      "/",
      14947
    ]
  },
  {
    "id": "23869",
    "description": "excitement",
    "pos": "YELLOW",
    "explanation": "(feeling + intensity + intensity)",
    "isCharacter": false,
    "composition": [
      14164,
      "/",
      14947,
      "/",
      14947
    ]
  },
  {
    "id": "23870",
    "description": "exhausted,worn_out_(OLD)",
    "pos": "GREEN",
    "explanation": "(feeling + without + energy_(mental) + description indicator)",
    "isCharacter": false,
    "composition": [
      14164,
      ";",
      8998,
      "/",
      15474,
      "/",
      13918,
      "/",
      15471
    ]
  },
  {
    "id": "23871",
    "description": "flute,recorder",
    "pos": "YELLOW",
    "explanation": "(pipe,hose,tube_(2) + dot + dot (high position): pictograph)  - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "23872",
    "description": "flute,transverse_flute",
    "pos": "YELLOW",
    "explanation": "(pipe,hose,tube_(1) + dot + dot: pictograph)  - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "23873",
    "description": "flute_(alto)",
    "pos": "YELLOW",
    "explanation": "(wind instrument + alto)",
    "isCharacter": false,
    "composition": [
      23904,
      "/",
      18255,
      "/",
      23803
    ]
  },
  {
    "id": "23874",
    "description": "flute_(soprano)",
    "pos": "YELLOW",
    "explanation": "(wind instrument + soprano)",
    "isCharacter": false,
    "composition": [
      23904,
      "/",
      18255,
      "/",
      23952
    ]
  },
  {
    "id": "23875",
    "description": "foam,mousse",
    "pos": "YELLOW",
    "explanation": "(many + many + bubble)",
    "isCharacter": false,
    "composition": [
      14647,
      "/",
      14647,
      "/",
      12916
    ]
  },
  {
    "id": "23876",
    "description": "French_horn,horn_(1)",
    "pos": "YELLOW",
    "explanation": "(horn + to circle: instrument with circularly coiled tubing)  SYMBOL SYNONYM",
    "isCharacter": false,
    "composition": [
      14895,
      "/",
      24249
    ]
  },
  {
    "id": "23877",
    "description": "French_horn,horn_(2)",
    "pos": "YELLOW",
    "explanation": "(brass instrument + to circle: instrument with circularly coiled tubing)  SYMBOL SYNONYM",
    "isCharacter": false,
    "composition": [
      23904,
      "/",
      23150,
      "/",
      24249
    ]
  },
  {
    "id": "23878",
    "description": "gong",
    "pos": "YELLOW",
    "explanation": "(percussion instrument + 1 + musical note)",
    "isCharacter": false,
    "composition": [
      23904,
      "/",
      14666,
      "/",
      8497,
      "/",
      15682
    ]
  },
  {
    "id": "23879",
    "description": "guitar,string_instrument",
    "pos": "YELLOW",
    "explanation": "(musical instrument + string)",
    "isCharacter": false,
    "composition": [
      23904,
      "/",
      23958
    ]
  },
  {
    "id": "23880",
    "description": "hair_spray",
    "pos": "YELLOW",
    "explanation": "(spray + hair)",
    "isCharacter": false,
    "composition": [
      24940,
      "/",
      14661
    ]
  },
  {
    "id": "23881",
    "description": "harp",
    "pos": "YELLOW",
    "explanation": "(musical instrument + many + string + finger)",
    "isCharacter": false,
    "composition": [
      23904,
      "/",
      14647,
      "/",
      23958,
      "/",
      14180
    ]
  },
  {
    "id": "23882",
    "description": "harpsichord",
    "pos": "YELLOW",
    "explanation": "(musical instrument + hook + string)",
    "isCharacter": false,
    "composition": [
      23904,
      "/",
      14891,
      "/",
      23958
    ]
  },
  {
    "id": "23883",
    "description": "hate-(to)",
    "pos": "RED",
    "explanation": "(hate,hatred + action indicator)  Preferred NEW SYNONYM, replacing 14683",
    "isCharacter": false,
    "composition": [
      14164,
      ";",
      8993,
      "/",
      15474,
      "/",
      14947,
      "/",
      14947
    ]
  },
  {
    "id": "23884",
    "description": "hum-(to)",
    "pos": "YELLOW",
    "explanation": "(to sing + without + word + action indicator)",
    "isCharacter": false,
    "composition": [
      15666,
      ";",
      8993,
      "/",
      15682,
      "/",
      15474,
      "/",
      15172
    ]
  },
  {
    "id": "23885",
    "description": "humid,damp,moist",
    "pos": "GREEN",
    "explanation": "(humidity + description indicator)",
    "isCharacter": false,
    "composition": [
      23886,
      ";",
      8998
    ]
  },
  {
    "id": "23886",
    "description": "humidity",
    "pos": "YELLOW",
    "explanation": "(air + water)  - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "23887",
    "description": "hurricane",
    "pos": "YELLOW",
    "explanation": "(much + storm: i.e., much + much + much + wind)",
    "isCharacter": false,
    "composition": [
      14647,
      "/",
      14647,
      "/",
      14647,
      "/",
      18255
    ]
  },
  {
    "id": "23888",
    "description": "kazoo",
    "pos": "YELLOW",
    "explanation": "(musical instrument + sound + mouth: device which modifies the sound of a persons voice)",
    "isCharacter": false,
    "composition": [
      23904,
      "/",
      17216,
      "/",
      15666
    ]
  },
  {
    "id": "23889",
    "description": "kebab_(Middle_East)",
    "pos": "YELLOW",
    "explanation": "(meat + hot + long)  SYMBOL SYNONYM",
    "isCharacter": false,
    "composition": [
      14377,
      "/",
      12378,
      "/",
      17506,
      "/",
      14183,
      "/",
      15193
    ]
  },
  {
    "id": "23890",
    "description": "kebab_(Scandinavia)",
    "pos": "YELLOW",
    "explanation": "(meat + rotation + to cut)  SYMBOL SYNONYM",
    "isCharacter": false,
    "composition": [
      14377,
      "/",
      12378,
      "/",
      24249,
      "/",
      15159
    ]
  },
  {
    "id": "23891",
    "description": "kebab_(UK,NL)",
    "pos": "YELLOW",
    "explanation": "(meat + part of + linear thing)  SYMBOL SYNONYM",
    "isCharacter": false,
    "composition": [
      14377,
      "/",
      12378,
      "/",
      15972,
      "/",
      15214,
      ";",
      9009
    ]
  },
  {
    "id": "23892",
    "description": "keyboard",
    "pos": "YELLOW",
    "explanation": "(pictograph)  - Character",
    "isCharacter": true
  },
  {
    "id": "23893",
    "description": "last_(person,etc)",
    "pos": "GREEN",
    "explanation": "(person + end + description indicator)  Person can be replaced by an appropriate other classifier.",
    "isCharacter": false,
    "composition": [
      16161,
      ";",
      8998,
      "/",
      13935
    ]
  },
  {
    "id": "23894",
    "description": "lie",
    "pos": "YELLOW",
    "explanation": "(purpose + without + truth)  Preferred NEW SYNONYM, replacing 15203",
    "isCharacter": false,
    "composition": [
      16437,
      "/",
      15474,
      "/",
      17786
    ]
  },
  {
    "id": "23895",
    "description": "lie-(to)",
    "pos": "RED",
    "explanation": "(lie + action indicator)  Preferred NEW SYNONYM, replacing 15204",
    "isCharacter": false,
    "composition": [
      16437,
      ";",
      8993,
      "/",
      15474,
      "/",
      17786
    ]
  },
  {
    "id": "23896",
    "description": "line,queue",
    "pos": "YELLOW",
    "explanation": "(line + many + person)  Person can be replaced by an appropriate other specifier.",
    "isCharacter": false,
    "composition": [
      15214,
      "/",
      14647,
      "/",
      16161
    ]
  },
  {
    "id": "23897",
    "description": "lose_(fail_to_win)-(to)",
    "pos": "RED",
    "explanation": "(competition + loss + action indicator)  Preferred NEW SYNONYM, replacing 15395",
    "isCharacter": false,
    "composition": [
      16451,
      ";",
      8993,
      "/",
      17449
    ]
  },
  {
    "id": "23898",
    "description": "loudspeaker",
    "pos": "YELLOW",
    "explanation": "(thing + sound + intensity + out)",
    "isCharacter": false,
    "composition": [
      17717,
      "/",
      17216,
      "/",
      14947,
      "/",
      15943
    ]
  },
  {
    "id": "23899",
    "description": "mandolin",
    "pos": "YELLOW",
    "explanation": "(string instrument + man + blissymbolics: an instrument associated with Charles Bliss)",
    "isCharacter": false,
    "composition": [
      23904,
      "/",
      23958,
      "/",
      15416,
      "/",
      12857
    ]
  },
  {
    "id": "23900",
    "description": "maracas,calabash_(etc)",
    "pos": "YELLOW",
    "explanation": "(rhythm_instrument + fruit)",
    "isCharacter": false,
    "composition": [
      23904,
      "/",
      20524,
      "/",
      14405
    ]
  },
  {
    "id": "23901",
    "description": "melodica,blow-organ",
    "pos": "YELLOW",
    "explanation": "(wind instrument + mouth + keyboard)",
    "isCharacter": false,
    "composition": [
      23904,
      "/",
      18255,
      "/",
      15666,
      "/",
      23892
    ]
  },
  {
    "id": "23902",
    "description": "microphone",
    "pos": "YELLOW",
    "explanation": "(thing + sound + into)",
    "isCharacter": false,
    "composition": [
      17717,
      "/",
      17216,
      "/",
      14952
    ]
  },
  {
    "id": "23903",
    "description": "MP3_player,iPod_(etc)",
    "pos": "YELLOW",
    "explanation": "(machine + to listen + carry)",
    "isCharacter": false,
    "composition": [
      15406,
      "/",
      13894,
      "/",
      24714
    ]
  },
  {
    "id": "23904",
    "description": "musical_instrument_(in_combinations)",
    "pos": "YELLOW",
    "explanation": "(thing + musical note) Used as classifier to create Bliss-words denoting musical instruments.  - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "23905",
    "description": "musical_instrument_(with_many_strings)",
    "pos": "YELLOW",
    "explanation": "(musical instrument + many + string)",
    "isCharacter": false,
    "composition": [
      23904,
      "/",
      14647,
      "/",
      23958
    ]
  },
  {
    "id": "23906",
    "description": "never",
    "pos": "GREEN",
    "explanation": "(without + time + description indicator)  Preferred NEW SYNONYM, replacing 15709",
    "isCharacter": false,
    "composition": [
      15474,
      "/",
      17732,
      ";",
      8998
    ]
  },
  {
    "id": "23907",
    "description": "nothing,none",
    "pos": "WHITE",
    "explanation": "(without + thing)  Preferred NEW SYNONYM, replacing 15725",
    "isCharacter": false,
    "composition": [
      15474,
      "/",
      17717
    ]
  },
  {
    "id": "23908",
    "description": "oboe_(1)",
    "pos": "YELLOW",
    "explanation": "(flute,recorder + 2 + reed)  SYMBOL SYNONYM",
    "isCharacter": false,
    "composition": [
      23871,
      "/",
      8498,
      "/",
      23942
    ]
  },
  {
    "id": "23909",
    "description": "oboe_(2)",
    "pos": "YELLOW",
    "explanation": "(musical instrument + 2 + reed)  SYMBOL SYNONYM",
    "isCharacter": false,
    "composition": [
      23904,
      "/",
      8498,
      "/",
      23942
    ]
  },
  {
    "id": "23910",
    "description": "old",
    "pos": "GREEN",
    "explanation": "(many + year + description indicator)  See also 15915",
    "isCharacter": false,
    "composition": [
      14647,
      "/",
      18289,
      ";",
      8998
    ]
  },
  {
    "id": "23911",
    "description": "organ,pipe_organ",
    "pos": "YELLOW",
    "explanation": "(wind instrument + many + tube)",
    "isCharacter": false,
    "composition": [
      23904,
      "/",
      18255,
      "/",
      14647,
      "/",
      23926
    ]
  },
  {
    "id": "23912",
    "description": "panpipe",
    "pos": "YELLOW",
    "explanation": "(wood instrument + many + tube)",
    "isCharacter": false,
    "composition": [
      23904,
      "/",
      17775,
      "/",
      14647,
      "/",
      23926
    ]
  },
  {
    "id": "23913",
    "description": "park-(to)",
    "pos": "RED",
    "explanation": "(parking lot + action indicator)",
    "isCharacter": false,
    "composition": [
      16193,
      ";",
      8993,
      "/",
      18010
    ]
  },
  {
    "id": "23914",
    "description": "parking_permit",
    "pos": "YELLOW",
    "explanation": "(card + parking lot)",
    "isCharacter": false,
    "composition": [
      23431,
      "/",
      16193,
      "/",
      18010
    ]
  },
  {
    "id": "23915",
    "description": "parking_ticket",
    "pos": "YELLOW",
    "explanation": "(paper + parking place)",
    "isCharacter": false,
    "composition": [
      15962,
      "/",
      16193,
      "/",
      18010
    ]
  },
  {
    "id": "23916",
    "description": "participant",
    "pos": "BLUE",
    "explanation": "(person + participation)",
    "isCharacter": false,
    "composition": [
      16161,
      "/",
      12335,
      "/",
      23409
    ]
  },
  {
    "id": "23917",
    "description": "participate-(to)",
    "pos": "RED",
    "explanation": "(participation + action indicator)",
    "isCharacter": false,
    "composition": [
      12335,
      ";",
      8993,
      "/",
      23409
    ]
  },
  {
    "id": "23918",
    "description": "participation",
    "pos": "YELLOW",
    "explanation": "(activity + together)",
    "isCharacter": false,
    "composition": [
      12335,
      "/",
      23409
    ]
  },
  {
    "id": "23919",
    "description": "participation,involvement",
    "pos": "YELLOW",
    "explanation": "(feeling + participation)",
    "isCharacter": false,
    "composition": [
      14164,
      "/",
      "RK:-2",
      "/",
      12335,
      "/",
      23409
    ]
  },
  {
    "id": "23920",
    "description": "pennywhistle,tin_whistle",
    "pos": "YELLOW",
    "explanation": "(musical instrument + downwards + soprano: explanation?)",
    "isCharacter": false,
    "composition": [
      23904,
      "/",
      13869,
      "/",
      23952
    ]
  },
  {
    "id": "23921",
    "description": "percussion_instrument",
    "pos": "YELLOW",
    "explanation": "(musical instrument + mallet)",
    "isCharacter": false,
    "composition": [
      23904,
      "/",
      14666
    ]
  },
  {
    "id": "23922",
    "description": "piano_(1)",
    "pos": "YELLOW",
    "explanation": "(musical instrument + keyboard)  SYMBOL SYNONYM",
    "isCharacter": false,
    "composition": [
      23904,
      "/",
      23892
    ]
  },
  {
    "id": "23923",
    "description": "piano_(2)",
    "pos": "YELLOW",
    "explanation": "(percussion_instrument + string)  SYMBOL SYNONYM",
    "isCharacter": false,
    "composition": [
      23904,
      "/",
      14666,
      "/",
      23958
    ]
  },
  {
    "id": "23924",
    "description": "piccolo_(1)",
    "pos": "YELLOW",
    "explanation": "(flute,transverse_flute + little)  SYMBOL SYNONYM",
    "isCharacter": false,
    "composition": [
      23872,
      "/",
      24917
    ]
  },
  {
    "id": "23925",
    "description": "piccolo_(2)",
    "pos": "YELLOW",
    "explanation": "(wind_instrument + soprano + little)  SYMBOL SYNONYM",
    "isCharacter": false,
    "composition": [
      23904,
      "/",
      18255,
      "/",
      23952,
      "/",
      24917
    ]
  },
  {
    "id": "23926",
    "description": "pipe,hose,tube_(2)",
    "pos": "YELLOW",
    "explanation": "(pictograph: vertical orientation)  - Character    SYMBOL SYNONYM",
    "isCharacter": true
  },
  {
    "id": "23927",
    "description": "pipe,tube_(closed)",
    "pos": "YELLOW",
    "explanation": "(pictograph)  - Character",
    "isCharacter": true
  },
  {
    "id": "23928",
    "description": "key,tonality",
    "pos": "YELLOW",
    "explanation": "(stave,staff + musical note)",
    "isCharacter": false,
    "composition": [
      23955,
      "/",
      15682
    ]
  },
  {
    "id": "23929",
    "description": "pitch_(sound)",
    "pos": "YELLOW",
    "explanation": "(stave,staff + pointer)  - Character (superimposed - pointer)",
    "isCharacter": true
  },
  {
    "id": "23930",
    "description": "play_(instrument)-(to)",
    "pos": "RED",
    "explanation": "(musical_instrument + action indicator)",
    "isCharacter": false,
    "composition": [
      17755,
      ";",
      8993,
      "/",
      15682
    ]
  },
  {
    "id": "23931",
    "description": "pop_music",
    "pos": "YELLOW",
    "explanation": "(music + many + many + person)",
    "isCharacter": false,
    "composition": [
      13894,
      "/",
      15682,
      "/",
      14647,
      "/",
      14647,
      "/",
      16161
    ]
  },
  {
    "id": "23932",
    "description": "punk_rock",
    "pos": "YELLOW",
    "explanation": "(music + hair + up)",
    "isCharacter": false,
    "composition": [
      13894,
      "/",
      15682,
      "/",
      14660,
      "/",
      17983
    ]
  },
  {
    "id": "23933",
    "description": "rainbow",
    "pos": "YELLOW",
    "explanation": "(bow,arc + many + colour)",
    "isCharacter": false,
    "composition": [
      23817,
      "/",
      14647,
      "/",
      13377
    ]
  },
  {
    "id": "23934",
    "description": "rap_(music)",
    "pos": "YELLOW",
    "explanation": "(song + same + speak-(to))",
    "isCharacter": false,
    "composition": [
      15666,
      "/",
      15682,
      "/",
      16713,
      "/",
      15666
    ]
  },
  {
    "id": "23935",
    "description": "rattle",
    "pos": "YELLOW",
    "explanation": "(thing + rotation + noise_(loud))",
    "isCharacter": false,
    "composition": [
      17717,
      "/",
      24249,
      "/",
      17216,
      "/",
      14947
    ]
  },
  {
    "id": "23936",
    "description": "rattle_(musical_instrument)",
    "pos": "YELLOW",
    "explanation": "(musical instrument + rotation + noise_(loud))",
    "isCharacter": false,
    "composition": [
      23904,
      "/",
      24249,
      "/",
      17216,
      "/",
      14947
    ]
  },
  {
    "id": "23937",
    "description": "recorder",
    "pos": "YELLOW",
    "explanation": "(flute,recorder + tree: where tree is a contraction of wood)",
    "isCharacter": false,
    "composition": [
      23871,
      "/",
      17775
    ]
  },
  {
    "id": "23938",
    "description": "recorder_(alto)",
    "pos": "YELLOW",
    "explanation": "(recorder + alto)",
    "isCharacter": false,
    "composition": [
      23904,
      "/",
      17775,
      "/",
      23803
    ]
  },
  {
    "id": "23939",
    "description": "recorder_(bass)",
    "pos": "YELLOW",
    "explanation": "(recorder + bass)",
    "isCharacter": false,
    "composition": [
      23904,
      "/",
      17775,
      "/",
      23809
    ]
  },
  {
    "id": "23940",
    "description": "recorder_(soprano)",
    "pos": "YELLOW",
    "explanation": "(recorder + soprano)",
    "isCharacter": false,
    "composition": [
      23904,
      "/",
      17775,
      "/",
      23952
    ]
  },
  {
    "id": "23941",
    "description": "recorder_(tenor)",
    "pos": "YELLOW",
    "explanation": "(recorder + tenor)",
    "isCharacter": false,
    "composition": [
      23904,
      "/",
      17775,
      "/",
      23966
    ]
  },
  {
    "id": "23942",
    "description": "reed",
    "pos": "YELLOW",
    "explanation": "(pictograph)  - Character",
    "isCharacter": true
  },
  {
    "id": "23943",
    "description": "rhythm_instrument",
    "pos": "YELLOW",
    "explanation": "(musical instrument + up and down)",
    "isCharacter": false,
    "composition": [
      23904,
      "/",
      20524
    ]
  },
  {
    "id": "23944",
    "description": "roe_deer",
    "pos": "YELLOW",
    "explanation": "(deer + little)",
    "isCharacter": false,
    "composition": [
      12381,
      "/",
      24917
    ]
  },
  {
    "id": "23945",
    "description": "rotisserie,spit",
    "pos": "YELLOW",
    "explanation": "(meat + rotation)",
    "isCharacter": false,
    "composition": [
      14377,
      "/",
      12378,
      "/",
      24249
    ]
  },
  {
    "id": "23946",
    "description": "saxophone_(1)",
    "pos": "YELLOW",
    "explanation": "(clarinet,reed_instrument_(1) + metal [contraction])  SYMBOL SYNONYM",
    "isCharacter": false,
    "composition": [
      23871,
      "/",
      23942,
      "/",
      23150
    ]
  },
  {
    "id": "23947",
    "description": "saxophone_(2)",
    "pos": "YELLOW",
    "explanation": "(clarinet,reed_instrument_(2) + metal [contraction])  SYMBOL SYNONYM",
    "isCharacter": false,
    "composition": [
      23904,
      "/",
      23942,
      "/",
      23150
    ]
  },
  {
    "id": "23948",
    "description": "sit_ski_(OLD)",
    "pos": "YELLOW",
    "explanation": "(2 + sitski,sit_ski)  SUPERSEDED SYNONYM  See sitski,sit_ski 25609",
    "isCharacter": false,
    "composition": [
      8498,
      "/",
      25609
    ]
  },
  {
    "id": "23949",
    "description": "small_pancake,blini",
    "pos": "YELLOW",
    "explanation": "(pancake + little)",
    "isCharacter": false,
    "composition": [
      23603,
      "/",
      24917
    ]
  },
  {
    "id": "23950",
    "description": "snowmobile",
    "pos": "YELLOW",
    "explanation": "(vehicle + snow)",
    "isCharacter": false,
    "composition": [
      18010,
      "/",
      17192
    ]
  },
  {
    "id": "23951",
    "description": "snowplow,snowplough",
    "pos": "YELLOW",
    "explanation": "(vehicle + minus + snow)",
    "isCharacter": false,
    "composition": [
      18010,
      "/",
      15474,
      "/",
      17192
    ]
  },
  {
    "id": "23952",
    "description": "soprano",
    "pos": "YELLOW",
    "explanation": "(stave + pointer, to soprano position in stave)  - Character (superimposed - pointer)",
    "isCharacter": true
  },
  {
    "id": "23953",
    "description": "spray,vaporize-(to)",
    "pos": "RED",
    "explanation": "(spray,vaporization + action indicator)",
    "isCharacter": false,
    "composition": [
      24940,
      ";",
      8993
    ]
  },
  {
    "id": "23954",
    "description": "spray_bottle,vaporizer,spray_can",
    "pos": "YELLOW",
    "explanation": "(bottle + spray,vaporization)",
    "isCharacter": false,
    "composition": [
      12880,
      "/",
      24940
    ]
  },
  {
    "id": "23955",
    "description": "stave,staff",
    "pos": "YELLOW",
    "explanation": "(pictograph: five half-sized horizontal lines, as in a stave for musical notation)  - Character",
    "isCharacter": true
  },
  {
    "id": "23956",
    "description": "storm",
    "pos": "YELLOW",
    "explanation": "(much + gale: i.e., much + much + wind)",
    "isCharacter": false,
    "composition": [
      14647,
      "/",
      14647,
      "/",
      18255
    ]
  },
  {
    "id": "23957",
    "description": "stressed_(for_time),pushed_(for_time),in_a_rush",
    "pos": "GREEN",
    "explanation": "(stress_(for_time) + description indicator: having a feeling of lacking time for an activity)",
    "isCharacter": false,
    "composition": [
      14164,
      ";",
      8998,
      "/",
      15474,
      "/",
      17732,
      "/",
      12335
    ]
  },
  {
    "id": "23958",
    "description": "string",
    "pos": "YELLOW",
    "explanation": "(line + pointer, to the line)  - Character (superimposed - pointer)",
    "isCharacter": true
  },
  {
    "id": "23959",
    "description": "string_(for_musical_instrument)",
    "pos": "YELLOW",
    "explanation": "(bow_and_string_(musical) + pointer, to string)  - Character (superimposed - pointer)",
    "isCharacter": true
  },
  {
    "id": "23960",
    "description": "surprise",
    "pos": "YELLOW",
    "explanation": "(feeling + what,question_mark + intensity: a feeling of unexpectedness)",
    "isCharacter": false,
    "composition": [
      14164,
      "/",
      18229,
      "/",
      14947
    ]
  },
  {
    "id": "23961",
    "description": "surprise-(to)",
    "pos": "RED",
    "explanation": "(cause-(to) + surprise + action indicator)  Preferred NEW SYNONYM, replacing 17470",
    "isCharacter": false,
    "composition": [
      13134,
      ";",
      8993,
      "/",
      14164,
      "/",
      18229,
      "/",
      14947
    ]
  },
  {
    "id": "23962",
    "description": "surprised",
    "pos": "GREEN",
    "explanation": "(surprise + description indicator)",
    "isCharacter": false,
    "composition": [
      14164,
      ";",
      8998,
      "/",
      18229,
      "/",
      14947
    ]
  },
  {
    "id": "23963",
    "description": "synthesizer,synthesiser,keyboard",
    "pos": "YELLOW",
    "explanation": "(piano_(1) + digits_(computer): a digital keyboard instrument)",
    "isCharacter": false,
    "composition": [
      23904,
      "/",
      23892,
      "/",
      23476
    ]
  },
  {
    "id": "23964",
    "description": "tambourine_(1)",
    "pos": "YELLOW",
    "explanation": "(drum + up and down)  SYMBOL SYNONYM",
    "isCharacter": false,
    "composition": [
      23854,
      "/",
      20524
    ]
  },
  {
    "id": "23965",
    "description": "tambourine_(2)",
    "pos": "YELLOW",
    "explanation": "(rhythm_instrument + disk + hand)  SYMBOL SYNONYM",
    "isCharacter": false,
    "composition": [
      23904,
      "/",
      20524,
      "/",
      13685,
      "/",
      14667
    ]
  },
  {
    "id": "23966",
    "description": "tenor",
    "pos": "YELLOW",
    "explanation": "(stave + pointer, to tenor position in stave)  - Character (superimposed - pointer)",
    "isCharacter": true
  },
  {
    "id": "23967",
    "description": "tornado",
    "pos": "YELLOW",
    "explanation": "(gale + rotation: a strong rotating wind)",
    "isCharacter": false,
    "composition": [
      14647,
      "/",
      18255,
      "/",
      24249
    ]
  },
  {
    "id": "23968",
    "description": "triangle_(instrument)_(1)",
    "pos": "YELLOW",
    "explanation": "(triangle [contraction] + mallet)  SYMBOL SYNONYM",
    "isCharacter": false,
    "composition": [
      13607,
      "/",
      14666
    ]
  },
  {
    "id": "23969",
    "description": "triangle_(instrument)_(2)",
    "pos": "YELLOW",
    "explanation": "(musical instrument + triangle_(instrument)_(1))  SYMBOL SYNONYM",
    "isCharacter": false,
    "composition": [
      23904,
      "/",
      13607,
      "/",
      14666
    ]
  },
  {
    "id": "23970",
    "description": "trombone",
    "pos": "YELLOW",
    "explanation": "(brass_instrument + back_and_forth)",
    "isCharacter": false,
    "composition": [
      23904,
      "/",
      23150,
      "/",
      12610
    ]
  },
  {
    "id": "23971",
    "description": "trumpet,horn,cornet_(2)",
    "pos": "YELLOW",
    "explanation": "(brass_instrument + 3 + disc: the three discs representing the three valves of a trumpet)  SYMBOL SYNONYM",
    "isCharacter": false,
    "composition": [
      23904,
      "/",
      23150,
      "/",
      8499,
      "/",
      13685
    ]
  },
  {
    "id": "23972",
    "description": "tsunami",
    "pos": "YELLOW",
    "explanation": "(tidal_wave + intensity: a very big tidal wave)",
    "isCharacter": false,
    "composition": [
      21880,
      "/",
      24875,
      "/",
      14947,
      "/",
      14947,
      "/",
      14947
    ]
  },
  {
    "id": "23973",
    "description": "tuba_(1)",
    "pos": "YELLOW",
    "explanation": "(trumpet + big)  SYMBOL SYNONYM",
    "isCharacter": false,
    "composition": [
      14895,
      "/",
      24875
    ]
  },
  {
    "id": "23974",
    "description": "tuba_(2)",
    "pos": "YELLOW",
    "explanation": "(brass_instrument + bass)  SYMBOL SYNONYM",
    "isCharacter": false,
    "composition": [
      23904,
      "/",
      23150,
      "/",
      23809
    ]
  },
  {
    "id": "23975",
    "description": "tuning_fork",
    "pos": "YELLOW",
    "explanation": "(fork + musical_note)",
    "isCharacter": false,
    "composition": [
      14389,
      "/",
      15682
    ]
  },
  {
    "id": "23976",
    "description": "twin_brother",
    "pos": "BLUE",
    "explanation": "(brother + same + birth)",
    "isCharacter": false,
    "composition": [
      17209,
      "/",
      8498,
      "/",
      16713,
      "/",
      12843
    ]
  },
  {
    "id": "23977",
    "description": "twin_sister",
    "pos": "BLUE",
    "explanation": "(sister + same + birth)",
    "isCharacter": false,
    "composition": [
      13638,
      "/",
      8498,
      "/",
      16713,
      "/",
      12843
    ]
  },
  {
    "id": "23978",
    "description": "twins",
    "pos": "BLUE",
    "explanation": "(2 + person + same + birth)",
    "isCharacter": false,
    "composition": [
      8498,
      "/",
      16161,
      "/",
      16713,
      "/",
      12843
    ]
  },
  {
    "id": "23979",
    "description": "ukulele",
    "pos": "YELLOW",
    "explanation": "(guitar,string_instrument + little)",
    "isCharacter": false,
    "composition": [
      23904,
      "/",
      23958,
      "/",
      24917
    ]
  },
  {
    "id": "23980",
    "description": "unfold-(to)",
    "pos": "RED",
    "explanation": "(unfolding + action indicator)  Preferred NEW SYNONYM, replacing 17976",
    "isCharacter": false,
    "composition": [
      25630,
      ";",
      8993
    ]
  },
  {
    "id": "23981",
    "description": "wind_instrument",
    "pos": "YELLOW",
    "explanation": "(musical_instrument + wind)",
    "isCharacter": false,
    "composition": [
      23904,
      "/",
      18255
    ]
  },
  {
    "id": "23982",
    "description": "viola",
    "pos": "YELLOW",
    "explanation": "(bow_and_string_instrument + alto)",
    "isCharacter": false,
    "composition": [
      23904,
      "/",
      23819,
      "/",
      23803
    ]
  },
  {
    "id": "23983",
    "description": "violin",
    "pos": "YELLOW",
    "explanation": "(bow_and_string_instrument + soprano)",
    "isCharacter": false,
    "composition": [
      23904,
      "/",
      23819,
      "/",
      23952
    ]
  },
  {
    "id": "23984",
    "description": "voice",
    "pos": "YELLOW",
    "explanation": "(sound + mouth)",
    "isCharacter": false,
    "composition": [
      17216,
      "/",
      15666
    ]
  },
  {
    "id": "23985",
    "description": "woodwind_instrument",
    "pos": "YELLOW",
    "explanation": "(wind_instrument + wood [contraction]",
    "isCharacter": false,
    "composition": [
      23904,
      "/",
      18255,
      "/",
      17775
    ]
  },
  {
    "id": "23986",
    "description": "xylophone,vibraphone_(1)",
    "pos": "YELLOW",
    "explanation": "(keyboard + mallet)  SYMBOL SYNONYM",
    "isCharacter": false,
    "composition": [
      23892,
      "/",
      14666
    ]
  },
  {
    "id": "23987",
    "description": "xylophone,vibraphone_(2)",
    "pos": "YELLOW",
    "explanation": "(percussion_instrument + keyboard)  SYMBOL SYNONYM",
    "isCharacter": false,
    "composition": [
      23904,
      "/",
      14666,
      "/",
      23892
    ]
  },
  {
    "id": "24001",
    "description": "acrobat",
    "pos": "BLUE",
    "explanation": "(person + gymnastics + show [contraction])",
    "isCharacter": false,
    "composition": [
      16161,
      "/",
      20517,
      "/",
      16194,
      "/",
      14133
    ]
  },
  {
    "id": "24002",
    "description": "acrobatics",
    "pos": "YELLOW",
    "explanation": "(activity + gymnastics + show [contraction])",
    "isCharacter": false,
    "composition": [
      12335,
      "/",
      20517,
      "/",
      16194,
      "/",
      14133
    ]
  },
  {
    "id": "24003",
    "description": "adding,additive",
    "pos": "YELLOW",
    "explanation": "(addition + thing indicator)  - (character with thing indicator)",
    "isCharacter": "false",
    "composition": [
      12339,
      ";",
      9009
    ]
  },
  {
    "id": "24004",
    "description": "Advent",
    "pos": "YELLOW",
    "explanation": "(limited time + before + Christmas)",
    "isCharacter": false,
    "composition": [
      15212,
      "/",
      12656,
      "/",
      13639,
      "/",
      12843,
      "/",
      13613
    ]
  },
  {
    "id": "24005",
    "description": "agnosticism",
    "pos": "YELLOW",
    "explanation": "(doubt + God: belief that we don't know of either the existence or the nonexistence of God)",
    "isCharacter": false,
    "composition": [
      22911,
      "/",
      14451
    ]
  },
  {
    "id": "24006",
    "description": "agreement_(spoken)",
    "pos": "YELLOW",
    "explanation": "(mouth + agreement: spoken agreement)",
    "isCharacter": false,
    "composition": [
      15666,
      "/",
      12354
    ]
  },
  {
    "id": "24007",
    "description": "agreement_(written),contract",
    "pos": "YELLOW",
    "explanation": "(paper + agreement: agreement by a written document)",
    "isCharacter": false,
    "composition": [
      15962,
      "/",
      12354
    ]
  },
  {
    "id": "24008",
    "description": "aid_store_room",
    "pos": "YELLOW",
    "explanation": "(store room + aid)",
    "isCharacter": false,
    "composition": [
      16687,
      "/",
      13403,
      "/",
      14704,
      ";",
      9009
    ]
  },
  {
    "id": "24009",
    "description": "animal_droppings",
    "pos": "YELLOW",
    "explanation": "(waste + animal)",
    "isCharacter": false,
    "composition": [
      18043,
      "/",
      12378
    ]
  },
  {
    "id": "24010",
    "description": "ankle_splint",
    "pos": "YELLOW",
    "explanation": "(aid + bones_with_joint + ankle + thing indicator: support for the ankle joint)",
    "isCharacter": false,
    "composition": [
      14704,
      ";",
      9009,
      "/",
      25528,
      "/",
      12391
    ]
  },
  {
    "id": "24011",
    "description": "other,another_(thing)",
    "pos": "WHITE",
    "explanation": "(thing + two)  See also: other,another_(person) 15938",
    "isCharacter": false,
    "composition": [
      17717,
      "/",
      8498
    ]
  },
  {
    "id": "24012",
    "description": "apricot_(dried)",
    "pos": "YELLOW",
    "explanation": "(apricot + dry)",
    "isCharacter": false,
    "composition": [
      15983,
      "/",
      24917,
      "/",
      23859
    ]
  },
  {
    "id": "24013",
    "description": "Ascension_(of_Christ)",
    "pos": "YELLOW",
    "explanation": "(up + Christ)",
    "isCharacter": false,
    "composition": [
      17983,
      "/",
      15416,
      "/",
      13613
    ]
  },
  {
    "id": "24014",
    "description": "Ascension_Day",
    "pos": "YELLOW",
    "explanation": "(day + Ascension)",
    "isCharacter": false,
    "composition": [
      13639,
      "/",
      17983,
      "/",
      15416,
      "/",
      13613
    ]
  },
  {
    "id": "24015",
    "description": "asparagus",
    "pos": "YELLOW",
    "explanation": "(root(s) + line,stripe: the line representing a modified stalk of asparagus, pictograph)  - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "24016",
    "description": "assessment_room",
    "pos": "YELLOW",
    "explanation": "(room + assessment)",
    "isCharacter": false,
    "composition": [
      16687,
      "/",
      16445,
      "/",
      14382,
      "/",
      "RK:-2",
      "/",
      13949
    ]
  },
  {
    "id": "24017",
    "description": "at_one's_destination,there",
    "pos": "GREEN",
    "explanation": "(end + description indicator)",
    "isCharacter": false,
    "composition": [
      13935,
      ";",
      8998
    ]
  },
  {
    "id": "24018",
    "description": "auditor,accountant",
    "pos": "BLUE",
    "explanation": "(person + watch [contraction] + money)",
    "isCharacter": false,
    "composition": [
      16161,
      "/",
      24949,
      "/",
      15484
    ]
  },
  {
    "id": "24019",
    "description": "avalanche",
    "pos": "YELLOW",
    "explanation": "(snow + down + mountain)",
    "isCharacter": false,
    "composition": [
      17192,
      "/",
      13869,
      "/",
      "RK:-2",
      "/",
      15663
    ]
  },
  {
    "id": "24020",
    "description": "bark-(to)",
    "pos": "RED",
    "explanation": "(to talk + dog + action indicator)",
    "isCharacter": false,
    "composition": [
      15666,
      ";",
      8993,
      "/",
      12380
    ]
  },
  {
    "id": "24021",
    "description": "bean_(dried),chick-pea,kidney_bean,pinto_bean",
    "pos": "YELLOW",
    "explanation": "(bean + dry)  Preferred NEW SYNONYM, replacing 13880",
    "isCharacter": false,
    "composition": [
      12642,
      "/",
      23859
    ]
  },
  {
    "id": "24022",
    "description": "bicycle_path",
    "pos": "YELLOW",
    "explanation": "(place + activity + bicycle)",
    "isCharacter": false,
    "composition": [
      16193,
      "/",
      12335,
      "/",
      8498,
      "/",
      18232
    ]
  },
  {
    "id": "24023",
    "description": "bisexual",
    "pos": "GREEN",
    "explanation": "(bisexuality + description indicator)",
    "isCharacter": false,
    "composition": [
      14164,
      ";",
      8998,
      "/",
      "RK:-2",
      "/",
      13425,
      "/",
      8498,
      "/",
      12360
    ]
  },
  {
    "id": "24024",
    "description": "bisexuality",
    "pos": "YELLOW",
    "explanation": "(feeling + male and female + both)",
    "isCharacter": false,
    "composition": [
      14164,
      "/",
      "RK:-2",
      "/",
      13425,
      "/",
      8498,
      "/",
      12360
    ]
  },
  {
    "id": "24025",
    "description": "bit_(horse)",
    "pos": "YELLOW",
    "explanation": "(metal [contraction] + mouth + horse)",
    "isCharacter": false,
    "composition": [
      23150,
      "/",
      15666,
      "/",
      14897
    ]
  },
  {
    "id": "24026",
    "description": "bleat,baa-(to)",
    "pos": "RED",
    "explanation": "(to talk + sheep + action indicator)",
    "isCharacter": false,
    "composition": [
      15666,
      ";",
      8993,
      "/",
      12379,
      "/",
      13365
    ]
  },
  {
    "id": "24027",
    "description": "Bliss_fanatic",
    "pos": "BLUE",
    "explanation": "(fanatic + blissymbol)",
    "isCharacter": false,
    "composition": [
      16161,
      "/",
      14164,
      "/",
      24913,
      "/",
      14947,
      "/",
      12857
    ]
  },
  {
    "id": "24028",
    "description": "blood_vessel",
    "pos": "YELLOW",
    "explanation": "(tube + blood [contraction])",
    "isCharacter": false,
    "composition": [
      23926,
      "/",
      15206
    ]
  },
  {
    "id": "24029",
    "description": "blush-(to)",
    "pos": "RED",
    "explanation": "(face + red + action indicator)",
    "isCharacter": false,
    "composition": [
      14138,
      ";",
      8993,
      "/",
      13377,
      "/",
      15666
    ]
  },
  {
    "id": "24030",
    "description": "body_brace,corset",
    "pos": "YELLOW",
    "explanation": "(aid + bones_with_joint + body + thing indicator: bones_with_joint representing joint [contraction], support for the hip joint and the spine)",
    "isCharacter": false,
    "composition": [
      14704,
      ";",
      9009,
      "/",
      25528,
      "/",
      12870
    ]
  },
  {
    "id": "24031",
    "description": "body_fluid",
    "pos": "YELLOW",
    "explanation": "(liquid + body)",
    "isCharacter": false,
    "composition": [
      18209,
      "/",
      12870
    ]
  },
  {
    "id": "24032",
    "description": "body_hair",
    "pos": "YELLOW",
    "explanation": "(hair + body)",
    "isCharacter": false,
    "composition": [
      14660,
      "/",
      12870
    ]
  },
  {
    "id": "24033",
    "description": "body_part",
    "pos": "YELLOW",
    "explanation": "(part of + body)",
    "isCharacter": false,
    "composition": [
      15972,
      "/",
      12870
    ]
  },
  {
    "id": "24034",
    "description": "body_temperature",
    "pos": "YELLOW",
    "explanation": "(temperature + body)",
    "isCharacter": false,
    "composition": [
      17520,
      "/",
      12870
    ]
  },
  {
    "id": "24035",
    "description": "bolt_(horse)-(to)",
    "pos": "RED",
    "explanation": "(horse + three intensity characters + danger + action indicator)",
    "isCharacter": false,
    "composition": [
      14897,
      ";",
      8993,
      "/",
      14947,
      "/",
      14947,
      "/",
      14947,
      "/",
      13632
    ]
  },
  {
    "id": "24036",
    "description": "bomb,explosive",
    "pos": "YELLOW",
    "explanation": "(explosion + thing indicator)  - (character with thing indicator)",
    "isCharacter": "false",
    "composition": [
      14132,
      ";",
      9009
    ]
  },
  {
    "id": "24037",
    "description": "bow",
    "pos": "YELLOW",
    "explanation": "(curve + thing indicator: bow, as in \"bow and arrow\", etc.)  - (character with thing indicator)",
    "isCharacter": "false",
    "composition": [
      13627,
      ";",
      9009
    ]
  },
  {
    "id": "24038",
    "description": "bridle,headstall",
    "pos": "YELLOW",
    "explanation": "(harness + muzzle + thing indicator)",
    "isCharacter": false,
    "composition": [
      14647,
      "/",
      15214,
      ";",
      9009,
      "/",
      13380,
      "/",
      24196
    ]
  },
  {
    "id": "24039",
    "description": "bus_lane",
    "pos": "YELLOW",
    "explanation": "(place + activity + bus)",
    "isCharacter": false,
    "composition": [
      16193,
      "/",
      12335,
      "/",
      13089
    ]
  },
  {
    "id": "24040",
    "description": "bus_station",
    "pos": "YELLOW",
    "explanation": "(station + bus)",
    "isCharacter": false,
    "composition": [
      14647,
      "/",
      24214,
      "/",
      13089
    ]
  },
  {
    "id": "24041",
    "description": "bus_stop,bus_bay",
    "pos": "YELLOW",
    "explanation": "(platform + bus)  Preferred NEW SYNONYM, replacing 13090",
    "isCharacter": false,
    "composition": [
      24214,
      "/",
      13089
    ]
  },
  {
    "id": "24042",
    "description": "cable_car",
    "pos": "YELLOW",
    "explanation": "(enclosure + ascending_and_descending)",
    "isCharacter": false,
    "composition": [
      13934,
      "/",
      25401
    ]
  },
  {
    "id": "24043",
    "description": "cancer",
    "pos": "YELLOW",
    "explanation": "(illness + cell + repetition)",
    "isCharacter": false,
    "composition": [
      16164,
      "/",
      21540,
      "/",
      24934
    ]
  },
  {
    "id": "24044",
    "description": "canter-(to)",
    "pos": "RED",
    "explanation": "(trot_(horse)-(to) + intensity + action indicator)",
    "isCharacter": false,
    "composition": [
      14897,
      ";",
      8993,
      "/",
      14947,
      "/",
      14947
    ]
  },
  {
    "id": "24047",
    "description": "celibacy_(religious)",
    "pos": "YELLOW",
    "explanation": "(chastity + religion)",
    "isCharacter": false,
    "composition": [
      13649,
      "/",
      15474,
      "/",
      13380,
      "/",
      14431,
      "/",
      20563
    ]
  },
  {
    "id": "24048",
    "description": "ceramics,pottery",
    "pos": "YELLOW",
    "explanation": "(craft + clay)",
    "isCharacter": false,
    "composition": [
      23583,
      "/",
      "RK:-2",
      "/",
      14667,
      "/",
      15672
    ]
  },
  {
    "id": "24049",
    "description": "certain,sure",
    "pos": "GREEN",
    "explanation": "(without + doubt + description indicator)  Preferred NEW SYNONYM, replacing 13146",
    "isCharacter": false,
    "composition": [
      15474,
      "/",
      22911,
      ";",
      8998
    ]
  },
  {
    "id": "24050",
    "description": "chairlift",
    "pos": "YELLOW",
    "explanation": "(seat,sitting + ascending_and_descending)",
    "isCharacter": false,
    "composition": [
      16165,
      "/",
      25401
    ]
  },
  {
    "id": "24051",
    "description": "chairman",
    "pos": "BLUE",
    "explanation": "(leader + meeting [modification, short arrows] (combination))  - Character (superimposed - modified - combined)",
    "isCharacter": true
  },
  {
    "id": "24052",
    "description": "challenge",
    "pos": "YELLOW",
    "explanation": "(opposition + cause + action)",
    "isCharacter": false,
    "composition": [
      15928,
      "/",
      13134,
      "/",
      "RK:-2",
      "/",
      12335
    ]
  },
  {
    "id": "24053",
    "description": "charm",
    "pos": "YELLOW",
    "explanation": "(personality + positive)",
    "isCharacter": false,
    "composition": [
      24210,
      "/",
      12374,
      "/",
      14947
    ]
  },
  {
    "id": "24054",
    "description": "charming",
    "pos": "GREEN",
    "explanation": "(charm + description indicator)",
    "isCharacter": false,
    "composition": [
      24210,
      ";",
      8998,
      "/",
      12374,
      "/",
      14947
    ]
  },
  {
    "id": "24055",
    "description": "checked",
    "pos": "GREEN",
    "explanation": "(many + grid + description indicator)",
    "isCharacter": false,
    "composition": [
      14647,
      "/",
      24904,
      ";",
      8998
    ]
  },
  {
    "id": "24056",
    "description": "chest_hair",
    "pos": "YELLOW",
    "explanation": "(hair + chest)",
    "isCharacter": false,
    "composition": [
      14660,
      "/",
      13161
    ]
  },
  {
    "id": "24057",
    "description": "child_care",
    "pos": "YELLOW",
    "explanation": "(care + child)  Child can be replaced by an appropriate specifier.",
    "isCharacter": false,
    "composition": [
      12335,
      "/",
      16420,
      "/",
      13166
    ]
  },
  {
    "id": "24058",
    "description": "child_harness,walking_reins",
    "pos": "YELLOW",
    "explanation": "(harness + child)",
    "isCharacter": false,
    "composition": [
      14647,
      "/",
      15214,
      ";",
      9009,
      "/",
      13380,
      "/",
      13166
    ]
  },
  {
    "id": "24059",
    "description": "Children's_Day",
    "pos": "YELLOW",
    "explanation": "(day + child)",
    "isCharacter": false,
    "composition": [
      13639,
      "/",
      13166
    ]
  },
  {
    "id": "24060",
    "description": "chirp,twitter-(to)",
    "pos": "RED",
    "explanation": "(to talk + bird + action indicator)",
    "isCharacter": false,
    "composition": [
      15666,
      ";",
      8993,
      "/",
      12837
    ]
  },
  {
    "id": "24061",
    "description": "circus",
    "pos": "YELLOW",
    "explanation": "(showplace + cloth: i.e. showplace + tent [contraction])",
    "isCharacter": false,
    "composition": [
      14905,
      "/",
      14133,
      "/",
      13365
    ]
  },
  {
    "id": "24062",
    "description": "clean",
    "pos": "GREEN",
    "explanation": "(without + spot + description indicator)  Preferred NEW SYNONYM, replacing 13356",
    "isCharacter": false,
    "composition": [
      15474,
      "/",
      14133,
      ";",
      8998,
      "/",
      13867
    ]
  },
  {
    "id": "24063",
    "description": "cloakroom,walk-in_closet",
    "pos": "YELLOW",
    "explanation": "(room + clothes)",
    "isCharacter": false,
    "composition": [
      16687,
      "/",
      13366
    ]
  },
  {
    "id": "24064",
    "description": "cloudberry",
    "pos": "YELLOW",
    "explanation": "(compound berry + marsh)",
    "isCharacter": false,
    "composition": [
      16463,
      "/",
      17472
    ]
  },
  {
    "id": "24065",
    "description": "cold,common_cold",
    "pos": "YELLOW",
    "explanation": "(illness + liquid + nose)",
    "isCharacter": false,
    "composition": [
      16164,
      "/",
      18209,
      "/",
      15732
    ]
  },
  {
    "id": "24066",
    "description": "common,mutual,shared",
    "pos": "GREEN",
    "explanation": "(to have + together + description indicator)",
    "isCharacter": false,
    "composition": [
      24912,
      ";",
      8998,
      "/",
      23409
    ]
  },
  {
    "id": "24067",
    "description": "commuter_train",
    "pos": "YELLOW",
    "explanation": "(train + back and forth)",
    "isCharacter": false,
    "composition": [
      14647,
      "/",
      18010,
      "/",
      12610
    ]
  },
  {
    "id": "24068",
    "description": "conductive_education",
    "pos": "YELLOW",
    "explanation": "(education + plus + therapy)",
    "isCharacter": false,
    "composition": [
      25555,
      "/",
      15162,
      "/",
      12374,
      "/",
      21589
    ]
  },
  {
    "id": "24069",
    "description": "conductor_(teacher,therapist)",
    "pos": "BLUE",
    "explanation": "(person + conductive education)",
    "isCharacter": false,
    "composition": [
      16161,
      "/",
      25555,
      "/",
      15162,
      "/",
      12374,
      "/",
      21589
    ]
  },
  {
    "id": "24070",
    "description": "constipation_(1)",
    "pos": "YELLOW",
    "explanation": "(bowel movement [contraction] + stop)  SYMBOL SYNONYM",
    "isCharacter": false,
    "composition": [
      13097,
      "/",
      13935
    ]
  },
  {
    "id": "24071",
    "description": "constipation_(2)",
    "pos": "YELLOW",
    "explanation": "(illness + bowel movement [contraction] + stop)  SYMBOL SYNONYM",
    "isCharacter": false,
    "composition": [
      16164,
      "/",
      13097,
      "/",
      13935
    ]
  },
  {
    "id": "24072",
    "description": "constitution",
    "pos": "YELLOW",
    "explanation": "(plan,design,method,system + country)",
    "isCharacter": false,
    "composition": [
      16194,
      "/",
      13423
    ]
  },
  {
    "id": "24073",
    "description": "croak_(frog)-(to)",
    "pos": "RED",
    "explanation": "(to talk + frog + action indicator)",
    "isCharacter": false,
    "composition": [
      15666,
      ";",
      8993,
      "/",
      12378,
      "/",
      25633,
      "/",
      23550
    ]
  },
  {
    "id": "24074",
    "description": "crown_prince",
    "pos": "BLUE",
    "explanation": "(prince + future)",
    "isCharacter": false,
    "composition": [
      12888,
      "/",
      22618,
      "/",
      14417
    ]
  },
  {
    "id": "24075",
    "description": "crown_princess",
    "pos": "BLUE",
    "explanation": "(princess + future)",
    "isCharacter": false,
    "composition": [
      14439,
      "/",
      22618,
      "/",
      14417
    ]
  },
  {
    "id": "24076",
    "description": "cuddle-(to)",
    "pos": "RED",
    "explanation": "(hug + feeling + action indicator)",
    "isCharacter": false,
    "composition": [
      12577,
      ";",
      8993,
      "/",
      12580,
      "/",
      14164
    ]
  },
  {
    "id": "24077",
    "description": "cure-(to)",
    "pos": "RED",
    "explanation": "(to destroy + illness + action indicator)",
    "isCharacter": false,
    "composition": [
      24883,
      ";",
      8993,
      "/",
      "RK:-2",
      "/",
      16164
    ]
  },
  {
    "id": "24078",
    "description": "dancing_therapy",
    "pos": "YELLOW",
    "explanation": "(therapy + dance)",
    "isCharacter": false,
    "composition": [
      21589,
      "/",
      15189,
      "/",
      15682
    ]
  },
  {
    "id": "24079",
    "description": "decoration,ornament",
    "pos": "YELLOW",
    "explanation": "(adding + beautiful + thing indicator)  Preferred NEW SYNONYM, replacing 13650",
    "isCharacter": false,
    "composition": [
      12339,
      ";",
      9009,
      "/",
      14133,
      "/",
      14164,
      "/",
      17983
    ]
  },
  {
    "id": "24080",
    "description": "democracy_(country)",
    "pos": "YELLOW",
    "explanation": "(country + to permit + choice)",
    "isCharacter": false,
    "composition": [
      13423,
      "/",
      24926,
      "/",
      13175
    ]
  },
  {
    "id": "24082",
    "description": "devoted",
    "pos": "GREEN",
    "explanation": "(devotion + description indicator)",
    "isCharacter": false,
    "composition": [
      14164,
      ";",
      8998,
      "/",
      24913
    ]
  },
  {
    "id": "24083",
    "description": "devotee,fan",
    "pos": "BLUE",
    "explanation": "(person + devotion)",
    "isCharacter": false,
    "composition": [
      16161,
      "/",
      14164,
      "/",
      24913
    ]
  },
  {
    "id": "24084",
    "description": "devotion",
    "pos": "YELLOW",
    "explanation": "(feeling + important)",
    "isCharacter": false,
    "composition": [
      14164,
      "/",
      24913
    ]
  },
  {
    "id": "24085",
    "description": "diarrhea,diarrhoea",
    "pos": "YELLOW",
    "explanation": "(illness + bowel movement + intensity)",
    "isCharacter": false,
    "composition": [
      16164,
      "/",
      18043,
      "/",
      13097,
      "/",
      14947
    ]
  },
  {
    "id": "24086",
    "description": "domestic",
    "pos": "GREEN",
    "explanation": "(in + country + description indicator)",
    "isCharacter": false,
    "composition": [
      14932,
      "/",
      13423,
      ";",
      8998
    ]
  },
  {
    "id": "24087",
    "description": "dotted",
    "pos": "GREEN",
    "explanation": "(many + dot + description indicator)",
    "isCharacter": false,
    "composition": [
      14647,
      "/",
      13867,
      ";",
      8998
    ]
  },
  {
    "id": "24088",
    "description": "drying_cupboard,airing_cupboard",
    "pos": "YELLOW",
    "explanation": "(cupboard + to dry + cloth)",
    "isCharacter": false,
    "composition": [
      13622,
      "/",
      23859,
      "/",
      13365
    ]
  },
  {
    "id": "24089",
    "description": "drying_room,drying_chamber",
    "pos": "YELLOW",
    "explanation": "(room + to dry + cloth)",
    "isCharacter": false,
    "composition": [
      16687,
      "/",
      23859,
      "/",
      13365
    ]
  },
  {
    "id": "24090",
    "description": "dump,dispose-(to)",
    "pos": "RED",
    "explanation": "(waste + action indicator)",
    "isCharacter": false,
    "composition": [
      18043,
      ";",
      8993
    ]
  },
  {
    "id": "24091",
    "description": "elbow_splint",
    "pos": "YELLOW",
    "explanation": "(aid + bones_with_joint + elbow + thing indicator: bones_with_joint representing joint [contraction], support for the elbow joint)",
    "isCharacter": false,
    "composition": [
      14704,
      ";",
      9009,
      "/",
      25528,
      "/",
      13916
    ]
  },
  {
    "id": "24092",
    "description": "voter,elector",
    "pos": "BLUE",
    "explanation": "(person + to choose: person who chooses or votes for a public official)",
    "isCharacter": false,
    "composition": [
      16161,
      "/",
      13175
    ]
  },
  {
    "id": "24093",
    "description": "electorate",
    "pos": "BLUE",
    "explanation": "(electorate + plural indicator)",
    "isCharacter": false,
    "composition": [
      14647,
      "/",
      16161,
      "/",
      13175
    ]
  },
  {
    "id": "24094",
    "description": "endangered",
    "pos": "GREEN",
    "explanation": "(danger + delete + description before the fact indicator)",
    "isCharacter": false,
    "composition": [
      13632,
      ";",
      8997,
      "/",
      24883
    ]
  },
  {
    "id": "24095",
    "description": "Epiphany",
    "pos": "YELLOW",
    "explanation": "(event + to observe + Christ)",
    "isCharacter": false,
    "composition": [
      14114,
      "/",
      24846,
      "/",
      15416,
      "/",
      13613
    ]
  },
  {
    "id": "24096",
    "description": "escalator,moving_stairs",
    "pos": "YELLOW",
    "explanation": "(stairs + up and down)",
    "isCharacter": false,
    "composition": [
      17247,
      "/",
      20524
    ]
  },
  {
    "id": "24097",
    "description": "Estonia",
    "pos": "YELLOW",
    "explanation": "(country + song: in E. singing, e g in choirs, is very important)",
    "isCharacter": false,
    "composition": [
      13423,
      "/",
      15666,
      "/",
      15682
    ]
  },
  {
    "id": "24098",
    "description": "existence,being_(1)",
    "pos": "YELLOW",
    "explanation": "(life + world) - Character (superimposed)  SYMBOL SYNONYM",
    "isCharacter": true
  },
  {
    "id": "24099",
    "description": "experiment-(to)",
    "pos": "RED",
    "explanation": "(experiment + action indicator)",
    "isCharacter": false,
    "composition": [
      12335,
      ";",
      8993,
      "/",
      16437,
      "/",
      12393
    ]
  },
  {
    "id": "24100",
    "description": "exploded",
    "pos": "GREEN",
    "explanation": "(explosion + description after the fact indicator)",
    "isCharacter": false,
    "composition": [
      14132,
      ";",
      8996
    ]
  },
  {
    "id": "24101",
    "description": "explosive",
    "pos": "GREEN",
    "explanation": "(explosion + description before the fact indicator)",
    "isCharacter": false,
    "composition": [
      14132,
      ";",
      8997
    ]
  },
  {
    "id": "24102",
    "description": "facial_hair",
    "pos": "YELLOW",
    "explanation": "(hair + face)",
    "isCharacter": false,
    "composition": [
      14660,
      "/",
      14138
    ]
  },
  {
    "id": "24103",
    "description": "Family_Day",
    "pos": "YELLOW",
    "explanation": "(day + family)",
    "isCharacter": false,
    "composition": [
      13639,
      "/",
      20572
    ]
  },
  {
    "id": "24104",
    "description": "fan_(machine)",
    "pos": "YELLOW",
    "explanation": "(machine + wind)",
    "isCharacter": false,
    "composition": [
      15406,
      "/",
      18255
    ]
  },
  {
    "id": "24105",
    "description": "fanatic",
    "pos": "GREEN",
    "explanation": "(devotion + intensity + description indicator)",
    "isCharacter": false,
    "composition": [
      14164,
      ";",
      8998,
      "/",
      24913,
      "/",
      14947
    ]
  },
  {
    "id": "24106",
    "description": "fanatic_(person)",
    "pos": "BLUE",
    "explanation": "(devotee + intensity)",
    "isCharacter": false,
    "composition": [
      16161,
      "/",
      14164,
      "/",
      24913,
      "/",
      14947
    ]
  },
  {
    "id": "24107",
    "description": "farrier",
    "pos": "BLUE",
    "explanation": "(person + hoof)",
    "isCharacter": false,
    "composition": [
      16161,
      "/",
      24155
    ]
  },
  {
    "id": "24108",
    "description": "Father's_Day",
    "pos": "YELLOW",
    "explanation": "(day + father)",
    "isCharacter": false,
    "composition": [
      13639,
      "/",
      14157
    ]
  },
  {
    "id": "24109",
    "description": "fee",
    "pos": "YELLOW",
    "explanation": "(money + for + activity)",
    "isCharacter": false,
    "composition": [
      15484,
      "/",
      14381,
      "/",
      12335
    ]
  },
  {
    "id": "24110",
    "description": "fertilized",
    "pos": "GREEN",
    "explanation": "(conception + description after the fact indicator)",
    "isCharacter": false,
    "composition": [
      13395,
      ";",
      8996
    ]
  },
  {
    "id": "24111",
    "description": "few,little",
    "pos": "GREEN",
    "explanation": "(number + small + description indicator)  Preferred NEW SYNONYM, replacing 14171",
    "isCharacter": false,
    "composition": [
      15742,
      ";",
      8998,
      "/",
      24917
    ]
  },
  {
    "id": "24112",
    "description": "fever,temperature",
    "pos": "YELLOW",
    "explanation": "(body temperature + high)",
    "isCharacter": false,
    "composition": [
      17520,
      "/",
      12870,
      "/",
      24909
    ]
  },
  {
    "id": "24113",
    "description": "financial_support",
    "pos": "YELLOW",
    "explanation": "(help + with + money)",
    "isCharacter": false,
    "composition": [
      14704,
      "/",
      18267,
      "/",
      15484
    ]
  },
  {
    "id": "24114",
    "description": "fingernail,nail",
    "pos": "YELLOW",
    "explanation": "(protection + finger)",
    "isCharacter": false,
    "composition": [
      16420,
      "/",
      14180
    ]
  },
  {
    "id": "24115",
    "description": "fish_(dried)",
    "pos": "YELLOW",
    "explanation": "(fish + dry)",
    "isCharacter": false,
    "composition": [
      14377,
      "/",
      14188,
      "/",
      23859
    ]
  },
  {
    "id": "24116",
    "description": "flower_(dried)",
    "pos": "YELLOW",
    "explanation": "(flower + dry)",
    "isCharacter": false,
    "composition": [
      14205,
      "/",
      23859
    ]
  },
  {
    "id": "24117",
    "description": "flu,influenza",
    "pos": "YELLOW",
    "explanation": "(illness + body + intensity: your entire body is aching)",
    "isCharacter": false,
    "composition": [
      16164,
      "/",
      12870,
      "/",
      14947
    ]
  },
  {
    "id": "24118",
    "description": "foreign",
    "pos": "GREEN",
    "explanation": "(out + country + description indicator)",
    "isCharacter": false,
    "composition": [
      15942,
      "/",
      13423,
      ";",
      8998
    ]
  },
  {
    "id": "24119",
    "description": "fort,fortress",
    "pos": "YELLOW",
    "explanation": "(castle + war)",
    "isCharacter": false,
    "composition": [
      23437,
      "/",
      18036
    ]
  },
  {
    "id": "24120",
    "description": "foundation,base,fundament",
    "pos": "YELLOW",
    "explanation": "(pictograph)  - Character",
    "isCharacter": true
  },
  {
    "id": "24121",
    "description": "fruit_(dried)",
    "pos": "YELLOW",
    "explanation": "(fruit + dry)",
    "isCharacter": false,
    "composition": [
      14405,
      "/",
      23859
    ]
  },
  {
    "id": "24122",
    "description": "fundamental,basic",
    "pos": "GREEN",
    "explanation": "(foundation + description indicator)",
    "isCharacter": false,
    "composition": [
      24120,
      ";",
      8998
    ]
  },
  {
    "id": "24123",
    "description": "fundamental_law",
    "pos": "YELLOW",
    "explanation": "(law + fundamental)",
    "isCharacter": false,
    "composition": [
      23127,
      "/",
      15962,
      "/",
      24120
    ]
  },
  {
    "id": "24124",
    "description": "fundamental_rule",
    "pos": "YELLOW",
    "explanation": "(rule + fundamental)",
    "isCharacter": false,
    "composition": [
      15962,
      "/",
      22913,
      "/",
      24120
    ]
  },
  {
    "id": "24125",
    "description": "fundamentalism",
    "pos": "YELLOW",
    "explanation": "(belief + fundamental)",
    "isCharacter": false,
    "composition": [
      14164,
      "/",
      "RK:-2",
      "/",
      25574,
      "/",
      24120
    ]
  },
  {
    "id": "24126",
    "description": "fundamentalism_(religious)",
    "pos": "YELLOW",
    "explanation": "(religion + fundamental)",
    "isCharacter": false,
    "composition": [
      20561,
      "/",
      24120
    ]
  },
  {
    "id": "24127",
    "description": "fundamentalist",
    "pos": "BLUE",
    "explanation": "(person + fundamentalism)",
    "isCharacter": false,
    "composition": [
      16161,
      "/",
      14164,
      "/",
      "RK:-2",
      "/",
      25574,
      "/",
      24120
    ]
  },
  {
    "id": "24128",
    "description": "fundamentalist_(religious)",
    "pos": "BLUE",
    "explanation": "(person + fundamentalism_(religious))",
    "isCharacter": false,
    "composition": [
      16161,
      "/",
      20561,
      "/",
      24120
    ]
  },
  {
    "id": "24129",
    "description": "gallop-(to)",
    "pos": "RED",
    "explanation": "(gallop + action indicator)",
    "isCharacter": false,
    "composition": [
      14897,
      ";",
      8993,
      "/",
      14947,
      "/",
      14947,
      "/",
      14947
    ]
  },
  {
    "id": "24130",
    "description": "gelding",
    "pos": "YELLOW",
    "explanation": "(stallion + sterilized)",
    "isCharacter": false,
    "composition": [
      14897,
      "/",
      12335,
      "/",
      15474,
      "/",
      13395
    ]
  },
  {
    "id": "24131",
    "description": "general",
    "pos": "GREEN",
    "explanation": "(generalization + description indicator)",
    "isCharacter": false,
    "composition": [
      14430,
      ";",
      8998
    ]
  },
  {
    "id": "24132",
    "description": "girth,cinch",
    "pos": "YELLOW",
    "explanation": "(linear thing + waist + horse + thing indicator)",
    "isCharacter": false,
    "composition": [
      15214,
      ";",
      9009,
      "/",
      18029,
      "/",
      14897
    ]
  },
  {
    "id": "24133",
    "description": "glacier",
    "pos": "YELLOW",
    "explanation": "(ice + river: ice that moves in response to gravity)",
    "isCharacter": false,
    "composition": [
      14919,
      "/",
      16677
    ]
  },
  {
    "id": "24134",
    "description": "glass_craft",
    "pos": "YELLOW",
    "explanation": "(craft + glass [contraction])",
    "isCharacter": false,
    "composition": [
      23583,
      "/",
      "RK:-2",
      "/",
      14667,
      "/",
      14442
    ]
  },
  {
    "id": "24135",
    "description": "glow",
    "pos": "YELLOW",
    "explanation": "(light + fire + end)",
    "isCharacter": false,
    "composition": [
      15208,
      "/",
      14183,
      "/",
      13935
    ]
  },
  {
    "id": "24136",
    "description": "glow-(to)",
    "pos": "RED",
    "explanation": "(glow + action indicator)",
    "isCharacter": false,
    "composition": [
      15208,
      ";",
      8993,
      "/",
      14183,
      "/",
      13935
    ]
  },
  {
    "id": "24137",
    "description": "groom_(horse)",
    "pos": "BLUE",
    "explanation": "(person + to work + to protect + horse)",
    "isCharacter": false,
    "composition": [
      16161,
      "/",
      18273,
      "/",
      16420,
      "/",
      14897
    ]
  },
  {
    "id": "24138",
    "description": "groom_(horse)-(to)",
    "pos": "RED",
    "explanation": "(horse brush + action indicator)",
    "isCharacter": false,
    "composition": [
      12912,
      ";",
      8993,
      "/",
      14897
    ]
  },
  {
    "id": "24139",
    "description": "growl_(dog)-(to)",
    "pos": "RED",
    "explanation": "(to talk + opposition + dog + action indicator)",
    "isCharacter": false,
    "composition": [
      15666,
      ";",
      8993,
      "/",
      15928,
      "/",
      12380
    ]
  },
  {
    "id": "24140",
    "description": "grunt_(pig)-(to)",
    "pos": "RED",
    "explanation": "(to talk + pig + action indicator)",
    "isCharacter": false,
    "composition": [
      15666,
      ";",
      8993,
      "/",
      16175
    ]
  },
  {
    "id": "24141",
    "description": "hair_drier,blow_dryer",
    "pos": "YELLOW",
    "explanation": "(tool + to dry + hair)",
    "isCharacter": false,
    "composition": [
      17755,
      "/",
      23859,
      "/",
      14660
    ]
  },
  {
    "id": "24142",
    "description": "hand_splint",
    "pos": "YELLOW",
    "explanation": "(aid + joint [contr ] + hand + thing indicator)",
    "isCharacter": false,
    "composition": [
      14704,
      ";",
      9009,
      "/",
      25528,
      "/",
      14667
    ]
  },
  {
    "id": "24143",
    "description": "harness",
    "pos": "YELLOW",
    "explanation": "(group of + linear thing + combination + thing indicator)",
    "isCharacter": false,
    "composition": [
      14647,
      "/",
      15214,
      ";",
      9009,
      "/",
      13380
    ]
  },
  {
    "id": "24144",
    "description": "harness-(to)",
    "pos": "RED",
    "explanation": "(harness + action indicator + thing indicator)",
    "isCharacter": false,
    "composition": [
      14647,
      "/",
      15214,
      ";",
      8993,
      "/",
      13380
    ]
  },
  {
    "id": "24145",
    "description": "harness_(horse)",
    "pos": "YELLOW",
    "explanation": "(harness + horse + thing indicator)",
    "isCharacter": false,
    "composition": [
      14647,
      "/",
      15214,
      ";",
      9009,
      "/",
      13380,
      "/",
      14897
    ]
  },
  {
    "id": "24146",
    "description": "harness_(horse)-(to)",
    "pos": "RED",
    "explanation": "(harness + horse + action indicator + thing indicator)",
    "isCharacter": false,
    "composition": [
      14647,
      "/",
      15214,
      ";",
      8993,
      "/",
      13380,
      "/",
      14897
    ]
  },
  {
    "id": "24147",
    "description": "hay",
    "pos": "YELLOW",
    "explanation": "(grass + dry)",
    "isCharacter": false,
    "composition": [
      14636,
      "/",
      23859
    ]
  },
  {
    "id": "24148",
    "description": "heal-(to)",
    "pos": "RED",
    "explanation": "(to become + healthy + action indicator)",
    "isCharacter": false,
    "composition": [
      14390,
      ";",
      8993,
      "/",
      24443,
      "/",
      14690
    ]
  },
  {
    "id": "24149",
    "description": "Heaven,Kingdom_of_God",
    "pos": "YELLOW",
    "explanation": "(world + God)",
    "isCharacter": false,
    "composition": [
      18278,
      "/",
      14451
    ]
  },
  {
    "id": "24150",
    "description": "hibernation",
    "pos": "YELLOW",
    "explanation": "(sleep + winter)",
    "isCharacter": false,
    "composition": [
      17008,
      "/",
      17462,
      "/",
      8500,
      "/",
      17192
    ]
  },
  {
    "id": "24151",
    "description": "hiss_(cat)-(to)",
    "pos": "RED",
    "explanation": "(to talk + opposition + cat + action indicator)",
    "isCharacter": false,
    "composition": [
      15666,
      ";",
      8993,
      "/",
      15928,
      "/",
      12383
    ]
  },
  {
    "id": "24152",
    "description": "hitch,tie_up,fix_up-(to)",
    "pos": "RED",
    "explanation": "(to fasten + animal + action indicator)",
    "isCharacter": false,
    "composition": [
      23409,
      ";",
      8993,
      "/",
      12378
    ]
  },
  {
    "id": "24153",
    "description": "homosexual",
    "pos": "GREEN",
    "explanation": "(homosexuality + description indicator)",
    "isCharacter": false,
    "composition": [
      14164,
      ";",
      8998,
      "/",
      "RK:-2",
      "/",
      25541,
      "/",
      25540
    ]
  },
  {
    "id": "24154",
    "description": "homosexuality",
    "pos": "YELLOW",
    "explanation": "(feeling + couple_(male) + couple_(female): combination of male and female homosexuality, representing homosexuality in general, either male or female)",
    "isCharacter": false,
    "composition": [
      14164,
      "/",
      "RK:-2",
      "/",
      25541,
      "/",
      25540
    ]
  },
  {
    "id": "24155",
    "description": "hoof",
    "pos": "YELLOW",
    "explanation": "(horse + pointer, to hoof)  - Character (superimposed - pointer)",
    "isCharacter": true
  },
  {
    "id": "24156",
    "description": "hoof_pick",
    "pos": "YELLOW",
    "explanation": "(tool + hoof)",
    "isCharacter": false,
    "composition": [
      17755,
      "/",
      24155
    ]
  },
  {
    "id": "24157",
    "description": "horse_box,stall",
    "pos": "YELLOW",
    "explanation": "(room + horse)",
    "isCharacter": false,
    "composition": [
      16687,
      "/",
      14897
    ]
  },
  {
    "id": "24158",
    "description": "horse_brush,body_brush",
    "pos": "YELLOW",
    "explanation": "(brush + horse)",
    "isCharacter": false,
    "composition": [
      12912,
      "/",
      14897
    ]
  },
  {
    "id": "24159",
    "description": "horse_cloth",
    "pos": "YELLOW",
    "explanation": "(cloth + protection + horse)",
    "isCharacter": false,
    "composition": [
      13365,
      "/",
      16420,
      "/",
      14897
    ]
  },
  {
    "id": "24160",
    "description": "horse_droppings",
    "pos": "YELLOW",
    "explanation": "(waste + horse)",
    "isCharacter": false,
    "composition": [
      18043,
      "/",
      14897
    ]
  },
  {
    "id": "24161",
    "description": "horse_trailer,horsebox",
    "pos": "YELLOW",
    "explanation": "(trailer,container_transport + horse)",
    "isCharacter": false,
    "composition": [
      25624,
      "/",
      14897
    ]
  },
  {
    "id": "24162",
    "description": "horsehair",
    "pos": "YELLOW",
    "explanation": "(material + hair + horse)",
    "isCharacter": false,
    "composition": [
      15431,
      "/",
      14660,
      "/",
      14897
    ]
  },
  {
    "id": "24163",
    "description": "horseshoe",
    "pos": "YELLOW",
    "explanation": "(protection + hoof)",
    "isCharacter": false,
    "composition": [
      16420,
      "/",
      24155
    ]
  },
  {
    "id": "24164",
    "description": "horseshoe_nail",
    "pos": "YELLOW",
    "explanation": "(pin + horseshoe)",
    "isCharacter": false,
    "composition": [
      16181,
      "/",
      16420,
      "/",
      24155
    ]
  },
  {
    "id": "24165",
    "description": "Hungary",
    "pos": "YELLOW",
    "explanation": "(a country that is a bridge between East and West)",
    "isCharacter": false,
    "composition": [
      13423,
      "/",
      12902,
      "/",
      13902,
      "/",
      18224
    ]
  },
  {
    "id": "24166",
    "description": "hurry,rush",
    "pos": "YELLOW",
    "explanation": "(time + fast)",
    "isCharacter": false,
    "composition": [
      17732,
      "/",
      14390,
      "/",
      14947
    ]
  },
  {
    "id": "24167",
    "description": "hurry,rush-(to)",
    "pos": "RED",
    "explanation": "(hurry + action indicator)",
    "isCharacter": false,
    "composition": [
      17732,
      ";",
      8993,
      "/",
      14390,
      "/",
      14947
    ]
  },
  {
    "id": "24168",
    "description": "hurry_(in_a),hurried,rushed",
    "pos": "GREEN",
    "explanation": "(hurry + description indicator)",
    "isCharacter": false,
    "composition": [
      17732,
      ";",
      8998,
      "/",
      14390,
      "/",
      14947
    ]
  },
  {
    "id": "24169",
    "description": "hydrotherapy",
    "pos": "YELLOW",
    "explanation": "(therapy + activity + water)",
    "isCharacter": false,
    "composition": [
      21589,
      "/",
      12335,
      "/",
      18209
    ]
  },
  {
    "id": "24170",
    "description": "ice_field",
    "pos": "YELLOW",
    "explanation": "(much + ice)",
    "isCharacter": false,
    "composition": [
      14647,
      "/",
      14919
    ]
  },
  {
    "id": "24171",
    "description": "iceberg",
    "pos": "YELLOW",
    "explanation": "(mountain + ice)",
    "isCharacter": false,
    "composition": [
      14919,
      "/",
      15663
    ]
  },
  {
    "id": "24172",
    "description": "independent",
    "pos": "GREEN",
    "explanation": "(ability + self + description indicator)",
    "isCharacter": false,
    "composition": [
      12322,
      ";",
      8998,
      "/",
      8497,
      "/",
      15214
    ]
  },
  {
    "id": "24173",
    "description": "invisible",
    "pos": "GREEN",
    "explanation": "(without + to see + description indicator)",
    "isCharacter": false,
    "composition": [
      15474,
      "/",
      14133,
      ";",
      8998
    ]
  },
  {
    "id": "24175",
    "description": "jaguar",
    "pos": "YELLOW",
    "explanation": "(animal + group of + spot: fur with small dots within larger rosette markings)",
    "isCharacter": false,
    "composition": [
      12383,
      "/",
      14647,
      "/",
      14133,
      "/",
      13867
    ]
  },
  {
    "id": "24176",
    "description": "kidney",
    "pos": "YELLOW",
    "explanation": "(pictograph)  - Character",
    "isCharacter": true
  },
  {
    "id": "24177",
    "description": "knot",
    "pos": "YELLOW",
    "explanation": "(combination + string + thing indicator)",
    "isCharacter": false,
    "composition": [
      13380,
      "/",
      15214,
      ";",
      9009,
      "/",
      23409
    ]
  },
  {
    "id": "24178",
    "description": "Lent",
    "pos": "YELLOW",
    "explanation": "(limited time + before + Easter)",
    "isCharacter": false,
    "composition": [
      15212,
      "/",
      12656,
      "/",
      13639,
      "/",
      17983,
      "/",
      13613
    ]
  },
  {
    "id": "24179",
    "description": "liberation",
    "pos": "YELLOW",
    "explanation": "(cause + freedom)",
    "isCharacter": false,
    "composition": [
      13134,
      "/",
      14396
    ]
  },
  {
    "id": "24180",
    "description": "linear_thing_(horizontal),bar",
    "pos": "YELLOW",
    "explanation": "(horizontal line + thing indicator)  - (character with thing indicator)",
    "isCharacter": "false",
    "composition": [
      17449,
      ";",
      9009
    ]
  },
  {
    "id": "24181",
    "description": "long_time",
    "pos": "GREEN",
    "explanation": "(limited time + long + description indicator)",
    "isCharacter": false,
    "composition": [
      15212,
      ";",
      8998,
      "/",
      15193
    ]
  },
  {
    "id": "24182",
    "description": "lower_body",
    "pos": "YELLOW",
    "explanation": "(below + waist)",
    "isCharacter": false,
    "composition": [
      17969,
      "/",
      18029
    ]
  },
  {
    "id": "24183",
    "description": "make_sign_of_the_cross-(to)",
    "pos": "RED",
    "explanation": "(sign_of_the_cross + action indicator)",
    "isCharacter": false,
    "composition": [
      14667,
      ";",
      8993,
      "/",
      13613
    ]
  },
  {
    "id": "24184",
    "description": "mane_(horse)",
    "pos": "YELLOW",
    "explanation": "(hair + horse_neck)",
    "isCharacter": false,
    "composition": [
      14660,
      "/",
      25571
    ]
  },
  {
    "id": "24185",
    "description": "manure,fertilizer",
    "pos": "YELLOW",
    "explanation": "(addition + to grow + thing indicator)",
    "isCharacter": false,
    "composition": [
      12339,
      ";",
      9009,
      "/",
      13134,
      "/",
      14205,
      "/",
      17983
    ]
  },
  {
    "id": "24186",
    "description": "mare",
    "pos": "YELLOW",
    "explanation": "(horse + female)",
    "isCharacter": false,
    "composition": [
      14897,
      "/",
      14166
    ]
  },
  {
    "id": "24187",
    "description": "meat_(dried),dried_meat",
    "pos": "YELLOW",
    "explanation": "(meat + dry)",
    "isCharacter": false,
    "composition": [
      14377,
      "/",
      12378,
      "/",
      23859
    ]
  },
  {
    "id": "24188",
    "description": "medical_treatment,medical_care",
    "pos": "YELLOW",
    "explanation": "(help + medical)",
    "isCharacter": false,
    "composition": [
      14704,
      "/",
      24920
    ]
  },
  {
    "id": "24189",
    "description": "menstrual_blood",
    "pos": "YELLOW",
    "explanation": "(blood + uterus [contraction])",
    "isCharacter": false,
    "composition": [
      18209,
      "/",
      15206,
      "/",
      17994
    ]
  },
  {
    "id": "24190",
    "description": "metal_craft",
    "pos": "YELLOW",
    "explanation": "(craft + metal [contraction])",
    "isCharacter": false,
    "composition": [
      23583,
      "/",
      "RK:-2",
      "/",
      14667,
      "/",
      23150
    ]
  },
  {
    "id": "24191",
    "description": "mew,meow-(to)",
    "pos": "RED",
    "explanation": "(to talk + cat + action indicator)",
    "isCharacter": false,
    "composition": [
      15666,
      ";",
      8993,
      "/",
      12383
    ]
  },
  {
    "id": "24192",
    "description": "minister_(government)",
    "pos": "BLUE",
    "explanation": "(leader + country)",
    "isCharacter": false,
    "composition": [
      21054,
      "/",
      13423
    ]
  },
  {
    "id": "24193",
    "description": "monarchy",
    "pos": "YELLOW",
    "explanation": "(country + royal)",
    "isCharacter": false,
    "composition": [
      13423,
      "/",
      22618
    ]
  },
  {
    "id": "24194",
    "description": "moo,bellow-(to)",
    "pos": "RED",
    "explanation": "(to talk + cow + action indicator)",
    "isCharacter": false,
    "composition": [
      15666,
      ";",
      8993,
      "/",
      12379,
      "/",
      14166
    ]
  },
  {
    "id": "24195",
    "description": "Mother's_Day",
    "pos": "YELLOW",
    "explanation": "(day + mother)",
    "isCharacter": false,
    "composition": [
      13639,
      "/",
      15662
    ]
  },
  {
    "id": "24196",
    "description": "muzzle",
    "pos": "YELLOW",
    "explanation": "(horse + pointer, to muzzle)  - Character (superimposed - pointer)",
    "isCharacter": true
  },
  {
    "id": "24197",
    "description": "nature_craft",
    "pos": "YELLOW",
    "explanation": "(craft + plant)",
    "isCharacter": false,
    "composition": [
      23583,
      "/",
      "RK:-2",
      "/",
      14667,
      "/",
      16196
    ]
  },
  {
    "id": "24198",
    "description": "navel",
    "pos": "YELLOW",
    "explanation": "(body_with_navel + pointer, to navel)  - Character (superimposed - pointer)",
    "isCharacter": true
  },
  {
    "id": "24199",
    "description": "neigh,whinny-(to)",
    "pos": "RED",
    "explanation": "(to talk + horse + action indicator)",
    "isCharacter": false,
    "composition": [
      15666,
      ";",
      8993,
      "/",
      14897
    ]
  },
  {
    "id": "24200",
    "description": "occupational_therapy",
    "pos": "YELLOW",
    "explanation": "(therapy + activity)",
    "isCharacter": false,
    "composition": [
      21589,
      "/",
      12335
    ]
  },
  {
    "id": "24201",
    "description": "occupational_therapy_room",
    "pos": "YELLOW",
    "explanation": "(room + occupational therapy)",
    "isCharacter": false,
    "composition": [
      16687,
      "/",
      21589,
      "/",
      12335
    ]
  },
  {
    "id": "24202",
    "description": "organ_(body)_(OLD)",
    "pos": "YELLOW",
    "explanation": "(generalization + kidney)  SUPERSEDED SYNONYM  See organ,inner_organ,inner_body_part 25480",
    "isCharacter": false,
    "composition": [
      14430,
      "/",
      24176
    ]
  },
  {
    "id": "24203",
    "description": "paddock",
    "pos": "YELLOW",
    "explanation": "(enclosure + field + small)",
    "isCharacter": false,
    "composition": [
      13934,
      "/",
      15180,
      "/",
      24917
    ]
  },
  {
    "id": "24204",
    "description": "paper_craft",
    "pos": "YELLOW",
    "explanation": "(craft + paper)",
    "isCharacter": false,
    "composition": [
      23583,
      "/",
      "RK:-2",
      "/",
      14667,
      "/",
      15962
    ]
  },
  {
    "id": "24205",
    "description": "parachute_harness",
    "pos": "YELLOW",
    "explanation": "(harness + parachute + thing indicator)",
    "isCharacter": false,
    "composition": [
      14647,
      "/",
      15214,
      ";",
      9009,
      "/",
      13380,
      "/",
      22105
    ]
  },
  {
    "id": "24206",
    "description": "parking_lot",
    "pos": "YELLOW",
    "explanation": "(place + vehicle)",
    "isCharacter": false,
    "composition": [
      16193,
      "/",
      18010
    ]
  },
  {
    "id": "24207",
    "description": "passport",
    "pos": "YELLOW",
    "explanation": "(book + permission,allowance + travel)",
    "isCharacter": false,
    "composition": [
      12875,
      "/",
      24926,
      "/",
      17779
    ]
  },
  {
    "id": "24208",
    "description": "pasture,enclosed_field",
    "pos": "YELLOW",
    "explanation": "(enclosure + field)",
    "isCharacter": false,
    "composition": [
      13934,
      "/",
      15180
    ]
  },
  {
    "id": "24209",
    "description": "pavement,sidewalk",
    "pos": "YELLOW",
    "explanation": "(platform + to walk)",
    "isCharacter": false,
    "composition": [
      24214,
      "/",
      15189
    ]
  },
  {
    "id": "24210",
    "description": "personality",
    "pos": "YELLOW",
    "explanation": "(pointer (left) + person + pointer (right): suggesting the charisma radiating from a person)  - Character (superimposed - pointer)",
    "isCharacter": true
  },
  {
    "id": "24211",
    "description": "physiotherapy",
    "pos": "YELLOW",
    "explanation": "(therapy + muscle)",
    "isCharacter": false,
    "composition": [
      21589,
      "/",
      20517
    ]
  },
  {
    "id": "24212",
    "description": "physiotherapy_room",
    "pos": "YELLOW",
    "explanation": "(room + physiotherapy)",
    "isCharacter": false,
    "composition": [
      16687,
      "/",
      21589,
      "/",
      20517
    ]
  },
  {
    "id": "24213",
    "description": "placenta_(OLD)",
    "pos": "YELLOW",
    "explanation": "(organ_(body)_(OLD) + food + fetus)  SUPERSEDED SYNONYM  See placenta 26021",
    "isCharacter": false,
    "composition": [
      14430,
      "/",
      24176,
      "/",
      14377,
      "/",
      14170
    ]
  },
  {
    "id": "24214",
    "description": "platform,stage",
    "pos": "YELLOW",
    "explanation": "(pictograph)  - Character",
    "isCharacter": true
  },
  {
    "id": "24215",
    "description": "politician",
    "pos": "BLUE",
    "explanation": "(person + politics)",
    "isCharacter": false,
    "composition": [
      16161,
      "/",
      24216
    ]
  },
  {
    "id": "24216",
    "description": "politics",
    "pos": "YELLOW",
    "explanation": "(leadership + say,speak,talk,tell,express-(to): combination of opinion and to lead)  - Character (superimposed - combined)",
    "isCharacter": true
  },
  {
    "id": "24217",
    "description": "pram_straps,safety_harness",
    "pos": "YELLOW",
    "explanation": "(harness + baby + thing indicator)",
    "isCharacter": false,
    "composition": [
      14647,
      "/",
      15214,
      ";",
      9009,
      "/",
      13380,
      "/",
      12603
    ]
  },
  {
    "id": "24218",
    "description": "preceding,previous,former,earlier",
    "pos": "GREEN",
    "explanation": "(first + in front of + description indicator)  Preferred NEW SYNONYM, replacing 16239",
    "isCharacter": false,
    "composition": [
      8497,
      ";",
      8998,
      "/",
      8486,
      "/",
      12656
    ]
  },
  {
    "id": "24219",
    "description": "prescription",
    "pos": "YELLOW",
    "explanation": "(paper + medicine)",
    "isCharacter": false,
    "composition": [
      15962,
      "/",
      13158,
      "/",
      24920
    ]
  },
  {
    "id": "24220",
    "description": "president",
    "pos": "BLUE",
    "explanation": "(chairman + country)",
    "isCharacter": false,
    "composition": [
      24051,
      "/",
      13423
    ]
  },
  {
    "id": "24221",
    "description": "prime_minister",
    "pos": "BLUE",
    "explanation": "(leader + country + first)",
    "isCharacter": false,
    "composition": [
      21054,
      "/",
      13423,
      "/",
      8497,
      "/",
      8486
    ]
  },
  {
    "id": "24222",
    "description": "program,programme",
    "pos": "YELLOW",
    "explanation": "(paper + plan + future: e.g. radio and tv)",
    "isCharacter": false,
    "composition": [
      15962,
      "/",
      16194,
      "/",
      14417
    ]
  },
  {
    "id": "24223",
    "description": "protected,saved",
    "pos": "GREEN",
    "explanation": "(protection + description after the fact indicator)",
    "isCharacter": false,
    "composition": [
      16420,
      ";",
      8996
    ]
  },
  {
    "id": "24224",
    "description": "protection_of_the_environment",
    "pos": "YELLOW",
    "explanation": "(protection + environment)",
    "isCharacter": false,
    "composition": [
      16420,
      "/",
      13942
    ]
  },
  {
    "id": "24225",
    "description": "prune",
    "pos": "YELLOW",
    "explanation": "(plum + dry)  Preferred NEW SYNONYM, replacing 16424",
    "isCharacter": false,
    "composition": [
      16208,
      "/",
      23859
    ]
  },
  {
    "id": "24226",
    "description": "psychology_room",
    "pos": "YELLOW",
    "explanation": "(room + psychology_(class))",
    "isCharacter": false,
    "composition": [
      16687,
      "/",
      15162,
      "/",
      15471,
      "/",
      14164
    ]
  },
  {
    "id": "24227",
    "description": "public_transport",
    "pos": "YELLOW",
    "explanation": "(generalization + bus)",
    "isCharacter": false,
    "composition": [
      14430,
      "/",
      13089
    ]
  },
  {
    "id": "24228",
    "description": "purr_(cat)-(to)",
    "pos": "RED",
    "explanation": "(to talk + feeling + cat + action indicator)",
    "isCharacter": false,
    "composition": [
      15666,
      ";",
      8993,
      "/",
      14164,
      "/",
      12383
    ]
  },
  {
    "id": "24230",
    "description": "rack,single-foot-(to)",
    "pos": "RED",
    "explanation": "(horse + Iceland + action indicator: a pace typical for Icelandic horses)",
    "isCharacter": false,
    "composition": [
      14897,
      ";",
      8993,
      "/",
      13423,
      "/",
      14919,
      "/",
      14183
    ]
  },
  {
    "id": "24231",
    "description": "raisin(s),currant(s)",
    "pos": "YELLOW",
    "explanation": "(grape,grapes + dry)  Preferred NEW SYNONYM, replacing 16460",
    "isCharacter": false,
    "composition": [
      14635,
      "/",
      23859
    ]
  },
  {
    "id": "24232",
    "description": "rash_(skin)",
    "pos": "YELLOW",
    "explanation": "(group of + dot + body: where body represents skin [contraction])",
    "isCharacter": false,
    "composition": [
      14647,
      "/",
      13867,
      "/",
      12870
    ]
  },
  {
    "id": "24233",
    "description": "reclaim_(marshes_etc)-(to)",
    "pos": "RED",
    "explanation": "(to dry + land + action indicator)",
    "isCharacter": false,
    "composition": [
      23859,
      ";",
      8993,
      "/",
      13901
    ]
  },
  {
    "id": "24234",
    "description": "religious_fanatic",
    "pos": "BLUE",
    "explanation": "(fanatic + religion)",
    "isCharacter": false,
    "composition": [
      16161,
      "/",
      14164,
      "/",
      24913,
      "/",
      14947,
      "/",
      20563
    ]
  },
  {
    "id": "24235",
    "description": "religious_fanatic_(God_based)",
    "pos": "BLUE",
    "explanation": "(fanatic + religion_(God_based))",
    "isCharacter": false,
    "composition": [
      16161,
      "/",
      14164,
      "/",
      24913,
      "/",
      14947,
      "/",
      20561
    ]
  },
  {
    "id": "24236",
    "description": "repair_room",
    "pos": "YELLOW",
    "explanation": "(room + to repair)",
    "isCharacter": false,
    "composition": [
      16687,
      "/",
      23583,
      "/",
      18273
    ]
  },
  {
    "id": "24237",
    "description": "repair_shop",
    "pos": "YELLOW",
    "explanation": "(house + to repair)",
    "isCharacter": false,
    "composition": [
      14905,
      "/",
      23583,
      "/",
      18273
    ]
  },
  {
    "id": "24238",
    "description": "republic",
    "pos": "YELLOW",
    "explanation": "(country + leader + choice)",
    "isCharacter": false,
    "composition": [
      13423,
      "/",
      21054,
      "/",
      13175
    ]
  },
  {
    "id": "24239",
    "description": "respirator",
    "pos": "YELLOW",
    "explanation": "(machine + breath)",
    "isCharacter": false,
    "composition": [
      15406,
      "/",
      15732,
      "/",
      15666
    ]
  },
  {
    "id": "24240",
    "description": "responsibility",
    "pos": "YELLOW",
    "explanation": "(conscience + other)  - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "24241",
    "description": "responsible",
    "pos": "GREEN",
    "explanation": "(responsibility + description indicator)",
    "isCharacter": false,
    "composition": [
      24240,
      ";",
      8998
    ]
  },
  {
    "id": "24242",
    "description": "Resurrection_of_Christ",
    "pos": "YELLOW",
    "explanation": "(resurrection + Christ)",
    "isCharacter": false,
    "composition": [
      17983,
      "/",
      13645,
      "/",
      15416,
      "/",
      13613
    ]
  },
  {
    "id": "24243",
    "description": "riding_boots",
    "pos": "YELLOW",
    "explanation": "(boots + horse: where horse represents riding [contraction])",
    "isCharacter": false,
    "composition": [
      16420,
      "/",
      25578,
      "/",
      14897
    ]
  },
  {
    "id": "24244",
    "description": "riding_clothes",
    "pos": "YELLOW",
    "explanation": "(clothes + horse: where horse represents riding [contraction])",
    "isCharacter": false,
    "composition": [
      13366,
      "/",
      14897
    ]
  },
  {
    "id": "24245",
    "description": "riding_instructor",
    "pos": "BLUE",
    "explanation": "(teacher [contraction] + horse: where horse represents riding [contraction])",
    "isCharacter": false,
    "composition": [
      16161,
      "/",
      15162,
      "/",
      14897
    ]
  },
  {
    "id": "24246",
    "description": "riding_school,manege",
    "pos": "YELLOW",
    "explanation": "(place + knowledge + horse: a place for training)",
    "isCharacter": false,
    "composition": [
      16193,
      "/",
      15162,
      "/",
      14897
    ]
  },
  {
    "id": "24247",
    "description": "road_(2)",
    "pos": "YELLOW",
    "explanation": "(place + activity + vehicle)  SYMBOL SYNONYM",
    "isCharacter": false,
    "composition": [
      16193,
      "/",
      12335,
      "/",
      18010
    ]
  },
  {
    "id": "24248",
    "description": "roar_(lion)-(to)",
    "pos": "RED",
    "explanation": "(to talk + lion + action indicator)",
    "isCharacter": false,
    "composition": [
      15666,
      ";",
      8993,
      "/",
      12383,
      "/",
      25580
    ]
  },
  {
    "id": "24249",
    "description": "rotation,circulation,orbit,lap,circle,round",
    "pos": "YELLOW",
    "explanation": "(curved arrow suggesting circular motion)  - Character",
    "isCharacter": true
  },
  {
    "id": "24250",
    "description": "royal",
    "pos": "GREEN",
    "explanation": "(crown + description indicator)",
    "isCharacter": false,
    "composition": [
      22618,
      ";",
      8998
    ]
  },
  {
    "id": "24251",
    "description": "royal_family",
    "pos": "YELLOW",
    "explanation": "(family + royal)",
    "isCharacter": false,
    "composition": [
      20572,
      "/",
      22618
    ]
  },
  {
    "id": "24252",
    "description": "saddle_pad,saddle_blanket",
    "pos": "YELLOW",
    "explanation": "(cloth + saddle)",
    "isCharacter": false,
    "composition": [
      13365,
      "/",
      16165,
      "/",
      14897
    ]
  },
  {
    "id": "24253",
    "description": "salvation_(religious)",
    "pos": "YELLOW",
    "explanation": "(liberation + religious)",
    "isCharacter": false,
    "composition": [
      13134,
      "/",
      14396,
      "/",
      20563
    ]
  },
  {
    "id": "24254",
    "description": "scabies",
    "pos": "YELLOW",
    "explanation": "(insect + skin + plural indicator)",
    "isCharacter": false,
    "composition": [
      14943,
      ";",
      9011,
      "/",
      16420,
      "/",
      12870
    ]
  },
  {
    "id": "24255",
    "description": "seat_belt",
    "pos": "YELLOW",
    "explanation": "(harness + vehicle + thing indicator)",
    "isCharacter": false,
    "composition": [
      14647,
      "/",
      15214,
      ";",
      9009,
      "/",
      13380,
      "/",
      18010
    ]
  },
  {
    "id": "24256",
    "description": "service_(help)",
    "pos": "YELLOW",
    "explanation": "(activity + to give + help)",
    "isCharacter": false,
    "composition": [
      12335,
      "/",
      24903,
      "/",
      14704
    ]
  },
  {
    "id": "24257",
    "description": "sexual_activity",
    "pos": "YELLOW",
    "explanation": "(activity + sexual)",
    "isCharacter": false,
    "composition": [
      12335,
      "/",
      14428
    ]
  },
  {
    "id": "24258",
    "description": "sexual_aid",
    "pos": "YELLOW",
    "explanation": "(aid + sexual + thing indicator)",
    "isCharacter": false,
    "composition": [
      14704,
      ";",
      9009,
      "/",
      14428
    ]
  },
  {
    "id": "24259",
    "description": "sexual_play",
    "pos": "YELLOW",
    "explanation": "(play + sexual)",
    "isCharacter": false,
    "composition": [
      12335,
      "/",
      "RK:-2",
      "/",
      14164,
      "/",
      17983,
      "/",
      14428
    ]
  },
  {
    "id": "24260",
    "description": "sexually_mature",
    "pos": "GREEN",
    "explanation": "(mature + sexual + description indicator)",
    "isCharacter": false,
    "composition": [
      12341,
      ";",
      8998,
      "/",
      14428
    ]
  },
  {
    "id": "24261",
    "description": "shall,will-(modal_aux_v)",
    "pos": "RED",
    "explanation": "(then + action indicator: auxiliary verb for future)",
    "isCharacter": false,
    "composition": [
      17705,
      ";",
      8993
    ]
  },
  {
    "id": "24262",
    "description": "shampoo-(to)",
    "pos": "RED",
    "explanation": "(shampoo + action indicator)",
    "isCharacter": false,
    "composition": [
      16992,
      ";",
      8993,
      "/",
      14661
    ]
  },
  {
    "id": "24263",
    "description": "shave-(to)",
    "pos": "RED",
    "explanation": "(knife + hair + action indicator)",
    "isCharacter": false,
    "composition": [
      15159,
      ";",
      8993,
      "/",
      14660
    ]
  },
  {
    "id": "24264",
    "description": "should,would-(modal_aux_v)",
    "pos": "RED",
    "explanation": "(then + conditional indicator: auxiliary verb for future conditional)",
    "isCharacter": false,
    "composition": [
      17705,
      ";",
      8995
    ]
  },
  {
    "id": "24265",
    "description": "sign_of_the_cross",
    "pos": "YELLOW",
    "explanation": "(hand + cross: where the cross represents Christ [contraction])",
    "isCharacter": false,
    "composition": [
      14667,
      "/",
      13613
    ]
  },
  {
    "id": "24266",
    "description": "skin_disease,eczema",
    "pos": "YELLOW",
    "explanation": "(illness + skin)",
    "isCharacter": false,
    "composition": [
      16164,
      "/",
      16420,
      "/",
      12870
    ]
  },
  {
    "id": "24267",
    "description": "skytrain,monorail",
    "pos": "YELLOW",
    "explanation": "(vehicle + above)",
    "isCharacter": false,
    "composition": [
      18010,
      "/",
      15948
    ]
  },
  {
    "id": "24268",
    "description": "slow,slowly",
    "pos": "GREEN",
    "explanation": "(forward + negative + description indicator)  Preferred NEW SYNONYM, replacing 17014",
    "isCharacter": false,
    "composition": [
      14390,
      ";",
      8998,
      "/",
      15474,
      "/",
      14947
    ]
  },
  {
    "id": "24269",
    "description": "social",
    "pos": "GREEN",
    "explanation": "(society + description indicator)",
    "isCharacter": false,
    "composition": [
      14430,
      "/",
      13349,
      ";",
      8998
    ]
  },
  {
    "id": "24270",
    "description": "society",
    "pos": "YELLOW",
    "explanation": "(generalization + citizen)",
    "isCharacter": false,
    "composition": [
      14430,
      "/",
      13349
    ]
  },
  {
    "id": "24272",
    "description": "somersault",
    "pos": "YELLOW",
    "explanation": "(rotation + ground) - Character (superimposed)  SYMBOL SYNONYM",
    "isCharacter": true
  },
  {
    "id": "24273",
    "description": "somersault_(person)",
    "pos": "YELLOW",
    "explanation": "(somersault + person)  SYMBOL SYNONYM",
    "isCharacter": false,
    "composition": [
      24272,
      "/",
      16161
    ]
  },
  {
    "id": "24274",
    "description": "spark",
    "pos": "YELLOW",
    "explanation": "(flame + star)",
    "isCharacter": false,
    "composition": [
      14183,
      "/",
      17252
    ]
  },
  {
    "id": "24275",
    "description": "spasm",
    "pos": "YELLOW",
    "explanation": "(activity + muscle + sudden)",
    "isCharacter": false,
    "composition": [
      12335,
      "/",
      20517,
      "/",
      17732,
      "/",
      15209
    ]
  },
  {
    "id": "24276",
    "description": "speech_therapy",
    "pos": "YELLOW",
    "explanation": "(therapy + language)",
    "isCharacter": false,
    "composition": [
      21589,
      "/",
      15172
    ]
  },
  {
    "id": "24277",
    "description": "speech_therapy_room",
    "pos": "YELLOW",
    "explanation": "(room + speech therapy)",
    "isCharacter": false,
    "composition": [
      16687,
      "/",
      21589,
      "/",
      15172
    ]
  },
  {
    "id": "24278",
    "description": "spiritual_awareness",
    "pos": "YELLOW",
    "explanation": "(insight + spirit)",
    "isCharacter": false,
    "composition": [
      21098,
      "/",
      21044
    ]
  },
  {
    "id": "24279",
    "description": "splint_(orthopedic)",
    "pos": "YELLOW",
    "explanation": "(aid + bones_with_joint + thing indicator: where bones_with_joint represents joint [contraction])",
    "isCharacter": false,
    "composition": [
      14704,
      ";",
      9009,
      "/",
      25528
    ]
  },
  {
    "id": "24280",
    "description": "sport_fanatic",
    "pos": "BLUE",
    "explanation": "(fanatic + sport)",
    "isCharacter": false,
    "composition": [
      16161,
      "/",
      14164,
      "/",
      24913,
      "/",
      14947,
      "/",
      20518
    ]
  },
  {
    "id": "24281",
    "description": "square_(public)",
    "pos": "YELLOW",
    "explanation": "(buildings_with_courtyard + pointer, to courtyard)  - Character (superimposed - pointer)",
    "isCharacter": true
  },
  {
    "id": "24282",
    "description": "stallion,entire",
    "pos": "YELLOW",
    "explanation": "(horse + male)",
    "isCharacter": false,
    "composition": [
      14897,
      "/",
      12335
    ]
  },
  {
    "id": "24283",
    "description": "starvation",
    "pos": "YELLOW",
    "explanation": "(life + without + food)",
    "isCharacter": false,
    "composition": [
      15206,
      "/",
      15474,
      "/",
      14377
    ]
  },
  {
    "id": "24284",
    "description": "station",
    "pos": "YELLOW",
    "explanation": "(group of + platform)",
    "isCharacter": false,
    "composition": [
      14647,
      "/",
      24214
    ]
  },
  {
    "id": "24285",
    "description": "still,continuing,ongoing",
    "pos": "GREEN",
    "explanation": "(continuance,continuation + description indicator)",
    "isCharacter": false,
    "composition": [
      24881,
      ";",
      8998
    ]
  },
  {
    "id": "24286",
    "description": "still,continuously",
    "pos": "GREEN",
    "explanation": "(time + to continue + description indicator)",
    "isCharacter": false,
    "composition": [
      17732,
      ";",
      8998,
      "/",
      24881
    ]
  },
  {
    "id": "24287",
    "description": "stirrup",
    "pos": "YELLOW",
    "explanation": "(support + foot + riding [contraction] + thing indicator)",
    "isCharacter": false,
    "composition": [
      14704,
      ";",
      9009,
      "/",
      14379,
      "/",
      14897
    ]
  },
  {
    "id": "24288",
    "description": "stomach_flu",
    "pos": "YELLOW",
    "explanation": "(illness + vomit)",
    "isCharacter": false,
    "composition": [
      16164,
      "/",
      15943,
      "/",
      14377
    ]
  },
  {
    "id": "24289",
    "description": "stomach_illness",
    "pos": "YELLOW",
    "explanation": "(illness + stomach)",
    "isCharacter": false,
    "composition": [
      16164,
      "/",
      17265
    ]
  },
  {
    "id": "24290",
    "description": "stop,platform_(vehicle)",
    "pos": "YELLOW",
    "explanation": "(platform + vehicle)  Preferred NEW SYNONYM, replacing 16198",
    "isCharacter": false,
    "composition": [
      24214,
      "/",
      18010
    ]
  },
  {
    "id": "24291",
    "description": "stretch_(elongate)-(to)",
    "pos": "RED",
    "explanation": "(to make + long + action indicator)",
    "isCharacter": false,
    "composition": [
      23583,
      ";",
      8993,
      "/",
      15193
    ]
  },
  {
    "id": "24292",
    "description": "stretch_(muscles)-(to)",
    "pos": "RED",
    "explanation": "(muscle + long + action indicator)",
    "isCharacter": false,
    "composition": [
      20517,
      ";",
      8993,
      "/",
      15193
    ]
  },
  {
    "id": "24293",
    "description": "striped",
    "pos": "GREEN",
    "explanation": "(many + line + description indicator)",
    "isCharacter": false,
    "composition": [
      14647,
      "/",
      15214,
      ";",
      8998
    ]
  },
  {
    "id": "24294",
    "description": "study-(to)",
    "pos": "RED",
    "explanation": "(activity + learning + action indicator)",
    "isCharacter": false,
    "composition": [
      12335,
      ";",
      8993,
      "/",
      24727,
      "/",
      15162
    ]
  },
  {
    "id": "24295",
    "description": "stupid,dumb",
    "pos": "GREEN",
    "explanation": "(without + smartness + description indicator)  Preferred NEW SYNONYM, replacing 17447",
    "isCharacter": false,
    "composition": [
      15474,
      "/",
      15471,
      ";",
      8998,
      "/",
      14947
    ]
  },
  {
    "id": "24296",
    "description": "subway,metro,underground,tube",
    "pos": "YELLOW",
    "explanation": "(vehicle + under)",
    "isCharacter": false,
    "composition": [
      18010,
      "/",
      17969
    ]
  },
  {
    "id": "24297",
    "description": "sunflower",
    "pos": "YELLOW",
    "explanation": "(flower + sun)",
    "isCharacter": false,
    "composition": [
      14205,
      "/",
      17462
    ]
  },
  {
    "id": "24298",
    "description": "walker,walking_aid_(1)",
    "pos": "YELLOW",
    "explanation": "(aid + activity + walk + thing indicator) SYMBOL SYNONYM (See also 18032)",
    "isCharacter": false,
    "composition": [
      14704,
      ";",
      9009,
      "/",
      12335,
      "/",
      15189
    ]
  },
  {
    "id": "24299",
    "description": "switch_off,turn_off-(to)",
    "pos": "RED",
    "explanation": "(switch + minus + action indicator)",
    "isCharacter": false,
    "composition": [
      17717,
      ";",
      8993,
      "/",
      14667,
      "/",
      15474
    ]
  },
  {
    "id": "24300",
    "description": "switch_on,turn_on-(to)",
    "pos": "RED",
    "explanation": "(switch + plus + action indicator)",
    "isCharacter": false,
    "composition": [
      17717,
      ";",
      8993,
      "/",
      14667,
      "/",
      12374
    ]
  },
  {
    "id": "24301",
    "description": "tack_room",
    "pos": "YELLOW",
    "explanation": "(room + tool + horse)",
    "isCharacter": false,
    "composition": [
      16687,
      "/",
      17755,
      "/",
      14897
    ]
  },
  {
    "id": "24302",
    "description": "tadpole",
    "pos": "YELLOW",
    "explanation": "(pictograph: the symbol also incorporates water)  - Character",
    "isCharacter": true
  },
  {
    "id": "24303",
    "description": "tail_(horse)",
    "pos": "YELLOW",
    "explanation": "(hair + horse_rump)",
    "isCharacter": false,
    "composition": [
      14660,
      "/",
      25572
    ]
  },
  {
    "id": "24304",
    "description": "tail_lift,lift",
    "pos": "YELLOW",
    "explanation": "(platform + up and down)",
    "isCharacter": false,
    "composition": [
      24214,
      "/",
      20524
    ]
  },
  {
    "id": "24305",
    "description": "teamwork",
    "pos": "YELLOW",
    "explanation": "(work + together)",
    "isCharacter": false,
    "composition": [
      18273,
      "/",
      23409
    ]
  },
  {
    "id": "24306",
    "description": "teetotalism",
    "pos": "YELLOW",
    "explanation": "(decision + without + alcohol)",
    "isCharacter": false,
    "composition": [
      13649,
      "/",
      15474,
      "/",
      12359
    ]
  },
  {
    "id": "24307",
    "description": "temporary",
    "pos": "GREEN",
    "explanation": "(limited time + description indicator)",
    "isCharacter": false,
    "composition": [
      15212,
      ";",
      8998
    ]
  },
  {
    "id": "24308",
    "description": "textile_craft",
    "pos": "YELLOW",
    "explanation": "(craft + cloth)",
    "isCharacter": false,
    "composition": [
      23583,
      "/",
      "RK:-2",
      "/",
      14667,
      "/",
      13365
    ]
  },
  {
    "id": "24309",
    "description": "that_(conj)",
    "pos": "WHITE",
    "explanation": "(ideograph: “…indicates a halt and afterwards a free flow” [C.K. Bliss, Semantography. p. 449]) See also: but,except 13094  - Character",
    "isCharacter": true
  },
  {
    "id": "24310",
    "description": "therapeutic_riding",
    "pos": "YELLOW",
    "explanation": "(therapy + riding)",
    "isCharacter": false,
    "composition": [
      21589,
      "/",
      12335,
      "/",
      14897
    ]
  },
  {
    "id": "24311",
    "description": "tie,bind_together,lash-(to)",
    "pos": "RED",
    "explanation": "(knot + action indicator + thing indicator)",
    "isCharacter": false,
    "composition": [
      13380,
      ";",
      8993,
      "/",
      15214,
      ";",
      9009,
      "/",
      23409
    ]
  },
  {
    "id": "24312",
    "description": "towel",
    "pos": "YELLOW",
    "explanation": "(cloth + dry)",
    "isCharacter": false,
    "composition": [
      13365,
      "/",
      23859
    ]
  },
  {
    "id": "24314",
    "description": "train_station_(building)",
    "pos": "YELLOW",
    "explanation": "(house + train)",
    "isCharacter": false,
    "composition": [
      14905,
      "/",
      14647,
      "/",
      18010
    ]
  },
  {
    "id": "24315",
    "description": "train_station_(platforms)",
    "pos": "YELLOW",
    "explanation": "(station + train)",
    "isCharacter": false,
    "composition": [
      14647,
      "/",
      24214,
      "/",
      14647,
      "/",
      18010
    ]
  },
  {
    "id": "24316",
    "description": "tram",
    "pos": "YELLOW",
    "explanation": "(long vehicle + track)",
    "isCharacter": false,
    "composition": [
      24332,
      "/",
      23690
    ]
  },
  {
    "id": "24317",
    "description": "treat,care_for_(medically)-(to)",
    "pos": "RED",
    "explanation": "(medical treatment + action indicator)",
    "isCharacter": false,
    "composition": [
      14704,
      ";",
      8993,
      "/",
      24920
    ]
  },
  {
    "id": "24318",
    "description": "trolleybus",
    "pos": "YELLOW",
    "explanation": "(bus + electricity)",
    "isCharacter": false,
    "composition": [
      13089,
      "/",
      13918
    ]
  },
  {
    "id": "24319",
    "description": "trot_(horse)-(to)",
    "pos": "RED",
    "explanation": "(horse + intensity + action indicator)",
    "isCharacter": false,
    "composition": [
      14897,
      ";",
      8993,
      "/",
      14947
    ]
  },
  {
    "id": "24320",
    "description": "tumble-drier,tumble-dryer",
    "pos": "YELLOW",
    "explanation": "(machine + dry + cloth)",
    "isCharacter": false,
    "composition": [
      15406,
      "/",
      23859,
      "/",
      13365
    ]
  },
  {
    "id": "24321",
    "description": "tunnel,subway,underpass",
    "pos": "YELLOW",
    "explanation": "(pipe + under)",
    "isCharacter": false,
    "composition": [
      16187,
      "/",
      17969
    ]
  },
  {
    "id": "24322",
    "description": "underground_station,subway_station",
    "pos": "YELLOW",
    "explanation": "(station + under)",
    "isCharacter": false,
    "composition": [
      14647,
      "/",
      24214,
      "/",
      17969
    ]
  },
  {
    "id": "24323",
    "description": "unharness_(horse)-(to)",
    "pos": "RED",
    "explanation": "(to remove + harness + horse + action indicator + thing indicator)",
    "isCharacter": false,
    "composition": [
      17449,
      ";",
      8993,
      "/",
      14647,
      "/",
      15214,
      ";",
      9009,
      "/",
      13380,
      "/",
      14897
    ]
  },
  {
    "id": "24324",
    "description": "union_(political_unit)",
    "pos": "YELLOW",
    "explanation": "(group of + country + together)  Add specific letters for the appropriate union e g NATO.",
    "isCharacter": false,
    "composition": [
      14647,
      "/",
      13423,
      "/",
      23409
    ]
  },
  {
    "id": "24325",
    "description": "upper_body",
    "pos": "YELLOW",
    "explanation": "(above + waist)",
    "isCharacter": false,
    "composition": [
      15948,
      "/",
      18029
    ]
  },
  {
    "id": "24326",
    "description": "vaginal_discharge",
    "pos": "YELLOW",
    "explanation": "(liquid + vagina + down)",
    "isCharacter": false,
    "composition": [
      18209,
      "/",
      17996,
      "/",
      13869
    ]
  },
  {
    "id": "24327",
    "description": "walk_(horse)-(to)",
    "pos": "RED",
    "explanation": "(horse + action indicator)",
    "isCharacter": false,
    "composition": [
      14897,
      ";",
      8993
    ]
  },
  {
    "id": "24328",
    "description": "walkway,footpath",
    "pos": "YELLOW",
    "explanation": "(place + activity + to walk)",
    "isCharacter": false,
    "composition": [
      16193,
      "/",
      12335,
      "/",
      15189
    ]
  },
  {
    "id": "24329",
    "description": "wart,papilloma_(venereal)",
    "pos": "YELLOW",
    "explanation": "(dot + genitals)",
    "isCharacter": false,
    "composition": [
      13867,
      "/",
      14431
    ]
  },
  {
    "id": "24330",
    "description": "water-(to)",
    "pos": "RED",
    "explanation": "(to give + water + action indicator)",
    "isCharacter": false,
    "composition": [
      24903,
      ";",
      8993,
      "/",
      18209
    ]
  },
  {
    "id": "24331",
    "description": "water_bucket",
    "pos": "YELLOW",
    "explanation": "(bucket + water)",
    "isCharacter": false,
    "composition": [
      15953,
      "/",
      18209
    ]
  },
  {
    "id": "24332",
    "description": "vehicle_(long)",
    "pos": "YELLOW",
    "explanation": "(vehicle [modification, lengthened] + wheel: pictograph of a long vehicle that does not operate under its own power)  - Character (superimposed - modified)",
    "isCharacter": true
  },
  {
    "id": "24333",
    "description": "venereal_disease",
    "pos": "YELLOW",
    "explanation": "(illness + sexual)",
    "isCharacter": false,
    "composition": [
      16164,
      "/",
      14428
    ]
  },
  {
    "id": "24334",
    "description": "venereal_papilloma",
    "pos": "YELLOW",
    "explanation": "(group of + wart,papilloma_(venereal))",
    "isCharacter": false,
    "composition": [
      14647,
      "/",
      13867,
      "/",
      14431
    ]
  },
  {
    "id": "24335",
    "description": "wheelchair_straps",
    "pos": "YELLOW",
    "explanation": "(harness + wheelchair + thing indicator)",
    "isCharacter": false,
    "composition": [
      14647,
      "/",
      15214,
      ";",
      9009,
      "/",
      13380,
      "/",
      18233
    ]
  },
  {
    "id": "24336",
    "description": "wild_strawberry",
    "pos": "YELLOW",
    "explanation": "(strawberry + small)",
    "isCharacter": false,
    "composition": [
      17278,
      "/",
      24917
    ]
  },
  {
    "id": "24337",
    "description": "visa",
    "pos": "YELLOW",
    "explanation": "(paper + permission + travel)",
    "isCharacter": false,
    "composition": [
      15962,
      "/",
      24926,
      "/",
      17779
    ]
  },
  {
    "id": "24338",
    "description": "volte_(horse)-(to)",
    "pos": "RED",
    "explanation": "(horse + rotation + action indicator: a circular movement executed by a horse in manège)",
    "isCharacter": false,
    "composition": [
      14897,
      ";",
      8993,
      "/",
      24249
    ]
  },
  {
    "id": "24339",
    "description": "woodcraft",
    "pos": "YELLOW",
    "explanation": "(craft + wood)",
    "isCharacter": false,
    "composition": [
      23583,
      "/",
      "RK:-2",
      "/",
      14667,
      "/",
      17775
    ]
  },
  {
    "id": "24340",
    "description": "wrist_splint",
    "pos": "YELLOW",
    "explanation": "(aid + bones_with_joint + wrist + thing indicator)",
    "isCharacter": false,
    "composition": [
      14704,
      ";",
      9009,
      "/",
      25528,
      "/",
      18284
    ]
  },
  {
    "id": "24401",
    "description": "achieve-(to)",
    "pos": "RED",
    "explanation": "(achievement + action indicator)",
    "isCharacter": false,
    "composition": [
      13910,
      ";",
      8993,
      "/",
      14164,
      "/",
      15948
    ]
  },
  {
    "id": "24402",
    "description": "achievement",
    "pos": "YELLOW",
    "explanation": "(effect + proud)",
    "isCharacter": false,
    "composition": [
      13910,
      "/",
      14164,
      "/",
      15948
    ]
  },
  {
    "id": "24403",
    "description": "addict",
    "pos": "BLUE",
    "explanation": "(person + addiction)",
    "isCharacter": false,
    "composition": [
      16161,
      "/",
      16164,
      "/",
      15701
    ]
  },
  {
    "id": "24404",
    "description": "addiction",
    "pos": "YELLOW",
    "explanation": "(illness + need)",
    "isCharacter": false,
    "composition": [
      16164,
      "/",
      15701
    ]
  },
  {
    "id": "24405",
    "description": "alcoholism,alcohol_addiction",
    "pos": "YELLOW",
    "explanation": "(illness + need)",
    "isCharacter": false,
    "composition": [
      16164,
      "/",
      15701,
      "/",
      12359
    ]
  },
  {
    "id": "24406",
    "description": "alcohol_abuse,alcohol_addiction",
    "pos": "YELLOW",
    "explanation": "(negative dependency + alcohol)",
    "isCharacter": false,
    "composition": [
      15701,
      "/",
      15474,
      "/",
      14947,
      "/",
      12359
    ]
  },
  {
    "id": "24407",
    "description": "allergy,hypersensitivity",
    "pos": "YELLOW",
    "explanation": "(reaction + body)",
    "isCharacter": false,
    "composition": [
      12335,
      "/",
      12613,
      "/",
      13910,
      "/",
      12870
    ]
  },
  {
    "id": "24408",
    "description": "baby_animal",
    "pos": "YELLOW",
    "explanation": "(animal + baby)",
    "isCharacter": false,
    "composition": [
      12378,
      "/",
      12603
    ]
  },
  {
    "id": "24409",
    "description": "baby_bottle,feeding_bottle",
    "pos": "YELLOW",
    "explanation": "(bottle + baby)",
    "isCharacter": false,
    "composition": [
      12880,
      "/",
      12603
    ]
  },
  {
    "id": "24410",
    "description": "bacterial_infection",
    "pos": "YELLOW",
    "explanation": "(illness + bacterium)",
    "isCharacter": false,
    "composition": [
      16164,
      "/",
      8497,
      "/",
      24443,
      ";",
      9009,
      "/",
      24917
    ]
  },
  {
    "id": "24411",
    "description": "bacterium",
    "pos": "YELLOW",
    "explanation": "(1 + micro-organism: single cell micro-organism)",
    "isCharacter": false,
    "composition": [
      8497,
      "/",
      24443,
      ";",
      9009,
      "/",
      24917
    ]
  },
  {
    "id": "24412",
    "description": "bend-(to)",
    "pos": "RED",
    "explanation": "(curved line + action indicator)",
    "isCharacter": false,
    "composition": [
      13627,
      ";",
      8993
    ]
  },
  {
    "id": "24413",
    "description": "bet",
    "pos": "YELLOW",
    "explanation": "(money + competition)",
    "isCharacter": false,
    "composition": [
      15484,
      "/",
      16451
    ]
  },
  {
    "id": "24414",
    "description": "bet-(to)",
    "pos": "RED",
    "explanation": "(bet + action indicator)",
    "isCharacter": false,
    "composition": [
      15484,
      ";",
      8993,
      "/",
      16451
    ]
  },
  {
    "id": "24415",
    "description": "betting",
    "pos": "YELLOW",
    "explanation": "(activity + bet)",
    "isCharacter": false,
    "composition": [
      12335,
      "/",
      15484,
      "/",
      16451
    ]
  },
  {
    "id": "24416",
    "description": "binoculars,field_glass_(OLD)",
    "pos": "YELLOW",
    "explanation": "(tool + to look + distance_(OLD))  SUPERSEDED SYNONYM  See binoculars,field_glass 25984",
    "isCharacter": false,
    "composition": [
      17755,
      "/",
      14133,
      "/",
      24896
    ]
  },
  {
    "id": "24417",
    "description": "blacksmith",
    "pos": "BLUE",
    "explanation": "(person + iron [contraction])",
    "isCharacter": false,
    "composition": [
      16161,
      "/",
      23150,
      "/",
      15689
    ]
  },
  {
    "id": "24418",
    "description": "bottle_nipple,teat",
    "pos": "YELLOW",
    "explanation": "(bottleneck,bottle_opening + baby: modified baby bottle with a pointer, to nipple)",
    "isCharacter": false,
    "composition": [
      25529,
      "/",
      12603
    ]
  },
  {
    "id": "24419",
    "description": "bruise,contusion,haematoma",
    "pos": "YELLOW",
    "explanation": "(spot + blue)",
    "isCharacter": false,
    "composition": [
      14133,
      "/",
      13867,
      "/",
      13377,
      "/",
      17006
    ]
  },
  {
    "id": "24420",
    "description": "bruise,dent",
    "pos": "YELLOW",
    "explanation": "(spot + bump)",
    "isCharacter": false,
    "composition": [
      14133,
      "/",
      13867,
      "/",
      24422
    ]
  },
  {
    "id": "24421",
    "description": "bruised,dented",
    "pos": "GREEN",
    "explanation": "(bruise,dent + description indicator)",
    "isCharacter": false,
    "composition": [
      14133,
      ";",
      8998,
      "/",
      13867,
      "/",
      24422
    ]
  },
  {
    "id": "24422",
    "description": "bump,press,pressing",
    "pos": "YELLOW",
    "explanation": "(down,downward + earth,ground,land)  - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "24423",
    "description": "bump,press-(to)",
    "pos": "RED",
    "explanation": "(bump,press,pressing + action indicator)",
    "isCharacter": false,
    "composition": [
      24422,
      ";",
      8993
    ]
  },
  {
    "id": "24424",
    "description": "cease-fire,armistice",
    "pos": "YELLOW",
    "explanation": "(agreement + stop + war)",
    "isCharacter": false,
    "composition": [
      12354,
      "/",
      13935,
      "/",
      18036
    ]
  },
  {
    "id": "24425",
    "description": "Ceres_(dwarf_planet)",
    "pos": "YELLOW",
    "explanation": "(dwarf planet + middle)",
    "isCharacter": false,
    "composition": [
      22834,
      "/",
      24917,
      "/",
      15464
    ]
  },
  {
    "id": "24426",
    "description": "chance,risk",
    "pos": "YELLOW",
    "explanation": "(choice + future_(uncertain))",
    "isCharacter": false,
    "composition": [
      13175,
      "/",
      25568
    ]
  },
  {
    "id": "24427",
    "description": "chive",
    "pos": "YELLOW",
    "explanation": "(onion + grass)",
    "isCharacter": false,
    "composition": [
      18006,
      "/",
      14636
    ]
  },
  {
    "id": "24428",
    "description": "control_(OLD)",
    "pos": "YELLOW",
    "explanation": "(leadership + limit(s),limitation_(OLD))  SUPERSEDED SYNONYM  See control 25987",
    "isCharacter": false,
    "composition": [
      22913,
      "/",
      15213
    ]
  },
  {
    "id": "24429",
    "description": "dependency",
    "pos": "YELLOW",
    "explanation": "(need + intensity)",
    "isCharacter": false,
    "composition": [
      15701,
      "/",
      14947
    ]
  },
  {
    "id": "24430",
    "description": "disability_benefit_(OLD)",
    "pos": "YELLOW",
    "explanation": "(money + disability,handicap,impairment_(OLD))  SUPERSEDED SYNONYM  See disability_benefit 25993",
    "isCharacter": false,
    "composition": [
      15484,
      "/",
      12322,
      "/",
      15213
    ]
  },
  {
    "id": "24431",
    "description": "dish_rack",
    "pos": "YELLOW",
    "explanation": "(sieve + glassware)",
    "isCharacter": false,
    "composition": [
      16976,
      "/",
      14430,
      "/",
      14442
    ]
  },
  {
    "id": "24432",
    "description": "domino",
    "pos": "YELLOW",
    "explanation": "(game [contraction] + tile)",
    "isCharacter": false,
    "composition": [
      12335,
      "/",
      "RK:-2",
      "/",
      14164,
      "/",
      24518
    ]
  },
  {
    "id": "24433",
    "description": "dribble-(to)",
    "pos": "RED",
    "explanation": "(saliva + down + action indicator)",
    "isCharacter": false,
    "composition": [
      18209,
      ";",
      8993,
      "/",
      15666,
      "/",
      13869
    ]
  },
  {
    "id": "24434",
    "description": "drug_addict",
    "pos": "BLUE",
    "explanation": "(person + drug addiction [contraction])",
    "isCharacter": false,
    "composition": [
      16161,
      "/",
      15701,
      "/",
      "RK:-2",
      "/",
      13158,
      "/",
      15471
    ]
  },
  {
    "id": "24435",
    "description": "drug_addiction",
    "pos": "YELLOW",
    "explanation": "(addiction + drug)",
    "isCharacter": false,
    "composition": [
      16164,
      "/",
      15701,
      "/",
      "RK:-2",
      "/",
      13158,
      "/",
      15471
    ]
  },
  {
    "id": "24436",
    "description": "drug_dependency",
    "pos": "YELLOW",
    "explanation": "(negative dependency + drug)",
    "isCharacter": false,
    "composition": [
      15701,
      "/",
      15474,
      "/",
      14947,
      "/",
      13158,
      "/",
      15471
    ]
  },
  {
    "id": "24437",
    "description": "dwarf_planet",
    "pos": "YELLOW",
    "explanation": "(planet + small)",
    "isCharacter": false,
    "composition": [
      22834,
      "/",
      24917
    ]
  },
  {
    "id": "24438",
    "description": "Earth,Tellus_(planet)",
    "pos": "YELLOW",
    "explanation": "(rock planet + water)",
    "isCharacter": false,
    "composition": [
      22834,
      "/",
      17267,
      "/",
      18209
    ]
  },
  {
    "id": "24439",
    "description": "eating_disorder",
    "pos": "YELLOW",
    "explanation": "(mental illness + food)",
    "isCharacter": false,
    "composition": [
      24482,
      "/",
      14377
    ]
  },
  {
    "id": "24440",
    "description": "Eris_(dwarf_planet)",
    "pos": "YELLOW",
    "explanation": "(dwarf planet + angle)",
    "isCharacter": false,
    "composition": [
      22834,
      "/",
      24917,
      "/",
      12376
    ]
  },
  {
    "id": "24441",
    "description": "examination,investigation",
    "pos": "YELLOW",
    "explanation": "(to observe + evaluation)",
    "isCharacter": false,
    "composition": [
      24846,
      "/",
      13949
    ]
  },
  {
    "id": "24442",
    "description": "examine_(medically)-(to)",
    "pos": "RED",
    "explanation": "(medical examination + action indicator)",
    "isCharacter": false,
    "composition": [
      24846,
      ";",
      8993,
      "/",
      13949,
      "/",
      24920
    ]
  },
  {
    "id": "24443",
    "description": "being_(state_of)",
    "pos": "YELLOW",
    "explanation": "(life [half sized])  - Character  SYMBOL SYNONYM",
    "isCharacter": true
  },
  {
    "id": "24444",
    "description": "fail-(to)",
    "pos": "RED",
    "explanation": "(failure + action indicator)",
    "isCharacter": false,
    "composition": [
      24445,
      ";",
      8993
    ]
  },
  {
    "id": "24445",
    "description": "failure",
    "pos": "YELLOW",
    "explanation": "(success + stop) - Character (superimposed - combined)",
    "isCharacter": true
  },
  {
    "id": "24446",
    "description": "fan_club",
    "pos": "YELLOW",
    "explanation": "(club [contraction] + feeling)",
    "isCharacter": false,
    "composition": [
      14427,
      "/",
      14164
    ]
  },
  {
    "id": "24447",
    "description": "fledgeling",
    "pos": "YELLOW",
    "explanation": "(bird + young)",
    "isCharacter": false,
    "composition": [
      12837,
      "/",
      13166
    ]
  },
  {
    "id": "24448",
    "description": "foal",
    "pos": "YELLOW",
    "explanation": "(horse + young)",
    "isCharacter": false,
    "composition": [
      14897,
      "/",
      13166
    ]
  },
  {
    "id": "24449",
    "description": "football_supporters_club",
    "pos": "YELLOW",
    "explanation": "(club [contraction] + football [contraction])",
    "isCharacter": false,
    "composition": [
      14427,
      "/",
      12621,
      "/",
      15189
    ]
  },
  {
    "id": "24450",
    "description": "football_team",
    "pos": "YELLOW",
    "explanation": "(group + football [contraction])",
    "isCharacter": false,
    "composition": [
      14647,
      "/",
      16161,
      "/",
      12621,
      "/",
      15189
    ]
  },
  {
    "id": "24451",
    "description": "galaxy",
    "pos": "YELLOW",
    "explanation": "(sun + star: the sun here representing a circular gathering of stars)  - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "24452",
    "description": "gamble",
    "pos": "YELLOW",
    "explanation": "(competition + money)",
    "isCharacter": false,
    "composition": [
      16451,
      "/",
      15484
    ]
  },
  {
    "id": "24453",
    "description": "gamble-(to)",
    "pos": "RED",
    "explanation": "(gamble + action indicator)",
    "isCharacter": false,
    "composition": [
      16451,
      ";",
      8993,
      "/",
      15484
    ]
  },
  {
    "id": "24454",
    "description": "gambler",
    "pos": "BLUE",
    "explanation": "(person + gamble)",
    "isCharacter": false,
    "composition": [
      16161,
      "/",
      16451,
      "/",
      15484
    ]
  },
  {
    "id": "24455",
    "description": "gas_planet",
    "pos": "YELLOW",
    "explanation": "(planet + gas)",
    "isCharacter": false,
    "composition": [
      22834,
      "/",
      14424
    ]
  },
  {
    "id": "24456",
    "description": "goldsmith",
    "pos": "BLUE",
    "explanation": "(person + gold [contraction])",
    "isCharacter": false,
    "composition": [
      16161,
      "/",
      23150,
      "/",
      16675
    ]
  },
  {
    "id": "24457",
    "description": "Good_day_(bye)",
    "pos": "WHITE",
    "explanation": "(goodbye + day)",
    "isCharacter": false,
    "composition": [
      15666,
      "/",
      25592,
      "/",
      13639
    ]
  },
  {
    "id": "24458",
    "description": "Good_day_(hello)",
    "pos": "WHITE",
    "explanation": "(hello + day)",
    "isCharacter": false,
    "composition": [
      15666,
      "/",
      25583,
      "/",
      13639
    ]
  },
  {
    "id": "24459",
    "description": "Good_evening_(bye)",
    "pos": "WHITE",
    "explanation": "(goodbye + evening)",
    "isCharacter": false,
    "composition": [
      15666,
      "/",
      25592,
      "/",
      13950
    ]
  },
  {
    "id": "24460",
    "description": "Good_evening_(hello)",
    "pos": "WHITE",
    "explanation": "(hello + evening)",
    "isCharacter": false,
    "composition": [
      15666,
      "/",
      25583,
      "/",
      13950
    ]
  },
  {
    "id": "24461",
    "description": "Good_morning_(bye)",
    "pos": "WHITE",
    "explanation": "(goodbye + morning)",
    "isCharacter": false,
    "composition": [
      15666,
      "/",
      25592,
      "/",
      15656
    ]
  },
  {
    "id": "24462",
    "description": "Good_morning_(hello)",
    "pos": "WHITE",
    "explanation": "(hello + morning)",
    "isCharacter": false,
    "composition": [
      15666,
      "/",
      25583,
      "/",
      15656
    ]
  },
  {
    "id": "24463",
    "description": "Good_night_(bye)",
    "pos": "WHITE",
    "explanation": "(goodbye + night)",
    "isCharacter": false,
    "composition": [
      15666,
      "/",
      25592,
      "/",
      15719
    ]
  },
  {
    "id": "24464",
    "description": "Good_night_(hello)",
    "pos": "WHITE",
    "explanation": "(hello + night)",
    "isCharacter": false,
    "composition": [
      15666,
      "/",
      25583,
      "/",
      15719
    ]
  },
  {
    "id": "24465",
    "description": "guest_room",
    "pos": "YELLOW",
    "explanation": "(room + guest)",
    "isCharacter": false,
    "composition": [
      16687,
      "/",
      16161,
      "/",
      24859
    ]
  },
  {
    "id": "24466",
    "description": "have_impact_on-(to)",
    "pos": "RED",
    "explanation": "(impact + action indicator)",
    "isCharacter": false,
    "composition": [
      13910,
      ";",
      8993,
      "/",
      14947
    ]
  },
  {
    "id": "24467",
    "description": "impact",
    "pos": "YELLOW",
    "explanation": "(effect + intensity)",
    "isCharacter": false,
    "composition": [
      13910,
      "/",
      14947
    ]
  },
  {
    "id": "24468",
    "description": "infect-(to)",
    "pos": "RED",
    "explanation": "(to cause + infection + action indicator + thing indicator)",
    "isCharacter": false,
    "composition": [
      13134,
      ";",
      8993,
      "/",
      "RK:-2",
      "/",
      16164,
      "/",
      24443,
      ";",
      9009,
      "/",
      24917
    ]
  },
  {
    "id": "24469",
    "description": "infected",
    "pos": "GREEN",
    "explanation": "(infection + description after the fact indicator + thing indicator)",
    "isCharacter": false,
    "composition": [
      16164,
      ";",
      8996,
      "/",
      24443,
      ";",
      9009,
      "/",
      24917
    ]
  },
  {
    "id": "24470",
    "description": "infection",
    "pos": "YELLOW",
    "explanation": "(illness + micro-organism + thing indicator)",
    "isCharacter": false,
    "composition": [
      16164,
      "/",
      24443,
      ";",
      9009,
      "/",
      24917
    ]
  },
  {
    "id": "24471",
    "description": "infectious,contagious",
    "pos": "GREEN",
    "explanation": "(infection + description before the fact indicator + thing indicator)",
    "isCharacter": false,
    "composition": [
      16164,
      ";",
      8997,
      "/",
      24443,
      ";",
      9009,
      "/",
      24917
    ]
  },
  {
    "id": "24472",
    "description": "itch",
    "pos": "YELLOW",
    "explanation": "(uncomfortable + scratch)",
    "isCharacter": false,
    "composition": [
      13687,
      "/",
      14180,
      "/",
      12610
    ]
  },
  {
    "id": "24473",
    "description": "Jupiter_(planet)",
    "pos": "YELLOW",
    "explanation": "(gas planet + big)",
    "isCharacter": false,
    "composition": [
      22834,
      "/",
      14424,
      "/",
      24875
    ]
  },
  {
    "id": "24474",
    "description": "kitten",
    "pos": "YELLOW",
    "explanation": "(cat + young)  Preferred NEW SYNONYM, replacing 15156",
    "isCharacter": false,
    "composition": [
      12383,
      "/",
      13166
    ]
  },
  {
    "id": "24475",
    "description": "lamb",
    "pos": "YELLOW",
    "explanation": "(sheep + young)",
    "isCharacter": false,
    "composition": [
      12379,
      "/",
      13365,
      "/",
      13166
    ]
  },
  {
    "id": "24476",
    "description": "leek",
    "pos": "YELLOW",
    "explanation": "(onion + leaf)",
    "isCharacter": false,
    "composition": [
      18006,
      "/",
      15183
    ]
  },
  {
    "id": "24477",
    "description": "lottery,game_of_chance",
    "pos": "YELLOW",
    "explanation": "(play [contraction] + money + number)",
    "isCharacter": false,
    "composition": [
      12335,
      "/",
      "RK:-2",
      "/",
      14164,
      "/",
      15484,
      "/",
      15742
    ]
  },
  {
    "id": "24478",
    "description": "magnifier,magnifying_glass",
    "pos": "YELLOW",
    "explanation": "(tool + to look + little: tool to look at small things)",
    "isCharacter": false,
    "composition": [
      17755,
      "/",
      14133,
      "/",
      24917
    ]
  },
  {
    "id": "24479",
    "description": "Mars_(planet)",
    "pos": "YELLOW",
    "explanation": "(rock planet + dust)",
    "isCharacter": false,
    "composition": [
      22834,
      "/",
      17267,
      "/",
      16233
    ]
  },
  {
    "id": "24480",
    "description": "medical_examination",
    "pos": "YELLOW",
    "explanation": "(examination + medical)",
    "isCharacter": false,
    "composition": [
      24846,
      "/",
      13949,
      "/",
      24920
    ]
  },
  {
    "id": "24481",
    "description": "meeting_room,auditorium",
    "pos": "YELLOW",
    "explanation": "(room + gathering)",
    "isCharacter": false,
    "composition": [
      16687,
      "/",
      14427
    ]
  },
  {
    "id": "24482",
    "description": "mental_illness",
    "pos": "YELLOW",
    "explanation": "(illness + mind)  - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "24483",
    "description": "Mercury_(planet)",
    "pos": "YELLOW",
    "explanation": "(rock planet + fire)",
    "isCharacter": false,
    "composition": [
      22834,
      "/",
      17267,
      "/",
      14183
    ]
  },
  {
    "id": "24484",
    "description": "message",
    "pos": "YELLOW",
    "explanation": "(information + forward)",
    "isCharacter": false,
    "composition": [
      23542,
      "/",
      14390
    ]
  },
  {
    "id": "24485",
    "description": "message,content_(communication)",
    "pos": "YELLOW",
    "explanation": "(substance + communication)",
    "isCharacter": false,
    "composition": [
      24515,
      "/",
      25555,
      "/",
      15441
    ]
  },
  {
    "id": "24486",
    "description": "micro-organism",
    "pos": "YELLOW",
    "explanation": "(organism + small + thing indicator)",
    "isCharacter": false,
    "composition": [
      24443,
      ";",
      9009,
      "/",
      24917
    ]
  },
  {
    "id": "24487",
    "description": "microscope",
    "pos": "YELLOW",
    "explanation": "(tool + to look + cell)",
    "isCharacter": false,
    "composition": [
      17755,
      "/",
      14133,
      "/",
      21540
    ]
  },
  {
    "id": "24488",
    "description": "drug,mind-altering_drug",
    "pos": "YELLOW",
    "explanation": "(chemical product + mind)",
    "isCharacter": false,
    "composition": [
      13158,
      "/",
      15471
    ]
  },
  {
    "id": "24489",
    "description": "money_on_a_regular_basis",
    "pos": "YELLOW",
    "explanation": "(money + often: e.g. child allowance)",
    "isCharacter": false,
    "composition": [
      15484,
      "/",
      14647,
      "/",
      17732
    ]
  },
  {
    "id": "24491",
    "description": "negative_dependency",
    "pos": "YELLOW",
    "explanation": "(dependency + negative)",
    "isCharacter": false,
    "composition": [
      15701,
      "/",
      15474,
      "/",
      14947
    ]
  },
  {
    "id": "24492",
    "description": "Neptune_(planet)",
    "pos": "YELLOW",
    "explanation": "(gas planet + wind)",
    "isCharacter": false,
    "composition": [
      22834,
      "/",
      14424,
      "/",
      18255
    ]
  },
  {
    "id": "24493",
    "description": "old-age_pension",
    "pos": "YELLOW",
    "explanation": "(money + old)",
    "isCharacter": false,
    "composition": [
      15484,
      "/",
      14647,
      "/",
      18289
    ]
  },
  {
    "id": "24494",
    "description": "organism",
    "pos": "YELLOW",
    "explanation": "(being + thing indicator)  - (character with thing indicator)",
    "isCharacter": "false",
    "composition": [
      24443,
      ";",
      9009
    ]
  },
  {
    "id": "24495",
    "description": "outcome,result,consequence",
    "pos": "YELLOW",
    "explanation": "(effect + activity: consequence of activity)",
    "isCharacter": false,
    "composition": [
      13910,
      "/",
      12335
    ]
  },
  {
    "id": "24496",
    "description": "pacifier,dummy",
    "pos": "YELLOW",
    "explanation": "(thing + baby + mouth)",
    "isCharacter": false,
    "composition": [
      17717,
      "/",
      12603,
      "/",
      15666
    ]
  },
  {
    "id": "24497",
    "description": "pensioner",
    "pos": "BLUE",
    "explanation": "(person + old age pension)",
    "isCharacter": false,
    "composition": [
      16161,
      "/",
      15484,
      "/",
      14647,
      "/",
      18289
    ]
  },
  {
    "id": "24498",
    "description": "Pluto_(dwarf_planet)",
    "pos": "YELLOW",
    "explanation": "(dwarf planet ice)",
    "isCharacter": false,
    "composition": [
      22834,
      "/",
      24917,
      "/",
      14919
    ]
  },
  {
    "id": "24499",
    "description": "program,programme,presentation",
    "pos": "YELLOW",
    "explanation": "(limited time + to see + to hear)",
    "isCharacter": false,
    "composition": [
      15212,
      "/",
      14133,
      "/",
      13894
    ]
  },
  {
    "id": "24500",
    "description": "react-(to)",
    "pos": "RED",
    "explanation": "(reaction + action indicator)",
    "isCharacter": false,
    "composition": [
      12335,
      ";",
      8993,
      "/",
      12613,
      "/",
      13910
    ]
  },
  {
    "id": "24501",
    "description": "reaction",
    "pos": "YELLOW",
    "explanation": "(activity + backward,back + effect)",
    "isCharacter": false,
    "composition": [
      12335,
      "/",
      12613,
      "/",
      13910
    ]
  },
  {
    "id": "24502",
    "description": "reception",
    "pos": "YELLOW",
    "explanation": "(entrance + question)",
    "isCharacter": false,
    "composition": [
      14952,
      "/",
      16445
    ]
  },
  {
    "id": "24503",
    "description": "retirement_pension",
    "pos": "YELLOW",
    "explanation": "(money + stop + work)",
    "isCharacter": false,
    "composition": [
      15484,
      "/",
      13935,
      "/",
      18273
    ]
  },
  {
    "id": "24504",
    "description": "rock_planet,terrestrial_planet",
    "pos": "YELLOW",
    "explanation": "(planet + stone,rock)",
    "isCharacter": false,
    "composition": [
      22834,
      "/",
      17267
    ]
  },
  {
    "id": "24505",
    "description": "Saturn_(planet)",
    "pos": "YELLOW",
    "explanation": "(gas planet + ring)",
    "isCharacter": false,
    "composition": [
      22834,
      "/",
      14424,
      "/",
      16675
    ]
  },
  {
    "id": "24506",
    "description": "scratch",
    "pos": "YELLOW",
    "explanation": "(finger + back and forth)",
    "isCharacter": false,
    "composition": [
      14180,
      "/",
      12610
    ]
  },
  {
    "id": "24507",
    "description": "scratch-(to)",
    "pos": "RED",
    "explanation": "(scratch + action indicator)",
    "isCharacter": false,
    "composition": [
      14180,
      ";",
      8993,
      "/",
      12610
    ]
  },
  {
    "id": "24508",
    "description": "senior_citizen",
    "pos": "BLUE",
    "explanation": "(person + old)",
    "isCharacter": false,
    "composition": [
      16161,
      "/",
      14647,
      "/",
      18289
    ]
  },
  {
    "id": "24509",
    "description": "short_message_system_(SMS),text_message",
    "pos": "YELLOW",
    "explanation": "(letter + telephone)",
    "isCharacter": false,
    "composition": [
      15198,
      "/",
      15172,
      "/",
      13918
    ]
  },
  {
    "id": "24510",
    "description": "silversmith",
    "pos": "BLUE",
    "explanation": "(person + silver [contraction])",
    "isCharacter": false,
    "composition": [
      16161,
      "/",
      23150,
      "/",
      17233
    ]
  },
  {
    "id": "24511",
    "description": "sink,basin",
    "pos": "YELLOW",
    "explanation": "(bath,washing + thing indicator)  - (character with thing indicator)",
    "isCharacter": "false",
    "composition": [
      16992,
      ";",
      9009
    ]
  },
  {
    "id": "24512",
    "description": "smoking_addiction_(2)",
    "pos": "YELLOW",
    "explanation": "(addiction + smoking)  SYMBOL SYNONYM",
    "isCharacter": false,
    "composition": [
      16164,
      "/",
      15701,
      "/",
      25611
    ]
  },
  {
    "id": "24513",
    "description": "smoking_addiction_(1)",
    "pos": "YELLOW",
    "explanation": "(negative dependency + smoking)  SYMBOL SYNONYM",
    "isCharacter": false,
    "composition": [
      15701,
      "/",
      15474,
      "/",
      14947,
      "/",
      25611
    ]
  },
  {
    "id": "24515",
    "description": "substance",
    "pos": "YELLOW",
    "explanation": "(material + dot, in the material: can also be seen as a combination of material and in [modification, half-sized]; what is in a material)  - Character (superimposed - combined - modified)",
    "isCharacter": true
  },
  {
    "id": "24516",
    "description": "tap_(1)",
    "pos": "YELLOW",
    "explanation": "(tool + water)  SYMBOL SYNONYM",
    "isCharacter": false,
    "composition": [
      17755,
      "/",
      18209
    ]
  },
  {
    "id": "24517",
    "description": "tap_(2)",
    "pos": "YELLOW",
    "explanation": "(tool + to cause + water)  SYMBOL SYNONYM",
    "isCharacter": false,
    "composition": [
      17755,
      "/",
      13134,
      "/",
      18209
    ]
  },
  {
    "id": "24518",
    "description": "tile",
    "pos": "YELLOW",
    "explanation": "(pictograph)  - Character",
    "isCharacter": true
  },
  {
    "id": "24519",
    "description": "treatment",
    "pos": "YELLOW",
    "explanation": "(generalization + therapy)",
    "isCharacter": false,
    "composition": [
      14430,
      "/",
      21589
    ]
  },
  {
    "id": "24520",
    "description": "Universe",
    "pos": "YELLOW",
    "explanation": "(all + galaxy)",
    "isCharacter": false,
    "composition": [
      12360,
      "/",
      24451
    ]
  },
  {
    "id": "24521",
    "description": "Uranus_(planet)",
    "pos": "YELLOW",
    "explanation": "(gas planet + ice)",
    "isCharacter": false,
    "composition": [
      22834,
      "/",
      14424,
      "/",
      14919
    ]
  },
  {
    "id": "24522",
    "description": "Venus_(planet)",
    "pos": "YELLOW",
    "explanation": "(rock planet + cloud)",
    "isCharacter": false,
    "composition": [
      22834,
      "/",
      17267,
      "/",
      13367
    ]
  },
  {
    "id": "24523",
    "description": "viral_infection",
    "pos": "YELLOW",
    "explanation": "(illness + virus)",
    "isCharacter": false,
    "composition": [
      16164,
      "/",
      24443,
      ";",
      9009,
      "/",
      24917,
      "/",
      24934
    ]
  },
  {
    "id": "24524",
    "description": "virus",
    "pos": "YELLOW",
    "explanation": "(micro-organism + duplicate: replicating microorganism)",
    "isCharacter": false,
    "composition": [
      24443,
      ";",
      9009,
      "/",
      24917,
      "/",
      24934
    ]
  },
  {
    "id": "24525",
    "description": "young_animal",
    "pos": "YELLOW",
    "explanation": "(animal + young)",
    "isCharacter": false,
    "composition": [
      12378,
      "/",
      13166
    ]
  },
  {
    "id": "24601",
    "description": "adventure_(OLD)",
    "pos": "YELLOW",
    "explanation": "(activity + future_(uncertain) + excited)  SUPERSEDED SYNONYM  See adventure 25006",
    "isCharacter": false,
    "composition": [
      12335,
      "/",
      25568,
      "/",
      14164,
      "/",
      14947,
      "/",
      14947
    ]
  },
  {
    "id": "24602",
    "description": "aerial,antenna",
    "pos": "YELLOW",
    "explanation": "(exchange + signal + thing indicator)",
    "isCharacter": false,
    "composition": [
      25555,
      ";",
      9009,
      "/",
      24750
    ]
  },
  {
    "id": "24603",
    "description": "agenda",
    "pos": "YELLOW",
    "explanation": "(plan + gathering)",
    "isCharacter": false,
    "composition": [
      16194,
      "/",
      14427
    ]
  },
  {
    "id": "24604",
    "description": "anchor",
    "pos": "YELLOW",
    "explanation": "(thing + stop + boat)",
    "isCharacter": false,
    "composition": [
      17717,
      "/",
      13935,
      "/",
      12869
    ]
  },
  {
    "id": "24605",
    "description": "Earth_axis,axis",
    "pos": "YELLOW",
    "explanation": "(earth,globe,world + pointer [modification, at an angle], to the axis of the earth)  - Character (superimposed - modified - pointer)",
    "isCharacter": true
  },
  {
    "id": "24606",
    "description": "band_(of_frequencies)_(OLD)",
    "pos": "YELLOW",
    "explanation": "(signal + limit(s),limitation_(OLD): signal or frequencies in a certain range)  SUPERSEDED SYNONYM  See band_(of_frequencies) 25980",
    "isCharacter": false,
    "composition": [
      24750,
      "/",
      15213
    ]
  },
  {
    "id": "24607",
    "description": "Bangladesh",
    "pos": "YELLOW",
    "explanation": "(land + tiger)",
    "isCharacter": false,
    "composition": [
      13423,
      "/",
      12383,
      "/",
      15214
    ]
  },
  {
    "id": "24608",
    "description": "barley",
    "pos": "YELLOW",
    "explanation": "(grain + straw + long: ear of grain with long tassels)",
    "isCharacter": false,
    "composition": [
      14625,
      "/",
      15214,
      ";",
      9009,
      "/",
      24875
    ]
  },
  {
    "id": "24610",
    "description": "berth,bunk",
    "pos": "YELLOW",
    "explanation": "(bed + boat)",
    "isCharacter": false,
    "composition": [
      12649,
      "/",
      12869
    ]
  },
  {
    "id": "24611",
    "description": "board,board_of_directors,executive",
    "pos": "YELLOW",
    "explanation": "(group of + leader)",
    "isCharacter": false,
    "composition": [
      14647,
      "/",
      21054
    ]
  },
  {
    "id": "24612",
    "description": "boat_ladder",
    "pos": "YELLOW",
    "explanation": "(ladder + boat)",
    "isCharacter": false,
    "composition": [
      15166,
      "/",
      12869
    ]
  },
  {
    "id": "24613",
    "description": "boot,trunk,roof_box,luggage_compartment",
    "pos": "YELLOW",
    "explanation": "(container + car)",
    "isCharacter": false,
    "composition": [
      13403,
      "/",
      13121
    ]
  },
  {
    "id": "24614",
    "description": "broadband_(OLD)",
    "pos": "YELLOW",
    "explanation": "(band_(of_frequencies)_(OLD) + fast)  SUPERSEDED SYNONYM  See broadband 25985",
    "isCharacter": false,
    "composition": [
      24750,
      "/",
      15213,
      "/",
      14390,
      "/",
      14947
    ]
  },
  {
    "id": "24615",
    "description": "broadcast,transmit-(to)",
    "pos": "RED",
    "explanation": "(signal + action indicator)",
    "isCharacter": false,
    "composition": [
      24750,
      ";",
      8993
    ]
  },
  {
    "id": "24616",
    "description": "buzzer",
    "pos": "YELLOW",
    "explanation": "(tool + noise)",
    "isCharacter": false,
    "composition": [
      17755,
      "/",
      17216,
      "/",
      14947
    ]
  },
  {
    "id": "24617",
    "description": "cabin_(boat)",
    "pos": "YELLOW",
    "explanation": "(room + boat)",
    "isCharacter": false,
    "composition": [
      16687,
      "/",
      12869
    ]
  },
  {
    "id": "24618",
    "description": "camper_van,RV",
    "pos": "YELLOW",
    "explanation": "(car + house)",
    "isCharacter": false,
    "composition": [
      13121,
      "/",
      14905
    ]
  },
  {
    "id": "24619",
    "description": "canal_(water)",
    "pos": "YELLOW",
    "explanation": "(waterway + man-made)",
    "isCharacter": false,
    "composition": [
      16677,
      "/",
      23583
    ]
  },
  {
    "id": "24620",
    "description": "care_manager,care_plan_manager",
    "pos": "BLUE",
    "explanation": "(leader + help)",
    "isCharacter": false,
    "composition": [
      21054,
      "/",
      "RK:-2",
      "/",
      14704
    ]
  },
  {
    "id": "24621",
    "description": "CD",
    "pos": "YELLOW",
    "explanation": "(disc + file)",
    "isCharacter": false,
    "composition": [
      25601,
      "/",
      23500
    ]
  },
  {
    "id": "24622",
    "description": "channel_(programs)",
    "pos": "YELLOW",
    "explanation": "(signal + choice)",
    "isCharacter": false,
    "composition": [
      24750,
      "/",
      13175
    ]
  },
  {
    "id": "24623",
    "description": "Christmas_song,carol",
    "pos": "YELLOW",
    "explanation": "(song + Christmas [contraction])",
    "isCharacter": false,
    "composition": [
      15666,
      "/",
      15682,
      "/",
      12843,
      "/",
      13613
    ]
  },
  {
    "id": "24624",
    "description": "communication_satellite",
    "pos": "YELLOW",
    "explanation": "(satellite + exchange,substitution: exchange representing communication [contraction])",
    "isCharacter": false,
    "composition": [
      24739,
      "/",
      25555
    ]
  },
  {
    "id": "24625",
    "description": "compartment",
    "pos": "YELLOW",
    "explanation": "(room + train)",
    "isCharacter": false,
    "composition": [
      16687,
      "/",
      14647,
      "/",
      18010
    ]
  },
  {
    "id": "24626",
    "description": "compass",
    "pos": "YELLOW",
    "explanation": "(gauge + north + thing indicator)",
    "isCharacter": false,
    "composition": [
      24806,
      ";",
      9009,
      "/",
      15730
    ]
  },
  {
    "id": "24627",
    "description": "connection_(computer)",
    "pos": "YELLOW",
    "explanation": "(entrance + digits_(computer))",
    "isCharacter": false,
    "composition": [
      14952,
      "/",
      23476
    ]
  },
  {
    "id": "24628",
    "description": "connector,interface_box",
    "pos": "YELLOW",
    "explanation": "(connection + thing indicator)",
    "isCharacter": false,
    "composition": [
      14952,
      ";",
      9009,
      "/",
      23476
    ]
  },
  {
    "id": "24629",
    "description": "corruption_(OLD)",
    "pos": "YELLOW",
    "explanation": "(abuse [contraction] + power,powerfulness_(OLD) [contraction] + selfish)  SUPERSEDED SYNONYM  See corruption 25988",
    "isCharacter": false,
    "composition": [
      22914,
      "/",
      22913,
      "/",
      15213,
      "/",
      24937
    ]
  },
  {
    "id": "24630",
    "description": "crack,gap,cleft",
    "pos": "YELLOW",
    "explanation": "(hole + narrow)",
    "isCharacter": false,
    "composition": [
      14883,
      "/",
      25622
    ]
  },
  {
    "id": "24631",
    "description": "crater",
    "pos": "YELLOW",
    "explanation": "(opening + volcano)",
    "isCharacter": false,
    "composition": [
      15923,
      "/",
      15663,
      "/",
      14183
    ]
  },
  {
    "id": "24632",
    "description": "credit",
    "pos": "YELLOW",
    "explanation": "(money + future: money you pay after time agreed upon)",
    "isCharacter": false,
    "composition": [
      15484,
      "/",
      14417
    ]
  },
  {
    "id": "24633",
    "description": "credit_card",
    "pos": "YELLOW",
    "explanation": "(card + credit)",
    "isCharacter": false,
    "composition": [
      23431,
      "/",
      15484,
      "/",
      14417
    ]
  },
  {
    "id": "24634",
    "description": "crew,staff",
    "pos": "BLUE",
    "explanation": "(group of + worker)",
    "isCharacter": false,
    "composition": [
      14647,
      "/",
      16161,
      "/",
      18273
    ]
  },
  {
    "id": "24635",
    "description": "crew_(boat)",
    "pos": "BLUE",
    "explanation": "(crew,staff + boat)",
    "isCharacter": false,
    "composition": [
      14647,
      "/",
      16161,
      "/",
      18273,
      "/",
      12869
    ]
  },
  {
    "id": "24636",
    "description": "crew_(plane)",
    "pos": "BLUE",
    "explanation": "(crew,staff + airplane)",
    "isCharacter": false,
    "composition": [
      14647,
      "/",
      16161,
      "/",
      18273,
      "/",
      12357
    ]
  },
  {
    "id": "24637",
    "description": "dependent",
    "pos": "GREEN",
    "explanation": "(need + intensity + description indicator)",
    "isCharacter": false,
    "composition": [
      15701,
      ";",
      8998,
      "/",
      14947
    ]
  },
  {
    "id": "24638",
    "description": "digital_device",
    "pos": "YELLOW",
    "explanation": "(enclosure + digits_(computer))  - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "24639",
    "description": "digital_signal",
    "pos": "YELLOW",
    "explanation": "(signal + digits)",
    "isCharacter": false,
    "composition": [
      24750,
      "/",
      23476
    ]
  },
  {
    "id": "24640",
    "description": "digital_memory,digital_storage",
    "pos": "YELLOW",
    "explanation": "(file,data_file_(digital) + future: combination of file and save)",
    "isCharacter": false,
    "composition": [
      23500,
      "/",
      14417
    ]
  },
  {
    "id": "24641",
    "description": "digital_storage_device",
    "pos": "YELLOW",
    "explanation": "(digital device + save)",
    "isCharacter": false,
    "composition": [
      24638,
      "/",
      13403,
      "/",
      14417
    ]
  },
  {
    "id": "24642",
    "description": "dizzy",
    "pos": "GREEN",
    "explanation": "(feeling + rotation + description indicator)",
    "isCharacter": false,
    "composition": [
      14164,
      ";",
      8998,
      "/",
      "RK:-2",
      "/",
      24249
    ]
  },
  {
    "id": "24643",
    "description": "document_(electronic),digital_document",
    "pos": "YELLOW",
    "explanation": "(document [contraction] + digits_(computer))",
    "isCharacter": false,
    "composition": [
      15962,
      "/",
      23476
    ]
  },
  {
    "id": "24644",
    "description": "drop_anchor-(to)",
    "pos": "RED",
    "explanation": "(anchor + action indicator)",
    "isCharacter": false,
    "composition": [
      17717,
      ";",
      8993,
      "/",
      13935,
      "/",
      12869
    ]
  },
  {
    "id": "24645",
    "description": "DVD",
    "pos": "YELLOW",
    "explanation": "(recording_disk + many + file)",
    "isCharacter": false,
    "composition": [
      25601,
      "/",
      14647,
      "/",
      23500
    ]
  },
  {
    "id": "24646",
    "description": "DVD,movie_disc",
    "pos": "YELLOW",
    "explanation": "(recording_disk + eye + ear: a disk for seeing images and film, and listening to sounds and music)",
    "isCharacter": false,
    "composition": [
      25601,
      "/",
      14133,
      "/",
      13894
    ]
  },
  {
    "id": "24647",
    "description": "DVD_player",
    "pos": "YELLOW",
    "explanation": "(machine + DVD,movie_disc)",
    "isCharacter": false,
    "composition": [
      15406,
      "/",
      25601,
      "/",
      14133,
      "/",
      13894
    ]
  },
  {
    "id": "24648",
    "description": "empower-(to)_(OLD)",
    "pos": "RED",
    "explanation": "(empowerment_(OLD) + action indicator)  SUPERSEDED SYNONYM  See empower-(to) 25997",
    "isCharacter": false,
    "composition": [
      24903,
      ";",
      8993,
      "/",
      22913,
      "/",
      15213
    ]
  },
  {
    "id": "24649",
    "description": "empowered_(OLD)",
    "pos": "GREEN",
    "explanation": "(empowerment_(OLD) + description indicator)  SUPERSEDED SYNONYM  See empowered 25998",
    "isCharacter": false,
    "composition": [
      24903,
      ";",
      8998,
      "/",
      22913,
      "/",
      15213
    ]
  },
  {
    "id": "24650",
    "description": "empowerment_(OLD)",
    "pos": "YELLOW",
    "explanation": "(give + power,powerfulness_(OLD) [contraction])  SUPERSEDED SYNONYM  See empowerment 25999",
    "isCharacter": false,
    "composition": [
      24903,
      "/",
      22913,
      "/",
      15213
    ]
  },
  {
    "id": "24651",
    "description": "erupt-(to)",
    "pos": "RED",
    "explanation": "(eruption + action indicator)",
    "isCharacter": false,
    "composition": [
      17255,
      ";",
      8993,
      "/",
      "RK:-2",
      "/",
      15663,
      "/",
      14183
    ]
  },
  {
    "id": "24652",
    "description": "eruption",
    "pos": "YELLOW",
    "explanation": "(steam + volcano)",
    "isCharacter": false,
    "composition": [
      17255,
      "/",
      "RK:-2",
      "/",
      15663,
      "/",
      14183
    ]
  },
  {
    "id": "24653",
    "description": "exchanger",
    "pos": "YELLOW",
    "explanation": "(exchange + thing indicator)  - (character with thing indicator)  To be used with specifiers, e.g., heat exchanger, air exchanger, etc.",
    "isCharacter": "false",
    "composition": [
      25555,
      ";",
      9009
    ]
  },
  {
    "id": "24654",
    "description": "external_hard_drive",
    "pos": "YELLOW",
    "explanation": "(digital storage device + big)",
    "isCharacter": false,
    "composition": [
      24638,
      "/",
      13403,
      "/",
      14417,
      "/",
      24875
    ]
  },
  {
    "id": "24655",
    "description": "firework",
    "pos": "YELLOW",
    "explanation": "(explosion + many + colour)",
    "isCharacter": false,
    "composition": [
      14132,
      "/",
      14647,
      "/",
      13377
    ]
  },
  {
    "id": "24656",
    "description": "fish_cage",
    "pos": "YELLOW",
    "explanation": "(cage + fish)",
    "isCharacter": false,
    "composition": [
      13934,
      "/",
      18257,
      "/",
      14188
    ]
  },
  {
    "id": "24657",
    "description": "French_fries,chips",
    "pos": "YELLOW",
    "explanation": "(potato [contraction] + linear thing + oil + thing indicator)  Preferred NEW SYNONYM, replacing 14398",
    "isCharacter": false,
    "composition": [
      18005,
      "/",
      15214,
      ";",
      9009,
      "/",
      15914
    ]
  },
  {
    "id": "24658",
    "description": "galley_(boat)",
    "pos": "YELLOW",
    "explanation": "(kitchen + boat)",
    "isCharacter": false,
    "composition": [
      16687,
      "/",
      23583,
      "/",
      14377,
      "/",
      12869
    ]
  },
  {
    "id": "24659",
    "description": "game_box",
    "pos": "YELLOW",
    "explanation": "(digital device + game [contraction])",
    "isCharacter": false,
    "composition": [
      24638,
      "/",
      12335,
      "/",
      "RK:-2",
      "/",
      14164
    ]
  },
  {
    "id": "24660",
    "description": "GPS,satnav",
    "pos": "YELLOW",
    "explanation": "(digital device + communication satellite + place)",
    "isCharacter": false,
    "composition": [
      24638,
      "/",
      24739,
      "/",
      25555,
      "/",
      16193
    ]
  },
  {
    "id": "24661",
    "description": "GPS_(system)",
    "pos": "YELLOW",
    "explanation": "(group of + communication satellite + place)",
    "isCharacter": false,
    "composition": [
      14647,
      "/",
      24739,
      "/",
      25555,
      "/",
      16193
    ]
  },
  {
    "id": "24662",
    "description": "hammock",
    "pos": "YELLOW",
    "explanation": "(swing + cloth + lie down + thing indicator)",
    "isCharacter": false,
    "composition": [
      25406,
      ";",
      9009,
      "/",
      13365,
      "/",
      16163
    ]
  },
  {
    "id": "24663",
    "description": "hard_rock",
    "pos": "YELLOW",
    "explanation": "(music + up and down + intensity)",
    "isCharacter": false,
    "composition": [
      13894,
      "/",
      15682,
      "/",
      20524,
      "/",
      14947
    ]
  },
  {
    "id": "24664",
    "description": "I_need_more_time,give_me_time",
    "pos": "WHITE",
    "explanation": "(need + time + action indicator)",
    "isCharacter": false,
    "composition": [
      15701,
      ";",
      8993,
      "/",
      17732
    ]
  },
  {
    "id": "24665",
    "description": "indicator_(adverb)",
    "pos": "GRAY",
    "explanation": "(indicator_(description) + indicator_(action): may be placed above a symbol to show that it is representing an adverb in a natural language.)  Used restrictively, primarily for language teaching purposes.  - Character (superimposed - indicator)",
    "isCharacter": true
  },
  {
    "id": "24667",
    "description": "indicator_(definite_form)",
    "pos": "GRAY",
    "explanation": "(the [quarter-sized]: may be placed above a symbol to show that it is representing a noun or other word in definite form in a natural language.)  Used restrictively, primarily for language teaching purposes.  - Character (indicator)",
    "isCharacter": true
  },
  {
    "id": "24668",
    "description": "indicator_(female)_OLD",
    "pos": "GRAY",
    "explanation": "(female_(gender) [quarter-sized]: may be placed above a symbol to show that it is representing a word in feminine form in a natural language (male = unmarked).) Used restrictively, primarily for language teaching purposes.  - Character (indicator)",
    "isCharacter": true
  },
  {
    "id": "24669",
    "description": "indicator_(first_person)_OLD",
    "pos": "GRAY",
    "explanation": "(one_(digit) [quarter-sized]: may be placed above a symbol to show that it is representing a verb or other word in first person form in a natural language.)  Used restrictively, primarily for language teaching purposes.  - Character (indicator)",
    "isCharacter": true
  },
  {
    "id": "24670",
    "description": "indicator_(imperative_form)",
    "pos": "GRAY",
    "explanation": "(exclamation mark [quarter-sized]: may be placed above a symbol to show that it is representing a verb in imperative form in a natural language.)  Used restrictively, primarily for language teaching purposes.  - Character (indicator)",
    "isCharacter": true
  },
  {
    "id": "24671",
    "description": "indicator_(indefinite_form)_OLD",
    "pos": "GRAY",
    "explanation": "(a,an,any [quarter-sized]: may be placed above a symbol to show that it is representing a noun or other word in indefinite form in a natural language.)  Used restrictively, primarily for language teaching purposes.  - Character (indicator)",
    "isCharacter": true
  },
  {
    "id": "24672",
    "description": "indicator_(neutral)_OLD",
    "pos": "GRAY",
    "explanation": "(vertical line [quarter-sized]: may be placed above a symbol to show that it is representing a word in neutral form in a natural language.)  Used restrictively, primarily for language teaching purposes.  - Character (indicator)",
    "isCharacter": true
  },
  {
    "id": "24673",
    "description": "indicator_(object_form)_OLD",
    "pos": "GRAY",
    "explanation": "(to,toward,towards [quarter-sized]: may be placed above a symbol to show that it is representing a word in object form in a natural language.)  Used restrictively, primarily for language teaching purposes.  - Character (indicator)",
    "isCharacter": true
  },
  {
    "id": "24674",
    "description": "indicator_(past_participle_1)",
    "pos": "GRAY",
    "explanation": "(indicator_(past_action) + indicator_(description): may be placed above a symbol to show that it is representing a verb in past participle form in a natural language.)  Used restrictively, primarily for language teaching purposes.  - Character (superimposed - indicator)",
    "isCharacter": true
  },
  {
    "id": "24675",
    "description": "indicator_(past_participle_2)",
    "pos": "GRAY",
    "explanation": "(indicator_(past_action) + dot: may be placed above a symbol to show that it is representing a verb in past participle form in a natural language.)  Used restrictively, primarily for language teaching purposes.  - Character (superimposed - indicator)",
    "isCharacter": true
  },
  {
    "id": "24676",
    "description": "indicator_(possessive_form)_OLD",
    "pos": "GRAY",
    "explanation": "(plus [quarter-sized]: may be placed above a symbol to show that it is representing a word in possessive form in a natural language.)  Used restrictively, primarily for language teaching purposes.  - Character (indicator)",
    "isCharacter": true
  },
  {
    "id": "24677",
    "description": "indicator_(present_participle)",
    "pos": "GRAY",
    "explanation": "(indicator_(present_action) + indicator_(description): may be placed above a symbol to show that it is representing a verb in present participle form in a natural language.)  Used restrictively, primarily for language teaching purposes.  - Character (superimposed - indicator)",
    "isCharacter": true
  },
  {
    "id": "24678",
    "description": "indicator_(second_person)_OLD",
    "pos": "GRAY",
    "explanation": "(two_(digit) [quarter-sized]: may be placed above a symbol to show that it is representing a verb or other word in second person form in a natural language.)  Used restrictively, primarily for language teaching purposes.  - Character (indicator)",
    "isCharacter": true
  },
  {
    "id": "24679",
    "description": "indicator_(third_person)_OLD",
    "pos": "GRAY",
    "explanation": "(three_(digit) [quarter-sized]: may be placed above a symbol to show that it is representing a verb or other word in third person form in a natural language.)  Used restrictively, primarily for language teaching purposes.  - Character (indicator)",
    "isCharacter": true
  },
  {
    "id": "24680",
    "description": "inflammable,flammable",
    "pos": "GREEN",
    "explanation": "(fire + intensity + description before the fact indicator)",
    "isCharacter": false,
    "composition": [
      14183,
      ";",
      8997,
      "/",
      14947
    ]
  },
  {
    "id": "24681",
    "description": "invoice",
    "pos": "YELLOW",
    "explanation": "(paper + before + money)",
    "isCharacter": false,
    "composition": [
      15962,
      "/",
      12656,
      "/",
      15484
    ]
  },
  {
    "id": "24682",
    "description": "jackfruit",
    "pos": "YELLOW",
    "explanation": "(fruit + heavy)",
    "isCharacter": false,
    "composition": [
      14405,
      "/",
      18221,
      "/",
      13869
    ]
  },
  {
    "id": "24683",
    "description": "janitor,caretaker",
    "pos": "BLUE",
    "explanation": "(person + help + house)",
    "isCharacter": false,
    "composition": [
      16161,
      "/",
      14704,
      "/",
      14905
    ]
  },
  {
    "id": "24684",
    "description": "lava,magma",
    "pos": "YELLOW",
    "explanation": "(liquid + volcano)",
    "isCharacter": false,
    "composition": [
      18209,
      "/",
      "RK:-2",
      "/",
      15663,
      "/",
      14183
    ]
  },
  {
    "id": "24685",
    "description": "lee,shelter",
    "pos": "YELLOW",
    "explanation": "(place + without + wind)",
    "isCharacter": false,
    "composition": [
      16193,
      "/",
      15474,
      "/",
      18255
    ]
  },
  {
    "id": "24686",
    "description": "let_fall,drop-(to)",
    "pos": "RED",
    "explanation": "(hand + fall-(to) + action indicator)",
    "isCharacter": false,
    "composition": [
      14667,
      ";",
      8993,
      "/",
      13869,
      "/",
      14947
    ]
  },
  {
    "id": "24687",
    "description": "life-jacket",
    "pos": "YELLOW",
    "explanation": "(clothes + float-(to))",
    "isCharacter": false,
    "composition": [
      13366,
      "/",
      25562
    ]
  },
  {
    "id": "24688",
    "description": "lower-(to)",
    "pos": "RED",
    "explanation": "(activity + down + action indicator)",
    "isCharacter": false,
    "composition": [
      12335,
      ";",
      8993,
      "/",
      13869
    ]
  },
  {
    "id": "24689",
    "description": "lullaby",
    "pos": "YELLOW",
    "explanation": "(song + sleep)",
    "isCharacter": false,
    "composition": [
      15666,
      "/",
      15682,
      "/",
      17008
    ]
  },
  {
    "id": "24690",
    "description": "lunar_eclipse",
    "pos": "YELLOW",
    "explanation": "(moon + behind + earth)",
    "isCharacter": false,
    "composition": [
      15651,
      "/",
      12348,
      "/",
      13900
    ]
  },
  {
    "id": "24691",
    "description": "media_player",
    "pos": "YELLOW",
    "explanation": "(digital device + eye + ear)",
    "isCharacter": false,
    "composition": [
      24638,
      "/",
      14133,
      "/",
      13894
    ]
  },
  {
    "id": "24692",
    "description": "member",
    "pos": "BLUE",
    "explanation": "(person + belong to + group)",
    "isCharacter": false,
    "composition": [
      16161,
      "/",
      12663,
      "/",
      14647,
      "/",
      16161
    ]
  },
  {
    "id": "24693",
    "description": "memo,reminder_note",
    "pos": "YELLOW",
    "explanation": "(paper + memory)",
    "isCharacter": false,
    "composition": [
      15962,
      "/",
      23589
    ]
  },
  {
    "id": "24694",
    "description": "memory_stick,USB-memory",
    "pos": "YELLOW",
    "explanation": "(digital storage device + small)",
    "isCharacter": false,
    "composition": [
      24638,
      "/",
      13403,
      "/",
      14417,
      "/",
      24917
    ]
  },
  {
    "id": "24695",
    "description": "metal_(music)",
    "pos": "YELLOW",
    "explanation": "(rock_music + metal [contraction])",
    "isCharacter": false,
    "composition": [
      13894,
      "/",
      15682,
      "/",
      20524,
      "/",
      23150
    ]
  },
  {
    "id": "24696",
    "description": "minutes",
    "pos": "YELLOW",
    "explanation": "(document [contraction] + after + gathering)",
    "isCharacter": false,
    "composition": [
      15962,
      "/",
      12348,
      "/",
      14427
    ]
  },
  {
    "id": "24697",
    "description": "misuse",
    "pos": "YELLOW",
    "explanation": "(use + wrong)",
    "isCharacter": false,
    "composition": [
      24847,
      "/",
      25539,
      "/",
      14947
    ]
  },
  {
    "id": "24698",
    "description": "misuse-(to)",
    "pos": "RED",
    "explanation": "(misuse + action indicator)",
    "isCharacter": false,
    "composition": [
      24847,
      ";",
      8993,
      "/",
      25539,
      "/",
      14947
    ]
  },
  {
    "id": "24699",
    "description": "MMS",
    "pos": "YELLOW",
    "explanation": "(picture + telephone)",
    "isCharacter": false,
    "composition": [
      14133,
      "/",
      13934,
      "/",
      15172,
      "/",
      13918
    ]
  },
  {
    "id": "24700",
    "description": "monument,commemorative_work",
    "pos": "YELLOW",
    "explanation": "(work_of_art,art_object + memory + thing indicator)",
    "isCharacter": false,
    "composition": [
      23583,
      ";",
      9009,
      "/",
      "RK:-2",
      "/",
      14164,
      "/",
      23589
    ]
  },
  {
    "id": "24701",
    "description": "move_(change_position)-(to)",
    "pos": "RED",
    "explanation": "(movement,motion_(2) + action indicator)",
    "isCharacter": false,
    "composition": [
      12335,
      ";",
      8993,
      "/",
      12610
    ]
  },
  {
    "id": "24702",
    "description": "movement,motion_(1)",
    "pos": "YELLOW",
    "explanation": "(generalization + back and forth)",
    "isCharacter": false,
    "composition": [
      14430,
      "/",
      12610
    ]
  },
  {
    "id": "24703",
    "description": "movement,motion_(2)",
    "pos": "YELLOW",
    "explanation": "(activity + back and forth)",
    "isCharacter": false,
    "composition": [
      12335,
      "/",
      12610
    ]
  },
  {
    "id": "24704",
    "description": "navigational_sign",
    "pos": "YELLOW",
    "explanation": "(sign + boat)",
    "isCharacter": false,
    "composition": [
      17717,
      "/",
      23542,
      "/",
      12869
    ]
  },
  {
    "id": "24705",
    "description": "oats",
    "pos": "YELLOW",
    "explanation": "(grain + bits: grain gathered in a cluster)",
    "isCharacter": false,
    "composition": [
      14625,
      "/",
      22362
    ]
  },
  {
    "id": "24706",
    "description": "okra,lady's_finger",
    "pos": "YELLOW",
    "explanation": "(fruit_(pointed) + soft)",
    "isCharacter": false,
    "composition": [
      25567,
      "/",
      14667,
      "/",
      25575
    ]
  },
  {
    "id": "24707",
    "description": "overspend,buy_over_budget-(to)",
    "pos": "RED",
    "explanation": "(money (buy [contraction]) + over + economy + action indicator)",
    "isCharacter": false,
    "composition": [
      15484,
      ";",
      8993,
      "/",
      15948,
      "/",
      13093
    ]
  },
  {
    "id": "24708",
    "description": "pay_channel",
    "pos": "YELLOW",
    "explanation": "(channel_(programs) + money)",
    "isCharacter": false,
    "composition": [
      24750,
      "/",
      13175,
      "/",
      15484
    ]
  },
  {
    "id": "24709",
    "description": "pick-(to)",
    "pos": "RED",
    "explanation": "(finger + to get + action indicator)",
    "isCharacter": false,
    "composition": [
      14180,
      ";",
      8993,
      "/",
      24727
    ]
  },
  {
    "id": "24710",
    "description": "plug_in,connect_(digital)-(to)",
    "pos": "RED",
    "explanation": "(connection_(computer) + action indicator)",
    "isCharacter": false,
    "composition": [
      14952,
      ";",
      8993,
      "/",
      23476
    ]
  },
  {
    "id": "24711",
    "description": "plug_in,connect_(power)-(to)",
    "pos": "RED",
    "explanation": "(plug [modification] + action indicator)",
    "isCharacter": false,
    "composition": [
      14952,
      ";",
      8993,
      "/",
      13918
    ]
  },
  {
    "id": "24712",
    "description": "port_(boat)",
    "pos": "YELLOW",
    "explanation": "(left_turn,left_(position_or_direction) + boat)",
    "isCharacter": false,
    "composition": [
      25577,
      "/",
      12869
    ]
  },
  {
    "id": "24713",
    "description": "port_(device)",
    "pos": "YELLOW",
    "explanation": "(opening + connection_(computer))",
    "isCharacter": false,
    "composition": [
      15923,
      "/",
      14952,
      "/",
      23476
    ]
  },
  {
    "id": "24714",
    "description": "portability",
    "pos": "YELLOW",
    "explanation": "(container + forward [modification, short arrow])  - Character (superimposed - modified)",
    "isCharacter": true
  },
  {
    "id": "24715",
    "description": "portable",
    "pos": "GREEN",
    "explanation": "(portability + action indicator)",
    "isCharacter": false,
    "composition": [
      24714,
      ";",
      8998
    ]
  },
  {
    "id": "24716",
    "description": "potato_chip(s),chip(s),crisp(s)",
    "pos": "YELLOW",
    "explanation": "(vegetable_(below_ground) (potato [contraction]) + disc)  Preferred NEW SYNONYM, replacing 16231",
    "isCharacter": false,
    "composition": [
      18005,
      "/",
      13685
    ]
  },
  {
    "id": "24717",
    "description": "potty,chamber_pot,bedpan",
    "pos": "YELLOW",
    "explanation": "(container + pictograph of a handle)  - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "24718",
    "description": "power,powerfulness_(OLD)",
    "pos": "YELLOW",
    "explanation": "(ability + control_(OLD))  SUPERSEDED SYNONYM  See power,powerfulness 26022",
    "isCharacter": false,
    "composition": [
      12322,
      "/",
      22913,
      "/",
      15213
    ]
  },
  {
    "id": "24719",
    "description": "powerful,mighty_(OLD)",
    "pos": "GREEN",
    "explanation": "(power,powerfulness_(OLD) + description indicator)  SUPERSEDED SYNONYM  See powerful,mighty 26023",
    "isCharacter": false,
    "composition": [
      12322,
      ";",
      8998,
      "/",
      22913,
      "/",
      15213
    ]
  },
  {
    "id": "24720",
    "description": "quality",
    "pos": "YELLOW",
    "explanation": "(evaluation,value + type,kind,sort,category)",
    "isCharacter": false,
    "composition": [
      13949,
      "/",
      17961
    ]
  },
  {
    "id": "24721",
    "description": "quality_(measurement)",
    "pos": "YELLOW",
    "explanation": "(measurement + quality)",
    "isCharacter": false,
    "composition": [
      15443,
      "/",
      13949,
      "/",
      17961
    ]
  },
  {
    "id": "24722",
    "description": "quantity_(measurement)",
    "pos": "YELLOW",
    "explanation": "(measurement + multitude)",
    "isCharacter": false,
    "composition": [
      15443,
      "/",
      15673,
      ";",
      9009
    ]
  },
  {
    "id": "24723",
    "description": "raise-(to)",
    "pos": "RED",
    "explanation": "(activity + up + action indicator)",
    "isCharacter": false,
    "composition": [
      12335,
      ";",
      8993,
      "/",
      17983
    ]
  },
  {
    "id": "24724",
    "description": "receipt",
    "pos": "YELLOW",
    "explanation": "(paper + after + money)",
    "isCharacter": false,
    "composition": [
      15962,
      "/",
      12348,
      "/",
      15484
    ]
  },
  {
    "id": "24725",
    "description": "receiver",
    "pos": "YELLOW",
    "explanation": "(receiving + thing indicator)  - (character with thing indicator)",
    "isCharacter": "false",
    "composition": [
      24727,
      ";",
      9009
    ]
  },
  {
    "id": "24726",
    "description": "receiver,dish",
    "pos": "YELLOW",
    "explanation": "(pictograph)  - Character",
    "isCharacter": true
  },
  {
    "id": "24727",
    "description": "acquiring,getting,receiving",
    "pos": "YELLOW",
    "explanation": "(down + container: drawing into what one holds)  - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "24728",
    "description": "reef-(to)",
    "pos": "RED",
    "explanation": "(decrease,reduce-(to) + sail + action indicator)",
    "isCharacter": false,
    "composition": [
      24917,
      ";",
      8993,
      "/",
      20519
    ]
  },
  {
    "id": "24729",
    "description": "rein",
    "pos": "YELLOW",
    "explanation": "(linear thing + leadership,guidance + horse + thing indicator)",
    "isCharacter": false,
    "composition": [
      15214,
      ";",
      9009,
      "/",
      22913,
      "/",
      14897
    ]
  },
  {
    "id": "24730",
    "description": "remote_control",
    "pos": "YELLOW",
    "explanation": "(tool + channel_(programs))",
    "isCharacter": false,
    "composition": [
      17755,
      "/",
      24750,
      "/",
      13175
    ]
  },
  {
    "id": "24731",
    "description": "rent",
    "pos": "YELLOW",
    "explanation": "(cost,price + limited time)",
    "isCharacter": false,
    "composition": [
      15484,
      "/",
      14381,
      "/",
      17717,
      "/",
      15212
    ]
  },
  {
    "id": "24732",
    "description": "rent,lease,let-(to)",
    "pos": "RED",
    "explanation": "(pay,spend-(to) + limited time + action indicator)",
    "isCharacter": false,
    "composition": [
      24727,
      ";",
      8993,
      "/",
      15484,
      "/",
      15212
    ]
  },
  {
    "id": "24733",
    "description": "rent,lease,hire,charter-(to)",
    "pos": "RED",
    "explanation": "(get,acquire,receive-(to) + money + limited time + action indicator)",
    "isCharacter": false,
    "composition": [
      24903,
      ";",
      8993,
      "/",
      15484,
      "/",
      15212
    ]
  },
  {
    "id": "24734",
    "description": "respiratory_illness",
    "pos": "YELLOW",
    "explanation": "(illness + breathe-(to))",
    "isCharacter": false,
    "composition": [
      16164,
      "/",
      15732,
      "/",
      15666
    ]
  },
  {
    "id": "24735",
    "description": "road_sign,traffic_signal",
    "pos": "YELLOW",
    "explanation": "(sign + vehicle)",
    "isCharacter": false,
    "composition": [
      17717,
      "/",
      23542,
      "/",
      18010
    ]
  },
  {
    "id": "24736",
    "description": "rock_music,rock'n'roll,rock",
    "pos": "YELLOW",
    "explanation": "(music + up and down)",
    "isCharacter": false,
    "composition": [
      13894,
      "/",
      15682,
      "/",
      20524
    ]
  },
  {
    "id": "24737",
    "description": "rough_sea",
    "pos": "YELLOW",
    "explanation": "(much,many,very + wave)",
    "isCharacter": false,
    "composition": [
      14647,
      "/",
      21880
    ]
  },
  {
    "id": "24738",
    "description": "rye",
    "pos": "YELLOW",
    "explanation": "(grain + linear thing + small + thing indicator: ear of grain with short tassels)",
    "isCharacter": false,
    "composition": [
      14625,
      "/",
      15214,
      ";",
      9009,
      "/",
      24917
    ]
  },
  {
    "id": "24739",
    "description": "satellite",
    "pos": "YELLOW",
    "explanation": "(planet [half-sized])  - Character",
    "isCharacter": true
  },
  {
    "id": "24740",
    "description": "satellite_dish_(1)",
    "pos": "YELLOW",
    "explanation": "(signal_receiver_(1) + communication satellite)  SYMBOL SYNONYM",
    "isCharacter": false,
    "composition": [
      24727,
      ";",
      9009,
      "/",
      24739,
      "/",
      25555
    ]
  },
  {
    "id": "24741",
    "description": "satellite_dish_(2)",
    "pos": "YELLOW",
    "explanation": "(signal_receiver_(2) + communication satellite)  SYMBOL SYNONYM",
    "isCharacter": false,
    "composition": [
      24726,
      "/",
      24739,
      "/",
      25555
    ]
  },
  {
    "id": "24742",
    "description": "satellite_signal",
    "pos": "YELLOW",
    "explanation": "(signal,broadcast,transmitting + satellite)",
    "isCharacter": false,
    "composition": [
      24750,
      "/",
      24739
    ]
  },
  {
    "id": "24743",
    "description": "school_uniform",
    "pos": "YELLOW",
    "explanation": "(clothes + school [contraction])",
    "isCharacter": false,
    "composition": [
      13366,
      "/",
      14905,
      "/",
      15162
    ]
  },
  {
    "id": "24744",
    "description": "sea_captain,skipper",
    "pos": "YELLOW",
    "explanation": "(leader + boat)",
    "isCharacter": false,
    "composition": [
      21054,
      "/",
      12869
    ]
  },
  {
    "id": "24745",
    "description": "sea_chart",
    "pos": "YELLOW",
    "explanation": "(paper + water_(ground_level) (sea [contraction]))",
    "isCharacter": false,
    "composition": [
      15962,
      "/",
      25777
    ]
  },
  {
    "id": "24746",
    "description": "shadow,shade",
    "pos": "YELLOW",
    "explanation": "(shape + without + light)",
    "isCharacter": false,
    "composition": [
      14133,
      "/",
      17717,
      "/",
      15474,
      "/",
      15208
    ]
  },
  {
    "id": "24747",
    "description": "shipping_forecast",
    "pos": "YELLOW",
    "explanation": "(weather forecast + water_(ground_level) (sea [contraction]))",
    "isCharacter": false,
    "composition": [
      15666,
      "/",
      14417,
      "/",
      18214,
      "/",
      25777
    ]
  },
  {
    "id": "24748",
    "description": "shower_chair",
    "pos": "YELLOW",
    "explanation": "(chair + shower)",
    "isCharacter": false,
    "composition": [
      13148,
      "/",
      16968
    ]
  },
  {
    "id": "24749",
    "description": "sign,signal",
    "pos": "YELLOW",
    "explanation": "(thing + information)  Preferred NEW SYNONYM, replacing 16978",
    "isCharacter": false,
    "composition": [
      17717,
      "/",
      23542
    ]
  },
  {
    "id": "24750",
    "description": "signal,broadcast,transmitting",
    "pos": "YELLOW",
    "explanation": "(pictograph: as of waves spreading in water)  - Character",
    "isCharacter": true
  },
  {
    "id": "24751",
    "description": "signal_receiver_(1)",
    "pos": "YELLOW",
    "explanation": "(signal reception + thing indicator)  SYMBOL SYNONYM",
    "isCharacter": false,
    "composition": [
      24727,
      ";",
      9009,
      "/",
      24750
    ]
  },
  {
    "id": "24752",
    "description": "signal_receiver_(2)",
    "pos": "YELLOW",
    "explanation": "(receiver,dish + signal)  SYMBOL SYNONYM",
    "isCharacter": false,
    "composition": [
      24726,
      "/",
      24750
    ]
  },
  {
    "id": "24753",
    "description": "signal_reception",
    "pos": "YELLOW",
    "explanation": "(to get + signal,broadcast,transmitting)",
    "isCharacter": false,
    "composition": [
      24727,
      "/",
      24750
    ]
  },
  {
    "id": "24754",
    "description": "singalong",
    "pos": "YELLOW",
    "explanation": "(activity + song + all)",
    "isCharacter": false,
    "composition": [
      12335,
      "/",
      15666,
      "/",
      15682,
      "/",
      12360
    ]
  },
  {
    "id": "24755",
    "description": "solar_eclipse",
    "pos": "YELLOW",
    "explanation": "(sun + behind + moon)",
    "isCharacter": false,
    "composition": [
      17462,
      "/",
      12348,
      "/",
      15651
    ]
  },
  {
    "id": "24756",
    "description": "speech",
    "pos": "YELLOW",
    "explanation": "(activity + mouth)",
    "isCharacter": false,
    "composition": [
      12335,
      "/",
      15666
    ]
  },
  {
    "id": "24757",
    "description": "spending_spree",
    "pos": "YELLOW",
    "explanation": "(to buy + intensity)",
    "isCharacter": false,
    "composition": [
      15484,
      "/",
      17717,
      "/",
      14947
    ]
  },
  {
    "id": "24758",
    "description": "splurge-(to)",
    "pos": "RED",
    "explanation": "(spending + action indicator)",
    "isCharacter": false,
    "composition": [
      15484,
      ";",
      8993,
      "/",
      17717,
      "/",
      14947
    ]
  },
  {
    "id": "24759",
    "description": "stand-in,substitute,alternate",
    "pos": "YELLOW",
    "explanation": "(person + activity + another)",
    "isCharacter": false,
    "composition": [
      16161,
      "/",
      12335,
      "/",
      15214,
      "/",
      8498
    ]
  },
  {
    "id": "24760",
    "description": "starboard",
    "pos": "YELLOW",
    "explanation": "(right_turn,right_(position_or_direction) + boat)",
    "isCharacter": false,
    "composition": [
      25604,
      "/",
      12869
    ]
  },
  {
    "id": "24761",
    "description": "step,stair",
    "pos": "YELLOW",
    "explanation": "(stairs + pointer, to step)  - Character (superimposed - pointer)",
    "isCharacter": true
  },
  {
    "id": "24762",
    "description": "stranger,unknown_(person)",
    "pos": "BLUE",
    "explanation": "(person + unknown)",
    "isCharacter": false,
    "composition": [
      16161,
      "/",
      21297
    ]
  },
  {
    "id": "24763",
    "description": "submerged_rock,reef",
    "pos": "YELLOW",
    "explanation": "(rock + under + water_(ground_level) (sea [contraction]))",
    "isCharacter": false,
    "composition": [
      17267,
      "/",
      17969,
      "/",
      25777
    ]
  },
  {
    "id": "24764",
    "description": "sun_lounger,deck_chair",
    "pos": "YELLOW",
    "explanation": "(sofa + sun)",
    "isCharacter": false,
    "composition": [
      13419,
      "/",
      17462
    ]
  },
  {
    "id": "24765",
    "description": "sunbathe-(to)",
    "pos": "RED",
    "explanation": "(to rest + sun + action indicator)",
    "isCharacter": false,
    "composition": [
      16495,
      ";",
      8993,
      "/",
      17462
    ]
  },
  {
    "id": "24766",
    "description": "sunburn",
    "pos": "YELLOW",
    "explanation": "(suntan + intensity)",
    "isCharacter": false,
    "composition": [
      13377,
      "/",
      13910,
      "/",
      17462,
      "/",
      14947
    ]
  },
  {
    "id": "24767",
    "description": "sunglasses",
    "pos": "YELLOW",
    "explanation": "(glasses + sun)",
    "isCharacter": false,
    "composition": [
      14443,
      "/",
      17462
    ]
  },
  {
    "id": "24768",
    "description": "suntan",
    "pos": "YELLOW",
    "explanation": "(colour + effect + sun)",
    "isCharacter": false,
    "composition": [
      13377,
      "/",
      13910,
      "/",
      17462
    ]
  },
  {
    "id": "24769",
    "description": "Take_your_time!",
    "pos": "WHITE",
    "explanation": "(use + time + action indicator)",
    "isCharacter": false,
    "composition": [
      24847,
      ";",
      8993,
      "/",
      17732
    ]
  },
  {
    "id": "24770",
    "description": "toilet_chair,commode_chair",
    "pos": "YELLOW",
    "explanation": "(chair + toilet)",
    "isCharacter": false,
    "composition": [
      13148,
      "/",
      17747
    ]
  },
  {
    "id": "24771",
    "description": "tourist",
    "pos": "BLUE",
    "explanation": "(visitor + place)",
    "isCharacter": false,
    "composition": [
      16161,
      "/",
      24859,
      "/",
      16193
    ]
  },
  {
    "id": "24772",
    "description": "tourist_(foreign)",
    "pos": "BLUE",
    "explanation": "(visitor + country)",
    "isCharacter": false,
    "composition": [
      16161,
      "/",
      24859,
      "/",
      13423
    ]
  },
  {
    "id": "24773",
    "description": "TV_programme,TV_show,radio_programme",
    "pos": "YELLOW",
    "explanation": "(part of + channel)",
    "isCharacter": false,
    "composition": [
      15972,
      "/",
      24750,
      "/",
      13175
    ]
  },
  {
    "id": "24774",
    "description": "TV_studio,radio_studio",
    "pos": "YELLOW",
    "explanation": "(place + signal,broadcast,transmitting)",
    "isCharacter": false,
    "composition": [
      16193,
      "/",
      24750
    ]
  },
  {
    "id": "24775",
    "description": "urine_bottle",
    "pos": "YELLOW",
    "explanation": "(bottle + urine)",
    "isCharacter": false,
    "composition": [
      12880,
      "/",
      18043,
      "/",
      14431
    ]
  },
  {
    "id": "24776",
    "description": "USA",
    "pos": "YELLOW",
    "explanation": "(country + star + stripe)",
    "isCharacter": false,
    "composition": [
      13423,
      "/",
      17252,
      "/",
      15214
    ]
  },
  {
    "id": "24777",
    "description": "waiter,waitress",
    "pos": "BLUE",
    "explanation": "(person + bring + food)",
    "isCharacter": false,
    "composition": [
      16161,
      "/",
      24714,
      "/",
      14377
    ]
  },
  {
    "id": "24778",
    "description": "water_flower,water_lily",
    "pos": "YELLOW",
    "explanation": "(flower + water)  - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "24779",
    "description": "weather_satellite,spy_satellite",
    "pos": "YELLOW",
    "explanation": "(communication satellite + camera)",
    "isCharacter": false,
    "composition": [
      24739,
      "/",
      25555,
      "/",
      13111
    ]
  },
  {
    "id": "24780",
    "description": "wheat",
    "pos": "YELLOW",
    "explanation": "(grain + without + linear thing + thing indicator: ear of grain without tassels)",
    "isCharacter": false,
    "composition": [
      14625,
      "/",
      15474,
      "/",
      15214,
      ";",
      9009
    ]
  },
  {
    "id": "24781",
    "description": "video_phone",
    "pos": "YELLOW",
    "explanation": "(telephone + camera)",
    "isCharacter": false,
    "composition": [
      15172,
      "/",
      13918,
      "/",
      13111
    ]
  },
  {
    "id": "24782",
    "description": "wireless_connection,WIFI_(OLD)",
    "pos": "YELLOW",
    "explanation": "(digital signal + without + linear thing (wire,cable [contraction)] + thing indicator)",
    "isCharacter": false,
    "composition": [
      24750,
      "/",
      23476,
      "/",
      15474,
      "/",
      15214,
      ";",
      9009
    ]
  },
  {
    "id": "24801",
    "description": "bear's_head",
    "pos": "YELLOW",
    "explanation": "(pictograph: of a bear's head)  - Character",
    "isCharacter": true
  },
  {
    "id": "24802",
    "description": "bell,chime_bar",
    "pos": "YELLOW",
    "explanation": "(musical instrument + 1 + musical note)",
    "isCharacter": false,
    "composition": [
      23904,
      "/",
      8497,
      "/",
      15682
    ]
  },
  {
    "id": "24803",
    "description": "man-made_item,artefact,artifact,product",
    "pos": "YELLOW",
    "explanation": "(making,production,fashioning + thing indicator)  - (character with thing indicator)",
    "isCharacter": "false",
    "composition": [
      23583,
      ";",
      9009
    ]
  },
  {
    "id": "24804",
    "description": "eagerness,keenness,willingness",
    "pos": "YELLOW",
    "explanation": "(feeling + intensity)",
    "isCharacter": false,
    "composition": [
      14164,
      "/",
      14947
    ]
  },
  {
    "id": "24805",
    "description": "jump_(backward)",
    "pos": "YELLOW",
    "explanation": "(curved arrow, backward, indicating the path of a backward jump)  - Character",
    "isCharacter": true
  },
  {
    "id": "24806",
    "description": "scale,measurement",
    "pos": "YELLOW",
    "explanation": "(height,tallness + lowness,shortness_(height): combination of high,tall and short )  - Character (superimposed - combined)",
    "isCharacter": true
  },
  {
    "id": "24807",
    "description": "indicator_(present_action)",
    "pos": "GRAY",
    "explanation": "(indicator_(past_action) + indicator_(future_action): may be placed above a symbol to show that it is representing a verb in present action form in a natural language)  Used restrictively, primarily for language teaching purposes.  - Character (superimposed - indicator)",
    "isCharacter": true
  },
  {
    "id": "24808",
    "description": "agreed,in_agreement,harmonious",
    "pos": "GREEN",
    "explanation": "(harmony,harmoniousness,concord,concordance + description indicator)",
    "isCharacter": false,
    "composition": [
      14164,
      ";",
      8998,
      "/",
      12354
    ]
  },
  {
    "id": "24809",
    "description": "bathtub,bath,tub",
    "pos": "YELLOW",
    "explanation": "(sink,basin + length,longness + thing indicator)",
    "isCharacter": false,
    "composition": [
      16992,
      ";",
      9009,
      "/",
      15193
    ]
  },
  {
    "id": "24810",
    "description": "bugle_(hunting)",
    "pos": "YELLOW",
    "explanation": "(trumpet,horn,cornet_(1) + animal)",
    "isCharacter": false,
    "composition": [
      14895,
      "/",
      12378
    ]
  },
  {
    "id": "24811",
    "description": "conductor_(music)",
    "pos": "BLUE",
    "explanation": "(leader,director,guide_(1) + musical_note (music [contraction]))  Preferred NEW SYNONYM, replacing 13399",
    "isCharacter": false,
    "composition": [
      21054,
      "/",
      15682
    ]
  },
  {
    "id": "24812",
    "description": "government",
    "pos": "YELLOW",
    "explanation": "(board,board_of_directors,executive + country)  Preferred NEW SYNONYM, replacing 14462",
    "isCharacter": false,
    "composition": [
      14647,
      "/",
      21054,
      "/",
      13423
    ]
  },
  {
    "id": "24813",
    "description": "homosexual_(female),lesbian",
    "pos": "GREEN",
    "explanation": "(homosexuality_(female),lesbianism + description indicator)",
    "isCharacter": false,
    "composition": [
      14164,
      ";",
      8998,
      "/",
      "RK:-2",
      "/",
      25540
    ]
  },
  {
    "id": "24814",
    "description": "homosexual_(male),gay",
    "pos": "GREEN",
    "explanation": "(homosexuality_(male) + description indicator)",
    "isCharacter": false,
    "composition": [
      14164,
      ";",
      8998,
      "/",
      "RK:-2",
      "/",
      25541
    ]
  },
  {
    "id": "24815",
    "description": "in_love",
    "pos": "GREEN",
    "explanation": "(love,affection + description indicator)",
    "isCharacter": false,
    "composition": [
      15399,
      ";",
      8998
    ]
  },
  {
    "id": "24816",
    "description": "massage-(to)",
    "pos": "RED",
    "explanation": "(massage + action indicator)",
    "isCharacter": false,
    "composition": [
      12335,
      ";",
      8993,
      "/",
      "RK:-2",
      "/",
      14667,
      "/",
      20517
    ]
  },
  {
    "id": "24817",
    "description": "niece_or_nephew",
    "pos": "BLUE",
    "explanation": "(offspring,child + sibling: child of a sibling)",
    "isCharacter": false,
    "composition": [
      15912,
      "/",
      15912,
      "/",
      8498
    ]
  },
  {
    "id": "24818",
    "description": "psychology_(class)",
    "pos": "YELLOW",
    "explanation": "(knowledge,class_(in_combinations) + mind + feeling: where mind + feeling represents psychology [contraction]",
    "isCharacter": false,
    "composition": [
      15162,
      "/",
      15471,
      "/",
      14164
    ]
  },
  {
    "id": "24819",
    "description": "quickness,rapidity,speediness",
    "pos": "YELLOW",
    "explanation": "(forward + intensity)",
    "isCharacter": false,
    "composition": [
      14390,
      "/",
      14947
    ]
  },
  {
    "id": "24820",
    "description": "terrorism",
    "pos": "YELLOW",
    "explanation": "(cause + terror,panic)",
    "isCharacter": false,
    "composition": [
      13134,
      "/",
      14164,
      "/",
      13869,
      "/",
      25568,
      "/",
      14947
    ]
  },
  {
    "id": "24821",
    "description": "troublesome",
    "pos": "GREEN",
    "explanation": "(trouble + description indicator)",
    "isCharacter": false,
    "composition": [
      14164,
      ";",
      8998,
      "/",
      25589
    ]
  },
  {
    "id": "24822",
    "description": "upset,disturbance,agitation",
    "pos": "YELLOW",
    "explanation": "(feeling + up and down: unsettled feelings)",
    "isCharacter": false,
    "composition": [
      14164,
      "/",
      20524
    ]
  },
  {
    "id": "24823",
    "description": "cry_out,call-(to)",
    "pos": "RED",
    "explanation": "(say,speak,talk,tell,express-(to) + intensity + action indicator)",
    "isCharacter": false,
    "composition": [
      15666,
      ";",
      8993,
      "/",
      14947
    ]
  },
  {
    "id": "24824",
    "description": "laugh,laughter",
    "pos": "YELLOW",
    "explanation": "(happiness + mouth: expression of happiness with the mouth by laughing)",
    "isCharacter": false,
    "composition": [
      14164,
      "/",
      17983,
      "/",
      15666
    ]
  },
  {
    "id": "24825",
    "description": "push,pushing",
    "pos": "YELLOW",
    "explanation": "(forward + thing: the forward moving arrow seems to be pushing the thing)  - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "24826",
    "description": "jewelry,jewellery",
    "pos": "YELLOW",
    "explanation": "(generalization + jewel)",
    "isCharacter": false,
    "composition": [
      14430,
      "/",
      17267,
      "/",
      17252
    ]
  },
  {
    "id": "24827",
    "description": "boring,dull,depressing",
    "pos": "GREEN",
    "explanation": "(sadness,sorrow,unhappiness + mouth: mouth displaying an unhappy and bored feeling)",
    "isCharacter": false,
    "composition": [
      14164,
      ";",
      8998,
      "/",
      13869,
      "/",
      15666
    ]
  },
  {
    "id": "24828",
    "description": "laundry_(workplace)",
    "pos": "YELLOW",
    "explanation": "(room + bath,washing + clothing)",
    "isCharacter": false,
    "composition": [
      16687,
      "/",
      16992,
      "/",
      13366
    ]
  },
  {
    "id": "24829",
    "description": "great,wonderful,fantastic",
    "pos": "GREEN",
    "explanation": "(good,well,fine,ok,okay,all_right + intensity + description indicator)",
    "isCharacter": false,
    "composition": [
      14164,
      ";",
      8998,
      "/",
      12374,
      "/",
      14947,
      "/",
      14947
    ]
  },
  {
    "id": "24830",
    "description": "geyser",
    "pos": "YELLOW",
    "explanation": "(hot_spring + intensity)",
    "isCharacter": false,
    "composition": [
      25777,
      "/",
      17983,
      "/",
      14696,
      "/",
      14947
    ]
  },
  {
    "id": "24831",
    "description": "terror,panic",
    "pos": "YELLOW",
    "explanation": "(fear + intensity)",
    "isCharacter": false,
    "composition": [
      14164,
      "/",
      13869,
      "/",
      25568,
      "/",
      14947
    ]
  },
  {
    "id": "24832",
    "description": "wait,waiting",
    "pos": "YELLOW",
    "explanation": "(end,arrival,stop + limited time: a halt for a limited time)",
    "isCharacter": false,
    "composition": [
      13935,
      "/",
      15212
    ]
  },
  {
    "id": "24833",
    "description": "wish,desire",
    "pos": "YELLOW",
    "explanation": "(mind + fire: a rational desire, a strong feeling shown by fire) See also: want,desire 24834  - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "24834",
    "description": "want,desire",
    "pos": "YELLOW",
    "explanation": "(feeling + fire: an emotional desire, a strong feeling shown by fire) See also: wish,desire 24833",
    "isCharacter": false,
    "composition": [
      14164,
      "/",
      14183
    ]
  },
  {
    "id": "24835",
    "description": "last_month",
    "pos": "YELLOW",
    "explanation": "(month + ago,then_(past))",
    "isCharacter": false,
    "composition": [
      15649,
      "/",
      12352
    ]
  },
  {
    "id": "24840",
    "description": "anthropologist",
    "pos": "BLUE",
    "explanation": "(person + anthropology)",
    "isCharacter": false,
    "composition": [
      16161,
      "/",
      16735,
      "/",
      16161
    ]
  },
  {
    "id": "24841",
    "description": "children's_room",
    "pos": "YELLOW",
    "explanation": "(room + child)",
    "isCharacter": false,
    "composition": [
      16687,
      "/",
      13166
    ]
  },
  {
    "id": "24842",
    "description": "cost-(to)",
    "pos": "RED",
    "explanation": "(cost,price + action indicator)",
    "isCharacter": false,
    "composition": [
      15484,
      ";",
      8993,
      "/",
      14381,
      "/",
      17717
    ]
  },
  {
    "id": "24843",
    "description": "expose_oneself_indecently-(to)",
    "pos": "RED",
    "explanation": "(exhibitionism,immodesty,indecent_exposure + action indicator)",
    "isCharacter": false,
    "composition": [
      13134,
      ";",
      8993,
      "/",
      14133,
      "/",
      14431
    ]
  },
  {
    "id": "24844",
    "description": "finished,complete,completed,all_done,done_(finished)",
    "pos": "GREEN",
    "explanation": "(to do + all + description indicator)",
    "isCharacter": false,
    "composition": [
      12335,
      ";",
      8998,
      "/",
      12360
    ]
  },
  {
    "id": "24845",
    "description": "light_(not_dark)",
    "pos": "GREEN",
    "explanation": "(light + description indicator)",
    "isCharacter": false,
    "composition": [
      15208,
      ";",
      8998
    ]
  },
  {
    "id": "24846",
    "description": "observation",
    "pos": "YELLOW",
    "explanation": "(mind + eye: to look at something thoughtfully)  - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "24847",
    "description": "usage,use",
    "pos": "YELLOW",
    "explanation": "(mind + tool: rational manipulation of a tool)  - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "24848",
    "description": "hug,squeeze,embrace",
    "pos": "YELLOW",
    "explanation": "(arm + around)",
    "isCharacter": false,
    "composition": [
      12577,
      "/",
      12580
    ]
  },
  {
    "id": "24849",
    "description": "boss,supervisor",
    "pos": "BLUE",
    "explanation": "(leader,director,guide_(1) + work,employment,job)  Preferred NEW SYNONYM, replacing 12878",
    "isCharacter": false,
    "composition": [
      21054,
      "/",
      18273
    ]
  },
  {
    "id": "24850",
    "description": "brake_(general)-(to)",
    "pos": "RED",
    "explanation": "(brake_(general) + action indicator)",
    "isCharacter": false,
    "composition": [
      17755,
      ";",
      8993,
      "/",
      13935
    ]
  },
  {
    "id": "24851",
    "description": "brake_(vehicle)-(to)",
    "pos": "RED",
    "explanation": "(brake_(vehicle) + action indicator)",
    "isCharacter": false,
    "composition": [
      17755,
      ";",
      8993,
      "/",
      13935,
      "/",
      25119
    ]
  },
  {
    "id": "24852",
    "description": "break,fracture,injury,damage",
    "pos": "YELLOW",
    "explanation": "(horizontal line [broken])  - Character",
    "isCharacter": true
  },
  {
    "id": "24853",
    "description": "dance,dancing",
    "pos": "YELLOW",
    "explanation": "(legs_and_feet + musical note: stepping to the rhythm of music)",
    "isCharacter": false,
    "composition": [
      15189,
      "/",
      15682
    ]
  },
  {
    "id": "24854",
    "description": "drowning",
    "pos": "YELLOW",
    "explanation": "(death + water)",
    "isCharacter": false,
    "composition": [
      13645,
      "/",
      18209
    ]
  },
  {
    "id": "24855",
    "description": "fight,combat",
    "pos": "YELLOW",
    "explanation": "(hand [modification, at an angle] + hand [modification, mirrored at an angle]: crossing hands, symbol represents physical conflict but may be used in a general sense to represent any sort of conflict or struggle)  - Character (superimposed - modified)",
    "isCharacter": true
  },
  {
    "id": "24856",
    "description": "improvement_(OLD)",
    "pos": "YELLOW",
    "explanation": "(cause + more + correct: to cause to be better, in a rational sense.)",
    "isCharacter": false,
    "composition": [
      13134,
      "/",
      24879,
      "/",
      25538,
      "/",
      14947
    ]
  },
  {
    "id": "24857",
    "description": "pier",
    "pos": "YELLOW",
    "explanation": "(platform,stage + boat,ship)  Preferred NEW SYNONYM, replacing 16174",
    "isCharacter": false,
    "composition": [
      24214,
      "/",
      12869
    ]
  },
  {
    "id": "24859",
    "description": "visit",
    "pos": "YELLOW",
    "explanation": "(forward + house: can be understood as a combination of house and  to enter)  - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "24871",
    "description": "advocacy",
    "pos": "YELLOW",
    "explanation": "(mouth + purpose: speaking for a purpose)",
    "isCharacter": false,
    "composition": [
      15666,
      "/",
      16437
    ]
  },
  {
    "id": "24872",
    "description": "advocacy,representation_(legal)",
    "pos": "YELLOW",
    "explanation": "(advocacy + legal [contraction])",
    "isCharacter": false,
    "composition": [
      15666,
      "/",
      16437,
      "/",
      23127
    ]
  },
  {
    "id": "24873",
    "description": "band,orchestra",
    "pos": "BLUE",
    "explanation": "(group + musical_instrument_(in_combinations))  Preferred NEW SYNONYM, replacing 12624",
    "isCharacter": false,
    "composition": [
      14647,
      "/",
      16161,
      "/",
      23904
    ]
  },
  {
    "id": "24874",
    "description": "be_named,be_called-(to)",
    "pos": "RED",
    "explanation": "(name,label,term,title + action indicator)",
    "isCharacter": false,
    "composition": [
      15691,
      ";",
      8993
    ]
  },
  {
    "id": "24875",
    "description": "bigness,largeness",
    "pos": "YELLOW",
    "explanation": "(vertical line bounded by two horizontal reference lines [half-sized]: the vertical line extends to the biggest possible size within the symbol square)  - Character",
    "isCharacter": true
  },
  {
    "id": "24876",
    "description": "board_and_lodging,room_and_board",
    "pos": "YELLOW",
    "explanation": "(house,building,dwelling,residence + plus + food: dwelling with food)",
    "isCharacter": false,
    "composition": [
      14905,
      "/",
      12374,
      "/",
      14377
    ]
  },
  {
    "id": "24877",
    "description": "build,construct-(to)",
    "pos": "RED",
    "explanation": "(structure,construction + action indicator)",
    "isCharacter": false,
    "composition": [
      17445,
      ";",
      8993
    ]
  },
  {
    "id": "24878",
    "description": "clearness,clarity,transparency,transparence",
    "pos": "YELLOW",
    "explanation": "(eye + through: the quality of being possible to see through)",
    "isCharacter": false,
    "composition": [
      14133,
      "/",
      17724
    ]
  },
  {
    "id": "24879",
    "description": "comparative_more",
    "pos": "WHITE",
    "explanation": "(horizontal reference line [modification, half-sized on midline] + much,many,very [modification, higher position]: much, many on a higher level)  - Character (superimposed - modified)",
    "isCharacter": true
  },
  {
    "id": "24880",
    "description": "consideration,thoughtfulness",
    "pos": "YELLOW",
    "explanation": "(mind + other: mindfulness of others)  - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "24881",
    "description": "continuance,continuation",
    "pos": "YELLOW",
    "explanation": "(forward [modification, extended] + reference line [half-sized]: the arrow passes  a reference line and continues on)  Character (superimposed - modified)",
    "isCharacter": true
  },
  {
    "id": "24882",
    "description": "crown_(currency)",
    "pos": "YELLOW",
    "explanation": "(money + crown)",
    "isCharacter": false,
    "composition": [
      15484,
      "/",
      22618
    ]
  },
  {
    "id": "24883",
    "description": "deletion,cancellation,destruction",
    "pos": "YELLOW",
    "explanation": "(diagonal line used to cross out something: in the top-right to bottom left orientation)  - Character",
    "isCharacter": true
  },
  {
    "id": "24884",
    "description": "difficulty",
    "pos": "YELLOW",
    "explanation": "(forward + reference line [modification, the line has an opening]: the forward arrow is halted at the reference line as by a difficulty passing through the opening)  - Character (superimposed - modified)",
    "isCharacter": true
  },
  {
    "id": "24885",
    "description": "disgust",
    "pos": "YELLOW",
    "explanation": "(hate + intensity)",
    "isCharacter": false,
    "composition": [
      14164,
      "/",
      15474,
      "/",
      14947,
      "/",
      14947,
      "/",
      14947
    ]
  },
  {
    "id": "24886",
    "description": "disgusting_(general)",
    "pos": "GREEN",
    "explanation": "(disgust + description indicator)",
    "isCharacter": false,
    "composition": [
      14164,
      ";",
      8998,
      "/",
      15474,
      "/",
      14947,
      "/",
      14947,
      "/",
      14947
    ]
  },
  {
    "id": "24887",
    "description": "dispersion,dissemination,scattering,spread,spreading",
    "pos": "YELLOW",
    "explanation": "(backward + upward + downward + forward [modification, short arrows]: the four arrows pointing outward from each other, i.e. spreading out)  - Character (superimposed - modified)",
    "isCharacter": true
  },
  {
    "id": "24888",
    "description": "divided",
    "pos": "GREEN",
    "explanation": "(division + description indicator)",
    "isCharacter": false,
    "composition": [
      13857,
      ";",
      8998
    ]
  },
  {
    "id": "24889",
    "description": "earmuffs_(general)",
    "pos": "YELLOW",
    "explanation": "(pictograph)  - Character",
    "isCharacter": true
  },
  {
    "id": "24890",
    "description": "ease,easiness,simplicity",
    "pos": "YELLOW",
    "explanation": "(forward + reference line [modification, the line has an opening]: the forward arrow easily passing through the broken reference line)  - Character (superimposed - modified)",
    "isCharacter": true
  },
  {
    "id": "24891",
    "description": "emptying,voidance,evacuation",
    "pos": "YELLOW",
    "explanation": "(container + jump [modification, higher position]: the curved forward arrow representing content moving out of the container)  - Character (superimposed - modified)",
    "isCharacter": true
  },
  {
    "id": "24892",
    "description": "eternity,infinity_(OLD)",
    "pos": "YELLOW",
    "explanation": "(time + infiniteness,boundlessness,limitlessness_(OLD))    SUPERSEDED SYNONYM  See eternity,infinity 26001",
    "isCharacter": false,
    "composition": [
      17732,
      "/",
      15474,
      "/",
      15213
    ]
  },
  {
    "id": "24893",
    "description": "experiment",
    "pos": "YELLOW",
    "explanation": "(activity + purpose + answer)",
    "isCharacter": false,
    "composition": [
      12335,
      "/",
      16437,
      "/",
      12393
    ]
  },
  {
    "id": "24894",
    "description": "fall,drop,spill,tumble",
    "pos": "YELLOW",
    "explanation": "(down + intensity)",
    "isCharacter": false,
    "composition": [
      13869,
      "/",
      14947
    ]
  },
  {
    "id": "24895",
    "description": "fantasy,phantasy,imagination,illusion",
    "pos": "YELLOW",
    "explanation": "(being_(state_of) [modification, high position over the skyline] + sky: imaginary existence up the sky, or up in the clouds)  - Character (superimposed - modified)",
    "isCharacter": true
  },
  {
    "id": "24896",
    "description": "farness,remoteness,farawayness_(OLD)",
    "pos": "YELLOW",
    "explanation": "(reference line [half-sized + reference line [half-sized]]: with a full square between them, the lines are relatively far apart) See also: nearness,closeness,proximity 25586  - Character (sequenced)  SUPERSEDED SYNONYM and SUPERSEDED CHARACTER  See farness,remoteness,farawayness 25559",
    "isCharacter": true
  },
  {
    "id": "24897",
    "description": "filling,fill,fullness",
    "pos": "YELLOW",
    "explanation": "(container + horizontal line: the container is closed over, as if filled up)  - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "24898",
    "description": "fixing,fix,mending,mend,repair,reparation",
    "pos": "YELLOW",
    "explanation": "(to make + to work: making something work again)",
    "isCharacter": false,
    "composition": [
      23583,
      "/",
      18273
    ]
  },
  {
    "id": "24899",
    "description": "forgetting,amnesia",
    "pos": "YELLOW",
    "explanation": "(knowledge + forward: combination of knowledge and out of)  - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "24900",
    "description": "fountain",
    "pos": "YELLOW",
    "explanation": "(thing + water_(ground_level) + up)",
    "isCharacter": false,
    "composition": [
      17717,
      "/",
      25777,
      "/",
      17983
    ]
  },
  {
    "id": "24901",
    "description": "gallop",
    "pos": "YELLOW",
    "explanation": "(canter-(to) + intensity)",
    "isCharacter": false,
    "composition": [
      14897,
      "/",
      14947,
      "/",
      14947,
      "/",
      14947
    ]
  },
  {
    "id": "24902",
    "description": "geographer",
    "pos": "BLUE",
    "explanation": "(scientist,academic + earth,globe,world)",
    "isCharacter": false,
    "composition": [
      16161,
      "/",
      16735,
      "/",
      13900
    ]
  },
  {
    "id": "24903",
    "description": "giving,gift",
    "pos": "YELLOW",
    "explanation": "(up + container: drawing from what one holds)  - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "24904",
    "description": "grid,matrix",
    "pos": "YELLOW",
    "explanation": "(enclosure + pictograph, of a matrix grid)  - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "24905",
    "description": "growth,growing",
    "pos": "YELLOW",
    "explanation": "(flower + up: to come up as flowers do. CKB says that this symbol applies primarily to agriculture and horticulture, but that it may be used in a  general sense (i.e., growth of children).)",
    "isCharacter": false,
    "composition": [
      14205,
      "/",
      17983
    ]
  },
  {
    "id": "24906",
    "description": "half,one-half",
    "pos": "WHITE",
    "explanation": "(one_(digit),1 [modification, higher position] + slash (slanted line) + two_(digit),2: a common way to write 1/2)  - Character (superimposed - modified)",
    "isCharacter": true
  },
  {
    "id": "24908",
    "description": "hate,hatred",
    "pos": "YELLOW",
    "explanation": "(dislike + intensity)",
    "isCharacter": false,
    "composition": [
      14164,
      "/",
      15474,
      "/",
      14947,
      "/",
      14947
    ]
  },
  {
    "id": "24909",
    "description": "height,tallness",
    "pos": "YELLOW",
    "explanation": "(two horizontal reference lines [half-sized]: the space between the reference lines is the highest possible within the symbol square) See also: lowness,shortness_(height) 24918.  - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "24910",
    "description": "heterosexual",
    "pos": "GREEN",
    "explanation": "(heterosexuality + description indicator)",
    "isCharacter": false,
    "composition": [
      14164,
      ";",
      8998,
      "/",
      "RK:-2",
      "/",
      13425
    ]
  },
  {
    "id": "24911",
    "description": "hitchrack,hitching_bar",
    "pos": "YELLOW",
    "explanation": "(linear_thing_(horizontal),bar + attachment,appendix,annex + horse: a bar for tying up horses, thus the modification of  hitch,tie_up,fix_up-(to) 24152",
    "isCharacter": false,
    "composition": [
      17449,
      ";",
      9009,
      "/",
      23409,
      "/",
      14897
    ]
  },
  {
    "id": "24912",
    "description": "holding",
    "pos": "YELLOW",
    "explanation": "(plus_sign_(low) + earth,ground,land [half-sized]: ownership,possession [half-sized], something in one's possession without necessarily being owned)  - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "24913",
    "description": "importance,significance",
    "pos": "YELLOW",
    "explanation": "(interest [modification, intensity moved to the left to make room for another one] + intensity: of intense interest)  - Character (superimposed - modified)",
    "isCharacter": true
  },
  {
    "id": "24914",
    "description": "indoor,indoors",
    "pos": "GREEN",
    "explanation": "(indoor_(character) + description indicator)",
    "isCharacter": false,
    "composition": [
      22116,
      ";",
      8998
    ]
  },
  {
    "id": "24915",
    "description": "infiniteness,boundlessness,limitlessness_(OLD)",
    "pos": "YELLOW",
    "explanation": "(minus,no,without + limit(s),limitation_(OLD))  SUPERSEDED SYNONYM  See infiniteness,boundlessness,limitlessness 26011",
    "isCharacter": false,
    "composition": [
      15474,
      "/",
      15213
    ]
  },
  {
    "id": "24916",
    "description": "interest",
    "pos": "YELLOW",
    "explanation": "(mind + intensity: engaging the mind)  - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "24917",
    "description": "littleness,smallness",
    "pos": "YELLOW",
    "explanation": "(vertical line [half-sized] bounded by two horizontal reference lines [half-sized]: the vertical line is relatively little) See also: bigness,largeness 24875.  - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "24918",
    "description": "lowness,shortness_(height)",
    "pos": "YELLOW",
    "explanation": "(two horizontal reference lines [half-sized]: the space between the reference lines is relatively low) See also: height,tallness 24909.  - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "24919",
    "description": "malodor,malodour,stench",
    "pos": "YELLOW",
    "explanation": "(smell,odour + negative)",
    "isCharacter": false,
    "composition": [
      17017,
      "/",
      15474,
      "/",
      14947
    ]
  },
  {
    "id": "24920",
    "description": "medicine,medical_practice",
    "pos": "YELLOW",
    "explanation": "(symbol suggests a modified caduceus (modeled after the staff with a snake - of Hermes), the traditional medical symbol)  - Character",
    "isCharacter": true
  },
  {
    "id": "24921",
    "description": "next_month",
    "pos": "YELLOW",
    "explanation": "(month + then (future))",
    "isCharacter": false,
    "composition": [
      15649,
      "/",
      17705
    ]
  },
  {
    "id": "24922",
    "description": "noise_(loud)",
    "pos": "YELLOW",
    "explanation": "(sound + intensity)",
    "isCharacter": false,
    "composition": [
      17216,
      "/",
      14947
    ]
  },
  {
    "id": "24923",
    "description": "oere_(currency)",
    "pos": "YELLOW",
    "explanation": "(part,bit,piece,portion,part_of + crown_(currency))",
    "isCharacter": false,
    "composition": [
      15972,
      "/",
      15484,
      "/",
      22618
    ]
  },
  {
    "id": "24924",
    "description": "oval,elliptic,elliptical",
    "pos": "GREEN",
    "explanation": "(oval,ellipse + description indicator)",
    "isCharacter": false,
    "composition": [
      14133,
      ";",
      8998,
      "/",
      17717,
      "/",
      23599
    ]
  },
  {
    "id": "24925",
    "description": "ownership,possession",
    "pos": "YELLOW",
    "explanation": "(addition + earth: CKB writes \"an addition, a gain, a plus of some very earthly (material) thing”)  - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "24926",
    "description": "permission,allowance",
    "pos": "YELLOW",
    "explanation": "(mind + through: CKB says that the symbol represents a thought that is allowed to pass through a mental barrier)  - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "24927",
    "description": "persuasion",
    "pos": "YELLOW",
    "explanation": "(leadership + agreement [modification, short arrows] (combination): leadership to agreement)  - Character (superimposed - modified - combined)",
    "isCharacter": true
  },
  {
    "id": "24928",
    "description": "physicist",
    "pos": "BLUE",
    "explanation": "(person + physics)",
    "isCharacter": false,
    "composition": [
      16161,
      "/",
      16735,
      "/",
      13936
    ]
  },
  {
    "id": "24929",
    "description": "preparation,readying,readiness,preparedness",
    "pos": "YELLOW",
    "explanation": "(activity + for (the purpose of) + future: something done in order to be ready for the future)",
    "isCharacter": false,
    "composition": [
      12335,
      "/",
      14382,
      "/",
      14417
    ]
  },
  {
    "id": "24930",
    "description": "promise",
    "pos": "YELLOW",
    "explanation": "(mouth (to say) + activity + future: to say that something will be done in the future)",
    "isCharacter": false,
    "composition": [
      15666,
      "/",
      12335,
      "/",
      14417
    ]
  },
  {
    "id": "24931",
    "description": "protected,sheltered",
    "pos": "GREEN",
    "explanation": "(protection,shelter + description indicator)",
    "isCharacter": false,
    "composition": [
      16420,
      ";",
      8998
    ]
  },
  {
    "id": "24932",
    "description": "quarter,one_quarter",
    "pos": "WHITE",
    "explanation": "(one_(digit),1 [modification, higher position] + slash (slanted line) + four_(digit),4: a common way to write 1/4) - Character (superimposed - modified)",
    "isCharacter": true
  },
  {
    "id": "24933",
    "description": "reading",
    "pos": "YELLOW",
    "explanation": "(eye (to see) + paper,card,page: the act of seeing and perceiving what is written on the printed page)",
    "isCharacter": false,
    "composition": [
      14133,
      "/",
      15962
    ]
  },
  {
    "id": "24934",
    "description": "repetition,copying,duplication,replication",
    "pos": "YELLOW",
    "explanation": "(line,stripe + line,stripe + action indicator: the vertical line is repeated)  - Character (sequenced)",
    "isCharacter": true
  },
  {
    "id": "24935",
    "description": "research-(to)",
    "pos": "RED",
    "explanation": "(research + action indicator)",
    "isCharacter": false,
    "composition": [
      12335,
      ";",
      8993,
      "/",
      23439,
      "/",
      14114
    ]
  },
  {
    "id": "24936",
    "description": "riding,horseback_riding",
    "pos": "YELLOW",
    "explanation": "(activity + horse)",
    "isCharacter": false,
    "composition": [
      12335,
      "/",
      14897
    ]
  },
  {
    "id": "24937",
    "description": "selfishness,egoism",
    "pos": "YELLOW",
    "explanation": "(mind + self: thinking only about oneself)  - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "24938",
    "description": "shortness_(distance,length)",
    "pos": "YELLOW",
    "explanation": "(horizontal line [half-sized] bounded by  reference lines [half-sized]: horizontal line is relatively short) See also: length,longness 15193.  - Character",
    "isCharacter": true
  },
  {
    "id": "24939",
    "description": "sport_(class)",
    "pos": "YELLOW",
    "explanation": "(knowledge,class_(in_combinations) + sport)",
    "isCharacter": false,
    "composition": [
      15162,
      "/",
      20518
    ]
  },
  {
    "id": "24940",
    "description": "spray,vaporization",
    "pos": "YELLOW",
    "explanation": "(water,fluid,liquid + a cluster of seven dots: a liquid  transformed into a spray of small drops)  - Character (superimposed - sequenced)",
    "isCharacter": true
  },
  {
    "id": "24941",
    "description": "strength",
    "pos": "YELLOW",
    "explanation": "(combination of health and  muscle: symbol suggests the outline of a person, arm bent, biceps flexed, showing strength)  - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "24942",
    "description": "stress_(for_time)",
    "pos": "YELLOW",
    "explanation": "(feeling + without + time + activity: a feeling of lacking time for an activity)",
    "isCharacter": false,
    "composition": [
      14164,
      "/",
      15474,
      "/",
      17732,
      "/",
      12335
    ]
  },
  {
    "id": "24943",
    "description": "stress_(for_time)-(to)",
    "pos": "RED",
    "explanation": "(stress_(for_time) + action indicator: acting with a feeling of lacking time for the activity)",
    "isCharacter": false,
    "composition": [
      14164,
      ";",
      8993,
      "/",
      15474,
      "/",
      17732,
      "/",
      12335
    ]
  },
  {
    "id": "24944",
    "description": "superlative_most",
    "pos": "WHITE",
    "explanation": "(horizontal reference line [modification, half-sized on skyline] + much,many,very [modification, higher position]: much, many on the highest level)  - Character (superimposed - modified)",
    "isCharacter": true
  },
  {
    "id": "24945",
    "description": "supernatural",
    "pos": "GREEN",
    "explanation": "(supernatural-(noun) + description indicator)",
    "isCharacter": false,
    "composition": [
      21036,
      ";",
      8998
    ]
  },
  {
    "id": "24946",
    "description": "sweetness,sweet",
    "pos": "YELLOW",
    "explanation": "(taste + up: pleasant taste)",
    "isCharacter": false,
    "composition": [
      17506,
      "/",
      17983
    ]
  },
  {
    "id": "24947",
    "description": "swimming,swim",
    "pos": "YELLOW",
    "explanation": "(through + water: motion through water)",
    "isCharacter": false,
    "composition": [
      17724,
      "/",
      18209
    ]
  },
  {
    "id": "24948",
    "description": "this_month",
    "pos": "YELLOW",
    "explanation": "(month + now)",
    "isCharacter": false,
    "composition": [
      15649,
      "/",
      15736
    ]
  },
  {
    "id": "24949",
    "description": "wakefulness,alertness",
    "pos": "YELLOW",
    "explanation": "(eye + open: state one is in when one's eyes are open)  - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "24950",
    "description": "vomiting,vomit,puking",
    "pos": "YELLOW",
    "explanation": "(out_of,exit_(forward) + food: expelling of food)",
    "isCharacter": false,
    "composition": [
      15943,
      "/",
      14377
    ]
  },
  {
    "id": "24961",
    "description": "slang",
    "pos": "YELLOW",
    "explanation": "(feeling + to speak: emotional talk)  - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "24962",
    "description": "coarse_slang",
    "pos": "YELLOW",
    "explanation": "(knife + to speak: sharp talk)  - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "24963",
    "description": "aport",
    "pos": "GREEN",
    "explanation": "(port_(boat) + description indicator)",
    "isCharacter": false,
    "composition": [
      25577,
      ";",
      8998,
      "/",
      12869
    ]
  },
  {
    "id": "24964",
    "description": "astarboard",
    "pos": "GREEN",
    "explanation": "(starboard + description indicator)",
    "isCharacter": false,
    "composition": [
      25604,
      ";",
      8998,
      "/",
      12869
    ]
  },
  {
    "id": "24965",
    "description": "hunt,hunting",
    "pos": "YELLOW",
    "explanation": "(gun + animal)",
    "isCharacter": false,
    "composition": [
      14655,
      "/",
      12378
    ]
  },
  {
    "id": "24966",
    "description": "church_ruin,temple_ruin,wreck,wreckage_(church,temple,mosque)_(2)",
    "pos": "YELLOW",
    "explanation": "(church,mosque,temple + deletion,cancellation,destruction)  SYMBOL SYNONYM",
    "isCharacter": false,
    "composition": [
      14905,
      "/",
      14451,
      "/",
      24883
    ]
  },
  {
    "id": "24967",
    "description": "army,regular_army,ground_forces",
    "pos": "YELLOW",
    "explanation": "(military,armed_forces,armed_services + earth,ground,land)",
    "isCharacter": false,
    "composition": [
      14647,
      "/",
      16161,
      "/",
      18036,
      "/",
      13901
    ]
  },
  {
    "id": "24968",
    "description": "destroyed,ruined,demolished,deleted,erased,cancelled",
    "pos": "GREEN",
    "explanation": "(deletion,cancellation,destruction + description indicator)",
    "isCharacter": false,
    "composition": [
      24883,
      ";",
      8998
    ]
  },
  {
    "id": "25001",
    "description": "access-(to)",
    "pos": "RED",
    "explanation": "(accessibility + action indicator)",
    "isCharacter": false,
    "composition": [
      24443,
      ";",
      8993,
      "/",
      17724
    ]
  },
  {
    "id": "25002",
    "description": "accessibility,access",
    "pos": "YELLOW",
    "explanation": "(being_(state_of) + through: being possible to get through to)",
    "isCharacter": false,
    "composition": [
      24443,
      "/",
      17724
    ]
  },
  {
    "id": "25003",
    "description": "accessible",
    "pos": "GREEN",
    "explanation": "(accessibility + description indicator)",
    "isCharacter": false,
    "composition": [
      24443,
      ";",
      8998,
      "/",
      17724
    ]
  },
  {
    "id": "25004",
    "description": "adopt-(to)",
    "pos": "RED",
    "explanation": "(adoption + action indicator)",
    "isCharacter": false,
    "composition": [
      12335,
      ";",
      8993,
      "/",
      23127,
      "/",
      15968
    ]
  },
  {
    "id": "25005",
    "description": "adoption",
    "pos": "YELLOW",
    "explanation": "(activity + legal + parent: the act of becoming a legal parent of a child)",
    "isCharacter": false,
    "composition": [
      12335,
      "/",
      23127,
      "/",
      15968
    ]
  },
  {
    "id": "25006",
    "description": "adventure",
    "pos": "YELLOW",
    "explanation": "(activity + thrilling + intensity)  Preferred NEW SYNONYM, replacing 24601",
    "isCharacter": false,
    "composition": [
      12335,
      "/",
      "RK:-2",
      "/",
      14164,
      "/",
      14128,
      "/",
      14947,
      "/",
      14947
    ]
  },
  {
    "id": "25007",
    "description": "adventurous",
    "pos": "GREEN",
    "explanation": "(adventure + description indicator)",
    "isCharacter": false,
    "composition": [
      12335,
      ";",
      8998,
      "/",
      "RK:-2",
      "/",
      14164,
      "/",
      14128,
      "/",
      14947,
      "/",
      14947
    ]
  },
  {
    "id": "25008",
    "description": "Afghanistan",
    "pos": "YELLOW",
    "explanation": "(country + kite)",
    "isCharacter": false,
    "composition": [
      13423,
      "/",
      15155
    ]
  },
  {
    "id": "25009",
    "description": "ajar",
    "pos": "GREEN",
    "explanation": "(open + little: slightly open)",
    "isCharacter": false,
    "composition": [
      15923,
      ";",
      8998,
      "/",
      24917
    ]
  },
  {
    "id": "25010",
    "description": "alcohol,ethanol",
    "pos": "YELLOW",
    "explanation": "(chemical product + liquor)",
    "isCharacter": false,
    "composition": [
      13158,
      "/",
      12359
    ]
  },
  {
    "id": "25011",
    "description": "alphabet,letters_(uppercase)_(Latin_alphabet)",
    "pos": "YELLOW",
    "explanation": "(A_(uppercase) + B_(uppercase) + C_(uppercase): first three letters of the English alphabet, representing the entire alphabet)  - Character (superimposed)",
    "isCharacter": "true",
    "composition": [
      "XA",
      "/",
      "XB",
      "/",
      "XC"
    ]
  },
  {
    "id": "25012",
    "description": "applaud,clap-(to)",
    "pos": "RED",
    "explanation": "(applause + action indicator)",
    "isCharacter": false,
    "composition": [
      8498,
      "/",
      14667,
      ";",
      8993,
      "/",
      14947,
      "/",
      17216
    ]
  },
  {
    "id": "25013",
    "description": "applause,clapping",
    "pos": "YELLOW",
    "explanation": "(2 + hand + intensity + sound: clapping the hands together as a demonstration of approval)",
    "isCharacter": false,
    "composition": [
      8498,
      "/",
      14667,
      "/",
      14947,
      "/",
      17216
    ]
  },
  {
    "id": "25014",
    "description": "armed",
    "pos": "GREEN",
    "explanation": "(weapon + description indicator)",
    "isCharacter": false,
    "composition": [
      17755,
      ";",
      8998,
      "/",
      13645
    ]
  },
  {
    "id": "25015",
    "description": "Austria",
    "pos": "YELLOW",
    "explanation": "(country + musical_note (music [contraction]) + mountain)",
    "isCharacter": false,
    "composition": [
      13423,
      "/",
      15682,
      "/",
      15663
    ]
  },
  {
    "id": "25017",
    "description": "bandit,armed_robber",
    "pos": "BLUE",
    "explanation": "(person + getting + weapon: i.e., thief [contraction] using a weapon to steal)",
    "isCharacter": false,
    "composition": [
      16161,
      "/",
      24727,
      "/",
      17755,
      "/",
      13645
    ]
  },
  {
    "id": "25018",
    "description": "bazaar",
    "pos": "YELLOW",
    "explanation": "(group of + store + small)",
    "isCharacter": false,
    "composition": [
      14647,
      "/",
      23223,
      "/",
      24917
    ]
  },
  {
    "id": "25019",
    "description": "beggar",
    "pos": "BLUE",
    "explanation": "(person + ask + being_(state_of))",
    "isCharacter": false,
    "composition": [
      16161,
      "/",
      16445,
      "/",
      24443
    ]
  },
  {
    "id": "25020",
    "description": "Belarus",
    "pos": "YELLOW",
    "explanation": "(country + buffalo + tree (wood [contraction]): the country of the European Bison, or Wisent)",
    "isCharacter": false,
    "composition": [
      13423,
      "/",
      12917,
      "/",
      17775
    ]
  },
  {
    "id": "25021",
    "description": "bioenergy",
    "pos": "YELLOW",
    "explanation": "(energy + plant)",
    "isCharacter": false,
    "composition": [
      13936,
      "/",
      16196
    ]
  },
  {
    "id": "25022",
    "description": "braid,plait-(to)",
    "pos": "RED",
    "explanation": "(braid + action indicator)",
    "isCharacter": false,
    "composition": [
      22377,
      ";",
      8993,
      "/",
      8499,
      "/",
      15214,
      ";",
      9009
    ]
  },
  {
    "id": "25023",
    "description": "braid,plait,pigtail(s)",
    "pos": "YELLOW",
    "explanation": "(to mix + 3 + linear thing)  3 can be replaced by an appropriate number.",
    "isCharacter": false,
    "composition": [
      22377,
      "/",
      8499,
      "/",
      15214,
      ";",
      9009
    ]
  },
  {
    "id": "25024",
    "description": "Brazil",
    "pos": "YELLOW",
    "explanation": "(country + ball + legs_and_feet: country of football [contraction])",
    "isCharacter": false,
    "composition": [
      13423,
      "/",
      12621,
      "/",
      15189
    ]
  },
  {
    "id": "25025",
    "description": "cheer-(to)",
    "pos": "RED",
    "explanation": "(cheering + action indicator)",
    "isCharacter": false,
    "composition": [
      15666,
      ";",
      8993,
      "/",
      14382,
      "/",
      14947
    ]
  },
  {
    "id": "25026",
    "description": "cheering_(the_sound)",
    "pos": "GRAY",
    "explanation": "(support_(oral) + intensity)",
    "isCharacter": false,
    "composition": [
      15666,
      "/",
      14382,
      "/",
      14947
    ]
  },
  {
    "id": "25027",
    "description": "cheerleader",
    "pos": "BLUE",
    "explanation": "(leader + cheering)",
    "isCharacter": false,
    "composition": [
      21054,
      "/",
      15666,
      "/",
      14382,
      "/",
      14947
    ]
  },
  {
    "id": "25028",
    "description": "cheers_(toast)",
    "pos": "GRAY",
    "explanation": "(say,speak,talk,tell,express-(to) + alcoholic drink + up)",
    "isCharacter": false,
    "composition": [
      15666,
      "/",
      12359,
      "/",
      17983
    ]
  },
  {
    "id": "25029",
    "description": "China",
    "pos": "YELLOW",
    "explanation": "(country + middle,centre; 中国 zhōng guó is the official name of China, which literally means middle or central country)",
    "isCharacter": false,
    "composition": [
      13423,
      "/",
      15464
    ]
  },
  {
    "id": "25030",
    "description": "city_tour",
    "pos": "YELLOW",
    "explanation": "(move + see + village: where village represents city [contraction])",
    "isCharacter": false,
    "composition": [
      25119,
      "/",
      14133,
      "/",
      14647,
      "/",
      14905
    ]
  },
  {
    "id": "25031",
    "description": "climate",
    "pos": "YELLOW",
    "explanation": "(generalisation + weather)",
    "isCharacter": false,
    "composition": [
      14430,
      "/",
      18214
    ]
  },
  {
    "id": "25032",
    "description": "code,password",
    "pos": "YELLOW",
    "explanation": "(number + secret)",
    "isCharacter": false,
    "composition": [
      15742,
      "/",
      16745
    ]
  },
  {
    "id": "25033",
    "description": "collection,pile,tussock_(etc)",
    "pos": "YELLOW",
    "explanation": "(group of + together)",
    "isCharacter": false,
    "composition": [
      14647,
      "/",
      23409
    ]
  },
  {
    "id": "25034",
    "description": "coup,hijack,takeover",
    "pos": "YELLOW",
    "explanation": "(theft + leadership)",
    "isCharacter": false,
    "composition": [
      24727,
      "/",
      15474,
      "/",
      14947,
      "/",
      22913
    ]
  },
  {
    "id": "25035",
    "description": "coup,coup_d'etat",
    "pos": "YELLOW",
    "explanation": "(coup + country)",
    "isCharacter": false,
    "composition": [
      24727,
      "/",
      15474,
      "/",
      14947,
      "/",
      22913,
      "/",
      13423
    ]
  },
  {
    "id": "25036",
    "description": "crime",
    "pos": "YELLOW",
    "explanation": "(activity + illegal,criminal)",
    "isCharacter": false,
    "composition": [
      12335,
      "/",
      15474,
      "/",
      23127,
      "/",
      15962
    ]
  },
  {
    "id": "25037",
    "description": "criminal_(person)",
    "pos": "BLUE",
    "explanation": "(person + illegal,criminal: where illegal represents crime [contraction])",
    "isCharacter": false,
    "composition": [
      16161,
      "/",
      15474,
      "/",
      23127,
      "/",
      15962
    ]
  },
  {
    "id": "25038",
    "description": "criminality,crime",
    "pos": "YELLOW",
    "explanation": "(action + illegal,criminal)",
    "isCharacter": false,
    "composition": [
      12334,
      "/",
      15474,
      "/",
      23127,
      "/",
      15962
    ]
  },
  {
    "id": "25039",
    "description": "curiosity,curiousness,inquisitiveness,wonder",
    "pos": "YELLOW",
    "explanation": "(wish + knowledge)",
    "isCharacter": false,
    "composition": [
      24833,
      "/",
      15162
    ]
  },
  {
    "id": "25040",
    "description": "curious,inquisitive",
    "pos": "GREEN",
    "explanation": "(curiosity + description indicator)",
    "isCharacter": false,
    "composition": [
      24833,
      ";",
      8998,
      "/",
      15162
    ]
  },
  {
    "id": "25041",
    "description": "cushion",
    "pos": "YELLOW",
    "explanation": "(enclosure + imprint,depression: where imprint,depression represents soft [contraction])",
    "isCharacter": false,
    "composition": [
      13934,
      "/",
      25575
    ]
  },
  {
    "id": "25042",
    "description": "cushion_(seat)",
    "pos": "YELLOW",
    "explanation": "(cushion + seat)",
    "isCharacter": false,
    "composition": [
      13934,
      "/",
      25575,
      "/",
      16165
    ]
  },
  {
    "id": "25043",
    "description": "Czech_Republic",
    "pos": "YELLOW",
    "explanation": "(country + beer)",
    "isCharacter": false,
    "composition": [
      13423,
      "/",
      12359,
      "/",
      14424
    ]
  },
  {
    "id": "25044",
    "description": "deflate,let_out_air-(to)",
    "pos": "RED",
    "explanation": "(out_of,exit_(forward) + air + action indicator)  Air can be replaced by an appropriate specifier.",
    "isCharacter": false,
    "composition": [
      15943,
      ";",
      8993,
      "/",
      12356
    ]
  },
  {
    "id": "25045",
    "description": "detective,investigator",
    "pos": "BLUE",
    "explanation": "(person + wakefulness,alertness + information: where wakefulness represents search-(to) [contraction])",
    "isCharacter": false,
    "composition": [
      16161,
      "/",
      24949,
      "/",
      23542
    ]
  },
  {
    "id": "25046",
    "description": "diaphragm,midriff",
    "pos": "YELLOW",
    "explanation": "(muscle + middle)",
    "isCharacter": false,
    "composition": [
      20517,
      "/",
      15464
    ]
  },
  {
    "id": "25047",
    "description": "disinfectant,antiseptic",
    "pos": "YELLOW",
    "explanation": "(chemical product + bath,washing + medical)",
    "isCharacter": false,
    "composition": [
      13158,
      "/",
      16992,
      "/",
      24920
    ]
  },
  {
    "id": "25048",
    "description": "drill",
    "pos": "YELLOW",
    "explanation": "(tool + rotation + through)",
    "isCharacter": false,
    "composition": [
      17755,
      "/",
      24249,
      "/",
      17724
    ]
  },
  {
    "id": "25049",
    "description": "drilling_rig_(gas)",
    "pos": "YELLOW",
    "explanation": "(machine + rotation + gas)",
    "isCharacter": false,
    "composition": [
      15406,
      "/",
      24249,
      "/",
      14424
    ]
  },
  {
    "id": "25050",
    "description": "drilling_rig_(oil)",
    "pos": "YELLOW",
    "explanation": "(machine + rotation + oil)",
    "isCharacter": false,
    "composition": [
      15406,
      "/",
      24249,
      "/",
      15914
    ]
  },
  {
    "id": "25051",
    "description": "drilling_rig_(water)",
    "pos": "YELLOW",
    "explanation": "(machine + rotation + water)",
    "isCharacter": false,
    "composition": [
      15406,
      "/",
      24249,
      "/",
      18209
    ]
  },
  {
    "id": "25052",
    "description": "each_other,one_another",
    "pos": "WHITE",
    "explanation": "(person + back and forth + person)",
    "isCharacter": false,
    "composition": [
      16161,
      "/",
      12610,
      "/",
      16161
    ]
  },
  {
    "id": "25053",
    "description": "encourage-(to)",
    "pos": "RED",
    "explanation": "(encouragement + action indicator)",
    "isCharacter": false,
    "composition": [
      24903,
      ";",
      8993,
      "/",
      14164,
      "/",
      24941
    ]
  },
  {
    "id": "25054",
    "description": "encouragement",
    "pos": "YELLOW",
    "explanation": "(to give + courage)",
    "isCharacter": false,
    "composition": [
      24903,
      "/",
      14164,
      "/",
      24941
    ]
  },
  {
    "id": "25055",
    "description": "escape",
    "pos": "YELLOW",
    "explanation": "(out_of,exit_(forward) + intensity)",
    "isCharacter": false,
    "composition": [
      15943,
      "/",
      14947
    ]
  },
  {
    "id": "25056",
    "description": "escape-(to)",
    "pos": "RED",
    "explanation": "(escape + action indicator)",
    "isCharacter": false,
    "composition": [
      15943,
      ";",
      8993,
      "/",
      14947
    ]
  },
  {
    "id": "25057",
    "description": "espionage,spying",
    "pos": "YELLOW",
    "explanation": "(to search + secret + information)",
    "isCharacter": false,
    "composition": [
      24949,
      "/",
      14947,
      "/",
      14947,
      "/",
      16745,
      "/",
      23542
    ]
  },
  {
    "id": "25058",
    "description": "explore-(to)",
    "pos": "RED",
    "explanation": "(exploration + action indicator)",
    "isCharacter": false,
    "composition": [
      24949,
      ";",
      8993,
      "/",
      25587
    ]
  },
  {
    "id": "25059",
    "description": "explorer,enquirer",
    "pos": "BLUE",
    "explanation": "(person + explore)",
    "isCharacter": false,
    "composition": [
      16161,
      "/",
      24949,
      "/",
      25587
    ]
  },
  {
    "id": "25060",
    "description": "fart,wind",
    "pos": "YELLOW",
    "explanation": "(gas + buttocks,bottom,bum,rear,ass)",
    "isCharacter": false,
    "composition": [
      14424,
      "/",
      13097
    ]
  },
  {
    "id": "25061",
    "description": "fatal,lethal",
    "pos": "GREEN",
    "explanation": "(to cause + death + description indicator)",
    "isCharacter": false,
    "composition": [
      13134,
      ";",
      8998,
      "/",
      13645
    ]
  },
  {
    "id": "25062",
    "description": "fossil_fuel,coal_(etc)",
    "pos": "YELLOW",
    "explanation": "(fuel + plant + passed time)",
    "isCharacter": false,
    "composition": [
      14412,
      "/",
      16196,
      "/",
      15975
    ]
  },
  {
    "id": "25063",
    "description": "France",
    "pos": "YELLOW",
    "explanation": "(country + champagne)",
    "isCharacter": false,
    "composition": [
      13423,
      "/",
      14635,
      "/",
      14424,
      "/",
      14947
    ]
  },
  {
    "id": "25064",
    "description": "Friday_(day5)",
    "pos": "YELLOW",
    "explanation": "(day + 5 + five_(index_number): small 5 of ISO standard)  SYMBOL SYNONYM (replacing 14400)",
    "isCharacter": false,
    "composition": [
      13639,
      "/",
      8501,
      "/",
      8515
    ]
  },
  {
    "id": "25065",
    "description": "Friday_(day6)",
    "pos": "YELLOW",
    "explanation": "(day + 6 + five_(index_number): small 5 of ISO standard)  SYMBOL SYNONYM (replacing 14400)",
    "isCharacter": false,
    "composition": [
      13639,
      "/",
      8502,
      "/",
      8515
    ]
  },
  {
    "id": "25066",
    "description": "Friday_(day7)",
    "pos": "YELLOW",
    "explanation": "(day + 7 + five_(index_number): small 5 of ISO standard)  SYMBOL SYNONYM (replacing 14400)",
    "isCharacter": false,
    "composition": [
      13639,
      "/",
      8503,
      "/",
      8515
    ]
  },
  {
    "id": "25067",
    "description": "gas_(fuel)",
    "pos": "YELLOW",
    "explanation": "(fuel + gas)",
    "isCharacter": false,
    "composition": [
      14412,
      "/",
      14424
    ]
  },
  {
    "id": "25068",
    "description": "gas_(fuel_from_biomass)",
    "pos": "YELLOW",
    "explanation": "(fuel + gas + plant)",
    "isCharacter": false,
    "composition": [
      14412,
      "/",
      14424,
      "/",
      16196
    ]
  },
  {
    "id": "25069",
    "description": "geothermal_energy",
    "pos": "YELLOW",
    "explanation": "(energy + ground)",
    "isCharacter": false,
    "composition": [
      13936,
      "/",
      13901
    ]
  },
  {
    "id": "25070",
    "description": "gravity,gravitation",
    "pos": "YELLOW",
    "explanation": "(thing + down [modification, short arrow])  - Character (superimposed - modified)",
    "isCharacter": true
  },
  {
    "id": "25071",
    "description": "Greece",
    "pos": "YELLOW",
    "explanation": "(country + five_(digit),5 + ring: The Olympics [contraction])",
    "isCharacter": false,
    "composition": [
      13423,
      "/",
      8501,
      "/",
      16675
    ]
  },
  {
    "id": "25072",
    "description": "habit,custom",
    "pos": "YELLOW",
    "explanation": "(activity + usually)",
    "isCharacter": false,
    "composition": [
      12335,
      "/",
      24944,
      "/",
      17732
    ]
  },
  {
    "id": "25073",
    "description": "Hattifatteners",
    "pos": "BLUE",
    "explanation": "(group of + imaginary person + electricity: Literary figures in the Moomin books by Tove Jansson - tall, thin, ghost-like creatures that become electrical during thunderstorms)",
    "isCharacter": false,
    "composition": [
      14647,
      "/",
      23577,
      "/",
      13918
    ]
  },
  {
    "id": "25074",
    "description": "Hemulen",
    "pos": "BLUE",
    "explanation": "(imaginary person + 1 + interest: Literary figures in the Moomin books by Tove Jansson - occupied with one specific interest)",
    "isCharacter": false,
    "composition": [
      23577,
      "/",
      8497,
      "/",
      24916
    ]
  },
  {
    "id": "25075",
    "description": "hiccup(s)_(1)",
    "pos": "YELLOW",
    "explanation": "(sound + diaphragm)  SYMBOL SYNONYM",
    "isCharacter": false,
    "composition": [
      17216,
      "/",
      20517,
      "/",
      15464
    ]
  },
  {
    "id": "25076",
    "description": "hiccup(s)_(2)",
    "pos": "YELLOW",
    "explanation": "(sound + out_of_body_(upward) + repetition)  SYMBOL SYNONYM",
    "isCharacter": false,
    "composition": [
      17216,
      "/",
      25590,
      "/",
      24934
    ]
  },
  {
    "id": "25077",
    "description": "hide,conceal_(secret)-(to)",
    "pos": "RED",
    "explanation": "(hiding place + action indicator)",
    "isCharacter": false,
    "composition": [
      16193,
      ";",
      8993,
      "/",
      16745
    ]
  },
  {
    "id": "25078",
    "description": "hide_and_seek",
    "pos": "YELLOW",
    "explanation": "(play_(in_combinations) + hiding place)",
    "isCharacter": false,
    "composition": [
      12335,
      "/",
      "RK:-2",
      "/",
      14164,
      "/",
      16193,
      "/",
      16745
    ]
  },
  {
    "id": "25079",
    "description": "hiding_place,cache",
    "pos": "YELLOW",
    "explanation": "(place + secret)",
    "isCharacter": false,
    "composition": [
      16193,
      "/",
      16745
    ]
  },
  {
    "id": "25081",
    "description": "hijack,make_a_coup-(to)",
    "pos": "RED",
    "explanation": "(coup,hijack,takeover + action indicator)",
    "isCharacter": false,
    "composition": [
      24727,
      ";",
      8993,
      "/",
      15474,
      "/",
      14947,
      "/",
      22913
    ]
  },
  {
    "id": "25082",
    "description": "hijacker,coup_maker",
    "pos": "BLUE",
    "explanation": "(person + coup,hijack,takeover)",
    "isCharacter": false,
    "composition": [
      16161,
      "/",
      24727,
      "/",
      15474,
      "/",
      14947,
      "/",
      22913
    ]
  },
  {
    "id": "25083",
    "description": "hold,contain_(2)-(to)",
    "pos": "RED",
    "explanation": "(goods,contents + action indicator)",
    "isCharacter": false,
    "composition": [
      14457,
      ";",
      8993
    ]
  },
  {
    "id": "25084",
    "description": "hostage_(1)",
    "pos": "BLUE",
    "explanation": "(person + oppression,captivity,slavery + for_(in_exchange_for))  SYMBOL SYNONYM",
    "isCharacter": false,
    "composition": [
      16161,
      "/",
      25132,
      "/",
      14381
    ]
  },
  {
    "id": "25085",
    "description": "hostage_(2)",
    "pos": "BLUE",
    "explanation": "(person + oppression,captivity,slavery + for_(in_exchange_for) + money)  Money can be replaced by an appropriate specifier.  SYMBOL SYNONYM",
    "isCharacter": false,
    "composition": [
      16161,
      "/",
      25132,
      "/",
      14381,
      "/",
      15484
    ]
  },
  {
    "id": "25086",
    "description": "hunter",
    "pos": "BLUE",
    "explanation": "(person + hunt,hunting)",
    "isCharacter": false,
    "composition": [
      16161,
      "/",
      14655,
      "/",
      12378
    ]
  },
  {
    "id": "25087",
    "description": "hydropower,hydro_energy",
    "pos": "YELLOW",
    "explanation": "(energy + water)",
    "isCharacter": false,
    "composition": [
      13936,
      "/",
      18209
    ]
  },
  {
    "id": "25088",
    "description": "identity_card",
    "pos": "YELLOW",
    "explanation": "(card + name + number)",
    "isCharacter": false,
    "composition": [
      23431,
      "/",
      15691,
      "/",
      15742
    ]
  },
  {
    "id": "25089",
    "description": "index,list_of_contents_(in_a_book_etc)",
    "pos": "YELLOW",
    "explanation": "(page + content)",
    "isCharacter": false,
    "composition": [
      15962,
      "/",
      24897
    ]
  },
  {
    "id": "25090",
    "description": "India",
    "pos": "YELLOW",
    "explanation": "(country + flavouring)",
    "isCharacter": false,
    "composition": [
      13423,
      "/",
      12339,
      ";",
      9009,
      "/",
      17506
    ]
  },
  {
    "id": "25091",
    "description": "inflate-(to)",
    "pos": "RED",
    "explanation": "(entrance + air + action indicator)  Air can be replaced by an appropriate specifier.",
    "isCharacter": false,
    "composition": [
      14952,
      ";",
      8993,
      "/",
      12356
    ]
  },
  {
    "id": "25093",
    "description": "invitation_(general_spoken)",
    "pos": "YELLOW",
    "explanation": "(say,speak,talk,tell,express-(to) + fidelity,loyalty,solidarity)",
    "isCharacter": false,
    "composition": [
      15666,
      "/",
      14164,
      "/",
      23409
    ]
  },
  {
    "id": "25094",
    "description": "invitation_(general_written)",
    "pos": "YELLOW",
    "explanation": "(paper + fidelity,loyalty,solidarity)",
    "isCharacter": false,
    "composition": [
      15962,
      "/",
      14164,
      "/",
      23409
    ]
  },
  {
    "id": "25095",
    "description": "invitation_(spoken)",
    "pos": "YELLOW",
    "explanation": "(say,speak,talk,tell,express-(to) + welcome)",
    "isCharacter": false,
    "composition": [
      15666,
      "/",
      14164,
      "/",
      24859
    ]
  },
  {
    "id": "25096",
    "description": "invitation_(written)",
    "pos": "YELLOW",
    "explanation": "(paper + welcome)",
    "isCharacter": false,
    "composition": [
      15962,
      "/",
      14164,
      "/",
      24859
    ]
  },
  {
    "id": "25097",
    "description": "Iraq",
    "pos": "YELLOW",
    "explanation": "(country + garden + stairs: refers to the Hanging Gardens of Babylon – and of queen Semiramis)",
    "isCharacter": false,
    "composition": [
      13423,
      "/",
      14422,
      "/",
      17247
    ]
  },
  {
    "id": "25098",
    "description": "Italy",
    "pos": "YELLOW",
    "explanation": "(country + opera)",
    "isCharacter": false,
    "composition": [
      13423,
      "/",
      15666,
      "/",
      15682,
      "/",
      20524
    ]
  },
  {
    "id": "25099",
    "description": "Japan",
    "pos": "YELLOW",
    "explanation": "(country + sunrise)",
    "isCharacter": false,
    "composition": [
      13423,
      "/",
      15656,
      "/",
      17983
    ]
  },
  {
    "id": "25100",
    "description": "kidnap-(to)",
    "pos": "RED",
    "explanation": "(theft + person + action indicator)",
    "isCharacter": false,
    "composition": [
      24727,
      ";",
      8993,
      "/",
      15474,
      "/",
      14947,
      "/",
      16161
    ]
  },
  {
    "id": "25101",
    "description": "kidnapper",
    "pos": "BLUE",
    "explanation": "(person + kidnap-(to))",
    "isCharacter": false,
    "composition": [
      16161,
      "/",
      24727,
      "/",
      15474,
      "/",
      14947,
      "/",
      16161
    ]
  },
  {
    "id": "25103",
    "description": "killer,murderer",
    "pos": "BLUE",
    "explanation": "(person + manslaughter)",
    "isCharacter": false,
    "composition": [
      16161,
      "/",
      13134,
      "/",
      13645
    ]
  },
  {
    "id": "25104",
    "description": "killing,murder,slaughter",
    "pos": "YELLOW",
    "explanation": "(cause + death)",
    "isCharacter": false,
    "composition": [
      13134,
      "/",
      13645
    ]
  },
  {
    "id": "25105",
    "description": "knock,tap-(to)",
    "pos": "RED",
    "explanation": "(knock + action indicator)",
    "isCharacter": false,
    "composition": [
      14667,
      ";",
      8993,
      "/",
      14947,
      "/",
      17216
    ]
  },
  {
    "id": "25106",
    "description": "knock,tap_(sound)",
    "pos": "YELLOW",
    "explanation": "(noise_(loud) + short)",
    "isCharacter": false,
    "composition": [
      17216,
      "/",
      14947,
      "/",
      24938
    ]
  },
  {
    "id": "25107",
    "description": "knocking",
    "pos": "YELLOW",
    "explanation": "(hand + intensity + sound)",
    "isCharacter": false,
    "composition": [
      14667,
      "/",
      14947,
      "/",
      17216
    ]
  },
  {
    "id": "25108",
    "description": "land_(rocket)-(to)",
    "pos": "RED",
    "explanation": "(landing_(rocket) + action indicator)",
    "isCharacter": false,
    "composition": [
      25614,
      ";",
      8993,
      "/",
      13871
    ]
  },
  {
    "id": "25109",
    "description": "landing_(rocket)",
    "pos": "YELLOW",
    "explanation": "(rocket + downward and forward)",
    "isCharacter": false,
    "composition": [
      25614,
      "/",
      13871
    ]
  },
  {
    "id": "25110",
    "description": "Little_My",
    "pos": "BLUE",
    "explanation": "(imaginary person + girl + against,opposed_to: Literary figure in the Moomin books by Tove Jansson - she is a small determined fiercely independent Mymble. Little My is brash, aggressive, mischievous and disrespectful.)",
    "isCharacter": false,
    "composition": [
      23577,
      "/",
      14439,
      "/",
      12351
    ]
  },
  {
    "id": "25111",
    "description": "load",
    "pos": "YELLOW",
    "explanation": "(much/many + together + container)",
    "isCharacter": false,
    "composition": [
      14647,
      "/",
      23409,
      "/",
      13403
    ]
  },
  {
    "id": "25112",
    "description": "make_a_speech-(to)",
    "pos": "RED",
    "explanation": "(speech_(event) + action indicator)",
    "isCharacter": false,
    "composition": [
      15666,
      ";",
      8993,
      "/",
      14114,
      "/",
      14647,
      "/",
      16161
    ]
  },
  {
    "id": "25113",
    "description": "Monday_(day1)",
    "pos": "YELLOW",
    "explanation": "(day + 1 + one_(index_number): small 1 of ISO standard)  SYMBOL SYNONYM (replacing 15483)",
    "isCharacter": false,
    "composition": [
      13639,
      "/",
      8497,
      "/",
      8511
    ]
  },
  {
    "id": "25114",
    "description": "Monday_(day2)",
    "pos": "YELLOW",
    "explanation": "(day + 2 + one_(index_number): small 1 of ISO standard)  SYMBOL SYNONYM (replacing 15483)",
    "isCharacter": false,
    "composition": [
      13639,
      "/",
      8498,
      "/",
      8511
    ]
  },
  {
    "id": "25115",
    "description": "Monday_(day3)",
    "pos": "YELLOW",
    "explanation": "(day + 3 + one_(index_number): small 1 of ISO standard)  SYMBOL SYNONYM (replacing 15483)",
    "isCharacter": false,
    "composition": [
      13639,
      "/",
      8499,
      "/",
      8511
    ]
  },
  {
    "id": "25116",
    "description": "Moominmamma",
    "pos": "BLUE",
    "explanation": "(Moomintroll [contraction] + mother: Literary figure in the Moomin books by Tove Jansson - she is the mother of Moomintroll.)",
    "isCharacter": false,
    "composition": [
      23577,
      "/",
      "RK:-2",
      "/",
      25575,
      "/",
      15662
    ]
  },
  {
    "id": "25117",
    "description": "Moominpappa",
    "pos": "BLUE",
    "explanation": "(Moomintroll [contraction] + father: Literary figure in the Moomin books by Tove Jansson - he is the father of Moomintroll.)",
    "isCharacter": false,
    "composition": [
      23577,
      "/",
      "RK:-2",
      "/",
      25575,
      "/",
      14157
    ]
  },
  {
    "id": "25118",
    "description": "Moomintroll",
    "pos": "BLUE",
    "explanation": "(imaginary person + imprint,depression + M: Literary figure in the Moomin books by Tove Jansson - the main character of most of the books, imprint,depression represents soft [contraction])",
    "isCharacter": false,
    "composition": [
      23577,
      "/",
      "RK:-2",
      "/",
      25575,
      "/",
      "XM"
    ]
  },
  {
    "id": "25119",
    "description": "move,movement",
    "pos": "YELLOW",
    "explanation": "(wheel + earth [half-sized]: the wheel moves by rolling over the ground)  - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "25120",
    "description": "mummy_(general)",
    "pos": "YELLOW",
    "explanation": "(body + dead + cloth)",
    "isCharacter": false,
    "composition": [
      12870,
      "/",
      13645,
      "/",
      13365
    ]
  },
  {
    "id": "25121",
    "description": "mummy_(imaginary)",
    "pos": "YELLOW",
    "explanation": "(imaginary person + dead + cloth)",
    "isCharacter": false,
    "composition": [
      23577,
      "/",
      13645,
      "/",
      13365
    ]
  },
  {
    "id": "25122",
    "description": "murder",
    "pos": "YELLOW",
    "explanation": "(killing + plan)",
    "isCharacter": false,
    "composition": [
      13134,
      "/",
      13645,
      "/",
      16194
    ]
  },
  {
    "id": "25123",
    "description": "murder-(to)",
    "pos": "RED",
    "explanation": "(murder + action indicator)",
    "isCharacter": false,
    "composition": [
      13134,
      ";",
      8993,
      "/",
      13645,
      "/",
      16194
    ]
  },
  {
    "id": "25124",
    "description": "murderer",
    "pos": "BLUE",
    "explanation": "(person + murder)",
    "isCharacter": false,
    "composition": [
      16161,
      "/",
      13134,
      "/",
      13645,
      "/",
      16194
    ]
  },
  {
    "id": "25125",
    "description": "nosy",
    "pos": "GREEN",
    "explanation": "(curious,inquisitive + negative + description indicator)",
    "isCharacter": false,
    "composition": [
      24833,
      ";",
      8998,
      "/",
      15162,
      "/",
      15474,
      "/",
      14947
    ]
  },
  {
    "id": "25126",
    "description": "nuclear_fuel",
    "pos": "YELLOW",
    "explanation": "(fuel + nucleus)",
    "isCharacter": false,
    "composition": [
      14412,
      "/",
      15741
    ]
  },
  {
    "id": "25127",
    "description": "oil_(fuel)",
    "pos": "YELLOW",
    "explanation": "(fuel + oil)",
    "isCharacter": false,
    "composition": [
      14412,
      "/",
      15914
    ]
  },
  {
    "id": "25128",
    "description": "oil_power,oil_energy",
    "pos": "YELLOW",
    "explanation": "(energy + oil)",
    "isCharacter": false,
    "composition": [
      13936,
      "/",
      15914
    ]
  },
  {
    "id": "25129",
    "description": "OK,alright",
    "pos": "GREEN",
    "explanation": "(feeling + enough + description indicator)",
    "isCharacter": false,
    "composition": [
      14164,
      ";",
      8998,
      "/",
      15474,
      "/",
      24879
    ]
  },
  {
    "id": "25130",
    "description": "Olympics,Olympic_games",
    "pos": "YELLOW",
    "explanation": "(competition + 5 + ring)",
    "isCharacter": false,
    "composition": [
      16451,
      "/",
      8501,
      "/",
      16675
    ]
  },
  {
    "id": "25131",
    "description": "oppressed,unfree",
    "pos": "GREEN",
    "explanation": "(oppression,captivity,slavery + description indicator)",
    "isCharacter": false,
    "composition": [
      25132,
      ";",
      8998
    ]
  },
  {
    "id": "25132",
    "description": "oppression,captivity,slavery",
    "pos": "YELLOW",
    "explanation": "(feeling + enclosure: feeling of being confined)  - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "25133",
    "description": "out_of_(backward)",
    "pos": "WHITE",
    "explanation": "(enclosure + backward)  - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "25134",
    "description": "out_of_(upward)",
    "pos": "WHITE",
    "explanation": "(enclosure + upward)  - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "25136",
    "description": "passive",
    "pos": "GREEN",
    "explanation": "(passivity + description indicator)",
    "isCharacter": false,
    "composition": [
      15474,
      "/",
      12335,
      ";",
      8998
    ]
  },
  {
    "id": "25137",
    "description": "passivity",
    "pos": "YELLOW",
    "explanation": "(without + activity)",
    "isCharacter": false,
    "composition": [
      15474,
      "/",
      12335
    ]
  },
  {
    "id": "25138",
    "description": "pill_box",
    "pos": "YELLOW",
    "explanation": "(container + time + pill,tablet)",
    "isCharacter": false,
    "composition": [
      13403,
      "/",
      17732,
      "/",
      13685,
      "/",
      24920
    ]
  },
  {
    "id": "25139",
    "description": "Poland",
    "pos": "YELLOW",
    "explanation": "(country + field)",
    "isCharacter": false,
    "composition": [
      13423,
      "/",
      14173
    ]
  },
  {
    "id": "25140",
    "description": "Portugal",
    "pos": "YELLOW",
    "explanation": "(country + wakefulness,alertness + new: country of discoveries (search [contraction] + new))",
    "isCharacter": false,
    "composition": [
      13423,
      "/",
      24949,
      "/",
      25587
    ]
  },
  {
    "id": "25141",
    "description": "power_plant,power_station",
    "pos": "YELLOW",
    "explanation": "(house + energy)",
    "isCharacter": false,
    "composition": [
      14905,
      "/",
      13936
    ]
  },
  {
    "id": "25142",
    "description": "precious,treasured",
    "pos": "GREEN",
    "explanation": "(value + feeling + and,also,plus,too + description indicator: value characterized by a positive feeling of fond affection for)",
    "isCharacter": false,
    "composition": [
      13949,
      ";",
      8998,
      "/",
      14164,
      "/",
      12374
    ]
  },
  {
    "id": "25143",
    "description": "precious_thing,treasure",
    "pos": "YELLOW",
    "explanation": "(thing + precious)",
    "isCharacter": false,
    "composition": [
      17717,
      "/",
      13949,
      "/",
      14164,
      "/",
      12374
    ]
  },
  {
    "id": "25144",
    "description": "prison_officer",
    "pos": "BLUE",
    "explanation": "(person + work + barred_window: the barred window representing prison [contr])",
    "isCharacter": false,
    "composition": [
      16161,
      "/",
      18273,
      "/",
      18257
    ]
  },
  {
    "id": "25145",
    "description": "prisoner",
    "pos": "BLUE",
    "explanation": "(person + barred_window: the barred window representing prison [contr])",
    "isCharacter": false,
    "composition": [
      16161,
      "/",
      18257
    ]
  },
  {
    "id": "25146",
    "description": "pump",
    "pos": "YELLOW",
    "explanation": "(tool + pressure)",
    "isCharacter": false,
    "composition": [
      17755,
      "/",
      23169
    ]
  },
  {
    "id": "25147",
    "description": "pump-(to)",
    "pos": "RED",
    "explanation": "(pump + action indicator)",
    "isCharacter": false,
    "composition": [
      17755,
      ";",
      8993,
      "/",
      23169
    ]
  },
  {
    "id": "25148",
    "description": "rag",
    "pos": "YELLOW",
    "explanation": "(cloth + broken)",
    "isCharacter": false,
    "composition": [
      13365,
      "/",
      24852
    ]
  },
  {
    "id": "25149",
    "description": "rags_(worn-out_clothes)",
    "pos": "YELLOW",
    "explanation": "(clothes + usage,use + end)",
    "isCharacter": false,
    "composition": [
      13366,
      "/",
      24847,
      "/",
      13935
    ]
  },
  {
    "id": "25150",
    "description": "resign,quit_(1)-(to)",
    "pos": "RED",
    "explanation": "(resignation_(1) + action indicator)  SYMBOL SYNONYM",
    "isCharacter": false,
    "composition": [
      13935,
      ";",
      8993,
      "/",
      18273
    ]
  },
  {
    "id": "25151",
    "description": "resign,quit_(2)-(to)",
    "pos": "RED",
    "explanation": "(resignation_(2) + action indicator)  SYMBOL SYNONYM",
    "isCharacter": false,
    "composition": [
      13658,
      ";",
      8993,
      "/",
      18273
    ]
  },
  {
    "id": "25152",
    "description": "resignation_(1)",
    "pos": "YELLOW",
    "explanation": "(end + work: to stop (a) work)  SYMBOL SYNONYM",
    "isCharacter": false,
    "composition": [
      13935,
      "/",
      18273
    ]
  },
  {
    "id": "25153",
    "description": "resignation_(2)",
    "pos": "YELLOW",
    "explanation": "(departure + work: to leave (a) work)  SYMBOL SYNONYM",
    "isCharacter": false,
    "composition": [
      13658,
      "/",
      18273
    ]
  },
  {
    "id": "25154",
    "description": "retire-(to)",
    "pos": "RED",
    "explanation": "(retirement + action indicator)",
    "isCharacter": false,
    "composition": [
      13935,
      ";",
      8993,
      "/",
      18273,
      "/",
      18289
    ]
  },
  {
    "id": "25155",
    "description": "retired",
    "pos": "GREEN",
    "explanation": "(retirement + description indicator)",
    "isCharacter": false,
    "composition": [
      13935,
      ";",
      8998,
      "/",
      18273,
      "/",
      18289
    ]
  },
  {
    "id": "25156",
    "description": "retirement",
    "pos": "YELLOW",
    "explanation": "(resignation_(1) + year)",
    "isCharacter": false,
    "composition": [
      13935,
      "/",
      18273,
      "/",
      18289
    ]
  },
  {
    "id": "25157",
    "description": "roast,joint_(of_meat)",
    "pos": "YELLOW",
    "explanation": "(meat + big)",
    "isCharacter": false,
    "composition": [
      14377,
      "/",
      12378,
      "/",
      24875
    ]
  },
  {
    "id": "25158",
    "description": "robot",
    "pos": "YELLOW",
    "explanation": "(machine + activity + person)",
    "isCharacter": false,
    "composition": [
      15406,
      "/",
      12335,
      "/",
      16161
    ]
  },
  {
    "id": "25159",
    "description": "sack,dismiss-(to)",
    "pos": "RED",
    "explanation": "(dismissal + action indicator)",
    "isCharacter": false,
    "composition": [
      13935,
      ";",
      8993,
      "/",
      18273,
      "/",
      22914
    ]
  },
  {
    "id": "25160",
    "description": "sacked,dismissed",
    "pos": "GREEN",
    "explanation": "(dismissal + description indicator)",
    "isCharacter": false,
    "composition": [
      13935,
      ";",
      8998,
      "/",
      18273,
      "/",
      22914
    ]
  },
  {
    "id": "25161",
    "description": "sacking,dismissal",
    "pos": "YELLOW",
    "explanation": "(resignation_(1) + force)",
    "isCharacter": false,
    "composition": [
      13935,
      "/",
      18273,
      "/",
      22914
    ]
  },
  {
    "id": "25162",
    "description": "safari,wildlife_expedition",
    "pos": "YELLOW",
    "explanation": "(move,movement + see,look,watch-(to) + animal)",
    "isCharacter": false,
    "composition": [
      25119,
      "/",
      14133,
      "/",
      12378
    ]
  },
  {
    "id": "25163",
    "description": "Saturday_(day1)",
    "pos": "YELLOW",
    "explanation": "(day + 1 + six_(index_number): small 6 of ISO standard)  SYMBOL SYNONYM (replacing 16722)",
    "isCharacter": false,
    "composition": [
      13639,
      "/",
      8497,
      "/",
      8516
    ]
  },
  {
    "id": "25164",
    "description": "Saturday_(day6)",
    "pos": "YELLOW",
    "explanation": "(day + 6 + six_(index_number): small 6 of ISO standard)  SYMBOL SYNONYM (replacing 16722)",
    "isCharacter": false,
    "composition": [
      13639,
      "/",
      8502,
      "/",
      8516
    ]
  },
  {
    "id": "25165",
    "description": "Saturday_(day7)",
    "pos": "YELLOW",
    "explanation": "(day + 7 + six_(index_number): small 6 of ISO standard)  SYMBOL SYNONYM (replacing 16722)",
    "isCharacter": false,
    "composition": [
      13639,
      "/",
      8503,
      "/",
      8516
    ]
  },
  {
    "id": "25166",
    "description": "scoundrel,villain",
    "pos": "BLUE",
    "explanation": "(person + mean,cruel)",
    "isCharacter": false,
    "composition": [
      16161,
      "/",
      14164,
      "/",
      15159
    ]
  },
  {
    "id": "25167",
    "description": "protector,guard",
    "pos": "BLUE",
    "explanation": "(person + safety,security)",
    "isCharacter": false,
    "composition": [
      16161,
      "/",
      14164,
      "/",
      16420
    ]
  },
  {
    "id": "25168",
    "description": "Sniff",
    "pos": "BLUE",
    "explanation": "(imaginary person + scared: Literary figure in the Moomin books by Tove Jansson - friend of Moomin, a real coward, and very interested in money.)",
    "isCharacter": false,
    "composition": [
      23577,
      "/",
      14164,
      "/",
      13869,
      "/",
      25568
    ]
  },
  {
    "id": "25169",
    "description": "Snork",
    "pos": "BLUE",
    "explanation": "(imaginary person + imprint,depression + glasses: Literary figure in the Moomin books by Tove Jansson - The Snork Maiden's brother, wears glasses, inteligent, avid inventor who has strong belief in the power of science, imprint,depression represents soft [contraction])",
    "isCharacter": false,
    "composition": [
      23577,
      "/",
      25575,
      "/",
      14443
    ]
  },
  {
    "id": "25170",
    "description": "Snork_Maiden",
    "pos": "BLUE",
    "explanation": "(imaginary person + imprint,depression + ring: Literary figure in the Moomin books by Tove Jansson - Moomintroll's fair lady friend and admirer, and sports a golden anklet, imprint,depression represents soft [contraction])",
    "isCharacter": false,
    "composition": [
      23577,
      "/",
      25575,
      "/",
      16675
    ]
  },
  {
    "id": "25171",
    "description": "Snufkin",
    "pos": "BLUE",
    "explanation": "(imaginary person + boy + musical_instrument: Literary figure in the Moomin books by Tove Jansson - Moomintroll's best friend, who lives in a tent, smokes a pipe, and plays the harmonica.)",
    "isCharacter": false,
    "composition": [
      23577,
      "/",
      12888,
      "/",
      23904
    ]
  },
  {
    "id": "25172",
    "description": "solar_energy,solar_power",
    "pos": "YELLOW",
    "explanation": "(energy + sun)",
    "isCharacter": false,
    "composition": [
      13936,
      "/",
      17462
    ]
  },
  {
    "id": "25173",
    "description": "space_travel,space_voyage,space_flight",
    "pos": "YELLOW",
    "explanation": "(move,movement + galaxy)",
    "isCharacter": false,
    "composition": [
      25119,
      "/",
      24451
    ]
  },
  {
    "id": "25174",
    "description": "speech_(event)",
    "pos": "YELLOW",
    "explanation": "(say,speak,talk,tell,express-(to) + event + group of + person)",
    "isCharacter": false,
    "composition": [
      15666,
      "/",
      14114,
      "/",
      14647,
      "/",
      16161
    ]
  },
  {
    "id": "25175",
    "description": "secret_agent,spy",
    "pos": "BLUE",
    "explanation": "(person + secret + information)",
    "isCharacter": false,
    "composition": [
      16161,
      "/",
      16745,
      "/",
      23542
    ]
  },
  {
    "id": "25176",
    "description": "steak",
    "pos": "YELLOW",
    "explanation": "(meat + slice + thing indicator)",
    "isCharacter": false,
    "composition": [
      14377,
      "/",
      12378,
      "/",
      25622,
      ";",
      9009
    ]
  },
  {
    "id": "25177",
    "description": "still,calm,peaceful,tranquil",
    "pos": "GREEN",
    "explanation": "(without + back and forth + description indicator: back and forth representing movement,motion_(2) [contraction])",
    "isCharacter": false,
    "composition": [
      15474,
      "/",
      12610,
      ";",
      8998
    ]
  },
  {
    "id": "25178",
    "description": "stolen_goods",
    "pos": "YELLOW",
    "explanation": "(goods + theft)",
    "isCharacter": false,
    "composition": [
      14457,
      "/",
      24727,
      "/",
      15474,
      "/",
      14947
    ]
  },
  {
    "id": "25179",
    "description": "summary,abstract",
    "pos": "YELLOW",
    "explanation": "(content + information + short)",
    "isCharacter": false,
    "composition": [
      24897,
      "/",
      23542,
      "/",
      24938
    ]
  },
  {
    "id": "25180",
    "description": "Sunday_(day1)",
    "pos": "YELLOW",
    "explanation": "(day + 1 + seven_(index_number): small 7 of ISO standard)  SYMBOL SYNONYM (replacing 17464)",
    "isCharacter": false,
    "composition": [
      13639,
      "/",
      8497,
      "/",
      8517
    ]
  },
  {
    "id": "25181",
    "description": "Sunday_(day2)",
    "pos": "YELLOW",
    "explanation": "(day + 2 + seven_(index_number): small 7 of ISO standard)  SYMBOL SYNONYM (replacing 17464)",
    "isCharacter": false,
    "composition": [
      13639,
      "/",
      8498,
      "/",
      8517
    ]
  },
  {
    "id": "25182",
    "description": "Sunday_(day7)",
    "pos": "YELLOW",
    "explanation": "(day + 7 + seven_(index_number): small 7 of ISO standard)  SYMBOL SYNONYM (replacing 17464)",
    "isCharacter": false,
    "composition": [
      13639,
      "/",
      8503,
      "/",
      8517
    ]
  },
  {
    "id": "25183",
    "description": "supporters,cheering_section",
    "pos": "BLUE",
    "explanation": "(group + support_(oral) + intensity)",
    "isCharacter": false,
    "composition": [
      14647,
      "/",
      16161,
      "/",
      15666,
      "/",
      14382,
      "/",
      14947
    ]
  },
  {
    "id": "25184",
    "description": "Switzerland",
    "pos": "YELLOW",
    "explanation": "(country + clock + thing indicator)",
    "isCharacter": false,
    "composition": [
      13423,
      "/",
      17732,
      ";",
      9009
    ]
  },
  {
    "id": "25186",
    "description": "take_off_(rocket)-(to)",
    "pos": "RED",
    "explanation": "(takeoff_(rocket) + action indicator)",
    "isCharacter": false,
    "composition": [
      25614,
      ";",
      8993,
      "/",
      17983,
      "/",
      14947
    ]
  },
  {
    "id": "25187",
    "description": "takeoff_(rocket)",
    "pos": "YELLOW",
    "explanation": "(rocket,spaceship + intensity)",
    "isCharacter": false,
    "composition": [
      25614,
      "/",
      17983,
      "/",
      14947
    ]
  },
  {
    "id": "25189",
    "description": "technology",
    "pos": "YELLOW",
    "explanation": "(generalization + machine)",
    "isCharacter": false,
    "composition": [
      14430,
      "/",
      15406
    ]
  },
  {
    "id": "25190",
    "description": "The_Groke",
    "pos": "BLUE",
    "explanation": "(imaginary person + coldness,cold: Literary figure in the Moomin books by Tove Jansson - She is cold and ghostlike, and represents loneliness and all that is scary in the world of Moomin.)",
    "isCharacter": false,
    "composition": [
      23577,
      "/",
      25533
    ]
  },
  {
    "id": "25191",
    "description": "theft",
    "pos": "YELLOW",
    "explanation": "(receiving + negative)",
    "isCharacter": false,
    "composition": [
      24727,
      "/",
      15474,
      "/",
      14947
    ]
  },
  {
    "id": "25192",
    "description": "thrilling,scary",
    "pos": "GREEN",
    "explanation": "(feeling + expectation,anticipation + intensity + description indicator)",
    "isCharacter": false,
    "composition": [
      14164,
      ";",
      8998,
      "/",
      14128,
      "/",
      14947
    ]
  },
  {
    "id": "25193",
    "description": "Thursday_(day4)",
    "pos": "YELLOW",
    "explanation": "(day + 4 + four_(index_number): small 4 of ISO standard)  SYMBOL SYNONYM (replacing 17728)",
    "isCharacter": false,
    "composition": [
      13639,
      "/",
      8500,
      "/",
      8514
    ]
  },
  {
    "id": "25194",
    "description": "Thursday_(day5)",
    "pos": "YELLOW",
    "explanation": "(day + 5 + four_(index_number): small 4 of ISO standard)  SYMBOL SYNONYM (replacing 17728)",
    "isCharacter": false,
    "composition": [
      13639,
      "/",
      8501,
      "/",
      8514
    ]
  },
  {
    "id": "25195",
    "description": "Thursday_(day6)",
    "pos": "YELLOW",
    "explanation": "(day + 6 + four_(index_number): small 4 of ISO standard)  SYMBOL SYNONYM (replacing 17728)",
    "isCharacter": false,
    "composition": [
      13639,
      "/",
      8502,
      "/",
      8514
    ]
  },
  {
    "id": "25196",
    "description": "Toffle",
    "pos": "BLUE",
    "explanation": "(imaginary person + sadness,sorrow,unhappiness: Literary figure in the Moomin books by Tove Jansson - Toffles are small creatures, shy, scared and confused. \"Toffle\" is the main character in Who Will Comfort Toffle?.)",
    "isCharacter": false,
    "composition": [
      23577,
      "/",
      14164,
      "/",
      13869
    ]
  },
  {
    "id": "25198",
    "description": "tour,sightseeing",
    "pos": "YELLOW",
    "explanation": "(move,movement + to see)",
    "isCharacter": false,
    "composition": [
      25119,
      "/",
      14133
    ]
  },
  {
    "id": "25199",
    "description": "trap",
    "pos": "YELLOW",
    "explanation": "(thing + capture + plan)",
    "isCharacter": false,
    "composition": [
      17717,
      "/",
      24727,
      "/",
      14947,
      "/",
      16194
    ]
  },
  {
    "id": "25200",
    "description": "trap-(to)",
    "pos": "RED",
    "explanation": "(trap + action indicator)",
    "isCharacter": false,
    "composition": [
      17717,
      ";",
      8993,
      "/",
      24727,
      "/",
      14947,
      "/",
      16194
    ]
  },
  {
    "id": "25201",
    "description": "hidden_treasure,treasure_trove",
    "pos": "YELLOW",
    "explanation": "(jewel + secret)",
    "isCharacter": false,
    "composition": [
      17267,
      "/",
      17252,
      "/",
      16745
    ]
  },
  {
    "id": "25202",
    "description": "tropical_rain_forest,jungle",
    "pos": "YELLOW",
    "explanation": "(grove + equator: grove representing forest [contraction])",
    "isCharacter": false,
    "composition": [
      14647,
      "/",
      17775,
      "/",
      22598
    ]
  },
  {
    "id": "25203",
    "description": "Tuesday_(day2)",
    "pos": "YELLOW",
    "explanation": "(day + 2 + two_(index_number): small 2 of ISO standard)  SYMBOL SYNONYM (replacing 17790)",
    "isCharacter": false,
    "composition": [
      13639,
      "/",
      8498,
      "/",
      8512
    ]
  },
  {
    "id": "25204",
    "description": "Tuesday_(day3)",
    "pos": "YELLOW",
    "explanation": "(day + 3 + two_(index_number): small 2 of ISO standard)  SYMBOL SYNONYM (replacing 17790)",
    "isCharacter": false,
    "composition": [
      13639,
      "/",
      8499,
      "/",
      8512
    ]
  },
  {
    "id": "25205",
    "description": "Tuesday_(day4)",
    "pos": "YELLOW",
    "explanation": "(day + 4 + two_(index_number): small 2 of ISO standard)  SYMBOL SYNONYM (replacing 17790)",
    "isCharacter": false,
    "composition": [
      13639,
      "/",
      8500,
      "/",
      8512
    ]
  },
  {
    "id": "25206",
    "description": "Turkey",
    "pos": "YELLOW",
    "explanation": "(country + bazaar)",
    "isCharacter": false,
    "composition": [
      13423,
      "/",
      14647,
      "/",
      23223,
      "/",
      24917
    ]
  },
  {
    "id": "25207",
    "description": "Ukraine",
    "pos": "YELLOW",
    "explanation": "(country + wheat)",
    "isCharacter": false,
    "composition": [
      13423,
      "/",
      14625,
      "/",
      15474,
      "/",
      15214,
      ";",
      9009
    ]
  },
  {
    "id": "25208",
    "description": "usually_do,habitually_do-(to)",
    "pos": "YELLOW",
    "explanation": "(habit,custom + action indicator)",
    "isCharacter": false,
    "composition": [
      12335,
      ";",
      8993,
      "/",
      24944,
      "/",
      17732
    ]
  },
  {
    "id": "25209",
    "description": "vampire",
    "pos": "BLUE",
    "explanation": "(imaginary person + blood)",
    "isCharacter": false,
    "composition": [
      23577,
      "/",
      18209,
      "/",
      15206
    ]
  },
  {
    "id": "25210",
    "description": "warn-(to)",
    "pos": "RED",
    "explanation": "(warning + action indicator)",
    "isCharacter": false,
    "composition": [
      15666,
      ";",
      8993,
      "/",
      13632
    ]
  },
  {
    "id": "25211",
    "description": "warning",
    "pos": "YELLOW",
    "explanation": "(say,speak,talk,tell,express-(to) + danger)",
    "isCharacter": false,
    "composition": [
      15666,
      "/",
      13632
    ]
  },
  {
    "id": "25212",
    "description": "wave_power,wave_energy",
    "pos": "YELLOW",
    "explanation": "(energy + wave)",
    "isCharacter": false,
    "composition": [
      13936,
      "/",
      21880
    ]
  },
  {
    "id": "25213",
    "description": "weapon",
    "pos": "YELLOW",
    "explanation": "(tool + death)",
    "isCharacter": false,
    "composition": [
      17755,
      "/",
      13645
    ]
  },
  {
    "id": "25214",
    "description": "Wednesday_(day3)",
    "pos": "YELLOW",
    "explanation": "(day + 3 + three_(index_number): small 3 of ISO standard)  SYMBOL SYNONYM (replacing 18216)",
    "isCharacter": false,
    "composition": [
      13639,
      "/",
      8499,
      "/",
      8513
    ]
  },
  {
    "id": "25215",
    "description": "Wednesday_(day4)",
    "pos": "YELLOW",
    "explanation": "(day + 4 + three_(index_number): small 3 of ISO standard)  SYMBOL SYNONYM (replacing 18216)",
    "isCharacter": false,
    "composition": [
      13639,
      "/",
      8500,
      "/",
      8513
    ]
  },
  {
    "id": "25216",
    "description": "Wednesday_(day5)",
    "pos": "YELLOW",
    "explanation": "(day + 5 + three_(index_number): small 3 of ISO standard)  SYMBOL SYNONYM (replacing 18216)",
    "isCharacter": false,
    "composition": [
      13639,
      "/",
      8501,
      "/",
      8513
    ]
  },
  {
    "id": "25217",
    "description": "weekend",
    "pos": "YELLOW",
    "explanation": "(end + week) (Added week day number neutral) SYMBOL SYNONYM",
    "isCharacter": false,
    "composition": [
      13935,
      "/",
      8503,
      "/",
      13639
    ]
  },
  {
    "id": "25218",
    "description": "werewolf",
    "pos": "BLUE",
    "explanation": "(imaginary person + wolf)",
    "isCharacter": false,
    "composition": [
      23577,
      "/",
      12380,
      "/",
      15923
    ]
  },
  {
    "id": "25220",
    "description": "wind_power,wind_energy,wind_farm",
    "pos": "YELLOW",
    "explanation": "(energy + wind)",
    "isCharacter": false,
    "composition": [
      13936,
      "/",
      18255
    ]
  },
  {
    "id": "25221",
    "description": "worn-out,raddled",
    "pos": "GREEN",
    "explanation": "(usage,use + end + description indicator)",
    "isCharacter": false,
    "composition": [
      24847,
      ";",
      8998,
      "/",
      13935
    ]
  },
  {
    "id": "25222",
    "description": "zombie",
    "pos": "BLUE",
    "explanation": "(imaginary person + dead + walk)",
    "isCharacter": false,
    "composition": [
      23577,
      "/",
      13645,
      "/",
      15189
    ]
  },
  {
    "id": "25223",
    "description": "touch,touching",
    "pos": "YELLOW",
    "explanation": "(activity + hand)",
    "isCharacter": false,
    "composition": [
      12335,
      "/",
      "RK:-2",
      "/",
      14667
    ]
  },
  {
    "id": "25250",
    "description": "airforce,air_force",
    "pos": "BLUE",
    "explanation": "(military,armed_forces,armed_services + sky)",
    "isCharacter": false,
    "composition": [
      14647,
      "/",
      16161,
      "/",
      18036,
      "/",
      17006
    ]
  },
  {
    "id": "25251",
    "description": "airport_terminal",
    "pos": "YELLOW",
    "explanation": "(public room + airplane)",
    "isCharacter": false,
    "composition": [
      16430,
      "/",
      12357
    ]
  },
  {
    "id": "25252",
    "description": "air_traffic_controller",
    "pos": "BLUE",
    "explanation": "(leader + group of + airplane)",
    "isCharacter": false,
    "composition": [
      21054,
      "/",
      14647,
      "/",
      12357
    ]
  },
  {
    "id": "25253",
    "description": "alarm",
    "pos": "YELLOW",
    "explanation": "(tool + noise_(loud) + intensity)",
    "isCharacter": false,
    "composition": [
      17755,
      "/",
      17216,
      "/",
      14947,
      "/",
      14947
    ]
  },
  {
    "id": "25254",
    "description": "alternate-(to)",
    "pos": "RED",
    "explanation": "(alternation + action indicator)",
    "isCharacter": false,
    "composition": [
      25257,
      ";",
      8993
    ]
  },
  {
    "id": "25255",
    "description": "alternating",
    "pos": "GREEN",
    "explanation": "(alternation + description indicator)",
    "isCharacter": false,
    "composition": [
      25257,
      ";",
      8998
    ]
  },
  {
    "id": "25256",
    "description": "alternating_current,AC",
    "pos": "YELLOW",
    "explanation": "(stream + electricity + alternation)",
    "isCharacter": false,
    "composition": [
      16677,
      "/",
      13918,
      "/",
      25257
    ]
  },
  {
    "id": "25257",
    "description": "alternation",
    "pos": "YELLOW",
    "explanation": "(forward + backward [modification, short arrows])  Character (superimposed - modified)",
    "isCharacter": true
  },
  {
    "id": "25258",
    "description": "ammeter",
    "pos": "YELLOW",
    "explanation": "(gauge + electric current + thing indicator)",
    "isCharacter": false,
    "composition": [
      24806,
      ";",
      9009,
      "/",
      16677,
      "/",
      13918
    ]
  },
  {
    "id": "25259",
    "description": "amplitude",
    "pos": "YELLOW",
    "explanation": "(measurement + height,tallness + wave)",
    "isCharacter": false,
    "composition": [
      15443,
      "/",
      24909,
      "/",
      21880
    ]
  },
  {
    "id": "25260",
    "description": "Arabic_(language)",
    "pos": "YELLOW",
    "explanation": "(language + Muslim,Moslem,Islamic)",
    "isCharacter": false,
    "composition": [
      15172,
      "/",
      17252,
      "/",
      15651
    ]
  },
  {
    "id": "25261",
    "description": "attack",
    "pos": "YELLOW",
    "explanation": "(activity + war)",
    "isCharacter": false,
    "composition": [
      12335,
      "/",
      18036
    ]
  },
  {
    "id": "25262",
    "description": "attack-(to)",
    "pos": "RED",
    "explanation": "(attack + action indicator)",
    "isCharacter": false,
    "composition": [
      12335,
      ";",
      8993,
      "/",
      18036
    ]
  },
  {
    "id": "25263",
    "description": "Batman",
    "pos": "YELLOW",
    "explanation": "(make-believe person + bat_(animal))",
    "isCharacter": false,
    "composition": [
      23576,
      "/",
      12636
    ]
  },
  {
    "id": "25264",
    "description": "bedbug,wall_louse",
    "pos": "YELLOW",
    "explanation": "(louse,stinging_insect + indoor)",
    "isCharacter": false,
    "composition": [
      14943,
      "/",
      16212,
      "/",
      22116
    ]
  },
  {
    "id": "25265",
    "description": "beige",
    "pos": "WHITE",
    "explanation": "(colour + earth,ground,land + snow: combination of brown and white)",
    "isCharacter": false,
    "composition": [
      13377,
      "/",
      13901,
      "/",
      17192
    ]
  },
  {
    "id": "25266",
    "description": "biathlon",
    "pos": "YELLOW",
    "explanation": "(sport + skies + gun)",
    "isCharacter": false,
    "composition": [
      20518,
      "/",
      8498,
      "/",
      25610,
      "/",
      14655
    ]
  },
  {
    "id": "25267",
    "description": "bird_of_prey,raptor,falcon,hawk,eagle",
    "pos": "YELLOW",
    "explanation": "(bird + pictograph of claws)  - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "25268",
    "description": "bless-(to)",
    "pos": "RED",
    "explanation": "(give + peace + protection + action indicator)",
    "isCharacter": false,
    "composition": [
      24903,
      ";",
      8993,
      "/",
      15981,
      "/",
      16420
    ]
  },
  {
    "id": "25269",
    "description": "have_a_view,have_an_opinion-(to)",
    "pos": "RED",
    "explanation": "(opinion + action indicator)",
    "isCharacter": false,
    "composition": [
      15925,
      ";",
      8993
    ]
  },
  {
    "id": "25270",
    "description": "cabin_(airplane)",
    "pos": "YELLOW",
    "explanation": "(room + airplane)",
    "isCharacter": false,
    "composition": [
      16687,
      "/",
      12357
    ]
  },
  {
    "id": "25271",
    "description": "camping_mat,sleeping_mat",
    "pos": "YELLOW",
    "explanation": "(cloth + reclining,lying_(person_lying_down): can be viewed as a combination of rug,carpet,mat and reclining)",
    "isCharacter": false,
    "composition": [
      13365,
      "/",
      16163
    ]
  },
  {
    "id": "25272",
    "description": "camping_stove",
    "pos": "YELLOW",
    "explanation": "(stove + carry)",
    "isCharacter": false,
    "composition": [
      14185,
      "/",
      24714
    ]
  },
  {
    "id": "25273",
    "description": "carve-(to)",
    "pos": "RED",
    "explanation": "(knife + shape + action indicator)",
    "isCharacter": false,
    "composition": [
      15159,
      ";",
      8993,
      "/",
      14133,
      "/",
      17717
    ]
  },
  {
    "id": "25274",
    "description": "chase",
    "pos": "YELLOW",
    "explanation": "(forward + forward) – Character (sequenced)",
    "isCharacter": true
  },
  {
    "id": "25275",
    "description": "chase-(to)",
    "pos": "RED",
    "explanation": "(chase + action indicator)",
    "isCharacter": false,
    "composition": [
      25274,
      ";",
      8993
    ]
  },
  {
    "id": "25276",
    "description": "cipher",
    "pos": "YELLOW",
    "explanation": "(alphabet,letters_(lowercase) + secret)",
    "isCharacter": false,
    "composition": [
      "Xa",
      "/",
      "Xb",
      "/",
      "Xc",
      "/",
      16745
    ]
  },
  {
    "id": "25277",
    "description": "closed",
    "pos": "GREEN",
    "explanation": "(enclosure + description indicator)",
    "isCharacter": false,
    "composition": [
      13934,
      ";",
      8998
    ]
  },
  {
    "id": "25278",
    "description": "clue",
    "pos": "YELLOW",
    "explanation": "(information + to + answer)",
    "isCharacter": false,
    "composition": [
      23542,
      "/",
      17739,
      "/",
      12393
    ]
  },
  {
    "id": "25279",
    "description": "cousin_(male)",
    "pos": "BLUE",
    "explanation": "(son + sibling(s) + parent: the son of an uncle or aunt)",
    "isCharacter": false,
    "composition": [
      17209,
      "/",
      15912,
      "/",
      8498,
      "/",
      15968
    ]
  },
  {
    "id": "25280",
    "description": "cousin_(female)",
    "pos": "BLUE",
    "explanation": "(daughter + sibling(s) + parent: the son of an uncle or aunt)",
    "isCharacter": false,
    "composition": [
      13638,
      "/",
      15912,
      "/",
      8498,
      "/",
      15968
    ]
  },
  {
    "id": "25281",
    "description": "direct_current,DC",
    "pos": "YELLOW",
    "explanation": "(electric current + forward)",
    "isCharacter": false,
    "composition": [
      16677,
      "/",
      13918,
      "/",
      14390
    ]
  },
  {
    "id": "25282",
    "description": "cylinder_for_breathing",
    "pos": "YELLOW",
    "explanation": "(cylinder + breathing)",
    "isCharacter": false,
    "composition": [
      13115,
      "/",
      15732,
      "/",
      15666
    ]
  },
  {
    "id": "25283",
    "description": "Danish_(language)_(OLD)",
    "pos": "YELLOW",
    "explanation": "(language + three_Danish_waters_(OLD): based on Denmark_(OLD) [contraction])  SUPERSEDED SYNONYM  See Danish_(language) 25990",
    "isCharacter": false,
    "composition": [
      15172,
      "/",
      25623
    ]
  },
  {
    "id": "25285",
    "description": "digital_memory,RAM",
    "pos": "YELLOW",
    "explanation": "(memory + digits_(computer))",
    "isCharacter": false,
    "composition": [
      23589,
      "/",
      23476
    ]
  },
  {
    "id": "25286",
    "description": "Egypt",
    "pos": "YELLOW",
    "explanation": "(country + pyramid)",
    "isCharacter": false,
    "composition": [
      13423,
      "/",
      16443
    ]
  },
  {
    "id": "25287",
    "description": "electric_circuit",
    "pos": "YELLOW",
    "explanation": "(ring + electricity)",
    "isCharacter": false,
    "composition": [
      16675,
      "/",
      13918
    ]
  },
  {
    "id": "25288",
    "description": "electric_conductor_(OLD)",
    "pos": "YELLOW",
    "explanation": "(through + electricity + thing indicator)",
    "isCharacter": false,
    "composition": [
      17724,
      ";",
      9009,
      "/",
      13918
    ]
  },
  {
    "id": "25289",
    "description": "electric_current",
    "pos": "YELLOW",
    "explanation": "(stream + electricity)",
    "isCharacter": false,
    "composition": [
      16677,
      "/",
      13918
    ]
  },
  {
    "id": "25290",
    "description": "electric_field",
    "pos": "YELLOW",
    "explanation": "(pointer (left) + electricity + pointer (right): suggesting  the field of force surrounding an electrically charged particle or varying magnetic field) - Character (superimposed - pointer)",
    "isCharacter": true
  },
  {
    "id": "25291",
    "description": "electric_insulator,electrical_insulator",
    "pos": "YELLOW",
    "explanation": "(impermeable_material,insulation_(material) + electricity)",
    "isCharacter": false,
    "composition": [
      15431,
      "/",
      13935,
      "/",
      13918
    ]
  },
  {
    "id": "25292",
    "description": "electro_magnet",
    "pos": "YELLOW",
    "explanation": "(thing + magnetism + electricity)",
    "isCharacter": false,
    "composition": [
      17717,
      "/",
      25340,
      "/",
      13918
    ]
  },
  {
    "id": "25293",
    "description": "engagement",
    "pos": "YELLOW",
    "explanation": "(before + marriage)",
    "isCharacter": false,
    "composition": [
      12656,
      "/",
      15425
    ]
  },
  {
    "id": "25295",
    "description": "Estonian_(language)",
    "pos": "YELLOW",
    "explanation": "(language + Estonia)",
    "isCharacter": false,
    "composition": [
      15172,
      "/",
      13423,
      "/",
      15666,
      "/",
      15682
    ]
  },
  {
    "id": "25296",
    "description": "fiance,groom-to-be",
    "pos": "BLUE",
    "explanation": "(man + engagement)",
    "isCharacter": false,
    "composition": [
      15416,
      "/",
      12656,
      "/",
      15425
    ]
  },
  {
    "id": "25297",
    "description": "fiancee,bride-to-be",
    "pos": "BLUE",
    "explanation": "(woman + engagement)",
    "isCharacter": false,
    "composition": [
      18269,
      "/",
      12656,
      "/",
      15425
    ]
  },
  {
    "id": "25298",
    "description": "fingerprint",
    "pos": "YELLOW",
    "explanation": "(imprint + finger)",
    "isCharacter": false,
    "composition": [
      13910,
      "/",
      24422,
      "/",
      14180
    ]
  },
  {
    "id": "25299",
    "description": "Finnish_(class)",
    "pos": "YELLOW",
    "explanation": "(class [contraction] + Finnish)",
    "isCharacter": false,
    "composition": [
      15162,
      "/",
      15172,
      "/",
      17257,
      "/",
      17267
    ]
  },
  {
    "id": "25300",
    "description": "Finnish_(language)",
    "pos": "YELLOW",
    "explanation": "(language + Finland [contraction])",
    "isCharacter": false,
    "composition": [
      15172,
      "/",
      17257,
      "/",
      17267
    ]
  },
  {
    "id": "25301",
    "description": "fire_extinguisher",
    "pos": "YELLOW",
    "explanation": "(cylinder + extinction,extinguishing_(fire))",
    "isCharacter": false,
    "composition": [
      13115,
      "/",
      25556
    ]
  },
  {
    "id": "25302",
    "description": "fire_place,campfire_site",
    "pos": "YELLOW",
    "explanation": "(place + stove)",
    "isCharacter": false,
    "composition": [
      16193,
      "/",
      14185
    ]
  },
  {
    "id": "25303",
    "description": "firecraft",
    "pos": "YELLOW",
    "explanation": "(knowledge + activity + fire)",
    "isCharacter": false,
    "composition": [
      15162,
      "/",
      12335,
      "/",
      14183
    ]
  },
  {
    "id": "25304",
    "description": "first_aid_kit",
    "pos": "YELLOW",
    "explanation": "(medical aid + first + thing indicator)",
    "isCharacter": false,
    "composition": [
      14704,
      ";",
      9009,
      "/",
      24920,
      "/",
      8497,
      "/",
      8486
    ]
  },
  {
    "id": "25305",
    "description": "fish_bone",
    "pos": "YELLOW",
    "explanation": "(bone + fish)",
    "isCharacter": false,
    "composition": [
      12873,
      "/",
      14188
    ]
  },
  {
    "id": "25306",
    "description": "flight_instrument(s)",
    "pos": "YELLOW",
    "explanation": "(gauge + airplane + thing indicator)",
    "isCharacter": false,
    "composition": [
      24806,
      ";",
      9009,
      "/",
      12357
    ]
  },
  {
    "id": "25307",
    "description": "flight_deck,cockpit",
    "pos": "YELLOW",
    "explanation": "(room + pilot)",
    "isCharacter": false,
    "composition": [
      16687,
      "/",
      16161,
      "/",
      12357
    ]
  },
  {
    "id": "25308",
    "description": "footprint",
    "pos": "YELLOW",
    "explanation": "(imprint,trace,track + foot)",
    "isCharacter": false,
    "composition": [
      13910,
      "/",
      24422,
      "/",
      14379
    ]
  },
  {
    "id": "25309",
    "description": "French_(language)",
    "pos": "YELLOW",
    "explanation": "(language + France [contraction])",
    "isCharacter": false,
    "composition": [
      15172,
      "/",
      14635,
      "/",
      14424,
      "/",
      14947
    ]
  },
  {
    "id": "25310",
    "description": "frequency_(wave_motion)",
    "pos": "YELLOW",
    "explanation": "(frequency + wave)",
    "isCharacter": false,
    "composition": [
      15742,
      "/",
      15212,
      "/",
      21880
    ]
  },
  {
    "id": "25311",
    "description": "front,front_of_a_thing",
    "pos": "WHITE",
    "explanation": "(thing + pointer: pointer pointing to the left on the \"front\" right-hand side of the thing) - Character (superimposed - pointer)",
    "isCharacter": true
  },
  {
    "id": "25312",
    "description": "full,satisfied",
    "pos": "GREEN",
    "explanation": "(feeling + full + food + description indicator)",
    "isCharacter": false,
    "composition": [
      14164,
      ";",
      8998,
      "/",
      24897,
      "/",
      14377
    ]
  },
  {
    "id": "25313",
    "description": "fuse",
    "pos": "YELLOW",
    "explanation": "(thing + protection + electricity)",
    "isCharacter": false,
    "composition": [
      17717,
      "/",
      16420,
      "/",
      13918
    ]
  },
  {
    "id": "25314",
    "description": "fuselage",
    "pos": "YELLOW",
    "explanation": "(body + airplane)",
    "isCharacter": false,
    "composition": [
      12870,
      "/",
      12357
    ]
  },
  {
    "id": "25315",
    "description": "gas_cylinder",
    "pos": "YELLOW",
    "explanation": "(cylinder + gas)",
    "isCharacter": false,
    "composition": [
      13115,
      "/",
      14424
    ]
  },
  {
    "id": "25316",
    "description": "gathering_of_scouts,jamboree",
    "pos": "YELLOW",
    "explanation": "(gathering + scouting)",
    "isCharacter": false,
    "composition": [
      14427,
      "/",
      15162,
      "/",
      12335,
      "/",
      14704
    ]
  },
  {
    "id": "25317",
    "description": "hangar",
    "pos": "YELLOW",
    "explanation": "(garage + airplane)",
    "isCharacter": false,
    "composition": [
      14420,
      "/",
      12357
    ]
  },
  {
    "id": "25318",
    "description": "head_louse",
    "pos": "YELLOW",
    "explanation": "(louse,stinging_insect + hair)",
    "isCharacter": false,
    "composition": [
      14943,
      "/",
      16212,
      "/",
      14660
    ]
  },
  {
    "id": "25319",
    "description": "headset",
    "pos": "YELLOW",
    "explanation": "(earmuffs + signal)",
    "isCharacter": false,
    "composition": [
      24889,
      "/",
      24750
    ]
  },
  {
    "id": "25320",
    "description": "hike-(to)",
    "pos": "RED",
    "explanation": "(hiking + action indicator)",
    "isCharacter": false,
    "composition": [
      12335,
      ";",
      8993,
      "/",
      15189,
      "/",
      15923
    ]
  },
  {
    "id": "25321",
    "description": "hiking",
    "pos": "YELLOW",
    "explanation": "(activity + legs and feet + open)",
    "isCharacter": false,
    "composition": [
      12335,
      "/",
      15189,
      "/",
      15923
    ]
  },
  {
    "id": "25322",
    "description": "Icelandic_(language)",
    "pos": "YELLOW",
    "explanation": "(language + ice + fire: ice + fire representing Iceland [contraction])",
    "isCharacter": false,
    "composition": [
      15172,
      "/",
      14919,
      "/",
      14183
    ]
  },
  {
    "id": "25323",
    "description": "illustrate-(to)",
    "pos": "RED",
    "explanation": "(illustration + action indicator)",
    "isCharacter": false,
    "composition": [
      23583,
      ";",
      8993,
      "/",
      14133,
      "/",
      13934
    ]
  },
  {
    "id": "25324",
    "description": "illustrated,illustrating",
    "pos": "GREEN",
    "explanation": "(illustration + description indicator)",
    "isCharacter": false,
    "composition": [
      23583,
      ";",
      8998,
      "/",
      14133,
      "/",
      13934
    ]
  },
  {
    "id": "25325",
    "description": "illustration",
    "pos": "YELLOW",
    "explanation": "(making,production,fashioning + picture)",
    "isCharacter": false,
    "composition": [
      23583,
      "/",
      14133,
      "/",
      13934
    ]
  },
  {
    "id": "25326",
    "description": "impermeable_material,insulation_(material)",
    "pos": "YELLOW",
    "explanation": "(material + stop)",
    "isCharacter": false,
    "composition": [
      15431,
      "/",
      13935
    ]
  },
  {
    "id": "25327",
    "description": "imprint,trace,track",
    "pos": "YELLOW",
    "explanation": "(effect + bump,press,pressing)",
    "isCharacter": false,
    "composition": [
      13910,
      "/",
      24422
    ]
  },
  {
    "id": "25328",
    "description": "inhaler",
    "pos": "YELLOW",
    "explanation": "(medical aid + breath)",
    "isCharacter": false,
    "composition": [
      14704,
      ";",
      9009,
      "/",
      24920,
      "/",
      15732,
      "/",
      15666
    ]
  },
  {
    "id": "25329",
    "description": "insomnia",
    "pos": "YELLOW",
    "explanation": "(state of mind + without + sleep)",
    "isCharacter": false,
    "composition": [
      25379,
      "/",
      15474,
      "/",
      17008
    ]
  },
  {
    "id": "25330",
    "description": "Iran",
    "pos": "YELLOW",
    "explanation": "(country + poetry)",
    "isCharacter": false,
    "composition": [
      13423,
      "/",
      25585,
      "/",
      14164
    ]
  },
  {
    "id": "25331",
    "description": "Irish_(language)",
    "pos": "YELLOW",
    "explanation": "(language + shamrock: shamrock representing Ireland [contraction])",
    "isCharacter": false,
    "composition": [
      15172,
      "/",
      16939
    ]
  },
  {
    "id": "25332",
    "description": "Italian_(language)",
    "pos": "YELLOW",
    "explanation": "(language + opera: opera representing Italy [contraction])",
    "isCharacter": false,
    "composition": [
      15172,
      "/",
      15666,
      "/",
      15682,
      "/",
      20524
    ]
  },
  {
    "id": "25333",
    "description": "ladybird",
    "pos": "YELLOW",
    "explanation": "(bug + dot)",
    "isCharacter": false,
    "composition": [
      12655,
      "/",
      14133,
      "/",
      13867
    ]
  },
  {
    "id": "25334",
    "description": "landing_gear",
    "pos": "YELLOW",
    "explanation": "(wheel + airplane)",
    "isCharacter": false,
    "composition": [
      18232,
      "/",
      12357
    ]
  },
  {
    "id": "25335",
    "description": "lifeline",
    "pos": "YELLOW",
    "explanation": "(strap,string,velcro,rope,cord + help)",
    "isCharacter": false,
    "composition": [
      15214,
      ";",
      9009,
      "/",
      23409,
      "/",
      14704
    ]
  },
  {
    "id": "25336",
    "description": "light_(weight)",
    "pos": "GREEN",
    "explanation": "(weight + little + description indicator)",
    "isCharacter": false,
    "composition": [
      18221,
      ";",
      8998,
      "/",
      24917
    ]
  },
  {
    "id": "25337",
    "description": "liquid",
    "pos": "YELLOW",
    "explanation": "(generalization + water)",
    "isCharacter": false,
    "composition": [
      14430,
      "/",
      18209
    ]
  },
  {
    "id": "25338",
    "description": "magnet",
    "pos": "YELLOW",
    "explanation": "(thing + magnetism)",
    "isCharacter": false,
    "composition": [
      17717,
      "/",
      25340
    ]
  },
  {
    "id": "25339",
    "description": "magnetic_field",
    "pos": "YELLOW",
    "explanation": "(pointer (left) + magnetism + pointer (right): suggesting the lines of force surrounding a permanent magnet or a moving charged particle)  - Character (superimposed - pointer)",
    "isCharacter": true
  },
  {
    "id": "25340",
    "description": "magnetism",
    "pos": "YELLOW",
    "explanation": "(metal bar + pictograph of lines of flux)  - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "25341",
    "description": "make_and_tend_a_fire-(to)",
    "pos": "RED",
    "explanation": "(activity + fire + action indicator)",
    "isCharacter": false,
    "composition": [
      12335,
      ";",
      8993,
      "/",
      14183
    ]
  },
  {
    "id": "25342",
    "description": "medication_for_breathing",
    "pos": "YELLOW",
    "explanation": "(medicine + breath)",
    "isCharacter": false,
    "composition": [
      13158,
      "/",
      24920,
      "/",
      15732,
      "/",
      15666
    ]
  },
  {
    "id": "25343",
    "description": "memory_game,Kim's_game",
    "pos": "YELLOW",
    "explanation": "(game [contraction] + memory)",
    "isCharacter": false,
    "composition": [
      12335,
      "/",
      "RK:-2",
      "/",
      14164,
      "/",
      23589
    ]
  },
  {
    "id": "25344",
    "description": "national",
    "pos": "GREEN",
    "explanation": "(country + descripton indicator)",
    "isCharacter": false,
    "composition": [
      13423,
      ";",
      8998
    ]
  },
  {
    "id": "25345",
    "description": "national_day",
    "pos": "YELLOW",
    "explanation": "(day + country)",
    "isCharacter": false,
    "composition": [
      13639,
      "/",
      13423
    ]
  },
  {
    "id": "25346",
    "description": "navigate_airplane-(to)",
    "pos": "RED",
    "explanation": "(activity + sign,signal + airplane + action indicator)",
    "isCharacter": false,
    "composition": [
      12335,
      ";",
      8993,
      "/",
      17717,
      "/",
      23542,
      "/",
      12357
    ]
  },
  {
    "id": "25347",
    "description": "Norwegian_(language)",
    "pos": "YELLOW",
    "explanation": "(language + fjord: fjord representing Norway [contraction])",
    "isCharacter": false,
    "composition": [
      15172,
      "/",
      22613
    ]
  },
  {
    "id": "25348",
    "description": "organization,organizing",
    "pos": "YELLOW",
    "explanation": "(plan + many + thing)",
    "isCharacter": false,
    "composition": [
      16194,
      "/",
      14647,
      "/",
      17717
    ]
  },
  {
    "id": "25349",
    "description": "orienteer_(sport)-(to)",
    "pos": "RED",
    "explanation": "(orienteering_(sport) + action indicator)",
    "isCharacter": false,
    "composition": [
      20518,
      ";",
      8993,
      "/",
      15962,
      "/",
      13901
    ]
  },
  {
    "id": "25350",
    "description": "orienteer,read_map-(to)",
    "pos": "RED",
    "explanation": "(map_reading + action indicator)",
    "isCharacter": false,
    "composition": [
      12335,
      ";",
      8993,
      "/",
      15962,
      "/",
      13901
    ]
  },
  {
    "id": "25351",
    "description": "orienteering_(sport)",
    "pos": "YELLOW",
    "explanation": "(sport + map)",
    "isCharacter": false,
    "composition": [
      20518,
      "/",
      15962,
      "/",
      13901
    ]
  },
  {
    "id": "25352",
    "description": "map_reading",
    "pos": "YELLOW",
    "explanation": "(activity + map)",
    "isCharacter": false,
    "composition": [
      12335,
      "/",
      15962,
      "/",
      13901
    ]
  },
  {
    "id": "25354",
    "description": "PEP_mask",
    "pos": "YELLOW",
    "explanation": "(breathing aid + pressure + thing indicator)",
    "isCharacter": false,
    "composition": [
      14704,
      ";",
      9009,
      "/",
      15732,
      "/",
      15666,
      "/",
      23169
    ]
  },
  {
    "id": "25355",
    "description": "perch_(fish)",
    "pos": "YELLOW",
    "explanation": "(fish + quill(s),spine(s))",
    "isCharacter": false,
    "composition": [
      14188,
      "/",
      23627
    ]
  },
  {
    "id": "25356",
    "description": "period_(wave_motion)",
    "pos": "YELLOW",
    "explanation": "(limited time + wave)",
    "isCharacter": false,
    "composition": [
      15212,
      "/",
      21880
    ]
  },
  {
    "id": "25357",
    "description": "permeable_material",
    "pos": "YELLOW",
    "explanation": "(material + through)",
    "isCharacter": false,
    "composition": [
      15431,
      "/",
      17724
    ]
  },
  {
    "id": "25358",
    "description": "Persian_(language)",
    "pos": "YELLOW",
    "explanation": "(language + poetry: poetry representing Iran [contraction]",
    "isCharacter": false,
    "composition": [
      15172,
      "/",
      25585,
      "/",
      14164
    ]
  },
  {
    "id": "25359",
    "description": "personal_measurement",
    "pos": "YELLOW",
    "explanation": "(measurement + self)",
    "isCharacter": false,
    "composition": [
      15443,
      "/",
      8497,
      "/",
      15214
    ]
  },
  {
    "id": "25360",
    "description": "plant-louse",
    "pos": "YELLOW",
    "explanation": "(louse,stinging_insect + plant)",
    "isCharacter": false,
    "composition": [
      14943,
      "/",
      16212,
      "/",
      16196
    ]
  },
  {
    "id": "25362",
    "description": "propeller,rotor_(blades)",
    "pos": "YELLOW",
    "explanation": "(pictograph: suggesting the rotor blades of a propeller)  - Character",
    "isCharacter": true
  },
  {
    "id": "25363",
    "description": "radio_(2)",
    "pos": "YELLOW",
    "explanation": "(enclosure + ear + signal,broadcast,transmitting: a device for hearing radio transmissions)",
    "isCharacter": false,
    "composition": [
      13934,
      "/",
      13894,
      "/",
      24750
    ]
  },
  {
    "id": "25364",
    "description": "rear,back_of_a_thing",
    "pos": "WHITE",
    "explanation": "(pointer + thing: pointer pointing to the right on the \"back\" left-hand side of the thing) - Character (superimposed - pointer)",
    "isCharacter": true
  },
  {
    "id": "25365",
    "description": "rowdy,raucous",
    "pos": "GREEN",
    "explanation": "(quarrel,row + description indicator)",
    "isCharacter": false,
    "composition": [
      12335,
      ";",
      8998,
      "/",
      14427,
      "/",
      15474,
      "/",
      14947
    ]
  },
  {
    "id": "25366",
    "description": "runway_(airport)",
    "pos": "YELLOW",
    "explanation": "(place + airplane + ascending and descending)",
    "isCharacter": false,
    "composition": [
      16193,
      "/",
      12357,
      "/",
      25401
    ]
  },
  {
    "id": "25367",
    "description": "Russian_(language)",
    "pos": "YELLOW",
    "explanation": "(language + Russia)",
    "isCharacter": false,
    "composition": [
      15172,
      "/",
      13423,
      "/",
      24801
    ]
  },
  {
    "id": "25368",
    "description": "equal,same",
    "pos": "GREEN",
    "explanation": "(same,equal,equality + description indicator)",
    "isCharacter": false,
    "composition": [
      16713,
      ";",
      8998
    ]
  },
  {
    "id": "25369",
    "description": "science_centre",
    "pos": "YELLOW",
    "explanation": "(activity center + science)",
    "isCharacter": false,
    "composition": [
      14905,
      "/",
      12335,
      "/",
      16735
    ]
  },
  {
    "id": "25370",
    "description": "scout_(etc)",
    "pos": "BLUE",
    "explanation": "(person + scouting)",
    "isCharacter": false,
    "composition": [
      16161,
      "/",
      15162,
      "/",
      12335,
      "/",
      14704
    ]
  },
  {
    "id": "25371",
    "description": "scouting_(etc)",
    "pos": "YELLOW",
    "explanation": "(knowledge + activity + help)",
    "isCharacter": false,
    "composition": [
      15162,
      "/",
      12335,
      "/",
      14704
    ]
  },
  {
    "id": "25372",
    "description": "signal_strength_meter",
    "pos": "YELLOW",
    "explanation": "(gauge + signal,broadcast,transmitting + thing indicator)",
    "isCharacter": false,
    "composition": [
      24806,
      ";",
      9009,
      "/",
      24750
    ]
  },
  {
    "id": "25373",
    "description": "sleepy",
    "pos": "GREEN",
    "explanation": "(feeling + without + sleep + description indicator)",
    "isCharacter": false,
    "composition": [
      14164,
      ";",
      8998,
      "/",
      15474,
      "/",
      17008
    ]
  },
  {
    "id": "25374",
    "description": "sniffer_dog",
    "pos": "YELLOW",
    "explanation": "(dog + nose + information)",
    "isCharacter": false,
    "composition": [
      12380,
      "/",
      15732,
      "/",
      23542
    ]
  },
  {
    "id": "25375",
    "description": "social_network,facebook_(etc)",
    "pos": "YELLOW",
    "explanation": "(exchange + digital_world + person: digital_world representing the Internet (contr.))",
    "isCharacter": false,
    "composition": [
      25555,
      "/",
      25552,
      "/",
      16161
    ]
  },
  {
    "id": "25376",
    "description": "Spain",
    "pos": "YELLOW",
    "explanation": "(country + castanet)",
    "isCharacter": false,
    "composition": [
      13423,
      "/",
      13685,
      "/",
      14180
    ]
  },
  {
    "id": "25377",
    "description": "Spanish,Castilian_(language)",
    "pos": "YELLOW",
    "explanation": "(language + castle,palace: Castilian being the \"language of castles\", the main language of Spain)",
    "isCharacter": false,
    "composition": [
      15172,
      "/",
      23437
    ]
  },
  {
    "id": "25378",
    "description": "Spiderman",
    "pos": "BLUE",
    "explanation": "(make-believe person + spider)",
    "isCharacter": false,
    "composition": [
      23576,
      "/",
      17229
    ]
  },
  {
    "id": "25379",
    "description": "state_of_mind",
    "pos": "YELLOW",
    "explanation": "(mind + being_(state_of): what you think exists)  - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "25380",
    "description": "suicide",
    "pos": "YELLOW",
    "explanation": "(cause + death + self)",
    "isCharacter": false,
    "composition": [
      13134,
      "/",
      13645,
      "/",
      8497,
      "/",
      15214
    ]
  },
  {
    "id": "25381",
    "description": "Superman",
    "pos": "BLUE",
    "explanation": "(make-believe person + brave + S)",
    "isCharacter": false,
    "composition": [
      23576,
      "/",
      14164,
      "/",
      24941,
      "/",
      "XS"
    ]
  },
  {
    "id": "25382",
    "description": "tail_(airplane)",
    "pos": "YELLOW",
    "explanation": "(rear,back_of_a_thing + airplane)",
    "isCharacter": false,
    "composition": [
      25364,
      "/",
      12357
    ]
  },
  {
    "id": "25383",
    "description": "tail_wing_(airplane)",
    "pos": "YELLOW",
    "explanation": "(wing(s) + tail_(airplane))",
    "isCharacter": false,
    "composition": [
      18259,
      "/",
      25364,
      "/",
      12357
    ]
  },
  {
    "id": "25384",
    "description": "take_off_(airplane)-(to)",
    "pos": "RED",
    "explanation": "(takeoff,take-off,airplane_take-off + action indicator)",
    "isCharacter": false,
    "composition": [
      12357,
      ";",
      8993,
      "/",
      "RK:-2",
      "/",
      17987
    ]
  },
  {
    "id": "25385",
    "description": "Tarzan",
    "pos": "BLUE",
    "explanation": "(make-believe person + jungle)",
    "isCharacter": false,
    "composition": [
      23576,
      "/",
      14647,
      "/",
      17775,
      "/",
      22598
    ]
  },
  {
    "id": "25386",
    "description": "tie_whipping_knot-(to)",
    "pos": "RED",
    "explanation": "(whipping_knot + action indicator)",
    "isCharacter": false,
    "composition": [
      25616,
      ";",
      8993,
      "/",
      15214,
      ";",
      9009,
      "/",
      23409
    ]
  },
  {
    "id": "25387",
    "description": "top,top_of_a_thing",
    "pos": "WHITE",
    "explanation": "(pointer + thing: pointer pointing down on the \"top\" of the thing) - Character (superimposed - pointer)",
    "isCharacter": true
  },
  {
    "id": "25388",
    "description": "tracker",
    "pos": "BLUE",
    "explanation": "(person + wakefulness,alertness + imprint,trace,track: alertness representing to watch [contraction])",
    "isCharacter": false,
    "composition": [
      16161,
      "/",
      24949,
      "/",
      13910,
      "/",
      24422
    ]
  },
  {
    "id": "25389",
    "description": "turquoise",
    "pos": "WHITE",
    "explanation": "(colour + sky + grass: a combination of blue and green)",
    "isCharacter": false,
    "composition": [
      13377,
      "/",
      17006,
      "/",
      14636
    ]
  },
  {
    "id": "25390",
    "description": "working_uniform",
    "pos": "YELLOW",
    "explanation": "(clothes + crew,staff)",
    "isCharacter": false,
    "composition": [
      13366,
      "/",
      14647,
      "/",
      16161,
      "/",
      18273
    ]
  },
  {
    "id": "25391",
    "description": "wave_length",
    "pos": "YELLOW",
    "explanation": "(length + wave)",
    "isCharacter": false,
    "composition": [
      15443,
      "/",
      15193,
      "/",
      21880
    ]
  },
  {
    "id": "25392",
    "description": "veterinarian",
    "pos": "BLUE",
    "explanation": "(doctor + animal)",
    "isCharacter": false,
    "composition": [
      16161,
      "/",
      24920,
      "/",
      12378
    ]
  },
  {
    "id": "25393",
    "description": "whipping_knot",
    "pos": "YELLOW",
    "explanation": "(spiral + strap,string,velcro,rope,cord)",
    "isCharacter": false,
    "composition": [
      25616,
      "/",
      15214,
      ";",
      9009,
      "/",
      23409
    ]
  },
  {
    "id": "25394",
    "description": "wind_turbine",
    "pos": "YELLOW",
    "explanation": "(windmill + electricity)",
    "isCharacter": false,
    "composition": [
      23240,
      "/",
      25362,
      "/",
      13918
    ]
  },
  {
    "id": "25395",
    "description": "windmill",
    "pos": "YELLOW",
    "explanation": "(tower + propeller,rotor_(blades))",
    "isCharacter": false,
    "composition": [
      23240,
      "/",
      25362
    ]
  },
  {
    "id": "25396",
    "description": "voltage",
    "pos": "YELLOW",
    "explanation": "(vertical line + electricity + vertical line: a combination of limit(s) and electricity)  - Character (sequenced)",
    "isCharacter": true
  },
  {
    "id": "25397",
    "description": "voltmeter",
    "pos": "YELLOW",
    "explanation": "(gauge + voltage + thing indicator)",
    "isCharacter": false,
    "composition": [
      24806,
      ";",
      9009,
      "/",
      25396
    ]
  },
  {
    "id": "25398",
    "description": "wrap,wind-(to)",
    "pos": "RED",
    "explanation": "(spiral + action indicator)",
    "isCharacter": false,
    "composition": [
      25616,
      ";",
      8993
    ]
  },
  {
    "id": "25399",
    "description": "wreck,wreckage_(airplane)",
    "pos": "YELLOW",
    "explanation": "(airplane + deletion,cancellation,destruction)",
    "isCharacter": false,
    "composition": [
      12357,
      "/",
      24883
    ]
  },
  {
    "id": "25400",
    "description": "wreck,wreckage_(boat)",
    "pos": "YELLOW",
    "explanation": "(boat + deletion,cancellation,destruction)",
    "isCharacter": false,
    "composition": [
      12869,
      "/",
      24883
    ]
  },
  {
    "id": "25401",
    "description": "ascending_and_descending",
    "pos": "YELLOW",
    "explanation": "(upward_and_forward + downward_and_backward)  - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "25402",
    "description": "land_(airplane)-(to)",
    "pos": "RED",
    "explanation": "(landing,airplane_landing + action indicator)",
    "isCharacter": false,
    "composition": [
      12357,
      ";",
      8993,
      "/",
      13871
    ]
  },
  {
    "id": "25405",
    "description": "different,other,unequal",
    "pos": "GREEN",
    "explanation": "(different,other,difference + description indicator)",
    "isCharacter": false,
    "composition": [
      13675,
      ";",
      8998
    ]
  },
  {
    "id": "25406",
    "description": "swing,swinging",
    "pos": "YELLOW",
    "explanation": "(two-headed curved arrow suggests swinging motion)  - Character",
    "isCharacter": true
  },
  {
    "id": "25407",
    "description": "magnetic_pole",
    "pos": "YELLOW",
    "explanation": "(South_Pole + magnetism)",
    "isCharacter": false,
    "composition": [
      22599,
      "/",
      25340
    ]
  },
  {
    "id": "25408",
    "description": "bottom,bottom_of_a_thing",
    "pos": "WHITE",
    "explanation": "(pointer + thing: pointer pointing up on the \"bottom\" of the thing) - Character (superimposed - pointer)",
    "isCharacter": true
  },
  {
    "id": "25409",
    "description": "breathing_aid",
    "pos": "YELLOW",
    "explanation": "(aid,device,support + breath + thing indicator)",
    "isCharacter": false,
    "composition": [
      14704,
      ";",
      9009,
      "/",
      15732,
      "/",
      15666
    ]
  },
  {
    "id": "25410",
    "description": "sitting_mat",
    "pos": "YELLOW",
    "explanation": "(cloth + seat,sitting_(sitting_person))",
    "isCharacter": false,
    "composition": [
      13365,
      "/",
      16165
    ]
  },
  {
    "id": "25411",
    "description": "frequency",
    "pos": "YELLOW",
    "explanation": "(number + limited time: number of something per time measure)",
    "isCharacter": false,
    "composition": [
      15742,
      "/",
      15212
    ]
  },
  {
    "id": "25412",
    "description": "sleepless",
    "pos": "GREEN",
    "explanation": "(insomnia + description indicator)",
    "isCharacter": false,
    "composition": [
      25379,
      ";",
      8998,
      "/",
      15474,
      "/",
      17008
    ]
  },
  {
    "id": "25413",
    "description": "quarrel,row",
    "pos": "YELLOW",
    "explanation": "(activity + gathering + negative)",
    "isCharacter": false,
    "composition": [
      12335,
      "/",
      14427,
      "/",
      15474,
      "/",
      14947
    ]
  },
  {
    "id": "25414",
    "description": "Germany",
    "pos": "YELLOW",
    "explanation": "(country + D + E + U)",
    "isCharacter": false,
    "composition": [
      13423,
      "/",
      "XD",
      "/",
      "XE",
      "/",
      "XU"
    ]
  },
  {
    "id": "25415",
    "description": "German_(language)",
    "pos": "YELLOW",
    "explanation": "(language + Germany)",
    "isCharacter": false,
    "composition": [
      15172,
      "/",
      13423,
      "/",
      "XD",
      "/",
      "XE",
      "/",
      "XU"
    ]
  },
  {
    "id": "25416",
    "description": "Thailand",
    "pos": "YELLOW",
    "explanation": "(country + T + H + A)",
    "isCharacter": false,
    "composition": [
      13423,
      "/",
      "XT",
      "/",
      "XH",
      "/",
      "XA"
    ]
  },
  {
    "id": "25417",
    "description": "Romania",
    "pos": "YELLOW",
    "explanation": "(country + R + O + U)",
    "isCharacter": false,
    "composition": [
      13423,
      "/",
      "XR",
      "/",
      "XO",
      "/",
      "XU"
    ]
  },
  {
    "id": "25418",
    "description": "artillery",
    "pos": "YELLOW",
    "explanation": "(military,armed_forces,armed_services + cannon,gun)",
    "isCharacter": false,
    "composition": [
      14647,
      "/",
      16161,
      "/",
      18036,
      "/",
      13120
    ]
  },
  {
    "id": "25419",
    "description": "German_(class)",
    "pos": "YELLOW",
    "explanation": "(class + German_(language))",
    "isCharacter": false,
    "composition": [
      15162,
      "/",
      15172,
      "/",
      13423,
      "/",
      "XD",
      "/",
      "XE",
      "/",
      "XU"
    ]
  },
  {
    "id": "25420",
    "description": "Romanian_(class)",
    "pos": "YELLOW",
    "explanation": "(class + Romanian_(language))",
    "isCharacter": false,
    "composition": [
      15162,
      "/",
      15172,
      "/",
      13423,
      "/",
      "XR",
      "/",
      "XO",
      "/",
      "XU"
    ]
  },
  {
    "id": "25421",
    "description": "Romanian_(language)",
    "pos": "YELLOW",
    "explanation": "(language + Romania)",
    "isCharacter": false,
    "composition": [
      15172,
      "/",
      13423,
      "/",
      "XR",
      "/",
      "XO",
      "/",
      "XU"
    ]
  },
  {
    "id": "25422",
    "description": "armoured_force,tank_force",
    "pos": "YELLOW",
    "explanation": "(military,armed_forces,armed_services + tank)",
    "isCharacter": false,
    "composition": [
      14647,
      "/",
      16161,
      "/",
      18036,
      "/",
      17504
    ]
  },
  {
    "id": "25423",
    "description": "Thai_(class)",
    "pos": "YELLOW",
    "explanation": "(class + Thai_(language))",
    "isCharacter": false,
    "composition": [
      15162,
      "/",
      15172,
      "/",
      13423,
      "/",
      "XT",
      "/",
      "XH",
      "/",
      "XA"
    ]
  },
  {
    "id": "25424",
    "description": "Thai_(language)",
    "pos": "YELLOW",
    "explanation": "(language + Thailand)",
    "isCharacter": false,
    "composition": [
      15172,
      "/",
      13423,
      "/",
      "XT",
      "/",
      "XH",
      "/",
      "XA"
    ]
  },
  {
    "id": "25430",
    "description": "appendix,cecum,caecum",
    "pos": "YELLOW",
    "explanation": "(intestine(s),bowel(s),gut(s) + end,arrival,stop: The intestine that stops in a dead end)",
    "isCharacter": false,
    "composition": [
      25480,
      "/",
      14377,
      "/",
      23926,
      "/",
      13935
    ]
  },
  {
    "id": "25431",
    "description": "beginning_of_year",
    "pos": "YELLOW",
    "explanation": "(beginning,start + year)",
    "isCharacter": false,
    "composition": [
      12658,
      "/",
      18289
    ]
  },
  {
    "id": "25432",
    "description": "body_painting",
    "pos": "YELLOW",
    "explanation": "(picture,image,icon,painting + body + brush: Panting on skin made with brush)",
    "isCharacter": false,
    "composition": [
      14133,
      "/",
      13934,
      "/",
      12870,
      "/",
      12912
    ]
  },
  {
    "id": "25433",
    "description": "bracelet",
    "pos": "YELLOW",
    "explanation": "(jewelry + arm)",
    "isCharacter": false,
    "composition": [
      14430,
      "/",
      17267,
      "/",
      17252,
      "/",
      12577
    ]
  },
  {
    "id": "25434",
    "description": "brain_signal",
    "pos": "YELLOW",
    "explanation": "(mind + electricity: the electrical impulses of the brain (and CNS))  - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "25435",
    "description": "breastbone,sternum",
    "pos": "YELLOW",
    "explanation": "(bone + chest)",
    "isCharacter": false,
    "composition": [
      12873,
      "/",
      13161
    ]
  },
  {
    "id": "25436",
    "description": "brooch",
    "pos": "YELLOW",
    "explanation": "(jewelry + clothing: Jewelry to put on clothes)",
    "isCharacter": false,
    "composition": [
      14430,
      "/",
      17267,
      "/",
      17252,
      "/",
      13366
    ]
  },
  {
    "id": "25437",
    "description": "cannula_(with_needle)",
    "pos": "YELLOW",
    "explanation": "(medical_tube,catheter,cannula + needle)",
    "isCharacter": false,
    "composition": [
      23926,
      "/",
      24920,
      "/",
      15703
    ]
  },
  {
    "id": "25438",
    "description": "cardiovascular_system",
    "pos": "YELLOW",
    "explanation": "(generalisation + organ + heart)",
    "isCharacter": false,
    "composition": [
      14430,
      "/",
      25480,
      "/",
      14164,
      ";",
      9009
    ]
  },
  {
    "id": "25439",
    "description": "catheter_(urine)",
    "pos": "YELLOW",
    "explanation": "(medical_tube,catheter,cannula + urine)",
    "isCharacter": false,
    "composition": [
      23926,
      "/",
      24920,
      "/",
      18043,
      "/",
      14431
    ]
  },
  {
    "id": "25440",
    "description": "cellular_fluid",
    "pos": "YELLOW",
    "explanation": "(water,fluid,liquid + cell)",
    "isCharacter": false,
    "composition": [
      18209,
      "/",
      21540
    ]
  },
  {
    "id": "25441",
    "description": "Christmas_Eve_(day)",
    "pos": "YELLOW",
    "explanation": "(day + before + birth + cross,Christianity_(in_combinations): where birth + cross represents Christmas [contraction], i.e., the birth of Jesus Christ)",
    "isCharacter": false,
    "composition": [
      13639,
      "/",
      12656,
      "/",
      12843,
      "/",
      13613
    ]
  },
  {
    "id": "25442",
    "description": "Christmas_Eve_(evening)",
    "pos": "YELLOW",
    "explanation": "(evening + before + birth + cross,Christianity_(in_combinations): where birth + cross represents Christmas [contraction], i.e., the birth of Jesus Christ)",
    "isCharacter": false,
    "composition": [
      13950,
      "/",
      12656,
      "/",
      12843,
      "/",
      13613
    ]
  },
  {
    "id": "25443",
    "description": "circulatory_system",
    "pos": "YELLOW",
    "explanation": "(generalisation + organ + rotation)",
    "isCharacter": false,
    "composition": [
      14430,
      "/",
      25480,
      "/",
      24249
    ]
  },
  {
    "id": "25444",
    "description": "collarbone,clavicle",
    "pos": "YELLOW",
    "explanation": "(bone + shoulder + in front of: A bone on the upper part of the front of the body, linking the scapula and sternum)",
    "isCharacter": false,
    "composition": [
      12873,
      "/",
      16964,
      "/",
      12656
    ]
  },
  {
    "id": "25445",
    "description": "day_before_holiday",
    "pos": "YELLOW",
    "explanation": "(day + before + holiday)",
    "isCharacter": false,
    "composition": [
      13639,
      "/",
      12656,
      "/",
      13639,
      "/",
      16495
    ]
  },
  {
    "id": "25446",
    "description": "drug_(leaf_based)",
    "pos": "YELLOW",
    "explanation": "(leaf + chemical_product: where chemical product represents drug [contraction]: Leaves used as drugs)  (kerned)",
    "isCharacter": false,
    "composition": [
      15183,
      "/",
      "RK:-2",
      "/",
      13158
    ]
  },
  {
    "id": "25447",
    "description": "earring",
    "pos": "YELLOW",
    "explanation": "(jewelry + ear)",
    "isCharacter": false,
    "composition": [
      14430,
      "/",
      17267,
      "/",
      17252,
      "/",
      13894
    ]
  },
  {
    "id": "25448",
    "description": "end_of_year",
    "pos": "YELLOW",
    "explanation": "(end,arrival,stop + year)",
    "isCharacter": false,
    "composition": [
      13935,
      "/",
      18289
    ]
  },
  {
    "id": "25449",
    "description": "endocrine_system",
    "pos": "YELLOW",
    "explanation": "(generalisation + gland: The system involving the glands)  (kerned)",
    "isCharacter": false,
    "composition": [
      14430,
      "/",
      25480,
      "/",
      "RK:-2",
      "/",
      13158
    ]
  },
  {
    "id": "25450",
    "description": "feeding_tube",
    "pos": "YELLOW",
    "explanation": "(medical_tube,catheter,cannula + food)",
    "isCharacter": false,
    "composition": [
      23926,
      "/",
      24920,
      "/",
      14377
    ]
  },
  {
    "id": "25451",
    "description": "gastrointestinal_system",
    "pos": "YELLOW",
    "explanation": "(generalisation + organ + food)",
    "isCharacter": false,
    "composition": [
      14430,
      "/",
      25480,
      "/",
      14377
    ]
  },
  {
    "id": "25452",
    "description": "gland",
    "pos": "YELLOW",
    "explanation": "(organ + chemical product: organ that produces chemicals)  (kerned)",
    "isCharacter": false,
    "composition": [
      25480,
      "/",
      "RK:-2",
      "/",
      13158
    ]
  },
  {
    "id": "25453",
    "description": "glitter",
    "pos": "YELLOW",
    "explanation": "(lump(s) + star: Small pieces that shine, like stars)",
    "isCharacter": false,
    "composition": [
      22362,
      "/",
      17252
    ]
  },
  {
    "id": "25454",
    "description": "have_a_tea_break,have_a_coffee_break-(to)",
    "pos": "RED",
    "explanation": "(rest_period,break + drink + action indicator: The activity of having a break with beverage)",
    "isCharacter": false,
    "composition": [
      15212,
      ";",
      8993,
      "/",
      16495,
      "/",
      13881
    ]
  },
  {
    "id": "25455",
    "description": "heel_(shoe)",
    "pos": "YELLOW",
    "explanation": "(protection + heel: combination of shoe and heel. The heel on the shoe)",
    "isCharacter": false,
    "composition": [
      16420,
      "/",
      14700
    ]
  },
  {
    "id": "25456",
    "description": "high_heeled_shoes,high_heels",
    "pos": "YELLOW",
    "explanation": "(heel_(shoe) + high)",
    "isCharacter": false,
    "composition": [
      16420,
      "/",
      14700,
      "/",
      24909
    ]
  },
  {
    "id": "25457",
    "description": "humerus,upper_arm_bone",
    "pos": "YELLOW",
    "explanation": "(bone + upper_arm)",
    "isCharacter": false,
    "composition": [
      12873,
      "/",
      12577,
      "/",
      15948
    ]
  },
  {
    "id": "25458",
    "description": "indicator_(diminutive_form)_OLD",
    "pos": "GRAY",
    "explanation": "(little [quarter-sized]: may be placed above a symbol to show that it is representing a word in diminutive form in a natural language)    Used restrictively, primarily for language teaching purposes.  - Character (indicator)",
    "isCharacter": true
  },
  {
    "id": "25459",
    "description": "insulin",
    "pos": "YELLOW",
    "explanation": "(chemical product + cell + work: the chemical substance that regulates the oxidation of sugar, providing the energy needed for the cells to work)",
    "isCharacter": false,
    "composition": [
      13158,
      "/",
      21540,
      "/",
      18273
    ]
  },
  {
    "id": "25460",
    "description": "intestine(s),bowel(s),gut(s)",
    "pos": "YELLOW",
    "explanation": "(organ + food + tube)  Preferred NEW SYNONYM, replacing 12883",
    "isCharacter": false,
    "composition": [
      25480,
      "/",
      14377,
      "/",
      23926
    ]
  },
  {
    "id": "25461",
    "description": "large_intestine",
    "pos": "YELLOW",
    "explanation": "(intestine(s),bowel(s),gut(s) + short: the shorter, but wider, part of the intestines)",
    "isCharacter": false,
    "composition": [
      25480,
      "/",
      14377,
      "/",
      23926,
      "/",
      24938
    ]
  },
  {
    "id": "25462",
    "description": "liver",
    "pos": "YELLOW",
    "explanation": "(gland + group + action: a gland with many functions)",
    "isCharacter": false,
    "composition": [
      25480,
      "/",
      "RK:-2",
      "/",
      13158,
      "/",
      14647,
      "/",
      12335
    ]
  },
  {
    "id": "25463",
    "description": "lower_arm",
    "pos": "YELLOW",
    "explanation": "(arm + under)",
    "isCharacter": false,
    "composition": [
      12577,
      "/",
      17969
    ]
  },
  {
    "id": "25464",
    "description": "lower_arm_bone(s)",
    "pos": "YELLOW",
    "explanation": "(bone + lower_arm)",
    "isCharacter": false,
    "composition": [
      12873,
      "/",
      12577,
      "/",
      17969
    ]
  },
  {
    "id": "25465",
    "description": "lung(s)",
    "pos": "YELLOW",
    "explanation": "(organ + breath: The major organ for breathing)",
    "isCharacter": false,
    "composition": [
      25480,
      "/",
      15732,
      "/",
      15666
    ]
  },
  {
    "id": "25466",
    "description": "lymph",
    "pos": "YELLOW",
    "explanation": "(cellular fluid + protection)",
    "isCharacter": false,
    "composition": [
      18209,
      "/",
      21540,
      "/",
      16420
    ]
  },
  {
    "id": "25467",
    "description": "lymph_node,lymph_gland",
    "pos": "YELLOW",
    "explanation": "(organ + lymph: where organ represents gland [contraction])",
    "isCharacter": false,
    "composition": [
      25480,
      "/",
      18209,
      "/",
      21540,
      "/",
      16420
    ]
  },
  {
    "id": "25468",
    "description": "lymphatic_system",
    "pos": "YELLOW",
    "explanation": "(generalisation + lymph)",
    "isCharacter": false,
    "composition": [
      14430,
      "/",
      18209,
      "/",
      21540,
      "/",
      16420
    ]
  },
  {
    "id": "25469",
    "description": "medical_tube,catheter,cannula",
    "pos": "YELLOW",
    "explanation": "(tube + medical: a tube used for medical purposes. Add appropriate specifier when needed)",
    "isCharacter": false,
    "composition": [
      23926,
      "/",
      24920
    ]
  },
  {
    "id": "25470",
    "description": "necklace",
    "pos": "YELLOW",
    "explanation": "(jewelry + neck)",
    "isCharacter": false,
    "composition": [
      14430,
      "/",
      17267,
      "/",
      17252,
      "/",
      15699
    ]
  },
  {
    "id": "25471",
    "description": "nerve",
    "pos": "YELLOW",
    "explanation": "(group of + neuron)",
    "isCharacter": false,
    "composition": [
      14647,
      "/",
      21540,
      "/",
      13918
    ]
  },
  {
    "id": "25472",
    "description": "nervous_system",
    "pos": "YELLOW",
    "explanation": "(generalisation + neuron)",
    "isCharacter": false,
    "composition": [
      14430,
      "/",
      21540,
      "/",
      13918
    ]
  },
  {
    "id": "25473",
    "description": "neuron",
    "pos": "YELLOW",
    "explanation": "(cell + electricity)",
    "isCharacter": false,
    "composition": [
      21540,
      "/",
      13918
    ]
  },
  {
    "id": "25474",
    "description": "New_Year_(general)",
    "pos": "YELLOW",
    "explanation": "(day + beginning + year: First day of a new year (e.g. school, calendar))",
    "isCharacter": false,
    "composition": [
      13639,
      "/",
      12658,
      "/",
      18289
    ]
  },
  {
    "id": "25475",
    "description": "New_Year's_eve_(day)",
    "pos": "YELLOW",
    "explanation": "(day + before + birth + year: Day before the birth of a year)",
    "isCharacter": false,
    "composition": [
      13639,
      "/",
      12656,
      "/",
      12843,
      "/",
      18289
    ]
  },
  {
    "id": "25476",
    "description": "New_Year's_eve_(evening)",
    "pos": "YELLOW",
    "explanation": "(evening + before + birth + year: Evening before the birth of a year)",
    "isCharacter": false,
    "composition": [
      13950,
      "/",
      12656,
      "/",
      12843,
      "/",
      18289
    ]
  },
  {
    "id": "25477",
    "description": "New_Year's_eve,end_of_year_(day)",
    "pos": "YELLOW",
    "explanation": "(day + end + year: Last day of a year)",
    "isCharacter": false,
    "composition": [
      13639,
      "/",
      13935,
      "/",
      18289
    ]
  },
  {
    "id": "25478",
    "description": "New_Year's_eve,end_of_year_(evening)",
    "pos": "YELLOW",
    "explanation": "(evening + end + year: Last evening of a year)",
    "isCharacter": false,
    "composition": [
      13950,
      "/",
      13935,
      "/",
      18289
    ]
  },
  {
    "id": "25479",
    "description": "oesophagus,gullet",
    "pos": "YELLOW",
    "explanation": "(organ + food + receive + tube: The food goes into the container (of the stomach) by a tube)",
    "isCharacter": false,
    "composition": [
      25480,
      "/",
      14377,
      "/",
      24727,
      "/",
      23926
    ]
  },
  {
    "id": "25480",
    "description": "organ,inner_organ,inner_body_part",
    "pos": "YELLOW",
    "explanation": "(body [modification, reduced width] + dot: a reduced body with a dot inside that represents an inner organ) - Character (superimposed - modified) Preferred NEW SYNONYM, replacing 24202",
    "isCharacter": true
  },
  {
    "id": "25481",
    "description": "pancreas",
    "pos": "YELLOW",
    "explanation": "(gland + insulin: The gland that produces insulin) (kerned)",
    "isCharacter": false,
    "composition": [
      25480,
      "/",
      "RK:-2",
      "/",
      13158,
      "/",
      21540,
      "/",
      18273
    ]
  },
  {
    "id": "25482",
    "description": "pierce_(jewellery)-(to)",
    "pos": "RED",
    "explanation": "(through + jewelry + action indicator)",
    "isCharacter": false,
    "composition": [
      17724,
      ";",
      8993,
      "/",
      14430,
      "/",
      17267,
      "/",
      17252
    ]
  },
  {
    "id": "25483",
    "description": "pierce-(to)",
    "pos": "RED",
    "explanation": "(through + knife + action indicator: The knife representing sharp. To penetrate with a sharp instrument)",
    "isCharacter": false,
    "composition": [
      17724,
      ";",
      8993,
      "/",
      15159
    ]
  },
  {
    "id": "25484",
    "description": "piercing_(thing)",
    "pos": "YELLOW",
    "explanation": "(jewelry + through)",
    "isCharacter": false,
    "composition": [
      14430,
      "/",
      17267,
      "/",
      17252,
      "/",
      17724
    ]
  },
  {
    "id": "25485",
    "description": "rectum",
    "pos": "YELLOW",
    "explanation": "(intestine(s),bowel(s),gut(s) + waste)",
    "isCharacter": false,
    "composition": [
      25480,
      "/",
      14377,
      "/",
      23926,
      "/",
      18043
    ]
  },
  {
    "id": "25486",
    "description": "respiratory_system",
    "pos": "YELLOW",
    "explanation": "(generalisation + lung(s))",
    "isCharacter": false,
    "composition": [
      14430,
      "/",
      25480,
      "/",
      15732,
      "/",
      15666
    ]
  },
  {
    "id": "25487",
    "description": "rib(s)",
    "pos": "YELLOW",
    "explanation": "(bone + side_(body))",
    "isCharacter": false,
    "composition": [
      12873,
      "/",
      16974
    ]
  },
  {
    "id": "25488",
    "description": "ring_(finger)",
    "pos": "YELLOW",
    "explanation": "(jewelry + finger)",
    "isCharacter": false,
    "composition": [
      14430,
      "/",
      17267,
      "/",
      17252,
      "/",
      14180
    ]
  },
  {
    "id": "25489",
    "description": "salivary_gland",
    "pos": "YELLOW",
    "explanation": "(organ + saliva: Organ representing gland [contraction]. A gland that produces saliva)",
    "isCharacter": false,
    "composition": [
      25480,
      "/",
      18209,
      "/",
      15666
    ]
  },
  {
    "id": "25490",
    "description": "sequin(s),spangle(s)",
    "pos": "YELLOW",
    "explanation": "(glitter + cloth: Glitter attached to cloth)",
    "isCharacter": false,
    "composition": [
      22362,
      "/",
      17252,
      "/",
      13365
    ]
  },
  {
    "id": "25491",
    "description": "shoulder_blade,scapula",
    "pos": "YELLOW",
    "explanation": "(bone + shoulder + behind)",
    "isCharacter": false,
    "composition": [
      12873,
      "/",
      16964,
      "/",
      12348
    ]
  },
  {
    "id": "25492",
    "description": "skull,cranium",
    "pos": "YELLOW",
    "explanation": "(bone + head)",
    "isCharacter": false,
    "composition": [
      12873,
      "/",
      14689
    ]
  },
  {
    "id": "25493",
    "description": "small_intestine",
    "pos": "YELLOW",
    "explanation": "(intestine(s),bowel(s),gut(s) + long: The longer, but thinner, part of the intestines)",
    "isCharacter": false,
    "composition": [
      25480,
      "/",
      14377,
      "/",
      23926,
      "/",
      15193
    ]
  },
  {
    "id": "25494",
    "description": "snuff_(nose)",
    "pos": "YELLOW",
    "explanation": "(drug_(leaf based) + nose: Leaf based drug that is taken through the nose)  (kerned)",
    "isCharacter": false,
    "composition": [
      15183,
      "/",
      "RK:-2",
      "/",
      13158,
      "/",
      15732
    ]
  },
  {
    "id": "25495",
    "description": "snuff,kat,coca",
    "pos": "YELLOW",
    "explanation": "(drug_(leaf based) + mouth: Leaf based drug that is taken through the mouth) (kerned)",
    "isCharacter": false,
    "composition": [
      15183,
      "/",
      "RK:-2",
      "/",
      13158,
      "/",
      15666
    ]
  },
  {
    "id": "25496",
    "description": "spleen",
    "pos": "YELLOW",
    "explanation": "(gland + blood: Gland that assists in production of blood cells)  (kerned)",
    "isCharacter": false,
    "composition": [
      25480,
      "/",
      "RK:-2",
      "/",
      13158,
      "/",
      18209,
      "/",
      15206
    ]
  },
  {
    "id": "25497",
    "description": "stoma,medical_hole",
    "pos": "YELLOW",
    "explanation": "(hole + medical)",
    "isCharacter": false,
    "composition": [
      14883,
      "/",
      24920
    ]
  },
  {
    "id": "25498",
    "description": "stomach,tummy,tum",
    "pos": "YELLOW",
    "explanation": "(organ + food + container)",
    "isCharacter": false,
    "composition": [
      25480,
      "/",
      14377,
      "/",
      13403
    ]
  },
  {
    "id": "25499",
    "description": "tattoo_(permanent)",
    "pos": "YELLOW",
    "explanation": "(picture + body + needle: where picture + body represents tattoo [contraction], tattoo made with needle)",
    "isCharacter": false,
    "composition": [
      14133,
      "/",
      13934,
      "/",
      12870,
      "/",
      15703
    ]
  },
  {
    "id": "25500",
    "description": "tattoo_(sticker)",
    "pos": "YELLOW",
    "explanation": "(picture + body + attachment: where picture + body represents tattoo [contraction], tattoo made from a sticker)",
    "isCharacter": false,
    "composition": [
      14133,
      "/",
      13934,
      "/",
      12870,
      "/",
      23409
    ]
  },
  {
    "id": "25501",
    "description": "tattoo,picture_on_skin",
    "pos": "YELLOW",
    "explanation": "(picture + skin)",
    "isCharacter": false,
    "composition": [
      14133,
      "/",
      13934,
      "/",
      16420,
      "/",
      12870
    ]
  },
  {
    "id": "25502",
    "description": "tea_break,coffee_break",
    "pos": "YELLOW",
    "explanation": "(rest_period,break + drink: A break to have a non alcoholic drink)",
    "isCharacter": false,
    "composition": [
      15212,
      "/",
      16495,
      "/",
      13881
    ]
  },
  {
    "id": "25503",
    "description": "tendon",
    "pos": "YELLOW",
    "explanation": "(linear thing + muscle + bone: A cord or band of inelastic tissue that connects bones and muscles with each other)",
    "isCharacter": false,
    "composition": [
      15214,
      ";",
      9009,
      "/",
      20517,
      "/",
      12873
    ]
  },
  {
    "id": "25504",
    "description": "tissue_(body)",
    "pos": "YELLOW",
    "explanation": "(group_of + cell: An aggregation of cells forms a tissue)",
    "isCharacter": false,
    "composition": [
      14647,
      "/",
      21540
    ]
  },
  {
    "id": "25505",
    "description": "trachea,wind_pipe",
    "pos": "YELLOW",
    "explanation": "(lung(s) + tube: The tube that transports the air to and from the lungs)",
    "isCharacter": false,
    "composition": [
      25480,
      "/",
      15732,
      "/",
      15666,
      "/",
      23926
    ]
  },
  {
    "id": "25506",
    "description": "tracheotomy_tube,tracheal_tube",
    "pos": "YELLOW",
    "explanation": "(medical_tube,catheter,cannula + breath: A catheter inserted directly into trachea to help a person to breathe)",
    "isCharacter": false,
    "composition": [
      23926,
      "/",
      24920,
      "/",
      15732,
      "/",
      15666
    ]
  },
  {
    "id": "25507",
    "description": "upper_arm",
    "pos": "YELLOW",
    "explanation": "(arm + above)",
    "isCharacter": false,
    "composition": [
      12577,
      "/",
      15948
    ]
  },
  {
    "id": "25508",
    "description": "vascular_system",
    "pos": "YELLOW",
    "explanation": "(generalisation + organ + blood)",
    "isCharacter": false,
    "composition": [
      14430,
      "/",
      18209,
      "/",
      15206
    ]
  },
  {
    "id": "25509",
    "description": "work_day",
    "pos": "YELLOW",
    "explanation": "(day + work: all days except weekend)",
    "isCharacter": false,
    "composition": [
      13639,
      "/",
      18273
    ]
  },
  {
    "id": "25520",
    "description": "ability_(half_sized)",
    "pos": "YELLOW",
    "explanation": "(dot + evaluation,value_(half-sized): evaluation beforehand of one’s potential to do something - half_sized, used in can,be_able-(to))  - Character (sequenced)",
    "isCharacter": true
  },
  {
    "id": "25521",
    "description": "animal_(bushy_tailed)",
    "pos": "YELLOW",
    "explanation": "(animal + raised_wavy_line: pictograph of an animal with a wavy line in high position as tail, used for representing animals with a bushy tail, e.g. a squirrel) - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "25522",
    "description": "away,at_a_distance,off",
    "pos": "WHITE",
    "explanation": "(reference line [half-sized] + three connecting dots + arrowhead: full square between reference line and arrowhead emphasizes distance. This symbol is a simplified form of departure.)  - Character (sequenced)  Preferred NEW SYNONYM, replacing 12602",
    "isCharacter": true
  },
  {
    "id": "25523",
    "description": "bad_conscience",
    "pos": "YELLOW",
    "explanation": "(conscience + minus,no,without: conscience in a negative state)  - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "25524",
    "description": "ball_field",
    "pos": "YELLOW",
    "explanation": "(ball + earth,ground,land)  - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "25525",
    "description": "biochemical_product,organic_compound",
    "pos": "YELLOW",
    "explanation": "(chemical product + life [modification] (combination): chemical substances that constitute biological processes)  - Character (superimposed - modified - combined)",
    "isCharacter": true
  },
  {
    "id": "25526",
    "description": "blindness",
    "pos": "YELLOW",
    "explanation": "(eye + deletion,cancellation,destruction: for destroyed vision and lack of sight)  - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "25527",
    "description": "boarding,embarkation_(to_sea)",
    "pos": "YELLOW",
    "explanation": "(shore + forward: going forward from shore to water)  - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "25528",
    "description": "bones_with_joint",
    "pos": "YELLOW",
    "explanation": "(bone + bone [modification, horizontal]: indicating the junction where bones meet) - Character (superimposed - sequenced - modified)",
    "isCharacter": true
  },
  {
    "id": "25529",
    "description": "bottleneck,bottle_opening",
    "pos": "YELLOW",
    "explanation": "(bottle + pointer, to neck or opening)  - Character (superimposed - pointer)",
    "isCharacter": true
  },
  {
    "id": "25530",
    "description": "bread_surface",
    "pos": "YELLOW",
    "explanation": "(bread + pointer, down to top of bread + pointer, up to bottom of bread)  - Character (superimposed - pointer)",
    "isCharacter": true
  },
  {
    "id": "25531",
    "description": "buttocks_and_genitals",
    "pos": "YELLOW",
    "explanation": "(standing person + pointer, to the right to buttocks + pointer, to the left to genitals) - Character (superimposed - pointer)",
    "isCharacter": true
  },
  {
    "id": "25532",
    "description": "case,casing",
    "pos": "YELLOW",
    "explanation": "(enclosure + thing: a crust or shell surrounds the thing)  - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "25533",
    "description": "coldness,cold",
    "pos": "YELLOW",
    "explanation": "(pointer (left) + ice + pointer (right): suggesting the spreading of cold from something cold like ice)  - Character (superimposed - pointer)",
    "isCharacter": true
  },
  {
    "id": "25534",
    "description": "compression,compressing,squeezing",
    "pos": "YELLOW",
    "explanation": "(forward + thing + backward: squeezing a thing by pressure from two directions)  - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "25535",
    "description": "container,basket_(high)",
    "pos": "YELLOW",
    "explanation": "(container [modification, high position, under the skyline])  - Character (modified)",
    "isCharacter": true
  },
  {
    "id": "25536",
    "description": "container_(low)",
    "pos": "YELLOW",
    "explanation": "(container [modification, low position, under the earthline])  - Character (modified)",
    "isCharacter": true
  },
  {
    "id": "25537",
    "description": "corner",
    "pos": "YELLOW",
    "explanation": "(square_(oblique) + pointer to the right corner)  - Character (superimposed - pointer)",
    "isCharacter": true
  },
  {
    "id": "25538",
    "description": "correct_thinking",
    "pos": "YELLOW",
    "explanation": "(mind + plus)  - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "25539",
    "description": "incorrect_thinking",
    "pos": "YELLOW",
    "explanation": "(mind + minus)  - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "25540",
    "description": "couple_(female)",
    "pos": "YELLOW",
    "explanation": "(woman + woman)  - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "25541",
    "description": "couple_(male)",
    "pos": "YELLOW",
    "explanation": "(man + man)  - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "25542",
    "description": "crossed_racquets_(OLD)",
    "pos": "YELLOW",
    "explanation": "(racket,racquet + racket,racquet [modification, mirrored]: pictograph of two crossed racquets)  - Character (superimposed - modified - redundant)",
    "isCharacter": true
  },
  {
    "id": "25543",
    "description": "deafness",
    "pos": "YELLOW",
    "explanation": "(ear + deletion,cancellation,destruction: representing destroyed hearing, lack of hearing  - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "25544",
    "description": "debarkation,disembarkation_(ashore)",
    "pos": "YELLOW",
    "explanation": "(shore + backward,back: going back to shore from water)  - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "25545",
    "description": "adversity,hardship,setback",
    "pos": "YELLOW",
    "explanation": "(forward + arrow, high position pointing backward + arrow, low position pointing backward: one arrow is \"frustrated\" in its efforts to penetrate the opposition of the other two)  - Character (superimposed - sequenced)",
    "isCharacter": true
  },
  {
    "id": "25546",
    "description": "depth",
    "pos": "YELLOW",
    "explanation": "(vertical line + vertical line + pointer: the pointer points downward to the bottom of a relatively deep space)  See also shallowness 25606  - Character (superimposed - pointer)",
    "isCharacter": true
  },
  {
    "id": "25547",
    "description": "miscarriage,abortion_(general)",
    "pos": "YELLOW",
    "explanation": "(conception + to cancel: cancelled pregnancy due to the natural death of an embryo)  - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "25548",
    "description": "detachment,separation,breakup",
    "pos": "YELLOW",
    "explanation": "(vertical line + minus + vertical line: representing the separation of two things previously attached)  - Character (sequenced)",
    "isCharacter": true
  },
  {
    "id": "25549",
    "description": "diamond_(character)",
    "pos": "YELLOW",
    "explanation": "(pictograph, of a diamond shape)  - Character",
    "isCharacter": true
  },
  {
    "id": "25550",
    "description": "digging,excavation",
    "pos": "YELLOW",
    "explanation": "(shovel + earth)  - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "25551",
    "description": "digital_space_(limited)",
    "pos": "YELLOW",
    "explanation": "(limit(s),limitation,restriction [modification] + digits_(computer)) - Character (superimposed - sequenced - modified)",
    "isCharacter": true
  },
  {
    "id": "25552",
    "description": "digital_world",
    "pos": "YELLOW",
    "explanation": "(world + digits_(computer))  - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "25553",
    "description": "disturbance,unrest",
    "pos": "YELLOW",
    "explanation": "(peace,peace_of_mind,serenity + deletion,cancellation,destruction: used in harassment 14677 and sexual_harassment 16930)  - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "25554",
    "description": "evaluation,value_(half-sized)",
    "pos": "YELLOW",
    "explanation": "(ideograph: symbol represents a half-sized cone balancing unsteadily on its point, reminding us that our evaluations are variable and unreliable) - Character",
    "isCharacter": true
  },
  {
    "id": "25555",
    "description": "exchange,substitution",
    "pos": "YELLOW",
    "explanation": "(receiving + giving,gift (combination))  - Character (superimposed - combined)",
    "isCharacter": true
  },
  {
    "id": "25556",
    "description": "extinction,extinguishing_(fire)",
    "pos": "YELLOW",
    "explanation": "(fire + deletion,cancellation,destruction)  - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "25557",
    "description": "eyelid(s)",
    "pos": "YELLOW",
    "explanation": "(eye + pointer, to upper eyelid (and eyelashes) + pointer, to lower eyelid)  - Character (superimposed - pointer)",
    "isCharacter": true
  },
  {
    "id": "25558",
    "description": "eyelid_(lower)",
    "pos": "YELLOW",
    "explanation": "(eye + pointer, to lower eyelid)  - Character (superimposed - pointer)",
    "isCharacter": true
  },
  {
    "id": "25559",
    "description": "farness,remoteness,farawayness",
    "pos": "YELLOW",
    "explanation": "(reference line [half-sized] + three connecting dots + reference line [half-sized]: full square between the reference lines emphasizes distance.) See also: nearness,closeness,proximity 25586  - Character (sequenced)  Preferred NEW SYNONYM, replacing 24896",
    "isCharacter": true
  },
  {
    "id": "25560",
    "description": "fatness,thickness",
    "pos": "YELLOW",
    "explanation": "(reference line + three connecting dots + reference line + pointer, to the right on the left line + pointer, to the left on the right line : the full square between the reference lines, and the pointers pointing inwards from the outside, emphasize thickness.) See also: thinness,narrowness 25622  - Character (superimposed - sequenced - pointer)  Preferred NEW SYNONYM, replacing 25561",
    "isCharacter": true
  },
  {
    "id": "25561",
    "description": "fatness,thickness_(OLD)",
    "pos": "YELLOW",
    "explanation": "(reference line + reference line + pointer, to the right on the left line + pointer, to the left on the right line : the full square between the reference lines, and the pointers pointing inwards from the outside, emphasize thickness.)  - Character (superimposed - sequenced - pointer)  SUPERSEDED SYNONYM  See fatness,thickness 25560",
    "isCharacter": true
  },
  {
    "id": "25562",
    "description": "floating_container",
    "pos": "YELLOW",
    "explanation": "(container + water_(ground_level): container appears to float on water)  - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "25563",
    "description": "flower,bloom,blossom",
    "pos": "YELLOW",
    "explanation": "(flower + pointer, to blossom)  - Character (superimposed - pointer)",
    "isCharacter": true
  },
  {
    "id": "25564",
    "description": "fold,folding,pleating",
    "pos": "YELLOW",
    "explanation": "(vertical reference line + horizontal reference line + pictograph, of a small curved arrow (to the right and down): the arrow pulls the vertical reference line down onto the horizontal one, as if closing a folder) - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "25565",
    "description": "freezing,hardening,solidifying",
    "pos": "YELLOW",
    "explanation": "(water + thing + action indicator: to convert water to solid ice)  - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "25566",
    "description": "from_sky",
    "pos": "YELLOW",
    "explanation": "(sky + down)  - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "25567",
    "description": "fruit_(pointed)",
    "pos": "YELLOW",
    "explanation": "(fruit + pictograph of  wedge shape (combination))  - Character (superimposed - combined)",
    "isCharacter": true
  },
  {
    "id": "25568",
    "description": "future_(uncertain)",
    "pos": "YELLOW",
    "explanation": "(future + what,question_mark: unpredictable future)  - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "25569",
    "description": "good_conscience",
    "pos": "YELLOW",
    "explanation": "(conscience + and also,plus,too: conscience in a positive state)  - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "25570",
    "description": "hidden_thing",
    "pos": "YELLOW",
    "explanation": "(thing + earth: something half hidden in the earth)  - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "25571",
    "description": "horse_neck",
    "pos": "YELLOW",
    "explanation": "(horse + pointer, to neck)  - Character (superimposed - pointer)",
    "isCharacter": true
  },
  {
    "id": "25572",
    "description": "horse_rump",
    "pos": "YELLOW",
    "explanation": "(horse + pointer, to tail)  - Character (superimposed - pointer)",
    "isCharacter": true
  },
  {
    "id": "25573",
    "description": "hypodermic_needlepoint",
    "pos": "YELLOW",
    "explanation": "(injection,inoculation,shot + pointer, to the needlepoint)  - Character (superimposed - pointer)",
    "isCharacter": true
  },
  {
    "id": "25574",
    "description": "hypothesis,theory",
    "pos": "YELLOW",
    "explanation": "(creation + what,question_mark [modification, lower position]: the nature of things, but with uncertainty) - Character (superimposed - modified)",
    "isCharacter": true
  },
  {
    "id": "25575",
    "description": "imprint,depression",
    "pos": "YELLOW",
    "explanation": "(pictograph of impression, like made by a thumb pressed into something soft)  - Character",
    "isCharacter": true
  },
  {
    "id": "25576",
    "description": "insurance",
    "pos": "YELLOW",
    "explanation": "(protection + future_(uncertain): protection against unpredictable future problems and expense)  - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "25577",
    "description": "left_turn,left_(position_or_direction)",
    "pos": "YELLOW",
    "explanation": "(horizontal line [modification, half-sized, on skyline, extending to the left] + vertical line)  - Character (superimposed - modified)",
    "isCharacter": true
  },
  {
    "id": "25578",
    "description": "leg_and_foot",
    "pos": "YELLOW",
    "explanation": "(legs and feet + two pointers: to leg and foot)  - Character (superimposed - pointer)",
    "isCharacter": true
  },
  {
    "id": "25579",
    "description": "limit(s),limitation,restriction",
    "pos": "YELLOW",
    "explanation": "(line,stripe + three connecting dots + line,stripe: two reference lines on the vertical boundaries of the symbol for enclosure, limiting what lies between them)  - Character (sequenced)  Preferred NEW SYNONYM, replacing 15213",
    "isCharacter": true
  },
  {
    "id": "25580",
    "description": "mane_(lion_etc)",
    "pos": "YELLOW",
    "explanation": "(body + hair + pointer, to mane: specifier for species that has a mane)  - Character (superimposed - pointer)",
    "isCharacter": true
  },
  {
    "id": "25581",
    "description": "mash,mush,pulp_(food)",
    "pos": "YELLOW",
    "explanation": "(forward + food + backward: crushed food)  - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "25582",
    "description": "mask_(disguise)",
    "pos": "YELLOW",
    "explanation": "(pictograph of mask)  - Character",
    "isCharacter": true
  },
  {
    "id": "25583",
    "description": "meeting,encounter",
    "pos": "YELLOW",
    "explanation": "(forward + backward: two arrows approaching each other from opposite directions)  - Character (sequenced)",
    "isCharacter": true
  },
  {
    "id": "25584",
    "description": "meeting_and_parting",
    "pos": "YELLOW",
    "explanation": "(meeting, encounter [modification, higher position] + parting [modification, lower position]) - Character (superimposed - sequenced - modified)",
    "isCharacter": true
  },
  {
    "id": "25585",
    "description": "metaphor_(winged)",
    "pos": "YELLOW",
    "explanation": "(metaphor + wings: \"winged speech\", used in poetry)  - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "25586",
    "description": "nearness,closeness,proximity",
    "pos": "YELLOW",
    "explanation": "(reference line [half-sized] + reference line [half-sized]: with a half square between them, the lines are relatively near each other) See also: farness,remoteness,farawayness 25559.  - Character (sequenced)",
    "isCharacter": true
  },
  {
    "id": "25587",
    "description": "newness,novelty",
    "pos": "YELLOW",
    "explanation": "(life + beginning,start + time (combination): combination of beginning and life and time)  - Character (superimposed - combined)",
    "isCharacter": true
  },
  {
    "id": "25588",
    "description": "no_speech,anarthria",
    "pos": "YELLOW",
    "explanation": "(to speak + deletion,cancellation,destruction: unable to speak). See also: speech_impaired 26025.  - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "25589",
    "description": "opposing_forces,counter-forces",
    "pos": "YELLOW",
    "explanation": "(backward,back [modification, on skyline] + backward,back [modification, on earthline]: forces working against something) See also: adversity,hardship,setback 25545  - Character (superimposed - modified)",
    "isCharacter": true
  },
  {
    "id": "25590",
    "description": "out_of_body_(upward),regurgitation",
    "pos": "YELLOW",
    "explanation": "(body + up,upward: e.g., used in burp,belch-(to) 12925)  - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "25591",
    "description": "outdoor_(character)",
    "pos": "YELLOW",
    "explanation": "(house + dot (outside the house): can also be seen as a combination of house and out,exterior,external,outside)) - Character (sequenced - combined)",
    "isCharacter": true
  },
  {
    "id": "25592",
    "description": "parting",
    "pos": "YELLOW",
    "explanation": "(backward + forward: two arrows, pointing away from each other)  - Character (sequenced)",
    "isCharacter": true
  },
  {
    "id": "25593",
    "description": "permission,allowance_(moral)",
    "pos": "YELLOW",
    "explanation": "(conscience + permission,allowance (combination): represents a moral consideration that is allowed to pass through a mental barrier)  - Character (superimposed - combined)",
    "isCharacter": true
  },
  {
    "id": "25594",
    "description": "pizza_slice(s),sector(s),circle_sector(s)",
    "pos": "YELLOW",
    "explanation": "(pictograph of pizza divided into pieces, a circle divided into circle sectors) - Character",
    "isCharacter": true
  },
  {
    "id": "25595",
    "description": "plus_minus",
    "pos": "WHITE",
    "explanation": "(plus_sign_(low) + minus [modification, higher position])  - Character (superimposed - modified)",
    "isCharacter": true
  },
  {
    "id": "25596",
    "description": "plus_sign_(low)",
    "pos": "YELLOW",
    "explanation": "(and,also,plus,too [modification, on earthline])  - Character (modified)",
    "isCharacter": true
  },
  {
    "id": "25597",
    "description": "protected_water",
    "pos": "YELLOW",
    "explanation": "(protection + water_(ground_level): water with protection)  - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "25598",
    "description": "protection_with_pointer",
    "pos": "YELLOW",
    "explanation": "(protection + pointer)  - Character (superimposed - pointer)",
    "isCharacter": true
  },
  {
    "id": "25599",
    "description": "pull,pulling",
    "pos": "YELLOW",
    "explanation": "(thing + forward [modification, short arrow]: the forward moving arrow seems to be pulling the thing)  - Character (superimposed - modified)",
    "isCharacter": true
  },
  {
    "id": "25600",
    "description": "raised_wavy_line",
    "pos": "YELLOW",
    "explanation": "(pictograph: wavy line, as in fire, but in a higher position)  - Character",
    "isCharacter": true
  },
  {
    "id": "25601",
    "description": "recording_disk",
    "pos": "YELLOW",
    "explanation": "(pictograph, of a disk or record: circle (as in sun) + dot (in the middle), suggesting any kind of rotating recording disk, gramophone, CD, DVD, video, etc.) - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "25602",
    "description": "reflection_(mental),consideration",
    "pos": "YELLOW",
    "explanation": "(mind + reflection: mirroring thoughts in the mind)  - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "25603",
    "description": "ride,drive",
    "pos": "YELLOW",
    "explanation": "(seat,sitting_(sitting_person) + forward [modification, on groundlevel]: going forward in a sitting position)  - Character (superimposed - modified)",
    "isCharacter": true
  },
  {
    "id": "25604",
    "description": "right_turn,right_(position_or_direction)",
    "pos": "YELLOW",
    "explanation": "(vertical line + horizontal line [modification, half-sized, on skyline, extending to the right])  - Character (superimposed - modified)",
    "isCharacter": true
  },
  {
    "id": "25605",
    "description": "ruin,wreck,wreckage_(building)_(1)",
    "pos": "YELLOW",
    "explanation": "(house,building,dwelling,residence + deletion,cancellation,destruction)  - Character (superimposed)  SYMBOL SYNONYM",
    "isCharacter": true
  },
  {
    "id": "25606",
    "description": "shallowness",
    "pos": "YELLOW",
    "explanation": "(two vertical  lines [half-sized] + pointer: pointer points downward into a relatively shallow space)  See also depth 25546 - Character (superimposed - pointer)",
    "isCharacter": true
  },
  {
    "id": "25607",
    "description": "shekel_(character)",
    "pos": "YELLOW",
    "explanation": "(international symbol for Israeli shekel)  - Character",
    "isCharacter": true
  },
  {
    "id": "25608",
    "description": "shuttlecock,birdie_(badminton)",
    "pos": "YELLOW",
    "explanation": "(ball + wing(s))  - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "25609",
    "description": "sitski,sit_ski",
    "pos": "YELLOW",
    "explanation": "(ski,runner_(sled_etc) + seat,sitting_(sitting_person))  - Character (superimposed)  Preferred NEW SYNONYM, replacing 23948",
    "isCharacter": true
  },
  {
    "id": "25610",
    "description": "ski,runner_(sled_etc)",
    "pos": "YELLOW",
    "explanation": "(pictograph of a ski)  - Character",
    "isCharacter": true
  },
  {
    "id": "25611",
    "description": "smoking_(cigarette)",
    "pos": "YELLOW",
    "explanation": "(mouth [modification, on earthline] + pictograph of cigarette + fire: symbol suggests a mouth holding a smoking cigarette)  - Character (superimposed - modified)",
    "isCharacter": true
  },
  {
    "id": "25612",
    "description": "smoking_(pipe)",
    "pos": "YELLOW",
    "explanation": "(mouth [modification, on earthline] + pictograph of smoking pipe + fire:combination of smoking_(cigarette) and pictograph of a smoking pipe)  - Character (superimposed - combined - modified)",
    "isCharacter": true
  },
  {
    "id": "25613",
    "description": "snowshoe",
    "pos": "YELLOW",
    "explanation": "(pictograph of a snowshoe: special shoe for walking over snow)  - Character  Preferred NEW SYNONYM, replacing 17197",
    "isCharacter": true
  },
  {
    "id": "25614",
    "description": "projectile,rocket,spacecraft",
    "pos": "YELLOW",
    "explanation": "(thing [modification, on earthline] + pictograph of a pointed top: together, a  pictograph suggesting a projectile or a rocket)  - Character (superimposed - modified)",
    "isCharacter": true
  },
  {
    "id": "25615",
    "description": "sperm_destruction",
    "pos": "YELLOW",
    "explanation": "(sperm + deletion,cancellation,destruction)  - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "25616",
    "description": "spiral",
    "pos": "YELLOW",
    "explanation": "(pictograph)  - Character",
    "isCharacter": true
  },
  {
    "id": "25617",
    "description": "spitting",
    "pos": "YELLOW",
    "explanation": "(mouth + downward curving arrow: to expel from one's mouth)  - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "25618",
    "description": "sport_stick_and_ball,bandy_stick",
    "pos": "YELLOW",
    "explanation": "(sport stick + ball)  - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "25619",
    "description": "sport_stick_and_puck,hockey_stick",
    "pos": "YELLOW",
    "explanation": "(sport stick + disk)  - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "25620",
    "description": "square_(oblique)",
    "pos": "YELLOW",
    "explanation": "(pictograph: a square standing on a corner)  - Character",
    "isCharacter": true
  },
  {
    "id": "25621",
    "description": "thawing,melting",
    "pos": "YELLOW",
    "explanation": "(thing + water: solid ice becoming water)  - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "25622",
    "description": "thinness,narrowness",
    "pos": "YELLOW",
    "explanation": "(two reference lines + two pointers: the pointers point inward toward the narrow space formed by the reference lines)  - Character (superimposed - sequenced - pointer)",
    "isCharacter": true
  },
  {
    "id": "25623",
    "description": "three_Danish_waters_(OLD)",
    "pos": "YELLOW",
    "explanation": "(water [modification, higher position] + water + water [modification, lower position]: three channels of water used in the old Bliss-word for Denmark) - Character (superimposed - modified) SUPERSEDED CHARACTER",
    "isCharacter": true
  },
  {
    "id": "25624",
    "description": "trailer,container_transport",
    "pos": "YELLOW",
    "explanation": "(vehicle + enclosure [modification, high position] (combination))  - Character (superimposed - modified - combined)",
    "isCharacter": true
  },
  {
    "id": "25625",
    "description": "transport,transportation",
    "pos": "YELLOW",
    "explanation": "(thing [modification, high position] + wheel: moving something by vehicle)  - Character (superimposed - modified)",
    "isCharacter": true
  },
  {
    "id": "25626",
    "description": "tree_or_wood_destruction",
    "pos": "YELLOW",
    "explanation": "(tree + deletion,cancellation,destruction: processes that destroy trees or wood)  - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "25627",
    "description": "turn,turning",
    "pos": "YELLOW",
    "explanation": "(curved arrow: from skyline - down, forward and backward, to earthline)  - Character",
    "isCharacter": true
  },
  {
    "id": "25628",
    "description": "under_(ground_level)",
    "pos": "WHITE",
    "explanation": "(earth,ground,land + reference dot (under ground level): combination of ground and under)  - Character (superimposed - combined)",
    "isCharacter": true
  },
  {
    "id": "25629",
    "description": "understanding,comprehension",
    "pos": "YELLOW",
    "explanation": "(forward (arrow into) + knowledge: combination of knowledge and into - to enter into one's store of knowledge)  - Character (superimposed - combined)",
    "isCharacter": true
  },
  {
    "id": "25630",
    "description": "unfolding",
    "pos": "YELLOW",
    "explanation": "(vertical reference line + horizontal reference line + pictograph, of a small curved arrow (to the left and up): the arrow has pushed the vertical reference line up from the horizontal line, as if opening a folder) - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "25631",
    "description": "Union_Jack_pattern",
    "pos": "YELLOW",
    "explanation": "(pictograph of Union Jack flag pattern)  - Character",
    "isCharacter": true
  },
  {
    "id": "25632",
    "description": "water_animal_(big_tail)",
    "pos": "YELLOW",
    "explanation": "(animal_(water) + pictograph, of a big tail: used in beaver 12646)  - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "25633",
    "description": "water_on_ground_(flooding)",
    "pos": "YELLOW",
    "explanation": "(water + land: water flooding over land)  - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "25634",
    "description": "wideness,broadness",
    "pos": "YELLOW",
    "explanation": "(reference line + pointer (left) + pointer (right) + reference line: the pointers point outward to the widest space bounded by the reference lines)  - Character (superimposed - sequenced - pointer)",
    "isCharacter": true
  },
  {
    "id": "25635",
    "description": "wok,wok_pan",
    "pos": "YELLOW",
    "explanation": "(container,bowl,holder,pouch,basket + pictograph, of a handle)  - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "25636",
    "description": "woman_(below_waist)",
    "pos": "YELLOW",
    "explanation": "(woman + pointer, to lower part of the body)  - Character (superimposed - pointer)",
    "isCharacter": true
  },
  {
    "id": "25650",
    "description": "actor",
    "pos": "BLUE",
    "explanation": "(person + play_(theatre))",
    "isCharacter": false,
    "composition": [
      16161,
      "/",
      12335,
      "/",
      15962,
      "/",
      15666
    ]
  },
  {
    "id": "25651",
    "description": "Alice_(in_Wonderland)",
    "pos": "BLUE",
    "explanation": "(bliss-name + girl + curiosity,curiousness,inquisitiveness)",
    "isCharacter": false,
    "composition": [
      21624,
      "/",
      14439,
      "/",
      24833,
      "/",
      15162
    ]
  },
  {
    "id": "25652",
    "description": "altruism,selflessness",
    "pos": "YELLOW",
    "explanation": "(give,offer,provide-(to) + consideration,thoughtfulness)",
    "isCharacter": false,
    "composition": [
      24903,
      "/",
      24880
    ]
  },
  {
    "id": "25653",
    "description": "among,amongst",
    "pos": "WHITE",
    "explanation": "(between + many)",
    "isCharacter": false,
    "composition": [
      12669,
      "/",
      14647
    ]
  },
  {
    "id": "25654",
    "description": "artist",
    "pos": "BLUE",
    "explanation": "(person + art)",
    "isCharacter": false,
    "composition": [
      16161,
      "/",
      23583,
      "/",
      "RK:-2",
      "/",
      14164
    ]
  },
  {
    "id": "25655",
    "description": "baguette",
    "pos": "YELLOW",
    "explanation": "(bread + long)",
    "isCharacter": false,
    "composition": [
      12895,
      "/",
      15193
    ]
  },
  {
    "id": "25656",
    "description": "baking_powder",
    "pos": "YELLOW",
    "explanation": "(powder + bun + up)",
    "isCharacter": false,
    "composition": [
      16233,
      "/",
      16683,
      "/",
      17983
    ]
  },
  {
    "id": "25657",
    "description": "ballot,voting_slip",
    "pos": "YELLOW",
    "explanation": "(paper,card,page + choice,selection,election)",
    "isCharacter": false,
    "composition": [
      15962,
      "/",
      13175
    ]
  },
  {
    "id": "25658",
    "description": "barn",
    "pos": "YELLOW",
    "explanation": "(house + grain)",
    "isCharacter": false,
    "composition": [
      14905,
      "/",
      14625
    ]
  },
  {
    "id": "25659",
    "description": "bird_nest,birdnest",
    "pos": "YELLOW",
    "explanation": "(container + bird + egg)",
    "isCharacter": false,
    "composition": [
      13403,
      "/",
      12837,
      "/",
      13912
    ]
  },
  {
    "id": "25660",
    "description": "birdhouse,house_for_bird",
    "pos": "YELLOW",
    "explanation": "(house + bird)",
    "isCharacter": false,
    "composition": [
      14905,
      "/",
      12837
    ]
  },
  {
    "id": "25661",
    "description": "blog,web_blog",
    "pos": "YELLOW",
    "explanation": "(book + day + digits_(computer))",
    "isCharacter": false,
    "composition": [
      12875,
      "/",
      13639,
      "/",
      23476
    ]
  },
  {
    "id": "25662",
    "description": "boar",
    "pos": "YELLOW",
    "explanation": "(pig + male)",
    "isCharacter": false,
    "composition": [
      16175,
      "/",
      12335
    ]
  },
  {
    "id": "25663",
    "description": "boyfriend",
    "pos": "BLUE",
    "explanation": "(man + love)",
    "isCharacter": false,
    "composition": [
      15416,
      "/",
      15399
    ]
  },
  {
    "id": "25664",
    "description": "bread_(sliced),sliced_bread",
    "pos": "YELLOW",
    "explanation": "(bread + knife: bread cut into slices)",
    "isCharacter": false,
    "composition": [
      12895,
      "/",
      15159
    ]
  },
  {
    "id": "25665",
    "description": "bread_crust",
    "pos": "YELLOW",
    "explanation": "(crust + bread)",
    "isCharacter": false,
    "composition": [
      16954,
      "/",
      12895
    ]
  },
  {
    "id": "25666",
    "description": "bread_knife",
    "pos": "YELLOW",
    "explanation": "(knife + bread)",
    "isCharacter": false,
    "composition": [
      15159,
      "/",
      12895
    ]
  },
  {
    "id": "25667",
    "description": "bread_with_fruit",
    "pos": "YELLOW",
    "explanation": "(bread + fruit)",
    "isCharacter": false,
    "composition": [
      12895,
      "/",
      14405
    ]
  },
  {
    "id": "25668",
    "description": "bread_with_seeds",
    "pos": "YELLOW",
    "explanation": "(bread + seed)",
    "isCharacter": false,
    "composition": [
      12895,
      "/",
      16749
    ]
  },
  {
    "id": "25669",
    "description": "brother-in-law_(husband's_brother)",
    "pos": "BLUE",
    "explanation": "(brother + husband)",
    "isCharacter": false,
    "composition": [
      17209,
      "/",
      8498,
      "/",
      14914
    ]
  },
  {
    "id": "25670",
    "description": "brother-in-law_(partner's_brother)",
    "pos": "BLUE",
    "explanation": "(brother + spouse)",
    "isCharacter": false,
    "composition": [
      17209,
      "/",
      8498,
      "/",
      17237
    ]
  },
  {
    "id": "25671",
    "description": "brother-in-law_(wife's_brother)",
    "pos": "BLUE",
    "explanation": "(brother + wife)",
    "isCharacter": false,
    "composition": [
      17209,
      "/",
      8498,
      "/",
      18251
    ]
  },
  {
    "id": "25672",
    "description": "bun_(soft),roll_(soft),scone,brioche",
    "pos": "YELLOW",
    "explanation": "(roll + imprint,depression: where imprint,depression represents soft [contraction])",
    "isCharacter": false,
    "composition": [
      16683,
      "/",
      25575
    ]
  },
  {
    "id": "25673",
    "description": "business_idea",
    "pos": "YELLOW",
    "explanation": "(idea + business)",
    "isCharacter": false,
    "composition": [
      14926,
      "/",
      13093
    ]
  },
  {
    "id": "25674",
    "description": "cactus",
    "pos": "YELLOW",
    "explanation": "(plant + quill(s),spine(s))",
    "isCharacter": false,
    "composition": [
      16196,
      "/",
      23627
    ]
  },
  {
    "id": "25675",
    "description": "chat_(online)",
    "pos": "YELLOW",
    "explanation": "(talk + back and forth + digits_(computer))",
    "isCharacter": false,
    "composition": [
      15666,
      "/",
      12610,
      "/",
      23476
    ]
  },
  {
    "id": "25676",
    "description": "chat_(online)-(to)",
    "pos": "RED",
    "explanation": "(chat (online) + action indicator)",
    "isCharacter": false,
    "composition": [
      15666,
      ";",
      8993,
      "/",
      12610,
      "/",
      23476
    ]
  },
  {
    "id": "25677",
    "description": "cheat-(to)",
    "pos": "RED",
    "explanation": "(cheating + action indicator)",
    "isCharacter": false,
    "composition": [
      12335,
      ";",
      8993,
      "/",
      15474,
      "/",
      17786
    ]
  },
  {
    "id": "25678",
    "description": "cheating",
    "pos": "YELLOW",
    "explanation": "(activity + without + truth)",
    "isCharacter": false,
    "composition": [
      12335,
      "/",
      15474,
      "/",
      17786
    ]
  },
  {
    "id": "25679",
    "description": "chick",
    "pos": "YELLOW",
    "explanation": "(chicken (bird) + child)",
    "isCharacter": false,
    "composition": [
      12837,
      "/",
      14377,
      "/",
      13166
    ]
  },
  {
    "id": "25680",
    "description": "classmate",
    "pos": "BLUE",
    "explanation": "(person + equal + classroom [contraction])",
    "isCharacter": false,
    "composition": [
      16161,
      "/",
      16713,
      "/",
      16687,
      "/",
      15162
    ]
  },
  {
    "id": "25681",
    "description": "claw_(shellfish)",
    "pos": "YELLOW",
    "explanation": "(crab,shellfish_(with_claws) + pointer, to claw)  - Character (superimposed - pointer)",
    "isCharacter": true
  },
  {
    "id": "25682",
    "description": "client,customer",
    "pos": "BLUE",
    "explanation": "(person + give + help)",
    "isCharacter": false,
    "composition": [
      16161,
      "/",
      24727,
      "/",
      14704
    ]
  },
  {
    "id": "25683",
    "description": "colleague",
    "pos": "BLUE",
    "explanation": "(person + equal + work)",
    "isCharacter": false,
    "composition": [
      16161,
      "/",
      16713,
      "/",
      18273
    ]
  },
  {
    "id": "25684",
    "description": "combine_(harvester)",
    "pos": "YELLOW",
    "explanation": "(machine + knife + grain)",
    "isCharacter": false,
    "composition": [
      15406,
      "/",
      15159,
      "/",
      14625
    ]
  },
  {
    "id": "25685",
    "description": "compass_(drawing)",
    "pos": "YELLOW",
    "explanation": "(tool + circle)",
    "isCharacter": false,
    "composition": [
      17755,
      "/",
      14133,
      "/",
      17717,
      "/",
      17462
    ]
  },
  {
    "id": "25686",
    "description": "cone,conifer_cone,strobilus",
    "pos": "YELLOW",
    "explanation": "(fruit + evergreen_tree,spruce,fir,fir_tree)",
    "isCharacter": false,
    "composition": [
      14405,
      "/",
      14116
    ]
  },
  {
    "id": "25687",
    "description": "core_activity",
    "pos": "YELLOW",
    "explanation": "(activity + middle)",
    "isCharacter": false,
    "composition": [
      12335,
      "/",
      15464
    ]
  },
  {
    "id": "25688",
    "description": "cowshed",
    "pos": "YELLOW",
    "explanation": "(house + animal_(bovine,ovine),bovid,bovine)",
    "isCharacter": false,
    "composition": [
      14905,
      "/",
      12379
    ]
  },
  {
    "id": "25689",
    "description": "daughter-in-law",
    "pos": "BLUE",
    "explanation": "(wife + offspring,child)",
    "isCharacter": false,
    "composition": [
      18251,
      "/",
      15912
    ]
  },
  {
    "id": "25690",
    "description": "definition",
    "pos": "YELLOW",
    "explanation": "(explanation + meaning)",
    "isCharacter": false,
    "composition": [
      15666,
      "/",
      25629,
      "/",
      15441
    ]
  },
  {
    "id": "25691",
    "description": "dice,die",
    "pos": "YELLOW",
    "explanation": "(block,brick + number)",
    "isCharacter": false,
    "composition": [
      12860,
      "/",
      15742
    ]
  },
  {
    "id": "25692",
    "description": "dichotomy,duality",
    "pos": "YELLOW",
    "explanation": "(mind + division + 2)",
    "isCharacter": false,
    "composition": [
      15471,
      "/",
      15972,
      "/",
      8498
    ]
  },
  {
    "id": "25693",
    "description": "dictator_(OLD)",
    "pos": "BLUE",
    "explanation": "(leader + dictatorship_(country))",
    "isCharacter": false,
    "composition": [
      21054,
      "/",
      13423,
      "/",
      24926,
      "/",
      15474,
      "/",
      13175
    ]
  },
  {
    "id": "25694",
    "description": "dictatorship_(country)",
    "pos": "YELLOW",
    "explanation": "(country + decide + without + choice)",
    "isCharacter": false,
    "composition": [
      13423,
      "/",
      24926,
      "/",
      15474,
      "/",
      13175
    ]
  },
  {
    "id": "25695",
    "description": "dilemma",
    "pos": "YELLOW",
    "explanation": "(question + difficult + choice)",
    "isCharacter": false,
    "composition": [
      16445,
      "/",
      24884,
      "/",
      13175
    ]
  },
  {
    "id": "25696",
    "description": "doll_pram,doll_carriage",
    "pos": "YELLOW",
    "explanation": "(wagon,cart,truck + doll: a combination of (baby_carriage,buggy,pram,pushchair,stroller and doll)",
    "isCharacter": false,
    "composition": [
      18028,
      "/",
      13166,
      "/",
      23583
    ]
  },
  {
    "id": "25697",
    "description": "dollhouse,doll_house",
    "pos": "YELLOW",
    "explanation": "(house + doll)",
    "isCharacter": false,
    "composition": [
      14905,
      "/",
      13166,
      "/",
      23583
    ]
  },
  {
    "id": "25698",
    "description": "domestic_science,home_economics",
    "pos": "YELLOW",
    "explanation": "(science + house_work,housekeeping,housework)",
    "isCharacter": false,
    "composition": [
      16735,
      "/",
      18273,
      "/",
      14905
    ]
  },
  {
    "id": "25699",
    "description": "domestic_science,home_economics_(class)",
    "pos": "YELLOW",
    "explanation": "(class [contraction] + house_work,housekeeping,housework)",
    "isCharacter": false,
    "composition": [
      15162,
      "/",
      18273,
      "/",
      14905
    ]
  },
  {
    "id": "25700",
    "description": "dormouse_(sleepy_rodent)",
    "pos": "YELLOW",
    "explanation": "(rodent + sleep)",
    "isCharacter": false,
    "composition": [
      12378,
      "/",
      17517,
      "/",
      17008
    ]
  },
  {
    "id": "25701",
    "description": "drop",
    "pos": "YELLOW",
    "explanation": "(dot + water,fluid,liquid)",
    "isCharacter": false,
    "composition": [
      13867,
      "/",
      18209
    ]
  },
  {
    "id": "25702",
    "description": "employed,working",
    "pos": "GREEN",
    "explanation": "(work + description indicator)",
    "isCharacter": false,
    "composition": [
      18273,
      ";",
      8998
    ]
  },
  {
    "id": "25703",
    "description": "employee",
    "pos": "BLUE",
    "explanation": "(person + work + agreement)",
    "isCharacter": false,
    "composition": [
      16161,
      "/",
      18273,
      "/",
      15962,
      "/",
      12354
    ]
  },
  {
    "id": "25704",
    "description": "equilateral_triangle",
    "pos": "YELLOW",
    "explanation": "(triangle + 3 + equal,same)",
    "isCharacter": false,
    "composition": [
      14133,
      "/",
      17717,
      "/",
      13607,
      "/",
      8499,
      "/",
      16713
    ]
  },
  {
    "id": "25705",
    "description": "ewe",
    "pos": "YELLOW",
    "explanation": "(sheep + female)",
    "isCharacter": false,
    "composition": [
      12379,
      "/",
      13365,
      "/",
      14166
    ]
  },
  {
    "id": "25706",
    "description": "even_number",
    "pos": "YELLOW",
    "explanation": "(number + multiplication + 2: a number which can be divided evenly into groups of two)",
    "isCharacter": false,
    "composition": [
      15742,
      "/",
      15673,
      "/",
      8498
    ]
  },
  {
    "id": "25707",
    "description": "excavator,digger,power_shovel",
    "pos": "YELLOW",
    "explanation": "(machine + digging,excavation)",
    "isCharacter": false,
    "composition": [
      15406,
      "/",
      25550
    ]
  },
  {
    "id": "25708",
    "description": "experience",
    "pos": "YELLOW",
    "explanation": "(knowledge + activity + self)",
    "isCharacter": false,
    "composition": [
      15162,
      "/",
      12335,
      "/",
      8497,
      "/",
      15214
    ]
  },
  {
    "id": "25709",
    "description": "explanation,reason",
    "pos": "YELLOW",
    "explanation": "(mouth + understanding,comprehension: something said to make something understood)",
    "isCharacter": false,
    "composition": [
      15666,
      "/",
      25629
    ]
  },
  {
    "id": "25710",
    "description": "family,couple_(female)",
    "pos": "BLUE",
    "explanation": "(woman + protection + woman)  - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "25711",
    "description": "family,couple_(male)",
    "pos": "BLUE",
    "explanation": "(man + protection + man)  - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "25712",
    "description": "family_(female)",
    "pos": "BLUE",
    "explanation": "(woman + birth + woman)  - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "25713",
    "description": "family_(male)",
    "pos": "BLUE",
    "explanation": "(man + birth + man)  - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "25714",
    "description": "farmhouse",
    "pos": "YELLOW",
    "explanation": "(house + farm)",
    "isCharacter": false,
    "composition": [
      14905,
      "/",
      14151
    ]
  },
  {
    "id": "25715",
    "description": "father-in-law_(partner's_father)",
    "pos": "BLUE",
    "explanation": "(father + spouse)",
    "isCharacter": false,
    "composition": [
      14157,
      "/",
      17237
    ]
  },
  {
    "id": "25716",
    "description": "female_friend",
    "pos": "BLUE",
    "explanation": "(woman + friend)",
    "isCharacter": false,
    "composition": [
      18269,
      "/",
      "RK:-2",
      "/",
      14164,
      "/",
      12374,
      "/",
      14947
    ]
  },
  {
    "id": "25717",
    "description": "flower_meadow",
    "pos": "YELLOW",
    "explanation": "(meadow + flower)",
    "isCharacter": false,
    "composition": [
      15180,
      "/",
      14205
    ]
  },
  {
    "id": "25718",
    "description": "get_engaged-(to)",
    "pos": "RED",
    "explanation": "(engagement + action indicator)",
    "isCharacter": false,
    "composition": [
      12656,
      "/",
      15425,
      ";",
      8993
    ]
  },
  {
    "id": "25719",
    "description": "girlfriend",
    "pos": "BLUE",
    "explanation": "(woman + love)",
    "isCharacter": false,
    "composition": [
      18269,
      "/",
      15399
    ]
  },
  {
    "id": "25720",
    "description": "grandchild",
    "pos": "BLUE",
    "explanation": "(child + grandparents)",
    "isCharacter": false,
    "composition": [
      13166,
      "/",
      14632
    ]
  },
  {
    "id": "25721",
    "description": "graze-(to)",
    "pos": "RED",
    "explanation": "(eat + grass + action Indicator)",
    "isCharacter": false,
    "composition": [
      14377,
      ";",
      8993,
      "/",
      14636
    ]
  },
  {
    "id": "25722",
    "description": "handcraft,craft-(to)",
    "pos": "RED",
    "explanation": "(handicraft + action Indicator)",
    "isCharacter": false,
    "composition": [
      23583,
      ";",
      8993,
      "/",
      "RK:-2",
      "/",
      14667
    ]
  },
  {
    "id": "25723",
    "description": "handmade_figure,handicraft_(animal)",
    "pos": "YELLOW",
    "explanation": "(handmade_object,handicraft + animal)",
    "isCharacter": false,
    "composition": [
      23583,
      ";",
      9009,
      "/",
      "RK:-2",
      "/",
      14667,
      "/",
      12378
    ]
  },
  {
    "id": "25724",
    "description": "handmade_figure,handicraft_(person)",
    "pos": "YELLOW",
    "explanation": "(handmade_object,handicraft + person)",
    "isCharacter": false,
    "composition": [
      23583,
      ";",
      9009,
      "/",
      "RK:-2",
      "/",
      14667,
      "/",
      16161
    ]
  },
  {
    "id": "25725",
    "description": "hare",
    "pos": "YELLOW",
    "explanation": "(rodent + ear + big)",
    "isCharacter": false,
    "composition": [
      12378,
      "/",
      17517,
      "/",
      13894,
      "/",
      24875
    ]
  },
  {
    "id": "25726",
    "description": "height,altitude",
    "pos": "YELLOW",
    "explanation": "(scale,measurement + height,altitude)",
    "isCharacter": false,
    "composition": [
      24806,
      "/",
      24909
    ]
  },
  {
    "id": "25727",
    "description": "hen",
    "pos": "YELLOW",
    "explanation": "(chicken (bird) + female)",
    "isCharacter": false,
    "composition": [
      12837,
      "/",
      14377,
      "/",
      14166
    ]
  },
  {
    "id": "25728",
    "description": "henhouse,chicken_coop",
    "pos": "YELLOW",
    "explanation": "(house + chicken (bird))",
    "isCharacter": false,
    "composition": [
      14905,
      "/",
      12837,
      "/",
      14377
    ]
  },
  {
    "id": "25729",
    "description": "home_worker",
    "pos": "BLUE",
    "explanation": "(person + work + money + house)",
    "isCharacter": false,
    "composition": [
      16161,
      "/",
      18273,
      "/",
      15484,
      "/",
      14905
    ]
  },
  {
    "id": "25730",
    "description": "housekeep,housework-(to)",
    "pos": "RED",
    "explanation": "(house_work,housekeeping,housework + action indicator)",
    "isCharacter": false,
    "composition": [
      18273,
      ";",
      8993,
      "/",
      14905
    ]
  },
  {
    "id": "25731",
    "description": "housekeeper",
    "pos": "BLUE",
    "explanation": "(person + house_work,housekeeping,housework)",
    "isCharacter": false,
    "composition": [
      16161,
      "/",
      18273,
      "/",
      14905
    ]
  },
  {
    "id": "25732",
    "description": "ice_layer",
    "pos": "YELLOW",
    "explanation": "(layer,level + ice)",
    "isCharacter": false,
    "composition": [
      25748,
      "/",
      14919
    ]
  },
  {
    "id": "25733",
    "description": "ice_skating_rink_(indoor)",
    "pos": "YELLOW",
    "explanation": "(house + ice_skates: ice skates representing skating [contraction])",
    "isCharacter": false,
    "composition": [
      14905,
      "/",
      14924
    ]
  },
  {
    "id": "25734",
    "description": "icing",
    "pos": "YELLOW",
    "explanation": "(spread,paste + powdered_sugar,icing_sugar)",
    "isCharacter": false,
    "composition": [
      17238,
      "/",
      12339,
      ";",
      9009,
      "/",
      17983,
      "/",
      16233
    ]
  },
  {
    "id": "25735",
    "description": "influence",
    "pos": "YELLOW",
    "explanation": "(cause + change,alteration)",
    "isCharacter": false,
    "composition": [
      13134,
      "/",
      13151
    ]
  },
  {
    "id": "25736",
    "description": "influence,affect-(to)",
    "pos": "RED",
    "explanation": "(influence + action indicator)",
    "isCharacter": false,
    "composition": [
      13134,
      ";",
      8993,
      "/",
      13151
    ]
  },
  {
    "id": "25737",
    "description": "influenced,affected",
    "pos": "GREEN",
    "explanation": "(influence + description indicator)",
    "isCharacter": false,
    "composition": [
      13134,
      ";",
      8998,
      "/",
      13151
    ]
  },
  {
    "id": "25738",
    "description": "inspiration",
    "pos": "YELLOW",
    "explanation": "(cause + want,desire + activity)",
    "isCharacter": false,
    "composition": [
      13134,
      "/",
      14164,
      "/",
      14183,
      "/",
      12335
    ]
  },
  {
    "id": "25739",
    "description": "inspire-(to)",
    "pos": "RED",
    "explanation": "(inspiration + action indicator)",
    "isCharacter": false,
    "composition": [
      13134,
      ";",
      8993,
      "/",
      14164,
      "/",
      14183,
      "/",
      12335
    ]
  },
  {
    "id": "25740",
    "description": "inspired",
    "pos": "GREEN",
    "explanation": "(inspiration + description indicator)",
    "isCharacter": false,
    "composition": [
      13134,
      ";",
      8998,
      "/",
      14164,
      "/",
      14183,
      "/",
      12335
    ]
  },
  {
    "id": "25741",
    "description": "interrupt_(in_conversation)-(to)",
    "pos": "RED",
    "explanation": "(interruption + action indicator)",
    "isCharacter": false,
    "composition": [
      15666,
      ";",
      8993,
      "/",
      12333
    ]
  },
  {
    "id": "25742",
    "description": "interruption_(in_conversation)",
    "pos": "YELLOW",
    "explanation": "(say,speak,talk,tell,express-(to) + across)",
    "isCharacter": false,
    "composition": [
      15666,
      "/",
      12333
    ]
  },
  {
    "id": "25743",
    "description": "intuition",
    "pos": "YELLOW",
    "explanation": "(knowledge + inside)",
    "isCharacter": false,
    "composition": [
      15162,
      "/",
      14932
    ]
  },
  {
    "id": "25744",
    "description": "isosceles_triangle",
    "pos": "YELLOW",
    "explanation": "(triangle + 2 + same,equal,equality)",
    "isCharacter": false,
    "composition": [
      14133,
      "/",
      17717,
      "/",
      13607,
      "/",
      8498,
      "/",
      16713
    ]
  },
  {
    "id": "25745",
    "description": "jobcentre,job-centre",
    "pos": "YELLOW",
    "explanation": "(house + exchange + work)",
    "isCharacter": false,
    "composition": [
      14905,
      "/",
      25555,
      "/",
      18273
    ]
  },
  {
    "id": "25746",
    "description": "knight",
    "pos": "BLUE",
    "explanation": "(person + shield + knife,sword)",
    "isCharacter": false,
    "composition": [
      16161,
      "/",
      12616,
      "/",
      15159
    ]
  },
  {
    "id": "25747",
    "description": "lawn_mower,mower",
    "pos": "YELLOW",
    "explanation": "(machine + to cut + grass)",
    "isCharacter": false,
    "composition": [
      15406,
      "/",
      15159,
      "/",
      14636
    ]
  },
  {
    "id": "25748",
    "description": "layer,level",
    "pos": "YELLOW",
    "explanation": "(pictograph: three half-sized horizontal reference lines on top of each other suggesting layers or levels)  - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "25749",
    "description": "long_for,yearn-(to)",
    "pos": "RED",
    "explanation": "(longing,yearning + action indicator)",
    "isCharacter": false,
    "composition": [
      14164,
      ";",
      8993,
      "/",
      14183,
      "/",
      14947
    ]
  },
  {
    "id": "25750",
    "description": "longing,yearning",
    "pos": "YELLOW",
    "explanation": "(want,desire + intensity)",
    "isCharacter": false,
    "composition": [
      14164,
      "/",
      14183,
      "/",
      14947
    ]
  },
  {
    "id": "25751",
    "description": "make_cheese-(to)",
    "pos": "RED",
    "explanation": "(to make + cheese)",
    "isCharacter": false,
    "composition": [
      23583,
      ";",
      8993,
      "/",
      13157
    ]
  },
  {
    "id": "25752",
    "description": "male_friend",
    "pos": "BLUE",
    "explanation": "(man + friend)",
    "isCharacter": false,
    "composition": [
      15416,
      "/",
      "RK:-2",
      "/",
      14164,
      "/",
      12374,
      "/",
      14947
    ]
  },
  {
    "id": "25753",
    "description": "married_(to_be)",
    "pos": "GREEN",
    "explanation": "(marriage + description indicator)",
    "isCharacter": false,
    "composition": [
      15425,
      ";",
      8998
    ]
  },
  {
    "id": "25754",
    "description": "measuring_cup",
    "pos": "YELLOW",
    "explanation": "(mug,cup + measurement,measure)",
    "isCharacter": false,
    "composition": [
      13621,
      "/",
      15443
    ]
  },
  {
    "id": "25755",
    "description": "mislead-(to)",
    "pos": "RED",
    "explanation": "(to lead + without + truth + action indicator)",
    "isCharacter": false,
    "composition": [
      22913,
      ";",
      8993,
      "/",
      15474,
      "/",
      17786
    ]
  },
  {
    "id": "25756",
    "description": "molasses,dark_syrup,black_treacle",
    "pos": "YELLOW",
    "explanation": "(syrup [contraction] + dark + thing indicator)",
    "isCharacter": false,
    "composition": [
      12339,
      ";",
      9009,
      "/",
      18209,
      "/",
      17983,
      "/",
      15474,
      "/",
      15208
    ]
  },
  {
    "id": "25757",
    "description": "mother-in-law_(partner's_mother)",
    "pos": "BLUE",
    "explanation": "(mother + spouse)",
    "isCharacter": false,
    "composition": [
      15662,
      "/",
      17237
    ]
  },
  {
    "id": "25758",
    "description": "motivate-(to)",
    "pos": "RED",
    "explanation": "(motivation + action indicator)",
    "isCharacter": false,
    "composition": [
      13134,
      ";",
      8993,
      "/",
      14164,
      "/",
      "RK:-2",
      "/",
      12335
    ]
  },
  {
    "id": "25759",
    "description": "motivated",
    "pos": "GREEN",
    "explanation": "(motivation + description indicator)",
    "isCharacter": false,
    "composition": [
      13134,
      ";",
      8998,
      "/",
      14164,
      "/",
      "RK:-2",
      "/",
      12335
    ]
  },
  {
    "id": "25760",
    "description": "motivation",
    "pos": "YELLOW",
    "explanation": "(cause + feeling + activity)",
    "isCharacter": false,
    "composition": [
      13134,
      "/",
      14164,
      "/",
      "RK:-2",
      "/",
      12335
    ]
  },
  {
    "id": "25761",
    "description": "odd_number",
    "pos": "YELLOW",
    "explanation": "(number + multiplication + 2 + plus + 1: a number which cannot be divided evenly into groups of two)",
    "isCharacter": false,
    "composition": [
      15742,
      "/",
      15673,
      "/",
      8498,
      "/",
      12374,
      "/",
      8497
    ]
  },
  {
    "id": "25762",
    "description": "partner_(game,dancing,business)",
    "pos": "BLUE",
    "explanation": "(person + together + person)",
    "isCharacter": false,
    "composition": [
      16161,
      "/",
      23409,
      "/",
      16161
    ]
  },
  {
    "id": "25763",
    "description": "pasture",
    "pos": "YELLOW",
    "explanation": "(meadow + animal)",
    "isCharacter": false,
    "composition": [
      15180,
      "/",
      12378
    ]
  },
  {
    "id": "25764",
    "description": "pasture,put_out_to_pasture-(to)",
    "pos": "RED",
    "explanation": "(pasture + action indicator)",
    "isCharacter": false,
    "composition": [
      15180,
      ";",
      8993,
      "/",
      12378
    ]
  },
  {
    "id": "25765",
    "description": "patient,enduring",
    "pos": "GREEN",
    "explanation": "(patience + description indicator)",
    "isCharacter": false,
    "composition": [
      12322,
      ";",
      8998,
      "/",
      13935,
      "/",
      15212
    ]
  },
  {
    "id": "25766",
    "description": "patient_(in_medical_care)",
    "pos": "BLUE",
    "explanation": "(person + get + medicine,medical_practice: where medicine represents medical_treatment,medical_care [contraction])",
    "isCharacter": false,
    "composition": [
      16161,
      "/",
      24727,
      "/",
      24920
    ]
  },
  {
    "id": "25767",
    "description": "pig_(wild),boar_(wild)",
    "pos": "YELLOW",
    "explanation": "(pig + open: where open represents wild)",
    "isCharacter": false,
    "composition": [
      16175,
      "/",
      15923
    ]
  },
  {
    "id": "25768",
    "description": "piggery",
    "pos": "YELLOW",
    "explanation": "(house + pig)",
    "isCharacter": false,
    "composition": [
      14905,
      "/",
      16175
    ]
  },
  {
    "id": "25769",
    "description": "piglet",
    "pos": "YELLOW",
    "explanation": "(pig + child)",
    "isCharacter": false,
    "composition": [
      16175,
      "/",
      13166
    ]
  },
  {
    "id": "25770",
    "description": "playhouse,play_house",
    "pos": "YELLOW",
    "explanation": "(house + play [contraction])",
    "isCharacter": false,
    "composition": [
      14905,
      "/",
      14164,
      "/",
      17983
    ]
  },
  {
    "id": "25771",
    "description": "powdered_sugar,icing_sugar",
    "pos": "YELLOW",
    "explanation": "(sugar [contraction] + powder + thing indicator)",
    "isCharacter": false,
    "composition": [
      12339,
      ";",
      9009,
      "/",
      17983,
      "/",
      16233
    ]
  },
  {
    "id": "25772",
    "description": "principal,headteacher",
    "pos": "BLUE",
    "explanation": "(leader + school [contraction])",
    "isCharacter": false,
    "composition": [
      21054,
      "/",
      14905,
      "/",
      15162
    ]
  },
  {
    "id": "25773",
    "description": "prize,award,trophy",
    "pos": "YELLOW",
    "explanation": "(thing + win-(to))",
    "isCharacter": false,
    "composition": [
      17717,
      "/",
      16451,
      "/",
      12339
    ]
  },
  {
    "id": "25774",
    "description": "publication",
    "pos": "YELLOW",
    "explanation": "(giving + dispersion,dissemination,scattering,spread,spreading)",
    "isCharacter": false,
    "composition": [
      24903,
      "/",
      24887
    ]
  },
  {
    "id": "25775",
    "description": "publish-(to)",
    "pos": "RED",
    "explanation": "(publication + action indicator)",
    "isCharacter": false,
    "composition": [
      24903,
      ";",
      8993,
      "/",
      24887
    ]
  },
  {
    "id": "25776",
    "description": "publisher",
    "pos": "BLUE",
    "explanation": "(person + publication)",
    "isCharacter": false,
    "composition": [
      16161,
      "/",
      24903,
      "/",
      24887
    ]
  },
  {
    "id": "25777",
    "description": "puddle,pool,water_(ground_level)",
    "pos": "YELLOW",
    "explanation": "(water,fluid,liquid [modification, on the ground])  - Character (modified)",
    "isCharacter": true
  },
  {
    "id": "25778",
    "description": "ram",
    "pos": "YELLOW",
    "explanation": "(sheep + male)",
    "isCharacter": false,
    "composition": [
      12379,
      "/",
      13365,
      "/",
      12335
    ]
  },
  {
    "id": "25779",
    "description": "reality",
    "pos": "YELLOW",
    "explanation": "(life + earth,ground,land)  - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "25780",
    "description": "rescue",
    "pos": "YELLOW",
    "explanation": "(help + danger)",
    "isCharacter": false,
    "composition": [
      14704,
      "/",
      13632
    ]
  },
  {
    "id": "25781",
    "description": "rescue-(to)",
    "pos": "RED",
    "explanation": "(rescue + action indicator)",
    "isCharacter": false,
    "composition": [
      14704,
      ";",
      8993,
      "/",
      13632
    ]
  },
  {
    "id": "25782",
    "description": "right_triangle",
    "pos": "YELLOW",
    "explanation": "(triangle + angle_(right),right_angle)",
    "isCharacter": false,
    "composition": [
      14133,
      "/",
      17717,
      "/",
      13607,
      "/",
      16674
    ]
  },
  {
    "id": "25783",
    "description": "root",
    "pos": "YELLOW",
    "explanation": "(earth + pictograph of root)  - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "25784",
    "description": "ruin_(castle),castle_ruin",
    "pos": "YELLOW",
    "explanation": "(castle + deletion,cancellation,destruction)",
    "isCharacter": false,
    "composition": [
      23437,
      "/",
      24883
    ]
  },
  {
    "id": "25785",
    "description": "salesperson,shop_owner",
    "pos": "BLUE",
    "explanation": "(person + to sell)",
    "isCharacter": false,
    "composition": [
      16161,
      "/",
      17717,
      "/",
      15484
    ]
  },
  {
    "id": "25786",
    "description": "scalene_triangle",
    "pos": "YELLOW",
    "explanation": "(triangle + different)",
    "isCharacter": false,
    "composition": [
      14133,
      "/",
      17717,
      "/",
      13607,
      "/",
      13675
    ]
  },
  {
    "id": "25787",
    "description": "sceptical,skeptical,questioning",
    "pos": "GREEN",
    "explanation": "(scepticism + description indicator)",
    "isCharacter": false,
    "composition": [
      22911,
      ";",
      8998,
      "/",
      15925
    ]
  },
  {
    "id": "25788",
    "description": "scepticism,skepticism",
    "pos": "YELLOW",
    "explanation": "(doubt + opinion)",
    "isCharacter": false,
    "composition": [
      22911,
      "/",
      15925
    ]
  },
  {
    "id": "25789",
    "description": "schoolmate",
    "pos": "BLUE",
    "explanation": "(person + equal + school [contraction])",
    "isCharacter": false,
    "composition": [
      16161,
      "/",
      16713,
      "/",
      14905,
      "/",
      15162
    ]
  },
  {
    "id": "25790",
    "description": "sculpture",
    "pos": "YELLOW",
    "explanation": "(work_of_art,art_object + 3 + space,dimension)",
    "isCharacter": false,
    "composition": [
      23583,
      ";",
      9009,
      "/",
      "RK:-2",
      "/",
      14164,
      "/",
      8499,
      "/",
      17221
    ]
  },
  {
    "id": "25791",
    "description": "self-raising_flour",
    "pos": "YELLOW",
    "explanation": "(flour + up)",
    "isCharacter": false,
    "composition": [
      16233,
      "/",
      14625,
      "/",
      17983
    ]
  },
  {
    "id": "25792",
    "description": "set_square",
    "pos": "YELLOW",
    "explanation": "(angle_(right),right_angle + thing indicator)  - (character with thing indicator)",
    "isCharacter": "false",
    "composition": [
      16674,
      ";",
      9009
    ]
  },
  {
    "id": "25793",
    "description": "sheath",
    "pos": "YELLOW",
    "explanation": "(protection + knife,sword)",
    "isCharacter": false,
    "composition": [
      16420,
      "/",
      15159
    ]
  },
  {
    "id": "25794",
    "description": "sheep_shed,sheep_barn",
    "pos": "YELLOW",
    "explanation": "(house + sheep)",
    "isCharacter": false,
    "composition": [
      14905,
      "/",
      12379,
      "/",
      13365
    ]
  },
  {
    "id": "25795",
    "description": "sister-in-law_(husband's_sister)",
    "pos": "BLUE",
    "explanation": "(sister + husband)",
    "isCharacter": false,
    "composition": [
      13638,
      "/",
      8498,
      "/",
      14914
    ]
  },
  {
    "id": "25796",
    "description": "sister-in-law_(partner's_sister)",
    "pos": "BLUE",
    "explanation": "(sister + spouse)",
    "isCharacter": false,
    "composition": [
      13638,
      "/",
      8498,
      "/",
      17237
    ]
  },
  {
    "id": "25797",
    "description": "sister-in-law_(wife's_sister)",
    "pos": "BLUE",
    "explanation": "(sister + wife)",
    "isCharacter": false,
    "composition": [
      13638,
      "/",
      8498,
      "/",
      18251
    ]
  },
  {
    "id": "25798",
    "description": "slaughter",
    "pos": "YELLOW",
    "explanation": "(knife + animal)",
    "isCharacter": false,
    "composition": [
      15159,
      "/",
      12378
    ]
  },
  {
    "id": "25799",
    "description": "slaughter-(to)",
    "pos": "RED",
    "explanation": "(slaughter + action indicator)",
    "isCharacter": false,
    "composition": [
      15159,
      ";",
      8993,
      "/",
      12378
    ]
  },
  {
    "id": "25800",
    "description": "slaughterer",
    "pos": "BLUE",
    "explanation": "(person + slaughter)",
    "isCharacter": false,
    "composition": [
      16161,
      "/",
      15159,
      "/",
      12378
    ]
  },
  {
    "id": "25801",
    "description": "slaughterhouse,abattoir",
    "pos": "YELLOW",
    "explanation": "(house + slaughter)",
    "isCharacter": false,
    "composition": [
      14905,
      "/",
      15159,
      "/",
      12378
    ]
  },
  {
    "id": "25802",
    "description": "slice_of_bread,bread_slice",
    "pos": "YELLOW",
    "explanation": "(slice + bread + thing indicator)",
    "isCharacter": false,
    "composition": [
      25622,
      ";",
      9009,
      "/",
      15159,
      "/",
      12895
    ]
  },
  {
    "id": "25803",
    "description": "slide,skid,slip-(to)",
    "pos": "RED",
    "explanation": "(downward and forward + action indicator)",
    "isCharacter": false,
    "composition": [
      13871,
      ";",
      8993
    ]
  },
  {
    "id": "25804",
    "description": "smartphone,digital_phone",
    "pos": "YELLOW",
    "explanation": "(digital device + telephone)",
    "isCharacter": false,
    "composition": [
      24638,
      "/",
      15172,
      "/",
      13918
    ]
  },
  {
    "id": "25805",
    "description": "son-in-law",
    "pos": "BLUE",
    "explanation": "(husband + offspring: the husband of a son or daughter)",
    "isCharacter": false,
    "composition": [
      14914,
      "/",
      15912
    ]
  },
  {
    "id": "25806",
    "description": "sow",
    "pos": "YELLOW",
    "explanation": "(pig + female)",
    "isCharacter": false,
    "composition": [
      16175,
      "/",
      14166
    ]
  },
  {
    "id": "25807",
    "description": "speaker,lecturer",
    "pos": "BLUE",
    "explanation": "(person + to talk + limited time)",
    "isCharacter": false,
    "composition": [
      16161,
      "/",
      15666,
      "/",
      15212
    ]
  },
  {
    "id": "25808",
    "description": "speech_recognition",
    "pos": "YELLOW",
    "explanation": "(software,computer_program,application,app + talk + pen: software that recognizes and transcribes speech)",
    "isCharacter": false,
    "composition": [
      16194,
      "/",
      23476,
      "/",
      15666,
      "/",
      15991
    ]
  },
  {
    "id": "25809",
    "description": "spider_web,cobweb,orb_web",
    "pos": "YELLOW",
    "explanation": "(cloth,fabric,material,textile,net + spider)",
    "isCharacter": false,
    "composition": [
      13365,
      "/",
      17229
    ]
  },
  {
    "id": "25810",
    "description": "sports_centre",
    "pos": "YELLOW",
    "explanation": "(house + sport)",
    "isCharacter": false,
    "composition": [
      14905,
      "/",
      20518
    ]
  },
  {
    "id": "25811",
    "description": "stepdaughter",
    "pos": "BLUE",
    "explanation": "(daughter + step-parent)",
    "isCharacter": false,
    "composition": [
      13638,
      "/",
      25812
    ]
  },
  {
    "id": "25812",
    "description": "stepparent,step-parent",
    "pos": "BLUE",
    "explanation": "(spouse + parent)  - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "25813",
    "description": "stepson",
    "pos": "BLUE",
    "explanation": "(son + step-parent)",
    "isCharacter": false,
    "composition": [
      17209,
      "/",
      25812
    ]
  },
  {
    "id": "25814",
    "description": "strategy",
    "pos": "YELLOW",
    "explanation": "(plan + stairs: plan to reach a goal step by step)",
    "isCharacter": false,
    "composition": [
      16194,
      "/",
      17247
    ]
  },
  {
    "id": "25815",
    "description": "sugar_lump,cube_(sugar)",
    "pos": "YELLOW",
    "explanation": "(sugar [contraction] + block,brick + thing indicator)",
    "isCharacter": false,
    "composition": [
      12339,
      ";",
      9009,
      "/",
      17983,
      "/",
      12860
    ]
  },
  {
    "id": "25816",
    "description": "surrounded,encircled,surrounding",
    "pos": "GREEN",
    "explanation": "(around + description indicator)",
    "isCharacter": false,
    "composition": [
      12580,
      ";",
      8998
    ]
  },
  {
    "id": "25817",
    "description": "swim_centre",
    "pos": "YELLOW",
    "explanation": "(house + swimming)",
    "isCharacter": false,
    "composition": [
      14905,
      "/",
      17724,
      "/",
      18209
    ]
  },
  {
    "id": "25818",
    "description": "swimming_hall,indoor_swimming_pool",
    "pos": "YELLOW",
    "explanation": "(room + swimming)",
    "isCharacter": false,
    "composition": [
      16687,
      "/",
      17724,
      "/",
      18209
    ]
  },
  {
    "id": "25819",
    "description": "synthetic_speech,text-to-speech,tts",
    "pos": "YELLOW",
    "explanation": "(speech + digits_(computer)",
    "isCharacter": false,
    "composition": [
      12335,
      "/",
      15666,
      "/",
      23476
    ]
  },
  {
    "id": "25820",
    "description": "tablet_computer,tablet,tablet_PC_(1)",
    "pos": "YELLOW",
    "explanation": "(digital device + enclosure: the enclosure representing the touch screen)  SYMBOL SYNONYM",
    "isCharacter": false,
    "composition": [
      24638,
      "/",
      13934
    ]
  },
  {
    "id": "25821",
    "description": "taco,taco_shell",
    "pos": "YELLOW",
    "explanation": "(shell,crust + corn)",
    "isCharacter": false,
    "composition": [
      16954,
      "/",
      13413
    ]
  },
  {
    "id": "25822",
    "description": "tooth",
    "pos": "YELLOW",
    "explanation": "(pictograph)  - Character",
    "isCharacter": true
  },
  {
    "id": "25823",
    "description": "unemployed",
    "pos": "GREEN",
    "explanation": "(without + work)",
    "isCharacter": false,
    "composition": [
      15474,
      "/",
      18273,
      ";",
      8998
    ]
  },
  {
    "id": "25824",
    "description": "well,water_well",
    "pos": "YELLOW",
    "explanation": "(hole + water)",
    "isCharacter": false,
    "composition": [
      14883,
      "/",
      18209
    ]
  },
  {
    "id": "25825",
    "description": "voluntary",
    "pos": "GREEN",
    "explanation": "(volunteering + description indicator)",
    "isCharacter": false,
    "composition": [
      14704,
      ";",
      8998,
      "/",
      14396
    ]
  },
  {
    "id": "25826",
    "description": "voluntary_work,unpaid_work",
    "pos": "YELLOW",
    "explanation": "(work + without + money)",
    "isCharacter": false,
    "composition": [
      18273,
      "/",
      15474,
      "/",
      15484
    ]
  },
  {
    "id": "25827",
    "description": "volunteering",
    "pos": "YELLOW",
    "explanation": "(help + free)",
    "isCharacter": false,
    "composition": [
      14704,
      "/",
      14396
    ]
  },
  {
    "id": "25828",
    "description": "work_from_home-(to)",
    "pos": "RED",
    "explanation": "(working_from_home + action indicator)",
    "isCharacter": false,
    "composition": [
      18273,
      ";",
      8993,
      "/",
      15484,
      "/",
      14905
    ]
  },
  {
    "id": "25829",
    "description": "working_from_home",
    "pos": "YELLOW",
    "explanation": "(work + money + house)",
    "isCharacter": false,
    "composition": [
      18273,
      "/",
      15484,
      "/",
      14905
    ]
  },
  {
    "id": "25830",
    "description": "yeast",
    "pos": "YELLOW",
    "explanation": "(micro-organism + roll,bun + up)",
    "isCharacter": false,
    "composition": [
      24443,
      ";",
      9009,
      "/",
      24917,
      "/",
      16683,
      "/",
      17983
    ]
  },
  {
    "id": "25831",
    "description": "possible",
    "pos": "GREEN",
    "explanation": "(possibility + description indicator)",
    "isCharacter": false,
    "composition": [
      24443,
      ";",
      8998,
      "/",
      18229
    ]
  },
  {
    "id": "25832",
    "description": "question,be_sceptical,doubt-(to)",
    "pos": "RED",
    "explanation": "(scepticism + action indicator)",
    "isCharacter": false,
    "composition": [
      22911,
      ";",
      8993,
      "/",
      15925
    ]
  },
  {
    "id": "25840",
    "description": "age",
    "pos": "YELLOW",
    "explanation": "(number + year)",
    "isCharacter": false,
    "composition": [
      15742,
      "/",
      18289
    ]
  },
  {
    "id": "25841",
    "description": "asteroid",
    "pos": "YELLOW",
    "explanation": "(similar + dwarf planet)",
    "isCharacter": false,
    "composition": [
      25586,
      "/",
      16713,
      "/",
      22834,
      "/",
      24917
    ]
  },
  {
    "id": "25842",
    "description": "balance,sense_of_balance",
    "pos": "YELLOW",
    "explanation": "(information + position + body: information to the brain about body position)",
    "isCharacter": false,
    "composition": [
      23542,
      "/",
      16224,
      "/",
      12870
    ]
  },
  {
    "id": "25843",
    "description": "balance_(general),poise",
    "pos": "YELLOW",
    "explanation": "(activity + without + fall,drop,spill,tumble)",
    "isCharacter": false,
    "composition": [
      12335,
      "/",
      15474,
      "/",
      13869,
      "/",
      14947
    ]
  },
  {
    "id": "25844",
    "description": "balance_(general),poise-(to)",
    "pos": "RED",
    "explanation": "(balance_(general),poise + action indicator)",
    "isCharacter": false,
    "composition": [
      12335,
      ";",
      8993,
      "/",
      15474,
      "/",
      13869,
      "/",
      14947
    ]
  },
  {
    "id": "25845",
    "description": "balance_(walking,standing)-(to)",
    "pos": "YELLOW",
    "explanation": "(walk,go-(to) + without + fall,drop,spill,tumble + action indicator: walking without falling, change classifier to “sit”, when more appropriate)",
    "isCharacter": false,
    "composition": [
      15189,
      ";",
      8993,
      "/",
      15474,
      "/",
      13869,
      "/",
      14947
    ]
  },
  {
    "id": "25846",
    "description": "barrow,grave_mound",
    "pos": "YELLOW",
    "explanation": "(collection + stone + grave)",
    "isCharacter": false,
    "composition": [
      14647,
      "/",
      23409,
      "/",
      17267,
      "/",
      14638
    ]
  },
  {
    "id": "25847",
    "description": "bathing_rule(s)",
    "pos": "YELLOW",
    "explanation": "(rule,regulation + pool)",
    "isCharacter": false,
    "composition": [
      15962,
      "/",
      22913,
      "/",
      16219
    ]
  },
  {
    "id": "25848",
    "description": "bike_lamp",
    "pos": "YELLOW",
    "explanation": "(lamp [contraction] + bike + thing indicator)",
    "isCharacter": false,
    "composition": [
      15208,
      ";",
      9009,
      "/",
      8498,
      "/",
      18232
    ]
  },
  {
    "id": "25849",
    "description": "birch",
    "pos": "YELLOW",
    "explanation": "(tree + white + north: tree with white trunk, birch is typical in the north)",
    "isCharacter": false,
    "composition": [
      17775,
      "/",
      13377,
      "/",
      17192,
      "/",
      15730
    ]
  },
  {
    "id": "25850",
    "description": "birdfeeder,bird_table",
    "pos": "YELLOW",
    "explanation": "(place + food + comma + bird: place to feed [contraction] birds)",
    "isCharacter": false,
    "composition": [
      16193,
      "/",
      14377,
      "/",
      8487,
      "/",
      12837
    ]
  },
  {
    "id": "25851",
    "description": "cardboard,paperboard",
    "pos": "YELLOW",
    "explanation": "(paper + thick)",
    "isCharacter": false,
    "composition": [
      15962,
      "/",
      25560
    ]
  },
  {
    "id": "25852",
    "description": "chess",
    "pos": "WHITE",
    "explanation": "(game + crown: crown representing king [contraction], the king is the target of the game)",
    "isCharacter": false,
    "composition": [
      16451,
      "/",
      14164,
      "/",
      17983,
      "/",
      22618
    ]
  },
  {
    "id": "25853",
    "description": "chewing-gum",
    "pos": "YELLOW",
    "explanation": "(candy + teeth: candy to chew)",
    "isCharacter": false,
    "composition": [
      22375,
      "/",
      17517
    ]
  },
  {
    "id": "25854",
    "description": "collar",
    "pos": "YELLOW",
    "explanation": "(part of + clothes + neck [body])",
    "isCharacter": false,
    "composition": [
      15972,
      "/",
      13366,
      "/",
      15700
    ]
  },
  {
    "id": "25855",
    "description": "cornea",
    "pos": "YELLOW",
    "explanation": "(protection + eye: the cornea covers the eye)",
    "isCharacter": false,
    "composition": [
      16420,
      "/",
      14133
    ]
  },
  {
    "id": "25856",
    "description": "covered,hidden",
    "pos": "GREEN",
    "explanation": "(make + invisible + description indicator: made invisible)",
    "isCharacter": false,
    "composition": [
      23583,
      ";",
      8998,
      "/",
      15474,
      "/",
      14133
    ]
  },
  {
    "id": "25857",
    "description": "dairy",
    "pos": "YELLOW",
    "explanation": "(factory + milk)",
    "isCharacter": false,
    "composition": [
      14905,
      "/",
      23583,
      "/",
      13881,
      "/",
      15206
    ]
  },
  {
    "id": "25858",
    "description": "darkness",
    "pos": "YELLOW",
    "explanation": "(minus + light)",
    "isCharacter": false,
    "composition": [
      15474,
      "/",
      15208
    ]
  },
  {
    "id": "25859",
    "description": "den,lair",
    "pos": "YELLOW",
    "explanation": "(hole + animal: the hole is the entrance to a hidden place)",
    "isCharacter": false,
    "composition": [
      14883,
      "/",
      12378
    ]
  },
  {
    "id": "25860",
    "description": "dense,thick,compact,tight,jammed",
    "pos": "GREEN",
    "explanation": "(density + description indicator)",
    "isCharacter": false,
    "composition": [
      14647,
      "/",
      17717,
      ";",
      8998,
      "/",
      25586
    ]
  },
  {
    "id": "25861",
    "description": "density,denseness,compactness,tightness_(general)",
    "pos": "YELLOW",
    "explanation": "(many + thing + closeness)",
    "isCharacter": false,
    "composition": [
      14647,
      "/",
      17717,
      "/",
      25586
    ]
  },
  {
    "id": "25862",
    "description": "density,denseness,concentration_(measurement)",
    "pos": "YELLOW",
    "explanation": "(measurement + thing + closeness: the spatial property of being crowded together)",
    "isCharacter": false,
    "composition": [
      15443,
      "/",
      17717,
      "/",
      25586
    ]
  },
  {
    "id": "25863",
    "description": "disagree,discord,disaccord-(to)",
    "pos": "RED",
    "explanation": "(disagreement + action indicator)",
    "isCharacter": false,
    "composition": [
      15474,
      "/",
      14164,
      ";",
      8993,
      "/",
      12354
    ]
  },
  {
    "id": "25864",
    "description": "disagreement,discord",
    "pos": "YELLOW",
    "explanation": "(without + feeling + agreement)",
    "isCharacter": false,
    "composition": [
      15474,
      "/",
      14164,
      "/",
      12354
    ]
  },
  {
    "id": "25865",
    "description": "discordant",
    "pos": "GREEN",
    "explanation": "(disagreement + description indicator)",
    "isCharacter": false,
    "composition": [
      15474,
      "/",
      14164,
      ";",
      8998,
      "/",
      12354
    ]
  },
  {
    "id": "25866",
    "description": "diver_(active_under_water)",
    "pos": "BLUE",
    "explanation": "(person + diving (activity))",
    "isCharacter": false,
    "composition": [
      16161,
      "/",
      12335,
      "/",
      17969,
      "/",
      25777
    ]
  },
  {
    "id": "25867",
    "description": "diver_(jump)",
    "pos": "BLUE",
    "explanation": "(person + diving (sport))",
    "isCharacter": false,
    "composition": [
      16161,
      "/",
      20518,
      "/",
      23550,
      "/",
      25777
    ]
  },
  {
    "id": "25868",
    "description": "diving,activity_under_water",
    "pos": "YELLOW",
    "explanation": "(activity + under + water)",
    "isCharacter": false,
    "composition": [
      12335,
      "/",
      17969,
      "/",
      25777
    ]
  },
  {
    "id": "25869",
    "description": "diving_equipment,diving_gear",
    "pos": "WHITE",
    "explanation": "(group_of + thing + diving: combination of equipment,gear + diving,activity_under_water)",
    "isCharacter": false,
    "composition": [
      14647,
      "/",
      17717,
      "/",
      12335,
      "/",
      17969,
      "/",
      25777
    ]
  },
  {
    "id": "25870",
    "description": "doorway,gate",
    "pos": "YELLOW",
    "explanation": "(door + fence)",
    "isCharacter": false,
    "composition": [
      13866,
      "/",
      14167
    ]
  },
  {
    "id": "25871",
    "description": "dove",
    "pos": "YELLOW",
    "explanation": "(bird + peace)",
    "isCharacter": false,
    "composition": [
      12837,
      "/",
      15981
    ]
  },
  {
    "id": "25872",
    "description": "dust_storm,duster,sirocco",
    "pos": "YELLOW",
    "explanation": "(storm + dust)",
    "isCharacter": false,
    "composition": [
      14647,
      "/",
      14647,
      "/",
      18255,
      "/",
      16233
    ]
  },
  {
    "id": "25873",
    "description": "ear,spike,capitulum",
    "pos": "YELLOW",
    "explanation": "(many + seed + grain)",
    "isCharacter": false,
    "composition": [
      14647,
      "/",
      16749,
      "/",
      14625
    ]
  },
  {
    "id": "25874",
    "description": "eastward",
    "pos": "GREEN",
    "explanation": "(forward + east + description indicator: forward representing (direction [contraction])",
    "isCharacter": false,
    "composition": [
      14390,
      ";",
      8998,
      "/",
      13902
    ]
  },
  {
    "id": "25875",
    "description": "equipment,gear",
    "pos": "YELLOW",
    "explanation": "(group_of + thing + activity: a group of things for a certain activity)",
    "isCharacter": false,
    "composition": [
      14647,
      "/",
      17717,
      "/",
      12335
    ]
  },
  {
    "id": "25876",
    "description": "fable,allegory,parable",
    "pos": "YELLOW",
    "explanation": "(story, tale + imaginary + meaning: an imaginary story with a specific meaning)",
    "isCharacter": false,
    "composition": [
      15962,
      "/",
      15666,
      "/",
      24895,
      "/",
      15441
    ]
  },
  {
    "id": "25877",
    "description": "fairy_tale",
    "pos": "YELLOW",
    "explanation": "(story, tale + imaginary person)",
    "isCharacter": false,
    "composition": [
      15962,
      "/",
      15666,
      "/",
      23577
    ]
  },
  {
    "id": "25878",
    "description": "fiber,fibre,fibril,filament,strand",
    "pos": "YELLOW",
    "explanation": "(pictograph, of a fiber)  - Character",
    "isCharacter": true
  },
  {
    "id": "25879",
    "description": "folk_tale,legend",
    "pos": "YELLOW",
    "explanation": "(story, tale + past + imaginary person: story from the past about imaginary persons)",
    "isCharacter": false,
    "composition": [
      15962,
      "/",
      15666,
      "/",
      15975,
      "/",
      23577
    ]
  },
  {
    "id": "25880",
    "description": "football_rule(s)",
    "pos": "YELLOW",
    "explanation": "(rule,regulation + football [contraction])",
    "isCharacter": false,
    "composition": [
      15962,
      "/",
      22913,
      "/",
      12621,
      "/",
      15189
    ]
  },
  {
    "id": "25881",
    "description": "four-leaf_clover",
    "pos": "YELLOW",
    "explanation": "(shamrock + 4 + leaf: shamrock representing clover)",
    "isCharacter": false,
    "composition": [
      16939,
      "/",
      8500,
      "/",
      15183
    ]
  },
  {
    "id": "25882",
    "description": "free_of_charge,gratis,for_free",
    "pos": "GREEN",
    "explanation": "(without + cost + description indicator)",
    "isCharacter": false,
    "composition": [
      15474,
      "/",
      15484,
      ";",
      8998,
      "/",
      14381,
      "/",
      17717
    ]
  },
  {
    "id": "25883",
    "description": "game_rule(s)",
    "pos": "YELLOW",
    "explanation": "(rule,regulation + game [contraction])",
    "isCharacter": false,
    "composition": [
      15962,
      "/",
      22913,
      "/",
      14164,
      "/",
      17983
    ]
  },
  {
    "id": "25884",
    "description": "give_birth-(to)",
    "pos": "RED",
    "explanation": "(birth_(reproduction) + action indicator)",
    "isCharacter": false,
    "composition": [
      12842,
      ";",
      8993
    ]
  },
  {
    "id": "25885",
    "description": "globe_(map)",
    "pos": "YELLOW",
    "explanation": "(earth,globe,world + man-made)",
    "isCharacter": false,
    "composition": [
      13900,
      "/",
      23583
    ]
  },
  {
    "id": "25886",
    "description": "grave_field",
    "pos": "YELLOW",
    "explanation": "(place + grave + past)",
    "isCharacter": false,
    "composition": [
      16193,
      "/",
      14638,
      "/",
      15975
    ]
  },
  {
    "id": "25887",
    "description": "habitation,dwelling_place,site",
    "pos": "YELLOW",
    "explanation": "(place + live)",
    "isCharacter": false,
    "composition": [
      16193,
      "/",
      14905
    ]
  },
  {
    "id": "25888",
    "description": "head_lamp",
    "pos": "YELLOW",
    "explanation": "(lamp [contraction] + head + thing indicator)",
    "isCharacter": false,
    "composition": [
      15208,
      ";",
      9009,
      "/",
      14689
    ]
  },
  {
    "id": "25889",
    "description": "heap_of_sand",
    "pos": "YELLOW",
    "explanation": "(collection + sand)",
    "isCharacter": false,
    "composition": [
      14647,
      "/",
      23409,
      "/",
      16233,
      "/",
      17267
    ]
  },
  {
    "id": "25890",
    "description": "hearing,audition,auditory_sense",
    "pos": "YELLOW",
    "explanation": "(information + ear: information to the brain from the ears)",
    "isCharacter": false,
    "composition": [
      23542,
      "/",
      13894
    ]
  },
  {
    "id": "25891",
    "description": "homeward",
    "pos": "GREEN",
    "explanation": "(forward + home + description indicator: forward representing direction [contraction])",
    "isCharacter": false,
    "composition": [
      14390,
      ";",
      8998,
      "/",
      14905,
      "/",
      14164
    ]
  },
  {
    "id": "25892",
    "description": "ice_coated,ice_covered",
    "pos": "GREEN",
    "explanation": "(ice covering + description indicator)",
    "isCharacter": false,
    "composition": [
      14919,
      ";",
      8998,
      "/",
      16954
    ]
  },
  {
    "id": "25893",
    "description": "ice_covering,ice_crust,ice_coating",
    "pos": "YELLOW",
    "explanation": "(ice + shell: ice like a crust which can cover any side of a thing)",
    "isCharacter": false,
    "composition": [
      14919,
      "/",
      16954
    ]
  },
  {
    "id": "25894",
    "description": "into_(backward)",
    "pos": "WHITE",
    "explanation": "(backward + enclosure: the arrow going backward into an enclosure)  - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "25895",
    "description": "into_(downward)",
    "pos": "WHITE",
    "explanation": "(downward [modification, higher position] + enclosure: the arrow going downward into an enclosure)  - Character (superimposed - modified)",
    "isCharacter": true
  },
  {
    "id": "25896",
    "description": "into_(upward)",
    "pos": "WHITE",
    "explanation": "(upward [modification, lower position] + enclosure: the arrow going upward into an enclosure)  - Character (superimposed - modified)",
    "isCharacter": true
  },
  {
    "id": "25897",
    "description": "iris_(eye)",
    "pos": "YELLOW",
    "explanation": "(protection + eye + light: muscular diaphragm which thus protects the eye from too much or too little light)",
    "isCharacter": false,
    "composition": [
      16420,
      "/",
      14133,
      "/",
      15208
    ]
  },
  {
    "id": "25898",
    "description": "labyrinth,maze",
    "pos": "YELLOW",
    "explanation": "(place + difficult + out_of,exit_(forward))",
    "isCharacter": false,
    "composition": [
      16193,
      "/",
      24884,
      "/",
      15943
    ]
  },
  {
    "id": "25899",
    "description": "lamb-(to)",
    "pos": "RED",
    "explanation": "(birth + sheep + action indicator)",
    "isCharacter": false,
    "composition": [
      12842,
      ";",
      8993,
      "/",
      12379,
      "/",
      13365
    ]
  },
  {
    "id": "25900",
    "description": "Sami(s)",
    "pos": "YELLOW",
    "explanation": "(ethnic group + north + deer,cervine_(animal),cervid: deer representing reindeer [contraction])",
    "isCharacter": false,
    "composition": [
      14647,
      "/",
      16161,
      "/",
      21607,
      "/",
      15730,
      "/",
      12381
    ]
  },
  {
    "id": "25901",
    "description": "Latvia",
    "pos": "YELLOW",
    "explanation": "(country + L + A + T)",
    "isCharacter": false,
    "composition": [
      13423,
      "/",
      "XL",
      "/",
      "XA",
      "/",
      "XT"
    ]
  },
  {
    "id": "25902",
    "description": "Latvian_(class)",
    "pos": "YELLOW",
    "explanation": "(class [contraction] + Latvian)",
    "isCharacter": false,
    "composition": [
      15162,
      "/",
      15172,
      "/",
      13423,
      "/",
      "XL",
      "/",
      "XA",
      "/",
      "XT"
    ]
  },
  {
    "id": "25903",
    "description": "Latvian_(language)",
    "pos": "YELLOW",
    "explanation": "(language + Latvia)",
    "isCharacter": false,
    "composition": [
      15172,
      "/",
      13423,
      "/",
      "XL",
      "/",
      "XA",
      "/",
      "XT"
    ]
  },
  {
    "id": "25904",
    "description": "leaf,flap",
    "pos": "YELLOW",
    "explanation": "(thing + fold,folding,pleating)",
    "isCharacter": false,
    "composition": [
      17717,
      "/",
      25564
    ]
  },
  {
    "id": "25905",
    "description": "lick-(to)",
    "pos": "RED",
    "explanation": "(tongue + action indicator)",
    "isCharacter": false,
    "composition": [
      15972,
      "/",
      15666,
      ";",
      8993,
      "/",
      20524
    ]
  },
  {
    "id": "25906",
    "description": "lock",
    "pos": "YELLOW",
    "explanation": "(thing + key)",
    "isCharacter": false,
    "composition": [
      17717,
      "/",
      15144
    ]
  },
  {
    "id": "25907",
    "description": "lower_leg,shank,shin",
    "pos": "YELLOW",
    "explanation": "(leg + under)",
    "isCharacter": false,
    "composition": [
      15188,
      "/",
      17969
    ]
  },
  {
    "id": "25908",
    "description": "magic",
    "pos": "YELLOW",
    "explanation": "(cause + mystery)",
    "isCharacter": false,
    "composition": [
      13134,
      "/",
      21297
    ]
  },
  {
    "id": "25909",
    "description": "magical",
    "pos": "GREEN",
    "explanation": "(magic + description indicator)",
    "isCharacter": false,
    "composition": [
      13134,
      ";",
      8998,
      "/",
      21297
    ]
  },
  {
    "id": "25910",
    "description": "manhole_cover",
    "pos": "YELLOW",
    "explanation": "(lid + opening + ground)",
    "isCharacter": false,
    "composition": [
      22583,
      "/",
      15923,
      "/",
      13901
    ]
  },
  {
    "id": "25911",
    "description": "midnight_sun",
    "pos": "YELLOW",
    "explanation": "(sun + night)",
    "isCharacter": false,
    "composition": [
      17462,
      "/",
      15719
    ]
  },
  {
    "id": "25912",
    "description": "milkmaid,dairymaid",
    "pos": "BLUE",
    "explanation": "(woman + mountain pasture)",
    "isCharacter": false,
    "composition": [
      18269,
      "/",
      14905,
      "/",
      15663,
      "/",
      12378
    ]
  },
  {
    "id": "25913",
    "description": "millipede,millepede",
    "pos": "YELLOW",
    "explanation": "(insect + group_of,much_of,many_of,quantity_of + legs and feet)",
    "isCharacter": false,
    "composition": [
      14943,
      "/",
      14647,
      "/",
      15189
    ]
  },
  {
    "id": "25914",
    "description": "mother's_milk",
    "pos": "YELLOW",
    "explanation": "(milk + mother)",
    "isCharacter": false,
    "composition": [
      13881,
      "/",
      15206,
      "/",
      15662
    ]
  },
  {
    "id": "25915",
    "description": "mountain_pasture",
    "pos": "YELLOW",
    "explanation": "(house + mountain + animal)",
    "isCharacter": false,
    "composition": [
      14905,
      "/",
      15663,
      "/",
      12378
    ]
  },
  {
    "id": "25916",
    "description": "mouth_(wide-open),open_mouth,gape",
    "pos": "YELLOW",
    "explanation": "(mouth + open)",
    "isCharacter": false,
    "composition": [
      15666,
      "/",
      15923
    ]
  },
  {
    "id": "25917",
    "description": "myth",
    "pos": "YELLOW",
    "explanation": "(story, tale + imaginary + event: imaginary tale of an event)",
    "isCharacter": false,
    "composition": [
      15962,
      "/",
      15666,
      "/",
      24895,
      "/",
      14114
    ]
  },
  {
    "id": "25918",
    "description": "northward",
    "pos": "GREEN",
    "explanation": "(forward + north + description indicator: forward representing direction [contraction])",
    "isCharacter": false,
    "composition": [
      14390,
      ";",
      8998,
      "/",
      15730
    ]
  },
  {
    "id": "25919",
    "description": "open_one's_mouth,hold_one's_mouth_open,gape-(to)",
    "pos": "RED",
    "explanation": "(mouth (wide-open), open mouth, gape + action indicator)",
    "isCharacter": false,
    "composition": [
      15666,
      ";",
      8993,
      "/",
      15923
    ]
  },
  {
    "id": "25920",
    "description": "others_(persons)",
    "pos": "BLUE",
    "explanation": "(other + plural indicator)",
    "isCharacter": false,
    "composition": [
      15214,
      ";",
      9011,
      "/",
      8498
    ]
  },
  {
    "id": "25921",
    "description": "overturn,turn_over,tip_over-(to)",
    "pos": "RED",
    "explanation": "(turn + fall,drop,spill,tumble + action indicator)",
    "isCharacter": false,
    "composition": [
      25627,
      ";",
      8993,
      "/",
      13869,
      "/",
      14947
    ]
  },
  {
    "id": "25922",
    "description": "paper_clip",
    "pos": "YELLOW",
    "explanation": "(thing + paper + together)",
    "isCharacter": false,
    "composition": [
      17717,
      "/",
      15962,
      "/",
      23409
    ]
  },
  {
    "id": "25923",
    "description": "people_in_the_north_(Lapps,Eskimos)",
    "pos": "YELLOW",
    "explanation": "(ethnic group + north)",
    "isCharacter": false,
    "composition": [
      14647,
      "/",
      16161,
      "/",
      21607,
      "/",
      15730
    ]
  },
  {
    "id": "25924",
    "description": "place_to_feed,feeding_place,feeding_ground",
    "pos": "YELLOW",
    "explanation": "(place + give + food: feeding place in general)",
    "isCharacter": false,
    "composition": [
      16193,
      "/",
      24903,
      "/",
      14377
    ]
  },
  {
    "id": "25925",
    "description": "plant_(edible)",
    "pos": "YELLOW",
    "explanation": "(plant + food)",
    "isCharacter": false,
    "composition": [
      16196,
      "/",
      14377
    ]
  },
  {
    "id": "25926",
    "description": "polar_bear",
    "pos": "YELLOW",
    "explanation": "(bear + ice)",
    "isCharacter": false,
    "composition": [
      12378,
      "/",
      24801,
      "/",
      14919
    ]
  },
  {
    "id": "25927",
    "description": "polar_night",
    "pos": "YELLOW",
    "explanation": "(night + north)",
    "isCharacter": false,
    "composition": [
      15719,
      "/",
      15730
    ]
  },
  {
    "id": "25928",
    "description": "pupil_(eye)",
    "pos": "YELLOW",
    "explanation": "(opening + eye)",
    "isCharacter": false,
    "composition": [
      15923,
      "/",
      14133
    ]
  },
  {
    "id": "25929",
    "description": "raindrop",
    "pos": "YELLOW",
    "explanation": "(dot + rain: combination of drop and rain)",
    "isCharacter": false,
    "composition": [
      13867,
      "/",
      16455
    ]
  },
  {
    "id": "25930",
    "description": "raise_one's_hand,put_up_one's_hand-(to)",
    "pos": "RED",
    "explanation": "(show of hands + action indicator)",
    "isCharacter": false,
    "composition": [
      14667,
      ";",
      8993,
      "/",
      17983
    ]
  },
  {
    "id": "25931",
    "description": "reed,bamboo_(tall_grass)",
    "pos": "WHITE",
    "explanation": "(grass + big)",
    "isCharacter": false,
    "composition": [
      14636,
      "/",
      24875
    ]
  },
  {
    "id": "25932",
    "description": "rock_(geology)",
    "pos": "YELLOW",
    "explanation": "(type,kind,sort,category  + stone)",
    "isCharacter": false,
    "composition": [
      17961,
      "/",
      17267
    ]
  },
  {
    "id": "25933",
    "description": "rope,hawser",
    "pos": "YELLOW",
    "explanation": "(group of + group of + fiber)",
    "isCharacter": false,
    "composition": [
      14647,
      "/",
      14647,
      "/",
      25878
    ]
  },
  {
    "id": "25934",
    "description": "sandstorm",
    "pos": "YELLOW",
    "explanation": "(storm + sand)",
    "isCharacter": false,
    "composition": [
      14647,
      "/",
      14647,
      "/",
      18255,
      "/",
      16233,
      "/",
      17267
    ]
  },
  {
    "id": "25935",
    "description": "school_way",
    "pos": "YELLOW",
    "explanation": "(way + school)",
    "isCharacter": false,
    "composition": [
      16193,
      "/",
      14390,
      "/",
      14905,
      "/",
      15162
    ]
  },
  {
    "id": "25936",
    "description": "season_of_darkness",
    "pos": "YELLOW",
    "explanation": "(season + darkness)",
    "isCharacter": false,
    "composition": [
      15972,
      "/",
      18289,
      "/",
      15474,
      "/",
      15208
    ]
  },
  {
    "id": "25937",
    "description": "sense",
    "pos": "YELLOW",
    "explanation": "(generalization + vision + hearing [contraction]: information to the brain, generalization for all senses)",
    "isCharacter": false,
    "composition": [
      14430,
      "/",
      23542,
      "/",
      14133,
      "/",
      13894
    ]
  },
  {
    "id": "25938",
    "description": "show_of_hands",
    "pos": "YELLOW",
    "explanation": "(hand + up)",
    "isCharacter": false,
    "composition": [
      14667,
      "/",
      17983
    ]
  },
  {
    "id": "25939",
    "description": "sight,vision,visual_sense",
    "pos": "YELLOW",
    "explanation": "(information + eye: information to the brain from the eyes)",
    "isCharacter": false,
    "composition": [
      23542,
      "/",
      14133
    ]
  },
  {
    "id": "25940",
    "description": "smell,sense_of_smell,olfaction",
    "pos": "YELLOW",
    "explanation": "(information + nose: information to the brain from the nose)",
    "isCharacter": false,
    "composition": [
      23542,
      "/",
      15732
    ]
  },
  {
    "id": "25941",
    "description": "snake_(dangerous),viper,boa_(etc)",
    "pos": "YELLOW",
    "explanation": "(snake + danger)",
    "isCharacter": false,
    "composition": [
      17189,
      "/",
      13632
    ]
  },
  {
    "id": "25942",
    "description": "snake_(not_dangerous),grass_snake_(etc)",
    "pos": "YELLOW",
    "explanation": "(snake + minus + danger)",
    "isCharacter": false,
    "composition": [
      17189,
      "/",
      15474,
      "/",
      13632
    ]
  },
  {
    "id": "25943",
    "description": "sole_(of_shoe)",
    "pos": "YELLOW",
    "explanation": "(bottom + shoe)",
    "isCharacter": false,
    "composition": [
      25408,
      "/",
      16420,
      "/",
      14379
    ]
  },
  {
    "id": "25944",
    "description": "southward",
    "pos": "GREEN",
    "explanation": "(forward + south + description indicator: forward representing direction [contraction])",
    "isCharacter": false,
    "composition": [
      14390,
      ";",
      8998,
      "/",
      17219
    ]
  },
  {
    "id": "25945",
    "description": "spill,slop-(to)",
    "pos": "RED",
    "explanation": "(cause + dirt + action indicator)",
    "isCharacter": false,
    "composition": [
      13134,
      ";",
      8993,
      "/",
      14647,
      "/",
      14133,
      "/",
      13867
    ]
  },
  {
    "id": "25946",
    "description": "sprout,germinate-(to)",
    "pos": "RED",
    "explanation": "(start + growth,growing + action indicator)",
    "isCharacter": false,
    "composition": [
      12658,
      ";",
      8993,
      "/",
      14205,
      "/",
      17983
    ]
  },
  {
    "id": "25947",
    "description": "story_(historical),historic_story",
    "pos": "YELLOW",
    "explanation": "(story, tale + past)",
    "isCharacter": false,
    "composition": [
      15962,
      "/",
      15666,
      "/",
      15975
    ]
  },
  {
    "id": "25948",
    "description": "summer_day",
    "pos": "YELLOW",
    "explanation": "(day + summer: only numbers are used, as seasons are different in different parts of the world)",
    "isCharacter": false,
    "composition": [
      13639,
      "/",
      17462,
      "/",
      8498
    ]
  },
  {
    "id": "25949",
    "description": "summer_house,summerhouse",
    "pos": "YELLOW",
    "explanation": "(house + summer: only numbers are used, as seasons are different in different parts of the world)",
    "isCharacter": false,
    "composition": [
      14905,
      "/",
      17462,
      "/",
      8498
    ]
  },
  {
    "id": "25950",
    "description": "swimming_rule(s)",
    "pos": "YELLOW",
    "explanation": "(rule,regulation + swimming)",
    "isCharacter": false,
    "composition": [
      15962,
      "/",
      22913,
      "/",
      17724,
      "/",
      18209
    ]
  },
  {
    "id": "25951",
    "description": "tanker_truck,tank_lorry",
    "pos": "YELLOW",
    "explanation": "(truck, lorry + water,fluid,liquid)",
    "isCharacter": false,
    "composition": [
      17781,
      "/",
      18209
    ]
  },
  {
    "id": "25952",
    "description": "taste,gustation,sense_of_taste",
    "pos": "YELLOW",
    "explanation": "(information + taste; information to the brain from the nose and the mouth)",
    "isCharacter": false,
    "composition": [
      23542,
      "/",
      17506
    ]
  },
  {
    "id": "25953",
    "description": "tear,teardrop",
    "pos": "YELLOW",
    "explanation": "(drop + eye)",
    "isCharacter": false,
    "composition": [
      13867,
      "/",
      18209,
      "/",
      14133
    ]
  },
  {
    "id": "25954",
    "description": "tear_along,advance_fast,go_fast-(to)",
    "pos": "RED",
    "explanation": "(quickness,rapidity,speediness + action indicator: moving fast forward)",
    "isCharacter": false,
    "composition": [
      14390,
      ";",
      8993,
      "/",
      14947
    ]
  },
  {
    "id": "25955",
    "description": "thigh,upper_leg",
    "pos": "YELLOW",
    "explanation": "(leg + over)",
    "isCharacter": false,
    "composition": [
      15188,
      "/",
      15948
    ]
  },
  {
    "id": "25956",
    "description": "thread,string,cord",
    "pos": "YELLOW",
    "explanation": "(group_of,much_of,many_of,quantity_of + fiber,fibre,fibril,filament,strand)",
    "isCharacter": false,
    "composition": [
      14647,
      "/",
      25878
    ]
  },
  {
    "id": "25957",
    "description": "touch,sense_of_touch,tactile_sense",
    "pos": "YELLOW",
    "explanation": "(information + skin: information to the brain from the skin)",
    "isCharacter": false,
    "composition": [
      23542,
      "/",
      16420,
      "/",
      12870
    ]
  },
  {
    "id": "25958",
    "description": "traffic_rule(s)",
    "pos": "YELLOW",
    "explanation": "(rule,regulation + traffic)",
    "isCharacter": false,
    "composition": [
      15962,
      "/",
      22913,
      "/",
      14647,
      "/",
      13121
    ]
  },
  {
    "id": "25959",
    "description": "trapeze",
    "pos": "YELLOW",
    "explanation": "(swing + acrobatics [contraction])",
    "isCharacter": false,
    "composition": [
      25406,
      ";",
      9009,
      "/",
      20517,
      "/",
      16194,
      "/",
      14133
    ]
  },
  {
    "id": "25960",
    "description": "T-shirt,tee_shirt,jersey",
    "pos": "YELLOW",
    "explanation": "(clothing + chest + T)",
    "isCharacter": false,
    "composition": [
      13366,
      "/",
      13161,
      "/",
      16181
    ]
  },
  {
    "id": "25961",
    "description": "tuft_of_grass,tussock",
    "pos": "YELLOW",
    "explanation": "(collection,pile,tussock_(etc) + grass)",
    "isCharacter": false,
    "composition": [
      14647,
      "/",
      23409,
      "/",
      14636
    ]
  },
  {
    "id": "25962",
    "description": "watchdog",
    "pos": "YELLOW",
    "explanation": "(dog + watch)",
    "isCharacter": false,
    "composition": [
      12380,
      "/",
      24949,
      "/",
      14947
    ]
  },
  {
    "id": "25963",
    "description": "way",
    "pos": "YELLOW",
    "explanation": "(place + forward: a place on the ground leading forward)",
    "isCharacter": false,
    "composition": [
      16193,
      "/",
      14390
    ]
  },
  {
    "id": "25964",
    "description": "very_much,very_many",
    "pos": "GREEN",
    "explanation": "(very + very + description indicator)",
    "isCharacter": false,
    "composition": [
      14647,
      ";",
      8998,
      "/",
      14647
    ]
  },
  {
    "id": "25965",
    "description": "westward",
    "pos": "GREEN",
    "explanation": "(forward + west + description indicator: forward representing direction [contraction])",
    "isCharacter": false,
    "composition": [
      14390,
      ";",
      8998,
      "/",
      18224
    ]
  },
  {
    "id": "25966",
    "description": "wheelchair_tricycle",
    "pos": "YELLOW",
    "explanation": "(tricycle + wheelchair)",
    "isCharacter": false,
    "composition": [
      8499,
      "/",
      18232,
      "/",
      18233
    ]
  },
  {
    "id": "25967",
    "description": "winter_day",
    "pos": "YELLOW",
    "explanation": "(day + winter: only numbers are used, as seasons are different in different parts of the world)",
    "isCharacter": false,
    "composition": [
      13639,
      "/",
      17462,
      "/",
      8500
    ]
  },
  {
    "id": "25968",
    "description": "winter_house",
    "pos": "YELLOW",
    "explanation": "(house + winter: only numbers are used, as seasons are different in different parts of the world)",
    "isCharacter": false,
    "composition": [
      14905,
      "/",
      17462,
      "/",
      8500
    ]
  },
  {
    "id": "25969",
    "description": "woodpecker",
    "pos": "YELLOW",
    "explanation": "(bird + chop-(to))",
    "isCharacter": false,
    "composition": [
      12837,
      "/",
      15159,
      "/",
      14947
    ]
  },
  {
    "id": "25970",
    "description": "work_method",
    "pos": "YELLOW",
    "explanation": "(plan,design,method,system + work)",
    "isCharacter": false,
    "composition": [
      16194,
      "/",
      18273
    ]
  },
  {
    "id": "25971",
    "description": "zigzag",
    "pos": "GREEN",
    "explanation": "(zigzag line + description indicator)",
    "isCharacter": false,
    "composition": [
      25972,
      ";",
      8998
    ]
  },
  {
    "id": "25972",
    "description": "zigzag_line",
    "pos": "WHITE",
    "explanation": "(pictograph)  - Character",
    "isCharacter": true
  },
  {
    "id": "25980",
    "description": "band_(of_frequencies)",
    "pos": "YELLOW",
    "explanation": "(signal + limit(s),limitation,restriction: signal or frequencies in a certain range)  Preferred NEW SYNONYM, replacing 24606",
    "isCharacter": false,
    "composition": [
      24750,
      "/",
      25579
    ]
  },
  {
    "id": "25981",
    "description": "beach_tennis_(activity)",
    "pos": "YELLOW",
    "explanation": "(tennis (activity) + beach)  Preferred NEW SYNONYM, replacing 12641",
    "isCharacter": false,
    "composition": [
      12335,
      "/",
      16452,
      "/",
      12640
    ]
  },
  {
    "id": "25982",
    "description": "beach_tennis_(sport)",
    "pos": "YELLOW",
    "explanation": "(tennis,racket_sport,racquet_sport + beach)  Preferred NEW SYNONYM, replacing 20604",
    "isCharacter": false,
    "composition": [
      20518,
      "/",
      16452,
      "/",
      12640
    ]
  },
  {
    "id": "25983",
    "description": "beyond,past",
    "pos": "GREEN",
    "explanation": "(outside + limit(s),limitation,restriction + description indicator)  Preferred NEW SYNONYM, replacing 12670",
    "isCharacter": false,
    "composition": [
      15942,
      "/",
      25579,
      ";",
      8998
    ]
  },
  {
    "id": "25984",
    "description": "binoculars,field_glass",
    "pos": "YELLOW",
    "explanation": "(tool + to look + distance)  Preferred NEW SYNONYM, replacing 24416",
    "isCharacter": false,
    "composition": [
      17755,
      "/",
      14133,
      "/",
      25559
    ]
  },
  {
    "id": "25985",
    "description": "broadband",
    "pos": "YELLOW",
    "explanation": "(band_(of_frequencies) + fast)  Preferred NEW SYNONYM, replacing 24614",
    "isCharacter": false,
    "composition": [
      24750,
      "/",
      25579,
      "/",
      14390,
      "/",
      14947
    ]
  },
  {
    "id": "25986",
    "description": "church_ruin,temple_ruin,wreck,wreckage_(church,temple,mosque)_(1)",
    "pos": "YELLOW",
    "explanation": "(ruin,wreck,wreckage_(building)_(1) + God: combination of ruin and church,mosque,temple)  SYMBOL SYNONYM",
    "isCharacter": false,
    "composition": [
      25605,
      "/",
      14451
    ]
  },
  {
    "id": "25987",
    "description": "control",
    "pos": "YELLOW",
    "explanation": "(leadership + limit(s),limitation,restriction)  Preferred NEW SYNONYM, replacing 24428",
    "isCharacter": false,
    "composition": [
      22913,
      "/",
      25579
    ]
  },
  {
    "id": "25988",
    "description": "corruption",
    "pos": "YELLOW",
    "explanation": "(abuse [contraction] + power,powerfulness [contraction] + selfish)  Preferred NEW SYNONYM, replacing 24629",
    "isCharacter": false,
    "composition": [
      22914,
      "/",
      22913,
      "/",
      25579,
      "/",
      24937
    ]
  },
  {
    "id": "25989",
    "description": "Danish_(class)",
    "pos": "YELLOW",
    "explanation": "(class [contraction] + Danish_(language))",
    "isCharacter": false,
    "composition": [
      15162,
      "/",
      15172,
      "/",
      8499,
      "/",
      18209
    ]
  },
  {
    "id": "25990",
    "description": "Danish_(language)",
    "pos": "YELLOW",
    "explanation": "(language + 3 + water: based on Denmark [contraction])  Preferred NEW SYNONYM, replacing 25283",
    "isCharacter": false,
    "composition": [
      15172,
      "/",
      8499,
      "/",
      18209
    ]
  },
  {
    "id": "25991",
    "description": "Denmark",
    "pos": "YELLOW",
    "explanation": "(country + 3 + water: country divided by three channels of water)  Preferred NEW SYNONYM, replacing 13654",
    "isCharacter": false,
    "composition": [
      13423,
      "/",
      8499,
      "/",
      18209
    ]
  },
  {
    "id": "25992",
    "description": "disability,handicap,impairment",
    "pos": "YELLOW",
    "explanation": "(ability,capability,capacity,potential + limit(s),limitation,restriction)  Preferred NEW SYNONYM, replacing 13684",
    "isCharacter": false,
    "composition": [
      12322,
      "/",
      25579
    ]
  },
  {
    "id": "25993",
    "description": "disability_benefit",
    "pos": "YELLOW",
    "explanation": "(money + disability,handicap,impairment)  Preferred NEW SYNONYM, replacing 24430",
    "isCharacter": false,
    "composition": [
      15484,
      "/",
      12322,
      "/",
      25579
    ]
  },
  {
    "id": "25994",
    "description": "disabled,impaired,handicapped_(intellectually,mentally)",
    "pos": "GREEN",
    "explanation": "(intellectual_impairment,cognitive_impairment,mental_impairment + description indicator: having limits to one's mental abilities)  Preferred NEW SYNONYM, replacing 15457",
    "isCharacter": false,
    "composition": [
      25579,
      ";",
      8998,
      "/",
      15471
    ]
  },
  {
    "id": "25995",
    "description": "disabled,impaired,handicapped_(physically)",
    "pos": "GREEN",
    "explanation": "(physical_impairment,physical_disability + description indicator: having limits to one's physical abilities)  Preferred NEW SYNONYM, replacing 16170",
    "isCharacter": false,
    "composition": [
      25579,
      ";",
      8998,
      "/",
      12870
    ]
  },
  {
    "id": "25996",
    "description": "distance",
    "pos": "YELLOW",
    "explanation": "(measurement + farness,remoteness,farawayness)  Preferred NEW SYNONYM, replacing 23071",
    "isCharacter": false,
    "composition": [
      15443,
      "/",
      25559
    ]
  },
  {
    "id": "25997",
    "description": "empower-(to)",
    "pos": "RED",
    "explanation": "(empowerment + action indicator)  Preferred NEW SYNONYM, replacing 24648",
    "isCharacter": false,
    "composition": [
      24903,
      ";",
      8993,
      "/",
      22913,
      "/",
      25579
    ]
  },
  {
    "id": "25998",
    "description": "empowered",
    "pos": "GREEN",
    "explanation": "(empowerment + description indicator)  Preferred NEW SYNONYM, replacing 24649",
    "isCharacter": false,
    "composition": [
      24903,
      ";",
      8998,
      "/",
      22913,
      "/",
      25579
    ]
  },
  {
    "id": "25999",
    "description": "empowerment",
    "pos": "YELLOW",
    "explanation": "(give + power,powerfulness [contraction])  Preferred NEW SYNONYM, replacing 24650",
    "isCharacter": false,
    "composition": [
      24903,
      "/",
      22913,
      "/",
      25579
    ]
  },
  {
    "id": "26000",
    "description": "eternal",
    "pos": "GREEN",
    "explanation": "(eternity,infinity + description indicator)    Preferred NEW SYNONYM, replacing 21332",
    "isCharacter": false,
    "composition": [
      17732,
      ";",
      8998,
      "/",
      15474,
      "/",
      25579
    ]
  },
  {
    "id": "26001",
    "description": "eternity,infinity",
    "pos": "YELLOW",
    "explanation": "(time + infiniteness,boundlessness,limitlessness)  Preferred NEW SYNONYM, replacing 24892",
    "isCharacter": false,
    "composition": [
      17732,
      "/",
      15474,
      "/",
      25579
    ]
  },
  {
    "id": "26002",
    "description": "far,distant,remote",
    "pos": "GREEN",
    "explanation": "(farness,remoteness,farawayness + description indicator)  Preferred NEW SYNONYM, replacing 14150",
    "isCharacter": false,
    "composition": [
      25559,
      ";",
      8998
    ]
  },
  {
    "id": "26003",
    "description": "fat,thick",
    "pos": "GREEN",
    "explanation": "(fatness,thickness + description indicator)    Preferred NEW SYNONYM, replacing 14156",
    "isCharacter": false,
    "composition": [
      25560,
      ";",
      8998
    ]
  },
  {
    "id": "26004",
    "description": "guess,estimation",
    "pos": "YELLOW",
    "explanation": "(doubt + plus minus: reason on the basis of information of uncertain accuracy)",
    "isCharacter": false,
    "composition": [
      22911,
      "/",
      25595
    ]
  },
  {
    "id": "26005",
    "description": "gym,gymnasium",
    "pos": "YELLOW",
    "explanation": "(room + sport)  Preferred NEW SYNONYM, replacing 14656",
    "isCharacter": false,
    "composition": [
      16687,
      "/",
      20518
    ]
  },
  {
    "id": "26006",
    "description": "gym_mat",
    "pos": "YELLOW",
    "explanation": "(rug,carpet,mat + sport)  Preferred NEW SYNONYM, replacing 14657",
    "isCharacter": false,
    "composition": [
      14203,
      "/",
      20518
    ]
  },
  {
    "id": "26007",
    "description": "Halloween",
    "pos": "YELLOW",
    "explanation": "(day + ghost,phantom)  Preferred NEW SYNONYM, replacing 14662",
    "isCharacter": false,
    "composition": [
      13639,
      "/",
      23577,
      "/",
      14133,
      "/",
      17724
    ]
  },
  {
    "id": "26008",
    "description": "hearing_impairment",
    "pos": "YELLOW",
    "explanation": "(limit(s),limitation,restriction + ear: ear representing hearing or to hear)",
    "isCharacter": false,
    "composition": [
      25579,
      "/",
      13894
    ]
  },
  {
    "id": "26009",
    "description": "hearing-impaired",
    "pos": "GREEN",
    "explanation": "(hearing_impairment + description indicator)  Preferred NEW SYNONYM, replacing 14694",
    "isCharacter": false,
    "composition": [
      25579,
      ";",
      8998,
      "/",
      13894
    ]
  },
  {
    "id": "26010",
    "description": "infinite,limitless",
    "pos": "GREEN",
    "explanation": "(infiniteness,boundlessness,limitlessness + description indicator)  Preferred NEW SYNONYM, replacing 14940",
    "isCharacter": false,
    "composition": [
      15474,
      "/",
      25579,
      ";",
      8998
    ]
  },
  {
    "id": "26011",
    "description": "infiniteness,boundlessness,limitlessness",
    "pos": "YELLOW",
    "explanation": "(minus,no,without + limit(s),limitation,restriction)  Preferred NEW SYNONYM, replacing 24915",
    "isCharacter": false,
    "composition": [
      15474,
      "/",
      25579
    ]
  },
  {
    "id": "26012",
    "description": "intellectual_impairment,cognitive_impairment,mental_impairment",
    "pos": "YELLOW",
    "explanation": "(limit(s),limitation,restriction + mind,intellect,reason: limitation to one's mental abilities)",
    "isCharacter": false,
    "composition": [
      25579,
      "/",
      15471
    ]
  },
  {
    "id": "26013",
    "description": "lacrosse_(sport)",
    "pos": "YELLOW",
    "explanation": "(tennis,racket_sport,racquet_sport + group: group representing team_(sport) [contraction])  Preferred NEW SYNONYM, replacing 22102",
    "isCharacter": false,
    "composition": [
      20518,
      "/",
      16452,
      "/",
      14647,
      "/",
      16161
    ]
  },
  {
    "id": "26014",
    "description": "limit,restrict,restrain,confine-(to)",
    "pos": "RED",
    "explanation": "(limit(s),limitation,restriction + description indicator)",
    "isCharacter": false,
    "composition": [
      25579,
      ";",
      8993
    ]
  },
  {
    "id": "26015",
    "description": "limited,restricted,confined",
    "pos": "GREEN",
    "explanation": "(limit(s),limitation,restriction + action indicator)",
    "isCharacter": false,
    "composition": [
      25579,
      ";",
      8998
    ]
  },
  {
    "id": "26016",
    "description": "Loki",
    "pos": "BLUE",
    "explanation": "(Nordic God + lie: the God of falseness)  Preferred NEW SYNONYM, replacing 22822",
    "isCharacter": false,
    "composition": [
      14451,
      "/",
      15730,
      "/",
      15474,
      "/",
      17786
    ]
  },
  {
    "id": "26017",
    "description": "long_jump_(sport)",
    "pos": "YELLOW",
    "explanation": "(sport + jump + far,distant)  Preferred NEW SYNONYM, replacing 21845",
    "isCharacter": false,
    "composition": [
      20518,
      "/",
      23550,
      "/",
      25559
    ]
  },
  {
    "id": "26018",
    "description": "louse,stinging_insect",
    "pos": "YELLOW",
    "explanation": "(insect + puncture,prick-(to): insect that punctures, the skin or leaves or stems of plants)",
    "isCharacter": false,
    "composition": [
      14943,
      "/",
      16212
    ]
  },
  {
    "id": "26019",
    "description": "odometer",
    "pos": "YELLOW",
    "explanation": "(gauge + farness,remoteness,farawayness + thing indicator: a meter that measures distance)  Preferred NEW SYNONYM, replacing 23161",
    "isCharacter": false,
    "composition": [
      24806,
      ";",
      9009,
      "/",
      25559
    ]
  },
  {
    "id": "26020",
    "description": "physical_impairment,physical_disability",
    "pos": "YELLOW",
    "explanation": "(limit(s),limitation,restriction + body: limitations to one's physical abilities)",
    "isCharacter": false,
    "composition": [
      25579,
      "/",
      12870
    ]
  },
  {
    "id": "26021",
    "description": "placenta",
    "pos": "YELLOW",
    "explanation": "(organ + food + fetus)  Preferred NEW SYNONYM, replacing 24213",
    "isCharacter": false,
    "composition": [
      25480,
      "/",
      14377,
      "/",
      14170
    ]
  },
  {
    "id": "26022",
    "description": "power,powerfulness",
    "pos": "YELLOW",
    "explanation": "(ability + control)  Preferred NEW SYNONYM, replacing 24718",
    "isCharacter": false,
    "composition": [
      12322,
      "/",
      22913,
      "/",
      25579
    ]
  },
  {
    "id": "26023",
    "description": "powerful,mighty",
    "pos": "GREEN",
    "explanation": "(power,powerfulness + description indicator)  Preferred NEW SYNONYM, replacing 24719",
    "isCharacter": false,
    "composition": [
      12322,
      ";",
      8998,
      "/",
      22913,
      "/",
      25579
    ]
  },
  {
    "id": "26024",
    "description": "sitski,sit_ski_(sport)",
    "pos": "YELLOW",
    "explanation": "(sport + sitski,sit_ski)",
    "isCharacter": false,
    "composition": [
      20518,
      "/",
      25609
    ]
  },
  {
    "id": "26025",
    "description": "speech_impaired",
    "pos": "GREEN",
    "explanation": "(speech_impairment,dysarthria + description indicator: having limits to one's physical abilities)  Preferred NEW SYNONYM, replacing 17225",
    "isCharacter": false,
    "composition": [
      25579,
      ";",
      8998,
      "/",
      15666
    ]
  },
  {
    "id": "26026",
    "description": "speech_impairment,dysarthria",
    "pos": "YELLOW",
    "explanation": "(limit(s),limitation,restriction + to speak: having difficulties to speak intelligibly)",
    "isCharacter": false,
    "composition": [
      25579,
      "/",
      15666
    ]
  },
  {
    "id": "26027",
    "description": "squash_(sport)",
    "pos": "YELLOW",
    "explanation": "(tennis,racket_sport,racquet_sport + room)  Preferred NEW SYNONYM, replacing 22101",
    "isCharacter": false,
    "composition": [
      20518,
      "/",
      16452,
      "/",
      16687
    ]
  },
  {
    "id": "26028",
    "description": "table_tennis,ping-pong_(activity)",
    "pos": "YELLOW",
    "explanation": "(tennis_(activity) + table: game like tennis, played on a table)  Preferred NEW SYNONYM, replacing 16183",
    "isCharacter": false,
    "composition": [
      12335,
      "/",
      16452,
      "/",
      17493
    ]
  },
  {
    "id": "26029",
    "description": "table_tennis,ping-pong_(sport)",
    "pos": "YELLOW",
    "explanation": "(tennis,racket_sport,racquet_sport + table)  Preferred NEW SYNONYM, replacing 20603",
    "isCharacter": false,
    "composition": [
      20518,
      "/",
      16452,
      "/",
      17493
    ]
  },
  {
    "id": "26030",
    "description": "tennis,racket_sport,racquet_sport",
    "pos": "YELLOW",
    "explanation": "(sport + racket,racquet)  Preferred NEW SYNONYM, replacing 20602",
    "isCharacter": false,
    "composition": [
      20518,
      "/",
      16452
    ]
  },
  {
    "id": "26031",
    "description": "tennis_(activity)",
    "pos": "YELLOW",
    "explanation": "(activity + racket,racquet: game played with racquets)  Preferred NEW SYNONYM, replacing 17522",
    "isCharacter": false,
    "composition": [
      12335,
      "/",
      16452
    ]
  },
  {
    "id": "26032",
    "description": "visual_impairment",
    "pos": "YELLOW",
    "explanation": "(limit(s),limitation,restriction + to see: difficulties to see)",
    "isCharacter": false,
    "composition": [
      25579,
      "/",
      14133
    ]
  },
  {
    "id": "26033",
    "description": "visually_impaired",
    "pos": "GREEN",
    "explanation": "(visual_impairment + description indicator: having difficulties to see)  Preferred NEW SYNONYM, replacing 18019",
    "isCharacter": false,
    "composition": [
      25579,
      ";",
      8998,
      "/",
      14133
    ]
  },
  {
    "id": "26040",
    "description": "body_with_mane",
    "pos": "YELLOW",
    "explanation": "(body + hair (on top)) - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "26041",
    "description": "body_with_navel",
    "pos": "YELLOW",
    "explanation": "(body + dot) - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "26042",
    "description": "body_with_pubic_hair",
    "pos": "YELLOW",
    "explanation": "(body + hair (at bottom)) - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "26043",
    "description": "building_with_attic",
    "pos": "YELLOW",
    "explanation": "(house + pictograph of attic) - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "26044",
    "description": "building_with_cellar",
    "pos": "YELLOW",
    "explanation": "(house + pictograph of cellar) - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "26045",
    "description": "building_with_chimney",
    "pos": "YELLOW",
    "explanation": "(house + pictograph of chimney) - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "26046",
    "description": "building_with_foundation",
    "pos": "YELLOW",
    "explanation": "(house + pictograph of foundation) - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "26047",
    "description": "building_with_storey",
    "pos": "YELLOW",
    "explanation": "(house + pictograph of storey) - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "26048",
    "description": "building_with_yard_and_fence",
    "pos": "YELLOW",
    "explanation": "(house + pictograph of yard and fence) - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "26049",
    "description": "buildings_with_courtyard",
    "pos": "YELLOW",
    "explanation": "(house + ground + house) - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "26050",
    "description": "bulbous_plant",
    "pos": "YELLOW",
    "explanation": "(bulb + flower) - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "26051",
    "description": "eye_with_eyebrow",
    "pos": "YELLOW",
    "explanation": "(eye + line [half-sized, above]) - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "26052",
    "description": "face_with_beard",
    "pos": "YELLOW",
    "explanation": "(face + hair [modification, below chin]) - Character (superimposed - modified)",
    "isCharacter": true
  },
  {
    "id": "26053",
    "description": "face_with_pimple",
    "pos": "YELLOW",
    "explanation": "(face + dot (on cheek)) - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "26054",
    "description": "furred_animal",
    "pos": "YELLOW",
    "explanation": "(animal + hair (on top)) - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "26055",
    "description": "throat",
    "pos": "YELLOW",
    "explanation": "(head + pictograph of neck) - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "26056",
    "description": "head_with_hair",
    "pos": "YELLOW",
    "explanation": "(head + hair [modification, on top of head]) - Character (superimposed - modified)",
    "isCharacter": true
  },
  {
    "id": "26057",
    "description": "mountains_with_valley",
    "pos": "YELLOW",
    "explanation": "(mountain + ground + mountain [modification, mirrored]) - Character (superimposed - modified)",
    "isCharacter": true
  },
  {
    "id": "26058",
    "description": "out_of_body_(downward),excretion",
    "pos": "YELLOW",
    "explanation": "(body + down,downward) - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "26059",
    "description": "pointer,arrowhead",
    "pos": "YELLOW",
    "explanation": "(pictograph of pointer or arrowhead: pointing downward, but can be in any of 8 directions)  - Character",
    "isCharacter": true
  },
  {
    "id": "26060",
    "description": "pointer,arrowhead_(small)",
    "pos": "YELLOW",
    "explanation": "(pictograph of small pointer or arrowhead: pointing downward, but can be in any of 8 directions)  - Character",
    "isCharacter": true
  },
  {
    "id": "26061",
    "description": "road_and_car",
    "pos": "YELLOW",
    "explanation": "(ground [modification, prolonged] + car) - Character (superimposed - modified)",
    "isCharacter": true
  },
  {
    "id": "26062",
    "description": "steering_wheel",
    "pos": "YELLOW",
    "explanation": "(car,automobile,motor_vehicle + pointer to steering wheel) - Character (superimposed - pointer)",
    "isCharacter": true
  },
  {
    "id": "26063",
    "description": "street_and_building",
    "pos": "YELLOW",
    "explanation": "(ground + house) - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "26064",
    "description": "one_third",
    "pos": "WHITE",
    "explanation": "(one_(digit),1 [modification, higher position] + slash (slanted line) + three_(digit),3: a common way to write 1/3) - Character (superimposed - modified)",
    "isCharacter": true
  },
  {
    "id": "26065",
    "description": "two_thirds",
    "pos": "WHITE",
    "explanation": "(two_(digit),2 [modification, higher position] + slash (slanted line) + three_(digit),3: a common way to write 2/3) - Character (superimposed - modified)",
    "isCharacter": true
  },
  {
    "id": "26066",
    "description": "three_quarters",
    "pos": "WHITE",
    "explanation": "(three_(digit),3 [modification, higher position] + slash (slanted line) + four_(digit),4: a common way to write ¾) - Character (superimposed - modified)",
    "isCharacter": true
  },
  {
    "id": "26100",
    "description": "cruelty,mercilessness,ruthlessness",
    "pos": "YELLOW",
    "explanation": "(feeling + knife: ”sharp”, ”cutting” and harmful behaviour)",
    "isCharacter": false,
    "composition": [
      14164,
      "/",
      15159
    ]
  },
  {
    "id": "26101",
    "description": "democracy_(OLD)",
    "pos": "YELLOW",
    "explanation": "(permission,allowance + choice)",
    "isCharacter": false,
    "composition": [
      24926,
      "/",
      13175
    ]
  },
  {
    "id": "26102",
    "description": "endlessness",
    "pos": "YELLOW",
    "explanation": "(without + end)",
    "isCharacter": false,
    "composition": [
      15474,
      "/",
      13935
    ]
  },
  {
    "id": "26103",
    "description": "floating,afloat",
    "pos": "GREEN",
    "explanation": "(floating container + description indicator)",
    "isCharacter": false,
    "composition": [
      25562,
      ";",
      8998
    ]
  },
  {
    "id": "26104",
    "description": "interrogation",
    "pos": "YELLOW",
    "explanation": "(question + intensity)",
    "isCharacter": false,
    "composition": [
      16445,
      "/",
      14947
    ]
  },
  {
    "id": "26105",
    "description": "loss_(competition)",
    "pos": "YELLOW",
    "explanation": "(competition + loss)",
    "isCharacter": false,
    "composition": [
      16451,
      "/",
      17449
    ]
  },
  {
    "id": "26106",
    "description": "mourning,grief",
    "pos": "YELLOW",
    "explanation": "(sadness + loss)",
    "isCharacter": false,
    "composition": [
      14164,
      "/",
      13869,
      "/",
      17449
    ]
  },
  {
    "id": "26107",
    "description": "translation",
    "pos": "YELLOW",
    "explanation": "(bridge + language)",
    "isCharacter": false,
    "composition": [
      12902,
      "/",
      15172
    ]
  },
  {
    "id": "26108",
    "description": "underground,below_ground",
    "pos": "GREEN",
    "explanation": "(under_(ground_level) + description indicator)",
    "isCharacter": false,
    "composition": [
      25628,
      ";",
      8998
    ]
  },
  {
    "id": "26120",
    "description": "All_Saints'_Day",
    "pos": "YELLOW",
    "explanation": "(day + all + saint)",
    "isCharacter": false,
    "composition": [
      13639,
      "/",
      12360,
      "/",
      16161,
      "/",
      21082
    ]
  },
  {
    "id": "26121",
    "description": "animal_(cold-blooded),cold-blooded_animal,poikilotherm,ectotherm",
    "pos": "YELLOW",
    "explanation": "(animal,beast + temperature + up_and_down: animal with varying body temperature, generally depending on the external temperature of the environment)",
    "isCharacter": false,
    "composition": [
      12378,
      "/",
      17520,
      "/",
      20524
    ]
  },
  {
    "id": "26122",
    "description": "animal_(warm-blooded),warm-blooded_animal,homeotherm,endotherm",
    "pos": "YELLOW",
    "explanation": "(animal,beast + temperature + same,equal,equality: animal with stable body temperature, generally controlled by internal bodily functions)",
    "isCharacter": false,
    "composition": [
      12378,
      "/",
      17520,
      "/",
      16713
    ]
  },
  {
    "id": "26123",
    "description": "arthropod(s)",
    "pos": "YELLOW",
    "explanation": "(generalisation + shellfish_(without_claws): invertebrate animals having an external skeleton, a segmented body, and jointed appendages, include insects, arachnids (spiders etc.), myriapods, and crustaceans (crabs, crayfish, shrimps etc.))",
    "isCharacter": false,
    "composition": [
      14430,
      "/",
      23204
    ]
  },
  {
    "id": "26124",
    "description": "assistance_dog",
    "pos": "YELLOW",
    "explanation": "(dog,canine_(animal),canid + help,aid,assistance,support)",
    "isCharacter": false,
    "composition": [
      12380,
      "/",
      14704
    ]
  },
  {
    "id": "26125",
    "description": "atlas,book_of_maps",
    "pos": "YELLOW",
    "explanation": "(book + map)",
    "isCharacter": false,
    "composition": [
      12875,
      "/",
      15962,
      "/",
      13901
    ]
  },
  {
    "id": "26126",
    "description": "attempt,effort,try",
    "pos": "YELLOW",
    "explanation": "(forward + difficulty: forward move, with difficulty)",
    "isCharacter": true
  },
  {
    "id": "26127",
    "description": "attendance_list,register_list,contact_list",
    "pos": "YELLOW",
    "explanation": "(paper + group: documentation of a group of people)",
    "isCharacter": false,
    "composition": [
      15962,
      "/",
      14647,
      "/",
      16161
    ]
  },
  {
    "id": "26128",
    "description": "auditory_system",
    "pos": "YELLOW",
    "explanation": "(generalisation + organ,inner_organ,inner_body_part + ear)",
    "isCharacter": false,
    "composition": [
      14430,
      "/",
      25480,
      "/",
      13894
    ]
  },
  {
    "id": "26129",
    "description": "badger",
    "pos": "YELLOW",
    "explanation": "(animal + smell,odour [contraction of mustelid] + many + line)",
    "isCharacter": false,
    "composition": [
      12378,
      "/",
      17017,
      "/",
      14647,
      "/",
      15214
    ]
  },
  {
    "id": "26130",
    "description": "bedtime",
    "pos": "YELLOW",
    "explanation": "(time + bed)",
    "isCharacter": false,
    "composition": [
      17732,
      "/",
      12649
    ]
  },
  {
    "id": "26131",
    "description": "bouquet_(flowers)",
    "pos": "YELLOW",
    "explanation": "(many + flower + attachment,appendix,annex: many flowers together)",
    "isCharacter": false,
    "composition": [
      14647,
      "/",
      14205,
      "/",
      23409
    ]
  },
  {
    "id": "26132",
    "description": "brook,creek",
    "pos": "YELLOW",
    "explanation": "(river,stream,current + littleness,smallness: a small stream of water)",
    "isCharacter": false,
    "composition": [
      16677,
      "/",
      24917
    ]
  },
  {
    "id": "26133",
    "description": "burial_mound,grave_mound",
    "pos": "YELLOW",
    "explanation": "(grave + group_of + stone: a heap of stones and earth placed over typically prehistoric tombs)",
    "isCharacter": false,
    "composition": [
      14638,
      "/",
      14647,
      "/",
      17267
    ]
  },
  {
    "id": "26134",
    "description": "capital,capital_city",
    "pos": "YELLOW",
    "explanation": "(town,city + country,state: the city of primary status in a country, state, or province, usually as its seat of government)",
    "isCharacter": false,
    "composition": [
      14647,
      "/",
      14647,
      "/",
      14905,
      "/",
      13423
    ]
  },
  {
    "id": "26135",
    "description": "carnivore",
    "pos": "YELLOW",
    "explanation": "(animal,beast + meat: animal that eats (the meat of) other animals)",
    "isCharacter": false,
    "composition": [
      12378,
      "/",
      14377,
      "/",
      12378
    ]
  },
  {
    "id": "26136",
    "description": "carpenter",
    "pos": "YELLOW",
    "explanation": "(person + carpentry [contraction with omission of work])",
    "isCharacter": false,
    "composition": [
      16161,
      "/",
      17755,
      "/",
      17775
    ]
  },
  {
    "id": "26137",
    "description": "carpentry,wood_work",
    "pos": "YELLOW",
    "explanation": "(work + tool + tree [contraction of wood (material + tree)]: work with tools for building with wood)",
    "isCharacter": false,
    "composition": [
      18273,
      "/",
      17755,
      "/",
      17775
    ]
  },
  {
    "id": "26138",
    "description": "character_(in_a_story)",
    "pos": "YELLOW",
    "explanation": "(person + story,tale)",
    "isCharacter": false,
    "composition": [
      16161,
      "/",
      15962,
      "/",
      15666
    ]
  },
  {
    "id": "26139",
    "description": "charge_(electricity)-(to)",
    "pos": "RED",
    "explanation": "(fill-(to) + electricity + action indicator)",
    "isCharacter": false,
    "composition": [
      24897,
      ";",
      8993,
      "/",
      13918
    ]
  },
  {
    "id": "26140",
    "description": "charged_(electricity)",
    "pos": "GREEN",
    "explanation": "(full + electricity + description indicator)",
    "isCharacter": false,
    "composition": [
      24897,
      ";",
      8998,
      "/",
      13918
    ]
  },
  {
    "id": "26141",
    "description": "charger,battery_charger",
    "pos": "YELLOW",
    "explanation": "(thing + filling,fill,fullness + electricity: thing for charging with electricity)",
    "isCharacter": false,
    "composition": [
      17717,
      "/",
      24897,
      "/",
      13918
    ]
  },
  {
    "id": "26142",
    "description": "cheetah",
    "pos": "YELLOW",
    "explanation": "(cat,feline_(animal),felid + quickness,rapidity,speediness: cat animal that is the swiftest mammal)",
    "isCharacter": false,
    "composition": [
      12383,
      "/",
      14390,
      "/",
      14947
    ]
  },
  {
    "id": "26143",
    "description": "chromosome",
    "pos": "YELLOW",
    "explanation": "(fiber,fibre,fibril,filament,strand, + atom + spiral [the latter two is a contraction of the DNA molecule]: the threadlike body in the cell nucleus that carries the DNA spiral molecule with genes in a linear order)",
    "isCharacter": false,
    "composition": [
      25878,
      "/",
      12592,
      "/",
      25616
    ]
  },
  {
    "id": "26144",
    "description": "clothes_line,drying_line",
    "pos": "YELLOW",
    "explanation": "(filament [contraction of thread,string,cord] + dryness: line for drying clothes etc.)",
    "isCharacter": false,
    "composition": [
      25878,
      "/",
      23859
    ]
  },
  {
    "id": "26145",
    "description": "coloring_book,colouring_book",
    "pos": "YELLOW",
    "explanation": "(book + pen + colour)",
    "isCharacter": false,
    "composition": [
      12875,
      "/",
      15991,
      "/",
      13377
    ]
  },
  {
    "id": "26146",
    "description": "communication_impaired",
    "pos": "GREEN",
    "explanation": "(communication_impairment + description indicator)",
    "isCharacter": false,
    "composition": [
      25579,
      ";",
      8998,
      "/",
      25555,
      "/",
      15441
    ]
  },
  {
    "id": "26147",
    "description": "communication_impairment",
    "pos": "YELLOW",
    "explanation": "(limit(s),limitation,restriction + communication)",
    "isCharacter": false,
    "composition": [
      25579,
      "/",
      25555,
      "/",
      15441
    ]
  },
  {
    "id": "26148",
    "description": "compost",
    "pos": "YELLOW",
    "explanation": "(mixture + change,alteration + earth,ground,land: mixture that is transformed into earth)",
    "isCharacter": false,
    "composition": [
      22377,
      "/",
      13151,
      "/",
      13901
    ]
  },
  {
    "id": "26149",
    "description": "confusion_(feeling)",
    "pos": "YELLOW",
    "explanation": "(feeling,emotion,sensation + mixture: mixed feelings about something)",
    "isCharacter": false,
    "composition": [
      14164,
      "/",
      22377
    ]
  },
  {
    "id": "26150",
    "description": "confusion_(mental)",
    "pos": "YELLOW",
    "explanation": "(mind,intellect,reason + mixture: mixed thinking about something)",
    "isCharacter": false,
    "composition": [
      15471,
      "/",
      22377
    ]
  },
  {
    "id": "26151",
    "description": "cookbook,cookery_book",
    "pos": "YELLOW",
    "explanation": "(book + cooking,cookery,preparation_(general))",
    "isCharacter": false,
    "composition": [
      12875,
      "/",
      23583,
      "/",
      14377
    ]
  },
  {
    "id": "26152",
    "description": "cycle_of_life,life_cycle",
    "pos": "YELLOW",
    "explanation": "(rotation,circulation,orbit,lap,circle,round + life: the cycle of generation of life, life span, death, and regeneration of new life)",
    "isCharacter": false,
    "composition": [
      24249,
      "/",
      15206
    ]
  },
  {
    "id": "26153",
    "description": "dictionary,lexicon,wordbook",
    "pos": "YELLOW",
    "explanation": "(book + word: a reference book containing an alphabetical list of words with information about them)",
    "isCharacter": false,
    "composition": [
      12875,
      "/",
      15972,
      "/",
      15172
    ]
  },
  {
    "id": "26154",
    "description": "digital_game,video_game,computer_game",
    "pos": "YELLOW",
    "explanation": "(play_(in_combinations) + digits_(computer): any kind of digital game on computers, game consoles or mobile devices)  - Preferred NEW SYNONYM, replacing computer_game_(OLD) 23449",
    "isCharacter": false,
    "composition": [
      12335,
      "/",
      "RK:-2",
      "/",
      14164,
      "/",
      23476
    ]
  },
  {
    "id": "26155",
    "description": "diversity,variety_(general)",
    "pos": "YELLOW",
    "explanation": "(group_of,much_of,many_of,quantity_of + different,other,difference: many of something being different in character, a heterogeneous group)",
    "isCharacter": false,
    "composition": [
      14647,
      "/",
      13675
    ]
  },
  {
    "id": "26156",
    "description": "DNA",
    "pos": "YELLOW",
    "explanation": "(atom [contraction of molecule] + life + spiral: the spiral formed DNA molecule of life carrying the genetic code)",
    "isCharacter": false,
    "composition": [
      12592,
      "/",
      15206,
      "/",
      25616
    ]
  },
  {
    "id": "26157",
    "description": "download",
    "pos": "YELLOW",
    "explanation": "(receiving + digits_(computer): the getting of digital data from a server on the internet)",
    "isCharacter": false,
    "composition": [
      24727,
      "/",
      23476
    ]
  },
  {
    "id": "26158",
    "description": "download-(to)",
    "pos": "RED",
    "explanation": "(download + action indicator)",
    "isCharacter": false,
    "composition": [
      24727,
      ";",
      8993,
      "/",
      23476
    ]
  },
  {
    "id": "26159",
    "description": "dragon",
    "pos": "YELLOW",
    "explanation": "(animal,beast + fire)",
    "isCharacter": false,
    "composition": [
      12378,
      "/",
      14183
    ]
  },
  {
    "id": "26160",
    "description": "drying_rack",
    "pos": "YELLOW",
    "explanation": "(structure,construction + dryness,drought: construction for drying something)",
    "isCharacter": false,
    "composition": [
      17445,
      "/",
      23859
    ]
  },
  {
    "id": "26161",
    "description": "drying_rack_(cloth)",
    "pos": "YELLOW",
    "explanation": "(drying_rack + cloth)",
    "isCharacter": false,
    "composition": [
      17445,
      "/",
      23859,
      "/",
      13365
    ]
  },
  {
    "id": "26162",
    "description": "drying_rack_(fish)",
    "pos": "YELLOW",
    "explanation": "(drying_rack + fish)",
    "isCharacter": false,
    "composition": [
      17445,
      "/",
      23859,
      "/",
      14188
    ]
  },
  {
    "id": "26163",
    "description": "ear_bone,ossicle,auditory_ossicle",
    "pos": "YELLOW",
    "explanation": "(bone + ear)",
    "isCharacter": false,
    "composition": [
      12873,
      "/",
      13894
    ]
  },
  {
    "id": "26164",
    "description": "eardrum,tympanic_membrane",
    "pos": "YELLOW",
    "explanation": "(membrane,drumhead,drum_skin + ear)",
    "isCharacter": false,
    "composition": [
      26197,
      "/",
      13894
    ]
  },
  {
    "id": "26165",
    "description": "environs",
    "pos": "YELLOW",
    "explanation": "(earth,ground,land [half-sized]) - Character",
    "isCharacter": true
  },
  {
    "id": "26166",
    "description": "equality_(social)",
    "pos": "YELLOW",
    "explanation": "(same,equal,equality + society: a certain level of general social equality among citizens of a state or community)",
    "isCharacter": false,
    "composition": [
      16713,
      "/",
      14430,
      "/",
      13349
    ]
  },
  {
    "id": "26167",
    "description": "exercise_(physical)",
    "pos": "YELLOW",
    "explanation": "(work + health: work, in order to maintain health)",
    "isCharacter": false,
    "composition": [
      18273,
      "/",
      14690
    ]
  },
  {
    "id": "26168",
    "description": "face_painting",
    "pos": "YELLOW",
    "explanation": "(picture,image,icon,painting + face + brush: painting on the face made with brush)",
    "isCharacter": false,
    "composition": [
      14133,
      "/",
      13934,
      "/",
      14138,
      "/",
      12912
    ]
  },
  {
    "id": "26169",
    "description": "fear_of_heights,acrophobia",
    "pos": "YELLOW",
    "explanation": "(fear,fright,concern + height,tallness)",
    "isCharacter": false,
    "composition": [
      14164,
      "/",
      13869,
      "/",
      25568,
      "/",
      24909
    ]
  },
  {
    "id": "26170",
    "description": "fishing_line",
    "pos": "YELLOW",
    "explanation": "(filament [contraction of thread,string,cord] + reception + fish: line for catching fish)",
    "isCharacter": false,
    "composition": [
      25878,
      "/",
      24727,
      "/",
      14188
    ]
  },
  {
    "id": "26171",
    "description": "fishing_rod",
    "pos": "YELLOW",
    "explanation": "(linear_thing,pole + reception + fish + thing indicator: rod for catching fish)",
    "isCharacter": false,
    "composition": [
      15214,
      ";",
      9009,
      "/",
      24727,
      "/",
      14188
    ]
  },
  {
    "id": "26172",
    "description": "fist",
    "pos": "YELLOW",
    "explanation": "(hand + fold,folding)",
    "isCharacter": false,
    "composition": [
      14667,
      "/",
      25564
    ]
  },
  {
    "id": "26173",
    "description": "flight_attendant",
    "pos": "BLUE",
    "explanation": "(worker + airplane,aeroplane,plane)",
    "isCharacter": false,
    "composition": [
      16161,
      "/",
      18273,
      "/",
      12357
    ]
  },
  {
    "id": "26174",
    "description": "gene",
    "pos": "YELLOW",
    "explanation": "(part,bit,piece,portion,part_of + DNA: section of the DNA molecule that encodes the production of a certain polypeptide chain, a unit of heredity)",
    "isCharacter": false,
    "composition": [
      15972,
      "/",
      12592,
      "/",
      15206,
      "/",
      25616
    ]
  },
  {
    "id": "26175",
    "description": "genetics",
    "pos": "YELLOW",
    "explanation": "(science,body_of_learning + atom + spiral: contraction of science + gene)",
    "isCharacter": false,
    "composition": [
      16735,
      "/",
      12592,
      "/",
      25616
    ]
  },
  {
    "id": "26176",
    "description": "gill",
    "pos": "YELLOW",
    "explanation": "(organ,inner_organ,inner_body_part + breath + fish: The respiratory organ of fish and other aquatic animals)",
    "isCharacter": false,
    "composition": [
      25480,
      "/",
      15732,
      "/",
      15666,
      "/",
      14188
    ]
  },
  {
    "id": "26177",
    "description": "herbivore",
    "pos": "YELLOW",
    "explanation": "(animal,beast + food + plant: animals that primarily eat plants)",
    "isCharacter": false,
    "composition": [
      12378,
      "/",
      14377,
      "/",
      16196
    ]
  },
  {
    "id": "26178",
    "description": "hierarchy",
    "pos": "YELLOW",
    "explanation": "(layer,level + plan,design,method,system: a series of ordered groupings or levels of people or things within a system)",
    "isCharacter": false,
    "composition": [
      25748,
      "/",
      16194
    ]
  },
  {
    "id": "26179",
    "description": "honest,honestly",
    "pos": "GREEN",
    "explanation": "(honesty + description indicator)",
    "isCharacter": false,
    "composition": [
      16437,
      ";",
      8998,
      "/",
      17786
    ]
  },
  {
    "id": "26180",
    "description": "honesty",
    "pos": "YELLOW",
    "explanation": "(purpose + truth: strive for truth)",
    "isCharacter": false,
    "composition": [
      16437,
      "/",
      17786
    ]
  },
  {
    "id": "26181",
    "description": "hyena",
    "pos": "YELLOW",
    "explanation": "(animal,beast + sound + up,upward + mouth [up + mouth is a contraction of laugh,laughter]: the hyena is known for its laughing sound)",
    "isCharacter": false,
    "composition": [
      12378,
      "/",
      17216,
      "/",
      17983,
      "/",
      15666
    ]
  },
  {
    "id": "26182",
    "description": "indigestion,heartburn",
    "pos": "YELLOW",
    "explanation": "(feeling + illness + inner_organ + food [organ + food is a contraction of stomach,tummy,tum])",
    "isCharacter": false,
    "composition": [
      14164,
      "/",
      "RK:-2",
      "/",
      16164,
      "/",
      25480,
      "/",
      14377
    ]
  },
  {
    "id": "26183",
    "description": "industry",
    "pos": "YELLOW",
    "explanation": "(generalization + factory,plant)",
    "isCharacter": false,
    "composition": [
      14430,
      "/",
      14905,
      "/",
      23583
    ]
  },
  {
    "id": "26184",
    "description": "inequality",
    "pos": "YELLOW",
    "explanation": "(different,other,difference + society: social inequality among citizens or members of a state or community)",
    "isCharacter": false,
    "composition": [
      13675,
      "/",
      14430,
      "/",
      13349
    ]
  },
  {
    "id": "26185",
    "description": "invertebrate",
    "pos": "YELLOW",
    "explanation": "(animal + without + spine,backbone)",
    "isCharacter": false,
    "composition": [
      12378,
      "/",
      15474,
      "/",
      12873,
      "/",
      12609
    ]
  },
  {
    "id": "26186",
    "description": "justification",
    "pos": "YELLOW",
    "explanation": "(support_(oral) + correctness)",
    "isCharacter": false,
    "composition": [
      15666,
      "/",
      14382,
      "/",
      25538,
      "/",
      14947
    ]
  },
  {
    "id": "26187",
    "description": "justified",
    "pos": "GREEN",
    "explanation": "(justification + description indicator)",
    "isCharacter": false,
    "composition": [
      15666,
      ";",
      8998,
      "/",
      14382,
      "/",
      25538,
      "/",
      14947
    ]
  },
  {
    "id": "26188",
    "description": "justify-(to)",
    "pos": "RED",
    "explanation": "(justification + action indicator)",
    "isCharacter": false,
    "composition": [
      15666,
      ";",
      8993,
      "/",
      14382,
      "/",
      25538,
      "/",
      14947
    ]
  },
  {
    "id": "26189",
    "description": "language_development",
    "pos": "YELLOW",
    "explanation": "(development + language)",
    "isCharacter": false,
    "composition": [
      28012,
      "/",
      15172
    ]
  },
  {
    "id": "26190",
    "description": "lifetime,life-time,lifespan",
    "pos": "YELLOW",
    "explanation": "(time + life + all: the period during which something lives or is functional, as between birth and death)",
    "isCharacter": false,
    "composition": [
      17732,
      "/",
      15206,
      "/",
      12360
    ]
  },
  {
    "id": "26191",
    "description": "literature",
    "pos": "YELLOW",
    "explanation": "(generalization + book)",
    "isCharacter": false,
    "composition": [
      14430,
      "/",
      12875
    ]
  },
  {
    "id": "26192",
    "description": "longsightedness,farsightedness,presbyopia,hyperopia",
    "pos": "YELLOW",
    "explanation": "(limitation + eye + nearness,closeness,proximity: difficulty to see near objects)",
    "isCharacter": false,
    "composition": [
      25579,
      "/",
      14133,
      "/",
      25586
    ]
  },
  {
    "id": "26193",
    "description": "longsighted,farsighted,presbyopic,hyperopic",
    "pos": "GREEN",
    "explanation": "(presbyopia,hyperopia,farsightedness,longsightedness + description indicator)",
    "isCharacter": false,
    "composition": [
      25579,
      ";",
      8998,
      "/",
      14133,
      "/",
      25586
    ]
  },
  {
    "id": "26194",
    "description": "lynx,bobcat",
    "pos": "YELLOW",
    "explanation": "(cat + ear + hair: medium sized wild cat with usually tufted ears)",
    "isCharacter": false,
    "composition": [
      12383,
      "/",
      13894,
      "/",
      14660
    ]
  },
  {
    "id": "26195",
    "description": "make_compost-(to)",
    "pos": "RED",
    "explanation": "(compost + action indicator)",
    "isCharacter": false,
    "composition": [
      22377,
      ";",
      8993,
      "/",
      13151,
      "/",
      13901
    ]
  },
  {
    "id": "26196",
    "description": "mammal",
    "pos": "YELLOW",
    "explanation": "(animal + milk: warm-blooded vertebrate having the skin more or less covered with hair; young are born alive and nourished with milk)",
    "isCharacter": false,
    "composition": [
      12378,
      "/",
      13881,
      "/",
      15206
    ]
  },
  {
    "id": "26197",
    "description": "membrane,drumhead,drum_skin",
    "pos": "YELLOW",
    "explanation": "(drum_(1) + pointer, to the membrane of the drum skin) - Character (superimposed - pointer)",
    "isCharacter": true
  },
  {
    "id": "26198",
    "description": "mink",
    "pos": "YELLOW",
    "explanation": "(mustelid_(animal) [contraction] + fur: the mink being a mustelid animal valued for its fur)",
    "isCharacter": false,
    "composition": [
      12378,
      "/",
      17017,
      "/",
      14415
    ]
  },
  {
    "id": "26199",
    "description": "modem",
    "pos": "YELLOW",
    "explanation": "(thing + change + signal,broadcast,transmitting: a device that modulates signal transmissions between different formats)",
    "isCharacter": false,
    "composition": [
      17717,
      "/",
      13151,
      "/",
      24750
    ]
  },
  {
    "id": "26200",
    "description": "modern",
    "pos": "GREEN",
    "explanation": "(newness,novelty + intensity + description indicator: novelty with some kind of emphasis)",
    "isCharacter": false,
    "composition": [
      25587,
      ";",
      8998,
      "/",
      14947
    ]
  },
  {
    "id": "26201",
    "description": "molecule",
    "pos": "YELLOW",
    "explanation": "(group_of + atom: a group of two or more atoms held together by chemical bonds)",
    "isCharacter": false,
    "composition": [
      14647,
      "/",
      12592
    ]
  },
  {
    "id": "26202",
    "description": "mollusk(s),mollusc(s)",
    "pos": "YELLOW",
    "explanation": "(generalization + snail: invertebrate animals having a soft unsegmented body usually enclosed in a shell)",
    "isCharacter": false,
    "composition": [
      14430,
      "/",
      17188
    ]
  },
  {
    "id": "26203",
    "description": "moon_axis",
    "pos": "YELLOW",
    "explanation": "(axis + moon: the Moon's spin axis, around which it turns in about the same time that it circles the Earth)",
    "isCharacter": false,
    "composition": [
      24605,
      "/",
      15651
    ]
  },
  {
    "id": "26204",
    "description": "moon_phase,phase_of_the_moon",
    "pos": "YELLOW",
    "explanation": "(limited_time,interval,period + moon: appearances of the Moon's state of illumination)  Additional specifier can be added, such as ”full” , ”half”, ”first quarter” and ”last quarter”",
    "isCharacter": false,
    "composition": [
      15212,
      "/",
      15651
    ]
  },
  {
    "id": "26205",
    "description": "moss",
    "pos": "YELLOW",
    "explanation": "(plant + without + root(s): small flowerless, non-vascular plants, lacking proper root systems, and that usually grow in dense green clumps or mats, in damp or shady locations)",
    "isCharacter": false,
    "composition": [
      16196,
      "/",
      15474,
      "/",
      16688
    ]
  },
  {
    "id": "26206",
    "description": "mountain_range",
    "pos": "YELLOW",
    "explanation": "(group_of + mountain)",
    "isCharacter": false,
    "composition": [
      14647,
      "/",
      15663
    ]
  },
  {
    "id": "26207",
    "description": "mustelid_(animal)",
    "pos": "YELLOW",
    "explanation": "(animal + smell + intensity: family of carnivorous mammals, including the weasel, badger, etc. Mustelids are typically known for producing a strong-smelling secretion)",
    "isCharacter": false,
    "composition": [
      12378,
      "/",
      17017,
      "/",
      14947
    ]
  },
  {
    "id": "26208",
    "description": "national_park",
    "pos": "YELLOW",
    "explanation": "(park + country,state: an area of land declared by the national government to be public property)",
    "isCharacter": false,
    "composition": [
      15969,
      "/",
      13423
    ]
  },
  {
    "id": "26209",
    "description": "nearsightedness,shortsightedness,myopia",
    "pos": "YELLOW",
    "explanation": "(limitation + eye + farness,remoteness: difficulty to see distant objects)",
    "isCharacter": false,
    "composition": [
      25579,
      "/",
      14133,
      "/",
      25559
    ]
  },
  {
    "id": "26210",
    "description": "nearsighted,shortsighted,myopic",
    "pos": "GREEN",
    "explanation": "(myopia,nearsightedness,shortsightedness + description indicator)",
    "isCharacter": false,
    "composition": [
      25579,
      ";",
      8998,
      "/",
      14133,
      "/",
      25559
    ]
  },
  {
    "id": "26211",
    "description": "northeast",
    "pos": "YELLOW",
    "explanation": "(sun + pointer, to northeast) - Character (superimposed - pointer)",
    "isCharacter": true
  },
  {
    "id": "26212",
    "description": "northwest",
    "pos": "YELLOW",
    "explanation": "(sun + pointer, to northwest) - Character (superimposed - pointer)",
    "isCharacter": true
  },
  {
    "id": "26213",
    "description": "nutrient,nutrition",
    "pos": "YELLOW",
    "explanation": "(substance + giving + health)",
    "isCharacter": false,
    "composition": [
      24515,
      "/",
      24903,
      "/",
      14690
    ]
  },
  {
    "id": "26214",
    "description": "omnivore",
    "pos": "YELLOW",
    "explanation": "(animal + food + animal + plant: an animal or person that feeds on both animal and vegetable food)",
    "isCharacter": false,
    "composition": [
      12378,
      "/",
      14377,
      "/",
      12378,
      "/",
      16196
    ]
  },
  {
    "id": "26215",
    "description": "once_upon_a_time",
    "pos": "WHITE",
    "explanation": "(1 + time + past)",
    "isCharacter": false,
    "composition": [
      8497,
      "/",
      17732,
      "/",
      "RK:-2",
      "/",
      15975
    ]
  },
  {
    "id": "26216",
    "description": "online_game,multiplayer_game,network_game",
    "pos": "YELLOW",
    "explanation": "(digital_game,video_game + internet_(1) [contraction])",
    "isCharacter": false,
    "composition": [
      12335,
      "/",
      "RK:-2",
      "/",
      14164,
      "/",
      23476,
      "/",
      13365
    ]
  },
  {
    "id": "26217",
    "description": "orbit_of_the_moon",
    "pos": "YELLOW",
    "explanation": "(orbit + moon)",
    "isCharacter": false,
    "composition": [
      24249,
      "/",
      "RK:-2",
      "/",
      15651
    ]
  },
  {
    "id": "26218",
    "description": "period_of_life",
    "pos": "YELLOW",
    "explanation": "(limited_time,period + life)",
    "isCharacter": false,
    "composition": [
      15212,
      "/",
      15206
    ]
  },
  {
    "id": "26219",
    "description": "pinch,pincer_grip",
    "pos": "YELLOW",
    "explanation": "(finger + pliers: a grip with the fingers, as if with pliers or pincer)",
    "isCharacter": false,
    "composition": [
      14180,
      "/",
      16205
    ]
  },
  {
    "id": "26220",
    "description": "pinch,pluck,tweeze-(to)",
    "pos": "RED",
    "explanation": "(pinch,pincer_grip + action indicator)",
    "isCharacter": false,
    "composition": [
      14180,
      ";",
      8993,
      "/",
      16205
    ]
  },
  {
    "id": "26221",
    "description": "plant-book,dictionary_of_plants",
    "pos": "YELLOW",
    "explanation": "(book + plant)",
    "isCharacter": false,
    "composition": [
      12875,
      "/",
      16196
    ]
  },
  {
    "id": "26222",
    "description": "plastic_bag",
    "pos": "YELLOW",
    "explanation": "(sack,bag + material + chemical_product [contraction of plastic])",
    "isCharacter": false,
    "composition": [
      16701,
      "/",
      15431,
      "/",
      13158
    ]
  },
  {
    "id": "26223",
    "description": "plough_(ancient),ard,ard_plough,scratch_plough",
    "pos": "YELLOW",
    "explanation": "(plough + past: ancient plough)",
    "isCharacter": false,
    "composition": [
      16206,
      "/",
      15975
    ]
  },
  {
    "id": "26224",
    "description": "practice,drill,exercise,rehearsal",
    "pos": "YELLOW",
    "explanation": "(work + repetition: work at something repeatedly to develop skill)",
    "isCharacter": false,
    "composition": [
      18273,
      "/",
      24934
    ]
  },
  {
    "id": "26225",
    "description": "recycling_station",
    "pos": "YELLOW",
    "explanation": "(place + waste_sorting,garbage_sorting)",
    "isCharacter": false,
    "composition": [
      16193,
      "/",
      17961,
      "/",
      18043
    ]
  },
  {
    "id": "26226",
    "description": "referee,judge_(sport)",
    "pos": "BLUE",
    "explanation": "(person + decision + sport)",
    "isCharacter": false,
    "composition": [
      16161,
      "/",
      13649,
      "/",
      20518
    ]
  },
  {
    "id": "26227",
    "description": "referee_(football,soccer)",
    "pos": "BLUE",
    "explanation": "(person + decision + football,soccer_(sport) [contraction])",
    "isCharacter": false,
    "composition": [
      16161,
      "/",
      13649,
      "/",
      12621,
      "/",
      15189
    ]
  },
  {
    "id": "26228",
    "description": "reuse,recycling",
    "pos": "YELLOW",
    "explanation": "(usage,use + again)",
    "isCharacter": false,
    "composition": [
      24847,
      "/",
      12350
    ]
  },
  {
    "id": "26229",
    "description": "reuse,use_again,recycle-(to)",
    "pos": "RED",
    "explanation": "(reuse,recycling + action indicator)",
    "isCharacter": false,
    "composition": [
      24847,
      ";",
      8993,
      "/",
      12350
    ]
  },
  {
    "id": "26230",
    "description": "rot,decompose-(to)",
    "pos": "RED",
    "explanation": "(rot,decomposition,rotting_matter + action indicator + thing indicator)",
    "isCharacter": false,
    "composition": [
      13151,
      ";",
      8993,
      "/",
      24443,
      ";",
      9009,
      "/",
      24883
    ]
  },
  {
    "id": "26231",
    "description": "rot,decomposition,rotting_matter",
    "pos": "YELLOW",
    "explanation": "(change,alteration,conversion + organism + deletion,cancellation,destruction + thing indicator: the decomposing change of organic material performed by organisms, primarily micro-organisms, breaking it down)",
    "isCharacter": false,
    "composition": [
      13151,
      "/",
      24443,
      ";",
      9009,
      "/",
      24883
    ]
  },
  {
    "id": "26232",
    "description": "rotten,decomposed",
    "pos": "GREEN",
    "explanation": "(rot,decomposition,rotting_matter + description indicator + thing indicator)",
    "isCharacter": false,
    "composition": [
      13151,
      ";",
      8998,
      "/",
      24443,
      ";",
      9009,
      "/",
      24883
    ]
  },
  {
    "id": "26233",
    "description": "router",
    "pos": "YELLOW",
    "explanation": "(connector,interface_box + signal,broadcast,transmitting + thing indicator: a networking device that forwards data packets between computer networks)",
    "isCharacter": false,
    "composition": [
      14952,
      ";",
      9009,
      "/",
      23476,
      "/",
      24750
    ]
  },
  {
    "id": "26234",
    "description": "run,jog",
    "pos": "YELLOW",
    "explanation": "(activity + run)",
    "isCharacter": false,
    "composition": [
      12335,
      "/",
      15189,
      "/",
      14390,
      "/",
      14947
    ]
  },
  {
    "id": "26235",
    "description": "salt",
    "pos": "YELLOW",
    "explanation": "(flavouring,condiment,seasoning + salt_crystal [contraction])  Preferred NEW SYNONYM, replacing 20523",
    "isCharacter": false,
    "composition": [
      12339,
      ";",
      9009,
      "/",
      17506,
      "/",
      13619
    ]
  },
  {
    "id": "26236",
    "description": "saltwater,seawater",
    "pos": "YELLOW",
    "explanation": "(water + salt_crystal [contraction]: water containing salts)",
    "isCharacter": false,
    "composition": [
      18209,
      "/",
      13619
    ]
  },
  {
    "id": "26237",
    "description": "salty",
    "pos": "GREEN",
    "explanation": "(taste + salt_crystal [contraction] + description indicator)  Preferred NEW SYNONYM, replacing 16712",
    "isCharacter": false,
    "composition": [
      17506,
      ";",
      8998,
      "/",
      13619
    ]
  },
  {
    "id": "26238",
    "description": "scavenger,carrion_eater",
    "pos": "YELLOW",
    "explanation": "(animal + food + dead: animals that feed on carrion and other dead organisms)",
    "isCharacter": false,
    "composition": [
      12378,
      "/",
      14377,
      "/",
      13645
    ]
  },
  {
    "id": "26239",
    "description": "school_year",
    "pos": "YELLOW",
    "explanation": "(year + school_(in_combinations))",
    "isCharacter": false,
    "composition": [
      18289,
      "/",
      "RK:-2",
      "/",
      14905,
      "/",
      15162
    ]
  },
  {
    "id": "26240",
    "description": "selfie",
    "pos": "YELLOW",
    "explanation": "(photograph,photo,pic + self: photo taken on oneself)",
    "isCharacter": false,
    "composition": [
      15962,
      "/",
      13111,
      "/",
      8497,
      "/",
      15214
    ]
  },
  {
    "id": "26241",
    "description": "server,host_(computer)",
    "pos": "YELLOW",
    "explanation": "(computer + combination,connection: a computer that provides client stations with access to programs, files, printers etc. as shared resources in a computer network)",
    "isCharacter": false,
    "composition": [
      15406,
      "/",
      23476,
      "/",
      13380
    ]
  },
  {
    "id": "26242",
    "description": "sloping,sloped,slanting,slanted",
    "pos": "GREEN",
    "explanation": "(downward_and_forward + description indicator)",
    "isCharacter": false,
    "composition": [
      13871,
      ";",
      8998
    ]
  },
  {
    "id": "26243",
    "description": "sort,differentiate,separate,classify-(to)",
    "pos": "RED",
    "explanation": "(type,kind,sort,category + action indicator)",
    "isCharacter": false,
    "composition": [
      17961,
      ";",
      8993
    ]
  },
  {
    "id": "26244",
    "description": "sort_garbage,separate_waste-(to)",
    "pos": "RED",
    "explanation": "(waste_sorting + action indicator)",
    "isCharacter": false,
    "composition": [
      17961,
      ";",
      8993,
      "/",
      18043
    ]
  },
  {
    "id": "26245",
    "description": "southeast",
    "pos": "YELLOW",
    "explanation": "(sun + pointer, to southeast) - Character (superimposed - pointer)",
    "isCharacter": true
  },
  {
    "id": "26246",
    "description": "southwest",
    "pos": "YELLOW",
    "explanation": "(sun + pointer, to southwest) - Character (superimposed - pointer)",
    "isCharacter": true
  },
  {
    "id": "26247",
    "description": "spine,backbone",
    "pos": "YELLOW",
    "explanation": "(bone + back_(body))",
    "isCharacter": false,
    "composition": [
      12873,
      "/",
      12609
    ]
  },
  {
    "id": "26248",
    "description": "steep",
    "pos": "GREEN",
    "explanation": "(sloping,sloped,slanting,slanted + intensity + description indicator)",
    "isCharacter": false,
    "composition": [
      13871,
      ";",
      8998,
      "/",
      14947
    ]
  },
  {
    "id": "26249",
    "description": "stream_(digital),data_stream",
    "pos": "YELLOW",
    "explanation": "(river,stream,current + digits_(computer): a stream of digital data)",
    "isCharacter": false,
    "composition": [
      16677,
      "/",
      23476
    ]
  },
  {
    "id": "26250",
    "description": "stream_(digital_data)-(to)",
    "pos": "RED",
    "explanation": "(stream_(digital),data_stream + action indicator: to stream digital data, typically media content over the internet)",
    "isCharacter": false,
    "composition": [
      16677,
      ";",
      8993,
      "/",
      23476
    ]
  },
  {
    "id": "26251",
    "description": "streamed,streaming_(digital_data)",
    "pos": "GREEN",
    "explanation": "(stream_(digital),data_stream + description indicator: digital data, typically media content, streaming over the internet)",
    "isCharacter": false,
    "composition": [
      16677,
      ";",
      8998,
      "/",
      23476
    ]
  },
  {
    "id": "26252",
    "description": "sweaty,sweating,perspiring",
    "pos": "GREEN",
    "explanation": "(sweat,perspiration + description indicator)",
    "isCharacter": false,
    "composition": [
      18209,
      ";",
      8998,
      "/",
      16420,
      "/",
      12870
    ]
  },
  {
    "id": "26253",
    "description": "term,semester",
    "pos": "YELLOW",
    "explanation": "(season + school_(in_combinations))",
    "isCharacter": false,
    "composition": [
      15972,
      "/",
      18289,
      "/",
      "RK:-2",
      "/",
      14905,
      "/",
      15162
    ]
  },
  {
    "id": "26254",
    "description": "umami",
    "pos": "YELLOW",
    "explanation": "(taste + seaweed: one of the five basic tastes (together with sweetness, sourness, bitterness, and saltiness) first identified in Japan from kombu seaweed)",
    "isCharacter": false,
    "composition": [
      17506,
      "/",
      23658
    ]
  },
  {
    "id": "26255",
    "description": "umami_tasting",
    "pos": "GREEN",
    "explanation": "(umami + description indicator)",
    "isCharacter": false,
    "composition": [
      17506,
      ";",
      8998,
      "/",
      23658
    ]
  },
  {
    "id": "26256",
    "description": "unfinished",
    "pos": "GREEN",
    "explanation": "(without + finished,complete,completed + description indicator)",
    "isCharacter": false,
    "composition": [
      15474,
      "/",
      12335,
      ";",
      8998,
      "/",
      12360
    ]
  },
  {
    "id": "26257",
    "description": "unicycle,monocycle,one-wheeled_vehicle",
    "pos": "YELLOW",
    "explanation": "(1 + wheel: one wheeled vehicle)",
    "isCharacter": false,
    "composition": [
      8497,
      "/",
      18232
    ]
  },
  {
    "id": "26258",
    "description": "unicycle,ride_a_one-wheeled_vehicle-(to)",
    "pos": "RED",
    "explanation": "(unicycle,monocycle,one-wheeled_vehicle + action indicator)",
    "isCharacter": false,
    "composition": [
      8497,
      "/",
      18232,
      ";",
      8993
    ]
  },
  {
    "id": "26259",
    "description": "untrue,false",
    "pos": "GREEN",
    "explanation": "(untruth,falsity,falsehood + description indicator)",
    "isCharacter": false,
    "composition": [
      15474,
      "/",
      17786,
      ";",
      8998
    ]
  },
  {
    "id": "26260",
    "description": "untruth,falsity,falsehood",
    "pos": "YELLOW",
    "explanation": "(without + truth)",
    "isCharacter": false,
    "composition": [
      15474,
      "/",
      17786
    ]
  },
  {
    "id": "26261",
    "description": "upload",
    "pos": "YELLOW",
    "explanation": "(giving,gift + digits_(computer): the sharing of digital data to a server on the internet)",
    "isCharacter": false,
    "composition": [
      24903,
      "/",
      23476
    ]
  },
  {
    "id": "26262",
    "description": "upload-(to)",
    "pos": "RED",
    "explanation": "(upload + action indicator)",
    "isCharacter": false,
    "composition": [
      24903,
      ";",
      8993,
      "/",
      23476
    ]
  },
  {
    "id": "26263",
    "description": "walk,walking",
    "pos": "YELLOW",
    "explanation": "(activity + legs_and_feet: the act of walking (somewhere))",
    "isCharacter": false,
    "composition": [
      12335,
      "/",
      15189
    ]
  },
  {
    "id": "26264",
    "description": "waste_sorting,garbage_sorting,source_separation_(of_waste)",
    "pos": "YELLOW",
    "explanation": "(type,kind,sort,category + waste,garbage,rubbish,trash: separation of different kinds of waste for recycling)",
    "isCharacter": false,
    "composition": [
      17961,
      "/",
      18043
    ]
  },
  {
    "id": "26265",
    "description": "vertebrate",
    "pos": "YELLOW",
    "explanation": "(animal + spine,backbone: animals with a backbone or spinal column)",
    "isCharacter": false,
    "composition": [
      12378,
      "/",
      12873,
      "/",
      12609
    ]
  },
  {
    "id": "26266",
    "description": "visible,sighted",
    "pos": "GREEN",
    "explanation": "(eye + description indicator)",
    "isCharacter": false,
    "composition": [
      14133,
      ";",
      8998
    ]
  },
  {
    "id": "26267",
    "description": "X-ray",
    "pos": "YELLOW",
    "explanation": "(light + through + thing: shortwave radiation passing through otherwise non-transparent things, used in medical diagnosis etc.)",
    "isCharacter": false,
    "composition": [
      15208,
      "/",
      17724,
      "/",
      17717
    ]
  },
  {
    "id": "26268",
    "description": "X-ray-(to)",
    "pos": "RED",
    "explanation": "(X-ray + action indicator)",
    "isCharacter": false,
    "composition": [
      15208,
      ";",
      8993,
      "/",
      17724,
      "/",
      17717
    ]
  },
  {
    "id": "26280",
    "description": "accept-(to)",
    "pos": "RED",
    "explanation": "(get + mind + action indicator: to receive reasons)",
    "isCharacter": false,
    "composition": [
      24727,
      ";",
      8993,
      "/",
      15471
    ]
  },
  {
    "id": "26281",
    "description": "audio_book",
    "pos": "YELLOW",
    "explanation": "(book + sound)",
    "isCharacter": false,
    "composition": [
      12875,
      "/",
      17216
    ]
  },
  {
    "id": "26282",
    "description": "brace(s)_(dental),dental_brace(s)_(medical)",
    "pos": "YELLOW",
    "explanation": "(medical aid + teeth)",
    "isCharacter": false,
    "composition": [
      14704,
      ";",
      9009,
      "/",
      24920,
      "/",
      17517
    ]
  },
  {
    "id": "26283",
    "description": "brace(s)_(dental),dental_brace(s)",
    "pos": "YELLOW",
    "explanation": "(aid + teeth + line: help to set the teeth in a row)",
    "isCharacter": false,
    "composition": [
      14704,
      ";",
      9009,
      "/",
      17517,
      "/",
      15214
    ]
  },
  {
    "id": "26284",
    "description": "brace_(neck,medical),neck_brace,cervical_collar,neck_collar",
    "pos": "YELLOW",
    "explanation": "(medical aid + neck)",
    "isCharacter": false,
    "composition": [
      14704,
      ";",
      9009,
      "/",
      24920,
      "/",
      15700
    ]
  },
  {
    "id": "26285",
    "description": "brain_injury",
    "pos": "YELLOW",
    "explanation": "(damage + brain)",
    "isCharacter": false,
    "composition": [
      24852,
      "/",
      15471,
      ";",
      9009
    ]
  },
  {
    "id": "26286",
    "description": "cape,poncho,clothing_without_sleeves",
    "pos": "YELLOW",
    "explanation": "(clothes + without + sleeve [contraction])",
    "isCharacter": false,
    "composition": [
      13366,
      "/",
      15474,
      "/",
      12577
    ]
  },
  {
    "id": "26287",
    "description": "chopstick(s)",
    "pos": "YELLOW",
    "explanation": "(two + linear thing + food: tools for eating food)",
    "isCharacter": false,
    "composition": [
      8498,
      "/",
      15214,
      ";",
      9009,
      "/",
      14377
    ]
  },
  {
    "id": "26288",
    "description": "CNS_injury",
    "pos": "YELLOW",
    "explanation": "(damage + central nervous system)",
    "isCharacter": false,
    "composition": [
      24852,
      "/",
      25434,
      ";",
      9009
    ]
  },
  {
    "id": "26289",
    "description": "consciousness,awareness",
    "pos": "YELLOW",
    "explanation": "(mind + activity: an alert cognitive state in which you are aware)",
    "isCharacter": false,
    "composition": [
      15471,
      "/",
      12335
    ]
  },
  {
    "id": "26290",
    "description": "cooking_vessel,pots_and_pans",
    "pos": "YELLOW",
    "explanation": "(generalization + pan: all kinds of cooking pans in a kitchen)",
    "isCharacter": false,
    "composition": [
      14430,
      "/",
      22584
    ]
  },
  {
    "id": "26291",
    "description": "critic,evaluator",
    "pos": "BLUE",
    "explanation": "(person + evaluate: a person that evaluates things e.g. best restaurant or best film",
    "isCharacter": false,
    "composition": [
      16161,
      "/",
      13949
    ]
  },
  {
    "id": "26292",
    "description": "dental_floss",
    "pos": "YELLOW",
    "explanation": "(fibre + teeth: a string for cleaning between the teeth)",
    "isCharacter": false,
    "composition": [
      25878,
      "/",
      17517
    ]
  },
  {
    "id": "26293",
    "description": "diagnosis_(medical)",
    "pos": "YELLOW",
    "explanation": "(outcome + evaluation + medical)",
    "isCharacter": false,
    "composition": [
      13910,
      "/",
      12335,
      "/",
      "RK:-2",
      "/",
      13949,
      "/",
      24920
    ]
  },
  {
    "id": "26294",
    "description": "disappointed",
    "pos": "GREEN",
    "explanation": "(disappointment + description after the fact indicator)",
    "isCharacter": false,
    "composition": [
      14164,
      ";",
      8996,
      "/",
      13869,
      "/",
      12348,
      "/",
      24833
    ]
  },
  {
    "id": "26295",
    "description": "disappointing",
    "pos": "GREEN",
    "explanation": "(disappointment + description indicator)",
    "isCharacter": false,
    "composition": [
      14164,
      ";",
      8998,
      "/",
      13869,
      "/",
      12348,
      "/",
      24833
    ]
  },
  {
    "id": "26296",
    "description": "disappointment",
    "pos": "YELLOW",
    "explanation": "(sadness + after + desire)",
    "isCharacter": false,
    "composition": [
      14164,
      "/",
      13869,
      "/",
      12348,
      "/",
      24833
    ]
  },
  {
    "id": "26297",
    "description": "dyscalculia",
    "pos": "YELLOW",
    "explanation": "(limitation + mathematics [contraction]: limited ability in mathematics)",
    "isCharacter": false,
    "composition": [
      25579,
      "/",
      15742
    ]
  },
  {
    "id": "26298",
    "description": "dysgraphia",
    "pos": "YELLOW",
    "explanation": "(limitation + writing; limited ability to learn to write)",
    "isCharacter": false,
    "composition": [
      25579,
      "/",
      15991
    ]
  },
  {
    "id": "26299",
    "description": "dyslexia",
    "pos": "YELLOW",
    "explanation": "(limitation + reading: limited ability to learn to read)",
    "isCharacter": false,
    "composition": [
      25579,
      "/",
      14133,
      "/",
      15962
    ]
  },
  {
    "id": "26300",
    "description": "dystonia",
    "pos": "YELLOW",
    "explanation": "(activity + muscle + up and down; neurological movement disorder with sustained or repetitive muscle contractions)",
    "isCharacter": false,
    "composition": [
      12335,
      "/",
      20517,
      "/",
      20524
    ]
  },
  {
    "id": "26301",
    "description": "e-book,digital_book",
    "pos": "YELLOW",
    "explanation": "(book + digits)",
    "isCharacter": false,
    "composition": [
      12875,
      "/",
      23476
    ]
  },
  {
    "id": "26302",
    "description": "egg_white,white_of_egg,albumin,glair",
    "pos": "YELLOW",
    "explanation": "(part of egg [contraction] + white: the albumin surrounding the yolk)",
    "isCharacter": false,
    "composition": [
      13912,
      "/",
      13377,
      "/",
      17192
    ]
  },
  {
    "id": "26303",
    "description": "egg_yolk,yolk",
    "pos": "YELLOW",
    "explanation": "(part of egg [contraction] + yellow: the center part of an egg,)",
    "isCharacter": false,
    "composition": [
      13912,
      "/",
      13377,
      "/",
      17462
    ]
  },
  {
    "id": "26304",
    "description": "eggshell",
    "pos": "YELLOW",
    "explanation": "(shell + egg: the shell of an egg)",
    "isCharacter": false,
    "composition": [
      16954,
      "/",
      13912
    ]
  },
  {
    "id": "26305",
    "description": "faint,pass_out-(to)",
    "pos": "RED",
    "explanation": "(fainting + action indicator)",
    "isCharacter": false,
    "composition": [
      15471,
      ";",
      8993,
      "/",
      15474,
      "/",
      12335,
      "/",
      15212
    ]
  },
  {
    "id": "26306",
    "description": "fainting,absence",
    "pos": "YELLOW",
    "explanation": "(mind + without + activity + limited time: a spontaneous loss of consciousness for a limited period of time)",
    "isCharacter": false,
    "composition": [
      15471,
      "/",
      15474,
      "/",
      12335,
      "/",
      15212
    ]
  },
  {
    "id": "26307",
    "description": "hair_accessory",
    "pos": "YELLOW",
    "explanation": "(thing + hair + together)",
    "isCharacter": false,
    "composition": [
      17717,
      "/",
      14661,
      "/",
      23409
    ]
  },
  {
    "id": "26308",
    "description": "hair_pin,bobby_pin",
    "pos": "YELLOW",
    "explanation": "(thing + hair + linear thing)",
    "isCharacter": false,
    "composition": [
      17717,
      "/",
      14661,
      "/",
      "RK:1",
      "/",
      15214,
      ";",
      9009
    ]
  },
  {
    "id": "26309",
    "description": "hair_tie",
    "pos": "YELLOW",
    "explanation": "(thing + hair + ring)",
    "isCharacter": false,
    "composition": [
      17717,
      "/",
      14661,
      "/",
      16675
    ]
  },
  {
    "id": "26310",
    "description": "hygiene",
    "pos": "YELLOW",
    "explanation": "(activity + protection + health: activity concerned with the maintenance of health)",
    "isCharacter": false,
    "composition": [
      12335,
      "/",
      16420,
      "/",
      14690
    ]
  },
  {
    "id": "26311",
    "description": "hygiene_(personal)",
    "pos": "YELLOW",
    "explanation": "(activity + protection + health + person: activity concerned with the maintenance of personal health)",
    "isCharacter": false,
    "composition": [
      12335,
      "/",
      16420,
      "/",
      14690,
      "/",
      16161
    ]
  },
  {
    "id": "26312",
    "description": "interdental_brush,interdental_rager",
    "pos": "YELLOW",
    "explanation": "(brush + teeth + between: a small brush made for cleaning between the teeth)",
    "isCharacter": false,
    "composition": [
      12912,
      "/",
      17517,
      "/",
      12669
    ]
  },
  {
    "id": "26313",
    "description": "karate",
    "pos": "YELLOW",
    "explanation": "(martial arts + kick [contraction]): martial art including fight with hands and feet)",
    "isCharacter": false,
    "composition": [
      20518,
      "/",
      24855,
      "/",
      13902,
      "/",
      25578
    ]
  },
  {
    "id": "26314",
    "description": "knitting_needle(s)",
    "pos": "YELLOW",
    "explanation": "(two + linear thing + cloth: needles used for knitting)",
    "isCharacter": false,
    "composition": [
      8498,
      "/",
      15214,
      ";",
      9009,
      "/",
      13365
    ]
  },
  {
    "id": "26315",
    "description": "leftovers,left_overs,food_waste_(food_thrown_away)",
    "pos": "YELLOW",
    "explanation": "(food + waste: the leftovers of food that is thrown away)",
    "isCharacter": false,
    "composition": [
      14377,
      "/",
      18043
    ]
  },
  {
    "id": "26316",
    "description": "leftovers,left_overs_(food_used_again)",
    "pos": "YELLOW",
    "explanation": "(food + again: leftovers of food that is served again)",
    "isCharacter": false,
    "composition": [
      14377,
      "/",
      12350
    ]
  },
  {
    "id": "26317",
    "description": "mathematical_difficulty",
    "pos": "YELLOW",
    "explanation": "(difficulty + mathematics [contraction)]: difficulties with mathematics)",
    "isCharacter": false,
    "composition": [
      24884,
      "/",
      15742
    ]
  },
  {
    "id": "26318",
    "description": "moustache",
    "pos": "YELLOW",
    "explanation": "(hair + mouth + pointer to the upper lip)",
    "isCharacter": false,
    "composition": [
      14660,
      "/",
      80004
    ]
  },
  {
    "id": "26319",
    "description": "movie,action_film,action_movie,film_(action)",
    "pos": "YELLOW",
    "explanation": "(movie + activity + fast, quick)",
    "isCharacter": false,
    "composition": [
      13115,
      "/",
      16254,
      "/",
      12335,
      "/",
      "RK:-2",
      "/",
      14390,
      "/",
      14947
    ]
  },
  {
    "id": "26320",
    "description": "movie,romance_movie,romance_film,film_(romantic)",
    "pos": "YELLOW",
    "explanation": "(movie + love)",
    "isCharacter": false,
    "composition": [
      13115,
      "/",
      16254,
      "/",
      15399
    ]
  },
  {
    "id": "26321",
    "description": "neurological",
    "pos": "GREEN",
    "explanation": "(neuron + description indicator)",
    "isCharacter": false,
    "composition": [
      21540,
      ";",
      8998,
      "/",
      13918
    ]
  },
  {
    "id": "26322",
    "description": "paralysis,palsy",
    "pos": "YELLOW",
    "explanation": "(limitation + activity + muscle: a limited ability or loss of a voluntary muscle function)",
    "isCharacter": false,
    "composition": [
      25579,
      "/",
      12335,
      "/",
      20517
    ]
  },
  {
    "id": "26323",
    "description": "pate,crown_(body_part)",
    "pos": "YELLOW",
    "explanation": "(head + pointer to the top of the head) - Character (superimposed - pointer)",
    "isCharacter": true
  },
  {
    "id": "26324",
    "description": "privy,outhouse",
    "pos": "YELLOW",
    "explanation": "(place + bowel movement: a place where a user can defecate)",
    "isCharacter": false,
    "composition": [
      16193,
      "/",
      18043,
      "/",
      13097
    ]
  },
  {
    "id": "26325",
    "description": "reading_difficulty",
    "pos": "YELLOW",
    "explanation": "(difficulty + reading: difficulties with reading)",
    "isCharacter": false,
    "composition": [
      24884,
      "/",
      14133,
      "/",
      15962
    ]
  },
  {
    "id": "26326",
    "description": "realize,realise-(to)",
    "pos": "RED",
    "explanation": "(understand + suddenly [contraction] + action indicator",
    "isCharacter": false,
    "composition": [
      25629,
      ";",
      8993,
      "/",
      15209
    ]
  },
  {
    "id": "26327",
    "description": "record_(achievement)",
    "pos": "YELLOW",
    "explanation": "(outcome + most: the extreme outcome)",
    "isCharacter": false,
    "composition": [
      13910,
      "/",
      12335,
      "/",
      24944
    ]
  },
  {
    "id": "26328",
    "description": "regain,recover,retrieve-(to)",
    "pos": "RED",
    "explanation": "(get + again: get or find back)",
    "isCharacter": false,
    "composition": [
      24727,
      ";",
      8993,
      "/",
      12350
    ]
  },
  {
    "id": "26329",
    "description": "sleeve(s)",
    "pos": "YELLOW",
    "explanation": "(clothes + arm)",
    "isCharacter": false,
    "composition": [
      13366,
      "/",
      12577
    ]
  },
  {
    "id": "26330",
    "description": "suspender(s)",
    "pos": "YELLOW",
    "explanation": "(linear thing + up + clothes)",
    "isCharacter": false,
    "composition": [
      15214,
      ";",
      9009,
      "/",
      17983,
      "/",
      13366
    ]
  },
  {
    "id": "26332",
    "description": "tremor,shudder",
    "pos": "YELLOW",
    "explanation": "(activity + muscle + back and forth: an involuntary vibration)",
    "isCharacter": false,
    "composition": [
      12335,
      "/",
      20517,
      "/",
      12610
    ]
  },
  {
    "id": "26333",
    "description": "unconscious,comatose",
    "pos": "GREEN",
    "explanation": "(unconsciousness + description indicator)",
    "isCharacter": false,
    "composition": [
      15471,
      ";",
      8998,
      "/",
      15474,
      "/",
      "RK:-2",
      "/",
      12335
    ]
  },
  {
    "id": "26334",
    "description": "unconsciousness,coma,comatoseness",
    "pos": "YELLOW",
    "explanation": "(mind + without + activity: a state of lacking awareness, sometimes deep and prolonged unconsciousness)",
    "isCharacter": false,
    "composition": [
      15471,
      "/",
      15474,
      "/",
      "RK:-2",
      "/",
      12335
    ]
  },
  {
    "id": "26335",
    "description": "vegetarian_(food)",
    "pos": "GREEN",
    "explanation": "(food + plant + description indicator)",
    "isCharacter": false,
    "composition": [
      14377,
      ";",
      8998,
      "/",
      16196
    ]
  },
  {
    "id": "26336",
    "description": "vegetarian_(person)",
    "pos": "BLUE",
    "explanation": "(person + food + plant: a person who eats plants and not any meat)",
    "isCharacter": false,
    "composition": [
      16161,
      "/",
      14377,
      "/",
      16196
    ]
  },
  {
    "id": "26337",
    "description": "wonder,inquire,enquire,be_curious-(to)",
    "pos": "RED",
    "explanation": "(curiosity + action indicator)",
    "isCharacter": false,
    "composition": [
      24833,
      ";",
      8993,
      "/",
      15162
    ]
  },
  {
    "id": "26338",
    "description": "writing_difficulty",
    "pos": "YELLOW",
    "explanation": "(difficulty + writing: difficulties with writing)",
    "isCharacter": false,
    "composition": [
      24884,
      "/",
      15991
    ]
  },
  {
    "id": "26339",
    "description": "yarn",
    "pos": "YELLOW",
    "explanation": "(thread + fabric: thread used in sewing, knitting and weaving)",
    "isCharacter": false,
    "composition": [
      14647,
      "/",
      25878,
      "/",
      13365
    ]
  },
  {
    "id": "27001",
    "description": "abstract",
    "pos": "GREEN",
    "explanation": "(concept + description indicator)",
    "isCharacter": false,
    "composition": [
      27026,
      ";",
      8998
    ]
  },
  {
    "id": "27002",
    "description": "adjective",
    "pos": "YELLOW",
    "explanation": "(word + evaluation: evaluation words)",
    "isCharacter": false,
    "composition": [
      15972,
      "/",
      15172,
      "/",
      13949
    ]
  },
  {
    "id": "27003",
    "description": "adverb",
    "pos": "YELLOW",
    "explanation": "(word + evaluation + action)",
    "isCharacter": false,
    "composition": [
      15972,
      "/",
      15172,
      "/",
      13949,
      "/",
      "RK:-2",
      "/",
      12334
    ]
  },
  {
    "id": "27004",
    "description": "affix",
    "pos": "YELLOW",
    "explanation": "(unit + together + language)",
    "isCharacter": false,
    "composition": [
      8497,
      ";",
      9009,
      "/",
      23409,
      "/",
      15172
    ]
  },
  {
    "id": "27005",
    "description": "alive",
    "pos": "GREEN",
    "explanation": "(life + description indicator)",
    "isCharacter": false,
    "composition": [
      15206,
      ";",
      8998
    ]
  },
  {
    "id": "27006",
    "description": "aluminium_foil,tin_foil",
    "pos": "YELLOW",
    "explanation": "(wrapping + metal [contraction])",
    "isCharacter": false,
    "composition": [
      25616,
      ";",
      9009,
      "/",
      23150
    ]
  },
  {
    "id": "27007",
    "description": "anaesthesia,numbness",
    "pos": "YELLOW",
    "explanation": "(without + feeling: loss of feeling)",
    "isCharacter": false,
    "composition": [
      15474,
      "/",
      14164
    ]
  },
  {
    "id": "27008",
    "description": "anaesthetic",
    "pos": "YELLOW",
    "explanation": "(medication + end + feeling)",
    "isCharacter": false,
    "composition": [
      13158,
      "/",
      24920,
      "/",
      13935,
      "/",
      14164
    ]
  },
  {
    "id": "27009",
    "description": "article",
    "pos": "YELLOW",
    "explanation": "(part + language + the)",
    "isCharacter": false,
    "composition": [
      15972,
      "/",
      15172,
      "/",
      17700
    ]
  },
  {
    "id": "27010",
    "description": "beside",
    "pos": "WHITE",
    "explanation": "(linear + after,behind ) - Character (sequenced)",
    "isCharacter": true
  },
  {
    "id": "27011",
    "description": "bite",
    "pos": "YELLOW",
    "explanation": "(effect + to bite: effect of being bitten)",
    "isCharacter": false,
    "composition": [
      13910,
      "/",
      17517
    ]
  },
  {
    "id": "27012",
    "description": "blood_circulation",
    "pos": "YELLOW",
    "explanation": "(circulation + blood)",
    "isCharacter": false,
    "composition": [
      24249,
      "/",
      18209,
      "/",
      15206
    ]
  },
  {
    "id": "27013",
    "description": "blood_pressure",
    "pos": "YELLOW",
    "explanation": "(pressure + blood)",
    "isCharacter": false,
    "composition": [
      23169,
      "/",
      18209,
      "/",
      15206
    ]
  },
  {
    "id": "27014",
    "description": "bone_fracture",
    "pos": "YELLOW",
    "explanation": "(fracture + bone)",
    "isCharacter": false,
    "composition": [
      24852,
      "/",
      12873
    ]
  },
  {
    "id": "27015",
    "description": "bored",
    "pos": "GREEN",
    "explanation": "(boring + description after the fact indicator)",
    "isCharacter": false,
    "composition": [
      14164,
      ";",
      8996,
      "/",
      13869,
      "/",
      15666
    ]
  },
  {
    "id": "27016",
    "description": "burned_out,burnt_out",
    "pos": "GREEN",
    "explanation": "(sickness + without + energy_(mental) [contraction] + description indicator)",
    "isCharacter": false,
    "composition": [
      16164,
      ";",
      8998,
      "/",
      15474,
      "/",
      13918
    ]
  },
  {
    "id": "27017",
    "description": "cactus_fruit_(dragon_fruit,cherimoya)",
    "pos": "YELLOW",
    "explanation": "(fruit + cactus)",
    "isCharacter": false,
    "composition": [
      14405,
      "/",
      16196,
      "/",
      23627
    ]
  },
  {
    "id": "27018",
    "description": "candy_(liquorice)",
    "pos": "YELLOW",
    "explanation": "(candy + roots)",
    "isCharacter": false,
    "composition": [
      22375,
      "/",
      16688
    ]
  },
  {
    "id": "27019",
    "description": "cannabis",
    "pos": "YELLOW",
    "explanation": "(leaf + medical + star)",
    "isCharacter": false,
    "composition": [
      15183,
      "/",
      24920,
      "/",
      17252
    ]
  },
  {
    "id": "27020",
    "description": "car_light(s)",
    "pos": "YELLOW",
    "explanation": "(lamp + car)",
    "isCharacter": false,
    "composition": [
      15208,
      ";",
      9009,
      "/",
      13121
    ]
  },
  {
    "id": "27021",
    "description": "cardiac_arrest",
    "pos": "YELLOW",
    "explanation": "(stop + heart: stop of the heart)",
    "isCharacter": false,
    "composition": [
      13935,
      "/",
      14164,
      ";",
      9009
    ]
  },
  {
    "id": "27022",
    "description": "children's_rights",
    "pos": "YELLOW",
    "explanation": "(right + child)",
    "isCharacter": false,
    "composition": [
      16420,
      "/",
      14396,
      "/",
      13166
    ]
  },
  {
    "id": "27023",
    "description": "chip_shop",
    "pos": "YELLOW",
    "explanation": "(restaurant [contraction] + French fries)",
    "isCharacter": false,
    "composition": [
      16430,
      "/",
      18005,
      "/",
      15214,
      ";",
      9009,
      "/",
      15914
    ]
  },
  {
    "id": "27024",
    "description": "chronic_fatigue_syndrome",
    "pos": "YELLOW",
    "explanation": "(sickness + tired + intensity + intensity + intensity)",
    "isCharacter": false,
    "composition": [
      16164,
      "/",
      15701,
      "/",
      16495,
      "/",
      14947,
      "/",
      14947,
      "/",
      14947
    ]
  },
  {
    "id": "27025",
    "description": "co-housing",
    "pos": "YELLOW",
    "explanation": "(village + agreement: A group of housing with agreement)",
    "isCharacter": false,
    "composition": [
      14647,
      "/",
      14905,
      "/",
      12354
    ]
  },
  {
    "id": "27026",
    "description": "concept",
    "pos": "YELLOW",
    "explanation": "(small character of thought)",
    "isCharacter": true
  },
  {
    "id": "27027",
    "description": "conceptualise-(to)",
    "pos": "RED",
    "explanation": "(concept + action indicator)",
    "isCharacter": false,
    "composition": [
      27026,
      ";",
      8993
    ]
  },
  {
    "id": "27028",
    "description": "concrete",
    "pos": "GREEN",
    "explanation": "(thing + description indicator)",
    "isCharacter": false,
    "composition": [
      17717,
      ";",
      8998
    ]
  },
  {
    "id": "27029",
    "description": "conjunction",
    "pos": "YELLOW",
    "explanation": "(word + combination)",
    "isCharacter": false,
    "composition": [
      15972,
      "/",
      15172,
      "/",
      13380
    ]
  },
  {
    "id": "27030",
    "description": "courgette,zucchini",
    "pos": "YELLOW",
    "explanation": "(squash,pumpkin + long)",
    "isCharacter": false,
    "composition": [
      17244,
      "/",
      15193
    ]
  },
  {
    "id": "27031",
    "description": "crumbs",
    "pos": "YELLOW",
    "explanation": "four particles [modification, two in high and two in low positions]: indicating crumbs",
    "isCharacter": true
  },
  {
    "id": "27032",
    "description": "definite",
    "pos": "GREEN",
    "explanation": "(the + description indicator)",
    "isCharacter": false,
    "composition": [
      17700,
      ";",
      8998
    ]
  },
  {
    "id": "27033",
    "description": "delicacy,speciality_(food)",
    "pos": "YELLOW",
    "explanation": "(food + feeling + interesting)",
    "isCharacter": false,
    "composition": [
      14377,
      "/",
      14164,
      "/",
      24916
    ]
  },
  {
    "id": "27034",
    "description": "democracy_(general)",
    "pos": "YELLOW",
    "explanation": "(lead + permission + choice)",
    "isCharacter": false,
    "composition": [
      22913,
      "/",
      24926,
      "/",
      13175
    ]
  },
  {
    "id": "27035",
    "description": "dictator_(general)",
    "pos": "BLUE",
    "explanation": "(leader + permission + without + choice)",
    "isCharacter": false,
    "composition": [
      21054,
      "/",
      24926,
      "/",
      15474,
      "/",
      13175
    ]
  },
  {
    "id": "27036",
    "description": "dictatorship_(general)",
    "pos": "BLUE",
    "explanation": "(lead + permission + without + choice)",
    "isCharacter": false,
    "composition": [
      22913,
      "/",
      24926,
      "/",
      15474,
      "/",
      13175
    ]
  },
  {
    "id": "27037",
    "description": "discover-(to)",
    "pos": "RED",
    "explanation": "(discovery + action indicator)",
    "isCharacter": false,
    "composition": [
      14133,
      ";",
      8993,
      "/",
      25570,
      "/",
      25587
    ]
  },
  {
    "id": "27038",
    "description": "discovery",
    "pos": "YELLOW",
    "explanation": "(find + new)",
    "isCharacter": false,
    "composition": [
      14133,
      "/",
      25570,
      "/",
      25587
    ]
  },
  {
    "id": "27039",
    "description": "dishwasher",
    "pos": "YELLOW",
    "explanation": "(washer + dish)",
    "isCharacter": false,
    "composition": [
      15406,
      "/",
      16992,
      "/",
      13690
    ]
  },
  {
    "id": "27040",
    "description": "drink_mix,shake,smoothie",
    "pos": "YELLOW",
    "explanation": "(drink + mix)",
    "isCharacter": false,
    "composition": [
      13881,
      "/",
      22377
    ]
  },
  {
    "id": "27041",
    "description": "dual",
    "pos": "YELLOW",
    "explanation": "(category + [contraction] noun + two)",
    "isCharacter": false,
    "composition": [
      17961,
      "/",
      15172,
      "/",
      8498
    ]
  },
  {
    "id": "27042",
    "description": "duty,obligation",
    "pos": "YELLOW",
    "explanation": "(protection + must_(a): protected requirements e.g. in law)",
    "isCharacter": false,
    "composition": [
      16420,
      "/",
      22914
    ]
  },
  {
    "id": "27043",
    "description": "earwax",
    "pos": "YELLOW",
    "explanation": "(substance + ear: substance of the ear)",
    "isCharacter": false,
    "composition": [
      24515,
      "/",
      13894
    ]
  },
  {
    "id": "27044",
    "description": "edible,eatable",
    "pos": "YELLOW",
    "explanation": "(food + description before the fact indicator)",
    "isCharacter": false,
    "composition": [
      14377,
      ";",
      8997
    ]
  },
  {
    "id": "27045",
    "description": "electric_conductor",
    "pos": "YELLOW",
    "explanation": "(material + through + electricity)",
    "isCharacter": false,
    "composition": [
      15431,
      "/",
      17724,
      "/",
      13918
    ]
  },
  {
    "id": "27046",
    "description": "electric_toothbrush",
    "pos": "YELLOW",
    "explanation": "(toothbrush + electricity)",
    "isCharacter": false,
    "composition": [
      12912,
      "/",
      17517,
      "/",
      13918
    ]
  },
  {
    "id": "27047",
    "description": "electric_wire,electric_cord,cord,cable,lead",
    "pos": "YELLOW",
    "explanation": "(fiber + electric)",
    "isCharacter": false,
    "composition": [
      25878,
      "/",
      13918
    ]
  },
  {
    "id": "27048",
    "description": "emergency_call,emergency_telephone",
    "pos": "YELLOW",
    "explanation": "(call + danger)",
    "isCharacter": false,
    "composition": [
      15172,
      "/",
      13918,
      "/",
      "RK:-2",
      "/",
      13632
    ]
  },
  {
    "id": "27049",
    "description": "emergency_room_(medical)",
    "pos": "YELLOW",
    "explanation": "(room + medical + danger)",
    "isCharacter": false,
    "composition": [
      16687,
      "/",
      24920,
      "/",
      13632
    ]
  },
  {
    "id": "27050",
    "description": "epidemic",
    "pos": "YELLOW",
    "explanation": "(sickness + spread)",
    "isCharacter": false,
    "composition": [
      16164,
      "/",
      24887
    ]
  },
  {
    "id": "27051",
    "description": "epiglottis",
    "pos": "YELLOW",
    "explanation": "(part + throat + lid)",
    "isCharacter": false,
    "composition": [
      15972,
      "/",
      26055,
      "/",
      22583
    ]
  },
  {
    "id": "27052",
    "description": "exhausted,worn_out",
    "pos": "GREEN",
    "explanation": "(feeling + without + energy [contraction] + description indicator)",
    "isCharacter": false,
    "composition": [
      14164,
      ";",
      8998,
      "/",
      15474,
      "/",
      13918
    ]
  },
  {
    "id": "27053",
    "description": "exploration",
    "pos": "YELLOW",
    "explanation": "( [contraction] search + new)",
    "isCharacter": false,
    "composition": [
      24949,
      "/",
      25587
    ]
  },
  {
    "id": "27054",
    "description": "fast_food",
    "pos": "YELLOW",
    "explanation": "(food + fast)",
    "isCharacter": false,
    "composition": [
      14377,
      "/",
      14390,
      "/",
      14947
    ]
  },
  {
    "id": "27055",
    "description": "first_aid",
    "pos": "YELLOW",
    "explanation": "(aid + medical + first)",
    "isCharacter": false,
    "composition": [
      14704,
      "/",
      24920,
      "/",
      8497,
      "/",
      8486
    ]
  },
  {
    "id": "27056",
    "description": "fish_skin",
    "pos": "YELLOW",
    "explanation": "(protection + fish)",
    "isCharacter": false,
    "composition": [
      16420,
      "/",
      14188
    ]
  },
  {
    "id": "27057",
    "description": "future_tense",
    "pos": "YELLOW",
    "explanation": "(category + language + future: language category of future time)",
    "isCharacter": false,
    "composition": [
      17961,
      "/",
      15172,
      "/",
      14417
    ]
  },
  {
    "id": "27058",
    "description": "germination",
    "pos": "YELLOW",
    "explanation": "(start + growth)",
    "isCharacter": false,
    "composition": [
      12658,
      "/",
      14205,
      "/",
      17983
    ]
  },
  {
    "id": "27059",
    "description": "gluten-free",
    "pos": "GREEN",
    "explanation": "(without + grain + description indicator)",
    "isCharacter": false,
    "composition": [
      15474,
      "/",
      14625,
      ";",
      8998
    ]
  },
  {
    "id": "27060",
    "description": "grammar_(general)",
    "pos": "YELLOW",
    "explanation": "(rule + word: rules of the language)",
    "isCharacter": false,
    "composition": [
      15962,
      "/",
      22913,
      "/",
      15972,
      "/",
      15172
    ]
  },
  {
    "id": "27061",
    "description": "grapheme",
    "pos": "YELLOW",
    "explanation": "(unit + small + different + write: the smallest unit that makes difference in writing).\nContraction of smallest ",
    "isCharacter": false,
    "composition": [
      8497,
      ";",
      9009,
      "/",
      24917,
      "/",
      13675,
      "/",
      15991
    ]
  },
  {
    "id": "27062",
    "description": "groin",
    "pos": "YELLOW",
    "explanation": "(body + pointer to groin) - Character (superimposed + pointer)",
    "isCharacter": true
  },
  {
    "id": "27063",
    "description": "heart_attack",
    "pos": "YELLOW",
    "explanation": "(sickness + heart + lightning)",
    "isCharacter": false,
    "composition": [
      16164,
      "/",
      14164,
      ";",
      9009,
      "/",
      15209
    ]
  },
  {
    "id": "27064",
    "description": "heart_disease",
    "pos": "YELLOW",
    "explanation": "(sickness + heart)",
    "isCharacter": false,
    "composition": [
      16164,
      "/",
      14164,
      ";",
      9009
    ]
  },
  {
    "id": "27065",
    "description": "helpful,assistive,supportive",
    "pos": "GREEN",
    "explanation": "(help+aid+assistant+support+description indicator)",
    "isCharacter": false,
    "composition": [
      14704,
      ";",
      8998
    ]
  },
  {
    "id": "27066",
    "description": "human_rights",
    "pos": "YELLOW",
    "explanation": "(right + person)",
    "isCharacter": false,
    "composition": [
      16420,
      "/",
      14396,
      "/",
      16161
    ]
  },
  {
    "id": "27067",
    "description": "immune_(medical)",
    "pos": "GREEN",
    "explanation": "(immunity + description indicator)",
    "isCharacter": false,
    "composition": [
      12351,
      ";",
      8998,
      "/",
      16164
    ]
  },
  {
    "id": "27068",
    "description": "immunity_(medical)",
    "pos": "YELLOW",
    "explanation": "(against + sickness)",
    "isCharacter": false,
    "composition": [
      12351,
      "/",
      16164
    ]
  },
  {
    "id": "27069",
    "description": "improve-(to)",
    "pos": "RED",
    "explanation": "(improvement + action indicator: the effect of being better in a rational sense)",
    "isCharacter": false,
    "composition": [
      13910,
      ";",
      8993,
      "/",
      24879,
      "/",
      25538,
      "/",
      14947
    ]
  },
  {
    "id": "27070",
    "description": "improvement,enhancement",
    "pos": "YELLOW",
    "explanation": "(effect + more + correct +: the effect of being better in a rational sense) see also improve-(to)",
    "isCharacter": false,
    "composition": [
      13910,
      "/",
      24879,
      "/",
      25538,
      "/",
      14947
    ]
  },
  {
    "id": "27071",
    "description": "independent_living",
    "pos": "YELLOW",
    "explanation": "(to live_(life) + independent)",
    "isCharacter": false,
    "composition": [
      15206,
      "/",
      12322,
      "/",
      8497,
      "/",
      15214
    ]
  },
  {
    "id": "27072",
    "description": "infix",
    "pos": "YELLOW",
    "explanation": "(unit + language + inside)",
    "isCharacter": false,
    "composition": [
      8497,
      ";",
      9009,
      "/",
      15172,
      "/",
      14932
    ]
  },
  {
    "id": "27073",
    "description": "inflatable",
    "pos": "GREEN",
    "explanation": "(to inflate + description before the fact indicator)",
    "isCharacter": false,
    "composition": [
      14952,
      ";",
      8997,
      "/",
      12356
    ]
  },
  {
    "id": "27074",
    "description": "interjection",
    "pos": "YELLOW",
    "explanation": "(word + feeling)",
    "isCharacter": false,
    "composition": [
      15972,
      "/",
      15172,
      "/",
      14164
    ]
  },
  {
    "id": "27075",
    "description": "intersection,crossroad",
    "pos": "YELLOW",
    "explanation": "(road_(1) + across: one road crossing the other)",
    "isCharacter": false,
    "composition": [
      16678,
      "/",
      12333
    ]
  },
  {
    "id": "27076",
    "description": "joke_(general)",
    "pos": "YELLOW",
    "explanation": "(activity + comma + funny) see also joke-(to)_(general)",
    "isCharacter": false,
    "composition": [
      12335,
      "/",
      8487,
      "/",
      14164,
      "/",
      17983,
      "/",
      15666
    ]
  },
  {
    "id": "27077",
    "description": "joke_(spoken)",
    "pos": "YELLOW",
    "explanation": "(to say + comma + funny) see also joke-(to)_(spoken) 14974  all theese three have been mixed",
    "isCharacter": false,
    "composition": [
      15666,
      "/",
      8487,
      "/",
      14164,
      "/",
      17983,
      "/",
      15666
    ]
  },
  {
    "id": "27078",
    "description": "joke_(general)-(to)",
    "pos": "RED",
    "explanation": "(joke (general) + act.indicator) see also joke_(general)",
    "isCharacter": false,
    "composition": [
      12335,
      ";",
      8993,
      "/",
      8487,
      "/",
      14164,
      "/",
      17983,
      "/",
      15666
    ]
  },
  {
    "id": "27079",
    "description": "kangaroo,wallaby",
    "pos": "YELLOW",
    "explanation": "(animal + container + jump)",
    "isCharacter": false,
    "composition": [
      12378,
      "/",
      13403,
      "/",
      23550
    ]
  },
  {
    "id": "27080",
    "description": "kernel,particle",
    "pos": "YELLOW",
    "explanation": "(pictograph: showing a particle) - Character",
    "isCharacter": true
  },
  {
    "id": "27081",
    "description": "kiosk,booth,stall",
    "pos": "YELLOW",
    "explanation": "(room + business) - Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "27082",
    "description": "kyphosis,scoliosis",
    "pos": "YELLOW",
    "explanation": "(bone + back + curve)",
    "isCharacter": false,
    "composition": [
      12873,
      "/",
      12609,
      "/",
      13627
    ]
  },
  {
    "id": "27083",
    "description": "larynx",
    "pos": "YELLOW",
    "explanation": "(part + throat + activity + sound)",
    "isCharacter": false,
    "composition": [
      15972,
      "/",
      26055,
      "/",
      "RK:-2",
      "/",
      12335,
      "/",
      17216
    ]
  },
  {
    "id": "27084",
    "description": "learning_difficulty",
    "pos": "YELLOW",
    "explanation": "(limitation + to learn)",
    "isCharacter": false,
    "composition": [
      25579,
      "/",
      24727,
      "/",
      15162
    ]
  },
  {
    "id": "27085",
    "description": "lichen",
    "pos": "YELLOW",
    "explanation": "(pictograph: showing lichen growing on a stone) - Character",
    "isCharacter": true
  },
  {
    "id": "27086",
    "description": "lukewarm,handwarm,tepid",
    "pos": "GREEN",
    "explanation": "(warm + little + hand + description indicator)",
    "isCharacter": false,
    "composition": [
      14696,
      ";",
      8998,
      "/",
      24917,
      "/",
      14667
    ]
  },
  {
    "id": "27087",
    "description": "mammoth",
    "pos": "YELLOW",
    "explanation": "(furred_animal + nose)",
    "isCharacter": false,
    "composition": [
      26054,
      "/",
      15732
    ]
  },
  {
    "id": "27088",
    "description": "marshmallow",
    "pos": "YELLOW",
    "explanation": "(candy + [contraction]soft)",
    "isCharacter": false,
    "composition": [
      22375,
      "/",
      25575
    ]
  },
  {
    "id": "27089",
    "description": "milkshake",
    "pos": "YELLOW",
    "explanation": "(smoothie + [contraction] milk)",
    "isCharacter": false,
    "composition": [
      13881,
      "/",
      22377,
      "/",
      15206
    ]
  },
  {
    "id": "27090",
    "description": "morpheme",
    "pos": "YELLOW",
    "explanation": "(unit + [contraction] + small + different + words [contraction] word: the smallest unit that makes difference in words) .\nContraction of smallest",
    "isCharacter": false,
    "composition": [
      8497,
      ";",
      9009,
      "/",
      24917,
      "/",
      13675,
      "/",
      15172
    ]
  },
  {
    "id": "27091",
    "description": "morphology",
    "pos": "YELLOW",
    "explanation": "(rule + structure + word: rules of the language structure)",
    "isCharacter": false,
    "composition": [
      15962,
      "/",
      22913,
      "/",
      15972,
      "/",
      15172
    ]
  },
  {
    "id": "27092",
    "description": "nasal_cavity",
    "pos": "YELLOW",
    "explanation": "(inside + nose)",
    "isCharacter": false,
    "composition": [
      14932,
      "/",
      15732
    ]
  },
  {
    "id": "27093",
    "description": "navigate_(general)-(to)",
    "pos": "RED",
    "explanation": "(activity + sign + action indicator)",
    "isCharacter": false,
    "composition": [
      12335,
      ";",
      8993,
      "/",
      17717,
      "/",
      23542
    ]
  },
  {
    "id": "27094",
    "description": "navigation_(general)",
    "pos": "YELLOW",
    "explanation": "(activity + sign)",
    "isCharacter": false,
    "composition": [
      12335,
      "/",
      17717,
      "/",
      23542
    ]
  },
  {
    "id": "27095",
    "description": "non-alcoholic",
    "pos": "GREEN",
    "explanation": "(without + alcoholic_drink + description indicator)",
    "isCharacter": false,
    "composition": [
      15474,
      "/",
      12359,
      ";",
      8998
    ]
  },
  {
    "id": "27096",
    "description": "noun",
    "pos": "YELLOW",
    "explanation": "(word + name)",
    "isCharacter": false,
    "composition": [
      15972,
      "/",
      15172,
      "/",
      15691
    ]
  },
  {
    "id": "27097",
    "description": "nude,naked",
    "pos": "GREEN",
    "explanation": "(nudity + description indicator)",
    "isCharacter": false,
    "composition": [
      15474,
      ";",
      8998,
      "/",
      13366
    ]
  },
  {
    "id": "27098",
    "description": "nudity",
    "pos": "YELLOW",
    "explanation": "(without + clothes)",
    "isCharacter": false,
    "composition": [
      15474,
      "/",
      13366
    ]
  },
  {
    "id": "27099",
    "description": "number,numeral",
    "pos": "YELLOW",
    "explanation": "(word + number: numeral words)",
    "isCharacter": false,
    "composition": [
      15972,
      "/",
      15172,
      "/",
      15742
    ]
  },
  {
    "id": "27100",
    "description": "oral_cavity",
    "pos": "YELLOW",
    "explanation": "(inside + mouth)",
    "isCharacter": false,
    "composition": [
      14932,
      "/",
      15666
    ]
  },
  {
    "id": "27101",
    "description": "oven_paper",
    "pos": "YELLOW",
    "explanation": "(paper + oven)",
    "isCharacter": false,
    "composition": [
      15962,
      "/",
      17273
    ]
  },
  {
    "id": "27102",
    "description": "palate,roof_of_mouth",
    "pos": "YELLOW",
    "explanation": "(ceiling + mouth)",
    "isCharacter": false,
    "composition": [
      13139,
      "/",
      15666
    ]
  },
  {
    "id": "27103",
    "description": "pandemic",
    "pos": "YELLOW",
    "explanation": "(sickness + spread + intensity)",
    "isCharacter": false,
    "composition": [
      16164,
      "/",
      24887,
      "/",
      14947
    ]
  },
  {
    "id": "27104",
    "description": "part_of_speech",
    "pos": "YELLOW",
    "explanation": "(category + word)",
    "isCharacter": false,
    "composition": [
      17961,
      "/",
      15972,
      "/",
      15172
    ]
  },
  {
    "id": "27105",
    "description": "past_tense",
    "pos": "YELLOW",
    "explanation": "(category + language + past: language category of past time)",
    "isCharacter": false,
    "composition": [
      17961,
      "/",
      15172,
      "/",
      15975
    ]
  },
  {
    "id": "27106",
    "description": "peanut",
    "pos": "YELLOW",
    "explanation": "(seed + combination: seeds joined in combination)",
    "isCharacter": false,
    "composition": [
      16749,
      "/",
      13380
    ]
  },
  {
    "id": "27107",
    "description": "phoneme",
    "pos": "YELLOW",
    "explanation": "(unit + [contraction] + small + different + sound: the smallest sound unit that makes difference).\nContraction of smallest",
    "isCharacter": false,
    "composition": [
      8497,
      ";",
      9009,
      "/",
      24917,
      "/",
      13675,
      "/",
      17216
    ]
  },
  {
    "id": "27108",
    "description": "phonology",
    "pos": "YELLOW",
    "explanation": "(rule + sound + word: rules of language sounds)",
    "isCharacter": false,
    "composition": [
      15962,
      "/",
      22913,
      "/",
      17216,
      "/",
      15972,
      "/",
      15172
    ]
  },
  {
    "id": "27109",
    "description": "pizzeria",
    "pos": "YELLOW",
    "explanation": "(restaurant [contraction] + pizza [contraction])",
    "isCharacter": false,
    "composition": [
      16430,
      "/",
      25594
    ]
  },
  {
    "id": "27110",
    "description": "plague",
    "pos": "YELLOW",
    "explanation": "(sickness + first [contraction] + micro-organism + intensity)",
    "isCharacter": false,
    "composition": [
      16164,
      "/",
      8497,
      "/",
      24443,
      ";",
      9009,
      "/",
      24917,
      "/",
      14947
    ]
  },
  {
    "id": "27111",
    "description": "plastic_wrap",
    "pos": "YELLOW",
    "explanation": "(wrapping + [contraction] plastic)",
    "isCharacter": false,
    "composition": [
      25616,
      ";",
      9009,
      "/",
      13158
    ]
  },
  {
    "id": "27112",
    "description": "plural",
    "pos": "YELLOW",
    "explanation": "(category + [contraction] noun + many)",
    "isCharacter": false,
    "composition": [
      17961,
      "/",
      15172,
      "/",
      14647
    ]
  },
  {
    "id": "27113",
    "description": "pointer",
    "pos": "YELLOW",
    "explanation": "(pointing_(hand) + thing indicator)",
    "isCharacter": false,
    "composition": [
      23619,
      ";",
      9009
    ]
  },
  {
    "id": "27114",
    "description": "pole",
    "pos": "YELLOW",
    "explanation": "(linear thing + big)",
    "isCharacter": false,
    "composition": [
      15214,
      ";",
      9009,
      "/",
      24875
    ]
  },
  {
    "id": "27115",
    "description": "pollen",
    "pos": "YELLOW",
    "explanation": "(powder + flower)",
    "isCharacter": false,
    "composition": [
      16233,
      "/",
      14205
    ]
  },
  {
    "id": "27116",
    "description": "post_position",
    "pos": "YELLOW",
    "explanation": "(word + after)",
    "isCharacter": false,
    "composition": [
      15972,
      "/",
      15172,
      "/",
      12348
    ]
  },
  {
    "id": "27117",
    "description": "prefix",
    "pos": "YELLOW",
    "explanation": "(unit + language + beginning: language units in the beginning of a word)",
    "isCharacter": false,
    "composition": [
      8497,
      ";",
      9009,
      "/",
      15172,
      "/",
      12658
    ]
  },
  {
    "id": "27118",
    "description": "preposition",
    "pos": "YELLOW",
    "explanation": "(word + in front of)",
    "isCharacter": false,
    "composition": [
      15972,
      "/",
      15172,
      "/",
      12656
    ]
  },
  {
    "id": "27119",
    "description": "present_tense",
    "pos": "YELLOW",
    "explanation": "(category + language + present: language category of present time)",
    "isCharacter": false,
    "composition": [
      17961,
      "/",
      15172,
      "/",
      16246
    ]
  },
  {
    "id": "27120",
    "description": "pronoun",
    "pos": "YELLOW",
    "explanation": "(word + in exchange for + name: in exchange for nouns)",
    "isCharacter": false,
    "composition": [
      15972,
      "/",
      15172,
      "/",
      14381,
      "/",
      15691
    ]
  },
  {
    "id": "27121",
    "description": "right(s)",
    "pos": "YELLOW",
    "explanation": "(protection + freedom: protection of freedom)",
    "isCharacter": false,
    "composition": [
      16420,
      "/",
      14396
    ]
  },
  {
    "id": "27122",
    "description": "rights_of_persons_with_disabilities,disability_rights",
    "pos": "YELLOW",
    "explanation": "(right + person + limited)",
    "isCharacter": false,
    "composition": [
      16420,
      "/",
      14396,
      "/",
      16161,
      "/",
      25579
    ]
  },
  {
    "id": "27123",
    "description": "roundabout",
    "pos": "YELLOW",
    "explanation": "(road_(1) + rotate: a road junction at which traffic streams circularly around a central island)",
    "isCharacter": false,
    "composition": [
      16678,
      "/",
      24249
    ]
  },
  {
    "id": "27124",
    "description": "semantics",
    "pos": "YELLOW",
    "explanation": "(science + language + meaning: study/science of linguistic/language meanings)",
    "isCharacter": false,
    "composition": [
      16735,
      "/",
      15172,
      "/",
      15441
    ]
  },
  {
    "id": "27125",
    "description": "shared_housing",
    "pos": "YELLOW",
    "explanation": "(house + share: shared housing, groupliving)",
    "isCharacter": false,
    "composition": [
      14905,
      "/",
      24912,
      "/",
      23409
    ]
  },
  {
    "id": "27126",
    "description": "singular",
    "pos": "YELLOW",
    "explanation": "(category + [contraction] noun + one)",
    "isCharacter": false,
    "composition": [
      17961,
      "/",
      15172,
      "/",
      8497
    ]
  },
  {
    "id": "27127",
    "description": "sleep_medication",
    "pos": "YELLOW",
    "explanation": "(medication + sleep)",
    "isCharacter": false,
    "composition": [
      13158,
      "/",
      24920,
      "/",
      17008
    ]
  },
  {
    "id": "27128",
    "description": "sleeping_pill",
    "pos": "YELLOW",
    "explanation": "(pill + sleep)",
    "isCharacter": false,
    "composition": [
      13685,
      "/",
      24920,
      "/",
      17008
    ]
  },
  {
    "id": "27129",
    "description": "sleeping_place,nest_(animals)",
    "pos": "YELLOW",
    "explanation": "(place + sleep + animal)",
    "isCharacter": false,
    "composition": [
      16193,
      "/",
      17008,
      "/",
      12378
    ]
  },
  {
    "id": "27130",
    "description": "snot",
    "pos": "YELLOW",
    "explanation": "(substance + nose: substance of the nose)",
    "isCharacter": false,
    "composition": [
      24515,
      "/",
      15732
    ]
  },
  {
    "id": "27131",
    "description": "sprout",
    "pos": "YELLOW",
    "explanation": "(plant + start)",
    "isCharacter": false,
    "composition": [
      16196,
      "/",
      12658
    ]
  },
  {
    "id": "27132",
    "description": "starfruit,carambola",
    "pos": "YELLOW",
    "explanation": "(fruit + star)",
    "isCharacter": false,
    "composition": [
      14405,
      "/",
      17252
    ]
  },
  {
    "id": "27133",
    "description": "stethoscope",
    "pos": "YELLOW",
    "explanation": "(tool + medical + sound)",
    "isCharacter": false,
    "composition": [
      17755,
      "/",
      24920,
      "/",
      17216
    ]
  },
  {
    "id": "27134",
    "description": "sticking_plaster,bandaid",
    "pos": "YELLOW",
    "explanation": "(bandage + together: contracted bandage sticky)",
    "isCharacter": false,
    "composition": [
      13365,
      "/",
      24920,
      "/",
      23409
    ]
  },
  {
    "id": "27135",
    "description": "stir-(to)",
    "pos": "RED",
    "explanation": "(mix + spoon + action indicator)",
    "isCharacter": false,
    "composition": [
      22377,
      ";",
      8993,
      "/",
      17233
    ]
  },
  {
    "id": "27136",
    "description": "stress",
    "pos": "YELLOW",
    "explanation": "(feeling + pressure)",
    "isCharacter": false,
    "composition": [
      14164,
      "/",
      23169
    ]
  },
  {
    "id": "27137",
    "description": "stressed,stressful",
    "pos": "GREEN",
    "explanation": "(stress + description indicator)",
    "isCharacter": false,
    "composition": [
      14164,
      ";",
      8998,
      "/",
      23169
    ]
  },
  {
    "id": "27138",
    "description": "stutter-(to)",
    "pos": "RED",
    "explanation": "(stuttering + action indicator)",
    "isCharacter": false,
    "composition": [
      25579,
      ";",
      8993,
      "/",
      15666,
      "/",
      24934
    ]
  },
  {
    "id": "27139",
    "description": "stuttering",
    "pos": "YELLOW",
    "explanation": "(limitation + mouth + repeat: speech limitation, repetition of sounds and blocks)",
    "isCharacter": false,
    "composition": [
      25579,
      "/",
      15666,
      "/",
      24934
    ]
  },
  {
    "id": "27140",
    "description": "suck-(to)",
    "pos": "RED",
    "explanation": "(mouth + into_(backward) + action indicator)",
    "isCharacter": false,
    "composition": [
      15666,
      ";",
      8993,
      "/",
      25894
    ]
  },
  {
    "id": "27141",
    "description": "suffix",
    "pos": "YELLOW",
    "explanation": "(unit + language + end: language units in the end of a word)",
    "isCharacter": false,
    "composition": [
      8497,
      ";",
      9009,
      "/",
      15172,
      "/",
      13935
    ]
  },
  {
    "id": "27142",
    "description": "sushi",
    "pos": "YELLOW",
    "explanation": "ball + [contraction]rice+fish",
    "isCharacter": false,
    "composition": [
      12621,
      "/",
      16505,
      "/",
      14188
    ]
  },
  {
    "id": "27143",
    "description": "syntax",
    "pos": "YELLOW",
    "explanation": "(rule + sentence: rules of the language sentences)",
    "isCharacter": false,
    "composition": [
      15962,
      "/",
      22913,
      "/",
      14647,
      "/",
      15972,
      "/",
      15172
    ]
  },
  {
    "id": "27144",
    "description": "tense",
    "pos": "YELLOW",
    "explanation": "(category + language + time: language category of time) it's not category,it's \"kind\" .",
    "isCharacter": false,
    "composition": [
      17961,
      "/",
      15172,
      "/",
      17732
    ]
  },
  {
    "id": "27145",
    "description": "thyroid_gland",
    "pos": "YELLOW",
    "explanation": "(gland + throat) arrow pointing to throat is missing",
    "isCharacter": false,
    "composition": [
      25480,
      "/",
      "RK:-2",
      "/",
      13158,
      "/",
      26055
    ]
  },
  {
    "id": "27146",
    "description": "tired,weary",
    "pos": "GREEN",
    "explanation": "(need + rest + description indicator: need of rest)",
    "isCharacter": false,
    "composition": [
      15701,
      ";",
      8998,
      "/",
      16495
    ]
  },
  {
    "id": "27147",
    "description": "tonsils",
    "pos": "YELLOW",
    "explanation": "(part + throat + immunity) arrow pointing to throat is missing",
    "isCharacter": false,
    "composition": [
      15972,
      "/",
      26055,
      "/",
      12351,
      "/",
      16164
    ]
  },
  {
    "id": "27148",
    "description": "traffic_light",
    "pos": "YELLOW",
    "explanation": "(lamp + [contraction] traffic)",
    "isCharacter": false,
    "composition": [
      15208,
      ";",
      9009,
      "/",
      18010
    ]
  },
  {
    "id": "27149",
    "description": "transgender",
    "pos": "GREEN",
    "explanation": "(transgender_(gender) + description indicator)",
    "isCharacter": false,
    "composition": [
      70101,
      ";",
      8998
    ]
  },
  {
    "id": "27150",
    "description": "transgender_person",
    "pos": "BLUE",
    "explanation": "(transgender_(gender) + person [modification, the upper part]) - Character (modified - superimposed)",
    "isCharacter": true
  },
  {
    "id": "27151",
    "description": "vegan_food",
    "pos": "YELLOW",
    "explanation": "(food + only + plant)",
    "isCharacter": false,
    "composition": [
      14377,
      "/",
      24443,
      "/",
      8497,
      "/",
      16196
    ]
  },
  {
    "id": "27152",
    "description": "verb",
    "pos": "YELLOW",
    "explanation": "(word + action: action words)",
    "isCharacter": false,
    "composition": [
      15972,
      "/",
      15172,
      "/",
      "RK:-2",
      "/",
      12334
    ]
  },
  {
    "id": "27153",
    "description": "wasp",
    "pos": "YELLOW",
    "explanation": "(stinging insect + wings + intensity)",
    "isCharacter": false,
    "composition": [
      14371,
      "/",
      16212,
      "/",
      14947
    ]
  },
  {
    "id": "27154",
    "description": "whisk,beat-(to)",
    "pos": "RED",
    "explanation": "(mix + kitchen_tool,utensil + action indicator)",
    "isCharacter": false,
    "composition": [
      22377,
      ";",
      8993,
      "/",
      22561
    ]
  },
  {
    "id": "27155",
    "description": "wire,cable",
    "pos": "YELLOW",
    "explanation": "(fiber + metal [contraction])",
    "isCharacter": false,
    "composition": [
      25878,
      "/",
      23150
    ]
  },
  {
    "id": "27156",
    "description": "wireless_connection",
    "pos": "YELLOW",
    "explanation": "(digital signal + without + fiber) Bliss-word synonym",
    "isCharacter": false,
    "composition": [
      24750,
      "/",
      23476,
      "/",
      15474,
      "/",
      25878
    ]
  },
  {
    "id": "27157",
    "description": "wrapping",
    "pos": "YELLOW",
    "explanation": "(spiral + thing indicator)",
    "isCharacter": false,
    "composition": [
      25616,
      ";",
      9009
    ]
  },
  {
    "id": "27158",
    "description": "wrapping,paper_roll",
    "pos": "YELLOW",
    "explanation": "(wrapping + paper)",
    "isCharacter": false,
    "composition": [
      25616,
      ";",
      9009,
      "/",
      15962
    ]
  },
  {
    "id": "28001",
    "description": "aim,intention",
    "pos": "YELLOW",
    "explanation": "(purpose + forward)",
    "isCharacter": false,
    "composition": [
      16437,
      "/",
      14390
    ]
  },
  {
    "id": "28002",
    "description": "allowable,permissable",
    "pos": "GREEN",
    "explanation": "(allow + before_fact)",
    "isCharacter": false,
    "composition": [
      24926,
      ";",
      8997
    ]
  },
  {
    "id": "28003",
    "description": "allowed,permitted",
    "pos": "GREEN",
    "explanation": "(allow + after_fact)",
    "isCharacter": false,
    "composition": [
      24926,
      ";",
      8996
    ]
  },
  {
    "id": "28004",
    "description": "amusement_park,theme_park",
    "pos": "YELLOW",
    "explanation": "(park + excitement)",
    "isCharacter": false,
    "composition": [
      15969,
      "/",
      14164,
      "/",
      14947,
      "/",
      14947
    ]
  },
  {
    "id": "28005",
    "description": "arm_support",
    "pos": "YELLOW",
    "explanation": "(aid + arm)",
    "isCharacter": false,
    "composition": [
      14704,
      ";",
      9009,
      "/",
      12577
    ]
  },
  {
    "id": "28007",
    "description": "audience",
    "pos": "BLUE",
    "explanation": "(group + see + hear)",
    "isCharacter": false,
    "composition": [
      14647,
      "/",
      16161,
      "/",
      14133,
      "/",
      13894
    ]
  },
  {
    "id": "28008",
    "description": "basketball_player",
    "pos": "BLUE",
    "explanation": "(person + basketball[contraction])",
    "isCharacter": false,
    "composition": [
      16161,
      "/",
      12621,
      "/",
      25535
    ]
  },
  {
    "id": "28009",
    "description": "carnival",
    "pos": "YELLOW",
    "explanation": "(festival + costume)",
    "isCharacter": false,
    "composition": [
      14114,
      "/",
      14164,
      "/",
      14947,
      "/",
      14947,
      "/",
      13366,
      "/",
      24895
    ]
  },
  {
    "id": "28010",
    "description": "climate_change",
    "pos": "YELLOW",
    "explanation": "(climate [contraction] + development)",
    "isCharacter": true
  },
  {
    "id": "28011",
    "description": "climate_emergency",
    "pos": "YELLOW",
    "explanation": "(climate change + danger)",
    "isCharacter": false,
    "composition": [
      28010,
      "/",
      13632
    ]
  },
  {
    "id": "28012",
    "description": "development",
    "pos": "YELLOW",
    "explanation": "(change + forward [modification,short arrow]:change through progression) - Character (superimposed-modified)",
    "isCharacter": true
  },
  {
    "id": "28013",
    "description": "discriminate-(to)",
    "pos": "RED",
    "explanation": "(discrimination + action indicator)",
    "isCharacter": false,
    "composition": [
      17961,
      ";",
      8993,
      "/",
      13675
    ]
  },
  {
    "id": "28014",
    "description": "discriminate_(person)-(to)",
    "pos": "RED",
    "explanation": "(discriminate + person) add + action indicatorfør )",
    "isCharacter": false,
    "composition": [
      17961,
      ";",
      8993,
      "/",
      13675,
      "/",
      16161
    ]
  },
  {
    "id": "28015",
    "description": "discriminated_(person)",
    "pos": "GREEN",
    "explanation": "(discriminated + person)",
    "isCharacter": false,
    "composition": [
      17961,
      ";",
      8998,
      "/",
      13675,
      "/",
      16161
    ]
  },
  {
    "id": "28016",
    "description": "discrimination",
    "pos": "YELLOW",
    "explanation": "(sort + different)",
    "isCharacter": false,
    "composition": [
      17961,
      "/",
      13675
    ]
  },
  {
    "id": "28017",
    "description": "discrimination_(person)",
    "pos": "YELLOW",
    "explanation": "(discrimination + person)  (person + discrimination)?",
    "isCharacter": false,
    "composition": [
      17961,
      "/",
      13675,
      "/",
      16161
    ]
  },
  {
    "id": "28018",
    "description": "discriminatory",
    "pos": "GREEN",
    "explanation": "(discrimination + description indicator)",
    "isCharacter": false,
    "composition": [
      17961,
      ";",
      8998,
      "/",
      13675
    ]
  },
  {
    "id": "28019",
    "description": "ensure,guarantee-(to)",
    "pos": "RED",
    "explanation": "(certain + action indicator[remove doubt])",
    "isCharacter": false,
    "composition": [
      15474,
      "/",
      22911,
      ";",
      8993
    ]
  },
  {
    "id": "28020",
    "description": "event_dressing_up,carnival",
    "pos": "YELLOW",
    "explanation": "(event + costume)",
    "isCharacter": false,
    "composition": [
      14114,
      "/",
      13366,
      "/",
      24895
    ]
  },
  {
    "id": "28021",
    "description": "eye_pointing",
    "pos": "YELLOW",
    "explanation": "(pointing + eye)",
    "isCharacter": false,
    "composition": [
      23619,
      "/",
      14133
    ]
  },
  {
    "id": "28022",
    "description": "eye_pointing_(digital)",
    "pos": "YELLOW",
    "explanation": "(eye_pointing + digital)",
    "isCharacter": false,
    "composition": [
      23619,
      "/",
      14133,
      "/",
      23476
    ]
  },
  {
    "id": "28023",
    "description": "fancy_dress_party",
    "pos": "YELLOW",
    "explanation": "(gathering + costume)",
    "isCharacter": false,
    "composition": [
      14427,
      "/",
      13366,
      "/",
      24895
    ]
  },
  {
    "id": "28024",
    "description": "festival",
    "pos": "YELLOW",
    "explanation": "(event + excitement)",
    "isCharacter": false,
    "composition": [
      14114,
      "/",
      14164,
      "/",
      14947,
      "/",
      14947
    ]
  },
  {
    "id": "28025",
    "description": "football_field,soccer_field",
    "pos": "YELLOW",
    "explanation": "(place + football [contraction])",
    "isCharacter": false,
    "composition": [
      16193,
      "/",
      12621,
      "/",
      15189
    ]
  },
  {
    "id": "28026",
    "description": "football_game,match,soccer_game",
    "pos": "YELLOW",
    "explanation": "(competition + football [contraction])",
    "isCharacter": false,
    "composition": [
      16451,
      "/",
      12621,
      "/",
      15189
    ]
  },
  {
    "id": "28027",
    "description": "football_player,soccer_player",
    "pos": "BLUE",
    "explanation": "(person + football [contraction])",
    "isCharacter": false,
    "composition": [
      16161,
      "/",
      12621,
      "/",
      15189
    ]
  },
  {
    "id": "28028",
    "description": "global_warming",
    "pos": "YELLOW",
    "explanation": "(climate change + temperature + rising)",
    "isCharacter": false,
    "composition": [
      28010,
      "/",
      17520,
      "/",
      17983
    ]
  },
  {
    "id": "28029",
    "description": "goalpost",
    "pos": "YELLOW",
    "explanation": "(pole[contraction] + goal)",
    "isCharacter": false,
    "composition": [
      15214,
      ";",
      9009,
      "/",
      14450
    ]
  },
  {
    "id": "28030",
    "description": "goal_keeper",
    "pos": "BLUE",
    "explanation": "(person + football [contraction])",
    "isCharacter": false,
    "composition": [
      16161,
      "/",
      14450
    ]
  },
  {
    "id": "28031",
    "description": "goal_net",
    "pos": "YELLOW",
    "explanation": "(fabric + goal)",
    "isCharacter": false,
    "composition": [
      13365,
      "/",
      14450
    ]
  },
  {
    "id": "28032",
    "description": "goal_(result),score",
    "pos": "YELLOW",
    "explanation": "(goal + exclamation mark) [the goal you make in a game] should be \"intensity\" instead of \"excalamtionmark\"",
    "isCharacter": false,
    "composition": [
      14450,
      "/",
      14947
    ]
  },
  {
    "id": "28033",
    "description": "goal,target",
    "pos": "YELLOW",
    "explanation": "(purpose + end)",
    "isCharacter": false,
    "composition": [
      16437,
      "/",
      13935
    ]
  },
  {
    "id": "28034",
    "description": "handball_court",
    "pos": "YELLOW",
    "explanation": "(place + handball [contraction])",
    "isCharacter": false,
    "composition": [
      16193,
      "/",
      12621,
      "/",
      14667
    ]
  },
  {
    "id": "28035",
    "description": "handball_game",
    "pos": "YELLOW",
    "explanation": "(competition + handball [contraction])",
    "isCharacter": false,
    "composition": [
      16451,
      "/",
      12621,
      "/",
      14667
    ]
  },
  {
    "id": "28036",
    "description": "handball_player",
    "pos": "BLUE",
    "explanation": "(person + handball[contraction])",
    "isCharacter": false,
    "composition": [
      16161,
      "/",
      12621,
      "/",
      14667
    ]
  },
  {
    "id": "28037",
    "description": "head_support",
    "pos": "YELLOW",
    "explanation": "(aid + head)",
    "isCharacter": false,
    "composition": [
      14704,
      ";",
      9009,
      "/",
      14689
    ]
  },
  {
    "id": "28038",
    "description": "homeland,nationality_(loyalty)",
    "pos": "YELLOW",
    "explanation": "(nation + feeling) (country + feeling) should be \"state\", instead of \"nation\"",
    "isCharacter": false,
    "composition": [
      13423,
      "/",
      14164
    ]
  },
  {
    "id": "28039",
    "description": "hoodie",
    "pos": "YELLOW",
    "explanation": "(sweater + protection + head) (shirt + protection + head)",
    "isCharacter": false,
    "composition": [
      13366,
      "/",
      13161,
      "/",
      16420,
      "/",
      14689
    ]
  },
  {
    "id": "28040",
    "description": "ice_hockey_rink",
    "pos": "YELLOW",
    "explanation": "(place + ice hockey)  add [contraction])",
    "isCharacter": false,
    "composition": [
      16193,
      "/",
      25619,
      "/",
      14919
    ]
  },
  {
    "id": "28041",
    "description": "implement-(to)",
    "pos": "RED",
    "explanation": "(implementation + action indicator)",
    "isCharacter": false,
    "composition": [
      13134,
      ";",
      8993,
      "/",
      14114
    ]
  },
  {
    "id": "28042",
    "description": "implementation,realization",
    "pos": "YELLOW",
    "explanation": "(cause + happen)",
    "isCharacter": false,
    "composition": [
      13134,
      "/",
      14114
    ]
  },
  {
    "id": "28043",
    "description": "indicator_(continuous_form)",
    "pos": "GREY",
    "explanation": "(horizontal line [quarter-sized]:  may be placed above a symbol to show that it is representing a verb in continuous form in a natural language.)",
    "isCharacter": true
  },
  {
    "id": "28044",
    "description": "indicator_(plural,definite)",
    "pos": "GREY",
    "explanation": "Indicator (plural + definite)",
    "isCharacter": true
  },
  {
    "id": "28045",
    "description": "indicator_(thing,definite)",
    "pos": "GREY",
    "explanation": "Indicator (thing + definite)",
    "isCharacter": true
  },
  {
    "id": "28046",
    "description": "indicator_(thing,plural,definite)",
    "pos": "GREY",
    "explanation": "Indicator (thing + plural + definite)",
    "isCharacter": true
  },
  {
    "id": "28047",
    "description": "insure-(to)",
    "pos": "RED",
    "explanation": "(insurance + action indicator)",
    "isCharacter": false,
    "composition": [
      25576,
      ";",
      8993
    ]
  },
  {
    "id": "28048",
    "description": "listener",
    "pos": "BLUE",
    "explanation": "(person + hear)",
    "isCharacter": false,
    "composition": [
      16161,
      "/",
      13894
    ]
  },
  {
    "id": "28049",
    "description": "long_lasting,durable",
    "pos": "GREEN",
    "explanation": "(time + long)",
    "isCharacter": false,
    "composition": [
      17732,
      ";",
      8998,
      "/",
      15193
    ]
  },
  {
    "id": "28050",
    "description": "manner,manners",
    "pos": "YELLOW",
    "explanation": "(activity + social)  should be (aktivity + citizen)",
    "isCharacter": false,
    "composition": [
      12335,
      "/",
      13349
    ]
  },
  {
    "id": "28051",
    "description": "manner,way,mode,style_(habit)",
    "pos": "YELLOW",
    "explanation": "(activity + most)",
    "isCharacter": false,
    "composition": [
      12335,
      "/",
      24944
    ]
  },
  {
    "id": "28052",
    "description": "modifier_(diminutive_form)",
    "pos": "GREY",
    "explanation": "(grammatical modification: (small) [half size, crossing baseline] - Character (modified))",
    "isCharacter": true
  },
  {
    "id": "28053",
    "description": "modifier_(feminine_form)",
    "pos": "GREY",
    "explanation": "Grammatical modification: (feminine) [half size, crossing baseline]  add  - Character (modified)",
    "isCharacter": true
  },
  {
    "id": "28055",
    "description": "modifier_(masculine_form)",
    "pos": "GREY",
    "explanation": "Grammatical modification: (masculine) [half size, crossing baseline] - Character (modified)",
    "isCharacter": true
  },
  {
    "id": "28056",
    "description": "modifier_(neuter_form)",
    "pos": "GREY",
    "explanation": "Grammatical modification (neuter) [bottom part of symbol for person, half size, crossing baseline]  add  -Character (modified)?",
    "isCharacter": true
  },
  {
    "id": "28057",
    "description": "modifier_(object_form,direct_object,accusative)",
    "pos": "GREY",
    "explanation": "Grammatical modification (to) [half size, crossing baseline] - Character (modified)",
    "isCharacter": true
  },
  {
    "id": "28058",
    "description": "music_festival",
    "pos": "YELLOW",
    "explanation": "(festival + music[contraction])",
    "isCharacter": false,
    "composition": [
      14114,
      "/",
      14164,
      "/",
      14947,
      "/",
      14947,
      "/",
      15682
    ]
  },
  {
    "id": "28059",
    "description": "nationality_(official)",
    "pos": "YELLOW",
    "explanation": "(nation + paper) should be  state_paper)",
    "isCharacter": false,
    "composition": [
      13423,
      "/",
      15962
    ]
  },
  {
    "id": "28060",
    "description": "negative_outcome",
    "pos": "YELLOW",
    "explanation": "(consequence + minus)",
    "isCharacter": false,
    "composition": [
      13910,
      "/",
      12335,
      "/",
      15474
    ]
  },
  {
    "id": "28061",
    "description": "neck_support",
    "pos": "YELLOW",
    "explanation": "(aid + head_and_neck)  should be neck (head)",
    "isCharacter": false,
    "composition": [
      14704,
      ";",
      9009,
      "/",
      15699
    ]
  },
  {
    "id": "28062",
    "description": "paint_box",
    "pos": "YELLOW",
    "explanation": "(case + paint [contraction])",
    "isCharacter": false,
    "composition": [
      25532,
      "/",
      13377,
      "/",
      18209
    ]
  },
  {
    "id": "28063",
    "description": "penalty_(sport)",
    "pos": "YELLOW",
    "explanation": "(punishment + sport)",
    "isCharacter": false,
    "composition": [
      13910,
      "/",
      12335,
      "/",
      15474,
      "/",
      14947,
      "/",
      20518
    ]
  },
  {
    "id": "28064",
    "description": "positive_outcome",
    "pos": "YELLOW",
    "explanation": "(consequence + plus)",
    "isCharacter": false,
    "composition": [
      13910,
      "/",
      12335,
      "/",
      12374
    ]
  },
  {
    "id": "28065",
    "description": "pride_parade,festival_of_equality",
    "pos": "YELLOW",
    "explanation": "(event + feeling + equality)",
    "isCharacter": false,
    "composition": [
      14114,
      "/",
      14164,
      "/",
      16713
    ]
  },
  {
    "id": "28066",
    "description": "punishment",
    "pos": "YELLOW",
    "explanation": "(consequence + negative)",
    "isCharacter": false,
    "composition": [
      13910,
      "/",
      12335,
      "/",
      15474,
      "/",
      14947
    ]
  },
  {
    "id": "28067",
    "description": "realistic",
    "pos": "GREEN",
    "explanation": "(reality + descriptive indicator)",
    "isCharacter": false,
    "composition": [
      25779,
      ";",
      8998
    ]
  },
  {
    "id": "28068",
    "description": "realize-(to)",
    "pos": "RED",
    "explanation": "(cause + reality)  add   + action indicator)",
    "isCharacter": false,
    "composition": [
      13134,
      ";",
      8993,
      "/",
      25779
    ]
  },
  {
    "id": "28069",
    "description": "red_card,penalty_card_(sports)",
    "pos": "YELLOW",
    "explanation": "(card + red) [penalty in sporting game]",
    "isCharacter": false,
    "composition": [
      15962,
      "/",
      13377,
      "/",
      15666
    ]
  },
  {
    "id": "28070",
    "description": "reference,references,source,sources",
    "pos": "YELLOW",
    "explanation": "(generalization + idea)",
    "isCharacter": false,
    "composition": [
      14430,
      "/",
      14926
    ]
  },
  {
    "id": "28071",
    "description": "reference_list",
    "pos": "YELLOW",
    "explanation": "(paper + references)",
    "isCharacter": false,
    "composition": [
      15962,
      "/",
      14430,
      "/",
      14926
    ]
  },
  {
    "id": "28072",
    "description": "reward",
    "pos": "YELLOW",
    "explanation": "(consequence  + positive)",
    "isCharacter": false,
    "composition": [
      13910,
      "/",
      12335,
      "/",
      12374,
      "/",
      14947
    ]
  },
  {
    "id": "28073",
    "description": "roller_coaster",
    "pos": "YELLOW",
    "explanation": "(vechicle + up + turn + fast) vehicle",
    "isCharacter": false,
    "composition": [
      18010,
      "/",
      17983,
      "/",
      25627,
      "/",
      14390,
      "/",
      14947
    ]
  },
  {
    "id": "28074",
    "description": "rugby_field,football_field_(N.A.)",
    "pos": "YELLOW",
    "explanation": "(place + rugby [contraction])",
    "isCharacter": false,
    "composition": [
      16193,
      "/",
      21807,
      "/",
      15189
    ]
  },
  {
    "id": "28075",
    "description": "seam_(fabric)",
    "pos": "YELLOW",
    "explanation": "(attachment + fabric)",
    "isCharacter": false,
    "composition": [
      23409,
      "/",
      13365
    ]
  },
  {
    "id": "28076",
    "description": "spectator",
    "pos": "BLUE",
    "explanation": "(person + see)",
    "isCharacter": false,
    "composition": [
      16161,
      "/",
      14133
    ]
  },
  {
    "id": "28077",
    "description": "speech_generating_device,voice_output_device,speech_output_device,talker",
    "pos": "YELLOW",
    "explanation": "(digital device + speak)",
    "isCharacter": false,
    "composition": [
      24638,
      "/",
      15666
    ]
  },
  {
    "id": "28078",
    "description": "sustain-(to)",
    "pos": "RED",
    "explanation": "(protection + action indicator + future)",
    "isCharacter": false,
    "composition": [
      16420,
      ";",
      8993,
      "/",
      14417
    ]
  },
  {
    "id": "28079",
    "description": "suture,join,seam_(medical)",
    "pos": "YELLOW",
    "explanation": "(attachment + medical)",
    "isCharacter": false,
    "composition": [
      23409,
      "/",
      24920
    ]
  },
  {
    "id": "28080",
    "description": "sweater,jumper,pullover",
    "pos": "YELLOW",
    "explanation": "(shirt + over)",
    "isCharacter": false,
    "composition": [
      13366,
      "/",
      13161,
      "/",
      15948
    ]
  },
  {
    "id": "28081",
    "description": "uniform",
    "pos": "YELLOW",
    "explanation": "(clothes + group)",
    "isCharacter": false,
    "composition": [
      13366,
      "/",
      14647,
      "/",
      16161
    ]
  },
  {
    "id": "28082",
    "description": "water_park",
    "pos": "YELLOW",
    "explanation": "(amusement park + pool)",
    "isCharacter": false,
    "composition": [
      15969,
      "/",
      14164,
      "/",
      14947,
      "/",
      14947,
      "/",
      16219
    ]
  },
  {
    "id": "28083",
    "description": "whoops,oops",
    "pos": "GREY",
    "explanation": "(emotion + talking + hand+ exclamation mark: something you say to play down a small accident) should add {superimposed] snd \"intensity\" Instead of “exclamationmarc”",
    "isCharacter": false,
    "composition": [
      24961,
      "/",
      14667,
      "/",
      14947
    ]
  },
  {
    "id": "28084",
    "description": "yellow_card,penalty_card_(sports)",
    "pos": "YELLOW",
    "explanation": "(card + yellow) [warning for bad behavior in sporting game]",
    "isCharacter": false,
    "composition": [
      15962,
      "/",
      13377,
      "/",
      17462
    ]
  },
  {
    "id": "29001",
    "description": "address_book,contact_list",
    "pos": "YELLOW",
    "explanation": "(book + address [contraction])",
    "isCharacter": false,
    "composition": [
      12875,
      "/",
      15691,
      "/",
      16193
    ]
  },
  {
    "id": "29002",
    "description": "afterwards",
    "pos": "GREEN",
    "explanation": "(time + after)",
    "isCharacter": false,
    "composition": [
      17732,
      "/",
      12348
    ]
  },
  {
    "id": "29003",
    "description": "alternate,expand,stretch-(to)",
    "pos": "RED",
    "explanation": "Stretching,expention + Indicator_[action]",
    "isCharacter": false,
    "composition": [
      29004,
      ";",
      8993
    ]
  },
  {
    "id": "29004",
    "description": "alternation,expansion,stretching,elastic",
    "pos": "YELLOW",
    "explanation": "new character",
    "isCharacter": true
  },
  {
    "id": "29005",
    "description": "another_time",
    "pos": "WHITE",
    "explanation": "time + 2_(digital)",
    "isCharacter": false,
    "composition": [
      17732,
      "/",
      8498
    ]
  },
  {
    "id": "29006",
    "description": "applicant",
    "pos": "BLUE",
    "explanation": "person + question + application",
    "isCharacter": false,
    "composition": [
      16161,
      "/",
      16445,
      "/",
      13649
    ]
  },
  {
    "id": "29007",
    "description": "application",
    "pos": "YELLOW",
    "explanation": "question+decision",
    "isCharacter": false,
    "composition": [
      16445,
      "/",
      13649
    ]
  },
  {
    "id": "29008",
    "description": "apply-(to)",
    "pos": "RED",
    "explanation": "activity(12335)+application+indicator_[action]",
    "isCharacter": false,
    "composition": [
      12335,
      ";",
      8993,
      "/",
      16445,
      "/",
      13649
    ]
  },
  {
    "id": "29009",
    "description": "archive",
    "pos": "YELLOW",
    "explanation": "(collection + important)",
    "isCharacter": false,
    "composition": [
      14647,
      "/",
      23409,
      "/",
      24913
    ]
  },
  {
    "id": "29010",
    "description": "baby_shop,baby_store",
    "pos": "YELLOW",
    "explanation": "(shop + thing + baby)",
    "isCharacter": false,
    "composition": [
      23223,
      "/",
      17717,
      "/",
      12603
    ]
  },
  {
    "id": "29011",
    "description": "bag_shop,bag_store,luggage_shop,luggage_store",
    "pos": "YELLOW",
    "explanation": "(shop + bag)",
    "isCharacter": false,
    "composition": [
      23223,
      "/",
      12618
    ]
  },
  {
    "id": "29012",
    "description": "beforehand",
    "pos": "GREEN",
    "explanation": "(time + before)",
    "isCharacter": false,
    "composition": [
      17732,
      "/",
      12656
    ]
  },
  {
    "id": "29013",
    "description": "bicycle_shop,bicycle_store",
    "pos": "YELLOW",
    "explanation": "(shop + bicycle)",
    "isCharacter": false,
    "composition": [
      23223,
      "/",
      8498,
      "/",
      18232
    ]
  },
  {
    "id": "29014",
    "description": "binder,ring_binder",
    "pos": "YELLOW",
    "explanation": "(folder + ring)",
    "isCharacter": false,
    "composition": [
      23511,
      "/",
      16675
    ]
  },
  {
    "id": "29015",
    "description": "bungee",
    "pos": "YELLOW",
    "explanation": "fiber + stretching + hook",
    "isCharacter": false,
    "composition": [
      25878,
      "/",
      29004,
      "/",
      14891
    ]
  },
  {
    "id": "29016",
    "description": "car_dealer,car_dealership",
    "pos": "YELLOW",
    "explanation": "(shop + car)",
    "isCharacter": false,
    "composition": [
      23223,
      "/",
      13121
    ]
  },
  {
    "id": "29017",
    "description": "computer_shop,computer_store,electronics_shop,electronics_store",
    "pos": "YELLOW",
    "explanation": "(shop + digital_device)",
    "isCharacter": false,
    "composition": [
      23223,
      "/",
      24638
    ]
  },
  {
    "id": "29018",
    "description": "concave",
    "pos": "GREEN",
    "explanation": "(concavity + description indicator)",
    "isCharacter": false,
    "composition": [
      29019,
      ";",
      8998
    ]
  },
  {
    "id": "29019",
    "description": "concavity",
    "pos": "YELLOW",
    "explanation": "(concavity: lines curving inward) Character",
    "isCharacter": true
  },
  {
    "id": "29020",
    "description": "cone_(shape)",
    "pos": "YELLOW",
    "explanation": "(shape + cone)",
    "isCharacter": false,
    "composition": [
      29081,
      "/",
      13400
    ]
  },
  {
    "id": "29021",
    "description": "convex",
    "pos": "GREEN",
    "explanation": "(convexity + description indicator)",
    "isCharacter": false,
    "composition": [
      29022,
      ";",
      8998
    ]
  },
  {
    "id": "29022",
    "description": "convexity",
    "pos": "YELLOW",
    "explanation": "(convexity: lines curving or bulging outward) Character",
    "isCharacter": true
  },
  {
    "id": "29023",
    "description": "Corona_virus",
    "pos": "YELLOW",
    "explanation": "(virus + crown)",
    "isCharacter": false,
    "composition": [
      24443,
      ";",
      9009,
      "/",
      24917,
      "/",
      24934,
      "/",
      22618
    ]
  },
  {
    "id": "29024",
    "description": "Covid_19",
    "pos": "YELLOW",
    "explanation": "(corona_virus + 19)",
    "isCharacter": false,
    "composition": [
      24443,
      ";",
      9009,
      "/",
      24917,
      "/",
      24934,
      "/",
      22618,
      "/",
      8497,
      "/",
      "RK:-1",
      "/",
      8505
    ]
  },
  {
    "id": "29025",
    "description": "cube_(shape)",
    "pos": "YELLOW",
    "explanation": "(shape + cube)",
    "isCharacter": false,
    "composition": [
      29081,
      "/",
      12886
    ]
  },
  {
    "id": "29026",
    "description": "cylinder_(shape)",
    "pos": "YELLOW",
    "explanation": "(shape + cylinder)",
    "isCharacter": false,
    "composition": [
      29081,
      "/",
      13115
    ]
  },
  {
    "id": "29027",
    "description": "date(1)",
    "pos": "YELLOW",
    "explanation": "(year + month + day)",
    "isCharacter": false,
    "composition": [
      18289,
      "/",
      15649,
      "/",
      13639
    ]
  },
  {
    "id": "29028",
    "description": "date(2)",
    "pos": "YELLOW",
    "explanation": "(day + month + year)",
    "isCharacter": false,
    "composition": [
      13639,
      "/",
      15649,
      "/",
      18289
    ]
  },
  {
    "id": "29029",
    "description": "date(3)",
    "pos": "YELLOW",
    "explanation": "(month + day + year)",
    "isCharacter": false,
    "composition": [
      15649,
      "/",
      13639,
      "/",
      18289
    ]
  },
  {
    "id": "29030",
    "description": "decagon",
    "pos": "YELLOW",
    "explanation": "(shape + corner [contraction] + 10)",
    "isCharacter": false,
    "composition": [
      29081,
      "/",
      25620,
      "/",
      8497,
      "/",
      "RK:-1",
      "/",
      8496
    ]
  },
  {
    "id": "29031",
    "description": "digital_board,interactive_board,smart_board",
    "pos": "YELLOW",
    "explanation": "(enclosed_space + pen + digital)",
    "isCharacter": false,
    "composition": [
      13934,
      "/",
      15991,
      "/",
      23476
    ]
  },
  {
    "id": "29032",
    "description": "direct,directly",
    "pos": "GREEN",
    "explanation": "(toward + exclamation mark)",
    "isCharacter": false,
    "composition": [
      17739,
      ";",
      8998,
      "/",
      14947
    ]
  },
  {
    "id": "29033",
    "description": "elastic_cord",
    "pos": "YELLOW",
    "explanation": "(string + stretching)",
    "isCharacter": false,
    "composition": [
      14647,
      "/",
      25878,
      "/",
      29004
    ]
  },
  {
    "id": "29034",
    "description": "electrical_shop,electrical_store",
    "pos": "YELLOW",
    "explanation": "(shop + thing + electricity)",
    "isCharacter": false,
    "composition": [
      23223,
      "/",
      17717,
      "/",
      13918
    ]
  },
  {
    "id": "29035",
    "description": "eraser",
    "pos": "YELLOW",
    "explanation": "(destroy + thing indicator) Character",
    "isCharacter": "false",
    "composition": [
      24883,
      ";",
      9009
    ]
  },
  {
    "id": "29036",
    "description": "everywhere",
    "pos": "YELLOW",
    "explanation": "(all + place)",
    "isCharacter": false,
    "composition": [
      12360,
      "/",
      16193
    ]
  },
  {
    "id": "29037",
    "description": "fabric_shop,fabric_store",
    "pos": "YELLOW",
    "explanation": "(cloth + stretching)",
    "isCharacter": false,
    "composition": [
      23223,
      "/",
      13365
    ]
  },
  {
    "id": "29038",
    "description": "filing_cabinet",
    "pos": "YELLOW",
    "explanation": "(chest_of_drawers + folder)",
    "isCharacter": false,
    "composition": [
      13162,
      "/",
      23511
    ]
  },
  {
    "id": "29039",
    "description": "global",
    "pos": "GREEN",
    "explanation": "(earth + descriptive indicator)",
    "isCharacter": false,
    "composition": [
      13900,
      ";",
      8998
    ]
  },
  {
    "id": "29040",
    "description": "glue_stick,glue_tube",
    "pos": "YELLOW",
    "explanation": "(glue + tube[pictorial])",
    "isCharacter": false,
    "composition": [
      13158,
      "/",
      23409,
      "/",
      23927
    ]
  },
  {
    "id": "29041",
    "description": "hardware_store_(goods)",
    "pos": "YELLOW",
    "explanation": "(shop + tool)",
    "isCharacter": false,
    "composition": [
      23223,
      "/",
      17755
    ]
  },
  {
    "id": "29042",
    "description": "heart_(shape)",
    "pos": "YELLOW",
    "explanation": "(shape + heart)",
    "isCharacter": false,
    "composition": [
      29081,
      "/",
      14164
    ]
  },
  {
    "id": "29043",
    "description": "heptagon",
    "pos": "YELLOW",
    "explanation": "(shape + corner[contraction] + 7)",
    "isCharacter": false,
    "composition": [
      29081,
      "/",
      25620,
      "/",
      8503
    ]
  },
  {
    "id": "29044",
    "description": "hexagon",
    "pos": "YELLOW",
    "explanation": "(shape + corner[contraction] + 6)",
    "isCharacter": false,
    "composition": [
      29081,
      "/",
      25620,
      "/",
      8502
    ]
  },
  {
    "id": "29045",
    "description": "highlighter,marker",
    "pos": "YELLOW",
    "explanation": "(pen + colour + interest)",
    "isCharacter": false,
    "composition": [
      15991,
      "/",
      13377,
      "/",
      24916
    ]
  },
  {
    "id": "29046",
    "description": "isolation",
    "pos": "YELLOW",
    "explanation": "(being_(state_of) + 1) [being alone]",
    "isCharacter": false,
    "composition": [
      24443,
      "/",
      8497
    ]
  },
  {
    "id": "29047",
    "description": "jewelry_shop,jewellery_store,jewellers",
    "pos": "YELLOW",
    "explanation": "(shop + jewelry)",
    "isCharacter": false,
    "composition": [
      23223,
      "/",
      14430,
      "/",
      17267,
      "/",
      17252
    ]
  },
  {
    "id": "29048",
    "description": "job_application,work_application",
    "pos": "YELLOW",
    "explanation": "(application + work)",
    "isCharacter": false,
    "composition": [
      16445,
      "/",
      13649,
      "/",
      18273
    ]
  },
  {
    "id": "29049",
    "description": "job_qualification",
    "pos": "YELLOW",
    "explanation": "(card + profession)",
    "isCharacter": false,
    "composition": [
      23431,
      "/",
      18273,
      "/",
      13175
    ]
  },
  {
    "id": "29050",
    "description": "local",
    "pos": "GREEN",
    "explanation": "(place + descriptive indicator)",
    "isCharacter": false,
    "composition": [
      16193,
      ";",
      8998
    ]
  },
  {
    "id": "29051",
    "description": "long_time_ago",
    "pos": "WHITE",
    "explanation": "(limited_time + long + ago)",
    "isCharacter": false,
    "composition": [
      15212,
      "/",
      15193,
      "/",
      12352
    ]
  },
  {
    "id": "29052",
    "description": "lycra,spandex,stretchy_fabric",
    "pos": "YELLOW",
    "explanation": "(cloth + stretching)",
    "isCharacter": false,
    "composition": [
      13365,
      "/",
      29004
    ]
  },
  {
    "id": "29053",
    "description": "maximum",
    "pos": "YELLOW",
    "explanation": "(most: noun form)",
    "isCharacter": false
  },
  {
    "id": "29054",
    "description": "minimum",
    "pos": "YELLOW",
    "explanation": "(opposite_meaning + maximum)",
    "isCharacter": false,
    "composition": [
      15927,
      "/",
      24944
    ]
  },
  {
    "id": "29055",
    "description": "music_shop,music_store",
    "pos": "YELLOW",
    "explanation": "(shop + record)",
    "isCharacter": false,
    "composition": [
      23223,
      "/",
      23904
    ]
  },
  {
    "id": "29056",
    "description": "nail_gun",
    "pos": "YELLOW",
    "explanation": "(tool + nail)",
    "isCharacter": false,
    "composition": [
      17755,
      "/",
      15689
    ]
  },
  {
    "id": "29057",
    "description": "notice_board,bulletin_board",
    "pos": "YELLOW",
    "explanation": "(enclosed_space + information)",
    "isCharacter": false,
    "composition": [
      13934,
      "/",
      23542
    ]
  },
  {
    "id": "29058",
    "description": "octagon",
    "pos": "YELLOW",
    "explanation": "(shape + corner[contraction] + 8)",
    "isCharacter": false,
    "composition": [
      29081,
      "/",
      25620,
      "/",
      8504
    ]
  },
  {
    "id": "29059",
    "description": "parallelogram",
    "pos": "YELLOW",
    "explanation": "(quadrilateral+ parallel + 2)",
    "isCharacter": false,
    "composition": [
      29081,
      "/",
      25620,
      "/",
      8500,
      "/",
      15964,
      "/",
      8498
    ]
  },
  {
    "id": "29060",
    "description": "pastry_shop,patisserie",
    "pos": "YELLOW",
    "explanation": "(shop + cake)",
    "isCharacter": false,
    "composition": [
      23223,
      "/",
      12895,
      "/",
      17506,
      "/",
      17983
    ]
  },
  {
    "id": "29061",
    "description": "pentagon",
    "pos": "YELLOW",
    "explanation": "(shape + corner[contraction] + 5)",
    "isCharacter": false,
    "composition": [
      29081,
      "/",
      25620,
      "/",
      8501
    ]
  },
  {
    "id": "29062",
    "description": "perfumery",
    "pos": "YELLOW",
    "explanation": "(shop + perfume)",
    "isCharacter": false,
    "composition": [
      23223,
      "/",
      17017,
      "/",
      14164,
      "/",
      17983
    ]
  },
  {
    "id": "29063",
    "description": "pet_shop,pet_store",
    "pos": "YELLOW",
    "explanation": "(shop + animal)",
    "isCharacter": false,
    "composition": [
      23223,
      "/",
      12378
    ]
  },
  {
    "id": "29064",
    "description": "polygon_(category)",
    "pos": "YELLOW",
    "explanation": "(shape + gereralization+ corner [contraction])",
    "isCharacter": false,
    "composition": [
      29081,
      "/",
      14430,
      "/",
      25620
    ]
  },
  {
    "id": "29065",
    "description": "post-it_note,reminder_note",
    "pos": "YELLOW",
    "explanation": "(paper + memory + attached)[a paper for your memory which can be attached somewhere]",
    "isCharacter": false,
    "composition": [
      15962,
      "/",
      23589,
      "/",
      23409
    ]
  },
  {
    "id": "29066",
    "description": "project",
    "pos": "YELLOW",
    "explanation": "(plan + activity + purpose)",
    "isCharacter": false,
    "composition": [
      16194,
      "/",
      12335,
      "/",
      16437
    ]
  },
  {
    "id": "29067",
    "description": "pyramid_(shape)",
    "pos": "YELLOW",
    "explanation": "(shape + pyramid)",
    "isCharacter": false,
    "composition": [
      29081,
      "/",
      16443
    ]
  },
  {
    "id": "29068",
    "description": "quadrilateral",
    "pos": "YELLOW",
    "explanation": "(shape + corner[contraction] + 4)",
    "isCharacter": false,
    "composition": [
      29081,
      "/",
      25620,
      "/",
      8500
    ]
  },
  {
    "id": "29069",
    "description": "quarantine",
    "pos": "YELLOW",
    "explanation": "(isolation + medicine)",
    "isCharacter": false,
    "composition": [
      24443,
      "/",
      8497,
      "/",
      24920
    ]
  },
  {
    "id": "29070",
    "description": "record_shop,record_store,music_shop_music_store",
    "pos": "YELLOW",
    "explanation": "(shop + record)",
    "isCharacter": false,
    "composition": [
      23223,
      "/",
      25601,
      "/",
      13894
    ]
  },
  {
    "id": "29071",
    "description": "report",
    "pos": "YELLOW",
    "explanation": "(full + information)",
    "isCharacter": false,
    "composition": [
      24897,
      "/",
      23542
    ]
  },
  {
    "id": "29072",
    "description": "re-usable,recycable",
    "pos": "GREEN",
    "explanation": "use + again + descriptive indicator before fact)",
    "isCharacter": false,
    "composition": [
      24847,
      ";",
      8997,
      "/",
      12350
    ]
  },
  {
    "id": "29073",
    "description": "re-used,recycled",
    "pos": "GREEN",
    "explanation": "(use + again + descriptive indicator after fact)",
    "isCharacter": false,
    "composition": [
      24847,
      ";",
      8996,
      "/",
      12350
    ]
  },
  {
    "id": "29074",
    "description": "rubber_band",
    "pos": "YELLOW",
    "explanation": "(ring + stretching)",
    "isCharacter": false,
    "composition": [
      16675,
      "/",
      29004
    ]
  },
  {
    "id": "29075",
    "description": "scotch_tape,adhesive_tape",
    "pos": "YELLOW",
    "explanation": "(linear_ thing + glue)",
    "isCharacter": false,
    "composition": [
      15214,
      ";",
      9009,
      "/",
      13158,
      "/",
      23409
    ]
  },
  {
    "id": "29076",
    "description": "second_hand",
    "pos": "GREEN",
    "explanation": "(second_hand + description indicator)",
    "isCharacter": false,
    "composition": [
      14457,
      ";",
      8998,
      "/",
      12350
    ]
  },
  {
    "id": "29077",
    "description": "second_hand_(goods)",
    "pos": "YELLOW",
    "explanation": "(goods + again) [things which can be used or sold again]",
    "isCharacter": false,
    "composition": [
      14457,
      "/",
      12350
    ]
  },
  {
    "id": "29078",
    "description": "second_hand_clothes_shop,second_hand_clothing_shop",
    "pos": "YELLOW",
    "explanation": "(shop + clothes + second hand [contraction])",
    "isCharacter": false,
    "composition": [
      23223,
      "/",
      13366,
      "/",
      12350
    ]
  },
  {
    "id": "29079",
    "description": "second_hand_shop,charity_shop,vintage_shop",
    "pos": "YELLOW",
    "explanation": "(shop + second hand)",
    "isCharacter": false,
    "composition": [
      23223,
      "/",
      14457,
      "/",
      12350
    ]
  },
  {
    "id": "29080",
    "description": "semicircle,half_circle_(shape)",
    "pos": "YELLOW",
    "explanation": "(shape + half_circle)",
    "isCharacter": false,
    "composition": [
      29081,
      "/",
      13627
    ]
  },
  {
    "id": "29081",
    "description": "shape_(in_combinations)",
    "pos": "YELLOW",
    "explanation": "(eye + thing) -Character (superimposed)",
    "isCharacter": true
  },
  {
    "id": "29082",
    "description": "shoe_shop,shoe_store",
    "pos": "YELLOW",
    "explanation": "(shop + shoe)",
    "isCharacter": false,
    "composition": [
      23223,
      "/",
      16420,
      "/",
      14379
    ]
  },
  {
    "id": "29083",
    "description": "shredder_(paper),paper_shredder",
    "pos": "YELLOW",
    "explanation": "(machine + destroy + paper)",
    "isCharacter": false,
    "composition": [
      15406,
      "/",
      24883,
      "/",
      15962
    ]
  },
  {
    "id": "29084",
    "description": "social_distance",
    "pos": "YELLOW",
    "explanation": "(at_a_distance + person)",
    "isCharacter": false,
    "composition": [
      25522,
      "/",
      16161
    ]
  },
  {
    "id": "29085",
    "description": "social_distance-(to)",
    "pos": "RED",
    "explanation": "(at_a_distance + person + action indicator)",
    "isCharacter": false,
    "composition": [
      25522,
      ";",
      8993,
      "/",
      16161
    ]
  },
  {
    "id": "29086",
    "description": "spiral_binder",
    "pos": "YELLOW",
    "explanation": "(folder + spiral)",
    "isCharacter": false,
    "composition": [
      23511,
      "/",
      25616
    ]
  },
  {
    "id": "29087",
    "description": "staple_gun",
    "pos": "YELLOW",
    "explanation": "(tool + pin + material)",
    "isCharacter": false,
    "composition": [
      17755,
      "/",
      16181,
      "/",
      15431
    ]
  },
  {
    "id": "29088",
    "description": "staple_remover",
    "pos": "YELLOW",
    "explanation": "(tool + remove + pin)",
    "isCharacter": false,
    "composition": [
      17755,
      "/",
      17449,
      "/",
      16181
    ]
  },
  {
    "id": "29089",
    "description": "stapler",
    "pos": "YELLOW",
    "explanation": "(tool + pin + paper)",
    "isCharacter": false,
    "composition": [
      17755,
      "/",
      16181,
      "/",
      15962
    ]
  },
  {
    "id": "29090",
    "description": "star_(shape)",
    "pos": "YELLOW",
    "explanation": "(shape + star)",
    "isCharacter": false,
    "composition": [
      29081,
      "/",
      17252
    ]
  },
  {
    "id": "29091",
    "description": "stationery_shop_,stationery_store",
    "pos": "YELLOW",
    "explanation": "(shop + generalization + pen) [pen represents all writing material in the stationery shop]",
    "isCharacter": false,
    "composition": [
      23223,
      "/",
      14430,
      "/",
      15991
    ]
  },
  {
    "id": "29092",
    "description": "tag,sticker,label",
    "pos": "YELLOW",
    "explanation": "(card + little + information)",
    "isCharacter": false,
    "composition": [
      23431,
      "/",
      24917,
      "/",
      23542
    ]
  },
  {
    "id": "29093",
    "description": "third_(ordinal)",
    "pos": "GREEN",
    "explanation": "(3 + decimal point + description indicator) [the dot indicates an ordinal numeral]",
    "isCharacter": false,
    "composition": [
      8499,
      ";",
      8998,
      "/",
      8486
    ]
  },
  {
    "id": "29094",
    "description": "this_afternoon",
    "pos": "YELLOW",
    "explanation": "(afternoon + now)",
    "isCharacter": false,
    "composition": [
      13639,
      "/",
      12348,
      "/",
      8497,
      "/",
      "RK:-1",
      "/",
      8498,
      "/",
      15736
    ]
  },
  {
    "id": "29095",
    "description": "this_evening",
    "pos": "YELLOW",
    "explanation": "(evening + now)",
    "isCharacter": false,
    "composition": [
      13950,
      "/",
      15736
    ]
  },
  {
    "id": "29096",
    "description": "this_morning",
    "pos": "YELLOW",
    "explanation": "(morning + now)",
    "isCharacter": false,
    "composition": [
      15656,
      "/",
      15736
    ]
  },
  {
    "id": "29097",
    "description": "tiny,mini,minscule,teeny-tiny",
    "pos": "GREEN",
    "explanation": "less_than + little + indicator_[descriptive]",
    "isCharacter": false,
    "composition": [
      24917,
      ";",
      8998,
      "/",
      14947,
      "/",
      14947,
      "/",
      14947
    ]
  },
  {
    "id": "29098",
    "description": "trapezoid,trapezium",
    "pos": "YELLOW",
    "explanation": "(shape + corner[contraction] + 4 + parallel + 1",
    "isCharacter": false,
    "composition": [
      29081,
      "/",
      25620,
      "/",
      8500,
      "/",
      15964,
      "/",
      8497
    ]
  },
  {
    "id": "29099",
    "description": "tube_(shape)",
    "pos": "YELLOW",
    "explanation": "(shape + tube)",
    "isCharacter": false,
    "composition": [
      29081,
      "/",
      23926
    ]
  },
  {
    "id": "29100",
    "description": "used_car_dealer",
    "pos": "YELLOW",
    "explanation": "(shop + car + second hand [contraction])",
    "isCharacter": false,
    "composition": [
      23223,
      "/",
      13121,
      "/",
      12350
    ]
  },
  {
    "id": "29101",
    "description": "vaccinate",
    "pos": "RED",
    "explanation": "(vaccination + action indicator)",
    "isCharacter": false,
    "composition": [
      14941,
      ";",
      8993,
      "/",
      18209,
      "/",
      16420
    ]
  },
  {
    "id": "29102",
    "description": "vaccinated",
    "pos": "GREEN",
    "explanation": "(vaccination + description indicator after fact)",
    "isCharacter": false,
    "composition": [
      14941,
      ";",
      8996,
      "/",
      18209,
      "/",
      16420
    ]
  },
  {
    "id": "29103",
    "description": "vaccination",
    "pos": "YELLOW",
    "explanation": "(injection + liquid + protection)",
    "isCharacter": false,
    "composition": [
      14941,
      "/",
      18209,
      "/",
      16420
    ]
  },
  {
    "id": "29104",
    "description": "vaccine",
    "pos": "YELLOW",
    "explanation": "(liquid + medicine + protection)",
    "isCharacter": false,
    "composition": [
      18209,
      "/",
      24920,
      "/",
      16420
    ]
  },
  {
    "id": "29105",
    "description": "whine,whimper-(to)",
    "pos": "RED",
    "explanation": "(talk + high pitch)",
    "isCharacter": false,
    "composition": [
      15666,
      ";",
      8993,
      "/",
      23952
    ]
  },
  {
    "id": "29106",
    "description": "whiteboard",
    "pos": "YELLOW",
    "explanation": "(enclosed_space + pen + white)",
    "isCharacter": false,
    "composition": [
      13934,
      "/",
      15991,
      "/",
      13377,
      "/",
      17192
    ]
  },
  {
    "id": "29107",
    "description": "wood_shredder,garden_shredder",
    "pos": "YELLOW",
    "explanation": "(machine + destroy + wood)",
    "isCharacter": false,
    "composition": [
      15406,
      "/",
      24883,
      "/",
      17775
    ]
  },
  {
    "id": "29108",
    "description": "work_interview",
    "pos": "YELLOW",
    "explanation": "(interview + work)",
    "isCharacter": false,
    "composition": [
      16445,
      "/",
      16161,
      "/",
      18273
    ]
  },
  {
    "id": "29109",
    "description": "work_schedule",
    "pos": "YELLOW",
    "explanation": "(paper + time + work)",
    "isCharacter": false,
    "composition": [
      15962,
      "/",
      17732,
      "/",
      18273
    ]
  },
  {
    "id": "29110",
    "description": "written_report",
    "pos": "YELLOW",
    "explanation": "(report + pen)",
    "isCharacter": false,
    "composition": [
      24897,
      "/",
      23542,
      "/",
      15991
    ]
  },
  {
    "id": "29111",
    "description": "yarn_shop,yarn_store,wool_shop,wool_store",
    "pos": "YELLOW",
    "explanation": "(shop + yarn [contraction])",
    "isCharacter": false,
    "composition": [
      23223,
      "/",
      25878,
      "/",
      13365
    ]
  }
]
